webpackJsonp([114276838955818,60335399758886],{

/***/ 116:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Maxime Beaudoin Front-End Developer from Montr&eacute;al"}}},"layoutContext":{}}

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(221);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(116);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(309);
	var isArguments = __webpack_require__(308);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 308:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global) {/**
	* matter-js 0.14.2 by @liabru 2018-06-11
	* http://brm.io/matter-js/
	* License MIT
	*/
	
	/**
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) Liam Brummitt and contributors.
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 */
	
	(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Matter = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(_dereq_,module,exports){
	/**
	* The `Matter.Body` module contains methods for creating and manipulating body models.
	* A `Matter.Body` is a rigid body that can be simulated by a `Matter.Engine`.
	* Factories for commonly used body configurations (such as rectangles, circles and other polygons) can be found in the module `Matter.Bodies`.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	
	* @class Body
	*/
	
	var Body = {};
	
	module.exports = Body;
	
	var Vertices = _dereq_('../geometry/Vertices');
	var Vector = _dereq_('../geometry/Vector');
	var Sleeping = _dereq_('../core/Sleeping');
	var Render = _dereq_('../render/Render');
	var Common = _dereq_('../core/Common');
	var Bounds = _dereq_('../geometry/Bounds');
	var Axes = _dereq_('../geometry/Axes');
	
	(function() {
	
	    Body._inertiaScale = 4;
	    Body._nextCollidingGroupId = 1;
	    Body._nextNonCollidingGroupId = -1;
	    Body._nextCategory = 0x0001;
	
	    /**
	     * Creates a new rigid body model. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * All properties have default values, and many are pre-calculated automatically based on other properties.
	     * Vertices must be specified in clockwise order.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {} options
	     * @return {body} body
	     */
	    Body.create = function(options) {
	        var defaults = {
	            id: Common.nextId(),
	            type: 'body',
	            label: 'Body',
	            parts: [],
	            plugin: {},
	            angle: 0,
	            vertices: Vertices.fromPath('L 0 0 L 40 0 L 40 40 L 0 40'),
	            position: { x: 0, y: 0 },
	            force: { x: 0, y: 0 },
	            torque: 0,
	            positionImpulse: { x: 0, y: 0 },
	            constraintImpulse: { x: 0, y: 0, angle: 0 },
	            totalContacts: 0,
	            speed: 0,
	            angularSpeed: 0,
	            velocity: { x: 0, y: 0 },
	            angularVelocity: 0,
	            isSensor: false,
	            isStatic: false,
	            isSleeping: false,
	            motion: 0,
	            sleepThreshold: 60,
	            density: 0.001,
	            restitution: 0,
	            friction: 0.1,
	            frictionStatic: 0.5,
	            frictionAir: 0.01,
	            collisionFilter: {
	                category: 0x0001,
	                mask: 0xFFFFFFFF,
	                group: 0
	            },
	            slop: 0.05,
	            timeScale: 1,
	            render: {
	                visible: true,
	                opacity: 1,
	                sprite: {
	                    xScale: 1,
	                    yScale: 1,
	                    xOffset: 0,
	                    yOffset: 0
	                },
	                lineWidth: 0
	            }
	        };
	
	        var body = Common.extend(defaults, options);
	
	        _initProperties(body, options);
	
	        return body;
	    };
	
	    /**
	     * Returns the next unique group index for which bodies will collide.
	     * If `isNonColliding` is `true`, returns the next unique group index for which bodies will _not_ collide.
	     * See `body.collisionFilter` for more information.
	     * @method nextGroup
	     * @param {bool} [isNonColliding=false]
	     * @return {Number} Unique group index
	     */
	    Body.nextGroup = function(isNonColliding) {
	        if (isNonColliding)
	            return Body._nextNonCollidingGroupId--;
	
	        return Body._nextCollidingGroupId++;
	    };
	
	    /**
	     * Returns the next unique category bitfield (starting after the initial default category `0x0001`).
	     * There are 32 available. See `body.collisionFilter` for more information.
	     * @method nextCategory
	     * @return {Number} Unique category bitfield
	     */
	    Body.nextCategory = function() {
	        Body._nextCategory = Body._nextCategory << 1;
	        return Body._nextCategory;
	    };
	
	    /**
	     * Initialises body properties.
	     * @method _initProperties
	     * @private
	     * @param {body} body
	     * @param {} [options]
	     */
	    var _initProperties = function(body, options) {
	        options = options || {};
	
	        // init required properties (order is important)
	        Body.set(body, {
	            bounds: body.bounds || Bounds.create(body.vertices),
	            positionPrev: body.positionPrev || Vector.clone(body.position),
	            anglePrev: body.anglePrev || body.angle,
	            vertices: body.vertices,
	            parts: body.parts || [body],
	            isStatic: body.isStatic,
	            isSleeping: body.isSleeping,
	            parent: body.parent || body
	        });
	
	        Vertices.rotate(body.vertices, body.angle, body.position);
	        Axes.rotate(body.axes, body.angle);
	        Bounds.update(body.bounds, body.vertices, body.velocity);
	
	        // allow options to override the automatically calculated properties
	        Body.set(body, {
	            axes: options.axes || body.axes,
	            area: options.area || body.area,
	            mass: options.mass || body.mass,
	            inertia: options.inertia || body.inertia
	        });
	
	        // render properties
	        var defaultFillStyle = (body.isStatic ? '#2e2b44' : Common.choose(['#006BA6', '#0496FF', '#FFBC42', '#D81159', '#8F2D56'])),
	            defaultStrokeStyle = '#000';
	        body.render.fillStyle = body.render.fillStyle || defaultFillStyle;
	        body.render.strokeStyle = body.render.strokeStyle || defaultStrokeStyle;
	        body.render.sprite.xOffset += -(body.bounds.min.x - body.position.x) / (body.bounds.max.x - body.bounds.min.x);
	        body.render.sprite.yOffset += -(body.bounds.min.y - body.position.y) / (body.bounds.max.y - body.bounds.min.y);
	    };
	
	    /**
	     * Given a property and a value (or map of), sets the property(s) on the body, using the appropriate setter functions if they exist.
	     * Prefer to use the actual setter functions in performance critical situations.
	     * @method set
	     * @param {body} body
	     * @param {} settings A property name (or map of properties and values) to set on the body.
	     * @param {} value The value to set if `settings` is a single property name.
	     */
	    Body.set = function(body, settings, value) {
	        var property;
	
	        if (typeof settings === 'string') {
	            property = settings;
	            settings = {};
	            settings[property] = value;
	        }
	
	        for (property in settings) {
	            value = settings[property];
	
	            if (!settings.hasOwnProperty(property))
	                continue;
	
	            switch (property) {
	
	            case 'isStatic':
	                Body.setStatic(body, value);
	                break;
	            case 'isSleeping':
	                Sleeping.set(body, value);
	                break;
	            case 'mass':
	                Body.setMass(body, value);
	                break;
	            case 'density':
	                Body.setDensity(body, value);
	                break;
	            case 'inertia':
	                Body.setInertia(body, value);
	                break;
	            case 'vertices':
	                Body.setVertices(body, value);
	                break;
	            case 'position':
	                Body.setPosition(body, value);
	                break;
	            case 'angle':
	                Body.setAngle(body, value);
	                break;
	            case 'velocity':
	                Body.setVelocity(body, value);
	                break;
	            case 'angularVelocity':
	                Body.setAngularVelocity(body, value);
	                break;
	            case 'parts':
	                Body.setParts(body, value);
	                break;
	            default:
	                body[property] = value;
	
	            }
	        }
	    };
	
	    /**
	     * Sets the body as static, including isStatic flag and setting mass and inertia to Infinity.
	     * @method setStatic
	     * @param {body} body
	     * @param {bool} isStatic
	     */
	    Body.setStatic = function(body, isStatic) {
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	            part.isStatic = isStatic;
	
	            if (isStatic) {
	                part._original = {
	                    restitution: part.restitution,
	                    friction: part.friction,
	                    mass: part.mass,
	                    inertia: part.inertia,
	                    density: part.density,
	                    inverseMass: part.inverseMass,
	                    inverseInertia: part.inverseInertia
	                };
	
	                part.restitution = 0;
	                part.friction = 1;
	                part.mass = part.inertia = part.density = Infinity;
	                part.inverseMass = part.inverseInertia = 0;
	
	                part.positionPrev.x = part.position.x;
	                part.positionPrev.y = part.position.y;
	                part.anglePrev = part.angle;
	                part.angularVelocity = 0;
	                part.speed = 0;
	                part.angularSpeed = 0;
	                part.motion = 0;
	            } else if (part._original) {
	                part.restitution = part._original.restitution;
	                part.friction = part._original.friction;
	                part.mass = part._original.mass;
	                part.inertia = part._original.inertia;
	                part.density = part._original.density;
	                part.inverseMass = part._original.inverseMass;
	                part.inverseInertia = part._original.inverseInertia;
	
	                delete part._original;
	            }
	        }
	    };
	
	    /**
	     * Sets the mass of the body. Inverse mass, density and inertia are automatically updated to reflect the change.
	     * @method setMass
	     * @param {body} body
	     * @param {number} mass
	     */
	    Body.setMass = function(body, mass) {
	        var moment = body.inertia / (body.mass / 6);
	        body.inertia = moment * (mass / 6);
	        body.inverseInertia = 1 / body.inertia;
	
	        body.mass = mass;
	        body.inverseMass = 1 / body.mass;
	        body.density = body.mass / body.area;
	    };
	
	    /**
	     * Sets the density of the body. Mass and inertia are automatically updated to reflect the change.
	     * @method setDensity
	     * @param {body} body
	     * @param {number} density
	     */
	    Body.setDensity = function(body, density) {
	        Body.setMass(body, density * body.area);
	        body.density = density;
	    };
	
	    /**
	     * Sets the moment of inertia (i.e. second moment of area) of the body of the body. 
	     * Inverse inertia is automatically updated to reflect the change. Mass is not changed.
	     * @method setInertia
	     * @param {body} body
	     * @param {number} inertia
	     */
	    Body.setInertia = function(body, inertia) {
	        body.inertia = inertia;
	        body.inverseInertia = 1 / body.inertia;
	    };
	
	    /**
	     * Sets the body's vertices and updates body properties accordingly, including inertia, area and mass (with respect to `body.density`).
	     * Vertices will be automatically transformed to be orientated around their centre of mass as the origin.
	     * They are then automatically translated to world space based on `body.position`.
	     *
	     * The `vertices` argument should be passed as an array of `Matter.Vector` points (or a `Matter.Vertices` array).
	     * Vertices must form a convex hull, concave hulls are not supported.
	     *
	     * @method setVertices
	     * @param {body} body
	     * @param {vector[]} vertices
	     */
	    Body.setVertices = function(body, vertices) {
	        // change vertices
	        if (vertices[0].body === body) {
	            body.vertices = vertices;
	        } else {
	            body.vertices = Vertices.create(vertices, body);
	        }
	
	        // update properties
	        body.axes = Axes.fromVertices(body.vertices);
	        body.area = Vertices.area(body.vertices);
	        Body.setMass(body, body.density * body.area);
	
	        // orient vertices around the centre of mass at origin (0, 0)
	        var centre = Vertices.centre(body.vertices);
	        Vertices.translate(body.vertices, centre, -1);
	
	        // update inertia while vertices are at origin (0, 0)
	        Body.setInertia(body, Body._inertiaScale * Vertices.inertia(body.vertices, body.mass));
	
	        // update geometry
	        Vertices.translate(body.vertices, body.position);
	        Bounds.update(body.bounds, body.vertices, body.velocity);
	    };
	
	    /**
	     * Sets the parts of the `body` and updates mass, inertia and centroid.
	     * Each part will have its parent set to `body`.
	     * By default the convex hull will be automatically computed and set on `body`, unless `autoHull` is set to `false.`
	     * Note that this method will ensure that the first part in `body.parts` will always be the `body`.
	     * @method setParts
	     * @param {body} body
	     * @param [body] parts
	     * @param {bool} [autoHull=true]
	     */
	    Body.setParts = function(body, parts, autoHull) {
	        var i;
	
	        // add all the parts, ensuring that the first part is always the parent body
	        parts = parts.slice(0);
	        body.parts.length = 0;
	        body.parts.push(body);
	        body.parent = body;
	
	        for (i = 0; i < parts.length; i++) {
	            var part = parts[i];
	            if (part !== body) {
	                part.parent = body;
	                body.parts.push(part);
	            }
	        }
	
	        if (body.parts.length === 1)
	            return;
	
	        autoHull = typeof autoHull !== 'undefined' ? autoHull : true;
	
	        // find the convex hull of all parts to set on the parent body
	        if (autoHull) {
	            var vertices = [];
	            for (i = 0; i < parts.length; i++) {
	                vertices = vertices.concat(parts[i].vertices);
	            }
	
	            Vertices.clockwiseSort(vertices);
	
	            var hull = Vertices.hull(vertices),
	                hullCentre = Vertices.centre(hull);
	
	            Body.setVertices(body, hull);
	            Vertices.translate(body.vertices, hullCentre);
	        }
	
	        // sum the properties of all compound parts of the parent body
	        var total = Body._totalProperties(body);
	
	        body.area = total.area;
	        body.parent = body;
	        body.position.x = total.centre.x;
	        body.position.y = total.centre.y;
	        body.positionPrev.x = total.centre.x;
	        body.positionPrev.y = total.centre.y;
	
	        Body.setMass(body, total.mass);
	        Body.setInertia(body, total.inertia);
	        Body.setPosition(body, total.centre);
	    };
	
	    /**
	     * Sets the position of the body instantly. Velocity, angle, force etc. are unchanged.
	     * @method setPosition
	     * @param {body} body
	     * @param {vector} position
	     */
	    Body.setPosition = function(body, position) {
	        var delta = Vector.sub(position, body.position);
	        body.positionPrev.x += delta.x;
	        body.positionPrev.y += delta.y;
	
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	            part.position.x += delta.x;
	            part.position.y += delta.y;
	            Vertices.translate(part.vertices, delta);
	            Bounds.update(part.bounds, part.vertices, body.velocity);
	        }
	    };
	
	    /**
	     * Sets the angle of the body instantly. Angular velocity, position, force etc. are unchanged.
	     * @method setAngle
	     * @param {body} body
	     * @param {number} angle
	     */
	    Body.setAngle = function(body, angle) {
	        var delta = angle - body.angle;
	        body.anglePrev += delta;
	
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	            part.angle += delta;
	            Vertices.rotate(part.vertices, delta, body.position);
	            Axes.rotate(part.axes, delta);
	            Bounds.update(part.bounds, part.vertices, body.velocity);
	            if (i > 0) {
	                Vector.rotateAbout(part.position, delta, body.position, part.position);
	            }
	        }
	    };
	
	    /**
	     * Sets the linear velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
	     * @method setVelocity
	     * @param {body} body
	     * @param {vector} velocity
	     */
	    Body.setVelocity = function(body, velocity) {
	        body.positionPrev.x = body.position.x - velocity.x;
	        body.positionPrev.y = body.position.y - velocity.y;
	        body.velocity.x = velocity.x;
	        body.velocity.y = velocity.y;
	        body.speed = Vector.magnitude(body.velocity);
	    };
	
	    /**
	     * Sets the angular velocity of the body instantly. Position, angle, force etc. are unchanged. See also `Body.applyForce`.
	     * @method setAngularVelocity
	     * @param {body} body
	     * @param {number} velocity
	     */
	    Body.setAngularVelocity = function(body, velocity) {
	        body.anglePrev = body.angle - velocity;
	        body.angularVelocity = velocity;
	        body.angularSpeed = Math.abs(body.angularVelocity);
	    };
	
	    /**
	     * Moves a body by a given vector relative to its current position, without imparting any velocity.
	     * @method translate
	     * @param {body} body
	     * @param {vector} translation
	     */
	    Body.translate = function(body, translation) {
	        Body.setPosition(body, Vector.add(body.position, translation));
	    };
	
	    /**
	     * Rotates a body by a given angle relative to its current angle, without imparting any angular velocity.
	     * @method rotate
	     * @param {body} body
	     * @param {number} rotation
	     * @param {vector} [point]
	     */
	    Body.rotate = function(body, rotation, point) {
	        if (!point) {
	            Body.setAngle(body, body.angle + rotation);
	        } else {
	            var cos = Math.cos(rotation),
	                sin = Math.sin(rotation),
	                dx = body.position.x - point.x,
	                dy = body.position.y - point.y;
	                
	            Body.setPosition(body, {
	                x: point.x + (dx * cos - dy * sin),
	                y: point.y + (dx * sin + dy * cos)
	            });
	
	            Body.setAngle(body, body.angle + rotation);
	        }
	    };
	
	    /**
	     * Scales the body, including updating physical properties (mass, area, axes, inertia), from a world-space point (default is body centre).
	     * @method scale
	     * @param {body} body
	     * @param {number} scaleX
	     * @param {number} scaleY
	     * @param {vector} [point]
	     */
	    Body.scale = function(body, scaleX, scaleY, point) {
	        var totalArea = 0,
	            totalInertia = 0;
	
	        point = point || body.position;
	
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	
	            // scale vertices
	            Vertices.scale(part.vertices, scaleX, scaleY, point);
	
	            // update properties
	            part.axes = Axes.fromVertices(part.vertices);
	            part.area = Vertices.area(part.vertices);
	            Body.setMass(part, body.density * part.area);
	
	            // update inertia (requires vertices to be at origin)
	            Vertices.translate(part.vertices, { x: -part.position.x, y: -part.position.y });
	            Body.setInertia(part, Body._inertiaScale * Vertices.inertia(part.vertices, part.mass));
	            Vertices.translate(part.vertices, { x: part.position.x, y: part.position.y });
	
	            if (i > 0) {
	                totalArea += part.area;
	                totalInertia += part.inertia;
	            }
	
	            // scale position
	            part.position.x = point.x + (part.position.x - point.x) * scaleX;
	            part.position.y = point.y + (part.position.y - point.y) * scaleY;
	
	            // update bounds
	            Bounds.update(part.bounds, part.vertices, body.velocity);
	        }
	
	        // handle parent body
	        if (body.parts.length > 1) {
	            body.area = totalArea;
	
	            if (!body.isStatic) {
	                Body.setMass(body, body.density * totalArea);
	                Body.setInertia(body, totalInertia);
	            }
	        }
	
	        // handle circles
	        if (body.circleRadius) { 
	            if (scaleX === scaleY) {
	                body.circleRadius *= scaleX;
	            } else {
	                // body is no longer a circle
	                body.circleRadius = null;
	            }
	        }
	    };
	
	    /**
	     * Performs a simulation step for the given `body`, including updating position and angle using Verlet integration.
	     * @method update
	     * @param {body} body
	     * @param {number} deltaTime
	     * @param {number} timeScale
	     * @param {number} correction
	     */
	    Body.update = function(body, deltaTime, timeScale, correction) {
	        var deltaTimeSquared = Math.pow(deltaTime * timeScale * body.timeScale, 2);
	
	        // from the previous step
	        var frictionAir = 1 - body.frictionAir * timeScale * body.timeScale,
	            velocityPrevX = body.position.x - body.positionPrev.x,
	            velocityPrevY = body.position.y - body.positionPrev.y;
	
	        // update velocity with Verlet integration
	        body.velocity.x = (velocityPrevX * frictionAir * correction) + (body.force.x / body.mass) * deltaTimeSquared;
	        body.velocity.y = (velocityPrevY * frictionAir * correction) + (body.force.y / body.mass) * deltaTimeSquared;
	
	        body.positionPrev.x = body.position.x;
	        body.positionPrev.y = body.position.y;
	        body.position.x += body.velocity.x;
	        body.position.y += body.velocity.y;
	
	        // update angular velocity with Verlet integration
	        body.angularVelocity = ((body.angle - body.anglePrev) * frictionAir * correction) + (body.torque / body.inertia) * deltaTimeSquared;
	        body.anglePrev = body.angle;
	        body.angle += body.angularVelocity;
	
	        // track speed and acceleration
	        body.speed = Vector.magnitude(body.velocity);
	        body.angularSpeed = Math.abs(body.angularVelocity);
	
	        // transform the body geometry
	        for (var i = 0; i < body.parts.length; i++) {
	            var part = body.parts[i];
	
	            Vertices.translate(part.vertices, body.velocity);
	            
	            if (i > 0) {
	                part.position.x += body.velocity.x;
	                part.position.y += body.velocity.y;
	            }
	
	            if (body.angularVelocity !== 0) {
	                Vertices.rotate(part.vertices, body.angularVelocity, body.position);
	                Axes.rotate(part.axes, body.angularVelocity);
	                if (i > 0) {
	                    Vector.rotateAbout(part.position, body.angularVelocity, body.position, part.position);
	                }
	            }
	
	            Bounds.update(part.bounds, part.vertices, body.velocity);
	        }
	    };
	
	    /**
	     * Applies a force to a body from a given world-space position, including resulting torque.
	     * @method applyForce
	     * @param {body} body
	     * @param {vector} position
	     * @param {vector} force
	     */
	    Body.applyForce = function(body, position, force) {
	        body.force.x += force.x;
	        body.force.y += force.y;
	        var offset = { x: position.x - body.position.x, y: position.y - body.position.y };
	        body.torque += offset.x * force.y - offset.y * force.x;
	    };
	
	    /**
	     * Returns the sums of the properties of all compound parts of the parent body.
	     * @method _totalProperties
	     * @private
	     * @param {body} body
	     * @return {}
	     */
	    Body._totalProperties = function(body) {
	        // from equations at:
	        // https://ecourses.ou.edu/cgi-bin/ebook.cgi?doc=&topic=st&chap_sec=07.2&page=theory
	        // http://output.to/sideway/default.asp?qno=121100087
	
	        var properties = {
	            mass: 0,
	            area: 0,
	            inertia: 0,
	            centre: { x: 0, y: 0 }
	        };
	
	        // sum the properties of all compound parts of the parent body
	        for (var i = body.parts.length === 1 ? 0 : 1; i < body.parts.length; i++) {
	            var part = body.parts[i],
	                mass = part.mass !== Infinity ? part.mass : 1;
	
	            properties.mass += mass;
	            properties.area += part.area;
	            properties.inertia += part.inertia;
	            properties.centre = Vector.add(properties.centre, Vector.mult(part.position, mass));
	        }
	
	        properties.centre = Vector.div(properties.centre, properties.mass);
	
	        return properties;
	    };
	
	    /*
	    *
	    *  Events Documentation
	    *
	    */
	
	    /**
	    * Fired when a body starts sleeping (where `this` is the body).
	    *
	    * @event sleepStart
	    * @this {body} The body that has started sleeping
	    * @param {} event An event object
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when a body ends sleeping (where `this` is the body).
	    *
	    * @event sleepEnd
	    * @this {body} The body that has ended sleeping
	    * @param {} event An event object
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * An integer `Number` uniquely identifying number generated in `Body.create` by `Common.nextId`.
	     *
	     * @property id
	     * @type number
	     */
	
	    /**
	     * A `String` denoting the type of object.
	     *
	     * @property type
	     * @type string
	     * @default "body"
	     * @readOnly
	     */
	
	    /**
	     * An arbitrary `String` name to help the user identify and manage bodies.
	     *
	     * @property label
	     * @type string
	     * @default "Body"
	     */
	
	    /**
	     * An array of bodies that make up this body. 
	     * The first body in the array must always be a self reference to the current body instance.
	     * All bodies in the `parts` array together form a single rigid compound body.
	     * Parts are allowed to overlap, have gaps or holes or even form concave bodies.
	     * Parts themselves should never be added to a `World`, only the parent body should be.
	     * Use `Body.setParts` when setting parts to ensure correct updates of all properties.
	     *
	     * @property parts
	     * @type body[]
	     */
	
	    /**
	     * An object reserved for storing plugin-specific properties.
	     *
	     * @property plugin
	     * @type {}
	     */
	
	    /**
	     * A self reference if the body is _not_ a part of another body.
	     * Otherwise this is a reference to the body that this is a part of.
	     * See `body.parts`.
	     *
	     * @property parent
	     * @type body
	     */
	
	    /**
	     * A `Number` specifying the angle of the body, in radians.
	     *
	     * @property angle
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * An array of `Vector` objects that specify the convex hull of the rigid body.
	     * These should be provided about the origin `(0, 0)`. E.g.
	     *
	     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
	     *
	     * When passed via `Body.create`, the vertices are translated relative to `body.position` (i.e. world-space, and constantly updated by `Body.update` during simulation).
	     * The `Vector` objects are also augmented with additional properties required for efficient collision detection. 
	     *
	     * Other properties such as `inertia` and `bounds` are automatically calculated from the passed vertices (unless provided via `options`).
	     * Concave hulls are not currently supported. The module `Matter.Vertices` contains useful methods for working with vertices.
	     *
	     * @property vertices
	     * @type vector[]
	     */
	
	    /**
	     * A `Vector` that specifies the current world-space position of the body.
	     *
	     * @property position
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Vector` that specifies the force to apply in the current step. It is zeroed after every `Body.update`. See also `Body.applyForce`.
	     *
	     * @property force
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Number` that specifies the torque (turning force) to apply in the current step. It is zeroed after every `Body.update`.
	     *
	     * @property torque
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that _measures_ the current speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.velocity`).
	     *
	     * @readOnly
	     * @property speed
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that _measures_ the current angular speed of the body after the last `Body.update`. It is read-only and always positive (it's the magnitude of `body.angularVelocity`).
	     *
	     * @readOnly
	     * @property angularSpeed
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Vector` that _measures_ the current velocity of the body after the last `Body.update`. It is read-only. 
	     * If you need to modify a body's velocity directly, you should either apply a force or simply change the body's `position` (as the engine uses position-Verlet integration).
	     *
	     * @readOnly
	     * @property velocity
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Number` that _measures_ the current angular velocity of the body after the last `Body.update`. It is read-only. 
	     * If you need to modify a body's angular velocity directly, you should apply a torque or simply change the body's `angle` (as the engine uses position-Verlet integration).
	     *
	     * @readOnly
	     * @property angularVelocity
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A flag that indicates whether a body is considered static. A static body can never change position or angle and is completely fixed.
	     * If you need to set a body as static after its creation, you should use `Body.setStatic` as this requires more than just setting this flag.
	     *
	     * @property isStatic
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * A flag that indicates whether a body is a sensor. Sensor triggers collision events, but doesn't react with colliding body physically.
	     *
	     * @property isSensor
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * A flag that indicates whether the body is considered sleeping. A sleeping body acts similar to a static body, except it is only temporary and can be awoken.
	     * If you need to set a body as sleeping, you should use `Sleeping.set` as this requires more than just setting this flag.
	     *
	     * @property isSleeping
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * A `Number` that _measures_ the amount of movement a body currently has (a combination of `speed` and `angularSpeed`). It is read-only and always positive.
	     * It is used and updated by the `Matter.Sleeping` module during simulation to decide if a body has come to rest.
	     *
	     * @readOnly
	     * @property motion
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that defines the number of updates in which this body must have near-zero velocity before it is set as sleeping by the `Matter.Sleeping` module (if sleeping is enabled by the engine).
	     *
	     * @property sleepThreshold
	     * @type number
	     * @default 60
	     */
	
	    /**
	     * A `Number` that defines the density of the body, that is its mass per unit area.
	     * If you pass the density via `Body.create` the `mass` property is automatically calculated for you based on the size (area) of the object.
	     * This is generally preferable to simply setting mass and allows for more intuitive definition of materials (e.g. rock has a higher density than wood).
	     *
	     * @property density
	     * @type number
	     * @default 0.001
	     */
	
	    /**
	     * A `Number` that defines the mass of the body, although it may be more appropriate to specify the `density` property instead.
	     * If you modify this value, you must also modify the `body.inverseMass` property (`1 / mass`).
	     *
	     * @property mass
	     * @type number
	     */
	
	    /**
	     * A `Number` that defines the inverse mass of the body (`1 / mass`).
	     * If you modify this value, you must also modify the `body.mass` property.
	     *
	     * @property inverseMass
	     * @type number
	     */
	
	    /**
	     * A `Number` that defines the moment of inertia (i.e. second moment of area) of the body.
	     * It is automatically calculated from the given convex hull (`vertices` array) and density in `Body.create`.
	     * If you modify this value, you must also modify the `body.inverseInertia` property (`1 / inertia`).
	     *
	     * @property inertia
	     * @type number
	     */
	
	    /**
	     * A `Number` that defines the inverse moment of inertia of the body (`1 / inertia`).
	     * If you modify this value, you must also modify the `body.inertia` property.
	     *
	     * @property inverseInertia
	     * @type number
	     */
	
	    /**
	     * A `Number` that defines the restitution (elasticity) of the body. The value is always positive and is in the range `(0, 1)`.
	     * A value of `0` means collisions may be perfectly inelastic and no bouncing may occur. 
	     * A value of `0.8` means the body may bounce back with approximately 80% of its kinetic energy.
	     * Note that collision response is based on _pairs_ of bodies, and that `restitution` values are _combined_ with the following formula:
	     *
	     *     Math.max(bodyA.restitution, bodyB.restitution)
	     *
	     * @property restitution
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that defines the friction of the body. The value is always positive and is in the range `(0, 1)`.
	     * A value of `0` means that the body may slide indefinitely.
	     * A value of `1` means the body may come to a stop almost instantly after a force is applied.
	     *
	     * The effects of the value may be non-linear. 
	     * High values may be unstable depending on the body.
	     * The engine uses a Coulomb friction model including static and kinetic friction.
	     * Note that collision response is based on _pairs_ of bodies, and that `friction` values are _combined_ with the following formula:
	     *
	     *     Math.min(bodyA.friction, bodyB.friction)
	     *
	     * @property friction
	     * @type number
	     * @default 0.1
	     */
	
	    /**
	     * A `Number` that defines the static friction of the body (in the Coulomb friction model). 
	     * A value of `0` means the body will never 'stick' when it is nearly stationary and only dynamic `friction` is used.
	     * The higher the value (e.g. `10`), the more force it will take to initially get the body moving when nearly stationary.
	     * This value is multiplied with the `friction` property to make it easier to change `friction` and maintain an appropriate amount of static friction.
	     *
	     * @property frictionStatic
	     * @type number
	     * @default 0.5
	     */
	
	    /**
	     * A `Number` that defines the air friction of the body (air resistance). 
	     * A value of `0` means the body will never slow as it moves through space.
	     * The higher the value, the faster a body slows when moving through space.
	     * The effects of the value are non-linear. 
	     *
	     * @property frictionAir
	     * @type number
	     * @default 0.01
	     */
	
	    /**
	     * An `Object` that specifies the collision filtering properties of this body.
	     *
	     * Collisions between two bodies will obey the following rules:
	     * - If the two bodies have the same non-zero value of `collisionFilter.group`,
	     *   they will always collide if the value is positive, and they will never collide
	     *   if the value is negative.
	     * - If the two bodies have different values of `collisionFilter.group` or if one
	     *   (or both) of the bodies has a value of 0, then the category/mask rules apply as follows:
	     *
	     * Each body belongs to a collision category, given by `collisionFilter.category`. This
	     * value is used as a bit field and the category should have only one bit set, meaning that
	     * the value of this property is a power of two in the range [1, 2^31]. Thus, there are 32
	     * different collision categories available.
	     *
	     * Each body also defines a collision bitmask, given by `collisionFilter.mask` which specifies
	     * the categories it collides with (the value is the bitwise AND value of all these categories).
	     *
	     * Using the category/mask rules, two bodies `A` and `B` collide if each includes the other's
	     * category in its mask, i.e. `(categoryA & maskB) !== 0` and `(categoryB & maskA) !== 0`
	     * are both true.
	     *
	     * @property collisionFilter
	     * @type object
	     */
	
	    /**
	     * An Integer `Number`, that specifies the collision group this body belongs to.
	     * See `body.collisionFilter` for more information.
	     *
	     * @property collisionFilter.group
	     * @type object
	     * @default 0
	     */
	
	    /**
	     * A bit field that specifies the collision category this body belongs to.
	     * The category value should have only one bit set, for example `0x0001`.
	     * This means there are up to 32 unique collision categories available.
	     * See `body.collisionFilter` for more information.
	     *
	     * @property collisionFilter.category
	     * @type object
	     * @default 1
	     */
	
	    /**
	     * A bit mask that specifies the collision categories this body may collide with.
	     * See `body.collisionFilter` for more information.
	     *
	     * @property collisionFilter.mask
	     * @type object
	     * @default -1
	     */
	
	    /**
	     * A `Number` that specifies a tolerance on how far a body is allowed to 'sink' or rotate into other bodies.
	     * Avoid changing this value unless you understand the purpose of `slop` in physics engines.
	     * The default should generally suffice, although very large bodies may require larger values for stable stacking.
	     *
	     * @property slop
	     * @type number
	     * @default 0.05
	     */
	
	    /**
	     * A `Number` that allows per-body time scaling, e.g. a force-field where bodies inside are in slow-motion, while others are at full speed.
	     *
	     * @property timeScale
	     * @type number
	     * @default 1
	     */
	
	    /**
	     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
	     *
	     * @property render
	     * @type object
	     */
	
	    /**
	     * A flag that indicates if the body should be rendered.
	     *
	     * @property render.visible
	     * @type boolean
	     * @default true
	     */
	
	    /**
	     * Sets the opacity to use when rendering.
	     *
	     * @property render.opacity
	     * @type number
	     * @default 1
	    */
	
	    /**
	     * An `Object` that defines the sprite properties to use when rendering, if any.
	     *
	     * @property render.sprite
	     * @type object
	     */
	
	    /**
	     * An `String` that defines the path to the image to use as the sprite texture, if any.
	     *
	     * @property render.sprite.texture
	     * @type string
	     */
	     
	    /**
	     * A `Number` that defines the scaling in the x-axis for the sprite, if any.
	     *
	     * @property render.sprite.xScale
	     * @type number
	     * @default 1
	     */
	
	    /**
	     * A `Number` that defines the scaling in the y-axis for the sprite, if any.
	     *
	     * @property render.sprite.yScale
	     * @type number
	     * @default 1
	     */
	
	     /**
	      * A `Number` that defines the offset in the x-axis for the sprite (normalised by texture width).
	      *
	      * @property render.sprite.xOffset
	      * @type number
	      * @default 0
	      */
	
	     /**
	      * A `Number` that defines the offset in the y-axis for the sprite (normalised by texture height).
	      *
	      * @property render.sprite.yOffset
	      * @type number
	      * @default 0
	      */
	
	    /**
	     * A `Number` that defines the line width to use when rendering the body outline (if a sprite is not defined).
	     * A value of `0` means no outline will be rendered.
	     *
	     * @property render.lineWidth
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `String` that defines the fill style to use when rendering the body (if a sprite is not defined).
	     * It is the same as when using a canvas, so it accepts CSS style property values.
	     *
	     * @property render.fillStyle
	     * @type string
	     * @default a random colour
	     */
	
	    /**
	     * A `String` that defines the stroke style to use when rendering the body outline (if a sprite is not defined).
	     * It is the same as when using a canvas, so it accepts CSS style property values.
	     *
	     * @property render.strokeStyle
	     * @type string
	     * @default a random colour
	     */
	
	    /**
	     * An array of unique axis vectors (edge normals) used for collision detection.
	     * These are automatically calculated from the given convex hull (`vertices` array) in `Body.create`.
	     * They are constantly updated by `Body.update` during the simulation.
	     *
	     * @property axes
	     * @type vector[]
	     */
	     
	    /**
	     * A `Number` that _measures_ the area of the body's convex hull, calculated at creation by `Body.create`.
	     *
	     * @property area
	     * @type string
	     * @default 
	     */
	
	    /**
	     * A `Bounds` object that defines the AABB region for the body.
	     * It is automatically calculated from the given convex hull (`vertices` array) in `Body.create` and constantly updated by `Body.update` during simulation.
	     *
	     * @property bounds
	     * @type bounds
	     */
	
	})();
	
	},{"../core/Common":14,"../core/Sleeping":22,"../geometry/Axes":25,"../geometry/Bounds":26,"../geometry/Vector":28,"../geometry/Vertices":29,"../render/Render":31}],2:[function(_dereq_,module,exports){
	/**
	* The `Matter.Composite` module contains methods for creating and manipulating composite bodies.
	* A composite body is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`, therefore composites form a tree structure.
	* It is important to use the functions in this module to modify composites, rather than directly modifying their properties.
	* Note that the `Matter.World` object is also a type of `Matter.Composite` and as such all composite methods here can also operate on a `Matter.World`.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Composite
	*/
	
	var Composite = {};
	
	module.exports = Composite;
	
	var Events = _dereq_('../core/Events');
	var Common = _dereq_('../core/Common');
	var Bounds = _dereq_('../geometry/Bounds');
	var Body = _dereq_('./Body');
	
	(function() {
	
	    /**
	     * Creates a new composite. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properites section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {} [options]
	     * @return {composite} A new composite
	     */
	    Composite.create = function(options) {
	        return Common.extend({ 
	            id: Common.nextId(),
	            type: 'composite',
	            parent: null,
	            isModified: false,
	            bodies: [], 
	            constraints: [], 
	            composites: [],
	            label: 'Composite',
	            plugin: {}
	        }, options);
	    };
	
	    /**
	     * Sets the composite's `isModified` flag. 
	     * If `updateParents` is true, all parents will be set (default: false).
	     * If `updateChildren` is true, all children will be set (default: false).
	     * @method setModified
	     * @param {composite} composite
	     * @param {boolean} isModified
	     * @param {boolean} [updateParents=false]
	     * @param {boolean} [updateChildren=false]
	     */
	    Composite.setModified = function(composite, isModified, updateParents, updateChildren) {
	        composite.isModified = isModified;
	
	        if (updateParents && composite.parent) {
	            Composite.setModified(composite.parent, isModified, updateParents, updateChildren);
	        }
	
	        if (updateChildren) {
	            for(var i = 0; i < composite.composites.length; i++) {
	                var childComposite = composite.composites[i];
	                Composite.setModified(childComposite, isModified, updateParents, updateChildren);
	            }
	        }
	    };
	
	    /**
	     * Generic add function. Adds one or many body(s), constraint(s) or a composite(s) to the given composite.
	     * Triggers `beforeAdd` and `afterAdd` events on the `composite`.
	     * @method add
	     * @param {composite} composite
	     * @param {} object
	     * @return {composite} The original composite with the objects added
	     */
	    Composite.add = function(composite, object) {
	        var objects = [].concat(object);
	
	        Events.trigger(composite, 'beforeAdd', { object: object });
	
	        for (var i = 0; i < objects.length; i++) {
	            var obj = objects[i];
	
	            switch (obj.type) {
	
	            case 'body':
	                // skip adding compound parts
	                if (obj.parent !== obj) {
	                    Common.warn('Composite.add: skipped adding a compound body part (you must add its parent instead)');
	                    break;
	                }
	
	                Composite.addBody(composite, obj);
	                break;
	            case 'constraint':
	                Composite.addConstraint(composite, obj);
	                break;
	            case 'composite':
	                Composite.addComposite(composite, obj);
	                break;
	            case 'mouseConstraint':
	                Composite.addConstraint(composite, obj.constraint);
	                break;
	
	            }
	        }
	
	        Events.trigger(composite, 'afterAdd', { object: object });
	
	        return composite;
	    };
	
	    /**
	     * Generic remove function. Removes one or many body(s), constraint(s) or a composite(s) to the given composite.
	     * Optionally searching its children recursively.
	     * Triggers `beforeRemove` and `afterRemove` events on the `composite`.
	     * @method remove
	     * @param {composite} composite
	     * @param {} object
	     * @param {boolean} [deep=false]
	     * @return {composite} The original composite with the objects removed
	     */
	    Composite.remove = function(composite, object, deep) {
	        var objects = [].concat(object);
	
	        Events.trigger(composite, 'beforeRemove', { object: object });
	
	        for (var i = 0; i < objects.length; i++) {
	            var obj = objects[i];
	
	            switch (obj.type) {
	
	            case 'body':
	                Composite.removeBody(composite, obj, deep);
	                break;
	            case 'constraint':
	                Composite.removeConstraint(composite, obj, deep);
	                break;
	            case 'composite':
	                Composite.removeComposite(composite, obj, deep);
	                break;
	            case 'mouseConstraint':
	                Composite.removeConstraint(composite, obj.constraint);
	                break;
	
	            }
	        }
	
	        Events.trigger(composite, 'afterRemove', { object: object });
	
	        return composite;
	    };
	
	    /**
	     * Adds a composite to the given composite.
	     * @private
	     * @method addComposite
	     * @param {composite} compositeA
	     * @param {composite} compositeB
	     * @return {composite} The original compositeA with the objects from compositeB added
	     */
	    Composite.addComposite = function(compositeA, compositeB) {
	        compositeA.composites.push(compositeB);
	        compositeB.parent = compositeA;
	        Composite.setModified(compositeA, true, true, false);
	        return compositeA;
	    };
	
	    /**
	     * Removes a composite from the given composite, and optionally searching its children recursively.
	     * @private
	     * @method removeComposite
	     * @param {composite} compositeA
	     * @param {composite} compositeB
	     * @param {boolean} [deep=false]
	     * @return {composite} The original compositeA with the composite removed
	     */
	    Composite.removeComposite = function(compositeA, compositeB, deep) {
	        var position = Common.indexOf(compositeA.composites, compositeB);
	        if (position !== -1) {
	            Composite.removeCompositeAt(compositeA, position);
	            Composite.setModified(compositeA, true, true, false);
	        }
	
	        if (deep) {
	            for (var i = 0; i < compositeA.composites.length; i++){
	                Composite.removeComposite(compositeA.composites[i], compositeB, true);
	            }
	        }
	
	        return compositeA;
	    };
	
	    /**
	     * Removes a composite from the given composite.
	     * @private
	     * @method removeCompositeAt
	     * @param {composite} composite
	     * @param {number} position
	     * @return {composite} The original composite with the composite removed
	     */
	    Composite.removeCompositeAt = function(composite, position) {
	        composite.composites.splice(position, 1);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Adds a body to the given composite.
	     * @private
	     * @method addBody
	     * @param {composite} composite
	     * @param {body} body
	     * @return {composite} The original composite with the body added
	     */
	    Composite.addBody = function(composite, body) {
	        composite.bodies.push(body);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Removes a body from the given composite, and optionally searching its children recursively.
	     * @private
	     * @method removeBody
	     * @param {composite} composite
	     * @param {body} body
	     * @param {boolean} [deep=false]
	     * @return {composite} The original composite with the body removed
	     */
	    Composite.removeBody = function(composite, body, deep) {
	        var position = Common.indexOf(composite.bodies, body);
	        if (position !== -1) {
	            Composite.removeBodyAt(composite, position);
	            Composite.setModified(composite, true, true, false);
	        }
	
	        if (deep) {
	            for (var i = 0; i < composite.composites.length; i++){
	                Composite.removeBody(composite.composites[i], body, true);
	            }
	        }
	
	        return composite;
	    };
	
	    /**
	     * Removes a body from the given composite.
	     * @private
	     * @method removeBodyAt
	     * @param {composite} composite
	     * @param {number} position
	     * @return {composite} The original composite with the body removed
	     */
	    Composite.removeBodyAt = function(composite, position) {
	        composite.bodies.splice(position, 1);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Adds a constraint to the given composite.
	     * @private
	     * @method addConstraint
	     * @param {composite} composite
	     * @param {constraint} constraint
	     * @return {composite} The original composite with the constraint added
	     */
	    Composite.addConstraint = function(composite, constraint) {
	        composite.constraints.push(constraint);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Removes a constraint from the given composite, and optionally searching its children recursively.
	     * @private
	     * @method removeConstraint
	     * @param {composite} composite
	     * @param {constraint} constraint
	     * @param {boolean} [deep=false]
	     * @return {composite} The original composite with the constraint removed
	     */
	    Composite.removeConstraint = function(composite, constraint, deep) {
	        var position = Common.indexOf(composite.constraints, constraint);
	        if (position !== -1) {
	            Composite.removeConstraintAt(composite, position);
	        }
	
	        if (deep) {
	            for (var i = 0; i < composite.composites.length; i++){
	                Composite.removeConstraint(composite.composites[i], constraint, true);
	            }
	        }
	
	        return composite;
	    };
	
	    /**
	     * Removes a body from the given composite.
	     * @private
	     * @method removeConstraintAt
	     * @param {composite} composite
	     * @param {number} position
	     * @return {composite} The original composite with the constraint removed
	     */
	    Composite.removeConstraintAt = function(composite, position) {
	        composite.constraints.splice(position, 1);
	        Composite.setModified(composite, true, true, false);
	        return composite;
	    };
	
	    /**
	     * Removes all bodies, constraints and composites from the given composite.
	     * Optionally clearing its children recursively.
	     * @method clear
	     * @param {composite} composite
	     * @param {boolean} keepStatic
	     * @param {boolean} [deep=false]
	     */
	    Composite.clear = function(composite, keepStatic, deep) {
	        if (deep) {
	            for (var i = 0; i < composite.composites.length; i++){
	                Composite.clear(composite.composites[i], keepStatic, true);
	            }
	        }
	        
	        if (keepStatic) {
	            composite.bodies = composite.bodies.filter(function(body) { return body.isStatic; });
	        } else {
	            composite.bodies.length = 0;
	        }
	
	        composite.constraints.length = 0;
	        composite.composites.length = 0;
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Returns all bodies in the given composite, including all bodies in its children, recursively.
	     * @method allBodies
	     * @param {composite} composite
	     * @return {body[]} All the bodies
	     */
	    Composite.allBodies = function(composite) {
	        var bodies = [].concat(composite.bodies);
	
	        for (var i = 0; i < composite.composites.length; i++)
	            bodies = bodies.concat(Composite.allBodies(composite.composites[i]));
	
	        return bodies;
	    };
	
	    /**
	     * Returns all constraints in the given composite, including all constraints in its children, recursively.
	     * @method allConstraints
	     * @param {composite} composite
	     * @return {constraint[]} All the constraints
	     */
	    Composite.allConstraints = function(composite) {
	        var constraints = [].concat(composite.constraints);
	
	        for (var i = 0; i < composite.composites.length; i++)
	            constraints = constraints.concat(Composite.allConstraints(composite.composites[i]));
	
	        return constraints;
	    };
	
	    /**
	     * Returns all composites in the given composite, including all composites in its children, recursively.
	     * @method allComposites
	     * @param {composite} composite
	     * @return {composite[]} All the composites
	     */
	    Composite.allComposites = function(composite) {
	        var composites = [].concat(composite.composites);
	
	        for (var i = 0; i < composite.composites.length; i++)
	            composites = composites.concat(Composite.allComposites(composite.composites[i]));
	
	        return composites;
	    };
	
	    /**
	     * Searches the composite recursively for an object matching the type and id supplied, null if not found.
	     * @method get
	     * @param {composite} composite
	     * @param {number} id
	     * @param {string} type
	     * @return {object} The requested object, if found
	     */
	    Composite.get = function(composite, id, type) {
	        var objects,
	            object;
	
	        switch (type) {
	        case 'body':
	            objects = Composite.allBodies(composite);
	            break;
	        case 'constraint':
	            objects = Composite.allConstraints(composite);
	            break;
	        case 'composite':
	            objects = Composite.allComposites(composite).concat(composite);
	            break;
	        }
	
	        if (!objects)
	            return null;
	
	        object = objects.filter(function(object) { 
	            return object.id.toString() === id.toString(); 
	        });
	
	        return object.length === 0 ? null : object[0];
	    };
	
	    /**
	     * Moves the given object(s) from compositeA to compositeB (equal to a remove followed by an add).
	     * @method move
	     * @param {compositeA} compositeA
	     * @param {object[]} objects
	     * @param {compositeB} compositeB
	     * @return {composite} Returns compositeA
	     */
	    Composite.move = function(compositeA, objects, compositeB) {
	        Composite.remove(compositeA, objects);
	        Composite.add(compositeB, objects);
	        return compositeA;
	    };
	
	    /**
	     * Assigns new ids for all objects in the composite, recursively.
	     * @method rebase
	     * @param {composite} composite
	     * @return {composite} Returns composite
	     */
	    Composite.rebase = function(composite) {
	        var objects = Composite.allBodies(composite)
	                        .concat(Composite.allConstraints(composite))
	                        .concat(Composite.allComposites(composite));
	
	        for (var i = 0; i < objects.length; i++) {
	            objects[i].id = Common.nextId();
	        }
	
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Translates all children in the composite by a given vector relative to their current positions, 
	     * without imparting any velocity.
	     * @method translate
	     * @param {composite} composite
	     * @param {vector} translation
	     * @param {bool} [recursive=true]
	     */
	    Composite.translate = function(composite, translation, recursive) {
	        var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
	
	        for (var i = 0; i < bodies.length; i++) {
	            Body.translate(bodies[i], translation);
	        }
	
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Rotates all children in the composite by a given angle about the given point, without imparting any angular velocity.
	     * @method rotate
	     * @param {composite} composite
	     * @param {number} rotation
	     * @param {vector} point
	     * @param {bool} [recursive=true]
	     */
	    Composite.rotate = function(composite, rotation, point, recursive) {
	        var cos = Math.cos(rotation),
	            sin = Math.sin(rotation),
	            bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                dx = body.position.x - point.x,
	                dy = body.position.y - point.y;
	                
	            Body.setPosition(body, {
	                x: point.x + (dx * cos - dy * sin),
	                y: point.y + (dx * sin + dy * cos)
	            });
	
	            Body.rotate(body, rotation);
	        }
	
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Scales all children in the composite, including updating physical properties (mass, area, axes, inertia), from a world-space point.
	     * @method scale
	     * @param {composite} composite
	     * @param {number} scaleX
	     * @param {number} scaleY
	     * @param {vector} point
	     * @param {bool} [recursive=true]
	     */
	    Composite.scale = function(composite, scaleX, scaleY, point, recursive) {
	        var bodies = recursive ? Composite.allBodies(composite) : composite.bodies;
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                dx = body.position.x - point.x,
	                dy = body.position.y - point.y;
	                
	            Body.setPosition(body, {
	                x: point.x + dx * scaleX,
	                y: point.y + dy * scaleY
	            });
	
	            Body.scale(body, scaleX, scaleY);
	        }
	
	        Composite.setModified(composite, true, true, false);
	
	        return composite;
	    };
	
	    /**
	     * Returns the union of the bounds of all of the composite's bodies.
	     * @method bounds
	     * @param {composite} composite The composite.
	     * @returns {bounds} The composite bounds.
	     */
	    Composite.bounds = function(composite) {
	        var bodies = Composite.allBodies(composite),
	            vertices = [];
	
	        for (var i = 0; i < bodies.length; i += 1) {
	            var body = bodies[i];
	            vertices.push(body.bounds.min, body.bounds.max);
	        }
	
	        return Bounds.create(vertices);
	    };
	
	    /*
	    *
	    *  Events Documentation
	    *
	    */
	
	    /**
	    * Fired when a call to `Composite.add` is made, before objects have been added.
	    *
	    * @event beforeAdd
	    * @param {} event An event object
	    * @param {} event.object The object(s) to be added (may be a single body, constraint, composite or a mixed array of these)
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when a call to `Composite.add` is made, after objects have been added.
	    *
	    * @event afterAdd
	    * @param {} event An event object
	    * @param {} event.object The object(s) that have been added (may be a single body, constraint, composite or a mixed array of these)
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when a call to `Composite.remove` is made, before objects have been removed.
	    *
	    * @event beforeRemove
	    * @param {} event An event object
	    * @param {} event.object The object(s) to be removed (may be a single body, constraint, composite or a mixed array of these)
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when a call to `Composite.remove` is made, after objects have been removed.
	    *
	    * @event afterRemove
	    * @param {} event An event object
	    * @param {} event.object The object(s) that have been removed (may be a single body, constraint, composite or a mixed array of these)
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
	     *
	     * @property id
	     * @type number
	     */
	
	    /**
	     * A `String` denoting the type of object.
	     *
	     * @property type
	     * @type string
	     * @default "composite"
	     * @readOnly
	     */
	
	    /**
	     * An arbitrary `String` name to help the user identify and manage composites.
	     *
	     * @property label
	     * @type string
	     * @default "Composite"
	     */
	
	    /**
	     * A flag that specifies whether the composite has been modified during the current step.
	     * Most `Matter.Composite` methods will automatically set this flag to `true` to inform the engine of changes to be handled.
	     * If you need to change it manually, you should use the `Composite.setModified` method.
	     *
	     * @property isModified
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * The `Composite` that is the parent of this composite. It is automatically managed by the `Matter.Composite` methods.
	     *
	     * @property parent
	     * @type composite
	     * @default null
	     */
	
	    /**
	     * An array of `Body` that are _direct_ children of this composite.
	     * To add or remove bodies you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
	     * If you wish to recursively find all descendants, you should use the `Composite.allBodies` method.
	     *
	     * @property bodies
	     * @type body[]
	     * @default []
	     */
	
	    /**
	     * An array of `Constraint` that are _direct_ children of this composite.
	     * To add or remove constraints you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
	     * If you wish to recursively find all descendants, you should use the `Composite.allConstraints` method.
	     *
	     * @property constraints
	     * @type constraint[]
	     * @default []
	     */
	
	    /**
	     * An array of `Composite` that are _direct_ children of this composite.
	     * To add or remove composites you should use `Composite.add` and `Composite.remove` methods rather than directly modifying this property.
	     * If you wish to recursively find all descendants, you should use the `Composite.allComposites` method.
	     *
	     * @property composites
	     * @type composite[]
	     * @default []
	     */
	
	    /**
	     * An object reserved for storing plugin-specific properties.
	     *
	     * @property plugin
	     * @type {}
	     */
	
	})();
	
	},{"../core/Common":14,"../core/Events":16,"../geometry/Bounds":26,"./Body":1}],3:[function(_dereq_,module,exports){
	/**
	* The `Matter.World` module contains methods for creating and manipulating the world composite.
	* A `Matter.World` is a `Matter.Composite` body, which is a collection of `Matter.Body`, `Matter.Constraint` and other `Matter.Composite`.
	* A `Matter.World` has a few additional properties including `gravity` and `bounds`.
	* It is important to use the functions in the `Matter.Composite` module to modify the world composite, rather than directly modifying its properties.
	* There are also a few methods here that alias those in `Matter.Composite` for easier readability.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class World
	* @extends Composite
	*/
	
	var World = {};
	
	module.exports = World;
	
	var Composite = _dereq_('./Composite');
	var Constraint = _dereq_('../constraint/Constraint');
	var Common = _dereq_('../core/Common');
	
	(function() {
	
	    /**
	     * Creates a new world composite. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @constructor
	     * @param {} options
	     * @return {world} A new world
	     */
	    World.create = function(options) {
	        var composite = Composite.create();
	
	        var defaults = {
	            label: 'World',
	            gravity: {
	                x: 0,
	                y: 1,
	                scale: 0.001
	            },
	            bounds: { 
	                min: { x: -Infinity, y: -Infinity }, 
	                max: { x: Infinity, y: Infinity } 
	            }
	        };
	        
	        return Common.extend(composite, defaults, options);
	    };
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * The gravity to apply on the world.
	     *
	     * @property gravity
	     * @type object
	     */
	
	    /**
	     * The gravity x component.
	     *
	     * @property gravity.x
	     * @type object
	     * @default 0
	     */
	
	    /**
	     * The gravity y component.
	     *
	     * @property gravity.y
	     * @type object
	     * @default 1
	     */
	
	    /**
	     * The gravity scale factor.
	     *
	     * @property gravity.scale
	     * @type object
	     * @default 0.001
	     */
	
	    /**
	     * A `Bounds` object that defines the world bounds for collision detection.
	     *
	     * @property bounds
	     * @type bounds
	     * @default { min: { x: -Infinity, y: -Infinity }, max: { x: Infinity, y: Infinity } }
	     */
	
	    // World is a Composite body
	    // see src/module/Outro.js for these aliases:
	    
	    /**
	     * An alias for Composite.add
	     * @method add
	     * @param {world} world
	     * @param {} object
	     * @return {composite} The original world with the objects added
	     */
	
	    /**
	     * An alias for Composite.remove
	     * @method remove
	     * @param {world} world
	     * @param {} object
	     * @param {boolean} [deep=false]
	     * @return {composite} The original world with the objects removed
	     */
	
	    /**
	     * An alias for Composite.clear
	     * @method clear
	     * @param {world} world
	     * @param {boolean} keepStatic
	     */
	
	    /**
	     * An alias for Composite.addComposite
	     * @method addComposite
	     * @param {world} world
	     * @param {composite} composite
	     * @return {world} The original world with the objects from composite added
	     */
	    
	     /**
	      * An alias for Composite.addBody
	      * @method addBody
	      * @param {world} world
	      * @param {body} body
	      * @return {world} The original world with the body added
	      */
	
	     /**
	      * An alias for Composite.addConstraint
	      * @method addConstraint
	      * @param {world} world
	      * @param {constraint} constraint
	      * @return {world} The original world with the constraint added
	      */
	
	})();
	
	},{"../constraint/Constraint":12,"../core/Common":14,"./Composite":2}],4:[function(_dereq_,module,exports){
	/**
	* The `Matter.Contact` module contains methods for creating and manipulating collision contacts.
	*
	* @class Contact
	*/
	
	var Contact = {};
	
	module.exports = Contact;
	
	(function() {
	
	    /**
	     * Creates a new contact.
	     * @method create
	     * @param {vertex} vertex
	     * @return {contact} A new contact
	     */
	    Contact.create = function(vertex) {
	        return {
	            id: Contact.id(vertex),
	            vertex: vertex,
	            normalImpulse: 0,
	            tangentImpulse: 0
	        };
	    };
	    
	    /**
	     * Generates a contact id.
	     * @method id
	     * @param {vertex} vertex
	     * @return {string} Unique contactID
	     */
	    Contact.id = function(vertex) {
	        return vertex.body.id + '_' + vertex.index;
	    };
	
	})();
	
	},{}],5:[function(_dereq_,module,exports){
	/**
	* The `Matter.Detector` module contains methods for detecting collisions given a set of pairs.
	*
	* @class Detector
	*/
	
	// TODO: speculative contacts
	
	var Detector = {};
	
	module.exports = Detector;
	
	var SAT = _dereq_('./SAT');
	var Pair = _dereq_('./Pair');
	var Bounds = _dereq_('../geometry/Bounds');
	
	(function() {
	
	    /**
	     * Finds all collisions given a list of pairs.
	     * @method collisions
	     * @param {pair[]} broadphasePairs
	     * @param {engine} engine
	     * @return {array} collisions
	     */
	    Detector.collisions = function(broadphasePairs, engine) {
	        var collisions = [],
	            pairsTable = engine.pairs.table;
	
	        
	        for (var i = 0; i < broadphasePairs.length; i++) {
	            var bodyA = broadphasePairs[i][0], 
	                bodyB = broadphasePairs[i][1];
	
	            if ((bodyA.isStatic || bodyA.isSleeping) && (bodyB.isStatic || bodyB.isSleeping))
	                continue;
	            
	            if (!Detector.canCollide(bodyA.collisionFilter, bodyB.collisionFilter))
	                continue;
	
	
	            // mid phase
	            if (Bounds.overlaps(bodyA.bounds, bodyB.bounds)) {
	                for (var j = bodyA.parts.length > 1 ? 1 : 0; j < bodyA.parts.length; j++) {
	                    var partA = bodyA.parts[j];
	
	                    for (var k = bodyB.parts.length > 1 ? 1 : 0; k < bodyB.parts.length; k++) {
	                        var partB = bodyB.parts[k];
	
	                        if ((partA === bodyA && partB === bodyB) || Bounds.overlaps(partA.bounds, partB.bounds)) {
	                            // find a previous collision we could reuse
	                            var pairId = Pair.id(partA, partB),
	                                pair = pairsTable[pairId],
	                                previousCollision;
	
	                            if (pair && pair.isActive) {
	                                previousCollision = pair.collision;
	                            } else {
	                                previousCollision = null;
	                            }
	
	                            // narrow phase
	                            var collision = SAT.collides(partA, partB, previousCollision);
	
	
	                            if (collision.collided) {
	                                collisions.push(collision);
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	        return collisions;
	    };
	
	    /**
	     * Returns `true` if both supplied collision filters will allow a collision to occur.
	     * See `body.collisionFilter` for more information.
	     * @method canCollide
	     * @param {} filterA
	     * @param {} filterB
	     * @return {bool} `true` if collision can occur
	     */
	    Detector.canCollide = function(filterA, filterB) {
	        if (filterA.group === filterB.group && filterA.group !== 0)
	            return filterA.group > 0;
	
	        return (filterA.mask & filterB.category) !== 0 && (filterB.mask & filterA.category) !== 0;
	    };
	
	})();
	
	},{"../geometry/Bounds":26,"./Pair":7,"./SAT":11}],6:[function(_dereq_,module,exports){
	/**
	* The `Matter.Grid` module contains methods for creating and manipulating collision broadphase grid structures.
	*
	* @class Grid
	*/
	
	var Grid = {};
	
	module.exports = Grid;
	
	var Pair = _dereq_('./Pair');
	var Detector = _dereq_('./Detector');
	var Common = _dereq_('../core/Common');
	
	(function() {
	
	    /**
	     * Creates a new grid.
	     * @method create
	     * @param {} options
	     * @return {grid} A new grid
	     */
	    Grid.create = function(options) {
	        var defaults = {
	            controller: Grid,
	            detector: Detector.collisions,
	            buckets: {},
	            pairs: {},
	            pairsList: [],
	            bucketWidth: 48,
	            bucketHeight: 48
	        };
	
	        return Common.extend(defaults, options);
	    };
	
	    /**
	     * The width of a single grid bucket.
	     *
	     * @property bucketWidth
	     * @type number
	     * @default 48
	     */
	
	    /**
	     * The height of a single grid bucket.
	     *
	     * @property bucketHeight
	     * @type number
	     * @default 48
	     */
	
	    /**
	     * Updates the grid.
	     * @method update
	     * @param {grid} grid
	     * @param {body[]} bodies
	     * @param {engine} engine
	     * @param {boolean} forceUpdate
	     */
	    Grid.update = function(grid, bodies, engine, forceUpdate) {
	        var i, col, row,
	            world = engine.world,
	            buckets = grid.buckets,
	            bucket,
	            bucketId,
	            gridChanged = false;
	
	
	        for (i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (body.isSleeping && !forceUpdate)
	                continue;
	
	            // don't update out of world bodies
	            if (body.bounds.max.x < world.bounds.min.x || body.bounds.min.x > world.bounds.max.x
	                || body.bounds.max.y < world.bounds.min.y || body.bounds.min.y > world.bounds.max.y)
	                continue;
	
	            var newRegion = Grid._getRegion(grid, body);
	
	            // if the body has changed grid region
	            if (!body.region || newRegion.id !== body.region.id || forceUpdate) {
	
	
	                if (!body.region || forceUpdate)
	                    body.region = newRegion;
	
	                var union = Grid._regionUnion(newRegion, body.region);
	
	                // update grid buckets affected by region change
	                // iterate over the union of both regions
	                for (col = union.startCol; col <= union.endCol; col++) {
	                    for (row = union.startRow; row <= union.endRow; row++) {
	                        bucketId = Grid._getBucketId(col, row);
	                        bucket = buckets[bucketId];
	
	                        var isInsideNewRegion = (col >= newRegion.startCol && col <= newRegion.endCol
	                                                && row >= newRegion.startRow && row <= newRegion.endRow);
	
	                        var isInsideOldRegion = (col >= body.region.startCol && col <= body.region.endCol
	                                                && row >= body.region.startRow && row <= body.region.endRow);
	
	                        // remove from old region buckets
	                        if (!isInsideNewRegion && isInsideOldRegion) {
	                            if (isInsideOldRegion) {
	                                if (bucket)
	                                    Grid._bucketRemoveBody(grid, bucket, body);
	                            }
	                        }
	
	                        // add to new region buckets
	                        if (body.region === newRegion || (isInsideNewRegion && !isInsideOldRegion) || forceUpdate) {
	                            if (!bucket)
	                                bucket = Grid._createBucket(buckets, bucketId);
	                            Grid._bucketAddBody(grid, bucket, body);
	                        }
	                    }
	                }
	
	                // set the new region
	                body.region = newRegion;
	
	                // flag changes so we can update pairs
	                gridChanged = true;
	            }
	        }
	
	        // update pairs list only if pairs changed (i.e. a body changed region)
	        if (gridChanged)
	            grid.pairsList = Grid._createActivePairsList(grid);
	    };
	
	    /**
	     * Clears the grid.
	     * @method clear
	     * @param {grid} grid
	     */
	    Grid.clear = function(grid) {
	        grid.buckets = {};
	        grid.pairs = {};
	        grid.pairsList = [];
	    };
	
	    /**
	     * Finds the union of two regions.
	     * @method _regionUnion
	     * @private
	     * @param {} regionA
	     * @param {} regionB
	     * @return {} region
	     */
	    Grid._regionUnion = function(regionA, regionB) {
	        var startCol = Math.min(regionA.startCol, regionB.startCol),
	            endCol = Math.max(regionA.endCol, regionB.endCol),
	            startRow = Math.min(regionA.startRow, regionB.startRow),
	            endRow = Math.max(regionA.endRow, regionB.endRow);
	
	        return Grid._createRegion(startCol, endCol, startRow, endRow);
	    };
	
	    /**
	     * Gets the region a given body falls in for a given grid.
	     * @method _getRegion
	     * @private
	     * @param {} grid
	     * @param {} body
	     * @return {} region
	     */
	    Grid._getRegion = function(grid, body) {
	        var bounds = body.bounds,
	            startCol = Math.floor(bounds.min.x / grid.bucketWidth),
	            endCol = Math.floor(bounds.max.x / grid.bucketWidth),
	            startRow = Math.floor(bounds.min.y / grid.bucketHeight),
	            endRow = Math.floor(bounds.max.y / grid.bucketHeight);
	
	        return Grid._createRegion(startCol, endCol, startRow, endRow);
	    };
	
	    /**
	     * Creates a region.
	     * @method _createRegion
	     * @private
	     * @param {} startCol
	     * @param {} endCol
	     * @param {} startRow
	     * @param {} endRow
	     * @return {} region
	     */
	    Grid._createRegion = function(startCol, endCol, startRow, endRow) {
	        return { 
	            id: startCol + ',' + endCol + ',' + startRow + ',' + endRow,
	            startCol: startCol, 
	            endCol: endCol, 
	            startRow: startRow, 
	            endRow: endRow 
	        };
	    };
	
	    /**
	     * Gets the bucket id at the given position.
	     * @method _getBucketId
	     * @private
	     * @param {} column
	     * @param {} row
	     * @return {string} bucket id
	     */
	    Grid._getBucketId = function(column, row) {
	        return 'C' + column + 'R' + row;
	    };
	
	    /**
	     * Creates a bucket.
	     * @method _createBucket
	     * @private
	     * @param {} buckets
	     * @param {} bucketId
	     * @return {} bucket
	     */
	    Grid._createBucket = function(buckets, bucketId) {
	        var bucket = buckets[bucketId] = [];
	        return bucket;
	    };
	
	    /**
	     * Adds a body to a bucket.
	     * @method _bucketAddBody
	     * @private
	     * @param {} grid
	     * @param {} bucket
	     * @param {} body
	     */
	    Grid._bucketAddBody = function(grid, bucket, body) {
	        // add new pairs
	        for (var i = 0; i < bucket.length; i++) {
	            var bodyB = bucket[i];
	
	            if (body.id === bodyB.id || (body.isStatic && bodyB.isStatic))
	                continue;
	
	            // keep track of the number of buckets the pair exists in
	            // important for Grid.update to work
	            var pairId = Pair.id(body, bodyB),
	                pair = grid.pairs[pairId];
	
	            if (pair) {
	                pair[2] += 1;
	            } else {
	                grid.pairs[pairId] = [body, bodyB, 1];
	            }
	        }
	
	        // add to bodies (after pairs, otherwise pairs with self)
	        bucket.push(body);
	    };
	
	    /**
	     * Removes a body from a bucket.
	     * @method _bucketRemoveBody
	     * @private
	     * @param {} grid
	     * @param {} bucket
	     * @param {} body
	     */
	    Grid._bucketRemoveBody = function(grid, bucket, body) {
	        // remove from bucket
	        bucket.splice(Common.indexOf(bucket, body), 1);
	
	        // update pair counts
	        for (var i = 0; i < bucket.length; i++) {
	            // keep track of the number of buckets the pair exists in
	            // important for _createActivePairsList to work
	            var bodyB = bucket[i],
	                pairId = Pair.id(body, bodyB),
	                pair = grid.pairs[pairId];
	
	            if (pair)
	                pair[2] -= 1;
	        }
	    };
	
	    /**
	     * Generates a list of the active pairs in the grid.
	     * @method _createActivePairsList
	     * @private
	     * @param {} grid
	     * @return [] pairs
	     */
	    Grid._createActivePairsList = function(grid) {
	        var pairKeys,
	            pair,
	            pairs = [];
	
	        // grid.pairs is used as a hashmap
	        pairKeys = Common.keys(grid.pairs);
	
	        // iterate over grid.pairs
	        for (var k = 0; k < pairKeys.length; k++) {
	            pair = grid.pairs[pairKeys[k]];
	
	            // if pair exists in at least one bucket
	            // it is a pair that needs further collision testing so push it
	            if (pair[2] > 0) {
	                pairs.push(pair);
	            } else {
	                delete grid.pairs[pairKeys[k]];
	            }
	        }
	
	        return pairs;
	    };
	    
	})();
	
	},{"../core/Common":14,"./Detector":5,"./Pair":7}],7:[function(_dereq_,module,exports){
	/**
	* The `Matter.Pair` module contains methods for creating and manipulating collision pairs.
	*
	* @class Pair
	*/
	
	var Pair = {};
	
	module.exports = Pair;
	
	var Contact = _dereq_('./Contact');
	
	(function() {
	    
	    /**
	     * Creates a pair.
	     * @method create
	     * @param {collision} collision
	     * @param {number} timestamp
	     * @return {pair} A new pair
	     */
	    Pair.create = function(collision, timestamp) {
	        var bodyA = collision.bodyA,
	            bodyB = collision.bodyB,
	            parentA = collision.parentA,
	            parentB = collision.parentB;
	
	        var pair = {
	            id: Pair.id(bodyA, bodyB),
	            bodyA: bodyA,
	            bodyB: bodyB,
	            contacts: {},
	            activeContacts: [],
	            separation: 0,
	            isActive: true,
	            isSensor: bodyA.isSensor || bodyB.isSensor,
	            timeCreated: timestamp,
	            timeUpdated: timestamp,
	            inverseMass: parentA.inverseMass + parentB.inverseMass,
	            friction: Math.min(parentA.friction, parentB.friction),
	            frictionStatic: Math.max(parentA.frictionStatic, parentB.frictionStatic),
	            restitution: Math.max(parentA.restitution, parentB.restitution),
	            slop: Math.max(parentA.slop, parentB.slop)
	        };
	
	        Pair.update(pair, collision, timestamp);
	
	        return pair;
	    };
	
	    /**
	     * Updates a pair given a collision.
	     * @method update
	     * @param {pair} pair
	     * @param {collision} collision
	     * @param {number} timestamp
	     */
	    Pair.update = function(pair, collision, timestamp) {
	        var contacts = pair.contacts,
	            supports = collision.supports,
	            activeContacts = pair.activeContacts,
	            parentA = collision.parentA,
	            parentB = collision.parentB;
	        
	        pair.collision = collision;
	        pair.inverseMass = parentA.inverseMass + parentB.inverseMass;
	        pair.friction = Math.min(parentA.friction, parentB.friction);
	        pair.frictionStatic = Math.max(parentA.frictionStatic, parentB.frictionStatic);
	        pair.restitution = Math.max(parentA.restitution, parentB.restitution);
	        pair.slop = Math.max(parentA.slop, parentB.slop);
	        activeContacts.length = 0;
	        
	        if (collision.collided) {
	            for (var i = 0; i < supports.length; i++) {
	                var support = supports[i],
	                    contactId = Contact.id(support),
	                    contact = contacts[contactId];
	
	                if (contact) {
	                    activeContacts.push(contact);
	                } else {
	                    activeContacts.push(contacts[contactId] = Contact.create(support));
	                }
	            }
	
	            pair.separation = collision.depth;
	            Pair.setActive(pair, true, timestamp);
	        } else {
	            if (pair.isActive === true)
	                Pair.setActive(pair, false, timestamp);
	        }
	    };
	    
	    /**
	     * Set a pair as active or inactive.
	     * @method setActive
	     * @param {pair} pair
	     * @param {bool} isActive
	     * @param {number} timestamp
	     */
	    Pair.setActive = function(pair, isActive, timestamp) {
	        if (isActive) {
	            pair.isActive = true;
	            pair.timeUpdated = timestamp;
	        } else {
	            pair.isActive = false;
	            pair.activeContacts.length = 0;
	        }
	    };
	
	    /**
	     * Get the id for the given pair.
	     * @method id
	     * @param {body} bodyA
	     * @param {body} bodyB
	     * @return {string} Unique pairId
	     */
	    Pair.id = function(bodyA, bodyB) {
	        if (bodyA.id < bodyB.id) {
	            return 'A' + bodyA.id + 'B' + bodyB.id;
	        } else {
	            return 'A' + bodyB.id + 'B' + bodyA.id;
	        }
	    };
	
	})();
	
	},{"./Contact":4}],8:[function(_dereq_,module,exports){
	/**
	* The `Matter.Pairs` module contains methods for creating and manipulating collision pair sets.
	*
	* @class Pairs
	*/
	
	var Pairs = {};
	
	module.exports = Pairs;
	
	var Pair = _dereq_('./Pair');
	var Common = _dereq_('../core/Common');
	
	(function() {
	    
	    Pairs._pairMaxIdleLife = 1000;
	
	    /**
	     * Creates a new pairs structure.
	     * @method create
	     * @param {object} options
	     * @return {pairs} A new pairs structure
	     */
	    Pairs.create = function(options) {
	        return Common.extend({ 
	            table: {},
	            list: [],
	            collisionStart: [],
	            collisionActive: [],
	            collisionEnd: []
	        }, options);
	    };
	
	    /**
	     * Updates pairs given a list of collisions.
	     * @method update
	     * @param {object} pairs
	     * @param {collision[]} collisions
	     * @param {number} timestamp
	     */
	    Pairs.update = function(pairs, collisions, timestamp) {
	        var pairsList = pairs.list,
	            pairsTable = pairs.table,
	            collisionStart = pairs.collisionStart,
	            collisionEnd = pairs.collisionEnd,
	            collisionActive = pairs.collisionActive,
	            activePairIds = [],
	            collision,
	            pairId,
	            pair,
	            i;
	
	        // clear collision state arrays, but maintain old reference
	        collisionStart.length = 0;
	        collisionEnd.length = 0;
	        collisionActive.length = 0;
	
	        for (i = 0; i < collisions.length; i++) {
	            collision = collisions[i];
	
	            if (collision.collided) {
	                pairId = Pair.id(collision.bodyA, collision.bodyB);
	                activePairIds.push(pairId);
	
	                pair = pairsTable[pairId];
	                
	                if (pair) {
	                    // pair already exists (but may or may not be active)
	                    if (pair.isActive) {
	                        // pair exists and is active
	                        collisionActive.push(pair);
	                    } else {
	                        // pair exists but was inactive, so a collision has just started again
	                        collisionStart.push(pair);
	                    }
	
	                    // update the pair
	                    Pair.update(pair, collision, timestamp);
	                } else {
	                    // pair did not exist, create a new pair
	                    pair = Pair.create(collision, timestamp);
	                    pairsTable[pairId] = pair;
	
	                    // push the new pair
	                    collisionStart.push(pair);
	                    pairsList.push(pair);
	                }
	            }
	        }
	
	        // deactivate previously active pairs that are now inactive
	        for (i = 0; i < pairsList.length; i++) {
	            pair = pairsList[i];
	            if (pair.isActive && Common.indexOf(activePairIds, pair.id) === -1) {
	                Pair.setActive(pair, false, timestamp);
	                collisionEnd.push(pair);
	            }
	        }
	    };
	    
	    /**
	     * Finds and removes pairs that have been inactive for a set amount of time.
	     * @method removeOld
	     * @param {object} pairs
	     * @param {number} timestamp
	     */
	    Pairs.removeOld = function(pairs, timestamp) {
	        var pairsList = pairs.list,
	            pairsTable = pairs.table,
	            indexesToRemove = [],
	            pair,
	            collision,
	            pairIndex,
	            i;
	
	        for (i = 0; i < pairsList.length; i++) {
	            pair = pairsList[i];
	            collision = pair.collision;
	            
	            // never remove sleeping pairs
	            if (collision.bodyA.isSleeping || collision.bodyB.isSleeping) {
	                pair.timeUpdated = timestamp;
	                continue;
	            }
	
	            // if pair is inactive for too long, mark it to be removed
	            if (timestamp - pair.timeUpdated > Pairs._pairMaxIdleLife) {
	                indexesToRemove.push(i);
	            }
	        }
	
	        // remove marked pairs
	        for (i = 0; i < indexesToRemove.length; i++) {
	            pairIndex = indexesToRemove[i] - i;
	            pair = pairsList[pairIndex];
	            delete pairsTable[pair.id];
	            pairsList.splice(pairIndex, 1);
	        }
	    };
	
	    /**
	     * Clears the given pairs structure.
	     * @method clear
	     * @param {pairs} pairs
	     * @return {pairs} pairs
	     */
	    Pairs.clear = function(pairs) {
	        pairs.table = {};
	        pairs.list.length = 0;
	        pairs.collisionStart.length = 0;
	        pairs.collisionActive.length = 0;
	        pairs.collisionEnd.length = 0;
	        return pairs;
	    };
	
	})();
	
	},{"../core/Common":14,"./Pair":7}],9:[function(_dereq_,module,exports){
	/**
	* The `Matter.Query` module contains methods for performing collision queries.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Query
	*/
	
	var Query = {};
	
	module.exports = Query;
	
	var Vector = _dereq_('../geometry/Vector');
	var SAT = _dereq_('./SAT');
	var Bounds = _dereq_('../geometry/Bounds');
	var Bodies = _dereq_('../factory/Bodies');
	var Vertices = _dereq_('../geometry/Vertices');
	
	(function() {
	
	    /**
	     * Returns a list of collisions between `body` and `bodies`.
	     * @method collides
	     * @param {body} body
	     * @param {body[]} bodies
	     * @return {object[]} Collisions
	     */
	    Query.collides = function(body, bodies) {
	        var collisions = [];
	
	        for (var i = 0; i < bodies.length; i++) {
	            var bodyA = bodies[i];
	            
	            if (Bounds.overlaps(bodyA.bounds, body.bounds)) {
	                for (var j = bodyA.parts.length === 1 ? 0 : 1; j < bodyA.parts.length; j++) {
	                    var part = bodyA.parts[j];
	
	                    if (Bounds.overlaps(part.bounds, body.bounds)) {
	                        var collision = SAT.collides(part, body);
	
	                        if (collision.collided) {
	                            collisions.push(collision);
	                            break;
	                        }
	                    }
	                }
	            }
	        }
	
	        return collisions;
	    };
	
	    /**
	     * Casts a ray segment against a set of bodies and returns all collisions, ray width is optional. Intersection points are not provided.
	     * @method ray
	     * @param {body[]} bodies
	     * @param {vector} startPoint
	     * @param {vector} endPoint
	     * @param {number} [rayWidth]
	     * @return {object[]} Collisions
	     */
	    Query.ray = function(bodies, startPoint, endPoint, rayWidth) {
	        rayWidth = rayWidth || 1e-100;
	
	        var rayAngle = Vector.angle(startPoint, endPoint),
	            rayLength = Vector.magnitude(Vector.sub(startPoint, endPoint)),
	            rayX = (endPoint.x + startPoint.x) * 0.5,
	            rayY = (endPoint.y + startPoint.y) * 0.5,
	            ray = Bodies.rectangle(rayX, rayY, rayLength, rayWidth, { angle: rayAngle }),
	            collisions = Query.collides(ray, bodies);
	
	        for (var i = 0; i < collisions.length; i += 1) {
	            var collision = collisions[i];
	            collision.body = collision.bodyB = collision.bodyA;            
	        }
	
	        return collisions;
	    };
	
	    /**
	     * Returns all bodies whose bounds are inside (or outside if set) the given set of bounds, from the given set of bodies.
	     * @method region
	     * @param {body[]} bodies
	     * @param {bounds} bounds
	     * @param {bool} [outside=false]
	     * @return {body[]} The bodies matching the query
	     */
	    Query.region = function(bodies, bounds, outside) {
	        var result = [];
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                overlaps = Bounds.overlaps(body.bounds, bounds);
	            if ((overlaps && !outside) || (!overlaps && outside))
	                result.push(body);
	        }
	
	        return result;
	    };
	
	    /**
	     * Returns all bodies whose vertices contain the given point, from the given set of bodies.
	     * @method point
	     * @param {body[]} bodies
	     * @param {vector} point
	     * @return {body[]} The bodies matching the query
	     */
	    Query.point = function(bodies, point) {
	        var result = [];
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	            
	            if (Bounds.contains(body.bounds, point)) {
	                for (var j = body.parts.length === 1 ? 0 : 1; j < body.parts.length; j++) {
	                    var part = body.parts[j];
	
	                    if (Bounds.contains(part.bounds, point)
	                        && Vertices.contains(part.vertices, point)) {
	                        result.push(body);
	                        break;
	                    }
	                }
	            }
	        }
	
	        return result;
	    };
	
	})();
	
	},{"../factory/Bodies":23,"../geometry/Bounds":26,"../geometry/Vector":28,"../geometry/Vertices":29,"./SAT":11}],10:[function(_dereq_,module,exports){
	/**
	* The `Matter.Resolver` module contains methods for resolving collision pairs.
	*
	* @class Resolver
	*/
	
	var Resolver = {};
	
	module.exports = Resolver;
	
	var Vertices = _dereq_('../geometry/Vertices');
	var Vector = _dereq_('../geometry/Vector');
	var Common = _dereq_('../core/Common');
	var Bounds = _dereq_('../geometry/Bounds');
	
	(function() {
	
	    Resolver._restingThresh = 4;
	    Resolver._restingThreshTangent = 6;
	    Resolver._positionDampen = 0.9;
	    Resolver._positionWarming = 0.8;
	    Resolver._frictionNormalMultiplier = 5;
	
	    /**
	     * Prepare pairs for position solving.
	     * @method preSolvePosition
	     * @param {pair[]} pairs
	     */
	    Resolver.preSolvePosition = function(pairs) {
	        var i,
	            pair,
	            activeCount;
	
	        // find total contacts on each body
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	            
	            if (!pair.isActive)
	                continue;
	            
	            activeCount = pair.activeContacts.length;
	            pair.collision.parentA.totalContacts += activeCount;
	            pair.collision.parentB.totalContacts += activeCount;
	        }
	    };
	
	    /**
	     * Find a solution for pair positions.
	     * @method solvePosition
	     * @param {pair[]} pairs
	     * @param {number} timeScale
	     */
	    Resolver.solvePosition = function(pairs, timeScale) {
	        var i,
	            pair,
	            collision,
	            bodyA,
	            bodyB,
	            normal,
	            bodyBtoA,
	            contactShare,
	            positionImpulse,
	            contactCount = {},
	            tempA = Vector._temp[0],
	            tempB = Vector._temp[1],
	            tempC = Vector._temp[2],
	            tempD = Vector._temp[3];
	
	        // find impulses required to resolve penetration
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	            
	            if (!pair.isActive || pair.isSensor)
	                continue;
	
	            collision = pair.collision;
	            bodyA = collision.parentA;
	            bodyB = collision.parentB;
	            normal = collision.normal;
	
	            // get current separation between body edges involved in collision
	            bodyBtoA = Vector.sub(Vector.add(bodyB.positionImpulse, bodyB.position, tempA), 
	                                    Vector.add(bodyA.positionImpulse, 
	                                        Vector.sub(bodyB.position, collision.penetration, tempB), tempC), tempD);
	
	            pair.separation = Vector.dot(normal, bodyBtoA);
	        }
	        
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	
	            if (!pair.isActive || pair.isSensor)
	                continue;
	            
	            collision = pair.collision;
	            bodyA = collision.parentA;
	            bodyB = collision.parentB;
	            normal = collision.normal;
	            positionImpulse = (pair.separation - pair.slop) * timeScale;
	
	            if (bodyA.isStatic || bodyB.isStatic)
	                positionImpulse *= 2;
	            
	            if (!(bodyA.isStatic || bodyA.isSleeping)) {
	                contactShare = Resolver._positionDampen / bodyA.totalContacts;
	                bodyA.positionImpulse.x += normal.x * positionImpulse * contactShare;
	                bodyA.positionImpulse.y += normal.y * positionImpulse * contactShare;
	            }
	
	            if (!(bodyB.isStatic || bodyB.isSleeping)) {
	                contactShare = Resolver._positionDampen / bodyB.totalContacts;
	                bodyB.positionImpulse.x -= normal.x * positionImpulse * contactShare;
	                bodyB.positionImpulse.y -= normal.y * positionImpulse * contactShare;
	            }
	        }
	    };
	
	    /**
	     * Apply position resolution.
	     * @method postSolvePosition
	     * @param {body[]} bodies
	     */
	    Resolver.postSolvePosition = function(bodies) {
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            // reset contact count
	            body.totalContacts = 0;
	
	            if (body.positionImpulse.x !== 0 || body.positionImpulse.y !== 0) {
	                // update body geometry
	                for (var j = 0; j < body.parts.length; j++) {
	                    var part = body.parts[j];
	                    Vertices.translate(part.vertices, body.positionImpulse);
	                    Bounds.update(part.bounds, part.vertices, body.velocity);
	                    part.position.x += body.positionImpulse.x;
	                    part.position.y += body.positionImpulse.y;
	                }
	
	                // move the body without changing velocity
	                body.positionPrev.x += body.positionImpulse.x;
	                body.positionPrev.y += body.positionImpulse.y;
	
	                if (Vector.dot(body.positionImpulse, body.velocity) < 0) {
	                    // reset cached impulse if the body has velocity along it
	                    body.positionImpulse.x = 0;
	                    body.positionImpulse.y = 0;
	                } else {
	                    // warm the next iteration
	                    body.positionImpulse.x *= Resolver._positionWarming;
	                    body.positionImpulse.y *= Resolver._positionWarming;
	                }
	            }
	        }
	    };
	
	    /**
	     * Prepare pairs for velocity solving.
	     * @method preSolveVelocity
	     * @param {pair[]} pairs
	     */
	    Resolver.preSolveVelocity = function(pairs) {
	        var i,
	            j,
	            pair,
	            contacts,
	            collision,
	            bodyA,
	            bodyB,
	            normal,
	            tangent,
	            contact,
	            contactVertex,
	            normalImpulse,
	            tangentImpulse,
	            offset,
	            impulse = Vector._temp[0],
	            tempA = Vector._temp[1];
	        
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	            
	            if (!pair.isActive || pair.isSensor)
	                continue;
	            
	            contacts = pair.activeContacts;
	            collision = pair.collision;
	            bodyA = collision.parentA;
	            bodyB = collision.parentB;
	            normal = collision.normal;
	            tangent = collision.tangent;
	
	            // resolve each contact
	            for (j = 0; j < contacts.length; j++) {
	                contact = contacts[j];
	                contactVertex = contact.vertex;
	                normalImpulse = contact.normalImpulse;
	                tangentImpulse = contact.tangentImpulse;
	
	                if (normalImpulse !== 0 || tangentImpulse !== 0) {
	                    // total impulse from contact
	                    impulse.x = (normal.x * normalImpulse) + (tangent.x * tangentImpulse);
	                    impulse.y = (normal.y * normalImpulse) + (tangent.y * tangentImpulse);
	                    
	                    // apply impulse from contact
	                    if (!(bodyA.isStatic || bodyA.isSleeping)) {
	                        offset = Vector.sub(contactVertex, bodyA.position, tempA);
	                        bodyA.positionPrev.x += impulse.x * bodyA.inverseMass;
	                        bodyA.positionPrev.y += impulse.y * bodyA.inverseMass;
	                        bodyA.anglePrev += Vector.cross(offset, impulse) * bodyA.inverseInertia;
	                    }
	
	                    if (!(bodyB.isStatic || bodyB.isSleeping)) {
	                        offset = Vector.sub(contactVertex, bodyB.position, tempA);
	                        bodyB.positionPrev.x -= impulse.x * bodyB.inverseMass;
	                        bodyB.positionPrev.y -= impulse.y * bodyB.inverseMass;
	                        bodyB.anglePrev -= Vector.cross(offset, impulse) * bodyB.inverseInertia;
	                    }
	                }
	            }
	        }
	    };
	
	    /**
	     * Find a solution for pair velocities.
	     * @method solveVelocity
	     * @param {pair[]} pairs
	     * @param {number} timeScale
	     */
	    Resolver.solveVelocity = function(pairs, timeScale) {
	        var timeScaleSquared = timeScale * timeScale,
	            impulse = Vector._temp[0],
	            tempA = Vector._temp[1],
	            tempB = Vector._temp[2],
	            tempC = Vector._temp[3],
	            tempD = Vector._temp[4],
	            tempE = Vector._temp[5];
	        
	        for (var i = 0; i < pairs.length; i++) {
	            var pair = pairs[i];
	            
	            if (!pair.isActive || pair.isSensor)
	                continue;
	            
	            var collision = pair.collision,
	                bodyA = collision.parentA,
	                bodyB = collision.parentB,
	                normal = collision.normal,
	                tangent = collision.tangent,
	                contacts = pair.activeContacts,
	                contactShare = 1 / contacts.length;
	
	            // update body velocities
	            bodyA.velocity.x = bodyA.position.x - bodyA.positionPrev.x;
	            bodyA.velocity.y = bodyA.position.y - bodyA.positionPrev.y;
	            bodyB.velocity.x = bodyB.position.x - bodyB.positionPrev.x;
	            bodyB.velocity.y = bodyB.position.y - bodyB.positionPrev.y;
	            bodyA.angularVelocity = bodyA.angle - bodyA.anglePrev;
	            bodyB.angularVelocity = bodyB.angle - bodyB.anglePrev;
	
	            // resolve each contact
	            for (var j = 0; j < contacts.length; j++) {
	                var contact = contacts[j],
	                    contactVertex = contact.vertex,
	                    offsetA = Vector.sub(contactVertex, bodyA.position, tempA),
	                    offsetB = Vector.sub(contactVertex, bodyB.position, tempB),
	                    velocityPointA = Vector.add(bodyA.velocity, Vector.mult(Vector.perp(offsetA), bodyA.angularVelocity), tempC),
	                    velocityPointB = Vector.add(bodyB.velocity, Vector.mult(Vector.perp(offsetB), bodyB.angularVelocity), tempD), 
	                    relativeVelocity = Vector.sub(velocityPointA, velocityPointB, tempE),
	                    normalVelocity = Vector.dot(normal, relativeVelocity);
	
	                var tangentVelocity = Vector.dot(tangent, relativeVelocity),
	                    tangentSpeed = Math.abs(tangentVelocity),
	                    tangentVelocityDirection = Common.sign(tangentVelocity);
	
	                // raw impulses
	                var normalImpulse = (1 + pair.restitution) * normalVelocity,
	                    normalForce = Common.clamp(pair.separation + normalVelocity, 0, 1) * Resolver._frictionNormalMultiplier;
	
	                // coulomb friction
	                var tangentImpulse = tangentVelocity,
	                    maxFriction = Infinity;
	
	                if (tangentSpeed > pair.friction * pair.frictionStatic * normalForce * timeScaleSquared) {
	                    maxFriction = tangentSpeed;
	                    tangentImpulse = Common.clamp(
	                        pair.friction * tangentVelocityDirection * timeScaleSquared,
	                        -maxFriction, maxFriction
	                    );
	                }
	
	                // modify impulses accounting for mass, inertia and offset
	                var oAcN = Vector.cross(offsetA, normal),
	                    oBcN = Vector.cross(offsetB, normal),
	                    share = contactShare / (bodyA.inverseMass + bodyB.inverseMass + bodyA.inverseInertia * oAcN * oAcN  + bodyB.inverseInertia * oBcN * oBcN);
	
	                normalImpulse *= share;
	                tangentImpulse *= share;
	
	                // handle high velocity and resting collisions separately
	                if (normalVelocity < 0 && normalVelocity * normalVelocity > Resolver._restingThresh * timeScaleSquared) {
	                    // high normal velocity so clear cached contact normal impulse
	                    contact.normalImpulse = 0;
	                } else {
	                    // solve resting collision constraints using Erin Catto's method (GDC08)
	                    // impulse constraint tends to 0
	                    var contactNormalImpulse = contact.normalImpulse;
	                    contact.normalImpulse = Math.min(contact.normalImpulse + normalImpulse, 0);
	                    normalImpulse = contact.normalImpulse - contactNormalImpulse;
	                }
	
	                // handle high velocity and resting collisions separately
	                if (tangentVelocity * tangentVelocity > Resolver._restingThreshTangent * timeScaleSquared) {
	                    // high tangent velocity so clear cached contact tangent impulse
	                    contact.tangentImpulse = 0;
	                } else {
	                    // solve resting collision constraints using Erin Catto's method (GDC08)
	                    // tangent impulse tends to -tangentSpeed or +tangentSpeed
	                    var contactTangentImpulse = contact.tangentImpulse;
	                    contact.tangentImpulse = Common.clamp(contact.tangentImpulse + tangentImpulse, -maxFriction, maxFriction);
	                    tangentImpulse = contact.tangentImpulse - contactTangentImpulse;
	                }
	
	                // total impulse from contact
	                impulse.x = (normal.x * normalImpulse) + (tangent.x * tangentImpulse);
	                impulse.y = (normal.y * normalImpulse) + (tangent.y * tangentImpulse);
	                
	                // apply impulse from contact
	                if (!(bodyA.isStatic || bodyA.isSleeping)) {
	                    bodyA.positionPrev.x += impulse.x * bodyA.inverseMass;
	                    bodyA.positionPrev.y += impulse.y * bodyA.inverseMass;
	                    bodyA.anglePrev += Vector.cross(offsetA, impulse) * bodyA.inverseInertia;
	                }
	
	                if (!(bodyB.isStatic || bodyB.isSleeping)) {
	                    bodyB.positionPrev.x -= impulse.x * bodyB.inverseMass;
	                    bodyB.positionPrev.y -= impulse.y * bodyB.inverseMass;
	                    bodyB.anglePrev -= Vector.cross(offsetB, impulse) * bodyB.inverseInertia;
	                }
	            }
	        }
	    };
	
	})();
	
	},{"../core/Common":14,"../geometry/Bounds":26,"../geometry/Vector":28,"../geometry/Vertices":29}],11:[function(_dereq_,module,exports){
	/**
	* The `Matter.SAT` module contains methods for detecting collisions using the Separating Axis Theorem.
	*
	* @class SAT
	*/
	
	// TODO: true circles and curves
	
	var SAT = {};
	
	module.exports = SAT;
	
	var Vertices = _dereq_('../geometry/Vertices');
	var Vector = _dereq_('../geometry/Vector');
	
	(function() {
	
	    /**
	     * Detect collision between two bodies using the Separating Axis Theorem.
	     * @method collides
	     * @param {body} bodyA
	     * @param {body} bodyB
	     * @param {collision} previousCollision
	     * @return {collision} collision
	     */
	    SAT.collides = function(bodyA, bodyB, previousCollision) {
	        var overlapAB,
	            overlapBA, 
	            minOverlap,
	            collision,
	            canReusePrevCol = false;
	
	        if (previousCollision) {
	            // estimate total motion
	            var parentA = bodyA.parent,
	                parentB = bodyB.parent,
	                motion = parentA.speed * parentA.speed + parentA.angularSpeed * parentA.angularSpeed
	                       + parentB.speed * parentB.speed + parentB.angularSpeed * parentB.angularSpeed;
	
	            // we may be able to (partially) reuse collision result 
	            // but only safe if collision was resting
	            canReusePrevCol = previousCollision && previousCollision.collided && motion < 0.2;
	
	            // reuse collision object
	            collision = previousCollision;
	        } else {
	            collision = { collided: false, bodyA: bodyA, bodyB: bodyB };
	        }
	
	        if (previousCollision && canReusePrevCol) {
	            // if we can reuse the collision result
	            // we only need to test the previously found axis
	            var axisBodyA = collision.axisBody,
	                axisBodyB = axisBodyA === bodyA ? bodyB : bodyA,
	                axes = [axisBodyA.axes[previousCollision.axisNumber]];
	
	            minOverlap = SAT._overlapAxes(axisBodyA.vertices, axisBodyB.vertices, axes);
	            collision.reused = true;
	
	            if (minOverlap.overlap <= 0) {
	                collision.collided = false;
	                return collision;
	            }
	        } else {
	            // if we can't reuse a result, perform a full SAT test
	
	            overlapAB = SAT._overlapAxes(bodyA.vertices, bodyB.vertices, bodyA.axes);
	
	            if (overlapAB.overlap <= 0) {
	                collision.collided = false;
	                return collision;
	            }
	
	            overlapBA = SAT._overlapAxes(bodyB.vertices, bodyA.vertices, bodyB.axes);
	
	            if (overlapBA.overlap <= 0) {
	                collision.collided = false;
	                return collision;
	            }
	
	            if (overlapAB.overlap < overlapBA.overlap) {
	                minOverlap = overlapAB;
	                collision.axisBody = bodyA;
	            } else {
	                minOverlap = overlapBA;
	                collision.axisBody = bodyB;
	            }
	
	            // important for reuse later
	            collision.axisNumber = minOverlap.axisNumber;
	        }
	
	        collision.bodyA = bodyA.id < bodyB.id ? bodyA : bodyB;
	        collision.bodyB = bodyA.id < bodyB.id ? bodyB : bodyA;
	        collision.collided = true;
	        collision.depth = minOverlap.overlap;
	        collision.parentA = collision.bodyA.parent;
	        collision.parentB = collision.bodyB.parent;
	        
	        bodyA = collision.bodyA;
	        bodyB = collision.bodyB;
	
	        // ensure normal is facing away from bodyA
	        if (Vector.dot(minOverlap.axis, Vector.sub(bodyB.position, bodyA.position)) < 0) {
	            collision.normal = {
	                x: minOverlap.axis.x,
	                y: minOverlap.axis.y
	            };
	        } else {
	            collision.normal = {
	                x: -minOverlap.axis.x,
	                y: -minOverlap.axis.y
	            };
	        }
	
	        collision.tangent = Vector.perp(collision.normal);
	
	        collision.penetration = collision.penetration || {};
	        collision.penetration.x = collision.normal.x * collision.depth;
	        collision.penetration.y = collision.normal.y * collision.depth; 
	
	        // find support points, there is always either exactly one or two
	        var verticesB = SAT._findSupports(bodyA, bodyB, collision.normal),
	            supports = [];
	
	        // find the supports from bodyB that are inside bodyA
	        if (Vertices.contains(bodyA.vertices, verticesB[0]))
	            supports.push(verticesB[0]);
	
	        if (Vertices.contains(bodyA.vertices, verticesB[1]))
	            supports.push(verticesB[1]);
	
	        // find the supports from bodyA that are inside bodyB
	        if (supports.length < 2) {
	            var verticesA = SAT._findSupports(bodyB, bodyA, Vector.neg(collision.normal));
	                
	            if (Vertices.contains(bodyB.vertices, verticesA[0]))
	                supports.push(verticesA[0]);
	
	            if (supports.length < 2 && Vertices.contains(bodyB.vertices, verticesA[1]))
	                supports.push(verticesA[1]);
	        }
	
	        // account for the edge case of overlapping but no vertex containment
	        if (supports.length < 1)
	            supports = [verticesB[0]];
	        
	        collision.supports = supports;
	
	        return collision;
	    };
	
	    /**
	     * Find the overlap between two sets of vertices.
	     * @method _overlapAxes
	     * @private
	     * @param {} verticesA
	     * @param {} verticesB
	     * @param {} axes
	     * @return result
	     */
	    SAT._overlapAxes = function(verticesA, verticesB, axes) {
	        var projectionA = Vector._temp[0], 
	            projectionB = Vector._temp[1],
	            result = { overlap: Number.MAX_VALUE },
	            overlap,
	            axis;
	
	        for (var i = 0; i < axes.length; i++) {
	            axis = axes[i];
	
	            SAT._projectToAxis(projectionA, verticesA, axis);
	            SAT._projectToAxis(projectionB, verticesB, axis);
	
	            overlap = Math.min(projectionA.max - projectionB.min, projectionB.max - projectionA.min);
	
	            if (overlap <= 0) {
	                result.overlap = overlap;
	                return result;
	            }
	
	            if (overlap < result.overlap) {
	                result.overlap = overlap;
	                result.axis = axis;
	                result.axisNumber = i;
	            }
	        }
	
	        return result;
	    };
	
	    /**
	     * Projects vertices on an axis and returns an interval.
	     * @method _projectToAxis
	     * @private
	     * @param {} projection
	     * @param {} vertices
	     * @param {} axis
	     */
	    SAT._projectToAxis = function(projection, vertices, axis) {
	        var min = Vector.dot(vertices[0], axis),
	            max = min;
	
	        for (var i = 1; i < vertices.length; i += 1) {
	            var dot = Vector.dot(vertices[i], axis);
	
	            if (dot > max) { 
	                max = dot; 
	            } else if (dot < min) { 
	                min = dot; 
	            }
	        }
	
	        projection.min = min;
	        projection.max = max;
	    };
	    
	    /**
	     * Finds supporting vertices given two bodies along a given direction using hill-climbing.
	     * @method _findSupports
	     * @private
	     * @param {} bodyA
	     * @param {} bodyB
	     * @param {} normal
	     * @return [vector]
	     */
	    SAT._findSupports = function(bodyA, bodyB, normal) {
	        var nearestDistance = Number.MAX_VALUE,
	            vertexToBody = Vector._temp[0],
	            vertices = bodyB.vertices,
	            bodyAPosition = bodyA.position,
	            distance,
	            vertex,
	            vertexA,
	            vertexB;
	
	        // find closest vertex on bodyB
	        for (var i = 0; i < vertices.length; i++) {
	            vertex = vertices[i];
	            vertexToBody.x = vertex.x - bodyAPosition.x;
	            vertexToBody.y = vertex.y - bodyAPosition.y;
	            distance = -Vector.dot(normal, vertexToBody);
	
	            if (distance < nearestDistance) {
	                nearestDistance = distance;
	                vertexA = vertex;
	            }
	        }
	
	        // find next closest vertex using the two connected to it
	        var prevIndex = vertexA.index - 1 >= 0 ? vertexA.index - 1 : vertices.length - 1;
	        vertex = vertices[prevIndex];
	        vertexToBody.x = vertex.x - bodyAPosition.x;
	        vertexToBody.y = vertex.y - bodyAPosition.y;
	        nearestDistance = -Vector.dot(normal, vertexToBody);
	        vertexB = vertex;
	
	        var nextIndex = (vertexA.index + 1) % vertices.length;
	        vertex = vertices[nextIndex];
	        vertexToBody.x = vertex.x - bodyAPosition.x;
	        vertexToBody.y = vertex.y - bodyAPosition.y;
	        distance = -Vector.dot(normal, vertexToBody);
	        if (distance < nearestDistance) {
	            vertexB = vertex;
	        }
	
	        return [vertexA, vertexB];
	    };
	
	})();
	
	},{"../geometry/Vector":28,"../geometry/Vertices":29}],12:[function(_dereq_,module,exports){
	/**
	* The `Matter.Constraint` module contains methods for creating and manipulating constraints.
	* Constraints are used for specifying that a fixed distance must be maintained between two bodies (or a body and a fixed world-space position).
	* The stiffness of constraints can be modified to create springs or elastic.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Constraint
	*/
	
	var Constraint = {};
	
	module.exports = Constraint;
	
	var Vertices = _dereq_('../geometry/Vertices');
	var Vector = _dereq_('../geometry/Vector');
	var Sleeping = _dereq_('../core/Sleeping');
	var Bounds = _dereq_('../geometry/Bounds');
	var Axes = _dereq_('../geometry/Axes');
	var Common = _dereq_('../core/Common');
	
	(function() {
	
	    Constraint._warming = 0.4;
	    Constraint._torqueDampen = 1;
	    Constraint._minLength = 0.000001;
	
	    /**
	     * Creates a new constraint.
	     * All properties have default values, and many are pre-calculated automatically based on other properties.
	     * To simulate a revolute constraint (or pin joint) set `length: 0` and a high `stiffness` value (e.g. `0.7` or above).
	     * If the constraint is unstable, try lowering the `stiffness` value and / or increasing `engine.constraintIterations`.
	     * For compound bodies, constraints must be applied to the parent body (not one of its parts).
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {} options
	     * @return {constraint} constraint
	     */
	    Constraint.create = function(options) {
	        var constraint = options;
	
	        // if bodies defined but no points, use body centre
	        if (constraint.bodyA && !constraint.pointA)
	            constraint.pointA = { x: 0, y: 0 };
	        if (constraint.bodyB && !constraint.pointB)
	            constraint.pointB = { x: 0, y: 0 };
	
	        // calculate static length using initial world space points
	        var initialPointA = constraint.bodyA ? Vector.add(constraint.bodyA.position, constraint.pointA) : constraint.pointA,
	            initialPointB = constraint.bodyB ? Vector.add(constraint.bodyB.position, constraint.pointB) : constraint.pointB,
	            length = Vector.magnitude(Vector.sub(initialPointA, initialPointB));
	    
	        constraint.length = typeof constraint.length !== 'undefined' ? constraint.length : length;
	
	        // option defaults
	        constraint.id = constraint.id || Common.nextId();
	        constraint.label = constraint.label || 'Constraint';
	        constraint.type = 'constraint';
	        constraint.stiffness = constraint.stiffness || (constraint.length > 0 ? 1 : 0.7);
	        constraint.damping = constraint.damping || 0;
	        constraint.angularStiffness = constraint.angularStiffness || 0;
	        constraint.angleA = constraint.bodyA ? constraint.bodyA.angle : constraint.angleA;
	        constraint.angleB = constraint.bodyB ? constraint.bodyB.angle : constraint.angleB;
	        constraint.plugin = {};
	
	        // render
	        var render = {
	            visible: true,
	            lineWidth: 2,
	            strokeStyle: '#ffffff',
	            type: 'line',
	            anchors: true
	        };
	
	        if (constraint.length === 0 && constraint.stiffness > 0.1) {
	            render.type = 'pin';
	            render.anchors = false;
	        } else if (constraint.stiffness < 0.9) {
	            render.type = 'spring';
	        }
	
	        constraint.render = Common.extend(render, constraint.render);
	
	        return constraint;
	    };
	
	    /**
	     * Prepares for solving by constraint warming.
	     * @private
	     * @method preSolveAll
	     * @param {body[]} bodies
	     */
	    Constraint.preSolveAll = function(bodies) {
	        for (var i = 0; i < bodies.length; i += 1) {
	            var body = bodies[i],
	                impulse = body.constraintImpulse;
	
	            if (body.isStatic || (impulse.x === 0 && impulse.y === 0 && impulse.angle === 0)) {
	                continue;
	            }
	
	            body.position.x += impulse.x;
	            body.position.y += impulse.y;
	            body.angle += impulse.angle;
	        }
	    };
	
	    /**
	     * Solves all constraints in a list of collisions.
	     * @private
	     * @method solveAll
	     * @param {constraint[]} constraints
	     * @param {number} timeScale
	     */
	    Constraint.solveAll = function(constraints, timeScale) {
	        // Solve fixed constraints first.
	        for (var i = 0; i < constraints.length; i += 1) {
	            var constraint = constraints[i],
	                fixedA = !constraint.bodyA || (constraint.bodyA && constraint.bodyA.isStatic),
	                fixedB = !constraint.bodyB || (constraint.bodyB && constraint.bodyB.isStatic);
	
	            if (fixedA || fixedB) {
	                Constraint.solve(constraints[i], timeScale);
	            }
	        }
	
	        // Solve free constraints last.
	        for (i = 0; i < constraints.length; i += 1) {
	            constraint = constraints[i];
	            fixedA = !constraint.bodyA || (constraint.bodyA && constraint.bodyA.isStatic);
	            fixedB = !constraint.bodyB || (constraint.bodyB && constraint.bodyB.isStatic);
	
	            if (!fixedA && !fixedB) {
	                Constraint.solve(constraints[i], timeScale);
	            }
	        }
	    };
	
	    /**
	     * Solves a distance constraint with Gauss-Siedel method.
	     * @private
	     * @method solve
	     * @param {constraint} constraint
	     * @param {number} timeScale
	     */
	    Constraint.solve = function(constraint, timeScale) {
	        var bodyA = constraint.bodyA,
	            bodyB = constraint.bodyB,
	            pointA = constraint.pointA,
	            pointB = constraint.pointB;
	
	        if (!bodyA && !bodyB)
	            return;
	
	        // update reference angle
	        if (bodyA && !bodyA.isStatic) {
	            Vector.rotate(pointA, bodyA.angle - constraint.angleA, pointA);
	            constraint.angleA = bodyA.angle;
	        }
	        
	        // update reference angle
	        if (bodyB && !bodyB.isStatic) {
	            Vector.rotate(pointB, bodyB.angle - constraint.angleB, pointB);
	            constraint.angleB = bodyB.angle;
	        }
	
	        var pointAWorld = pointA,
	            pointBWorld = pointB;
	
	        if (bodyA) pointAWorld = Vector.add(bodyA.position, pointA);
	        if (bodyB) pointBWorld = Vector.add(bodyB.position, pointB);
	
	        if (!pointAWorld || !pointBWorld)
	            return;
	
	        var delta = Vector.sub(pointAWorld, pointBWorld),
	            currentLength = Vector.magnitude(delta);
	
	        // prevent singularity
	        if (currentLength < Constraint._minLength) {
	            currentLength = Constraint._minLength;
	        }
	
	        // solve distance constraint with Gauss-Siedel method
	        var difference = (currentLength - constraint.length) / currentLength,
	            stiffness = constraint.stiffness < 1 ? constraint.stiffness * timeScale : constraint.stiffness,
	            force = Vector.mult(delta, difference * stiffness),
	            massTotal = (bodyA ? bodyA.inverseMass : 0) + (bodyB ? bodyB.inverseMass : 0),
	            inertiaTotal = (bodyA ? bodyA.inverseInertia : 0) + (bodyB ? bodyB.inverseInertia : 0),
	            resistanceTotal = massTotal + inertiaTotal,
	            torque,
	            share,
	            normal,
	            normalVelocity,
	            relativeVelocity;
	
	        if (constraint.damping) {
	            var zero = Vector.create();
	            normal = Vector.div(delta, currentLength);
	
	            relativeVelocity = Vector.sub(
	                bodyB && Vector.sub(bodyB.position, bodyB.positionPrev) || zero,
	                bodyA && Vector.sub(bodyA.position, bodyA.positionPrev) || zero
	            );
	
	            normalVelocity = Vector.dot(normal, relativeVelocity);
	        }
	
	        if (bodyA && !bodyA.isStatic) {
	            share = bodyA.inverseMass / massTotal;
	
	            // keep track of applied impulses for post solving
	            bodyA.constraintImpulse.x -= force.x * share;
	            bodyA.constraintImpulse.y -= force.y * share;
	
	            // apply forces
	            bodyA.position.x -= force.x * share;
	            bodyA.position.y -= force.y * share;
	
	            // apply damping
	            if (constraint.damping) {
	                bodyA.positionPrev.x -= constraint.damping * normal.x * normalVelocity * share;
	                bodyA.positionPrev.y -= constraint.damping * normal.y * normalVelocity * share;
	            }
	
	            // apply torque
	            torque = (Vector.cross(pointA, force) / resistanceTotal) * Constraint._torqueDampen * bodyA.inverseInertia * (1 - constraint.angularStiffness);
	            bodyA.constraintImpulse.angle -= torque;
	            bodyA.angle -= torque;
	        }
	
	        if (bodyB && !bodyB.isStatic) {
	            share = bodyB.inverseMass / massTotal;
	
	            // keep track of applied impulses for post solving
	            bodyB.constraintImpulse.x += force.x * share;
	            bodyB.constraintImpulse.y += force.y * share;
	            
	            // apply forces
	            bodyB.position.x += force.x * share;
	            bodyB.position.y += force.y * share;
	
	            // apply damping
	            if (constraint.damping) {
	                bodyB.positionPrev.x += constraint.damping * normal.x * normalVelocity * share;
	                bodyB.positionPrev.y += constraint.damping * normal.y * normalVelocity * share;
	            }
	
	            // apply torque
	            torque = (Vector.cross(pointB, force) / resistanceTotal) * Constraint._torqueDampen * bodyB.inverseInertia * (1 - constraint.angularStiffness);
	            bodyB.constraintImpulse.angle += torque;
	            bodyB.angle += torque;
	        }
	
	    };
	
	    /**
	     * Performs body updates required after solving constraints.
	     * @private
	     * @method postSolveAll
	     * @param {body[]} bodies
	     */
	    Constraint.postSolveAll = function(bodies) {
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                impulse = body.constraintImpulse;
	
	            if (body.isStatic || (impulse.x === 0 && impulse.y === 0 && impulse.angle === 0)) {
	                continue;
	            }
	
	            Sleeping.set(body, false);
	
	            // update geometry and reset
	            for (var j = 0; j < body.parts.length; j++) {
	                var part = body.parts[j];
	                
	                Vertices.translate(part.vertices, impulse);
	
	                if (j > 0) {
	                    part.position.x += impulse.x;
	                    part.position.y += impulse.y;
	                }
	
	                if (impulse.angle !== 0) {
	                    Vertices.rotate(part.vertices, impulse.angle, body.position);
	                    Axes.rotate(part.axes, impulse.angle);
	                    if (j > 0) {
	                        Vector.rotateAbout(part.position, impulse.angle, body.position, part.position);
	                    }
	                }
	
	                Bounds.update(part.bounds, part.vertices, body.velocity);
	            }
	
	            // dampen the cached impulse for warming next step
	            impulse.angle *= Constraint._warming;
	            impulse.x *= Constraint._warming;
	            impulse.y *= Constraint._warming;
	        }
	    };
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * An integer `Number` uniquely identifying number generated in `Composite.create` by `Common.nextId`.
	     *
	     * @property id
	     * @type number
	     */
	
	    /**
	     * A `String` denoting the type of object.
	     *
	     * @property type
	     * @type string
	     * @default "constraint"
	     * @readOnly
	     */
	
	    /**
	     * An arbitrary `String` name to help the user identify and manage bodies.
	     *
	     * @property label
	     * @type string
	     * @default "Constraint"
	     */
	
	    /**
	     * An `Object` that defines the rendering properties to be consumed by the module `Matter.Render`.
	     *
	     * @property render
	     * @type object
	     */
	
	    /**
	     * A flag that indicates if the constraint should be rendered.
	     *
	     * @property render.visible
	     * @type boolean
	     * @default true
	     */
	
	    /**
	     * A `Number` that defines the line width to use when rendering the constraint outline.
	     * A value of `0` means no outline will be rendered.
	     *
	     * @property render.lineWidth
	     * @type number
	     * @default 2
	     */
	
	    /**
	     * A `String` that defines the stroke style to use when rendering the constraint outline.
	     * It is the same as when using a canvas, so it accepts CSS style property values.
	     *
	     * @property render.strokeStyle
	     * @type string
	     * @default a random colour
	     */
	
	    /**
	     * A `String` that defines the constraint rendering type. 
	     * The possible values are 'line', 'pin', 'spring'.
	     * An appropriate render type will be automatically chosen unless one is given in options.
	     *
	     * @property render.type
	     * @type string
	     * @default 'line'
	     */
	
	    /**
	     * A `Boolean` that defines if the constraint's anchor points should be rendered.
	     *
	     * @property render.anchors
	     * @type boolean
	     * @default true
	     */
	
	    /**
	     * The first possible `Body` that this constraint is attached to.
	     *
	     * @property bodyA
	     * @type body
	     * @default null
	     */
	
	    /**
	     * The second possible `Body` that this constraint is attached to.
	     *
	     * @property bodyB
	     * @type body
	     * @default null
	     */
	
	    /**
	     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyA` if defined, otherwise a world-space position.
	     *
	     * @property pointA
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Vector` that specifies the offset of the constraint from center of the `constraint.bodyB` if defined, otherwise a world-space position.
	     *
	     * @property pointB
	     * @type vector
	     * @default { x: 0, y: 0 }
	     */
	
	    /**
	     * A `Number` that specifies the stiffness of the constraint, i.e. the rate at which it returns to its resting `constraint.length`.
	     * A value of `1` means the constraint should be very stiff.
	     * A value of `0.2` means the constraint acts like a soft spring.
	     *
	     * @property stiffness
	     * @type number
	     * @default 1
	     */
	
	    /**
	     * A `Number` that specifies the damping of the constraint, 
	     * i.e. the amount of resistance applied to each body based on their velocities to limit the amount of oscillation.
	     * Damping will only be apparent when the constraint also has a very low `stiffness`.
	     * A value of `0.1` means the constraint will apply heavy damping, resulting in little to no oscillation.
	     * A value of `0` means the constraint will apply no damping.
	     *
	     * @property damping
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * A `Number` that specifies the target resting length of the constraint. 
	     * It is calculated automatically in `Constraint.create` from initial positions of the `constraint.bodyA` and `constraint.bodyB`.
	     *
	     * @property length
	     * @type number
	     */
	
	    /**
	     * An object reserved for storing plugin-specific properties.
	     *
	     * @property plugin
	     * @type {}
	     */
	
	})();
	
	},{"../core/Common":14,"../core/Sleeping":22,"../geometry/Axes":25,"../geometry/Bounds":26,"../geometry/Vector":28,"../geometry/Vertices":29}],13:[function(_dereq_,module,exports){
	/**
	* The `Matter.MouseConstraint` module contains methods for creating mouse constraints.
	* Mouse constraints are used for allowing user interaction, providing the ability to move bodies via the mouse or touch.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class MouseConstraint
	*/
	
	var MouseConstraint = {};
	
	module.exports = MouseConstraint;
	
	var Vertices = _dereq_('../geometry/Vertices');
	var Sleeping = _dereq_('../core/Sleeping');
	var Mouse = _dereq_('../core/Mouse');
	var Events = _dereq_('../core/Events');
	var Detector = _dereq_('../collision/Detector');
	var Constraint = _dereq_('./Constraint');
	var Composite = _dereq_('../body/Composite');
	var Common = _dereq_('../core/Common');
	var Bounds = _dereq_('../geometry/Bounds');
	
	(function() {
	
	    /**
	     * Creates a new mouse constraint.
	     * All properties have default values, and many are pre-calculated automatically based on other properties.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {engine} engine
	     * @param {} options
	     * @return {MouseConstraint} A new MouseConstraint
	     */
	    MouseConstraint.create = function(engine, options) {
	        var mouse = (engine ? engine.mouse : null) || (options ? options.mouse : null);
	
	        if (!mouse) {
	            if (engine && engine.render && engine.render.canvas) {
	                mouse = Mouse.create(engine.render.canvas);
	            } else if (options && options.element) {
	                mouse = Mouse.create(options.element);
	            } else {
	                mouse = Mouse.create();
	                Common.warn('MouseConstraint.create: options.mouse was undefined, options.element was undefined, may not function as expected');
	            }
	        }
	
	        var constraint = Constraint.create({ 
	            label: 'Mouse Constraint',
	            pointA: mouse.position,
	            pointB: { x: 0, y: 0 },
	            length: 0.01, 
	            stiffness: 0.1,
	            angularStiffness: 1,
	            render: {
	                strokeStyle: '#90EE90',
	                lineWidth: 3
	            }
	        });
	
	        var defaults = {
	            type: 'mouseConstraint',
	            mouse: mouse,
	            element: null,
	            body: null,
	            constraint: constraint,
	            collisionFilter: {
	                category: 0x0001,
	                mask: 0xFFFFFFFF,
	                group: 0
	            }
	        };
	
	        var mouseConstraint = Common.extend(defaults, options);
	
	        Events.on(engine, 'beforeUpdate', function() {
	            var allBodies = Composite.allBodies(engine.world);
	            MouseConstraint.update(mouseConstraint, allBodies);
	            MouseConstraint._triggerEvents(mouseConstraint);
	        });
	
	        return mouseConstraint;
	    };
	
	    /**
	     * Updates the given mouse constraint.
	     * @private
	     * @method update
	     * @param {MouseConstraint} mouseConstraint
	     * @param {body[]} bodies
	     */
	    MouseConstraint.update = function(mouseConstraint, bodies) {
	        var mouse = mouseConstraint.mouse,
	            constraint = mouseConstraint.constraint,
	            body = mouseConstraint.body;
	
	        if (mouse.button === 0) {
	            if (!constraint.bodyB) {
	                for (var i = 0; i < bodies.length; i++) {
	                    body = bodies[i];
	                    if (Bounds.contains(body.bounds, mouse.position) 
	                            && Detector.canCollide(body.collisionFilter, mouseConstraint.collisionFilter)) {
	                        for (var j = body.parts.length > 1 ? 1 : 0; j < body.parts.length; j++) {
	                            var part = body.parts[j];
	                            if (Vertices.contains(part.vertices, mouse.position)) {
	                                constraint.pointA = mouse.position;
	                                constraint.bodyB = mouseConstraint.body = body;
	                                constraint.pointB = { x: mouse.position.x - body.position.x, y: mouse.position.y - body.position.y };
	                                constraint.angleB = body.angle;
	
	                                Sleeping.set(body, false);
	                                Events.trigger(mouseConstraint, 'startdrag', { mouse: mouse, body: body });
	
	                                break;
	                            }
	                        }
	                    }
	                }
	            } else {
	                Sleeping.set(constraint.bodyB, false);
	                constraint.pointA = mouse.position;
	            }
	        } else {
	            constraint.bodyB = mouseConstraint.body = null;
	            constraint.pointB = null;
	
	            if (body)
	                Events.trigger(mouseConstraint, 'enddrag', { mouse: mouse, body: body });
	        }
	    };
	
	    /**
	     * Triggers mouse constraint events.
	     * @method _triggerEvents
	     * @private
	     * @param {mouse} mouseConstraint
	     */
	    MouseConstraint._triggerEvents = function(mouseConstraint) {
	        var mouse = mouseConstraint.mouse,
	            mouseEvents = mouse.sourceEvents;
	
	        if (mouseEvents.mousemove)
	            Events.trigger(mouseConstraint, 'mousemove', { mouse: mouse });
	
	        if (mouseEvents.mousedown)
	            Events.trigger(mouseConstraint, 'mousedown', { mouse: mouse });
	
	        if (mouseEvents.mouseup)
	            Events.trigger(mouseConstraint, 'mouseup', { mouse: mouse });
	
	        // reset the mouse state ready for the next step
	        Mouse.clearSourceEvents(mouse);
	    };
	
	    /*
	    *
	    *  Events Documentation
	    *
	    */
	
	    /**
	    * Fired when the mouse has moved (or a touch moves) during the last step
	    *
	    * @event mousemove
	    * @param {} event An event object
	    * @param {mouse} event.mouse The engine's mouse instance
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when the mouse is down (or a touch has started) during the last step
	    *
	    * @event mousedown
	    * @param {} event An event object
	    * @param {mouse} event.mouse The engine's mouse instance
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when the mouse is up (or a touch has ended) during the last step
	    *
	    * @event mouseup
	    * @param {} event An event object
	    * @param {mouse} event.mouse The engine's mouse instance
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when the user starts dragging a body
	    *
	    * @event startdrag
	    * @param {} event An event object
	    * @param {mouse} event.mouse The engine's mouse instance
	    * @param {body} event.body The body being dragged
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired when the user ends dragging a body
	    *
	    * @event enddrag
	    * @param {} event An event object
	    * @param {mouse} event.mouse The engine's mouse instance
	    * @param {body} event.body The body that has stopped being dragged
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * A `String` denoting the type of object.
	     *
	     * @property type
	     * @type string
	     * @default "constraint"
	     * @readOnly
	     */
	
	    /**
	     * The `Mouse` instance in use. If not supplied in `MouseConstraint.create`, one will be created.
	     *
	     * @property mouse
	     * @type mouse
	     * @default mouse
	     */
	
	    /**
	     * The `Body` that is currently being moved by the user, or `null` if no body.
	     *
	     * @property body
	     * @type body
	     * @default null
	     */
	
	    /**
	     * The `Constraint` object that is used to move the body during interaction.
	     *
	     * @property constraint
	     * @type constraint
	     */
	
	    /**
	     * An `Object` that specifies the collision filter properties.
	     * The collision filter allows the user to define which types of body this mouse constraint can interact with.
	     * See `body.collisionFilter` for more information.
	     *
	     * @property collisionFilter
	     * @type object
	     */
	
	})();
	
	},{"../body/Composite":2,"../collision/Detector":5,"../core/Common":14,"../core/Events":16,"../core/Mouse":19,"../core/Sleeping":22,"../geometry/Bounds":26,"../geometry/Vertices":29,"./Constraint":12}],14:[function(_dereq_,module,exports){
	(function (global){
	/**
	* The `Matter.Common` module contains utility functions that are common to all modules.
	*
	* @class Common
	*/
	
	var Common = {};
	
	module.exports = Common;
	
	(function() {
	
	    Common._nextId = 0;
	    Common._seed = 0;
	    Common._nowStartTime = +(new Date());
	
	    /**
	     * Extends the object in the first argument using the object in the second argument.
	     * @method extend
	     * @param {} obj
	     * @param {boolean} deep
	     * @return {} obj extended
	     */
	    Common.extend = function(obj, deep) {
	        var argsStart,
	            args,
	            deepClone;
	
	        if (typeof deep === 'boolean') {
	            argsStart = 2;
	            deepClone = deep;
	        } else {
	            argsStart = 1;
	            deepClone = true;
	        }
	
	        for (var i = argsStart; i < arguments.length; i++) {
	            var source = arguments[i];
	
	            if (source) {
	                for (var prop in source) {
	                    if (deepClone && source[prop] && source[prop].constructor === Object) {
	                        if (!obj[prop] || obj[prop].constructor === Object) {
	                            obj[prop] = obj[prop] || {};
	                            Common.extend(obj[prop], deepClone, source[prop]);
	                        } else {
	                            obj[prop] = source[prop];
	                        }
	                    } else {
	                        obj[prop] = source[prop];
	                    }
	                }
	            }
	        }
	        
	        return obj;
	    };
	
	    /**
	     * Creates a new clone of the object, if deep is true references will also be cloned.
	     * @method clone
	     * @param {} obj
	     * @param {bool} deep
	     * @return {} obj cloned
	     */
	    Common.clone = function(obj, deep) {
	        return Common.extend({}, deep, obj);
	    };
	
	    /**
	     * Returns the list of keys for the given object.
	     * @method keys
	     * @param {} obj
	     * @return {string[]} keys
	     */
	    Common.keys = function(obj) {
	        if (Object.keys)
	            return Object.keys(obj);
	
	        // avoid hasOwnProperty for performance
	        var keys = [];
	        for (var key in obj)
	            keys.push(key);
	        return keys;
	    };
	
	    /**
	     * Returns the list of values for the given object.
	     * @method values
	     * @param {} obj
	     * @return {array} Array of the objects property values
	     */
	    Common.values = function(obj) {
	        var values = [];
	        
	        if (Object.keys) {
	            var keys = Object.keys(obj);
	            for (var i = 0; i < keys.length; i++) {
	                values.push(obj[keys[i]]);
	            }
	            return values;
	        }
	        
	        // avoid hasOwnProperty for performance
	        for (var key in obj)
	            values.push(obj[key]);
	        return values;
	    };
	
	    /**
	     * Gets a value from `base` relative to the `path` string.
	     * @method get
	     * @param {} obj The base object
	     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
	     * @param {number} [begin] Path slice begin
	     * @param {number} [end] Path slice end
	     * @return {} The object at the given path
	     */
	    Common.get = function(obj, path, begin, end) {
	        path = path.split('.').slice(begin, end);
	
	        for (var i = 0; i < path.length; i += 1) {
	            obj = obj[path[i]];
	        }
	
	        return obj;
	    };
	
	    /**
	     * Sets a value on `base` relative to the given `path` string.
	     * @method set
	     * @param {} obj The base object
	     * @param {string} path The path relative to `base`, e.g. 'Foo.Bar.baz'
	     * @param {} val The value to set
	     * @param {number} [begin] Path slice begin
	     * @param {number} [end] Path slice end
	     * @return {} Pass through `val` for chaining
	     */
	    Common.set = function(obj, path, val, begin, end) {
	        var parts = path.split('.').slice(begin, end);
	        Common.get(obj, path, 0, -1)[parts[parts.length - 1]] = val;
	        return val;
	    };
	
	    /**
	     * Shuffles the given array in-place.
	     * The function uses a seeded random generator.
	     * @method shuffle
	     * @param {array} array
	     * @return {array} array shuffled randomly
	     */
	    Common.shuffle = function(array) {
	        for (var i = array.length - 1; i > 0; i--) {
	            var j = Math.floor(Common.random() * (i + 1));
	            var temp = array[i];
	            array[i] = array[j];
	            array[j] = temp;
	        }
	        return array;
	    };
	
	    /**
	     * Randomly chooses a value from a list with equal probability.
	     * The function uses a seeded random generator.
	     * @method choose
	     * @param {array} choices
	     * @return {object} A random choice object from the array
	     */
	    Common.choose = function(choices) {
	        return choices[Math.floor(Common.random() * choices.length)];
	    };
	
	    /**
	     * Returns true if the object is a HTMLElement, otherwise false.
	     * @method isElement
	     * @param {object} obj
	     * @return {boolean} True if the object is a HTMLElement, otherwise false
	     */
	    Common.isElement = function(obj) {
	        if (typeof HTMLElement !== 'undefined') {
	            return obj instanceof HTMLElement;
	        }
	
	        return !!(obj && obj.nodeType && obj.nodeName);
	    };
	
	    /**
	     * Returns true if the object is an array.
	     * @method isArray
	     * @param {object} obj
	     * @return {boolean} True if the object is an array, otherwise false
	     */
	    Common.isArray = function(obj) {
	        return Object.prototype.toString.call(obj) === '[object Array]';
	    };
	
	    /**
	     * Returns true if the object is a function.
	     * @method isFunction
	     * @param {object} obj
	     * @return {boolean} True if the object is a function, otherwise false
	     */
	    Common.isFunction = function(obj) {
	        return typeof obj === "function";
	    };
	
	    /**
	     * Returns true if the object is a plain object.
	     * @method isPlainObject
	     * @param {object} obj
	     * @return {boolean} True if the object is a plain object, otherwise false
	     */
	    Common.isPlainObject = function(obj) {
	        return typeof obj === 'object' && obj.constructor === Object;
	    };
	
	    /**
	     * Returns true if the object is a string.
	     * @method isString
	     * @param {object} obj
	     * @return {boolean} True if the object is a string, otherwise false
	     */
	    Common.isString = function(obj) {
	        return toString.call(obj) === '[object String]';
	    };
	    
	    /**
	     * Returns the given value clamped between a minimum and maximum value.
	     * @method clamp
	     * @param {number} value
	     * @param {number} min
	     * @param {number} max
	     * @return {number} The value clamped between min and max inclusive
	     */
	    Common.clamp = function(value, min, max) {
	        if (value < min)
	            return min;
	        if (value > max)
	            return max;
	        return value;
	    };
	    
	    /**
	     * Returns the sign of the given value.
	     * @method sign
	     * @param {number} value
	     * @return {number} -1 if negative, +1 if 0 or positive
	     */
	    Common.sign = function(value) {
	        return value < 0 ? -1 : 1;
	    };
	    
	    /**
	     * Returns the current timestamp since the time origin (e.g. from page load).
	     * The result will be high-resolution including decimal places if available.
	     * @method now
	     * @return {number} the current timestamp
	     */
	    Common.now = function() {
	        if (window.performance) {
	            if (window.performance.now) {
	                return window.performance.now();
	            } else if (window.performance.webkitNow) {
	                return window.performance.webkitNow();
	            }
	        }
	
	        return (new Date()) - Common._nowStartTime;
	    };
	    
	    /**
	     * Returns a random value between a minimum and a maximum value inclusive.
	     * The function uses a seeded random generator.
	     * @method random
	     * @param {number} min
	     * @param {number} max
	     * @return {number} A random number between min and max inclusive
	     */
	    Common.random = function(min, max) {
	        min = (typeof min !== "undefined") ? min : 0;
	        max = (typeof max !== "undefined") ? max : 1;
	        return min + _seededRandom() * (max - min);
	    };
	
	    var _seededRandom = function() {
	        // https://en.wikipedia.org/wiki/Linear_congruential_generator
	        Common._seed = (Common._seed * 9301 + 49297) % 233280;
	        return Common._seed / 233280;
	    };
	
	    /**
	     * Converts a CSS hex colour string into an integer.
	     * @method colorToNumber
	     * @param {string} colorString
	     * @return {number} An integer representing the CSS hex string
	     */
	    Common.colorToNumber = function(colorString) {
	        colorString = colorString.replace('#','');
	
	        if (colorString.length == 3) {
	            colorString = colorString.charAt(0) + colorString.charAt(0)
	                        + colorString.charAt(1) + colorString.charAt(1)
	                        + colorString.charAt(2) + colorString.charAt(2);
	        }
	
	        return parseInt(colorString, 16);
	    };
	
	    /**
	     * The console logging level to use, where each level includes all levels above and excludes the levels below.
	     * The default level is 'debug' which shows all console messages.  
	     *
	     * Possible level values are:
	     * - 0 = None
	     * - 1 = Debug
	     * - 2 = Info
	     * - 3 = Warn
	     * - 4 = Error
	     * @property Common.logLevel
	     * @type {Number}
	     * @default 1
	     */
	    Common.logLevel = 1;
	
	    /**
	     * Shows a `console.log` message only if the current `Common.logLevel` allows it.
	     * The message will be prefixed with 'matter-js' to make it easily identifiable.
	     * @method log
	     * @param ...objs {} The objects to log.
	     */
	    Common.log = function() {
	        if (console && Common.logLevel > 0 && Common.logLevel <= 3) {
	            console.log.apply(console, ['matter-js:'].concat(Array.prototype.slice.call(arguments)));
	        }
	    };
	
	    /**
	     * Shows a `console.info` message only if the current `Common.logLevel` allows it.
	     * The message will be prefixed with 'matter-js' to make it easily identifiable.
	     * @method info
	     * @param ...objs {} The objects to log.
	     */
	    Common.info = function() {
	        if (console && Common.logLevel > 0 && Common.logLevel <= 2) {
	            console.info.apply(console, ['matter-js:'].concat(Array.prototype.slice.call(arguments)));
	        }
	    };
	
	    /**
	     * Shows a `console.warn` message only if the current `Common.logLevel` allows it.
	     * The message will be prefixed with 'matter-js' to make it easily identifiable.
	     * @method warn
	     * @param ...objs {} The objects to log.
	     */
	    Common.warn = function() {
	        if (console && Common.logLevel > 0 && Common.logLevel <= 3) {
	            console.warn.apply(console, ['matter-js:'].concat(Array.prototype.slice.call(arguments)));
	        }
	    };
	
	    /**
	     * Returns the next unique sequential ID.
	     * @method nextId
	     * @return {Number} Unique sequential ID
	     */
	    Common.nextId = function() {
	        return Common._nextId++;
	    };
	
	    /**
	     * A cross browser compatible indexOf implementation.
	     * @method indexOf
	     * @param {array} haystack
	     * @param {object} needle
	     * @return {number} The position of needle in haystack, otherwise -1.
	     */
	    Common.indexOf = function(haystack, needle) {
	        if (haystack.indexOf)
	            return haystack.indexOf(needle);
	
	        for (var i = 0; i < haystack.length; i++) {
	            if (haystack[i] === needle)
	                return i;
	        }
	
	        return -1;
	    };
	
	    /**
	     * A cross browser compatible array map implementation.
	     * @method map
	     * @param {array} list
	     * @param {function} func
	     * @return {array} Values from list transformed by func.
	     */
	    Common.map = function(list, func) {
	        if (list.map) {
	            return list.map(func);
	        }
	
	        var mapped = [];
	
	        for (var i = 0; i < list.length; i += 1) {
	            mapped.push(func(list[i]));
	        }
	
	        return mapped;
	    };
	
	    /**
	     * Takes a directed graph and returns the partially ordered set of vertices in topological order.
	     * Circular dependencies are allowed.
	     * @method topologicalSort
	     * @param {object} graph
	     * @return {array} Partially ordered set of vertices in topological order.
	     */
	    Common.topologicalSort = function(graph) {
	        // https://github.com/mgechev/javascript-algorithms
	        // Copyright (c) Minko Gechev (MIT license)
	        // Modifications: tidy formatting and naming
	        var result = [],
	            visited = [],
	            temp = [];
	
	        for (var node in graph) {
	            if (!visited[node] && !temp[node]) {
	                Common._topologicalSort(node, visited, temp, graph, result);
	            }
	        }
	
	        return result;
	    };
	
	    Common._topologicalSort = function(node, visited, temp, graph, result) {
	        var neighbors = graph[node] || [];
	        temp[node] = true;
	
	        for (var i = 0; i < neighbors.length; i += 1) {
	            var neighbor = neighbors[i];
	
	            if (temp[neighbor]) {
	                // skip circular dependencies
	                continue;
	            }
	
	            if (!visited[neighbor]) {
	                Common._topologicalSort(neighbor, visited, temp, graph, result);
	            }
	        }
	
	        temp[node] = false;
	        visited[node] = true;
	
	        result.push(node);
	    };
	
	    /**
	     * Takes _n_ functions as arguments and returns a new function that calls them in order.
	     * The arguments applied when calling the new function will also be applied to every function passed.
	     * The value of `this` refers to the last value returned in the chain that was not `undefined`.
	     * Therefore if a passed function does not return a value, the previously returned value is maintained.
	     * After all passed functions have been called the new function returns the last returned value (if any).
	     * If any of the passed functions are a chain, then the chain will be flattened.
	     * @method chain
	     * @param ...funcs {function} The functions to chain.
	     * @return {function} A new function that calls the passed functions in order.
	     */
	    Common.chain = function() {
	        var funcs = [];
	
	        for (var i = 0; i < arguments.length; i += 1) {
	            var func = arguments[i];
	
	            if (func._chained) {
	                // flatten already chained functions
	                funcs.push.apply(funcs, func._chained);
	            } else {
	                funcs.push(func);
	            }
	        }
	
	        var chain = function() {
	            // https://github.com/GoogleChrome/devtools-docs/issues/53#issuecomment-51941358
	            var lastResult,
	                args = new Array(arguments.length);
	
	            for (var i = 0, l = arguments.length; i < l; i++) {
	                args[i] = arguments[i];
	            }
	
	            for (i = 0; i < funcs.length; i += 1) {
	                var result = funcs[i].apply(lastResult, args);
	
	                if (typeof result !== 'undefined') {
	                    lastResult = result;
	                }
	            }
	
	            return lastResult;
	        };
	
	        chain._chained = funcs;
	
	        return chain;
	    };
	
	    /**
	     * Chains a function to excute before the original function on the given `path` relative to `base`.
	     * See also docs for `Common.chain`.
	     * @method chainPathBefore
	     * @param {} base The base object
	     * @param {string} path The path relative to `base`
	     * @param {function} func The function to chain before the original
	     * @return {function} The chained function that replaced the original
	     */
	    Common.chainPathBefore = function(base, path, func) {
	        return Common.set(base, path, Common.chain(
	            func,
	            Common.get(base, path)
	        ));
	    };
	
	    /**
	     * Chains a function to excute after the original function on the given `path` relative to `base`.
	     * See also docs for `Common.chain`.
	     * @method chainPathAfter
	     * @param {} base The base object
	     * @param {string} path The path relative to `base`
	     * @param {function} func The function to chain after the original
	     * @return {function} The chained function that replaced the original
	     */
	    Common.chainPathAfter = function(base, path, func) {
	        return Common.set(base, path, Common.chain(
	            Common.get(base, path),
	            func
	        ));
	    };
	
	    /**
	     * Used to require external libraries outside of the bundle.
	     * It first looks for the `globalName` on the environment's global namespace.
	     * If the global is not found, it will fall back to using the standard `require` using the `moduleName`.
	     * @private
	     * @method _requireGlobal
	     * @param {string} globalName The global module name
	     * @param {string} moduleName The fallback CommonJS module name
	     * @return {} The loaded module
	     */
	    Common._requireGlobal = function(globalName, moduleName) {
	        var obj = (typeof window !== 'undefined' ? window[globalName] : typeof global !== 'undefined' ? global[globalName] : null);
	        return obj || _dereq_(moduleName);
	    };
	})();
	
	}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
	},{}],15:[function(_dereq_,module,exports){
	/**
	* The `Matter.Engine` module contains methods for creating and manipulating engines.
	* An engine is a controller that manages updating the simulation of the world.
	* See `Matter.Runner` for an optional game loop utility.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Engine
	*/
	
	var Engine = {};
	
	module.exports = Engine;
	
	var World = _dereq_('../body/World');
	var Sleeping = _dereq_('./Sleeping');
	var Resolver = _dereq_('../collision/Resolver');
	var Render = _dereq_('../render/Render');
	var Pairs = _dereq_('../collision/Pairs');
	var Metrics = _dereq_('./Metrics');
	var Grid = _dereq_('../collision/Grid');
	var Events = _dereq_('./Events');
	var Composite = _dereq_('../body/Composite');
	var Constraint = _dereq_('../constraint/Constraint');
	var Common = _dereq_('./Common');
	var Body = _dereq_('../body/Body');
	
	(function() {
	
	    /**
	     * Creates a new engine. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * All properties have default values, and many are pre-calculated automatically based on other properties.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {object} [options]
	     * @return {engine} engine
	     */
	    Engine.create = function(element, options) {
	        // options may be passed as the first (and only) argument
	        options = Common.isElement(element) ? options : element;
	        element = Common.isElement(element) ? element : null;
	        options = options || {};
	
	        if (element || options.render) {
	            Common.warn('Engine.create: engine.render is deprecated (see docs)');
	        }
	
	        var defaults = {
	            positionIterations: 6,
	            velocityIterations: 4,
	            constraintIterations: 2,
	            enableSleeping: false,
	            events: [],
	            plugin: {},
	            timing: {
	                timestamp: 0,
	                timeScale: 1
	            },
	            broadphase: {
	                controller: Grid
	            }
	        };
	
	        var engine = Common.extend(defaults, options);
	
	        // @deprecated
	        if (element || engine.render) {
	            var renderDefaults = {
	                element: element,
	                controller: Render
	            };
	            
	            engine.render = Common.extend(renderDefaults, engine.render);
	        }
	
	        // @deprecated
	        if (engine.render && engine.render.controller) {
	            engine.render = engine.render.controller.create(engine.render);
	        }
	
	        // @deprecated
	        if (engine.render) {
	            engine.render.engine = engine;
	        }
	
	        engine.world = options.world || World.create(engine.world);
	        engine.pairs = Pairs.create();
	        engine.broadphase = engine.broadphase.controller.create(engine.broadphase);
	        engine.metrics = engine.metrics || { extended: false };
	
	
	        return engine;
	    };
	
	    /**
	     * Moves the simulation forward in time by `delta` ms.
	     * The `correction` argument is an optional `Number` that specifies the time correction factor to apply to the update.
	     * This can help improve the accuracy of the simulation in cases where `delta` is changing between updates.
	     * The value of `correction` is defined as `delta / lastDelta`, i.e. the percentage change of `delta` over the last step.
	     * Therefore the value is always `1` (no correction) when `delta` constant (or when no correction is desired, which is the default).
	     * See the paper on <a href="http://lonesock.net/article/verlet.html">Time Corrected Verlet</a> for more information.
	     *
	     * Triggers `beforeUpdate` and `afterUpdate` events.
	     * Triggers `collisionStart`, `collisionActive` and `collisionEnd` events.
	     * @method update
	     * @param {engine} engine
	     * @param {number} [delta=16.666]
	     * @param {number} [correction=1]
	     */
	    Engine.update = function(engine, delta, correction) {
	        delta = delta || 1000 / 60;
	        correction = correction || 1;
	
	        var world = engine.world,
	            timing = engine.timing,
	            broadphase = engine.broadphase,
	            broadphasePairs = [],
	            i;
	
	        // increment timestamp
	        timing.timestamp += delta * timing.timeScale;
	
	        // create an event object
	        var event = {
	            timestamp: timing.timestamp
	        };
	
	        Events.trigger(engine, 'beforeUpdate', event);
	
	        // get lists of all bodies and constraints, no matter what composites they are in
	        var allBodies = Composite.allBodies(world),
	            allConstraints = Composite.allConstraints(world);
	
	
	        // if sleeping enabled, call the sleeping controller
	        if (engine.enableSleeping)
	            Sleeping.update(allBodies, timing.timeScale);
	
	        // applies gravity to all bodies
	        Engine._bodiesApplyGravity(allBodies, world.gravity);
	
	        // update all body position and rotation by integration
	        Engine._bodiesUpdate(allBodies, delta, timing.timeScale, correction, world.bounds);
	
	        // update all constraints (first pass)
	        Constraint.preSolveAll(allBodies);
	        for (i = 0; i < engine.constraintIterations; i++) {
	            Constraint.solveAll(allConstraints, timing.timeScale);
	        }
	        Constraint.postSolveAll(allBodies);
	
	        // broadphase pass: find potential collision pairs
	        if (broadphase.controller) {
	            // if world is dirty, we must flush the whole grid
	            if (world.isModified)
	                broadphase.controller.clear(broadphase);
	
	            // update the grid buckets based on current bodies
	            broadphase.controller.update(broadphase, allBodies, engine, world.isModified);
	            broadphasePairs = broadphase.pairsList;
	        } else {
	            // if no broadphase set, we just pass all bodies
	            broadphasePairs = allBodies;
	        }
	
	        // clear all composite modified flags
	        if (world.isModified) {
	            Composite.setModified(world, false, false, true);
	        }
	
	        // narrowphase pass: find actual collisions, then create or update collision pairs
	        var collisions = broadphase.detector(broadphasePairs, engine);
	
	        // update collision pairs
	        var pairs = engine.pairs,
	            timestamp = timing.timestamp;
	        Pairs.update(pairs, collisions, timestamp);
	        Pairs.removeOld(pairs, timestamp);
	
	        // wake up bodies involved in collisions
	        if (engine.enableSleeping)
	            Sleeping.afterCollisions(pairs.list, timing.timeScale);
	
	        // trigger collision events
	        if (pairs.collisionStart.length > 0)
	            Events.trigger(engine, 'collisionStart', { pairs: pairs.collisionStart });
	
	        // iteratively resolve position between collisions
	        Resolver.preSolvePosition(pairs.list);
	        for (i = 0; i < engine.positionIterations; i++) {
	            Resolver.solvePosition(pairs.list, timing.timeScale);
	        }
	        Resolver.postSolvePosition(allBodies);
	
	        // update all constraints (second pass)
	        Constraint.preSolveAll(allBodies);
	        for (i = 0; i < engine.constraintIterations; i++) {
	            Constraint.solveAll(allConstraints, timing.timeScale);
	        }
	        Constraint.postSolveAll(allBodies);
	
	        // iteratively resolve velocity between collisions
	        Resolver.preSolveVelocity(pairs.list);
	        for (i = 0; i < engine.velocityIterations; i++) {
	            Resolver.solveVelocity(pairs.list, timing.timeScale);
	        }
	
	        // trigger collision events
	        if (pairs.collisionActive.length > 0)
	            Events.trigger(engine, 'collisionActive', { pairs: pairs.collisionActive });
	
	        if (pairs.collisionEnd.length > 0)
	            Events.trigger(engine, 'collisionEnd', { pairs: pairs.collisionEnd });
	
	
	        // clear force buffers
	        Engine._bodiesClearForces(allBodies);
	
	        Events.trigger(engine, 'afterUpdate', event);
	
	        return engine;
	    };
	    
	    /**
	     * Merges two engines by keeping the configuration of `engineA` but replacing the world with the one from `engineB`.
	     * @method merge
	     * @param {engine} engineA
	     * @param {engine} engineB
	     */
	    Engine.merge = function(engineA, engineB) {
	        Common.extend(engineA, engineB);
	        
	        if (engineB.world) {
	            engineA.world = engineB.world;
	
	            Engine.clear(engineA);
	
	            var bodies = Composite.allBodies(engineA.world);
	
	            for (var i = 0; i < bodies.length; i++) {
	                var body = bodies[i];
	                Sleeping.set(body, false);
	                body.id = Common.nextId();
	            }
	        }
	    };
	
	    /**
	     * Clears the engine including the world, pairs and broadphase.
	     * @method clear
	     * @param {engine} engine
	     */
	    Engine.clear = function(engine) {
	        var world = engine.world;
	        
	        Pairs.clear(engine.pairs);
	
	        var broadphase = engine.broadphase;
	        if (broadphase.controller) {
	            var bodies = Composite.allBodies(world);
	            broadphase.controller.clear(broadphase);
	            broadphase.controller.update(broadphase, bodies, engine, true);
	        }
	    };
	
	    /**
	     * Zeroes the `body.force` and `body.torque` force buffers.
	     * @method _bodiesClearForces
	     * @private
	     * @param {body[]} bodies
	     */
	    Engine._bodiesClearForces = function(bodies) {
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            // reset force buffers
	            body.force.x = 0;
	            body.force.y = 0;
	            body.torque = 0;
	        }
	    };
	
	    /**
	     * Applys a mass dependant force to all given bodies.
	     * @method _bodiesApplyGravity
	     * @private
	     * @param {body[]} bodies
	     * @param {vector} gravity
	     */
	    Engine._bodiesApplyGravity = function(bodies, gravity) {
	        var gravityScale = typeof gravity.scale !== 'undefined' ? gravity.scale : 0.001;
	
	        if ((gravity.x === 0 && gravity.y === 0) || gravityScale === 0) {
	            return;
	        }
	        
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (body.isStatic || body.isSleeping)
	                continue;
	
	            // apply gravity
	            body.force.y += body.mass * gravity.y * gravityScale;
	            body.force.x += body.mass * gravity.x * gravityScale;
	        }
	    };
	
	    /**
	     * Applys `Body.update` to all given `bodies`.
	     * @method _bodiesUpdate
	     * @private
	     * @param {body[]} bodies
	     * @param {number} deltaTime 
	     * The amount of time elapsed between updates
	     * @param {number} timeScale
	     * @param {number} correction 
	     * The Verlet correction factor (deltaTime / lastDeltaTime)
	     * @param {bounds} worldBounds
	     */
	    Engine._bodiesUpdate = function(bodies, deltaTime, timeScale, correction, worldBounds) {
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (body.isStatic || body.isSleeping)
	                continue;
	
	            Body.update(body, deltaTime, timeScale, correction);
	        }
	    };
	
	    /**
	     * An alias for `Runner.run`, see `Matter.Runner` for more information.
	     * @method run
	     * @param {engine} engine
	     */
	
	    /**
	    * Fired just before an update
	    *
	    * @event beforeUpdate
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine update and all collision events
	    *
	    * @event afterUpdate
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine update, provides a list of all pairs that have started to collide in the current tick (if any)
	    *
	    * @event collisionStart
	    * @param {} event An event object
	    * @param {} event.pairs List of affected pairs
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine update, provides a list of all pairs that are colliding in the current tick (if any)
	    *
	    * @event collisionActive
	    * @param {} event An event object
	    * @param {} event.pairs List of affected pairs
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine update, provides a list of all pairs that have ended collision in the current tick (if any)
	    *
	    * @event collisionEnd
	    * @param {} event An event object
	    * @param {} event.pairs List of affected pairs
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * An integer `Number` that specifies the number of position iterations to perform each update.
	     * The higher the value, the higher quality the simulation will be at the expense of performance.
	     *
	     * @property positionIterations
	     * @type number
	     * @default 6
	     */
	
	    /**
	     * An integer `Number` that specifies the number of velocity iterations to perform each update.
	     * The higher the value, the higher quality the simulation will be at the expense of performance.
	     *
	     * @property velocityIterations
	     * @type number
	     * @default 4
	     */
	
	    /**
	     * An integer `Number` that specifies the number of constraint iterations to perform each update.
	     * The higher the value, the higher quality the simulation will be at the expense of performance.
	     * The default value of `2` is usually very adequate.
	     *
	     * @property constraintIterations
	     * @type number
	     * @default 2
	     */
	
	    /**
	     * A flag that specifies whether the engine should allow sleeping via the `Matter.Sleeping` module.
	     * Sleeping can improve stability and performance, but often at the expense of accuracy.
	     *
	     * @property enableSleeping
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * An `Object` containing properties regarding the timing systems of the engine. 
	     *
	     * @property timing
	     * @type object
	     */
	
	    /**
	     * A `Number` that specifies the global scaling factor of time for all bodies.
	     * A value of `0` freezes the simulation.
	     * A value of `0.1` gives a slow-motion effect.
	     * A value of `1.2` gives a speed-up effect.
	     *
	     * @property timing.timeScale
	     * @type number
	     * @default 1
	     */
	
	    /**
	     * A `Number` that specifies the current simulation-time in milliseconds starting from `0`. 
	     * It is incremented on every `Engine.update` by the given `delta` argument. 
	     *
	     * @property timing.timestamp
	     * @type number
	     * @default 0
	     */
	
	    /**
	     * An instance of a `Render` controller. The default value is a `Matter.Render` instance created by `Engine.create`.
	     * One may also develop a custom renderer module based on `Matter.Render` and pass an instance of it to `Engine.create` via `options.render`.
	     *
	     * A minimal custom renderer object must define at least three functions: `create`, `clear` and `world` (see `Matter.Render`).
	     * It is also possible to instead pass the _module_ reference via `options.render.controller` and `Engine.create` will instantiate one for you.
	     *
	     * @property render
	     * @type render
	     * @deprecated see Demo.js for an example of creating a renderer
	     * @default a Matter.Render instance
	     */
	
	    /**
	     * An instance of a broadphase controller. The default value is a `Matter.Grid` instance created by `Engine.create`.
	     *
	     * @property broadphase
	     * @type grid
	     * @default a Matter.Grid instance
	     */
	
	    /**
	     * A `World` composite object that will contain all simulated bodies and constraints.
	     *
	     * @property world
	     * @type world
	     * @default a Matter.World instance
	     */
	
	    /**
	     * An object reserved for storing plugin-specific properties.
	     *
	     * @property plugin
	     * @type {}
	     */
	
	})();
	
	},{"../body/Body":1,"../body/Composite":2,"../body/World":3,"../collision/Grid":6,"../collision/Pairs":8,"../collision/Resolver":10,"../constraint/Constraint":12,"../render/Render":31,"./Common":14,"./Events":16,"./Metrics":18,"./Sleeping":22}],16:[function(_dereq_,module,exports){
	/**
	* The `Matter.Events` module contains methods to fire and listen to events on other objects.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Events
	*/
	
	var Events = {};
	
	module.exports = Events;
	
	var Common = _dereq_('./Common');
	
	(function() {
	
	    /**
	     * Subscribes a callback function to the given object's `eventName`.
	     * @method on
	     * @param {} object
	     * @param {string} eventNames
	     * @param {function} callback
	     */
	    Events.on = function(object, eventNames, callback) {
	        var names = eventNames.split(' '),
	            name;
	
	        for (var i = 0; i < names.length; i++) {
	            name = names[i];
	            object.events = object.events || {};
	            object.events[name] = object.events[name] || [];
	            object.events[name].push(callback);
	        }
	
	        return callback;
	    };
	
	    /**
	     * Removes the given event callback. If no callback, clears all callbacks in `eventNames`. If no `eventNames`, clears all events.
	     * @method off
	     * @param {} object
	     * @param {string} eventNames
	     * @param {function} callback
	     */
	    Events.off = function(object, eventNames, callback) {
	        if (!eventNames) {
	            object.events = {};
	            return;
	        }
	
	        // handle Events.off(object, callback)
	        if (typeof eventNames === 'function') {
	            callback = eventNames;
	            eventNames = Common.keys(object.events).join(' ');
	        }
	
	        var names = eventNames.split(' ');
	
	        for (var i = 0; i < names.length; i++) {
	            var callbacks = object.events[names[i]],
	                newCallbacks = [];
	
	            if (callback && callbacks) {
	                for (var j = 0; j < callbacks.length; j++) {
	                    if (callbacks[j] !== callback)
	                        newCallbacks.push(callbacks[j]);
	                }
	            }
	
	            object.events[names[i]] = newCallbacks;
	        }
	    };
	
	    /**
	     * Fires all the callbacks subscribed to the given object's `eventName`, in the order they subscribed, if any.
	     * @method trigger
	     * @param {} object
	     * @param {string} eventNames
	     * @param {} event
	     */
	    Events.trigger = function(object, eventNames, event) {
	        var names,
	            name,
	            callbacks,
	            eventClone;
	
	        if (object.events) {
	            if (!event)
	                event = {};
	
	            names = eventNames.split(' ');
	
	            for (var i = 0; i < names.length; i++) {
	                name = names[i];
	                callbacks = object.events[name];
	
	                if (callbacks) {
	                    eventClone = Common.clone(event, false);
	                    eventClone.name = name;
	                    eventClone.source = object;
	
	                    for (var j = 0; j < callbacks.length; j++) {
	                        callbacks[j].apply(object, [eventClone]);
	                    }
	                }
	            }
	        }
	    };
	
	})();
	
	},{"./Common":14}],17:[function(_dereq_,module,exports){
	/**
	* The `Matter` module is the top level namespace. It also includes a function for installing plugins on top of the library.
	*
	* @class Matter
	*/
	
	var Matter = {};
	
	module.exports = Matter;
	
	var Plugin = _dereq_('./Plugin');
	var Common = _dereq_('./Common');
	
	(function() {
	
	    /**
	     * The library name.
	     * @property name
	     * @readOnly
	     * @type {String}
	     */
	    Matter.name = 'matter-js';
	
	    /**
	     * The library version.
	     * @property version
	     * @readOnly
	     * @type {String}
	     */
	    Matter.version = '0.14.2';
	
	    /**
	     * A list of plugin dependencies to be installed. These are normally set and installed through `Matter.use`.
	     * Alternatively you may set `Matter.uses` manually and install them by calling `Plugin.use(Matter)`.
	     * @property uses
	     * @type {Array}
	     */
	    Matter.uses = [];
	
	    /**
	     * The plugins that have been installed through `Matter.Plugin.install`. Read only.
	     * @property used
	     * @readOnly
	     * @type {Array}
	     */
	    Matter.used = [];
	
	    /**
	     * Installs the given plugins on the `Matter` namespace.
	     * This is a short-hand for `Plugin.use`, see it for more information.
	     * Call this function once at the start of your code, with all of the plugins you wish to install as arguments.
	     * Avoid calling this function multiple times unless you intend to manually control installation order.
	     * @method use
	     * @param ...plugin {Function} The plugin(s) to install on `base` (multi-argument).
	     */
	    Matter.use = function() {
	        Plugin.use(Matter, Array.prototype.slice.call(arguments));
	    };
	
	    /**
	     * Chains a function to excute before the original function on the given `path` relative to `Matter`.
	     * See also docs for `Common.chain`.
	     * @method before
	     * @param {string} path The path relative to `Matter`
	     * @param {function} func The function to chain before the original
	     * @return {function} The chained function that replaced the original
	     */
	    Matter.before = function(path, func) {
	        path = path.replace(/^Matter./, '');
	        return Common.chainPathBefore(Matter, path, func);
	    };
	
	    /**
	     * Chains a function to excute after the original function on the given `path` relative to `Matter`.
	     * See also docs for `Common.chain`.
	     * @method after
	     * @param {string} path The path relative to `Matter`
	     * @param {function} func The function to chain after the original
	     * @return {function} The chained function that replaced the original
	     */
	    Matter.after = function(path, func) {
	        path = path.replace(/^Matter./, '');
	        return Common.chainPathAfter(Matter, path, func);
	    };
	
	})();
	
	},{"./Common":14,"./Plugin":20}],18:[function(_dereq_,module,exports){
	
	},{"../body/Composite":2,"./Common":14}],19:[function(_dereq_,module,exports){
	/**
	* The `Matter.Mouse` module contains methods for creating and manipulating mouse inputs.
	*
	* @class Mouse
	*/
	
	var Mouse = {};
	
	module.exports = Mouse;
	
	var Common = _dereq_('../core/Common');
	
	(function() {
	
	    /**
	     * Creates a mouse input.
	     * @method create
	     * @param {HTMLElement} element
	     * @return {mouse} A new mouse
	     */
	    Mouse.create = function(element) {
	        var mouse = {};
	
	        if (!element) {
	            Common.log('Mouse.create: element was undefined, defaulting to document.body', 'warn');
	        }
	        
	        mouse.element = element || document.body;
	        mouse.absolute = { x: 0, y: 0 };
	        mouse.position = { x: 0, y: 0 };
	        mouse.mousedownPosition = { x: 0, y: 0 };
	        mouse.mouseupPosition = { x: 0, y: 0 };
	        mouse.offset = { x: 0, y: 0 };
	        mouse.scale = { x: 1, y: 1 };
	        mouse.wheelDelta = 0;
	        mouse.button = -1;
	        mouse.pixelRatio = mouse.element.getAttribute('data-pixel-ratio') || 1;
	
	        mouse.sourceEvents = {
	            mousemove: null,
	            mousedown: null,
	            mouseup: null,
	            mousewheel: null
	        };
	        
	        mouse.mousemove = function(event) { 
	            var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio),
	                touches = event.changedTouches;
	
	            if (touches) {
	                mouse.button = 0;
	                event.preventDefault();
	            }
	
	            mouse.absolute.x = position.x;
	            mouse.absolute.y = position.y;
	            mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
	            mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
	            mouse.sourceEvents.mousemove = event;
	        };
	        
	        mouse.mousedown = function(event) {
	            var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio),
	                touches = event.changedTouches;
	
	            if (touches) {
	                mouse.button = 0;
	                event.preventDefault();
	            } else {
	                mouse.button = event.button;
	            }
	
	            mouse.absolute.x = position.x;
	            mouse.absolute.y = position.y;
	            mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
	            mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
	            mouse.mousedownPosition.x = mouse.position.x;
	            mouse.mousedownPosition.y = mouse.position.y;
	            mouse.sourceEvents.mousedown = event;
	        };
	        
	        mouse.mouseup = function(event) {
	            var position = Mouse._getRelativeMousePosition(event, mouse.element, mouse.pixelRatio),
	                touches = event.changedTouches;
	
	            if (touches) {
	                event.preventDefault();
	            }
	            
	            mouse.button = -1;
	            mouse.absolute.x = position.x;
	            mouse.absolute.y = position.y;
	            mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
	            mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
	            mouse.mouseupPosition.x = mouse.position.x;
	            mouse.mouseupPosition.y = mouse.position.y;
	            mouse.sourceEvents.mouseup = event;
	        };
	
	        mouse.mousewheel = function(event) {
	            mouse.wheelDelta = Math.max(-1, Math.min(1, event.wheelDelta || -event.detail));
	            event.preventDefault();
	        };
	
	        Mouse.setElement(mouse, mouse.element);
	
	        return mouse;
	    };
	
	    /**
	     * Sets the element the mouse is bound to (and relative to).
	     * @method setElement
	     * @param {mouse} mouse
	     * @param {HTMLElement} element
	     */
	    Mouse.setElement = function(mouse, element) {
	        mouse.element = element;
	
	        element.addEventListener('mousemove', mouse.mousemove);
	        element.addEventListener('mousedown', mouse.mousedown);
	        element.addEventListener('mouseup', mouse.mouseup);
	        
	        element.addEventListener('mousewheel', mouse.mousewheel);
	        element.addEventListener('DOMMouseScroll', mouse.mousewheel);
	
	        element.addEventListener('touchmove', mouse.mousemove);
	        element.addEventListener('touchstart', mouse.mousedown);
	        element.addEventListener('touchend', mouse.mouseup);
	    };
	
	    /**
	     * Clears all captured source events.
	     * @method clearSourceEvents
	     * @param {mouse} mouse
	     */
	    Mouse.clearSourceEvents = function(mouse) {
	        mouse.sourceEvents.mousemove = null;
	        mouse.sourceEvents.mousedown = null;
	        mouse.sourceEvents.mouseup = null;
	        mouse.sourceEvents.mousewheel = null;
	        mouse.wheelDelta = 0;
	    };
	
	    /**
	     * Sets the mouse position offset.
	     * @method setOffset
	     * @param {mouse} mouse
	     * @param {vector} offset
	     */
	    Mouse.setOffset = function(mouse, offset) {
	        mouse.offset.x = offset.x;
	        mouse.offset.y = offset.y;
	        mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
	        mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
	    };
	
	    /**
	     * Sets the mouse position scale.
	     * @method setScale
	     * @param {mouse} mouse
	     * @param {vector} scale
	     */
	    Mouse.setScale = function(mouse, scale) {
	        mouse.scale.x = scale.x;
	        mouse.scale.y = scale.y;
	        mouse.position.x = mouse.absolute.x * mouse.scale.x + mouse.offset.x;
	        mouse.position.y = mouse.absolute.y * mouse.scale.y + mouse.offset.y;
	    };
	    
	    /**
	     * Gets the mouse position relative to an element given a screen pixel ratio.
	     * @method _getRelativeMousePosition
	     * @private
	     * @param {} event
	     * @param {} element
	     * @param {number} pixelRatio
	     * @return {}
	     */
	    Mouse._getRelativeMousePosition = function(event, element, pixelRatio) {
	        var elementBounds = element.getBoundingClientRect(),
	            rootNode = (document.documentElement || document.body.parentNode || document.body),
	            scrollX = (window.pageXOffset !== undefined) ? window.pageXOffset : rootNode.scrollLeft,
	            scrollY = (window.pageYOffset !== undefined) ? window.pageYOffset : rootNode.scrollTop,
	            touches = event.changedTouches,
	            x, y;
	        
	        if (touches) {
	            x = touches[0].pageX - elementBounds.left - scrollX;
	            y = touches[0].pageY - elementBounds.top - scrollY;
	        } else {
	            x = event.pageX - elementBounds.left - scrollX;
	            y = event.pageY - elementBounds.top - scrollY;
	        }
	
	        return { 
	            x: x / (element.clientWidth / (element.width || element.clientWidth) * pixelRatio),
	            y: y / (element.clientHeight / (element.height || element.clientHeight) * pixelRatio)
	        };
	    };
	
	})();
	
	},{"../core/Common":14}],20:[function(_dereq_,module,exports){
	/**
	* The `Matter.Plugin` module contains functions for registering and installing plugins on modules.
	*
	* @class Plugin
	*/
	
	var Plugin = {};
	
	module.exports = Plugin;
	
	var Common = _dereq_('./Common');
	
	(function() {
	
	    Plugin._registry = {};
	
	    /**
	     * Registers a plugin object so it can be resolved later by name.
	     * @method register
	     * @param plugin {} The plugin to register.
	     * @return {object} The plugin.
	     */
	    Plugin.register = function(plugin) {
	        if (!Plugin.isPlugin(plugin)) {
	            Common.warn('Plugin.register:', Plugin.toString(plugin), 'does not implement all required fields.');
	        }
	
	        if (plugin.name in Plugin._registry) {
	            var registered = Plugin._registry[plugin.name],
	                pluginVersion = Plugin.versionParse(plugin.version).number,
	                registeredVersion = Plugin.versionParse(registered.version).number;
	
	            if (pluginVersion > registeredVersion) {
	                Common.warn('Plugin.register:', Plugin.toString(registered), 'was upgraded to', Plugin.toString(plugin));
	                Plugin._registry[plugin.name] = plugin;
	            } else if (pluginVersion < registeredVersion) {
	                Common.warn('Plugin.register:', Plugin.toString(registered), 'can not be downgraded to', Plugin.toString(plugin));
	            } else if (plugin !== registered) {
	                Common.warn('Plugin.register:', Plugin.toString(plugin), 'is already registered to different plugin object');
	            }
	        } else {
	            Plugin._registry[plugin.name] = plugin;
	        }
	
	        return plugin;
	    };
	
	    /**
	     * Resolves a dependency to a plugin object from the registry if it exists. 
	     * The `dependency` may contain a version, but only the name matters when resolving.
	     * @method resolve
	     * @param dependency {string} The dependency.
	     * @return {object} The plugin if resolved, otherwise `undefined`.
	     */
	    Plugin.resolve = function(dependency) {
	        return Plugin._registry[Plugin.dependencyParse(dependency).name];
	    };
	
	    /**
	     * Returns a pretty printed plugin name and version.
	     * @method toString
	     * @param plugin {} The plugin.
	     * @return {string} Pretty printed plugin name and version.
	     */
	    Plugin.toString = function(plugin) {
	        return typeof plugin === 'string' ? plugin : (plugin.name || 'anonymous') + '@' + (plugin.version || plugin.range || '0.0.0');
	    };
	
	    /**
	     * Returns `true` if the object meets the minimum standard to be considered a plugin.
	     * This means it must define the following properties:
	     * - `name`
	     * - `version`
	     * - `install`
	     * @method isPlugin
	     * @param obj {} The obj to test.
	     * @return {boolean} `true` if the object can be considered a plugin otherwise `false`.
	     */
	    Plugin.isPlugin = function(obj) {
	        return obj && obj.name && obj.version && obj.install;
	    };
	
	    /**
	     * Returns `true` if a plugin with the given `name` been installed on `module`.
	     * @method isUsed
	     * @param module {} The module.
	     * @param name {string} The plugin name.
	     * @return {boolean} `true` if a plugin with the given `name` been installed on `module`, otherwise `false`.
	     */
	    Plugin.isUsed = function(module, name) {
	        return module.used.indexOf(name) > -1;
	    };
	
	    /**
	     * Returns `true` if `plugin.for` is applicable to `module` by comparing against `module.name` and `module.version`.
	     * If `plugin.for` is not specified then it is assumed to be applicable.
	     * The value of `plugin.for` is a string of the format `'module-name'` or `'module-name@version'`.
	     * @method isFor
	     * @param plugin {} The plugin.
	     * @param module {} The module.
	     * @return {boolean} `true` if `plugin.for` is applicable to `module`, otherwise `false`.
	     */
	    Plugin.isFor = function(plugin, module) {
	        var parsed = plugin.for && Plugin.dependencyParse(plugin.for);
	        return !plugin.for || (module.name === parsed.name && Plugin.versionSatisfies(module.version, parsed.range));
	    };
	
	    /**
	     * Installs the plugins by calling `plugin.install` on each plugin specified in `plugins` if passed, otherwise `module.uses`.
	     * For installing plugins on `Matter` see the convenience function `Matter.use`.
	     * Plugins may be specified either by their name or a reference to the plugin object.
	     * Plugins themselves may specify further dependencies, but each plugin is installed only once.
	     * Order is important, a topological sort is performed to find the best resulting order of installation.
	     * This sorting attempts to satisfy every dependency's requested ordering, but may not be exact in all cases.
	     * This function logs the resulting status of each dependency in the console, along with any warnings.
	     * - A green tick ✅ indicates a dependency was resolved and installed.
	     * - An orange diamond 🔶 indicates a dependency was resolved but a warning was thrown for it or one if its dependencies.
	     * - A red cross ❌ indicates a dependency could not be resolved.
	     * Avoid calling this function multiple times on the same module unless you intend to manually control installation order.
	     * @method use
	     * @param module {} The module install plugins on.
	     * @param [plugins=module.uses] {} The plugins to install on module (optional, defaults to `module.uses`).
	     */
	    Plugin.use = function(module, plugins) {
	        module.uses = (module.uses || []).concat(plugins || []);
	
	        if (module.uses.length === 0) {
	            Common.warn('Plugin.use:', Plugin.toString(module), 'does not specify any dependencies to install.');
	            return;
	        }
	
	        var dependencies = Plugin.dependencies(module),
	            sortedDependencies = Common.topologicalSort(dependencies),
	            status = [];
	
	        for (var i = 0; i < sortedDependencies.length; i += 1) {
	            if (sortedDependencies[i] === module.name) {
	                continue;
	            }
	
	            var plugin = Plugin.resolve(sortedDependencies[i]);
	
	            if (!plugin) {
	                status.push('❌ ' + sortedDependencies[i]);
	                continue;
	            }
	
	            if (Plugin.isUsed(module, plugin.name)) {
	                continue;
	            }
	
	            if (!Plugin.isFor(plugin, module)) {
	                Common.warn('Plugin.use:', Plugin.toString(plugin), 'is for', plugin.for, 'but installed on', Plugin.toString(module) + '.');
	                plugin._warned = true;
	            }
	
	            if (plugin.install) {
	                plugin.install(module);
	            } else {
	                Common.warn('Plugin.use:', Plugin.toString(plugin), 'does not specify an install function.');
	                plugin._warned = true;
	            }
	
	            if (plugin._warned) {
	                status.push('🔶 ' + Plugin.toString(plugin));
	                delete plugin._warned;
	            } else {
	                status.push('✅ ' + Plugin.toString(plugin));
	            }
	
	            module.used.push(plugin.name);
	        }
	
	        if (status.length > 0) {
	            Common.info(status.join('  '));
	        }
	    };
	
	    /**
	     * Recursively finds all of a module's dependencies and returns a flat dependency graph.
	     * @method dependencies
	     * @param module {} The module.
	     * @return {object} A dependency graph.
	     */
	    Plugin.dependencies = function(module, tracked) {
	        var parsedBase = Plugin.dependencyParse(module),
	            name = parsedBase.name;
	
	        tracked = tracked || {};
	
	        if (name in tracked) {
	            return;
	        }
	
	        module = Plugin.resolve(module) || module;
	
	        tracked[name] = Common.map(module.uses || [], function(dependency) {
	            if (Plugin.isPlugin(dependency)) {
	                Plugin.register(dependency);
	            }
	
	            var parsed = Plugin.dependencyParse(dependency),
	                resolved = Plugin.resolve(dependency);
	
	            if (resolved && !Plugin.versionSatisfies(resolved.version, parsed.range)) {
	                Common.warn(
	                    'Plugin.dependencies:', Plugin.toString(resolved), 'does not satisfy',
	                    Plugin.toString(parsed), 'used by', Plugin.toString(parsedBase) + '.'
	                );
	
	                resolved._warned = true;
	                module._warned = true;
	            } else if (!resolved) {
	                Common.warn(
	                    'Plugin.dependencies:', Plugin.toString(dependency), 'used by',
	                    Plugin.toString(parsedBase), 'could not be resolved.'
	                );
	
	                module._warned = true;
	            }
	
	            return parsed.name;
	        });
	
	        for (var i = 0; i < tracked[name].length; i += 1) {
	            Plugin.dependencies(tracked[name][i], tracked);
	        }
	
	        return tracked;
	    };
	
	    /**
	     * Parses a dependency string into its components.
	     * The `dependency` is a string of the format `'module-name'` or `'module-name@version'`.
	     * See documentation for `Plugin.versionParse` for a description of the format.
	     * This function can also handle dependencies that are already resolved (e.g. a module object).
	     * @method dependencyParse
	     * @param dependency {string} The dependency of the format `'module-name'` or `'module-name@version'`.
	     * @return {object} The dependency parsed into its components.
	     */
	    Plugin.dependencyParse = function(dependency) {
	        if (Common.isString(dependency)) {
	            var pattern = /^[\w-]+(@(\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?))?$/;
	
	            if (!pattern.test(dependency)) {
	                Common.warn('Plugin.dependencyParse:', dependency, 'is not a valid dependency string.');
	            }
	
	            return {
	                name: dependency.split('@')[0],
	                range: dependency.split('@')[1] || '*'
	            };
	        }
	
	        return {
	            name: dependency.name,
	            range: dependency.range || dependency.version
	        };
	    };
	
	    /**
	     * Parses a version string into its components.  
	     * Versions are strictly of the format `x.y.z` (as in [semver](http://semver.org/)).
	     * Versions may optionally have a prerelease tag in the format `x.y.z-alpha`.
	     * Ranges are a strict subset of [npm ranges](https://docs.npmjs.com/misc/semver#advanced-range-syntax).
	     * Only the following range types are supported:
	     * - Tilde ranges e.g. `~1.2.3`
	     * - Caret ranges e.g. `^1.2.3`
	     * - Exact version e.g. `1.2.3`
	     * - Any version `*`
	     * @method versionParse
	     * @param range {string} The version string.
	     * @return {object} The version range parsed into its components.
	     */
	    Plugin.versionParse = function(range) {
	        var pattern = /^\*|[\^~]?\d+\.\d+\.\d+(-[0-9A-Za-z-]+)?$/;
	
	        if (!pattern.test(range)) {
	            Common.warn('Plugin.versionParse:', range, 'is not a valid version or range.');
	        }
	
	        var identifiers = range.split('-');
	        range = identifiers[0];
	
	        var isRange = isNaN(Number(range[0])),
	            version = isRange ? range.substr(1) : range,
	            parts = Common.map(version.split('.'), function(part) {
	                return Number(part);
	            });
	
	        return {
	            isRange: isRange,
	            version: version,
	            range: range,
	            operator: isRange ? range[0] : '',
	            parts: parts,
	            prerelease: identifiers[1],
	            number: parts[0] * 1e8 + parts[1] * 1e4 + parts[2]
	        };
	    };
	
	    /**
	     * Returns `true` if `version` satisfies the given `range`.
	     * See documentation for `Plugin.versionParse` for a description of the format.
	     * If a version or range is not specified, then any version (`*`) is assumed to satisfy.
	     * @method versionSatisfies
	     * @param version {string} The version string.
	     * @param range {string} The range string.
	     * @return {boolean} `true` if `version` satisfies `range`, otherwise `false`.
	     */
	    Plugin.versionSatisfies = function(version, range) {
	        range = range || '*';
	
	        var rangeParsed = Plugin.versionParse(range),
	            rangeParts = rangeParsed.parts,
	            versionParsed = Plugin.versionParse(version),
	            versionParts = versionParsed.parts;
	
	        if (rangeParsed.isRange) {
	            if (rangeParsed.operator === '*' || version === '*') {
	                return true;
	            }
	
	            if (rangeParsed.operator === '~') {
	                return versionParts[0] === rangeParts[0] && versionParts[1] === rangeParts[1] && versionParts[2] >= rangeParts[2];
	            }
	
	            if (rangeParsed.operator === '^') {
	                if (rangeParts[0] > 0) {
	                    return versionParts[0] === rangeParts[0] && versionParsed.number >= rangeParsed.number;
	                }
	
	                if (rangeParts[1] > 0) {
	                    return versionParts[1] === rangeParts[1] && versionParts[2] >= rangeParts[2];
	                }
	
	                return versionParts[2] === rangeParts[2];
	            }
	        }
	
	        return version === range || version === '*';
	    };
	
	})();
	
	},{"./Common":14}],21:[function(_dereq_,module,exports){
	/**
	* The `Matter.Runner` module is an optional utility which provides a game loop, 
	* that handles continuously updating a `Matter.Engine` for you within a browser.
	* It is intended for development and debugging purposes, but may also be suitable for simple games.
	* If you are using your own game loop instead, then you do not need the `Matter.Runner` module.
	* Instead just call `Engine.update(engine, delta)` in your own loop.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Runner
	*/
	
	var Runner = {};
	
	module.exports = Runner;
	
	var Events = _dereq_('./Events');
	var Engine = _dereq_('./Engine');
	var Common = _dereq_('./Common');
	
	(function() {
	
	    var _requestAnimationFrame,
	        _cancelAnimationFrame;
	
	    if (typeof window !== 'undefined') {
	        _requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame
	                                      || window.mozRequestAnimationFrame || window.msRequestAnimationFrame;
	   
	        _cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame 
	                                      || window.webkitCancelAnimationFrame || window.msCancelAnimationFrame;
	    }
	
	    if (!_requestAnimationFrame) {
	        var _frameTimeout;
	
	        _requestAnimationFrame = function(callback){ 
	            _frameTimeout = setTimeout(function() { 
	                callback(Common.now()); 
	            }, 1000 / 60);
	        };
	
	        _cancelAnimationFrame = function() {
	            clearTimeout(_frameTimeout);
	        };
	    }
	
	    /**
	     * Creates a new Runner. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * @method create
	     * @param {} options
	     */
	    Runner.create = function(options) {
	        var defaults = {
	            fps: 60,
	            correction: 1,
	            deltaSampleSize: 60,
	            counterTimestamp: 0,
	            frameCounter: 0,
	            deltaHistory: [],
	            timePrev: null,
	            timeScalePrev: 1,
	            frameRequestId: null,
	            isFixed: false,
	            enabled: true
	        };
	
	        var runner = Common.extend(defaults, options);
	
	        runner.delta = runner.delta || 1000 / runner.fps;
	        runner.deltaMin = runner.deltaMin || 1000 / runner.fps;
	        runner.deltaMax = runner.deltaMax || 1000 / (runner.fps * 0.5);
	        runner.fps = 1000 / runner.delta;
	
	        return runner;
	    };
	
	    /**
	     * Continuously ticks a `Matter.Engine` by calling `Runner.tick` on the `requestAnimationFrame` event.
	     * @method run
	     * @param {engine} engine
	     */
	    Runner.run = function(runner, engine) {
	        // create runner if engine is first argument
	        if (typeof runner.positionIterations !== 'undefined') {
	            engine = runner;
	            runner = Runner.create();
	        }
	
	        (function render(time){
	            runner.frameRequestId = _requestAnimationFrame(render);
	
	            if (time && runner.enabled) {
	                Runner.tick(runner, engine, time);
	            }
	        })();
	
	        return runner;
	    };
	
	    /**
	     * A game loop utility that updates the engine and renderer by one step (a 'tick').
	     * Features delta smoothing, time correction and fixed or dynamic timing.
	     * Triggers `beforeTick`, `tick` and `afterTick` events on the engine.
	     * Consider just `Engine.update(engine, delta)` if you're using your own loop.
	     * @method tick
	     * @param {runner} runner
	     * @param {engine} engine
	     * @param {number} time
	     */
	    Runner.tick = function(runner, engine, time) {
	        var timing = engine.timing,
	            correction = 1,
	            delta;
	
	        // create an event object
	        var event = {
	            timestamp: timing.timestamp
	        };
	
	        Events.trigger(runner, 'beforeTick', event);
	        Events.trigger(engine, 'beforeTick', event); // @deprecated
	
	        if (runner.isFixed) {
	            // fixed timestep
	            delta = runner.delta;
	        } else {
	            // dynamic timestep based on wall clock between calls
	            delta = (time - runner.timePrev) || runner.delta;
	            runner.timePrev = time;
	
	            // optimistically filter delta over a few frames, to improve stability
	            runner.deltaHistory.push(delta);
	            runner.deltaHistory = runner.deltaHistory.slice(-runner.deltaSampleSize);
	            delta = Math.min.apply(null, runner.deltaHistory);
	            
	            // limit delta
	            delta = delta < runner.deltaMin ? runner.deltaMin : delta;
	            delta = delta > runner.deltaMax ? runner.deltaMax : delta;
	
	            // correction for delta
	            correction = delta / runner.delta;
	
	            // update engine timing object
	            runner.delta = delta;
	        }
	
	        // time correction for time scaling
	        if (runner.timeScalePrev !== 0)
	            correction *= timing.timeScale / runner.timeScalePrev;
	
	        if (timing.timeScale === 0)
	            correction = 0;
	
	        runner.timeScalePrev = timing.timeScale;
	        runner.correction = correction;
	
	        // fps counter
	        runner.frameCounter += 1;
	        if (time - runner.counterTimestamp >= 1000) {
	            runner.fps = runner.frameCounter * ((time - runner.counterTimestamp) / 1000);
	            runner.counterTimestamp = time;
	            runner.frameCounter = 0;
	        }
	
	        Events.trigger(runner, 'tick', event);
	        Events.trigger(engine, 'tick', event); // @deprecated
	
	        // if world has been modified, clear the render scene graph
	        if (engine.world.isModified 
	            && engine.render
	            && engine.render.controller
	            && engine.render.controller.clear) {
	            engine.render.controller.clear(engine.render); // @deprecated
	        }
	
	        // update
	        Events.trigger(runner, 'beforeUpdate', event);
	        Engine.update(engine, delta, correction);
	        Events.trigger(runner, 'afterUpdate', event);
	
	        // render
	        // @deprecated
	        if (engine.render && engine.render.controller) {
	            Events.trigger(runner, 'beforeRender', event);
	            Events.trigger(engine, 'beforeRender', event); // @deprecated
	
	            engine.render.controller.world(engine.render);
	
	            Events.trigger(runner, 'afterRender', event);
	            Events.trigger(engine, 'afterRender', event); // @deprecated
	        }
	
	        Events.trigger(runner, 'afterTick', event);
	        Events.trigger(engine, 'afterTick', event); // @deprecated
	    };
	
	    /**
	     * Ends execution of `Runner.run` on the given `runner`, by canceling the animation frame request event loop.
	     * If you wish to only temporarily pause the engine, see `engine.enabled` instead.
	     * @method stop
	     * @param {runner} runner
	     */
	    Runner.stop = function(runner) {
	        _cancelAnimationFrame(runner.frameRequestId);
	    };
	
	    /**
	     * Alias for `Runner.run`.
	     * @method start
	     * @param {runner} runner
	     * @param {engine} engine
	     */
	    Runner.start = function(runner, engine) {
	        Runner.run(runner, engine);
	    };
	
	    /*
	    *
	    *  Events Documentation
	    *
	    */
	
	    /**
	    * Fired at the start of a tick, before any updates to the engine or timing
	    *
	    * @event beforeTick
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after engine timing updated, but just before update
	    *
	    * @event tick
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired at the end of a tick, after engine update and after rendering
	    *
	    * @event afterTick
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired before update
	    *
	    * @event beforeUpdate
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after update
	    *
	    * @event afterUpdate
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired before rendering
	    *
	    * @event beforeRender
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    * @deprecated
	    */
	
	    /**
	    * Fired after rendering
	    *
	    * @event afterRender
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    * @deprecated
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * A flag that specifies whether the runner is running or not.
	     *
	     * @property enabled
	     * @type boolean
	     * @default true
	     */
	
	    /**
	     * A `Boolean` that specifies if the runner should use a fixed timestep (otherwise it is variable).
	     * If timing is fixed, then the apparent simulation speed will change depending on the frame rate (but behaviour will be deterministic).
	     * If the timing is variable, then the apparent simulation speed will be constant (approximately, but at the cost of determininism).
	     *
	     * @property isFixed
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * A `Number` that specifies the time step between updates in milliseconds.
	     * If `engine.timing.isFixed` is set to `true`, then `delta` is fixed.
	     * If it is `false`, then `delta` can dynamically change to maintain the correct apparent simulation speed.
	     *
	     * @property delta
	     * @type number
	     * @default 1000 / 60
	     */
	
	})();
	
	},{"./Common":14,"./Engine":15,"./Events":16}],22:[function(_dereq_,module,exports){
	/**
	* The `Matter.Sleeping` module contains methods to manage the sleeping state of bodies.
	*
	* @class Sleeping
	*/
	
	var Sleeping = {};
	
	module.exports = Sleeping;
	
	var Events = _dereq_('./Events');
	
	(function() {
	
	    Sleeping._motionWakeThreshold = 0.18;
	    Sleeping._motionSleepThreshold = 0.08;
	    Sleeping._minBias = 0.9;
	
	    /**
	     * Puts bodies to sleep or wakes them up depending on their motion.
	     * @method update
	     * @param {body[]} bodies
	     * @param {number} timeScale
	     */
	    Sleeping.update = function(bodies, timeScale) {
	        var timeFactor = timeScale * timeScale * timeScale;
	
	        // update bodies sleeping status
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                motion = body.speed * body.speed + body.angularSpeed * body.angularSpeed;
	
	            // wake up bodies if they have a force applied
	            if (body.force.x !== 0 || body.force.y !== 0) {
	                Sleeping.set(body, false);
	                continue;
	            }
	
	            var minMotion = Math.min(body.motion, motion),
	                maxMotion = Math.max(body.motion, motion);
	        
	            // biased average motion estimation between frames
	            body.motion = Sleeping._minBias * minMotion + (1 - Sleeping._minBias) * maxMotion;
	            
	            if (body.sleepThreshold > 0 && body.motion < Sleeping._motionSleepThreshold * timeFactor) {
	                body.sleepCounter += 1;
	                
	                if (body.sleepCounter >= body.sleepThreshold)
	                    Sleeping.set(body, true);
	            } else if (body.sleepCounter > 0) {
	                body.sleepCounter -= 1;
	            }
	        }
	    };
	
	    /**
	     * Given a set of colliding pairs, wakes the sleeping bodies involved.
	     * @method afterCollisions
	     * @param {pair[]} pairs
	     * @param {number} timeScale
	     */
	    Sleeping.afterCollisions = function(pairs, timeScale) {
	        var timeFactor = timeScale * timeScale * timeScale;
	
	        // wake up bodies involved in collisions
	        for (var i = 0; i < pairs.length; i++) {
	            var pair = pairs[i];
	            
	            // don't wake inactive pairs
	            if (!pair.isActive)
	                continue;
	
	            var collision = pair.collision,
	                bodyA = collision.bodyA.parent, 
	                bodyB = collision.bodyB.parent;
	        
	            // don't wake if at least one body is static
	            if ((bodyA.isSleeping && bodyB.isSleeping) || bodyA.isStatic || bodyB.isStatic)
	                continue;
	        
	            if (bodyA.isSleeping || bodyB.isSleeping) {
	                var sleepingBody = (bodyA.isSleeping && !bodyA.isStatic) ? bodyA : bodyB,
	                    movingBody = sleepingBody === bodyA ? bodyB : bodyA;
	
	                if (!sleepingBody.isStatic && movingBody.motion > Sleeping._motionWakeThreshold * timeFactor) {
	                    Sleeping.set(sleepingBody, false);
	                }
	            }
	        }
	    };
	  
	    /**
	     * Set a body as sleeping or awake.
	     * @method set
	     * @param {body} body
	     * @param {boolean} isSleeping
	     */
	    Sleeping.set = function(body, isSleeping) {
	        var wasSleeping = body.isSleeping;
	
	        if (isSleeping) {
	            body.isSleeping = true;
	            body.sleepCounter = body.sleepThreshold;
	
	            body.positionImpulse.x = 0;
	            body.positionImpulse.y = 0;
	
	            body.positionPrev.x = body.position.x;
	            body.positionPrev.y = body.position.y;
	
	            body.anglePrev = body.angle;
	            body.speed = 0;
	            body.angularSpeed = 0;
	            body.motion = 0;
	
	            if (!wasSleeping) {
	                Events.trigger(body, 'sleepStart');
	            }
	        } else {
	            body.isSleeping = false;
	            body.sleepCounter = 0;
	
	            if (wasSleeping) {
	                Events.trigger(body, 'sleepEnd');
	            }
	        }
	    };
	
	})();
	
	},{"./Events":16}],23:[function(_dereq_,module,exports){
	/**
	* The `Matter.Bodies` module contains factory methods for creating rigid body models 
	* with commonly used body configurations (such as rectangles, circles and other polygons).
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Bodies
	*/
	
	// TODO: true circle bodies
	
	var Bodies = {};
	
	module.exports = Bodies;
	
	var Vertices = _dereq_('../geometry/Vertices');
	var Common = _dereq_('../core/Common');
	var Body = _dereq_('../body/Body');
	var Bounds = _dereq_('../geometry/Bounds');
	var Vector = _dereq_('../geometry/Vector');
	var decomp;
	
	(function() {
	
	    /**
	     * Creates a new rigid body model with a rectangle hull. 
	     * The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method rectangle
	     * @param {number} x
	     * @param {number} y
	     * @param {number} width
	     * @param {number} height
	     * @param {object} [options]
	     * @return {body} A new rectangle body
	     */
	    Bodies.rectangle = function(x, y, width, height, options) {
	        options = options || {};
	
	        var rectangle = { 
	            label: 'Rectangle Body',
	            position: { x: x, y: y },
	            vertices: Vertices.fromPath('L 0 0 L ' + width + ' 0 L ' + width + ' ' + height + ' L 0 ' + height)
	        };
	
	        if (options.chamfer) {
	            var chamfer = options.chamfer;
	            rectangle.vertices = Vertices.chamfer(rectangle.vertices, chamfer.radius, 
	                                    chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
	            delete options.chamfer;
	        }
	
	        return Body.create(Common.extend({}, rectangle, options));
	    };
	    
	    /**
	     * Creates a new rigid body model with a trapezoid hull. 
	     * The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method trapezoid
	     * @param {number} x
	     * @param {number} y
	     * @param {number} width
	     * @param {number} height
	     * @param {number} slope
	     * @param {object} [options]
	     * @return {body} A new trapezoid body
	     */
	    Bodies.trapezoid = function(x, y, width, height, slope, options) {
	        options = options || {};
	
	        slope *= 0.5;
	        var roof = (1 - (slope * 2)) * width;
	        
	        var x1 = width * slope,
	            x2 = x1 + roof,
	            x3 = x2 + x1,
	            verticesPath;
	
	        if (slope < 0.5) {
	            verticesPath = 'L 0 0 L ' + x1 + ' ' + (-height) + ' L ' + x2 + ' ' + (-height) + ' L ' + x3 + ' 0';
	        } else {
	            verticesPath = 'L 0 0 L ' + x2 + ' ' + (-height) + ' L ' + x3 + ' 0';
	        }
	
	        var trapezoid = { 
	            label: 'Trapezoid Body',
	            position: { x: x, y: y },
	            vertices: Vertices.fromPath(verticesPath)
	        };
	
	        if (options.chamfer) {
	            var chamfer = options.chamfer;
	            trapezoid.vertices = Vertices.chamfer(trapezoid.vertices, chamfer.radius, 
	                                    chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
	            delete options.chamfer;
	        }
	
	        return Body.create(Common.extend({}, trapezoid, options));
	    };
	
	    /**
	     * Creates a new rigid body model with a circle hull. 
	     * The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method circle
	     * @param {number} x
	     * @param {number} y
	     * @param {number} radius
	     * @param {object} [options]
	     * @param {number} [maxSides]
	     * @return {body} A new circle body
	     */
	    Bodies.circle = function(x, y, radius, options, maxSides) {
	        options = options || {};
	
	        var circle = {
	            label: 'Circle Body',
	            circleRadius: radius
	        };
	        
	        // approximate circles with polygons until true circles implemented in SAT
	        maxSides = maxSides || 25;
	        var sides = Math.ceil(Math.max(10, Math.min(maxSides, radius)));
	
	        // optimisation: always use even number of sides (half the number of unique axes)
	        if (sides % 2 === 1)
	            sides += 1;
	
	        return Bodies.polygon(x, y, sides, radius, Common.extend({}, circle, options));
	    };
	
	    /**
	     * Creates a new rigid body model with a regular polygon hull with the given number of sides. 
	     * The options parameter is an object that specifies any properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method polygon
	     * @param {number} x
	     * @param {number} y
	     * @param {number} sides
	     * @param {number} radius
	     * @param {object} [options]
	     * @return {body} A new regular polygon body
	     */
	    Bodies.polygon = function(x, y, sides, radius, options) {
	        options = options || {};
	
	        if (sides < 3)
	            return Bodies.circle(x, y, radius, options);
	
	        var theta = 2 * Math.PI / sides,
	            path = '',
	            offset = theta * 0.5;
	
	        for (var i = 0; i < sides; i += 1) {
	            var angle = offset + (i * theta),
	                xx = Math.cos(angle) * radius,
	                yy = Math.sin(angle) * radius;
	
	            path += 'L ' + xx.toFixed(3) + ' ' + yy.toFixed(3) + ' ';
	        }
	
	        var polygon = { 
	            label: 'Polygon Body',
	            position: { x: x, y: y },
	            vertices: Vertices.fromPath(path)
	        };
	
	        if (options.chamfer) {
	            var chamfer = options.chamfer;
	            polygon.vertices = Vertices.chamfer(polygon.vertices, chamfer.radius, 
	                                    chamfer.quality, chamfer.qualityMin, chamfer.qualityMax);
	            delete options.chamfer;
	        }
	
	        return Body.create(Common.extend({}, polygon, options));
	    };
	
	    /**
	     * Creates a body using the supplied vertices (or an array containing multiple sets of vertices).
	     * If the vertices are convex, they will pass through as supplied.
	     * Otherwise if the vertices are concave, they will be decomposed if [poly-decomp.js](https://github.com/schteppe/poly-decomp.js) is available.
	     * Note that this process is not guaranteed to support complex sets of vertices (e.g. those with holes may fail).
	     * By default the decomposition will discard collinear edges (to improve performance).
	     * It can also optionally discard any parts that have an area less than `minimumArea`.
	     * If the vertices can not be decomposed, the result will fall back to using the convex hull.
	     * The options parameter is an object that specifies any `Matter.Body` properties you wish to override the defaults.
	     * See the properties section of the `Matter.Body` module for detailed information on what you can pass via the `options` object.
	     * @method fromVertices
	     * @param {number} x
	     * @param {number} y
	     * @param [[vector]] vertexSets
	     * @param {object} [options]
	     * @param {bool} [flagInternal=false]
	     * @param {number} [removeCollinear=0.01]
	     * @param {number} [minimumArea=10]
	     * @return {body}
	     */
	    Bodies.fromVertices = function(x, y, vertexSets, options, flagInternal, removeCollinear, minimumArea) {
	        if (!decomp) {
	            decomp = Common._requireGlobal('decomp', 'poly-decomp');
	        }
	
	        var body,
	            parts,
	            isConvex,
	            vertices,
	            i,
	            j,
	            k,
	            v,
	            z;
	
	        options = options || {};
	        parts = [];
	
	        flagInternal = typeof flagInternal !== 'undefined' ? flagInternal : false;
	        removeCollinear = typeof removeCollinear !== 'undefined' ? removeCollinear : 0.01;
	        minimumArea = typeof minimumArea !== 'undefined' ? minimumArea : 10;
	
	        if (!decomp) {
	            Common.warn('Bodies.fromVertices: poly-decomp.js required. Could not decompose vertices. Fallback to convex hull.');
	        }
	
	        // ensure vertexSets is an array of arrays
	        if (!Common.isArray(vertexSets[0])) {
	            vertexSets = [vertexSets];
	        }
	
	        for (v = 0; v < vertexSets.length; v += 1) {
	            vertices = vertexSets[v];
	            isConvex = Vertices.isConvex(vertices);
	
	            if (isConvex || !decomp) {
	                if (isConvex) {
	                    vertices = Vertices.clockwiseSort(vertices);
	                } else {
	                    // fallback to convex hull when decomposition is not possible
	                    vertices = Vertices.hull(vertices);
	                }
	
	                parts.push({
	                    position: { x: x, y: y },
	                    vertices: vertices
	                });
	            } else {
	                // initialise a decomposition
	                var concave = vertices.map(function(vertex) {
	                    return [vertex.x, vertex.y];
	                });
	
	                // vertices are concave and simple, we can decompose into parts
	                decomp.makeCCW(concave);
	                if (removeCollinear !== false)
	                    decomp.removeCollinearPoints(concave, removeCollinear);
	
	                // use the quick decomposition algorithm (Bayazit)
	                var decomposed = decomp.quickDecomp(concave);
	
	                // for each decomposed chunk
	                for (i = 0; i < decomposed.length; i++) {
	                    var chunk = decomposed[i];
	
	                    // convert vertices into the correct structure
	                    var chunkVertices = chunk.map(function(vertices) {
	                        return {
	                            x: vertices[0],
	                            y: vertices[1]
	                        };
	                    });
	
	                    // skip small chunks
	                    if (minimumArea > 0 && Vertices.area(chunkVertices) < minimumArea)
	                        continue;
	
	                    // create a compound part
	                    parts.push({
	                        position: Vertices.centre(chunkVertices),
	                        vertices: chunkVertices
	                    });
	                }
	            }
	        }
	
	        // create body parts
	        for (i = 0; i < parts.length; i++) {
	            parts[i] = Body.create(Common.extend(parts[i], options));
	        }
	
	        // flag internal edges (coincident part edges)
	        if (flagInternal) {
	            var coincident_max_dist = 5;
	
	            for (i = 0; i < parts.length; i++) {
	                var partA = parts[i];
	
	                for (j = i + 1; j < parts.length; j++) {
	                    var partB = parts[j];
	
	                    if (Bounds.overlaps(partA.bounds, partB.bounds)) {
	                        var pav = partA.vertices,
	                            pbv = partB.vertices;
	
	                        // iterate vertices of both parts
	                        for (k = 0; k < partA.vertices.length; k++) {
	                            for (z = 0; z < partB.vertices.length; z++) {
	                                // find distances between the vertices
	                                var da = Vector.magnitudeSquared(Vector.sub(pav[(k + 1) % pav.length], pbv[z])),
	                                    db = Vector.magnitudeSquared(Vector.sub(pav[k], pbv[(z + 1) % pbv.length]));
	
	                                // if both vertices are very close, consider the edge concident (internal)
	                                if (da < coincident_max_dist && db < coincident_max_dist) {
	                                    pav[k].isInternal = true;
	                                    pbv[z].isInternal = true;
	                                }
	                            }
	                        }
	
	                    }
	                }
	            }
	        }
	
	        if (parts.length > 1) {
	            // create the parent body to be returned, that contains generated compound parts
	            body = Body.create(Common.extend({ parts: parts.slice(0) }, options));
	            Body.setPosition(body, { x: x, y: y });
	
	            return body;
	        } else {
	            return parts[0];
	        }
	    };
	
	})();
	
	},{"../body/Body":1,"../core/Common":14,"../geometry/Bounds":26,"../geometry/Vector":28,"../geometry/Vertices":29}],24:[function(_dereq_,module,exports){
	/**
	* The `Matter.Composites` module contains factory methods for creating composite bodies
	* with commonly used configurations (such as stacks and chains).
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Composites
	*/
	
	var Composites = {};
	
	module.exports = Composites;
	
	var Composite = _dereq_('../body/Composite');
	var Constraint = _dereq_('../constraint/Constraint');
	var Common = _dereq_('../core/Common');
	var Body = _dereq_('../body/Body');
	var Bodies = _dereq_('./Bodies');
	
	(function() {
	
	    /**
	     * Create a new composite containing bodies created in the callback in a grid arrangement.
	     * This function uses the body's bounds to prevent overlaps.
	     * @method stack
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} columns
	     * @param {number} rows
	     * @param {number} columnGap
	     * @param {number} rowGap
	     * @param {function} callback
	     * @return {composite} A new composite containing objects created in the callback
	     */
	    Composites.stack = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
	        var stack = Composite.create({ label: 'Stack' }),
	            x = xx,
	            y = yy,
	            lastBody,
	            i = 0;
	
	        for (var row = 0; row < rows; row++) {
	            var maxHeight = 0;
	            
	            for (var column = 0; column < columns; column++) {
	                var body = callback(x, y, column, row, lastBody, i);
	                    
	                if (body) {
	                    var bodyHeight = body.bounds.max.y - body.bounds.min.y,
	                        bodyWidth = body.bounds.max.x - body.bounds.min.x; 
	
	                    if (bodyHeight > maxHeight)
	                        maxHeight = bodyHeight;
	                    
	                    Body.translate(body, { x: bodyWidth * 0.5, y: bodyHeight * 0.5 });
	
	                    x = body.bounds.max.x + columnGap;
	
	                    Composite.addBody(stack, body);
	                    
	                    lastBody = body;
	                    i += 1;
	                } else {
	                    x += columnGap;
	                }
	            }
	            
	            y += maxHeight + rowGap;
	            x = xx;
	        }
	
	        return stack;
	    };
	    
	    /**
	     * Chains all bodies in the given composite together using constraints.
	     * @method chain
	     * @param {composite} composite
	     * @param {number} xOffsetA
	     * @param {number} yOffsetA
	     * @param {number} xOffsetB
	     * @param {number} yOffsetB
	     * @param {object} options
	     * @return {composite} A new composite containing objects chained together with constraints
	     */
	    Composites.chain = function(composite, xOffsetA, yOffsetA, xOffsetB, yOffsetB, options) {
	        var bodies = composite.bodies;
	        
	        for (var i = 1; i < bodies.length; i++) {
	            var bodyA = bodies[i - 1],
	                bodyB = bodies[i],
	                bodyAHeight = bodyA.bounds.max.y - bodyA.bounds.min.y,
	                bodyAWidth = bodyA.bounds.max.x - bodyA.bounds.min.x, 
	                bodyBHeight = bodyB.bounds.max.y - bodyB.bounds.min.y,
	                bodyBWidth = bodyB.bounds.max.x - bodyB.bounds.min.x;
	        
	            var defaults = {
	                bodyA: bodyA,
	                pointA: { x: bodyAWidth * xOffsetA, y: bodyAHeight * yOffsetA },
	                bodyB: bodyB,
	                pointB: { x: bodyBWidth * xOffsetB, y: bodyBHeight * yOffsetB }
	            };
	            
	            var constraint = Common.extend(defaults, options);
	        
	            Composite.addConstraint(composite, Constraint.create(constraint));
	        }
	
	        composite.label += ' Chain';
	        
	        return composite;
	    };
	
	    /**
	     * Connects bodies in the composite with constraints in a grid pattern, with optional cross braces.
	     * @method mesh
	     * @param {composite} composite
	     * @param {number} columns
	     * @param {number} rows
	     * @param {boolean} crossBrace
	     * @param {object} options
	     * @return {composite} The composite containing objects meshed together with constraints
	     */
	    Composites.mesh = function(composite, columns, rows, crossBrace, options) {
	        var bodies = composite.bodies,
	            row,
	            col,
	            bodyA,
	            bodyB,
	            bodyC;
	        
	        for (row = 0; row < rows; row++) {
	            for (col = 1; col < columns; col++) {
	                bodyA = bodies[(col - 1) + (row * columns)];
	                bodyB = bodies[col + (row * columns)];
	                Composite.addConstraint(composite, Constraint.create(Common.extend({ bodyA: bodyA, bodyB: bodyB }, options)));
	            }
	
	            if (row > 0) {
	                for (col = 0; col < columns; col++) {
	                    bodyA = bodies[col + ((row - 1) * columns)];
	                    bodyB = bodies[col + (row * columns)];
	                    Composite.addConstraint(composite, Constraint.create(Common.extend({ bodyA: bodyA, bodyB: bodyB }, options)));
	
	                    if (crossBrace && col > 0) {
	                        bodyC = bodies[(col - 1) + ((row - 1) * columns)];
	                        Composite.addConstraint(composite, Constraint.create(Common.extend({ bodyA: bodyC, bodyB: bodyB }, options)));
	                    }
	
	                    if (crossBrace && col < columns - 1) {
	                        bodyC = bodies[(col + 1) + ((row - 1) * columns)];
	                        Composite.addConstraint(composite, Constraint.create(Common.extend({ bodyA: bodyC, bodyB: bodyB }, options)));
	                    }
	                }
	            }
	        }
	
	        composite.label += ' Mesh';
	        
	        return composite;
	    };
	    
	    /**
	     * Create a new composite containing bodies created in the callback in a pyramid arrangement.
	     * This function uses the body's bounds to prevent overlaps.
	     * @method pyramid
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} columns
	     * @param {number} rows
	     * @param {number} columnGap
	     * @param {number} rowGap
	     * @param {function} callback
	     * @return {composite} A new composite containing objects created in the callback
	     */
	    Composites.pyramid = function(xx, yy, columns, rows, columnGap, rowGap, callback) {
	        return Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y, column, row, lastBody, i) {
	            var actualRows = Math.min(rows, Math.ceil(columns / 2)),
	                lastBodyWidth = lastBody ? lastBody.bounds.max.x - lastBody.bounds.min.x : 0;
	            
	            if (row > actualRows)
	                return;
	            
	            // reverse row order
	            row = actualRows - row;
	            
	            var start = row,
	                end = columns - 1 - row;
	
	            if (column < start || column > end)
	                return;
	            
	            // retroactively fix the first body's position, since width was unknown
	            if (i === 1) {
	                Body.translate(lastBody, { x: (column + (columns % 2 === 1 ? 1 : -1)) * lastBodyWidth, y: 0 });
	            }
	
	            var xOffset = lastBody ? column * lastBodyWidth : 0;
	            
	            return callback(xx + xOffset + column * columnGap, y, column, row, lastBody, i);
	        });
	    };
	
	    /**
	     * Creates a composite with a Newton's Cradle setup of bodies and constraints.
	     * @method newtonsCradle
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} number
	     * @param {number} size
	     * @param {number} length
	     * @return {composite} A new composite newtonsCradle body
	     */
	    Composites.newtonsCradle = function(xx, yy, number, size, length) {
	        var newtonsCradle = Composite.create({ label: 'Newtons Cradle' });
	
	        for (var i = 0; i < number; i++) {
	            var separation = 1.9,
	                circle = Bodies.circle(xx + i * (size * separation), yy + length, size, 
	                            { inertia: Infinity, restitution: 1, friction: 0, frictionAir: 0.0001, slop: 1 }),
	                constraint = Constraint.create({ pointA: { x: xx + i * (size * separation), y: yy }, bodyB: circle });
	
	            Composite.addBody(newtonsCradle, circle);
	            Composite.addConstraint(newtonsCradle, constraint);
	        }
	
	        return newtonsCradle;
	    };
	    
	    /**
	     * Creates a composite with simple car setup of bodies and constraints.
	     * @method car
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} width
	     * @param {number} height
	     * @param {number} wheelSize
	     * @return {composite} A new composite car body
	     */
	    Composites.car = function(xx, yy, width, height, wheelSize) {
	        var group = Body.nextGroup(true),
	            wheelBase = 20,
	            wheelAOffset = -width * 0.5 + wheelBase,
	            wheelBOffset = width * 0.5 - wheelBase,
	            wheelYOffset = 0;
	    
	        var car = Composite.create({ label: 'Car' }),
	            body = Bodies.rectangle(xx, yy, width, height, { 
	                collisionFilter: {
	                    group: group
	                },
	                chamfer: {
	                    radius: height * 0.5
	                },
	                density: 0.0002
	            });
	    
	        var wheelA = Bodies.circle(xx + wheelAOffset, yy + wheelYOffset, wheelSize, { 
	            collisionFilter: {
	                group: group
	            },
	            friction: 0.8
	        });
	                    
	        var wheelB = Bodies.circle(xx + wheelBOffset, yy + wheelYOffset, wheelSize, { 
	            collisionFilter: {
	                group: group
	            },
	            friction: 0.8
	        });
	                    
	        var axelA = Constraint.create({
	            bodyB: body,
	            pointB: { x: wheelAOffset, y: wheelYOffset },
	            bodyA: wheelA,
	            stiffness: 1,
	            length: 0
	        });
	                        
	        var axelB = Constraint.create({
	            bodyB: body,
	            pointB: { x: wheelBOffset, y: wheelYOffset },
	            bodyA: wheelB,
	            stiffness: 1,
	            length: 0
	        });
	        
	        Composite.addBody(car, body);
	        Composite.addBody(car, wheelA);
	        Composite.addBody(car, wheelB);
	        Composite.addConstraint(car, axelA);
	        Composite.addConstraint(car, axelB);
	
	        return car;
	    };
	
	    /**
	     * Creates a simple soft body like object.
	     * @method softBody
	     * @param {number} xx
	     * @param {number} yy
	     * @param {number} columns
	     * @param {number} rows
	     * @param {number} columnGap
	     * @param {number} rowGap
	     * @param {boolean} crossBrace
	     * @param {number} particleRadius
	     * @param {} particleOptions
	     * @param {} constraintOptions
	     * @return {composite} A new composite softBody
	     */
	    Composites.softBody = function(xx, yy, columns, rows, columnGap, rowGap, crossBrace, particleRadius, particleOptions, constraintOptions) {
	        particleOptions = Common.extend({ inertia: Infinity }, particleOptions);
	        constraintOptions = Common.extend({ stiffness: 0.2, render: { type: 'line', anchors: false } }, constraintOptions);
	
	        var softBody = Composites.stack(xx, yy, columns, rows, columnGap, rowGap, function(x, y) {
	            return Bodies.circle(x, y, particleRadius, particleOptions);
	        });
	
	        Composites.mesh(softBody, columns, rows, crossBrace, constraintOptions);
	
	        softBody.label = 'Soft Body';
	
	        return softBody;
	    };
	
	})();
	
	},{"../body/Body":1,"../body/Composite":2,"../constraint/Constraint":12,"../core/Common":14,"./Bodies":23}],25:[function(_dereq_,module,exports){
	/**
	* The `Matter.Axes` module contains methods for creating and manipulating sets of axes.
	*
	* @class Axes
	*/
	
	var Axes = {};
	
	module.exports = Axes;
	
	var Vector = _dereq_('../geometry/Vector');
	var Common = _dereq_('../core/Common');
	
	(function() {
	
	    /**
	     * Creates a new set of axes from the given vertices.
	     * @method fromVertices
	     * @param {vertices} vertices
	     * @return {axes} A new axes from the given vertices
	     */
	    Axes.fromVertices = function(vertices) {
	        var axes = {};
	
	        // find the unique axes, using edge normal gradients
	        for (var i = 0; i < vertices.length; i++) {
	            var j = (i + 1) % vertices.length, 
	                normal = Vector.normalise({ 
	                    x: vertices[j].y - vertices[i].y, 
	                    y: vertices[i].x - vertices[j].x
	                }),
	                gradient = (normal.y === 0) ? Infinity : (normal.x / normal.y);
	            
	            // limit precision
	            gradient = gradient.toFixed(3).toString();
	            axes[gradient] = normal;
	        }
	
	        return Common.values(axes);
	    };
	
	    /**
	     * Rotates a set of axes by the given angle.
	     * @method rotate
	     * @param {axes} axes
	     * @param {number} angle
	     */
	    Axes.rotate = function(axes, angle) {
	        if (angle === 0)
	            return;
	        
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle);
	
	        for (var i = 0; i < axes.length; i++) {
	            var axis = axes[i],
	                xx;
	            xx = axis.x * cos - axis.y * sin;
	            axis.y = axis.x * sin + axis.y * cos;
	            axis.x = xx;
	        }
	    };
	
	})();
	
	},{"../core/Common":14,"../geometry/Vector":28}],26:[function(_dereq_,module,exports){
	/**
	* The `Matter.Bounds` module contains methods for creating and manipulating axis-aligned bounding boxes (AABB).
	*
	* @class Bounds
	*/
	
	var Bounds = {};
	
	module.exports = Bounds;
	
	(function() {
	
	    /**
	     * Creates a new axis-aligned bounding box (AABB) for the given vertices.
	     * @method create
	     * @param {vertices} vertices
	     * @return {bounds} A new bounds object
	     */
	    Bounds.create = function(vertices) {
	        var bounds = { 
	            min: { x: 0, y: 0 }, 
	            max: { x: 0, y: 0 }
	        };
	
	        if (vertices)
	            Bounds.update(bounds, vertices);
	        
	        return bounds;
	    };
	
	    /**
	     * Updates bounds using the given vertices and extends the bounds given a velocity.
	     * @method update
	     * @param {bounds} bounds
	     * @param {vertices} vertices
	     * @param {vector} velocity
	     */
	    Bounds.update = function(bounds, vertices, velocity) {
	        bounds.min.x = Infinity;
	        bounds.max.x = -Infinity;
	        bounds.min.y = Infinity;
	        bounds.max.y = -Infinity;
	
	        for (var i = 0; i < vertices.length; i++) {
	            var vertex = vertices[i];
	            if (vertex.x > bounds.max.x) bounds.max.x = vertex.x;
	            if (vertex.x < bounds.min.x) bounds.min.x = vertex.x;
	            if (vertex.y > bounds.max.y) bounds.max.y = vertex.y;
	            if (vertex.y < bounds.min.y) bounds.min.y = vertex.y;
	        }
	        
	        if (velocity) {
	            if (velocity.x > 0) {
	                bounds.max.x += velocity.x;
	            } else {
	                bounds.min.x += velocity.x;
	            }
	            
	            if (velocity.y > 0) {
	                bounds.max.y += velocity.y;
	            } else {
	                bounds.min.y += velocity.y;
	            }
	        }
	    };
	
	    /**
	     * Returns true if the bounds contains the given point.
	     * @method contains
	     * @param {bounds} bounds
	     * @param {vector} point
	     * @return {boolean} True if the bounds contain the point, otherwise false
	     */
	    Bounds.contains = function(bounds, point) {
	        return point.x >= bounds.min.x && point.x <= bounds.max.x 
	               && point.y >= bounds.min.y && point.y <= bounds.max.y;
	    };
	
	    /**
	     * Returns true if the two bounds intersect.
	     * @method overlaps
	     * @param {bounds} boundsA
	     * @param {bounds} boundsB
	     * @return {boolean} True if the bounds overlap, otherwise false
	     */
	    Bounds.overlaps = function(boundsA, boundsB) {
	        return (boundsA.min.x <= boundsB.max.x && boundsA.max.x >= boundsB.min.x
	                && boundsA.max.y >= boundsB.min.y && boundsA.min.y <= boundsB.max.y);
	    };
	
	    /**
	     * Translates the bounds by the given vector.
	     * @method translate
	     * @param {bounds} bounds
	     * @param {vector} vector
	     */
	    Bounds.translate = function(bounds, vector) {
	        bounds.min.x += vector.x;
	        bounds.max.x += vector.x;
	        bounds.min.y += vector.y;
	        bounds.max.y += vector.y;
	    };
	
	    /**
	     * Shifts the bounds to the given position.
	     * @method shift
	     * @param {bounds} bounds
	     * @param {vector} position
	     */
	    Bounds.shift = function(bounds, position) {
	        var deltaX = bounds.max.x - bounds.min.x,
	            deltaY = bounds.max.y - bounds.min.y;
	            
	        bounds.min.x = position.x;
	        bounds.max.x = position.x + deltaX;
	        bounds.min.y = position.y;
	        bounds.max.y = position.y + deltaY;
	    };
	    
	})();
	
	},{}],27:[function(_dereq_,module,exports){
	/**
	* The `Matter.Svg` module contains methods for converting SVG images into an array of vector points.
	*
	* To use this module you also need the SVGPathSeg polyfill: https://github.com/progers/pathseg
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Svg
	*/
	
	var Svg = {};
	
	module.exports = Svg;
	
	var Bounds = _dereq_('../geometry/Bounds');
	var Common = _dereq_('../core/Common');
	
	(function() {
	
	    /**
	     * Converts an SVG path into an array of vector points.
	     * If the input path forms a concave shape, you must decompose the result into convex parts before use.
	     * See `Bodies.fromVertices` which provides support for this.
	     * Note that this function is not guaranteed to support complex paths (such as those with holes).
	     * You must load the `pathseg.js` polyfill on newer browsers.
	     * @method pathToVertices
	     * @param {SVGPathElement} path
	     * @param {Number} [sampleLength=15]
	     * @return {Vector[]} points
	     */
	    Svg.pathToVertices = function(path, sampleLength) {
	        if (typeof window !== 'undefined' && !('SVGPathSeg' in window)) {
	            Common.warn('Svg.pathToVertices: SVGPathSeg not defined, a polyfill is required.');
	        }
	
	        // https://github.com/wout/svg.topoly.js/blob/master/svg.topoly.js
	        var i, il, total, point, segment, segments, 
	            segmentsQueue, lastSegment, 
	            lastPoint, segmentIndex, points = [],
	            lx, ly, length = 0, x = 0, y = 0;
	
	        sampleLength = sampleLength || 15;
	
	        var addPoint = function(px, py, pathSegType) {
	            // all odd-numbered path types are relative except PATHSEG_CLOSEPATH (1)
	            var isRelative = pathSegType % 2 === 1 && pathSegType > 1;
	
	            // when the last point doesn't equal the current point add the current point
	            if (!lastPoint || px != lastPoint.x || py != lastPoint.y) {
	                if (lastPoint && isRelative) {
	                    lx = lastPoint.x;
	                    ly = lastPoint.y;
	                } else {
	                    lx = 0;
	                    ly = 0;
	                }
	
	                var point = {
	                    x: lx + px,
	                    y: ly + py
	                };
	
	                // set last point
	                if (isRelative || !lastPoint) {
	                    lastPoint = point;
	                }
	
	                points.push(point);
	
	                x = lx + px;
	                y = ly + py;
	            }
	        };
	
	        var addSegmentPoint = function(segment) {
	            var segType = segment.pathSegTypeAsLetter.toUpperCase();
	
	            // skip path ends
	            if (segType === 'Z') 
	                return;
	
	            // map segment to x and y
	            switch (segType) {
	
	            case 'M':
	            case 'L':
	            case 'T':
	            case 'C':
	            case 'S':
	            case 'Q':
	                x = segment.x;
	                y = segment.y;
	                break;
	            case 'H':
	                x = segment.x;
	                break;
	            case 'V':
	                y = segment.y;
	                break;
	            }
	
	            addPoint(x, y, segment.pathSegType);
	        };
	
	        // ensure path is absolute
	        Svg._svgPathToAbsolute(path);
	
	        // get total length
	        total = path.getTotalLength();
	
	        // queue segments
	        segments = [];
	        for (i = 0; i < path.pathSegList.numberOfItems; i += 1)
	            segments.push(path.pathSegList.getItem(i));
	
	        segmentsQueue = segments.concat();
	
	        // sample through path
	        while (length < total) {
	            // get segment at position
	            segmentIndex = path.getPathSegAtLength(length);
	            segment = segments[segmentIndex];
	
	            // new segment
	            if (segment != lastSegment) {
	                while (segmentsQueue.length && segmentsQueue[0] != segment)
	                    addSegmentPoint(segmentsQueue.shift());
	
	                lastSegment = segment;
	            }
	
	            // add points in between when curving
	            // TODO: adaptive sampling
	            switch (segment.pathSegTypeAsLetter.toUpperCase()) {
	
	            case 'C':
	            case 'T':
	            case 'S':
	            case 'Q':
	            case 'A':
	                point = path.getPointAtLength(length);
	                addPoint(point.x, point.y, 0);
	                break;
	
	            }
	
	            // increment by sample value
	            length += sampleLength;
	        }
	
	        // add remaining segments not passed by sampling
	        for (i = 0, il = segmentsQueue.length; i < il; ++i)
	            addSegmentPoint(segmentsQueue[i]);
	
	        return points;
	    };
	
	    Svg._svgPathToAbsolute = function(path) {
	        // http://phrogz.net/convert-svg-path-to-all-absolute-commands
	        // Copyright (c) Gavin Kistner
	        // http://phrogz.net/js/_ReuseLicense.txt
	        // Modifications: tidy formatting and naming
	        var x0, y0, x1, y1, x2, y2, segs = path.pathSegList,
	            x = 0, y = 0, len = segs.numberOfItems;
	
	        for (var i = 0; i < len; ++i) {
	            var seg = segs.getItem(i),
	                segType = seg.pathSegTypeAsLetter;
	
	            if (/[MLHVCSQTA]/.test(segType)) {
	                if ('x' in seg) x = seg.x;
	                if ('y' in seg) y = seg.y;
	            } else {
	                if ('x1' in seg) x1 = x + seg.x1;
	                if ('x2' in seg) x2 = x + seg.x2;
	                if ('y1' in seg) y1 = y + seg.y1;
	                if ('y2' in seg) y2 = y + seg.y2;
	                if ('x' in seg) x += seg.x;
	                if ('y' in seg) y += seg.y;
	
	                switch (segType) {
	
	                case 'm':
	                    segs.replaceItem(path.createSVGPathSegMovetoAbs(x, y), i);
	                    break;
	                case 'l':
	                    segs.replaceItem(path.createSVGPathSegLinetoAbs(x, y), i);
	                    break;
	                case 'h':
	                    segs.replaceItem(path.createSVGPathSegLinetoHorizontalAbs(x), i);
	                    break;
	                case 'v':
	                    segs.replaceItem(path.createSVGPathSegLinetoVerticalAbs(y), i);
	                    break;
	                case 'c':
	                    segs.replaceItem(path.createSVGPathSegCurvetoCubicAbs(x, y, x1, y1, x2, y2), i);
	                    break;
	                case 's':
	                    segs.replaceItem(path.createSVGPathSegCurvetoCubicSmoothAbs(x, y, x2, y2), i);
	                    break;
	                case 'q':
	                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticAbs(x, y, x1, y1), i);
	                    break;
	                case 't':
	                    segs.replaceItem(path.createSVGPathSegCurvetoQuadraticSmoothAbs(x, y), i);
	                    break;
	                case 'a':
	                    segs.replaceItem(path.createSVGPathSegArcAbs(x, y, seg.r1, seg.r2, seg.angle, seg.largeArcFlag, seg.sweepFlag), i);
	                    break;
	                case 'z':
	                case 'Z':
	                    x = x0;
	                    y = y0;
	                    break;
	
	                }
	            }
	
	            if (segType == 'M' || segType == 'm') {
	                x0 = x;
	                y0 = y;
	            }
	        }
	    };
	
	})();
	},{"../core/Common":14,"../geometry/Bounds":26}],28:[function(_dereq_,module,exports){
	/**
	* The `Matter.Vector` module contains methods for creating and manipulating vectors.
	* Vectors are the basis of all the geometry related operations in the engine.
	* A `Matter.Vector` object is of the form `{ x: 0, y: 0 }`.
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Vector
	*/
	
	// TODO: consider params for reusing vector objects
	
	var Vector = {};
	
	module.exports = Vector;
	
	(function() {
	
	    /**
	     * Creates a new vector.
	     * @method create
	     * @param {number} x
	     * @param {number} y
	     * @return {vector} A new vector
	     */
	    Vector.create = function(x, y) {
	        return { x: x || 0, y: y || 0 };
	    };
	
	    /**
	     * Returns a new vector with `x` and `y` copied from the given `vector`.
	     * @method clone
	     * @param {vector} vector
	     * @return {vector} A new cloned vector
	     */
	    Vector.clone = function(vector) {
	        return { x: vector.x, y: vector.y };
	    };
	
	    /**
	     * Returns the magnitude (length) of a vector.
	     * @method magnitude
	     * @param {vector} vector
	     * @return {number} The magnitude of the vector
	     */
	    Vector.magnitude = function(vector) {
	        return Math.sqrt((vector.x * vector.x) + (vector.y * vector.y));
	    };
	
	    /**
	     * Returns the magnitude (length) of a vector (therefore saving a `sqrt` operation).
	     * @method magnitudeSquared
	     * @param {vector} vector
	     * @return {number} The squared magnitude of the vector
	     */
	    Vector.magnitudeSquared = function(vector) {
	        return (vector.x * vector.x) + (vector.y * vector.y);
	    };
	
	    /**
	     * Rotates the vector about (0, 0) by specified angle.
	     * @method rotate
	     * @param {vector} vector
	     * @param {number} angle
	     * @param {vector} [output]
	     * @return {vector} The vector rotated about (0, 0)
	     */
	    Vector.rotate = function(vector, angle, output) {
	        var cos = Math.cos(angle), sin = Math.sin(angle);
	        if (!output) output = {};
	        var x = vector.x * cos - vector.y * sin;
	        output.y = vector.x * sin + vector.y * cos;
	        output.x = x;
	        return output;
	    };
	
	    /**
	     * Rotates the vector about a specified point by specified angle.
	     * @method rotateAbout
	     * @param {vector} vector
	     * @param {number} angle
	     * @param {vector} point
	     * @param {vector} [output]
	     * @return {vector} A new vector rotated about the point
	     */
	    Vector.rotateAbout = function(vector, angle, point, output) {
	        var cos = Math.cos(angle), sin = Math.sin(angle);
	        if (!output) output = {};
	        var x = point.x + ((vector.x - point.x) * cos - (vector.y - point.y) * sin);
	        output.y = point.y + ((vector.x - point.x) * sin + (vector.y - point.y) * cos);
	        output.x = x;
	        return output;
	    };
	
	    /**
	     * Normalises a vector (such that its magnitude is `1`).
	     * @method normalise
	     * @param {vector} vector
	     * @return {vector} A new vector normalised
	     */
	    Vector.normalise = function(vector) {
	        var magnitude = Vector.magnitude(vector);
	        if (magnitude === 0)
	            return { x: 0, y: 0 };
	        return { x: vector.x / magnitude, y: vector.y / magnitude };
	    };
	
	    /**
	     * Returns the dot-product of two vectors.
	     * @method dot
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @return {number} The dot product of the two vectors
	     */
	    Vector.dot = function(vectorA, vectorB) {
	        return (vectorA.x * vectorB.x) + (vectorA.y * vectorB.y);
	    };
	
	    /**
	     * Returns the cross-product of two vectors.
	     * @method cross
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @return {number} The cross product of the two vectors
	     */
	    Vector.cross = function(vectorA, vectorB) {
	        return (vectorA.x * vectorB.y) - (vectorA.y * vectorB.x);
	    };
	
	    /**
	     * Returns the cross-product of three vectors.
	     * @method cross3
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @param {vector} vectorC
	     * @return {number} The cross product of the three vectors
	     */
	    Vector.cross3 = function(vectorA, vectorB, vectorC) {
	        return (vectorB.x - vectorA.x) * (vectorC.y - vectorA.y) - (vectorB.y - vectorA.y) * (vectorC.x - vectorA.x);
	    };
	
	    /**
	     * Adds the two vectors.
	     * @method add
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @param {vector} [output]
	     * @return {vector} A new vector of vectorA and vectorB added
	     */
	    Vector.add = function(vectorA, vectorB, output) {
	        if (!output) output = {};
	        output.x = vectorA.x + vectorB.x;
	        output.y = vectorA.y + vectorB.y;
	        return output;
	    };
	
	    /**
	     * Subtracts the two vectors.
	     * @method sub
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @param {vector} [output]
	     * @return {vector} A new vector of vectorA and vectorB subtracted
	     */
	    Vector.sub = function(vectorA, vectorB, output) {
	        if (!output) output = {};
	        output.x = vectorA.x - vectorB.x;
	        output.y = vectorA.y - vectorB.y;
	        return output;
	    };
	
	    /**
	     * Multiplies a vector and a scalar.
	     * @method mult
	     * @param {vector} vector
	     * @param {number} scalar
	     * @return {vector} A new vector multiplied by scalar
	     */
	    Vector.mult = function(vector, scalar) {
	        return { x: vector.x * scalar, y: vector.y * scalar };
	    };
	
	    /**
	     * Divides a vector and a scalar.
	     * @method div
	     * @param {vector} vector
	     * @param {number} scalar
	     * @return {vector} A new vector divided by scalar
	     */
	    Vector.div = function(vector, scalar) {
	        return { x: vector.x / scalar, y: vector.y / scalar };
	    };
	
	    /**
	     * Returns the perpendicular vector. Set `negate` to true for the perpendicular in the opposite direction.
	     * @method perp
	     * @param {vector} vector
	     * @param {bool} [negate=false]
	     * @return {vector} The perpendicular vector
	     */
	    Vector.perp = function(vector, negate) {
	        negate = negate === true ? -1 : 1;
	        return { x: negate * -vector.y, y: negate * vector.x };
	    };
	
	    /**
	     * Negates both components of a vector such that it points in the opposite direction.
	     * @method neg
	     * @param {vector} vector
	     * @return {vector} The negated vector
	     */
	    Vector.neg = function(vector) {
	        return { x: -vector.x, y: -vector.y };
	    };
	
	    /**
	     * Returns the angle between the vector `vectorB - vectorA` and the x-axis in radians.
	     * @method angle
	     * @param {vector} vectorA
	     * @param {vector} vectorB
	     * @return {number} The angle in radians
	     */
	    Vector.angle = function(vectorA, vectorB) {
	        return Math.atan2(vectorB.y - vectorA.y, vectorB.x - vectorA.x);
	    };
	
	    /**
	     * Temporary vector pool (not thread-safe).
	     * @property _temp
	     * @type {vector[]}
	     * @private
	     */
	    Vector._temp = [
	        Vector.create(), Vector.create(), 
	        Vector.create(), Vector.create(), 
	        Vector.create(), Vector.create()
	    ];
	
	})();
	},{}],29:[function(_dereq_,module,exports){
	/**
	* The `Matter.Vertices` module contains methods for creating and manipulating sets of vertices.
	* A set of vertices is an array of `Matter.Vector` with additional indexing properties inserted by `Vertices.create`.
	* A `Matter.Body` maintains a set of vertices to represent the shape of the object (its convex hull).
	*
	* See the included usage [examples](https://github.com/liabru/matter-js/tree/master/examples).
	*
	* @class Vertices
	*/
	
	var Vertices = {};
	
	module.exports = Vertices;
	
	var Vector = _dereq_('../geometry/Vector');
	var Common = _dereq_('../core/Common');
	
	(function() {
	
	    /**
	     * Creates a new set of `Matter.Body` compatible vertices.
	     * The `points` argument accepts an array of `Matter.Vector` points orientated around the origin `(0, 0)`, for example:
	     *
	     *     [{ x: 0, y: 0 }, { x: 25, y: 50 }, { x: 50, y: 0 }]
	     *
	     * The `Vertices.create` method returns a new array of vertices, which are similar to Matter.Vector objects,
	     * but with some additional references required for efficient collision detection routines.
	     *
	     * Vertices must be specified in clockwise order.
	     *
	     * Note that the `body` argument is not optional, a `Matter.Body` reference must be provided.
	     *
	     * @method create
	     * @param {vector[]} points
	     * @param {body} body
	     */
	    Vertices.create = function(points, body) {
	        var vertices = [];
	
	        for (var i = 0; i < points.length; i++) {
	            var point = points[i],
	                vertex = {
	                    x: point.x,
	                    y: point.y,
	                    index: i,
	                    body: body,
	                    isInternal: false
	                };
	
	            vertices.push(vertex);
	        }
	
	        return vertices;
	    };
	
	    /**
	     * Parses a string containing ordered x y pairs separated by spaces (and optionally commas), 
	     * into a `Matter.Vertices` object for the given `Matter.Body`.
	     * For parsing SVG paths, see `Svg.pathToVertices`.
	     * @method fromPath
	     * @param {string} path
	     * @param {body} body
	     * @return {vertices} vertices
	     */
	    Vertices.fromPath = function(path, body) {
	        var pathPattern = /L?\s*([\-\d\.e]+)[\s,]*([\-\d\.e]+)*/ig,
	            points = [];
	
	        path.replace(pathPattern, function(match, x, y) {
	            points.push({ x: parseFloat(x), y: parseFloat(y) });
	        });
	
	        return Vertices.create(points, body);
	    };
	
	    /**
	     * Returns the centre (centroid) of the set of vertices.
	     * @method centre
	     * @param {vertices} vertices
	     * @return {vector} The centre point
	     */
	    Vertices.centre = function(vertices) {
	        var area = Vertices.area(vertices, true),
	            centre = { x: 0, y: 0 },
	            cross,
	            temp,
	            j;
	
	        for (var i = 0; i < vertices.length; i++) {
	            j = (i + 1) % vertices.length;
	            cross = Vector.cross(vertices[i], vertices[j]);
	            temp = Vector.mult(Vector.add(vertices[i], vertices[j]), cross);
	            centre = Vector.add(centre, temp);
	        }
	
	        return Vector.div(centre, 6 * area);
	    };
	
	    /**
	     * Returns the average (mean) of the set of vertices.
	     * @method mean
	     * @param {vertices} vertices
	     * @return {vector} The average point
	     */
	    Vertices.mean = function(vertices) {
	        var average = { x: 0, y: 0 };
	
	        for (var i = 0; i < vertices.length; i++) {
	            average.x += vertices[i].x;
	            average.y += vertices[i].y;
	        }
	
	        return Vector.div(average, vertices.length);
	    };
	
	    /**
	     * Returns the area of the set of vertices.
	     * @method area
	     * @param {vertices} vertices
	     * @param {bool} signed
	     * @return {number} The area
	     */
	    Vertices.area = function(vertices, signed) {
	        var area = 0,
	            j = vertices.length - 1;
	
	        for (var i = 0; i < vertices.length; i++) {
	            area += (vertices[j].x - vertices[i].x) * (vertices[j].y + vertices[i].y);
	            j = i;
	        }
	
	        if (signed)
	            return area / 2;
	
	        return Math.abs(area) / 2;
	    };
	
	    /**
	     * Returns the moment of inertia (second moment of area) of the set of vertices given the total mass.
	     * @method inertia
	     * @param {vertices} vertices
	     * @param {number} mass
	     * @return {number} The polygon's moment of inertia
	     */
	    Vertices.inertia = function(vertices, mass) {
	        var numerator = 0,
	            denominator = 0,
	            v = vertices,
	            cross,
	            j;
	
	        // find the polygon's moment of inertia, using second moment of area
	        // from equations at http://www.physicsforums.com/showthread.php?t=25293
	        for (var n = 0; n < v.length; n++) {
	            j = (n + 1) % v.length;
	            cross = Math.abs(Vector.cross(v[j], v[n]));
	            numerator += cross * (Vector.dot(v[j], v[j]) + Vector.dot(v[j], v[n]) + Vector.dot(v[n], v[n]));
	            denominator += cross;
	        }
	
	        return (mass / 6) * (numerator / denominator);
	    };
	
	    /**
	     * Translates the set of vertices in-place.
	     * @method translate
	     * @param {vertices} vertices
	     * @param {vector} vector
	     * @param {number} scalar
	     */
	    Vertices.translate = function(vertices, vector, scalar) {
	        var i;
	        if (scalar) {
	            for (i = 0; i < vertices.length; i++) {
	                vertices[i].x += vector.x * scalar;
	                vertices[i].y += vector.y * scalar;
	            }
	        } else {
	            for (i = 0; i < vertices.length; i++) {
	                vertices[i].x += vector.x;
	                vertices[i].y += vector.y;
	            }
	        }
	
	        return vertices;
	    };
	
	    /**
	     * Rotates the set of vertices in-place.
	     * @method rotate
	     * @param {vertices} vertices
	     * @param {number} angle
	     * @param {vector} point
	     */
	    Vertices.rotate = function(vertices, angle, point) {
	        if (angle === 0)
	            return;
	
	        var cos = Math.cos(angle),
	            sin = Math.sin(angle);
	
	        for (var i = 0; i < vertices.length; i++) {
	            var vertice = vertices[i],
	                dx = vertice.x - point.x,
	                dy = vertice.y - point.y;
	                
	            vertice.x = point.x + (dx * cos - dy * sin);
	            vertice.y = point.y + (dx * sin + dy * cos);
	        }
	
	        return vertices;
	    };
	
	    /**
	     * Returns `true` if the `point` is inside the set of `vertices`.
	     * @method contains
	     * @param {vertices} vertices
	     * @param {vector} point
	     * @return {boolean} True if the vertices contains point, otherwise false
	     */
	    Vertices.contains = function(vertices, point) {
	        for (var i = 0; i < vertices.length; i++) {
	            var vertice = vertices[i],
	                nextVertice = vertices[(i + 1) % vertices.length];
	            if ((point.x - vertice.x) * (nextVertice.y - vertice.y) + (point.y - vertice.y) * (vertice.x - nextVertice.x) > 0) {
	                return false;
	            }
	        }
	
	        return true;
	    };
	
	    /**
	     * Scales the vertices from a point (default is centre) in-place.
	     * @method scale
	     * @param {vertices} vertices
	     * @param {number} scaleX
	     * @param {number} scaleY
	     * @param {vector} point
	     */
	    Vertices.scale = function(vertices, scaleX, scaleY, point) {
	        if (scaleX === 1 && scaleY === 1)
	            return vertices;
	
	        point = point || Vertices.centre(vertices);
	
	        var vertex,
	            delta;
	
	        for (var i = 0; i < vertices.length; i++) {
	            vertex = vertices[i];
	            delta = Vector.sub(vertex, point);
	            vertices[i].x = point.x + delta.x * scaleX;
	            vertices[i].y = point.y + delta.y * scaleY;
	        }
	
	        return vertices;
	    };
	
	    /**
	     * Chamfers a set of vertices by giving them rounded corners, returns a new set of vertices.
	     * The radius parameter is a single number or an array to specify the radius for each vertex.
	     * @method chamfer
	     * @param {vertices} vertices
	     * @param {number[]} radius
	     * @param {number} quality
	     * @param {number} qualityMin
	     * @param {number} qualityMax
	     */
	    Vertices.chamfer = function(vertices, radius, quality, qualityMin, qualityMax) {
	        if (typeof radius === 'number') {
	            radius = [radius];
	        } else {
	            radius = radius || [8];
	        }
	
	        // quality defaults to -1, which is auto
	        quality = (typeof quality !== 'undefined') ? quality : -1;
	        qualityMin = qualityMin || 2;
	        qualityMax = qualityMax || 14;
	
	        var newVertices = [];
	
	        for (var i = 0; i < vertices.length; i++) {
	            var prevVertex = vertices[i - 1 >= 0 ? i - 1 : vertices.length - 1],
	                vertex = vertices[i],
	                nextVertex = vertices[(i + 1) % vertices.length],
	                currentRadius = radius[i < radius.length ? i : radius.length - 1];
	
	            if (currentRadius === 0) {
	                newVertices.push(vertex);
	                continue;
	            }
	
	            var prevNormal = Vector.normalise({ 
	                x: vertex.y - prevVertex.y, 
	                y: prevVertex.x - vertex.x
	            });
	
	            var nextNormal = Vector.normalise({ 
	                x: nextVertex.y - vertex.y, 
	                y: vertex.x - nextVertex.x
	            });
	
	            var diagonalRadius = Math.sqrt(2 * Math.pow(currentRadius, 2)),
	                radiusVector = Vector.mult(Common.clone(prevNormal), currentRadius),
	                midNormal = Vector.normalise(Vector.mult(Vector.add(prevNormal, nextNormal), 0.5)),
	                scaledVertex = Vector.sub(vertex, Vector.mult(midNormal, diagonalRadius));
	
	            var precision = quality;
	
	            if (quality === -1) {
	                // automatically decide precision
	                precision = Math.pow(currentRadius, 0.32) * 1.75;
	            }
	
	            precision = Common.clamp(precision, qualityMin, qualityMax);
	
	            // use an even value for precision, more likely to reduce axes by using symmetry
	            if (precision % 2 === 1)
	                precision += 1;
	
	            var alpha = Math.acos(Vector.dot(prevNormal, nextNormal)),
	                theta = alpha / precision;
	
	            for (var j = 0; j < precision; j++) {
	                newVertices.push(Vector.add(Vector.rotate(radiusVector, theta * j), scaledVertex));
	            }
	        }
	
	        return newVertices;
	    };
	
	    /**
	     * Sorts the input vertices into clockwise order in place.
	     * @method clockwiseSort
	     * @param {vertices} vertices
	     * @return {vertices} vertices
	     */
	    Vertices.clockwiseSort = function(vertices) {
	        var centre = Vertices.mean(vertices);
	
	        vertices.sort(function(vertexA, vertexB) {
	            return Vector.angle(centre, vertexA) - Vector.angle(centre, vertexB);
	        });
	
	        return vertices;
	    };
	
	    /**
	     * Returns true if the vertices form a convex shape (vertices must be in clockwise order).
	     * @method isConvex
	     * @param {vertices} vertices
	     * @return {bool} `true` if the `vertices` are convex, `false` if not (or `null` if not computable).
	     */
	    Vertices.isConvex = function(vertices) {
	        // http://paulbourke.net/geometry/polygonmesh/
	        // Copyright (c) Paul Bourke (use permitted)
	
	        var flag = 0,
	            n = vertices.length,
	            i,
	            j,
	            k,
	            z;
	
	        if (n < 3)
	            return null;
	
	        for (i = 0; i < n; i++) {
	            j = (i + 1) % n;
	            k = (i + 2) % n;
	            z = (vertices[j].x - vertices[i].x) * (vertices[k].y - vertices[j].y);
	            z -= (vertices[j].y - vertices[i].y) * (vertices[k].x - vertices[j].x);
	
	            if (z < 0) {
	                flag |= 1;
	            } else if (z > 0) {
	                flag |= 2;
	            }
	
	            if (flag === 3) {
	                return false;
	            }
	        }
	
	        if (flag !== 0){
	            return true;
	        } else {
	            return null;
	        }
	    };
	
	    /**
	     * Returns the convex hull of the input vertices as a new array of points.
	     * @method hull
	     * @param {vertices} vertices
	     * @return [vertex] vertices
	     */
	    Vertices.hull = function(vertices) {
	        // http://geomalgorithms.com/a10-_hull-1.html
	
	        var upper = [],
	            lower = [], 
	            vertex,
	            i;
	
	        // sort vertices on x-axis (y-axis for ties)
	        vertices = vertices.slice(0);
	        vertices.sort(function(vertexA, vertexB) {
	            var dx = vertexA.x - vertexB.x;
	            return dx !== 0 ? dx : vertexA.y - vertexB.y;
	        });
	
	        // build lower hull
	        for (i = 0; i < vertices.length; i += 1) {
	            vertex = vertices[i];
	
	            while (lower.length >= 2 
	                   && Vector.cross3(lower[lower.length - 2], lower[lower.length - 1], vertex) <= 0) {
	                lower.pop();
	            }
	
	            lower.push(vertex);
	        }
	
	        // build upper hull
	        for (i = vertices.length - 1; i >= 0; i -= 1) {
	            vertex = vertices[i];
	
	            while (upper.length >= 2 
	                   && Vector.cross3(upper[upper.length - 2], upper[upper.length - 1], vertex) <= 0) {
	                upper.pop();
	            }
	
	            upper.push(vertex);
	        }
	
	        // concatenation of the lower and upper hulls gives the convex hull
	        // omit last points because they are repeated at the beginning of the other list
	        upper.pop();
	        lower.pop();
	
	        return upper.concat(lower);
	    };
	
	})();
	
	},{"../core/Common":14,"../geometry/Vector":28}],30:[function(_dereq_,module,exports){
	var Matter = module.exports = _dereq_('../core/Matter');
	
	Matter.Body = _dereq_('../body/Body');
	Matter.Composite = _dereq_('../body/Composite');
	Matter.World = _dereq_('../body/World');
	
	Matter.Contact = _dereq_('../collision/Contact');
	Matter.Detector = _dereq_('../collision/Detector');
	Matter.Grid = _dereq_('../collision/Grid');
	Matter.Pairs = _dereq_('../collision/Pairs');
	Matter.Pair = _dereq_('../collision/Pair');
	Matter.Query = _dereq_('../collision/Query');
	Matter.Resolver = _dereq_('../collision/Resolver');
	Matter.SAT = _dereq_('../collision/SAT');
	
	Matter.Constraint = _dereq_('../constraint/Constraint');
	Matter.MouseConstraint = _dereq_('../constraint/MouseConstraint');
	
	Matter.Common = _dereq_('../core/Common');
	Matter.Engine = _dereq_('../core/Engine');
	Matter.Events = _dereq_('../core/Events');
	Matter.Mouse = _dereq_('../core/Mouse');
	Matter.Runner = _dereq_('../core/Runner');
	Matter.Sleeping = _dereq_('../core/Sleeping');
	Matter.Plugin = _dereq_('../core/Plugin');
	
	
	Matter.Bodies = _dereq_('../factory/Bodies');
	Matter.Composites = _dereq_('../factory/Composites');
	
	Matter.Axes = _dereq_('../geometry/Axes');
	Matter.Bounds = _dereq_('../geometry/Bounds');
	Matter.Svg = _dereq_('../geometry/Svg');
	Matter.Vector = _dereq_('../geometry/Vector');
	Matter.Vertices = _dereq_('../geometry/Vertices');
	
	Matter.Render = _dereq_('../render/Render');
	Matter.RenderPixi = _dereq_('../render/RenderPixi');
	
	// aliases
	
	Matter.World.add = Matter.Composite.add;
	Matter.World.remove = Matter.Composite.remove;
	Matter.World.addComposite = Matter.Composite.addComposite;
	Matter.World.addBody = Matter.Composite.addBody;
	Matter.World.addConstraint = Matter.Composite.addConstraint;
	Matter.World.clear = Matter.Composite.clear;
	Matter.Engine.run = Matter.Runner.run;
	
	},{"../body/Body":1,"../body/Composite":2,"../body/World":3,"../collision/Contact":4,"../collision/Detector":5,"../collision/Grid":6,"../collision/Pair":7,"../collision/Pairs":8,"../collision/Query":9,"../collision/Resolver":10,"../collision/SAT":11,"../constraint/Constraint":12,"../constraint/MouseConstraint":13,"../core/Common":14,"../core/Engine":15,"../core/Events":16,"../core/Matter":17,"../core/Metrics":18,"../core/Mouse":19,"../core/Plugin":20,"../core/Runner":21,"../core/Sleeping":22,"../factory/Bodies":23,"../factory/Composites":24,"../geometry/Axes":25,"../geometry/Bounds":26,"../geometry/Svg":27,"../geometry/Vector":28,"../geometry/Vertices":29,"../render/Render":31,"../render/RenderPixi":32}],31:[function(_dereq_,module,exports){
	/**
	* The `Matter.Render` module is a simple HTML5 canvas based renderer for visualising instances of `Matter.Engine`.
	* It is intended for development and debugging purposes, but may also be suitable for simple games.
	* It includes a number of drawing options including wireframe, vector with support for sprites and viewports.
	*
	* @class Render
	*/
	
	var Render = {};
	
	module.exports = Render;
	
	var Common = _dereq_('../core/Common');
	var Composite = _dereq_('../body/Composite');
	var Bounds = _dereq_('../geometry/Bounds');
	var Events = _dereq_('../core/Events');
	var Grid = _dereq_('../collision/Grid');
	var Vector = _dereq_('../geometry/Vector');
	var Mouse = _dereq_('../core/Mouse');
	
	(function() {
	
	    var _requestAnimationFrame,
	        _cancelAnimationFrame;
	
	    if (typeof window !== 'undefined') {
	        _requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame
	                                      || window.mozRequestAnimationFrame || window.msRequestAnimationFrame
	                                      || function(callback){ window.setTimeout(function() { callback(Common.now()); }, 1000 / 60); };
	
	        _cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame
	                                      || window.webkitCancelAnimationFrame || window.msCancelAnimationFrame;
	    }
	
	    /**
	     * Creates a new renderer. The options parameter is an object that specifies any properties you wish to override the defaults.
	     * All properties have default values, and many are pre-calculated automatically based on other properties.
	     * See the properties section below for detailed information on what you can pass via the `options` object.
	     * @method create
	     * @param {object} [options]
	     * @return {render} A new renderer
	     */
	    Render.create = function(options) {
	        var defaults = {
	            controller: Render,
	            engine: null,
	            element: null,
	            canvas: null,
	            mouse: null,
	            frameRequestId: null,
	            options: {
	                width: 800,
	                height: 600,
	                pixelRatio: 1,
	                background: '#18181d',
	                wireframeBackground: '#0f0f13',
	                hasBounds: !!options.bounds,
	                enabled: true,
	                wireframes: true,
	                showSleeping: true,
	                showDebug: false,
	                showBroadphase: false,
	                showBounds: false,
	                showVelocity: false,
	                showCollisions: false,
	                showSeparations: false,
	                showAxes: false,
	                showPositions: false,
	                showAngleIndicator: false,
	                showIds: false,
	                showShadows: false,
	                showVertexNumbers: false,
	                showConvexHulls: false,
	                showInternalEdges: false,
	                showMousePosition: false
	            }
	        };
	
	        var render = Common.extend(defaults, options);
	
	        if (render.canvas) {
	            render.canvas.width = render.options.width || render.canvas.width;
	            render.canvas.height = render.options.height || render.canvas.height;
	        }
	
	        render.mouse = options.mouse;
	        render.engine = options.engine;
	        render.canvas = render.canvas || _createCanvas(render.options.width, render.options.height);
	        render.context = render.canvas.getContext('2d');
	        render.textures = {};
	
	        render.bounds = render.bounds || {
	            min: {
	                x: 0,
	                y: 0
	            },
	            max: {
	                x: render.canvas.width,
	                y: render.canvas.height
	            }
	        };
	
	        if (render.options.pixelRatio !== 1) {
	            Render.setPixelRatio(render, render.options.pixelRatio);
	        }
	
	        if (Common.isElement(render.element)) {
	            render.element.appendChild(render.canvas);
	        } else if (!render.canvas.parentNode) {
	            Common.log('Render.create: options.element was undefined, render.canvas was created but not appended', 'warn');
	        }
	
	        return render;
	    };
	
	    /**
	     * Continuously updates the render canvas on the `requestAnimationFrame` event.
	     * @method run
	     * @param {render} render
	     */
	    Render.run = function(render) {
	        (function loop(time){
	            render.frameRequestId = _requestAnimationFrame(loop);
	            Render.world(render);
	        })();
	    };
	
	    /**
	     * Ends execution of `Render.run` on the given `render`, by canceling the animation frame request event loop.
	     * @method stop
	     * @param {render} render
	     */
	    Render.stop = function(render) {
	        _cancelAnimationFrame(render.frameRequestId);
	    };
	
	    /**
	     * Sets the pixel ratio of the renderer and updates the canvas.
	     * To automatically detect the correct ratio, pass the string `'auto'` for `pixelRatio`.
	     * @method setPixelRatio
	     * @param {render} render
	     * @param {number} pixelRatio
	     */
	    Render.setPixelRatio = function(render, pixelRatio) {
	        var options = render.options,
	            canvas = render.canvas;
	
	        if (pixelRatio === 'auto') {
	            pixelRatio = _getPixelRatio(canvas);
	        }
	
	        options.pixelRatio = pixelRatio;
	        canvas.setAttribute('data-pixel-ratio', pixelRatio);
	        canvas.width = options.width * pixelRatio;
	        canvas.height = options.height * pixelRatio;
	        canvas.style.width = options.width + 'px';
	        canvas.style.height = options.height + 'px';
	        render.context.scale(pixelRatio, pixelRatio);
	    };
	
	    /**
	     * Positions and sizes the viewport around the given object bounds.
	     * Objects must have at least one of the following properties:
	     * - `object.bounds`
	     * - `object.position`
	     * - `object.min` and `object.max`
	     * - `object.x` and `object.y`
	     * @method lookAt
	     * @param {render} render
	     * @param {object[]} objects
	     * @param {vector} [padding]
	     * @param {bool} [center=true]
	     */
	    Render.lookAt = function(render, objects, padding, center) {
	        center = typeof center !== 'undefined' ? center : true;
	        objects = Common.isArray(objects) ? objects : [objects];
	        padding = padding || {
	            x: 0,
	            y: 0
	        };
	
	        // find bounds of all objects
	        var bounds = {
	            min: { x: Infinity, y: Infinity },
	            max: { x: -Infinity, y: -Infinity }
	        };
	
	        for (var i = 0; i < objects.length; i += 1) {
	            var object = objects[i],
	                min = object.bounds ? object.bounds.min : (object.min || object.position || object),
	                max = object.bounds ? object.bounds.max : (object.max || object.position || object);
	
	            if (min && max) {
	                if (min.x < bounds.min.x)
	                    bounds.min.x = min.x;
	
	                if (max.x > bounds.max.x)
	                    bounds.max.x = max.x;
	
	                if (min.y < bounds.min.y)
	                    bounds.min.y = min.y;
	
	                if (max.y > bounds.max.y)
	                    bounds.max.y = max.y;
	            }
	        }
	
	        // find ratios
	        var width = (bounds.max.x - bounds.min.x) + 2 * padding.x,
	            height = (bounds.max.y - bounds.min.y) + 2 * padding.y,
	            viewHeight = render.canvas.height,
	            viewWidth = render.canvas.width,
	            outerRatio = viewWidth / viewHeight,
	            innerRatio = width / height,
	            scaleX = 1,
	            scaleY = 1;
	
	        // find scale factor
	        if (innerRatio > outerRatio) {
	            scaleY = innerRatio / outerRatio;
	        } else {
	            scaleX = outerRatio / innerRatio;
	        }
	
	        // enable bounds
	        render.options.hasBounds = true;
	
	        // position and size
	        render.bounds.min.x = bounds.min.x;
	        render.bounds.max.x = bounds.min.x + width * scaleX;
	        render.bounds.min.y = bounds.min.y;
	        render.bounds.max.y = bounds.min.y + height * scaleY;
	
	        // center
	        if (center) {
	            render.bounds.min.x += width * 0.5 - (width * scaleX) * 0.5;
	            render.bounds.max.x += width * 0.5 - (width * scaleX) * 0.5;
	            render.bounds.min.y += height * 0.5 - (height * scaleY) * 0.5;
	            render.bounds.max.y += height * 0.5 - (height * scaleY) * 0.5;
	        }
	
	        // padding
	        render.bounds.min.x -= padding.x;
	        render.bounds.max.x -= padding.x;
	        render.bounds.min.y -= padding.y;
	        render.bounds.max.y -= padding.y;
	
	        // update mouse
	        if (render.mouse) {
	            Mouse.setScale(render.mouse, {
	                x: (render.bounds.max.x - render.bounds.min.x) / render.canvas.width,
	                y: (render.bounds.max.y - render.bounds.min.y) / render.canvas.height
	            });
	
	            Mouse.setOffset(render.mouse, render.bounds.min);
	        }
	    };
	
	    /**
	     * Applies viewport transforms based on `render.bounds` to a render context.
	     * @method startViewTransform
	     * @param {render} render
	     */
	    Render.startViewTransform = function(render) {
	        var boundsWidth = render.bounds.max.x - render.bounds.min.x,
	            boundsHeight = render.bounds.max.y - render.bounds.min.y,
	            boundsScaleX = boundsWidth / render.options.width,
	            boundsScaleY = boundsHeight / render.options.height;
	
	        render.context.scale(1 / boundsScaleX, 1 / boundsScaleY);
	        render.context.translate(-render.bounds.min.x, -render.bounds.min.y);
	    };
	
	    /**
	     * Resets all transforms on the render context.
	     * @method endViewTransform
	     * @param {render} render
	     */
	    Render.endViewTransform = function(render) {
	        render.context.setTransform(render.options.pixelRatio, 0, 0, render.options.pixelRatio, 0, 0);
	    };
	
	    /**
	     * Renders the given `engine`'s `Matter.World` object.
	     * This is the entry point for all rendering and should be called every time the scene changes.
	     * @method world
	     * @param {render} render
	     */
	    Render.world = function(render) {
	        var engine = render.engine,
	            world = engine.world,
	            canvas = render.canvas,
	            context = render.context,
	            options = render.options,
	            allBodies = Composite.allBodies(world),
	            allConstraints = Composite.allConstraints(world),
	            background = options.wireframes ? options.wireframeBackground : options.background,
	            bodies = [],
	            constraints = [],
	            i;
	
	        var event = {
	            timestamp: engine.timing.timestamp
	        };
	
	        Events.trigger(render, 'beforeRender', event);
	
	        // apply background if it has changed
	        if (render.currentBackground !== background)
	            _applyBackground(render, background);
	
	        // clear the canvas with a transparent fill, to allow the canvas background to show
	        context.globalCompositeOperation = 'source-in';
	        context.fillStyle = "transparent";
	        context.fillRect(0, 0, canvas.width, canvas.height);
	        context.globalCompositeOperation = 'source-over';
	
	        // handle bounds
	        if (options.hasBounds) {
	            // filter out bodies that are not in view
	            for (i = 0; i < allBodies.length; i++) {
	                var body = allBodies[i];
	                if (Bounds.overlaps(body.bounds, render.bounds))
	                    bodies.push(body);
	            }
	
	            // filter out constraints that are not in view
	            for (i = 0; i < allConstraints.length; i++) {
	                var constraint = allConstraints[i],
	                    bodyA = constraint.bodyA,
	                    bodyB = constraint.bodyB,
	                    pointAWorld = constraint.pointA,
	                    pointBWorld = constraint.pointB;
	
	                if (bodyA) pointAWorld = Vector.add(bodyA.position, constraint.pointA);
	                if (bodyB) pointBWorld = Vector.add(bodyB.position, constraint.pointB);
	
	                if (!pointAWorld || !pointBWorld)
	                    continue;
	
	                if (Bounds.contains(render.bounds, pointAWorld) || Bounds.contains(render.bounds, pointBWorld))
	                    constraints.push(constraint);
	            }
	
	            // transform the view
	            Render.startViewTransform(render);
	
	            // update mouse
	            if (render.mouse) {
	                Mouse.setScale(render.mouse, {
	                    x: (render.bounds.max.x - render.bounds.min.x) / render.canvas.width,
	                    y: (render.bounds.max.y - render.bounds.min.y) / render.canvas.height
	                });
	
	                Mouse.setOffset(render.mouse, render.bounds.min);
	            }
	        } else {
	            constraints = allConstraints;
	            bodies = allBodies;
	        }
	
	        if (!options.wireframes || (engine.enableSleeping && options.showSleeping)) {
	            // fully featured rendering of bodies
	            Render.bodies(render, bodies, context);
	        } else {
	            if (options.showConvexHulls)
	                Render.bodyConvexHulls(render, bodies, context);
	
	            // optimised method for wireframes only
	            Render.bodyWireframes(render, bodies, context);
	        }
	
	        if (options.showBounds)
	            Render.bodyBounds(render, bodies, context);
	
	        if (options.showAxes || options.showAngleIndicator)
	            Render.bodyAxes(render, bodies, context);
	
	        if (options.showPositions)
	            Render.bodyPositions(render, bodies, context);
	
	        if (options.showVelocity)
	            Render.bodyVelocity(render, bodies, context);
	
	        if (options.showIds)
	            Render.bodyIds(render, bodies, context);
	
	        if (options.showSeparations)
	            Render.separations(render, engine.pairs.list, context);
	
	        if (options.showCollisions)
	            Render.collisions(render, engine.pairs.list, context);
	
	        if (options.showVertexNumbers)
	            Render.vertexNumbers(render, bodies, context);
	
	        if (options.showMousePosition)
	            Render.mousePosition(render, render.mouse, context);
	
	        Render.constraints(constraints, context);
	
	        if (options.showBroadphase && engine.broadphase.controller === Grid)
	            Render.grid(render, engine.broadphase, context);
	
	        if (options.showDebug)
	            Render.debug(render, context);
	
	        if (options.hasBounds) {
	            // revert view transforms
	            Render.endViewTransform(render);
	        }
	
	        Events.trigger(render, 'afterRender', event);
	    };
	
	    /**
	     * Description
	     * @private
	     * @method debug
	     * @param {render} render
	     * @param {RenderingContext} context
	     */
	    Render.debug = function(render, context) {
	        var c = context,
	            engine = render.engine,
	            world = engine.world,
	            metrics = engine.metrics,
	            options = render.options,
	            bodies = Composite.allBodies(world),
	            space = "    ";
	
	        if (engine.timing.timestamp - (render.debugTimestamp || 0) >= 500) {
	            var text = "";
	
	            if (metrics.timing) {
	                text += "fps: " + Math.round(metrics.timing.fps) + space;
	            }
	
	
	            render.debugString = text;
	            render.debugTimestamp = engine.timing.timestamp;
	        }
	
	        if (render.debugString) {
	            c.font = "12px Arial";
	
	            if (options.wireframes) {
	                c.fillStyle = 'rgba(255,255,255,0.5)';
	            } else {
	                c.fillStyle = 'rgba(0,0,0,0.5)';
	            }
	
	            var split = render.debugString.split('\n');
	
	            for (var i = 0; i < split.length; i++) {
	                c.fillText(split[i], 50, 50 + i * 18);
	            }
	        }
	    };
	
	    /**
	     * Description
	     * @private
	     * @method constraints
	     * @param {constraint[]} constraints
	     * @param {RenderingContext} context
	     */
	    Render.constraints = function(constraints, context) {
	        var c = context;
	
	        for (var i = 0; i < constraints.length; i++) {
	            var constraint = constraints[i];
	
	            if (!constraint.render.visible || !constraint.pointA || !constraint.pointB)
	                continue;
	
	            var bodyA = constraint.bodyA,
	                bodyB = constraint.bodyB,
	                start,
	                end;
	
	            if (bodyA) {
	                start = Vector.add(bodyA.position, constraint.pointA);
	            } else {
	                start = constraint.pointA;
	            }
	
	            if (constraint.render.type === 'pin') {
	                c.beginPath();
	                c.arc(start.x, start.y, 3, 0, 2 * Math.PI);
	                c.closePath();
	            } else {
	                if (bodyB) {
	                    end = Vector.add(bodyB.position, constraint.pointB);
	                } else {
	                    end = constraint.pointB;
	                }
	
	                c.beginPath();
	                c.moveTo(start.x, start.y);
	
	                if (constraint.render.type === 'spring') {
	                    var delta = Vector.sub(end, start),
	                        normal = Vector.perp(Vector.normalise(delta)),
	                        coils = Math.ceil(Common.clamp(constraint.length / 5, 12, 20)),
	                        offset;
	
	                    for (var j = 1; j < coils; j += 1) {
	                        offset = j % 2 === 0 ? 1 : -1;
	
	                        c.lineTo(
	                            start.x + delta.x * (j / coils) + normal.x * offset * 4,
	                            start.y + delta.y * (j / coils) + normal.y * offset * 4
	                        );
	                    }
	                }
	
	                c.lineTo(end.x, end.y);
	            }
	
	            if (constraint.render.lineWidth) {
	                c.lineWidth = constraint.render.lineWidth;
	                c.strokeStyle = constraint.render.strokeStyle;
	                c.stroke();
	            }
	
	            if (constraint.render.anchors) {
	                c.fillStyle = constraint.render.strokeStyle;
	                c.beginPath();
	                c.arc(start.x, start.y, 3, 0, 2 * Math.PI);
	                c.arc(end.x, end.y, 3, 0, 2 * Math.PI);
	                c.closePath();
	                c.fill();
	            }
	        }
	    };
	
	    /**
	     * Description
	     * @private
	     * @method bodyShadows
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodyShadows = function(render, bodies, context) {
	        var c = context,
	            engine = render.engine;
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (!body.render.visible)
	                continue;
	
	            if (body.circleRadius) {
	                c.beginPath();
	                c.arc(body.position.x, body.position.y, body.circleRadius, 0, 2 * Math.PI);
	                c.closePath();
	            } else {
	                c.beginPath();
	                c.moveTo(body.vertices[0].x, body.vertices[0].y);
	                for (var j = 1; j < body.vertices.length; j++) {
	                    c.lineTo(body.vertices[j].x, body.vertices[j].y);
	                }
	                c.closePath();
	            }
	
	            var distanceX = body.position.x - render.options.width * 0.5,
	                distanceY = body.position.y - render.options.height * 0.2,
	                distance = Math.abs(distanceX) + Math.abs(distanceY);
	
	            c.shadowColor = 'rgba(0,0,0,0.15)';
	            c.shadowOffsetX = 0.05 * distanceX;
	            c.shadowOffsetY = 0.05 * distanceY;
	            c.shadowBlur = 1 + 12 * Math.min(1, distance / 1000);
	
	            c.fill();
	
	            c.shadowColor = null;
	            c.shadowOffsetX = null;
	            c.shadowOffsetY = null;
	            c.shadowBlur = null;
	        }
	    };
	
	    /**
	     * Description
	     * @private
	     * @method bodies
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodies = function(render, bodies, context) {
	        var c = context,
	            engine = render.engine,
	            options = render.options,
	            showInternalEdges = options.showInternalEdges || !options.wireframes,
	            body,
	            part,
	            i,
	            k;
	
	        for (i = 0; i < bodies.length; i++) {
	            body = bodies[i];
	
	            if (!body.render.visible)
	                continue;
	
	            // handle compound parts
	            for (k = body.parts.length > 1 ? 1 : 0; k < body.parts.length; k++) {
	                part = body.parts[k];
	
	                if (!part.render.visible)
	                    continue;
	
	                if (options.showSleeping && body.isSleeping) {
	                    c.globalAlpha = 0.5 * part.render.opacity;
	                } else if (part.render.opacity !== 1) {
	                    c.globalAlpha = part.render.opacity;
	                }
	
	                if (part.render.sprite && part.render.sprite.texture && !options.wireframes) {
	                    // part sprite
	                    var sprite = part.render.sprite,
	                        texture = _getTexture(render, sprite.texture);
	
	                    c.translate(part.position.x, part.position.y);
	                    c.rotate(part.angle);
	
	                    c.drawImage(
	                        texture,
	                        texture.width * -sprite.xOffset * sprite.xScale,
	                        texture.height * -sprite.yOffset * sprite.yScale,
	                        texture.width * sprite.xScale,
	                        texture.height * sprite.yScale
	                    );
	
	                    // revert translation, hopefully faster than save / restore
	                    c.rotate(-part.angle);
	                    c.translate(-part.position.x, -part.position.y);
	                } else {
	                    // part polygon
	                    if (part.circleRadius) {
	                        c.beginPath();
	                        c.arc(part.position.x, part.position.y, part.circleRadius, 0, 2 * Math.PI);
	                    } else {
	                        c.beginPath();
	                        c.moveTo(part.vertices[0].x, part.vertices[0].y);
	
	                        for (var j = 1; j < part.vertices.length; j++) {
	                            if (!part.vertices[j - 1].isInternal || showInternalEdges) {
	                                c.lineTo(part.vertices[j].x, part.vertices[j].y);
	                            } else {
	                                c.moveTo(part.vertices[j].x, part.vertices[j].y);
	                            }
	
	                            if (part.vertices[j].isInternal && !showInternalEdges) {
	                                c.moveTo(part.vertices[(j + 1) % part.vertices.length].x, part.vertices[(j + 1) % part.vertices.length].y);
	                            }
	                        }
	
	                        c.lineTo(part.vertices[0].x, part.vertices[0].y);
	                        c.closePath();
	                    }
	
	                    if (!options.wireframes) {
	                        c.fillStyle = part.render.fillStyle;
	
	                        if (part.render.lineWidth) {
	                            c.lineWidth = part.render.lineWidth;
	                            c.strokeStyle = part.render.strokeStyle;
	                            c.stroke();
	                        }
	
	                        c.fill();
	                    } else {
	                        c.lineWidth = 1;
	                        c.strokeStyle = '#bbb';
	                        c.stroke();
	                    }
	                }
	
	                c.globalAlpha = 1;
	            }
	        }
	    };
	
	    /**
	     * Optimised method for drawing body wireframes in one pass
	     * @private
	     * @method bodyWireframes
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodyWireframes = function(render, bodies, context) {
	        var c = context,
	            showInternalEdges = render.options.showInternalEdges,
	            body,
	            part,
	            i,
	            j,
	            k;
	
	        c.beginPath();
	
	        // render all bodies
	        for (i = 0; i < bodies.length; i++) {
	            body = bodies[i];
	
	            if (!body.render.visible)
	                continue;
	
	            // handle compound parts
	            for (k = body.parts.length > 1 ? 1 : 0; k < body.parts.length; k++) {
	                part = body.parts[k];
	
	                c.moveTo(part.vertices[0].x, part.vertices[0].y);
	
	                for (j = 1; j < part.vertices.length; j++) {
	                    if (!part.vertices[j - 1].isInternal || showInternalEdges) {
	                        c.lineTo(part.vertices[j].x, part.vertices[j].y);
	                    } else {
	                        c.moveTo(part.vertices[j].x, part.vertices[j].y);
	                    }
	
	                    if (part.vertices[j].isInternal && !showInternalEdges) {
	                        c.moveTo(part.vertices[(j + 1) % part.vertices.length].x, part.vertices[(j + 1) % part.vertices.length].y);
	                    }
	                }
	
	                c.lineTo(part.vertices[0].x, part.vertices[0].y);
	            }
	        }
	
	        c.lineWidth = 1;
	        c.strokeStyle = '#bbb';
	        c.stroke();
	    };
	
	    /**
	     * Optimised method for drawing body convex hull wireframes in one pass
	     * @private
	     * @method bodyConvexHulls
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodyConvexHulls = function(render, bodies, context) {
	        var c = context,
	            body,
	            part,
	            i,
	            j,
	            k;
	
	        c.beginPath();
	
	        // render convex hulls
	        for (i = 0; i < bodies.length; i++) {
	            body = bodies[i];
	
	            if (!body.render.visible || body.parts.length === 1)
	                continue;
	
	            c.moveTo(body.vertices[0].x, body.vertices[0].y);
	
	            for (j = 1; j < body.vertices.length; j++) {
	                c.lineTo(body.vertices[j].x, body.vertices[j].y);
	            }
	
	            c.lineTo(body.vertices[0].x, body.vertices[0].y);
	        }
	
	        c.lineWidth = 1;
	        c.strokeStyle = 'rgba(255,255,255,0.2)';
	        c.stroke();
	    };
	
	    /**
	     * Renders body vertex numbers.
	     * @private
	     * @method vertexNumbers
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.vertexNumbers = function(render, bodies, context) {
	        var c = context,
	            i,
	            j,
	            k;
	
	        for (i = 0; i < bodies.length; i++) {
	            var parts = bodies[i].parts;
	            for (k = parts.length > 1 ? 1 : 0; k < parts.length; k++) {
	                var part = parts[k];
	                for (j = 0; j < part.vertices.length; j++) {
	                    c.fillStyle = 'rgba(255,255,255,0.2)';
	                    c.fillText(i + '_' + j, part.position.x + (part.vertices[j].x - part.position.x) * 0.8, part.position.y + (part.vertices[j].y - part.position.y) * 0.8);
	                }
	            }
	        }
	    };
	
	    /**
	     * Renders mouse position.
	     * @private
	     * @method mousePosition
	     * @param {render} render
	     * @param {mouse} mouse
	     * @param {RenderingContext} context
	     */
	    Render.mousePosition = function(render, mouse, context) {
	        var c = context;
	        c.fillStyle = 'rgba(255,255,255,0.8)';
	        c.fillText(mouse.position.x + '  ' + mouse.position.y, mouse.position.x + 5, mouse.position.y - 5);
	    };
	
	    /**
	     * Draws body bounds
	     * @private
	     * @method bodyBounds
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodyBounds = function(render, bodies, context) {
	        var c = context,
	            engine = render.engine,
	            options = render.options;
	
	        c.beginPath();
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (body.render.visible) {
	                var parts = bodies[i].parts;
	                for (var j = parts.length > 1 ? 1 : 0; j < parts.length; j++) {
	                    var part = parts[j];
	                    c.rect(part.bounds.min.x, part.bounds.min.y, part.bounds.max.x - part.bounds.min.x, part.bounds.max.y - part.bounds.min.y);
	                }
	            }
	        }
	
	        if (options.wireframes) {
	            c.strokeStyle = 'rgba(255,255,255,0.08)';
	        } else {
	            c.strokeStyle = 'rgba(0,0,0,0.1)';
	        }
	
	        c.lineWidth = 1;
	        c.stroke();
	    };
	
	    /**
	     * Draws body angle indicators and axes
	     * @private
	     * @method bodyAxes
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodyAxes = function(render, bodies, context) {
	        var c = context,
	            engine = render.engine,
	            options = render.options,
	            part,
	            i,
	            j,
	            k;
	
	        c.beginPath();
	
	        for (i = 0; i < bodies.length; i++) {
	            var body = bodies[i],
	                parts = body.parts;
	
	            if (!body.render.visible)
	                continue;
	
	            if (options.showAxes) {
	                // render all axes
	                for (j = parts.length > 1 ? 1 : 0; j < parts.length; j++) {
	                    part = parts[j];
	                    for (k = 0; k < part.axes.length; k++) {
	                        var axis = part.axes[k];
	                        c.moveTo(part.position.x, part.position.y);
	                        c.lineTo(part.position.x + axis.x * 20, part.position.y + axis.y * 20);
	                    }
	                }
	            } else {
	                for (j = parts.length > 1 ? 1 : 0; j < parts.length; j++) {
	                    part = parts[j];
	                    for (k = 0; k < part.axes.length; k++) {
	                        // render a single axis indicator
	                        c.moveTo(part.position.x, part.position.y);
	                        c.lineTo((part.vertices[0].x + part.vertices[part.vertices.length-1].x) / 2,
	                                 (part.vertices[0].y + part.vertices[part.vertices.length-1].y) / 2);
	                    }
	                }
	            }
	        }
	
	        if (options.wireframes) {
	            c.strokeStyle = 'indianred';
	            c.lineWidth = 1;
	        } else {
	            c.strokeStyle = 'rgba(255, 255, 255, 0.4)';
	            c.globalCompositeOperation = 'overlay';
	            c.lineWidth = 2;
	        }
	
	        c.stroke();
	        c.globalCompositeOperation = 'source-over';
	    };
	
	    /**
	     * Draws body positions
	     * @private
	     * @method bodyPositions
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodyPositions = function(render, bodies, context) {
	        var c = context,
	            engine = render.engine,
	            options = render.options,
	            body,
	            part,
	            i,
	            k;
	
	        c.beginPath();
	
	        // render current positions
	        for (i = 0; i < bodies.length; i++) {
	            body = bodies[i];
	
	            if (!body.render.visible)
	                continue;
	
	            // handle compound parts
	            for (k = 0; k < body.parts.length; k++) {
	                part = body.parts[k];
	                c.arc(part.position.x, part.position.y, 3, 0, 2 * Math.PI, false);
	                c.closePath();
	            }
	        }
	
	        if (options.wireframes) {
	            c.fillStyle = 'indianred';
	        } else {
	            c.fillStyle = 'rgba(0,0,0,0.5)';
	        }
	        c.fill();
	
	        c.beginPath();
	
	        // render previous positions
	        for (i = 0; i < bodies.length; i++) {
	            body = bodies[i];
	            if (body.render.visible) {
	                c.arc(body.positionPrev.x, body.positionPrev.y, 2, 0, 2 * Math.PI, false);
	                c.closePath();
	            }
	        }
	
	        c.fillStyle = 'rgba(255,165,0,0.8)';
	        c.fill();
	    };
	
	    /**
	     * Draws body velocity
	     * @private
	     * @method bodyVelocity
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodyVelocity = function(render, bodies, context) {
	        var c = context;
	
	        c.beginPath();
	
	        for (var i = 0; i < bodies.length; i++) {
	            var body = bodies[i];
	
	            if (!body.render.visible)
	                continue;
	
	            c.moveTo(body.position.x, body.position.y);
	            c.lineTo(body.position.x + (body.position.x - body.positionPrev.x) * 2, body.position.y + (body.position.y - body.positionPrev.y) * 2);
	        }
	
	        c.lineWidth = 3;
	        c.strokeStyle = 'cornflowerblue';
	        c.stroke();
	    };
	
	    /**
	     * Draws body ids
	     * @private
	     * @method bodyIds
	     * @param {render} render
	     * @param {body[]} bodies
	     * @param {RenderingContext} context
	     */
	    Render.bodyIds = function(render, bodies, context) {
	        var c = context,
	            i,
	            j;
	
	        for (i = 0; i < bodies.length; i++) {
	            if (!bodies[i].render.visible)
	                continue;
	
	            var parts = bodies[i].parts;
	            for (j = parts.length > 1 ? 1 : 0; j < parts.length; j++) {
	                var part = parts[j];
	                c.font = "12px Arial";
	                c.fillStyle = 'rgba(255,255,255,0.5)';
	                c.fillText(part.id, part.position.x + 10, part.position.y - 10);
	            }
	        }
	    };
	
	    /**
	     * Description
	     * @private
	     * @method collisions
	     * @param {render} render
	     * @param {pair[]} pairs
	     * @param {RenderingContext} context
	     */
	    Render.collisions = function(render, pairs, context) {
	        var c = context,
	            options = render.options,
	            pair,
	            collision,
	            corrected,
	            bodyA,
	            bodyB,
	            i,
	            j;
	
	        c.beginPath();
	
	        // render collision positions
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	
	            if (!pair.isActive)
	                continue;
	
	            collision = pair.collision;
	            for (j = 0; j < pair.activeContacts.length; j++) {
	                var contact = pair.activeContacts[j],
	                    vertex = contact.vertex;
	                c.rect(vertex.x - 1.5, vertex.y - 1.5, 3.5, 3.5);
	            }
	        }
	
	        if (options.wireframes) {
	            c.fillStyle = 'rgba(255,255,255,0.7)';
	        } else {
	            c.fillStyle = 'orange';
	        }
	        c.fill();
	
	        c.beginPath();
	
	        // render collision normals
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	
	            if (!pair.isActive)
	                continue;
	
	            collision = pair.collision;
	
	            if (pair.activeContacts.length > 0) {
	                var normalPosX = pair.activeContacts[0].vertex.x,
	                    normalPosY = pair.activeContacts[0].vertex.y;
	
	                if (pair.activeContacts.length === 2) {
	                    normalPosX = (pair.activeContacts[0].vertex.x + pair.activeContacts[1].vertex.x) / 2;
	                    normalPosY = (pair.activeContacts[0].vertex.y + pair.activeContacts[1].vertex.y) / 2;
	                }
	
	                if (collision.bodyB === collision.supports[0].body || collision.bodyA.isStatic === true) {
	                    c.moveTo(normalPosX - collision.normal.x * 8, normalPosY - collision.normal.y * 8);
	                } else {
	                    c.moveTo(normalPosX + collision.normal.x * 8, normalPosY + collision.normal.y * 8);
	                }
	
	                c.lineTo(normalPosX, normalPosY);
	            }
	        }
	
	        if (options.wireframes) {
	            c.strokeStyle = 'rgba(255,165,0,0.7)';
	        } else {
	            c.strokeStyle = 'orange';
	        }
	
	        c.lineWidth = 1;
	        c.stroke();
	    };
	
	    /**
	     * Description
	     * @private
	     * @method separations
	     * @param {render} render
	     * @param {pair[]} pairs
	     * @param {RenderingContext} context
	     */
	    Render.separations = function(render, pairs, context) {
	        var c = context,
	            options = render.options,
	            pair,
	            collision,
	            corrected,
	            bodyA,
	            bodyB,
	            i,
	            j;
	
	        c.beginPath();
	
	        // render separations
	        for (i = 0; i < pairs.length; i++) {
	            pair = pairs[i];
	
	            if (!pair.isActive)
	                continue;
	
	            collision = pair.collision;
	            bodyA = collision.bodyA;
	            bodyB = collision.bodyB;
	
	            var k = 1;
	
	            if (!bodyB.isStatic && !bodyA.isStatic) k = 0.5;
	            if (bodyB.isStatic) k = 0;
	
	            c.moveTo(bodyB.position.x, bodyB.position.y);
	            c.lineTo(bodyB.position.x - collision.penetration.x * k, bodyB.position.y - collision.penetration.y * k);
	
	            k = 1;
	
	            if (!bodyB.isStatic && !bodyA.isStatic) k = 0.5;
	            if (bodyA.isStatic) k = 0;
	
	            c.moveTo(bodyA.position.x, bodyA.position.y);
	            c.lineTo(bodyA.position.x + collision.penetration.x * k, bodyA.position.y + collision.penetration.y * k);
	        }
	
	        if (options.wireframes) {
	            c.strokeStyle = 'rgba(255,165,0,0.5)';
	        } else {
	            c.strokeStyle = 'orange';
	        }
	        c.stroke();
	    };
	
	    /**
	     * Description
	     * @private
	     * @method grid
	     * @param {render} render
	     * @param {grid} grid
	     * @param {RenderingContext} context
	     */
	    Render.grid = function(render, grid, context) {
	        var c = context,
	            options = render.options;
	
	        if (options.wireframes) {
	            c.strokeStyle = 'rgba(255,180,0,0.1)';
	        } else {
	            c.strokeStyle = 'rgba(255,180,0,0.5)';
	        }
	
	        c.beginPath();
	
	        var bucketKeys = Common.keys(grid.buckets);
	
	        for (var i = 0; i < bucketKeys.length; i++) {
	            var bucketId = bucketKeys[i];
	
	            if (grid.buckets[bucketId].length < 2)
	                continue;
	
	            var region = bucketId.split(/C|R/);
	            c.rect(0.5 + parseInt(region[1], 10) * grid.bucketWidth,
	                    0.5 + parseInt(region[2], 10) * grid.bucketHeight,
	                    grid.bucketWidth,
	                    grid.bucketHeight);
	        }
	
	        c.lineWidth = 1;
	        c.stroke();
	    };
	
	    /**
	     * Description
	     * @private
	     * @method inspector
	     * @param {inspector} inspector
	     * @param {RenderingContext} context
	     */
	    Render.inspector = function(inspector, context) {
	        var engine = inspector.engine,
	            selected = inspector.selected,
	            render = inspector.render,
	            options = render.options,
	            bounds;
	
	        if (options.hasBounds) {
	            var boundsWidth = render.bounds.max.x - render.bounds.min.x,
	                boundsHeight = render.bounds.max.y - render.bounds.min.y,
	                boundsScaleX = boundsWidth / render.options.width,
	                boundsScaleY = boundsHeight / render.options.height;
	
	            context.scale(1 / boundsScaleX, 1 / boundsScaleY);
	            context.translate(-render.bounds.min.x, -render.bounds.min.y);
	        }
	
	        for (var i = 0; i < selected.length; i++) {
	            var item = selected[i].data;
	
	            context.translate(0.5, 0.5);
	            context.lineWidth = 1;
	            context.strokeStyle = 'rgba(255,165,0,0.9)';
	            context.setLineDash([1,2]);
	
	            switch (item.type) {
	
	            case 'body':
	
	                // render body selections
	                bounds = item.bounds;
	                context.beginPath();
	                context.rect(Math.floor(bounds.min.x - 3), Math.floor(bounds.min.y - 3),
	                             Math.floor(bounds.max.x - bounds.min.x + 6), Math.floor(bounds.max.y - bounds.min.y + 6));
	                context.closePath();
	                context.stroke();
	
	                break;
	
	            case 'constraint':
	
	                // render constraint selections
	                var point = item.pointA;
	                if (item.bodyA)
	                    point = item.pointB;
	                context.beginPath();
	                context.arc(point.x, point.y, 10, 0, 2 * Math.PI);
	                context.closePath();
	                context.stroke();
	
	                break;
	
	            }
	
	            context.setLineDash([]);
	            context.translate(-0.5, -0.5);
	        }
	
	        // render selection region
	        if (inspector.selectStart !== null) {
	            context.translate(0.5, 0.5);
	            context.lineWidth = 1;
	            context.strokeStyle = 'rgba(255,165,0,0.6)';
	            context.fillStyle = 'rgba(255,165,0,0.1)';
	            bounds = inspector.selectBounds;
	            context.beginPath();
	            context.rect(Math.floor(bounds.min.x), Math.floor(bounds.min.y),
	                         Math.floor(bounds.max.x - bounds.min.x), Math.floor(bounds.max.y - bounds.min.y));
	            context.closePath();
	            context.stroke();
	            context.fill();
	            context.translate(-0.5, -0.5);
	        }
	
	        if (options.hasBounds)
	            context.setTransform(1, 0, 0, 1, 0, 0);
	    };
	
	    /**
	     * Description
	     * @method _createCanvas
	     * @private
	     * @param {} width
	     * @param {} height
	     * @return canvas
	     */
	    var _createCanvas = function(width, height) {
	        var canvas = document.createElement('canvas');
	        canvas.width = width;
	        canvas.height = height;
	        canvas.oncontextmenu = function() { return false; };
	        canvas.onselectstart = function() { return false; };
	        return canvas;
	    };
	
	    /**
	     * Gets the pixel ratio of the canvas.
	     * @method _getPixelRatio
	     * @private
	     * @param {HTMLElement} canvas
	     * @return {Number} pixel ratio
	     */
	    var _getPixelRatio = function(canvas) {
	        var context = canvas.getContext('2d'),
	            devicePixelRatio = window.devicePixelRatio || 1,
	            backingStorePixelRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio
	                                      || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio
	                                      || context.backingStorePixelRatio || 1;
	
	        return devicePixelRatio / backingStorePixelRatio;
	    };
	
	    /**
	     * Gets the requested texture (an Image) via its path
	     * @method _getTexture
	     * @private
	     * @param {render} render
	     * @param {string} imagePath
	     * @return {Image} texture
	     */
	    var _getTexture = function(render, imagePath) {
	        var image = render.textures[imagePath];
	
	        if (image)
	            return image;
	
	        image = render.textures[imagePath] = new Image();
	        image.src = imagePath;
	
	        return image;
	    };
	
	    /**
	     * Applies the background to the canvas using CSS.
	     * @method applyBackground
	     * @private
	     * @param {render} render
	     * @param {string} background
	     */
	    var _applyBackground = function(render, background) {
	        var cssBackground = background;
	
	        if (/(jpg|gif|png)$/.test(background))
	            cssBackground = 'url(' + background + ')';
	
	        render.canvas.style.background = cssBackground;
	        render.canvas.style.backgroundSize = "contain";
	        render.currentBackground = background;
	    };
	
	    /*
	    *
	    *  Events Documentation
	    *
	    */
	
	    /**
	    * Fired before rendering
	    *
	    * @event beforeRender
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /**
	    * Fired after rendering
	    *
	    * @event afterRender
	    * @param {} event An event object
	    * @param {number} event.timestamp The engine.timing.timestamp of the event
	    * @param {} event.source The source object of the event
	    * @param {} event.name The name of the event
	    */
	
	    /*
	    *
	    *  Properties Documentation
	    *
	    */
	
	    /**
	     * A back-reference to the `Matter.Render` module.
	     *
	     * @property controller
	     * @type render
	     */
	
	    /**
	     * A reference to the `Matter.Engine` instance to be used.
	     *
	     * @property engine
	     * @type engine
	     */
	
	    /**
	     * A reference to the element where the canvas is to be inserted (if `render.canvas` has not been specified)
	     *
	     * @property element
	     * @type HTMLElement
	     * @default null
	     */
	
	    /**
	     * The canvas element to render to. If not specified, one will be created if `render.element` has been specified.
	     *
	     * @property canvas
	     * @type HTMLCanvasElement
	     * @default null
	     */
	
	    /**
	     * The configuration options of the renderer.
	     *
	     * @property options
	     * @type {}
	     */
	
	    /**
	     * The target width in pixels of the `render.canvas` to be created.
	     *
	     * @property options.width
	     * @type number
	     * @default 800
	     */
	
	    /**
	     * The target height in pixels of the `render.canvas` to be created.
	     *
	     * @property options.height
	     * @type number
	     * @default 600
	     */
	
	    /**
	     * A flag that specifies if `render.bounds` should be used when rendering.
	     *
	     * @property options.hasBounds
	     * @type boolean
	     * @default false
	     */
	
	    /**
	     * A `Bounds` object that specifies the drawing view region.
	     * Rendering will be automatically transformed and scaled to fit within the canvas size (`render.options.width` and `render.options.height`).
	     * This allows for creating views that can pan or zoom around the scene.
	     * You must also set `render.options.hasBounds` to `true` to enable bounded rendering.
	     *
	     * @property bounds
	     * @type bounds
	     */
	
	    /**
	     * The 2d rendering context from the `render.canvas` element.
	     *
	     * @property context
	     * @type CanvasRenderingContext2D
	     */
	
	    /**
	     * The sprite texture cache.
	     *
	     * @property textures
	     * @type {}
	     */
	
	})();
	
	},{"../body/Composite":2,"../collision/Grid":6,"../core/Common":14,"../core/Events":16,"../core/Mouse":19,"../geometry/Bounds":26,"../geometry/Vector":28}],32:[function(_dereq_,module,exports){
	/**
	* The `Matter.RenderPixi` module is an example renderer using pixi.js.
	* See also `Matter.Render` for a canvas based renderer.
	*
	* @class RenderPixi
	* @deprecated the Matter.RenderPixi module will soon be removed from the Matter.js core.
	* It will likely be moved to its own repository (but maintenance will be limited).
	*/
	
	var RenderPixi = {};
	
	module.exports = RenderPixi;
	
	var Bounds = _dereq_('../geometry/Bounds');
	var Composite = _dereq_('../body/Composite');
	var Common = _dereq_('../core/Common');
	var Events = _dereq_('../core/Events');
	var Vector = _dereq_('../geometry/Vector');
	
	(function() {
	
	    var _requestAnimationFrame,
	        _cancelAnimationFrame;
	
	    if (typeof window !== 'undefined') {
	        _requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame
	                                      || window.mozRequestAnimationFrame || window.msRequestAnimationFrame 
	                                      || function(callback){ window.setTimeout(function() { callback(Common.now()); }, 1000 / 60); };
	   
	        _cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame 
	                                      || window.webkitCancelAnimationFrame || window.msCancelAnimationFrame;
	    }
	    
	    /**
	     * Creates a new Pixi.js WebGL renderer
	     * @method create
	     * @param {object} options
	     * @return {RenderPixi} A new renderer
	     * @deprecated
	     */
	    RenderPixi.create = function(options) {
	        Common.warn('RenderPixi.create: Matter.RenderPixi is deprecated (see docs)');
	
	        var defaults = {
	            controller: RenderPixi,
	            engine: null,
	            element: null,
	            frameRequestId: null,
	            canvas: null,
	            renderer: null,
	            container: null,
	            spriteContainer: null,
	            pixiOptions: null,
	            options: {
	                width: 800,
	                height: 600,
	                background: '#fafafa',
	                wireframeBackground: '#222',
	                hasBounds: false,
	                enabled: true,
	                wireframes: true,
	                showSleeping: true,
	                showDebug: false,
	                showBroadphase: false,
	                showBounds: false,
	                showVelocity: false,
	                showCollisions: false,
	                showAxes: false,
	                showPositions: false,
	                showAngleIndicator: false,
	                showIds: false,
	                showShadows: false
	            }
	        };
	
	        var render = Common.extend(defaults, options),
	            transparent = !render.options.wireframes && render.options.background === 'transparent';
	
	        // init pixi
	        render.pixiOptions = render.pixiOptions || {
	            view: render.canvas,
	            transparent: transparent,
	            antialias: true,
	            backgroundColor: options.background
	        };
	
	        render.mouse = options.mouse;
	        render.engine = options.engine;
	        render.renderer = render.renderer || new PIXI.WebGLRenderer(render.options.width, render.options.height, render.pixiOptions);
	        render.container = render.container || new PIXI.Container();
	        render.spriteContainer = render.spriteContainer || new PIXI.Container();
	        render.canvas = render.canvas || render.renderer.view;
	        render.bounds = render.bounds || { 
	            min: {
	                x: 0,
	                y: 0
	            }, 
	            max: { 
	                x: render.options.width,
	                y: render.options.height
	            }
	        };
	
	        // event listeners
	        Events.on(render.engine, 'beforeUpdate', function() {
	            RenderPixi.clear(render);
	        });
	
	        // caches
	        render.textures = {};
	        render.sprites = {};
	        render.primitives = {};
	
	        // use a sprite batch for performance
	        render.container.addChild(render.spriteContainer);
	
	        // insert canvas
	        if (Common.isElement(render.element)) {
	            render.element.appendChild(render.canvas);
	        } else {
	            Common.warn('No "render.element" passed, "render.canvas" was not inserted into document.');
	        }
	
	        // prevent menus on canvas
	        render.canvas.oncontextmenu = function() { return false; };
	        render.canvas.onselectstart = function() { return false; };
	
	        return render;
	    };
	
	    /**
	     * Continuously updates the render canvas on the `requestAnimationFrame` event.
	     * @method run
	     * @param {render} render
	     * @deprecated
	     */
	    RenderPixi.run = function(render) {
	        (function loop(time){
	            render.frameRequestId = _requestAnimationFrame(loop);
	            RenderPixi.world(render);
	        })();
	    };
	
	    /**
	     * Ends execution of `Render.run` on the given `render`, by canceling the animation frame request event loop.
	     * @method stop
	     * @param {render} render
	     * @deprecated
	     */
	    RenderPixi.stop = function(render) {
	        _cancelAnimationFrame(render.frameRequestId);
	    };
	
	    /**
	     * Clears the scene graph
	     * @method clear
	     * @param {RenderPixi} render
	     * @deprecated
	     */
	    RenderPixi.clear = function(render) {
	        var container = render.container,
	            spriteContainer = render.spriteContainer;
	
	        // clear stage container
	        while (container.children[0]) { 
	            container.removeChild(container.children[0]); 
	        }
	
	        // clear sprite batch
	        while (spriteContainer.children[0]) { 
	            spriteContainer.removeChild(spriteContainer.children[0]); 
	        }
	
	        var bgSprite = render.sprites['bg-0'];
	
	        // clear caches
	        render.textures = {};
	        render.sprites = {};
	        render.primitives = {};
	
	        // set background sprite
	        render.sprites['bg-0'] = bgSprite;
	        if (bgSprite)
	            container.addChildAt(bgSprite, 0);
	
	        // add sprite batch back into container
	        render.container.addChild(render.spriteContainer);
	
	        // reset background state
	        render.currentBackground = null;
	
	        // reset bounds transforms
	        container.scale.set(1, 1);
	        container.position.set(0, 0);
	    };
	
	    /**
	     * Sets the background of the canvas 
	     * @method setBackground
	     * @param {RenderPixi} render
	     * @param {string} background
	     * @deprecated
	     */
	    RenderPixi.setBackground = function(render, background) {
	        if (render.currentBackground !== background) {
	            var isColor = background.indexOf && background.indexOf('#') !== -1,
	                bgSprite = render.sprites['bg-0'];
	
	            if (isColor) {
	                // if solid background color
	                var color = Common.colorToNumber(background);
	                render.renderer.backgroundColor = color;
	
	                // remove background sprite if existing
	                if (bgSprite)
	                    render.container.removeChild(bgSprite); 
	            } else {
	                // initialise background sprite if needed
	                if (!bgSprite) {
	                    var texture = _getTexture(render, background);
	
	                    bgSprite = render.sprites['bg-0'] = new PIXI.Sprite(texture);
	                    bgSprite.position.x = 0;
	                    bgSprite.position.y = 0;
	                    render.container.addChildAt(bgSprite, 0);
	                }
	            }
	
	            render.currentBackground = background;
	        }
	    };
	
	    /**
	     * Description
	     * @method world
	     * @param {engine} engine
	     * @deprecated
	     */
	    RenderPixi.world = function(render) {
	        var engine = render.engine,
	            world = engine.world,
	            renderer = render.renderer,
	            container = render.container,
	            options = render.options,
	            bodies = Composite.allBodies(world),
	            allConstraints = Composite.allConstraints(world),
	            constraints = [],
	            i;
	
	        if (options.wireframes) {
	            RenderPixi.setBackground(render, options.wireframeBackground);
	        } else {
	            RenderPixi.setBackground(render, options.background);
	        }
	
	        // handle bounds
	        var boundsWidth = render.bounds.max.x - render.bounds.min.x,
	            boundsHeight = render.bounds.max.y - render.bounds.min.y,
	            boundsScaleX = boundsWidth / render.options.width,
	            boundsScaleY = boundsHeight / render.options.height;
	
	        if (options.hasBounds) {
	            // Hide bodies that are not in view
	            for (i = 0; i < bodies.length; i++) {
	                var body = bodies[i];
	                body.render.sprite.visible = Bounds.overlaps(body.bounds, render.bounds);
	            }
	
	            // filter out constraints that are not in view
	            for (i = 0; i < allConstraints.length; i++) {
	                var constraint = allConstraints[i],
	                    bodyA = constraint.bodyA,
	                    bodyB = constraint.bodyB,
	                    pointAWorld = constraint.pointA,
	                    pointBWorld = constraint.pointB;
	
	                if (bodyA) pointAWorld = Vector.add(bodyA.position, constraint.pointA);
	                if (bodyB) pointBWorld = Vector.add(bodyB.position, constraint.pointB);
	
	                if (!pointAWorld || !pointBWorld)
	                    continue;
	
	                if (Bounds.contains(render.bounds, pointAWorld) || Bounds.contains(render.bounds, pointBWorld))
	                    constraints.push(constraint);
	            }
	
	            // transform the view
	            container.scale.set(1 / boundsScaleX, 1 / boundsScaleY);
	            container.position.set(-render.bounds.min.x * (1 / boundsScaleX), -render.bounds.min.y * (1 / boundsScaleY));
	        } else {
	            constraints = allConstraints;
	        }
	
	        for (i = 0; i < bodies.length; i++)
	            RenderPixi.body(render, bodies[i]);
	
	        for (i = 0; i < constraints.length; i++)
	            RenderPixi.constraint(render, constraints[i]);
	
	        renderer.render(container);
	    };
	
	
	    /**
	     * Description
	     * @method constraint
	     * @param {engine} engine
	     * @param {constraint} constraint
	     * @deprecated
	     */
	    RenderPixi.constraint = function(render, constraint) {
	        var engine = render.engine,
	            bodyA = constraint.bodyA,
	            bodyB = constraint.bodyB,
	            pointA = constraint.pointA,
	            pointB = constraint.pointB,
	            container = render.container,
	            constraintRender = constraint.render,
	            primitiveId = 'c-' + constraint.id,
	            primitive = render.primitives[primitiveId];
	
	        // initialise constraint primitive if not existing
	        if (!primitive)
	            primitive = render.primitives[primitiveId] = new PIXI.Graphics();
	
	        // don't render if constraint does not have two end points
	        if (!constraintRender.visible || !constraint.pointA || !constraint.pointB) {
	            primitive.clear();
	            return;
	        }
	
	        // add to scene graph if not already there
	        if (Common.indexOf(container.children, primitive) === -1)
	            container.addChild(primitive);
	
	        // render the constraint on every update, since they can change dynamically
	        primitive.clear();
	        primitive.beginFill(0, 0);
	        primitive.lineStyle(constraintRender.lineWidth, Common.colorToNumber(constraintRender.strokeStyle), 1);
	        
	        if (bodyA) {
	            primitive.moveTo(bodyA.position.x + pointA.x, bodyA.position.y + pointA.y);
	        } else {
	            primitive.moveTo(pointA.x, pointA.y);
	        }
	
	        if (bodyB) {
	            primitive.lineTo(bodyB.position.x + pointB.x, bodyB.position.y + pointB.y);
	        } else {
	            primitive.lineTo(pointB.x, pointB.y);
	        }
	
	        primitive.endFill();
	    };
	    
	    /**
	     * Description
	     * @method body
	     * @param {engine} engine
	     * @param {body} body
	     * @deprecated
	     */
	    RenderPixi.body = function(render, body) {
	        var engine = render.engine,
	            bodyRender = body.render;
	
	        if (!bodyRender.visible)
	            return;
	
	        if (bodyRender.sprite && bodyRender.sprite.texture) {
	            var spriteId = 'b-' + body.id,
	                sprite = render.sprites[spriteId],
	                spriteContainer = render.spriteContainer;
	
	            // initialise body sprite if not existing
	            if (!sprite)
	                sprite = render.sprites[spriteId] = _createBodySprite(render, body);
	
	            // add to scene graph if not already there
	            if (Common.indexOf(spriteContainer.children, sprite) === -1)
	                spriteContainer.addChild(sprite);
	
	            // update body sprite
	            sprite.position.x = body.position.x;
	            sprite.position.y = body.position.y;
	            sprite.rotation = body.angle;
	            sprite.scale.x = bodyRender.sprite.xScale || 1;
	            sprite.scale.y = bodyRender.sprite.yScale || 1;
	        } else {
	            var primitiveId = 'b-' + body.id,
	                primitive = render.primitives[primitiveId],
	                container = render.container;
	
	            // initialise body primitive if not existing
	            if (!primitive) {
	                primitive = render.primitives[primitiveId] = _createBodyPrimitive(render, body);
	                primitive.initialAngle = body.angle;
	            }
	
	            // add to scene graph if not already there
	            if (Common.indexOf(container.children, primitive) === -1)
	                container.addChild(primitive);
	
	            // update body primitive
	            primitive.position.x = body.position.x;
	            primitive.position.y = body.position.y;
	            primitive.rotation = body.angle - primitive.initialAngle;
	        }
	    };
	
	    /**
	     * Creates a body sprite
	     * @method _createBodySprite
	     * @private
	     * @param {RenderPixi} render
	     * @param {body} body
	     * @return {PIXI.Sprite} sprite
	     * @deprecated
	     */
	    var _createBodySprite = function(render, body) {
	        var bodyRender = body.render,
	            texturePath = bodyRender.sprite.texture,
	            texture = _getTexture(render, texturePath),
	            sprite = new PIXI.Sprite(texture);
	
	        sprite.anchor.x = body.render.sprite.xOffset;
	        sprite.anchor.y = body.render.sprite.yOffset;
	
	        return sprite;
	    };
	
	    /**
	     * Creates a body primitive
	     * @method _createBodyPrimitive
	     * @private
	     * @param {RenderPixi} render
	     * @param {body} body
	     * @return {PIXI.Graphics} graphics
	     * @deprecated
	     */
	    var _createBodyPrimitive = function(render, body) {
	        var bodyRender = body.render,
	            options = render.options,
	            primitive = new PIXI.Graphics(),
	            fillStyle = Common.colorToNumber(bodyRender.fillStyle),
	            strokeStyle = Common.colorToNumber(bodyRender.strokeStyle),
	            strokeStyleIndicator = Common.colorToNumber(bodyRender.strokeStyle),
	            strokeStyleWireframe = Common.colorToNumber('#bbb'),
	            strokeStyleWireframeIndicator = Common.colorToNumber('#CD5C5C'),
	            part;
	
	        primitive.clear();
	
	        // handle compound parts
	        for (var k = body.parts.length > 1 ? 1 : 0; k < body.parts.length; k++) {
	            part = body.parts[k];
	
	            if (!options.wireframes) {
	                primitive.beginFill(fillStyle, 1);
	                primitive.lineStyle(bodyRender.lineWidth, strokeStyle, 1);
	            } else {
	                primitive.beginFill(0, 0);
	                primitive.lineStyle(1, strokeStyleWireframe, 1);
	            }
	
	            primitive.moveTo(part.vertices[0].x - body.position.x, part.vertices[0].y - body.position.y);
	
	            for (var j = 1; j < part.vertices.length; j++) {
	                primitive.lineTo(part.vertices[j].x - body.position.x, part.vertices[j].y - body.position.y);
	            }
	
	            primitive.lineTo(part.vertices[0].x - body.position.x, part.vertices[0].y - body.position.y);
	
	            primitive.endFill();
	
	            // angle indicator
	            if (options.showAngleIndicator || options.showAxes) {
	                primitive.beginFill(0, 0);
	
	                if (options.wireframes) {
	                    primitive.lineStyle(1, strokeStyleWireframeIndicator, 1);
	                } else {
	                    primitive.lineStyle(1, strokeStyleIndicator);
	                }
	
	                primitive.moveTo(part.position.x - body.position.x, part.position.y - body.position.y);
	                primitive.lineTo(((part.vertices[0].x + part.vertices[part.vertices.length-1].x) / 2 - body.position.x), 
	                                 ((part.vertices[0].y + part.vertices[part.vertices.length-1].y) / 2 - body.position.y));
	
	                primitive.endFill();
	            }
	        }
	
	        return primitive;
	    };
	
	    /**
	     * Gets the requested texture (a PIXI.Texture) via its path
	     * @method _getTexture
	     * @private
	     * @param {RenderPixi} render
	     * @param {string} imagePath
	     * @return {PIXI.Texture} texture
	     * @deprecated
	     */
	    var _getTexture = function(render, imagePath) {
	        var texture = render.textures[imagePath];
	
	        if (!texture)
	            texture = render.textures[imagePath] = PIXI.Texture.fromImage(imagePath);
	
	        return texture;
	    };
	
	})();
	
	},{"../body/Composite":2,"../core/Common":14,"../core/Events":16,"../geometry/Bounds":26,"../geometry/Vector":28}]},{},[30])(30)
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

	/** @license mobx-react v5.4.4
	 * index.js
	 *
	 * Copyright (c) 2015 Michel Weststrate.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(53), __webpack_require__(1), __webpack_require__(75)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'mobx', 'react', 'react-dom'], factory) :
	  (factory((global.mobxReact = {}),global.mobx,global.React,global.ReactDOM));
	}(this, (function (exports,mobx,React,reactDom) { 'use strict';
	
	  var React__default = 'default' in React ? React['default'] : React;
	
	  function _typeof(obj) {
	    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	      _typeof = function (obj) {
	        return typeof obj;
	      };
	    } else {
	      _typeof = function (obj) {
	        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	      };
	    }
	
	    return _typeof(obj);
	  }
	
	  function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  }
	
	  function _defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  function _createClass(Constructor, protoProps, staticProps) {
	    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) _defineProperties(Constructor, staticProps);
	    return Constructor;
	  }
	
	  function _defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }
	
	    return obj;
	  }
	
	  function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	      throw new TypeError("Super expression must either be null or a function");
	    }
	
	    subClass.prototype = Object.create(superClass && superClass.prototype, {
	      constructor: {
	        value: subClass,
	        writable: true,
	        configurable: true
	      }
	    });
	    if (superClass) _setPrototypeOf(subClass, superClass);
	  }
	
	  function _getPrototypeOf(o) {
	    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	      return o.__proto__ || Object.getPrototypeOf(o);
	    };
	    return _getPrototypeOf(o);
	  }
	
	  function _setPrototypeOf(o, p) {
	    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	      o.__proto__ = p;
	      return o;
	    };
	
	    return _setPrototypeOf(o, p);
	  }
	
	  function _assertThisInitialized(self) {
	    if (self === void 0) {
	      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }
	
	    return self;
	  }
	
	  function _possibleConstructorReturn(self, call) {
	    if (call && (typeof call === "object" || typeof call === "function")) {
	      return call;
	    }
	
	    return _assertThisInitialized(self);
	  }
	
	  // These functions can be stubbed out in specific environments
	
	  function unwrapExports (x) {
	  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
	  }
	
	  function createCommonjsModule(fn, module) {
	  	return module = { exports: {} }, fn(module, module.exports), module.exports;
	  }
	
	  var reactIs_production_min = createCommonjsModule(function (module, exports) {
	  Object.defineProperty(exports,"__esModule",{value:!0});
	  var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,r=b?Symbol.for("react.memo"):
	  60115,t=b?Symbol.for("react.lazy"):60116;function u(a){if("object"===typeof a&&null!==a){var q=a.$$typeof;switch(q){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return q}}case d:return q}}}function v(a){return u(a)===m}exports.typeOf=u;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;
	  exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||u(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return u(a)===k};exports.isContextProvider=function(a){return u(a)===h};
	  exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return u(a)===n};exports.isFragment=function(a){return u(a)===e};exports.isProfiler=function(a){return u(a)===g};exports.isPortal=function(a){return u(a)===d};exports.isStrictMode=function(a){return u(a)===f};
	  });
	
	  unwrapExports(reactIs_production_min);
	  var reactIs_production_min_1 = reactIs_production_min.typeOf;
	  var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
	  var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
	  var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
	  var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
	  var reactIs_production_min_6 = reactIs_production_min.Element;
	  var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
	  var reactIs_production_min_8 = reactIs_production_min.Fragment;
	  var reactIs_production_min_9 = reactIs_production_min.Profiler;
	  var reactIs_production_min_10 = reactIs_production_min.Portal;
	  var reactIs_production_min_11 = reactIs_production_min.StrictMode;
	  var reactIs_production_min_12 = reactIs_production_min.isValidElementType;
	  var reactIs_production_min_13 = reactIs_production_min.isAsyncMode;
	  var reactIs_production_min_14 = reactIs_production_min.isConcurrentMode;
	  var reactIs_production_min_15 = reactIs_production_min.isContextConsumer;
	  var reactIs_production_min_16 = reactIs_production_min.isContextProvider;
	  var reactIs_production_min_17 = reactIs_production_min.isElement;
	  var reactIs_production_min_18 = reactIs_production_min.isForwardRef;
	  var reactIs_production_min_19 = reactIs_production_min.isFragment;
	  var reactIs_production_min_20 = reactIs_production_min.isProfiler;
	  var reactIs_production_min_21 = reactIs_production_min.isPortal;
	  var reactIs_production_min_22 = reactIs_production_min.isStrictMode;
	
	  var reactIs = createCommonjsModule(function (module) {
	
	  {
	    module.exports = reactIs_production_min;
	  }
	  });
	
	  /**
	   * Copyright 2015, Yahoo! Inc.
	   * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	   */
	
	  var REACT_STATICS = {
	      childContextTypes: true,
	      contextType: true,
	      contextTypes: true,
	      defaultProps: true,
	      displayName: true,
	      getDefaultProps: true,
	      getDerivedStateFromError: true,
	      getDerivedStateFromProps: true,
	      mixins: true,
	      propTypes: true,
	      type: true
	  };
	
	  var KNOWN_STATICS = {
	      name: true,
	      length: true,
	      prototype: true,
	      caller: true,
	      callee: true,
	      arguments: true,
	      arity: true
	  };
	
	  var FORWARD_REF_STATICS = {
	      '$$typeof': true,
	      render: true,
	      defaultProps: true,
	      displayName: true,
	      propTypes: true
	  };
	
	  var TYPE_STATICS = {};
	  TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	  var defineProperty = Object.defineProperty;
	  var getOwnPropertyNames = Object.getOwnPropertyNames;
	  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	  var getPrototypeOf = Object.getPrototypeOf;
	  var objectPrototype = Object.prototype;
	
	  function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	      if (typeof sourceComponent !== 'string') {
	          // don't hoist over string (html) components
	
	          if (objectPrototype) {
	              var inheritedComponent = getPrototypeOf(sourceComponent);
	              if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                  hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	              }
	          }
	
	          var keys = getOwnPropertyNames(sourceComponent);
	
	          if (getOwnPropertySymbols) {
	              keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	          }
	
	          var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
	          var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;
	
	          for (var i = 0; i < keys.length; ++i) {
	              var key = keys[i];
	              if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	                  var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                  try {
	                      // Avoid failures from read-only properties
	                      defineProperty(targetComponent, key, descriptor);
	                  } catch (e) {}
	              }
	          }
	
	          return targetComponent;
	      }
	
	      return targetComponent;
	  }
	
	  var hoistNonReactStatics_cjs = hoistNonReactStatics;
	
	  var EventEmitter =
	  /*#__PURE__*/
	  function () {
	    function EventEmitter() {
	      _classCallCheck(this, EventEmitter);
	
	      this.listeners = [];
	    }
	
	    _createClass(EventEmitter, [{
	      key: "on",
	      value: function on(cb) {
	        var _this = this;
	
	        this.listeners.push(cb);
	        return function () {
	          var index = _this.listeners.indexOf(cb);
	
	          if (index !== -1) _this.listeners.splice(index, 1);
	        };
	      }
	    }, {
	      key: "emit",
	      value: function emit(data) {
	        this.listeners.forEach(function (fn) {
	          return fn(data);
	        });
	      }
	    }]);
	
	    return EventEmitter;
	  }();
	
	  function createChainableTypeChecker(validate) {
	    function checkType(isRequired, props, propName, componentName, location, propFullName) {
	      for (var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
	        rest[_key - 6] = arguments[_key];
	      }
	
	      return mobx.untracked(function () {
	        componentName = componentName || "<<anonymous>>";
	        propFullName = propFullName || propName;
	
	        if (props[propName] == null) {
	          if (isRequired) {
	            var actual = props[propName] === null ? "null" : "undefined";
	            return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
	          }
	
	          return null;
	        } else {
	          return validate.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
	        }
	      });
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	    return chainedCheckType;
	  } // Copied from React.PropTypes
	
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === "symbol") {
	      return true;
	    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	
	
	    if (propValue["@@toStringTag"] === "Symbol") {
	      return true;
	    } // Fallback for non-spec compliant Symbols which are polyfilled.
	
	
	    if (typeof Symbol === "function" && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  } // Copied from React.PropTypes
	
	
	  function getPropType(propValue) {
	    var propType = _typeof(propValue);
	
	    if (Array.isArray(propValue)) {
	      return "array";
	    }
	
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return "object";
	    }
	
	    if (isSymbol(propType, propValue)) {
	      return "symbol";
	    }
	
	    return propType;
	  } // This handles more types than `getPropType`. Only used for error messages.
	  // Copied from React.PropTypes
	
	
	  function getPreciseType(propValue) {
	    var propType = getPropType(propValue);
	
	    if (propType === "object") {
	      if (propValue instanceof Date) {
	        return "date";
	      } else if (propValue instanceof RegExp) {
	        return "regexp";
	      }
	    }
	
	    return propType;
	  }
	
	  function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	      return mobx.untracked(function () {
	        if (allowNativeType) {
	          if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
	        }
	
	        var mobxChecker;
	
	        switch (mobxType) {
	          case "Array":
	            mobxChecker = mobx.isObservableArray;
	            break;
	
	          case "Object":
	            mobxChecker = mobx.isObservableObject;
	            break;
	
	          case "Map":
	            mobxChecker = mobx.isObservableMap;
	            break;
	
	          default:
	            throw new Error("Unexpected mobxType: ".concat(mobxType));
	        }
	
	        var propValue = props[propName];
	
	        if (!mobxChecker(propValue)) {
	          var preciseType = getPreciseType(propValue);
	          var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
	          return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
	        }
	
	        return null;
	      });
	    });
	  }
	
	  function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
	    return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
	      for (var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
	        rest[_key2 - 5] = arguments[_key2];
	      }
	
	      return mobx.untracked(function () {
	        if (typeof typeChecker !== "function") {
	          return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
	        }
	
	        var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
	        if (error instanceof Error) return error;
	        var propValue = props[propName];
	
	        for (var i = 0; i < propValue.length; i++) {
	          error = typeChecker.apply(void 0, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
	          if (error instanceof Error) return error;
	        }
	
	        return null;
	      });
	    });
	  }
	
	  var observableArray = createObservableTypeCheckerCreator(false, "Array");
	  var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
	  var observableMap = createObservableTypeCheckerCreator(false, "Map");
	  var observableObject = createObservableTypeCheckerCreator(false, "Object");
	  var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
	  var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
	  var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");
	
	  var propTypes = /*#__PURE__*/Object.freeze({
	    observableArray: observableArray,
	    observableArrayOf: observableArrayOf,
	    observableMap: observableMap,
	    observableObject: observableObject,
	    arrayOrObservableArray: arrayOrObservableArray,
	    arrayOrObservableArrayOf: arrayOrObservableArrayOf,
	    objectOrObservableObject: objectOrObservableObject
	  });
	
	  function isStateless(component) {
	    // `function() {}` has prototype, but `() => {}` doesn't
	    // `() => {}` via Babel has prototype too.
	    return !(component.prototype && component.prototype.render);
	  }
	  var symbolId = 0;
	
	  function createSymbol(name) {
	    if (typeof Symbol === "function") {
	      return Symbol(name);
	    }
	
	    var symbol = "__$mobx-react ".concat(name, " (").concat(symbolId, ")");
	    symbolId++;
	    return symbol;
	  }
	
	  var createdSymbols = {};
	  function newSymbol(name) {
	    if (!createdSymbols[name]) {
	      createdSymbols[name] = createSymbol(name);
	    }
	
	    return createdSymbols[name];
	  }
	  var mobxMixins = newSymbol("patchMixins");
	  var mobxPatchedDefinition = newSymbol("patchedDefinition");
	
	  function getMixins(target, methodName) {
	    var mixins = target[mobxMixins] = target[mobxMixins] || {};
	    var methodMixins = mixins[methodName] = mixins[methodName] || {};
	    methodMixins.locks = methodMixins.locks || 0;
	    methodMixins.methods = methodMixins.methods || [];
	    return methodMixins;
	  }
	
	  function wrapper(realMethod, mixins) {
	    var _this = this;
	
	    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
	    mixins.locks++;
	
	    try {
	      var retVal;
	
	      if (realMethod !== undefined && realMethod !== null) {
	        retVal = realMethod.apply(this, args);
	      }
	
	      return retVal;
	    } finally {
	      mixins.locks--;
	
	      if (mixins.locks === 0) {
	        mixins.methods.forEach(function (mx) {
	          mx.apply(_this, args);
	        });
	      }
	    }
	  }
	
	  function wrapFunction(realMethod, mixins) {
	    var fn = function fn() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      wrapper.call.apply(wrapper, [this, realMethod, mixins].concat(args));
	    };
	
	    return fn;
	  }
	
	  function patch(target, methodName) {
	    var mixins = getMixins(target, methodName);
	
	    for (var _len3 = arguments.length, mixinMethods = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
	      mixinMethods[_key3 - 2] = arguments[_key3];
	    }
	
	    for (var _i = 0; _i < mixinMethods.length; _i++) {
	      var mixinMethod = mixinMethods[_i];
	
	      if (mixins.methods.indexOf(mixinMethod) < 0) {
	        mixins.methods.push(mixinMethod);
	      }
	    }
	
	    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
	
	    if (oldDefinition && oldDefinition[mobxPatchedDefinition]) {
	      // already patched definition, do not repatch
	      return;
	    }
	
	    var originalMethod = target[methodName];
	    var newDefinition = createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
	    Object.defineProperty(target, methodName, newDefinition);
	  }
	
	  function createDefinition(target, methodName, enumerable, mixins, originalMethod) {
	    var _ref;
	
	    var wrappedFunc = wrapFunction(originalMethod, mixins);
	    return _ref = {}, _defineProperty(_ref, mobxPatchedDefinition, true), _defineProperty(_ref, "get", function get() {
	      return wrappedFunc;
	    }), _defineProperty(_ref, "set", function set(value) {
	      if (this === target) {
	        wrappedFunc = wrapFunction(value, mixins);
	      } else {
	        // when it is an instance of the prototype/a child prototype patch that particular case again separately
	        // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
	        // e.g. the method for super might not be the same as the method for the prototype which might be not the same
	        // as the method for the instance
	        var newDefinition = createDefinition(this, methodName, enumerable, mixins, value);
	        Object.defineProperty(this, methodName, newDefinition);
	      }
	    }), _defineProperty(_ref, "configurable", true), _defineProperty(_ref, "enumerable", enumerable), _ref;
	  }
	
	  var injectorContextTypes = {
	    mobxStores: objectOrObservableObject
	  };
	  Object.seal(injectorContextTypes);
	  var proxiedInjectorProps = {
	    contextTypes: {
	      get: function get() {
	        return injectorContextTypes;
	      },
	      set: function set(_) {
	        console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
	      },
	      configurable: true,
	      enumerable: false
	    },
	    isMobxInjector: {
	      value: true,
	      writable: true,
	      configurable: true,
	      enumerable: true
	    }
	    /**
	     * Store Injection
	     */
	
	  };
	
	  function createStoreInjector(grabStoresFn, component, injectNames) {
	    var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
	    if (injectNames) displayName += "-with-" + injectNames;
	
	    var Injector =
	    /*#__PURE__*/
	    function (_Component) {
	      _inherits(Injector, _Component);
	
	      function Injector() {
	        var _getPrototypeOf2;
	
	        var _this;
	
	        _classCallCheck(this, Injector);
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Injector)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	        _this.storeRef = function (instance) {
	          _this.wrappedInstance = instance;
	        };
	
	        return _this;
	      }
	
	      _createClass(Injector, [{
	        key: "render",
	        value: function render() {
	          // Optimization: it might be more efficient to apply the mapper function *outside* the render method
	          // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
	          // See this test: 'using a custom injector is not too reactive' in inject.js
	          var newProps = {};
	
	          for (var key in this.props) {
	            if (this.props.hasOwnProperty(key)) {
	              newProps[key] = this.props[key];
	            }
	          }
	
	          var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};
	
	          for (var _key2 in additionalProps) {
	            newProps[_key2] = additionalProps[_key2];
	          }
	
	          if (!isStateless(component)) {
	            newProps.ref = this.storeRef;
	          }
	
	          return React.createElement(component, newProps);
	        }
	      }]);
	
	      return Injector;
	    }(React.Component); // Static fields from component should be visible on the generated Injector
	
	
	    Injector.displayName = displayName;
	    hoistNonReactStatics_cjs(Injector, component);
	    Injector.wrappedComponent = component;
	    Object.defineProperties(Injector, proxiedInjectorProps);
	    return Injector;
	  }
	
	  function grabStoresByName(storeNames) {
	    return function (baseStores, nextProps) {
	      storeNames.forEach(function (storeName) {
	        if (storeName in nextProps // prefer props over stores
	        ) return;
	        if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
	        nextProps[storeName] = baseStores[storeName];
	      });
	      return nextProps;
	    };
	  }
	  /**
	   * higher order component that injects stores to a child.
	   * takes either a varargs list of strings, which are stores read from the context,
	   * or a function that manually maps the available stores from the context to props:
	   * storesToProps(mobxStores, props, context) => newProps
	   */
	
	
	  function inject()
	  /* fn(stores, nextProps) or ...storeNames */
	  {
	    var grabStoresFn;
	
	    if (typeof arguments[0] === "function") {
	      grabStoresFn = arguments[0];
	      return function (componentClass) {
	        var injected = createStoreInjector(grabStoresFn, componentClass);
	        injected.isMobxInjector = false; // supress warning
	        // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
	        // see #111
	
	        injected = observer(injected);
	        injected.isMobxInjector = true; // restore warning
	
	        return injected;
	      };
	    } else {
	      var storeNames = [];
	
	      for (var i = 0; i < arguments.length; i++) {
	        storeNames[i] = arguments[i];
	      }
	
	      grabStoresFn = grabStoresByName(storeNames);
	      return function (componentClass) {
	        return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
	      };
	    }
	  }
	
	  var mobxAdminProperty = mobx.$mobx || "$mobx";
	  var mobxIsUnmounted = newSymbol("isUnmounted");
	  /**
	   * dev tool support
	   */
	
	  var isDevtoolsEnabled = false;
	  var isUsingStaticRendering = false;
	  var warnedAboutObserverInjectDeprecation = false; // WeakMap<Node, Object>;
	
	  var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
	  var renderReporter = new EventEmitter();
	  var skipRenderKey = newSymbol("skipRender");
	  var isForcingUpdateKey = newSymbol("isForcingUpdate"); // Using react-is had some issues (and operates on elements, not on types), see #608 / #609
	
	  var ReactForwardRefSymbol = typeof React.forwardRef === "function" && React.forwardRef(function (_props, _ref) {})["$$typeof"];
	  /**
	   * Helper to set `prop` to `this` as non-enumerable (hidden prop)
	   * @param target
	   * @param prop
	   * @param value
	   */
	
	  function setHiddenProp(target, prop, value) {
	    if (!Object.hasOwnProperty.call(target, prop)) {
	      Object.defineProperty(target, prop, {
	        enumerable: false,
	        configurable: true,
	        writable: true,
	        value: value
	      });
	    } else {
	      target[prop] = value;
	    }
	  }
	
	  function findDOMNode$1(component) {
	    if (reactDom.findDOMNode) {
	      try {
	        return reactDom.findDOMNode(component);
	      } catch (e) {
	        // findDOMNode will throw in react-test-renderer, see:
	        // See https://github.com/mobxjs/mobx-react/issues/216
	        // Is there a better heuristic?
	        return null;
	      }
	    }
	
	    return null;
	  }
	
	  function reportRendering(component) {
	    var node = findDOMNode$1(component);
	    if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
	    renderReporter.emit({
	      event: "render",
	      renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
	      totalTime: Date.now() - component.__$mobRenderStart,
	      component: component,
	      node: node
	    });
	  }
	
	  function trackComponents() {
	    if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
	    if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
	  }
	  function useStaticRendering(useStaticRendering) {
	    isUsingStaticRendering = useStaticRendering;
	  }
	  /**
	   * Errors reporter
	   */
	
	  var errorsReporter = new EventEmitter();
	  /**
	   * Utilities
	   */
	
	  function patch$1(target, funcName) {
	    patch(target, funcName, reactiveMixin[funcName]);
	  }
	
	  function shallowEqual(objA, objB) {
	    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (is(objA, objB)) return true;
	
	    if (_typeof(objA) !== "object" || objA === null || _typeof(objB) !== "object" || objB === null) {
	      return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	    if (keysA.length !== keysB.length) return false;
	
	    for (var i = 0; i < keysA.length; i++) {
	      if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  function is(x, y) {
	    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
	    if (x === y) {
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      return x !== x && y !== y;
	    }
	  }
	
	  function makeComponentReactive(render) {
	    var _this2 = this;
	
	    if (isUsingStaticRendering === true) return render.call(this);
	
	    function reactiveRender() {
	      var _this = this;
	
	      isRenderingPending = false;
	      var exception = undefined;
	      var rendering = undefined;
	      reaction.track(function () {
	        if (isDevtoolsEnabled) {
	          _this.__$mobRenderStart = Date.now();
	        }
	
	        try {
	          rendering = mobx._allowStateChanges(false, baseRender);
	        } catch (e) {
	          exception = e;
	        }
	
	        if (isDevtoolsEnabled) {
	          _this.__$mobRenderEnd = Date.now();
	        }
	      });
	
	      if (exception) {
	        errorsReporter.emit(exception);
	        throw exception;
	      }
	
	      return rendering;
	    } // Generate friendly name for debugging
	
	
	    var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
	    var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
	    /**
	     * If props are shallowly modified, react will render anyway,
	     * so atom.reportChanged() should not result in yet another re-render
	     */
	
	    setHiddenProp(this, skipRenderKey, false);
	    /**
	     * forceUpdate will re-assign this.props. We don't want that to cause a loop,
	     * so detect these changes
	     */
	
	    setHiddenProp(this, isForcingUpdateKey, false); // wire up reactive render
	
	    var baseRender = render.bind(this);
	    var isRenderingPending = false;
	    var reaction = new mobx.Reaction("".concat(initialName, "#").concat(rootNodeID, ".render()"), function () {
	      if (!isRenderingPending) {
	        // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
	        // This unidiomatic React usage but React will correctly warn about this so we continue as usual
	        // See #85 / Pull #44
	        isRenderingPending = true;
	        if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?
	
	        if (_this2[mobxIsUnmounted] !== true) {
	          // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
	          // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
	          // However, people also claim this might happen during unit tests..
	          var hasError = true;
	
	          try {
	            setHiddenProp(_this2, isForcingUpdateKey, true);
	            if (!_this2[skipRenderKey]) React.Component.prototype.forceUpdate.call(_this2);
	            hasError = false;
	          } finally {
	            setHiddenProp(_this2, isForcingUpdateKey, false);
	            if (hasError) reaction.dispose();
	          }
	        }
	      }
	    });
	    reaction.reactComponent = this;
	    reactiveRender[mobxAdminProperty] = reaction;
	    this.render = reactiveRender;
	    return reactiveRender.call(this);
	  }
	  /**
	   * ReactiveMixin
	   */
	
	
	  var reactiveMixin = {
	    componentWillUnmount: function componentWillUnmount() {
	      if (isUsingStaticRendering === true) return;
	      this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
	      this[mobxIsUnmounted] = true;
	
	      if (isDevtoolsEnabled) {
	        var node = findDOMNode$1(this);
	
	        if (node && componentByNodeRegistry) {
	          componentByNodeRegistry.delete(node);
	        }
	
	        renderReporter.emit({
	          event: "destroy",
	          component: this,
	          node: node
	        });
	      }
	    },
	    componentDidMount: function componentDidMount() {
	      if (isDevtoolsEnabled) {
	        reportRendering(this);
	      }
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      if (isDevtoolsEnabled) {
	        reportRendering(this);
	      }
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	      if (isUsingStaticRendering) {
	        console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
	      } // update on any state changes (as is the default)
	
	
	      if (this.state !== nextState) {
	        return true;
	      } // update if props are shallowly not equal, inspired by PureRenderMixin
	      // we could return just 'false' here, and avoid the `skipRender` checks etc
	      // however, it is nicer if lifecycle events are triggered like usually,
	      // so we return true here if props are shallowly modified.
	
	
	      return !shallowEqual(this.props, nextProps);
	    }
	  };
	
	  function makeObservableProp(target, propName) {
	    var valueHolderKey = newSymbol("reactProp_".concat(propName, "_valueHolder"));
	    var atomHolderKey = newSymbol("reactProp_".concat(propName, "_atomHolder"));
	
	    function getAtom() {
	      if (!this[atomHolderKey]) {
	        setHiddenProp(this, atomHolderKey, mobx.createAtom("reactive " + propName));
	      }
	
	      return this[atomHolderKey];
	    }
	
	    Object.defineProperty(target, propName, {
	      configurable: true,
	      enumerable: true,
	      get: function get() {
	        getAtom.call(this).reportObserved();
	        return this[valueHolderKey];
	      },
	      set: function set(v) {
	        if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
	          setHiddenProp(this, valueHolderKey, v);
	          setHiddenProp(this, skipRenderKey, true);
	          getAtom.call(this).reportChanged();
	          setHiddenProp(this, skipRenderKey, false);
	        } else {
	          setHiddenProp(this, valueHolderKey, v);
	        }
	      }
	    });
	  }
	  /**
	   * Observer function / decorator
	   */
	
	
	  function observer(arg1, arg2) {
	    if (typeof arg1 === "string") {
	      throw new Error("Store names should be provided as array");
	    }
	
	    if (Array.isArray(arg1)) {
	      // TODO: remove in next major
	      // component needs stores
	      if (!warnedAboutObserverInjectDeprecation) {
	        warnedAboutObserverInjectDeprecation = true;
	        console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
	      }
	
	      if (!arg2) {
	        // invoked as decorator
	        return function (componentClass) {
	          return observer(arg1, componentClass);
	        };
	      } else {
	        return inject.apply(null, arg1)(observer(arg2));
	      }
	    }
	
	    var componentClass = arg1;
	
	    if (componentClass.isMobxInjector === true) {
	      console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
	    }
	
	    if (componentClass.__proto__ === React.PureComponent) {
	      console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
	    } // Unwrap forward refs into `<Observer>` component
	    // we need to unwrap the render, because it is the inner render that needs to be tracked,
	    // not the ForwardRef HoC
	
	
	    if (ReactForwardRefSymbol && componentClass["$$typeof"] === ReactForwardRefSymbol) {
	      var _baseRender = componentClass.render;
	      if (typeof _baseRender !== "function") throw new Error("render property of ForwardRef was not a function"); // TODO: do we need to hoist statics from baseRender to the forward ref?
	
	      return React.forwardRef(function ObserverForwardRef() {
	        var _arguments = arguments;
	        return React__default.createElement(Observer, null, function () {
	          return _baseRender.apply(undefined, _arguments);
	        });
	      });
	    } // Stateless function component:
	    // If it is function but doesn't seem to be a react class constructor,
	    // wrap it to a react class automatically
	
	
	    if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !React.Component.isPrototypeOf(componentClass)) {
	      var _class, _temp;
	
	      var observerComponent = observer((_temp = _class =
	      /*#__PURE__*/
	      function (_Component) {
	        _inherits(_class, _Component);
	
	        function _class() {
	          _classCallCheck(this, _class);
	
	          return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
	        }
	
	        _createClass(_class, [{
	          key: "render",
	          value: function render() {
	            return componentClass.call(this, this.props, this.context);
	          }
	        }]);
	
	        return _class;
	      }(React.Component), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
	      hoistNonReactStatics_cjs(observerComponent, componentClass);
	      return observerComponent;
	    }
	
	    if (!componentClass) {
	      throw new Error("Please pass a valid component to 'observer'");
	    }
	
	    var target = componentClass.prototype || componentClass;
	    mixinLifecycleEvents(target);
	    componentClass.isMobXReactObserver = true;
	    makeObservableProp(target, "props");
	    makeObservableProp(target, "state");
	    var baseRender = target.render;
	
	    target.render = function () {
	      return makeComponentReactive.call(this, baseRender);
	    };
	
	    return componentClass;
	  }
	
	  function mixinLifecycleEvents(target) {
	    ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
	      patch$1(target, funcName);
	    });
	
	    if (!target.shouldComponentUpdate) {
	      target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
	    } else {
	      if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
	        // TODO: make throw in next major
	        console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
	      }
	    }
	  }
	
	  var Observer = observer(function (_ref2) {
	    var children = _ref2.children,
	        observerInject = _ref2.inject,
	        render = _ref2.render;
	    var component = children || render;
	
	    if (typeof component === "undefined") {
	      return null;
	    }
	
	    if (!observerInject) {
	      return component();
	    } // TODO: remove in next major
	
	
	    console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
	    var InjectComponent = inject(observerInject)(component);
	    return React__default.createElement(InjectComponent, null);
	  });
	  Observer.displayName = "Observer";
	
	  var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
	    var extraKey = key === "children" ? "render" : "children";
	
	    if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
	      return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
	    }
	
	    if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
	      return;
	    }
	
	    return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
	  };
	
	  Observer.propTypes = {
	    render: ObserverPropsCheck,
	    children: ObserverPropsCheck
	  };
	
	  /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   */
	
	  function componentWillMount() {
	    // Call this.constructor.gDSFP to support sub-classes.
	    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	    if (state !== null && state !== undefined) {
	      this.setState(state);
	    }
	  }
	
	  function componentWillReceiveProps(nextProps) {
	    // Call this.constructor.gDSFP to support sub-classes.
	    // Use the setState() updater to ensure state isn't stale in certain edge cases.
	    function updater(prevState) {
	      var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	      return state !== null && state !== undefined ? state : null;
	    }
	    // Binding "this" is important for shallow renderer support.
	    this.setState(updater.bind(this));
	  }
	
	  function componentWillUpdate(nextProps, nextState) {
	    try {
	      var prevProps = this.props;
	      var prevState = this.state;
	      this.props = nextProps;
	      this.state = nextState;
	      this.__reactInternalSnapshotFlag = true;
	      this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	        prevProps,
	        prevState
	      );
	    } finally {
	      this.props = prevProps;
	      this.state = prevState;
	    }
	  }
	
	  // React may warn about cWM/cWRP/cWU methods being deprecated.
	  // Add a flag to suppress these warnings for this special case.
	  componentWillMount.__suppressDeprecationWarning = true;
	  componentWillReceiveProps.__suppressDeprecationWarning = true;
	  componentWillUpdate.__suppressDeprecationWarning = true;
	
	  function polyfill(Component) {
	    var prototype = Component.prototype;
	
	    if (!prototype || !prototype.isReactComponent) {
	      throw new Error('Can only polyfill class components');
	    }
	
	    if (
	      typeof Component.getDerivedStateFromProps !== 'function' &&
	      typeof prototype.getSnapshotBeforeUpdate !== 'function'
	    ) {
	      return Component;
	    }
	
	    // If new component APIs are defined, "unsafe" lifecycles won't be called.
	    // Error if any of these lifecycles are present,
	    // Because they would work differently between older and newer (16.3+) versions of React.
	    var foundWillMountName = null;
	    var foundWillReceivePropsName = null;
	    var foundWillUpdateName = null;
	    if (typeof prototype.componentWillMount === 'function') {
	      foundWillMountName = 'componentWillMount';
	    } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	      foundWillMountName = 'UNSAFE_componentWillMount';
	    }
	    if (typeof prototype.componentWillReceiveProps === 'function') {
	      foundWillReceivePropsName = 'componentWillReceiveProps';
	    } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	      foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	    }
	    if (typeof prototype.componentWillUpdate === 'function') {
	      foundWillUpdateName = 'componentWillUpdate';
	    } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	      foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	    }
	    if (
	      foundWillMountName !== null ||
	      foundWillReceivePropsName !== null ||
	      foundWillUpdateName !== null
	    ) {
	      var componentName = Component.displayName || Component.name;
	      var newApiName =
	        typeof Component.getDerivedStateFromProps === 'function'
	          ? 'getDerivedStateFromProps()'
	          : 'getSnapshotBeforeUpdate()';
	
	      throw Error(
	        'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	          componentName +
	          ' uses ' +
	          newApiName +
	          ' but also contains the following legacy lifecycles:' +
	          (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	          (foundWillReceivePropsName !== null
	            ? '\n  ' + foundWillReceivePropsName
	            : '') +
	          (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	          '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	          'https://fb.me/react-async-component-lifecycle-hooks'
	      );
	    }
	
	    // React <= 16.2 does not support static getDerivedStateFromProps.
	    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	    // Newer versions of React will ignore these lifecycles if gDSFP exists.
	    if (typeof Component.getDerivedStateFromProps === 'function') {
	      prototype.componentWillMount = componentWillMount;
	      prototype.componentWillReceiveProps = componentWillReceiveProps;
	    }
	
	    // React <= 16.2 does not support getSnapshotBeforeUpdate.
	    // As a workaround, use cWU to invoke the new lifecycle.
	    // Newer versions of React will ignore that lifecycle if gSBU exists.
	    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	      if (typeof prototype.componentDidUpdate !== 'function') {
	        throw new Error(
	          'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	        );
	      }
	
	      prototype.componentWillUpdate = componentWillUpdate;
	
	      var componentDidUpdate = prototype.componentDidUpdate;
	
	      prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	        prevProps,
	        prevState,
	        maybeSnapshot
	      ) {
	        // 16.3+ will not execute our will-update method;
	        // It will pass a snapshot value to did-update though.
	        // Older versions will require our polyfilled will-update value.
	        // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	        // Because for <= 15.x versions this might be a "prevContext" object.
	        // We also can't just check "__reactInternalSnapshot",
	        // Because get-snapshot might return a falsy value.
	        // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	        var snapshot = this.__reactInternalSnapshotFlag
	          ? this.__reactInternalSnapshot
	          : maybeSnapshot;
	
	        componentDidUpdate.call(this, prevProps, prevState, snapshot);
	      };
	    }
	
	    return Component;
	  }
	
	  var specialReactKeys = {
	    children: true,
	    key: true,
	    ref: true
	  };
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider(props, context) {
	      var _this;
	
	      _classCallCheck(this, Provider);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props, context));
	      _this.state = {};
	      copyStores(props, _this.state);
	      return _this;
	    }
	
	    _createClass(Provider, [{
	      key: "render",
	      value: function render() {
	        return React.Children.only(this.props.children);
	      }
	    }, {
	      key: "getChildContext",
	      value: function getChildContext() {
	        var stores = {}; // inherit stores
	
	        copyStores(this.context.mobxStores, stores); // add own stores
	
	        copyStores(this.props, stores);
	        return {
	          mobxStores: stores
	        };
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(nextProps, prevState) {
	        if (!nextProps) return null;
	        if (!prevState) return nextProps; // Maybe this warning is too aggressive?
	
	        if (Object.keys(nextProps).filter(validStoreName).length !== Object.keys(prevState).filter(validStoreName).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
	        if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
	          if (validStoreName(key) && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
	        }
	        return nextProps;
	      }
	    }]);
	
	    return Provider;
	  }(React.Component);
	
	  Provider.contextTypes = {
	    mobxStores: objectOrObservableObject
	  };
	  Provider.childContextTypes = {
	    mobxStores: objectOrObservableObject.isRequired
	  };
	
	  function copyStores(from, to) {
	    if (!from) return;
	
	    for (var key in from) {
	      if (validStoreName(key)) to[key] = from[key];
	    }
	  }
	
	  function validStoreName(key) {
	    return !specialReactKeys[key] && key !== "suppressChangedStoreWarning";
	  } // TODO: kill in next major
	
	
	  polyfill(Provider);
	
	  var storeKey = newSymbol("disposeOnUnmount");
	
	  function runDisposersOnWillUnmount() {
	    var _this = this;
	
	    if (!this[storeKey]) {
	      // when disposeOnUnmount is only set to some instances of a component it will still patch the prototype
	      return;
	    }
	
	    this[storeKey].forEach(function (propKeyOrFunction) {
	      var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
	
	      if (prop !== undefined && prop !== null) {
	        if (typeof prop !== "function") {
	          throw new Error("[mobx-react] disposeOnUnmount only works on functions such as disposers returned by reactions, autorun, etc.");
	        }
	
	        prop();
	      }
	    });
	    this[storeKey] = [];
	  }
	
	  function disposeOnUnmount(target, propertyKeyOrFunction) {
	    if (Array.isArray(propertyKeyOrFunction)) {
	      return propertyKeyOrFunction.map(function (fn) {
	        return disposeOnUnmount(target, fn);
	      });
	    }
	
	    if (!target instanceof React.Component) {
	      throw new Error("[mobx-react] disposeOnUnmount only works on class based React components.");
	    }
	
	    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function") {
	      throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
	    } // add property key / function we want run (disposed) to the store
	
	
	    var componentWasAlreadyModified = !!target[storeKey];
	    var store = target[storeKey] || (target[storeKey] = []);
	    store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already
	
	    if (!componentWasAlreadyModified) {
	      patch(target, "componentWillUnmount", runDisposersOnWillUnmount);
	    } // return the disposer as is if invoked as a non decorator
	
	
	    if (typeof propertyKeyOrFunction !== "string") {
	      return propertyKeyOrFunction;
	    }
	  }
	
	  if (!React.Component) throw new Error("mobx-react requires React to be available");
	  if (!mobx.spy) throw new Error("mobx-react requires mobx to be available");
	  if (typeof reactDom.unstable_batchedUpdates === "function") mobx.configure({
	    reactionScheduler: reactDom.unstable_batchedUpdates
	  });
	  var onError = function onError(fn) {
	    return errorsReporter.on(fn);
	  };
	
	  if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
	    var mobx$1 = {
	      spy: mobx.spy,
	      extras: {
	        getDebugName: mobx.getDebugName
	      }
	    };
	    var mobxReact = {
	      renderReporter: renderReporter,
	      componentByNodeRegistry: componentByNodeRegistry,
	      componentByNodeRegistery: componentByNodeRegistry,
	      trackComponents: trackComponents
	    };
	
	    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx$1);
	  }
	
	  exports.propTypes = propTypes;
	  exports.PropTypes = propTypes;
	  exports.onError = onError;
	  exports.observer = observer;
	  exports.Observer = Observer;
	  exports.renderReporter = renderReporter;
	  exports.componentByNodeRegistery = componentByNodeRegistry;
	  exports.componentByNodeRegistry = componentByNodeRegistry;
	  exports.trackComponents = trackComponents;
	  exports.useStaticRendering = useStaticRendering;
	  exports.Provider = Provider;
	  exports.inject = inject;
	  exports.disposeOnUnmount = disposeOnUnmount;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	if (typeof process !== 'undefined' && ("production") === 'production') {
	    module.exports = __webpack_require__(54);
	} else {
	    module.exports = __webpack_require__(54);
	}
	        
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16)))

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var extendStatics=function(e,t){return(extendStatics=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};function __extends(e,t){function r(){this.constructor=e}extendStatics(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}var __assign=function(){return(__assign=Object.assign||function(e){for(var t,r=1,n=arguments.length;r<n;r++)for(var o in t=arguments[r])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e}).apply(this,arguments)};function __values(e){var t="function"==typeof Symbol&&e[Symbol.iterator],r=0;return t?t.call(e):{next:function(){return e&&r>=e.length&&(e=void 0),{value:e&&e[r++],done:!e}}}}function __read(e,t){var r="function"==typeof Symbol&&e[Symbol.iterator];if(!r)return e;var n,o,a=r.call(e),i=[];try{for(;(void 0===t||t-- >0)&&!(n=a.next()).done;)i.push(n.value)}catch(e){o={error:e}}finally{try{n&&!n.done&&(r=a.return)&&r.call(a)}finally{if(o)throw o.error}}return i}function __spread(){for(var e=[],t=0;t<arguments.length;t++)e=e.concat(__read(arguments[t]));return e}var OBFUSCATED_ERROR="An invariant failed, however the error is obfuscated because this is a production build.",EMPTY_ARRAY=[];Object.freeze(EMPTY_ARRAY);var EMPTY_OBJECT={};function getNextId(){return++globalState.mobxGuid}function fail(e){throw invariant(!1,e),"X"}function invariant(e,t){if(!e)throw new Error("[mobx] "+(t||OBFUSCATED_ERROR))}Object.freeze(EMPTY_OBJECT);var deprecatedMessages=[];function deprecated(e,t){return!1}function once(e){var t=!1;return function(){if(!t)return t=!0,e.apply(this,arguments)}}var noop=function(){};function unique(e){var t=[];return e.forEach(function(e){-1===t.indexOf(e)&&t.push(e)}),t}function isObject(e){return null!==e&&"object"==typeof e}function isPlainObject(e){if(null===e||"object"!=typeof e)return!1;var t=Object.getPrototypeOf(e);return t===Object.prototype||null===t}function addHiddenProp(e,t,r){Object.defineProperty(e,t,{enumerable:!1,writable:!0,configurable:!0,value:r})}function addHiddenFinalProp(e,t,r){Object.defineProperty(e,t,{enumerable:!1,writable:!1,configurable:!0,value:r})}function isPropertyConfigurable(e,t){var r=Object.getOwnPropertyDescriptor(e,t);return!r||!1!==r.configurable&&!1!==r.writable}function createInstanceofPredicate(e,t){var r="isMobX"+e;return t.prototype[r]=!0,function(e){return isObject(e)&&!0===e[r]}}function isArrayLike(e){return Array.isArray(e)||isObservableArray(e)}function isES6Map(e){return e instanceof Map}function isES6Set(e){return e instanceof Set}function getPlainObjectKeys(e){var t=new Set;for(var r in e)t.add(r);return Object.getOwnPropertySymbols(e).forEach(function(r){Object.getOwnPropertyDescriptor(e,r).enumerable&&t.add(r)}),Array.from(t)}function stringifyKey(e){return e&&e.toString?e.toString():new String(e).toString()}function getMapLikeKeys(e){return isPlainObject(e)?Object.keys(e):Array.isArray(e)?e.map(function(e){return __read(e,1)[0]}):isES6Map(e)||isObservableMap(e)?Array.from(e.keys()):fail("Cannot get keys from '"+e+"'")}function toPrimitive(e){return null===e?null:"object"==typeof e?""+e:e}var $mobx=Symbol("mobx administration"),Atom=function(){function e(e){void 0===e&&(e="Atom@"+getNextId()),this.name=e,this.isPendingUnobservation=!1,this.isBeingObserved=!1,this.observers=new Set,this.diffValue=0,this.lastAccessedBy=0,this.lowestObserverState=exports.IDerivationState.NOT_TRACKING}return e.prototype.onBecomeObserved=function(){this.onBecomeObservedListeners&&this.onBecomeObservedListeners.forEach(function(e){return e()})},e.prototype.onBecomeUnobserved=function(){this.onBecomeUnobservedListeners&&this.onBecomeUnobservedListeners.forEach(function(e){return e()})},e.prototype.reportObserved=function(){return reportObserved(this)},e.prototype.reportChanged=function(){startBatch(),propagateChanged(this),endBatch()},e.prototype.toString=function(){return this.name},e}(),isAtom=createInstanceofPredicate("Atom",Atom);function createAtom(e,t,r){void 0===t&&(t=noop),void 0===r&&(r=noop);var n=new Atom(e);return t!==noop&&onBecomeObserved(n,t),r!==noop&&onBecomeUnobserved(n,r),n}function identityComparer(e,t){return e===t}function structuralComparer(e,t){return deepEqual(e,t)}function shallowComparer(e,t){return deepEqual(e,t,1)}function defaultComparer(e,t){return Object.is(e,t)}var comparer={identity:identityComparer,structural:structuralComparer,default:defaultComparer,shallow:shallowComparer},mobxDidRunLazyInitializersSymbol=Symbol("mobx did run lazy initializers"),mobxPendingDecorators=Symbol("mobx pending decorators"),enumerableDescriptorCache={},nonEnumerableDescriptorCache={};function createPropertyInitializerDescriptor(e,t){var r=t?enumerableDescriptorCache:nonEnumerableDescriptorCache;return r[e]||(r[e]={configurable:!0,enumerable:t,get:function(){return initializeInstance(this),this[e]},set:function(t){initializeInstance(this),this[e]=t}})}function initializeInstance(e){var t,r;if(!0!==e[mobxDidRunLazyInitializersSymbol]){var n=e[mobxPendingDecorators];if(n){addHiddenProp(e,mobxDidRunLazyInitializersSymbol,!0);var o=__spread(Object.getOwnPropertySymbols(n),Object.keys(n));try{for(var a=__values(o),i=a.next();!i.done;i=a.next()){var s=n[i.value];s.propertyCreator(e,s.prop,s.descriptor,s.decoratorTarget,s.decoratorArguments)}}catch(e){t={error:e}}finally{try{i&&!i.done&&(r=a.return)&&r.call(a)}finally{if(t)throw t.error}}}}}function createPropDecorator(e,t){return function(){var r,n=function(n,o,a,i){if(!0===i)return t(n,o,a,n,r),null;if(!Object.prototype.hasOwnProperty.call(n,mobxPendingDecorators)){var s=n[mobxPendingDecorators];addHiddenProp(n,mobxPendingDecorators,__assign({},s))}return n[mobxPendingDecorators][o]={prop:o,propertyCreator:t,descriptor:a,decoratorTarget:n,decoratorArguments:r},createPropertyInitializerDescriptor(o,e)};return quacksLikeADecorator(arguments)?(r=EMPTY_ARRAY,n.apply(null,arguments)):(r=Array.prototype.slice.call(arguments),n)}}function quacksLikeADecorator(e){return(2===e.length||3===e.length)&&("string"==typeof e[1]||"symbol"==typeof e[1])||4===e.length&&!0===e[3]}function deepEnhancer(e,t,r){return isObservable(e)?e:Array.isArray(e)?observable.array(e,{name:r}):isPlainObject(e)?observable.object(e,void 0,{name:r}):isES6Map(e)?observable.map(e,{name:r}):isES6Set(e)?observable.set(e,{name:r}):e}function shallowEnhancer(e,t,r){return null==e?e:isObservableObject(e)||isObservableArray(e)||isObservableMap(e)||isObservableSet(e)?e:Array.isArray(e)?observable.array(e,{name:r,deep:!1}):isPlainObject(e)?observable.object(e,void 0,{name:r,deep:!1}):isES6Map(e)?observable.map(e,{name:r,deep:!1}):isES6Set(e)?observable.set(e,{name:r,deep:!1}):fail(!1)}function referenceEnhancer(e){return e}function refStructEnhancer(e,t,r){return deepEqual(e,t)?t:e}function createDecoratorForEnhancer(e){invariant(e);var t=createPropDecorator(!0,function(t,r,n,o,a){var i=n?n.initializer?n.initializer.call(t):n.value:void 0;asObservableObject(t).addObservableProp(r,i,e)}),r=("undefined"!=typeof process&&({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"}),t);return r.enhancer=e,r}var defaultCreateObservableOptions={deep:!0,name:void 0,defaultDecorator:void 0,proxy:!0};function asCreateObservableOptions(e){return null==e?defaultCreateObservableOptions:"string"==typeof e?{name:e,deep:!0,proxy:!0}:e}Object.freeze(defaultCreateObservableOptions);var deepDecorator=createDecoratorForEnhancer(deepEnhancer),shallowDecorator=createDecoratorForEnhancer(shallowEnhancer),refDecorator=createDecoratorForEnhancer(referenceEnhancer),refStructDecorator=createDecoratorForEnhancer(refStructEnhancer);function getEnhancerFromOptions(e){return e.defaultDecorator?e.defaultDecorator.enhancer:!1===e.deep?referenceEnhancer:deepEnhancer}function createObservable(e,t,r){if("string"==typeof arguments[1]||"symbol"==typeof arguments[1])return deepDecorator.apply(null,arguments);if(isObservable(e))return e;var n=isPlainObject(e)?observable.object(e,t,r):Array.isArray(e)?observable.array(e,t):isES6Map(e)?observable.map(e,t):isES6Set(e)?observable.set(e,t):e;if(n!==e)return n;fail(!1)}var observableFactories={box:function(e,t){arguments.length>2&&incorrectlyUsedAsDecorator("box");var r=asCreateObservableOptions(t);return new ObservableValue(e,getEnhancerFromOptions(r),r.name,!0,r.equals)},array:function(e,t){arguments.length>2&&incorrectlyUsedAsDecorator("array");var r=asCreateObservableOptions(t);return createObservableArray(e,getEnhancerFromOptions(r),r.name)},map:function(e,t){arguments.length>2&&incorrectlyUsedAsDecorator("map");var r=asCreateObservableOptions(t);return new ObservableMap(e,getEnhancerFromOptions(r),r.name)},set:function(e,t){arguments.length>2&&incorrectlyUsedAsDecorator("set");var r=asCreateObservableOptions(t);return new ObservableSet(e,getEnhancerFromOptions(r),r.name)},object:function(e,t,r){"string"==typeof arguments[1]&&incorrectlyUsedAsDecorator("object");var n=asCreateObservableOptions(r);if(!1===n.proxy)return extendObservable({},e,t,n);var o=getDefaultDecoratorFromObjectOptions(n),a=createDynamicObservableObject(extendObservable({},void 0,void 0,n));return extendObservableObjectWithProperties(a,e,t,o),a},ref:refDecorator,shallow:shallowDecorator,deep:deepDecorator,struct:refStructDecorator},observable=createObservable;function incorrectlyUsedAsDecorator(e){fail("Expected one or two arguments to observable."+e+". Did you accidentally try to use observable."+e+" as decorator?")}Object.keys(observableFactories).forEach(function(e){return observable[e]=observableFactories[e]});var TraceMode,computedDecorator=createPropDecorator(!1,function(e,t,r,n,o){var a=r.get,i=r.set,s=o[0]||{};asObservableObject(e).addComputedProp(e,t,__assign({get:a,set:i,context:e},s))}),computedStructDecorator=computedDecorator({equals:comparer.structural}),computed=function(e,t,r){if("string"==typeof t)return computedDecorator.apply(null,arguments);if(null!==e&&"object"==typeof e&&1===arguments.length)return computedDecorator.apply(null,arguments);var n="object"==typeof t?t:{};return n.get=e,n.set="function"==typeof t?t:n.set,n.name=n.name||e.name||"",new ComputedValue(n)};computed.struct=computedStructDecorator,function(e){e[e.NOT_TRACKING=-1]="NOT_TRACKING",e[e.UP_TO_DATE=0]="UP_TO_DATE",e[e.POSSIBLY_STALE=1]="POSSIBLY_STALE",e[e.STALE=2]="STALE"}(exports.IDerivationState||(exports.IDerivationState={})),function(e){e[e.NONE=0]="NONE",e[e.LOG=1]="LOG",e[e.BREAK=2]="BREAK"}(TraceMode||(TraceMode={}));var CaughtException=function(){return function(e){this.cause=e}}();function isCaughtException(e){return e instanceof CaughtException}function shouldCompute(e){switch(e.dependenciesState){case exports.IDerivationState.UP_TO_DATE:return!1;case exports.IDerivationState.NOT_TRACKING:case exports.IDerivationState.STALE:return!0;case exports.IDerivationState.POSSIBLY_STALE:for(var t=allowStateReadsStart(!0),r=untrackedStart(),n=e.observing,o=n.length,a=0;a<o;a++){var i=n[a];if(isComputedValue(i)){if(globalState.disableErrorBoundaries)i.get();else try{i.get()}catch(e){return untrackedEnd(r),allowStateReadsEnd(t),!0}if(e.dependenciesState===exports.IDerivationState.STALE)return untrackedEnd(r),allowStateReadsEnd(t),!0}}return changeDependenciesStateTo0(e),untrackedEnd(r),allowStateReadsEnd(t),!1}}function isComputingDerivation(){return null!==globalState.trackingDerivation}function checkIfStateModificationsAreAllowed(e){var t=e.observers.size>0;globalState.computationDepth>0&&t&&fail(!1),globalState.allowStateChanges||!t&&"strict"!==globalState.enforceActions||fail(!1)}function trackDerivedFunction(e,t,r){var n=allowStateReadsStart(!0);changeDependenciesStateTo0(e),e.newObserving=new Array(e.observing.length+100),e.unboundDepsCount=0,e.runId=++globalState.runId;var o,a=globalState.trackingDerivation;if(globalState.trackingDerivation=e,!0===globalState.disableErrorBoundaries)o=t.call(r);else try{o=t.call(r)}catch(e){o=new CaughtException(e)}return globalState.trackingDerivation=a,bindDependencies(e),warnAboutDerivationWithoutDependencies(e),allowStateReadsEnd(n),o}function warnAboutDerivationWithoutDependencies(e){}function bindDependencies(e){for(var t=e.observing,r=e.observing=e.newObserving,n=exports.IDerivationState.UP_TO_DATE,o=0,a=e.unboundDepsCount,i=0;i<a;i++){0===(s=r[i]).diffValue&&(s.diffValue=1,o!==i&&(r[o]=s),o++),s.dependenciesState>n&&(n=s.dependenciesState)}for(r.length=o,e.newObserving=null,a=t.length;a--;){0===(s=t[a]).diffValue&&removeObserver(s,e),s.diffValue=0}for(;o--;){var s;1===(s=r[o]).diffValue&&(s.diffValue=0,addObserver(s,e))}n!==exports.IDerivationState.UP_TO_DATE&&(e.dependenciesState=n,e.onBecomeStale())}function clearObserving(e){var t=e.observing;e.observing=[];for(var r=t.length;r--;)removeObserver(t[r],e);e.dependenciesState=exports.IDerivationState.NOT_TRACKING}function untracked(e){var t=untrackedStart();try{return e()}finally{untrackedEnd(t)}}function untrackedStart(){var e=globalState.trackingDerivation;return globalState.trackingDerivation=null,e}function untrackedEnd(e){globalState.trackingDerivation=e}function allowStateReadsStart(e){var t=globalState.allowStateReads;return globalState.allowStateReads=e,t}function allowStateReadsEnd(e){globalState.allowStateReads=e}function changeDependenciesStateTo0(e){if(e.dependenciesState!==exports.IDerivationState.UP_TO_DATE){e.dependenciesState=exports.IDerivationState.UP_TO_DATE;for(var t=e.observing,r=t.length;r--;)t[r].lowestObserverState=exports.IDerivationState.UP_TO_DATE}}var currentActionId=0,nextActionId=1,functionNameDescriptor=Object.getOwnPropertyDescriptor(function(){},"name"),isFunctionNameConfigurable=functionNameDescriptor&&functionNameDescriptor.configurable;function createAction(e,t,r){var n=function(){return executeAction(e,t,r||this,arguments)};return n.isMobxAction=!0,n}function executeAction(e,t,r,n){var o=_startAction(e,r,n);try{return t.apply(r,n)}catch(e){throw o.error=e,e}finally{_endAction(o)}}function _startAction(e,t,r){var n=isSpyEnabled(),o=untrackedStart();startBatch();var a={prevDerivation:o,prevAllowStateChanges:allowStateChangesStart(!0),prevAllowStateReads:allowStateReadsStart(!0),notifySpy:n,startTime:0,actionId:nextActionId++,parentActionId:currentActionId};return currentActionId=a.actionId,a}function _endAction(e){currentActionId!==e.actionId&&fail("invalid action stack. did you forget to finish an action?"),currentActionId=e.parentActionId,void 0!==e.error&&(globalState.suppressReactionErrors=!0),allowStateChangesEnd(e.prevAllowStateChanges),allowStateReadsEnd(e.prevAllowStateReads),endBatch(),untrackedEnd(e.prevDerivation),e.notifySpy,globalState.suppressReactionErrors=!1}function allowStateChanges(e,t){var r,n=allowStateChangesStart(e);try{r=t()}finally{allowStateChangesEnd(n)}return r}function allowStateChangesStart(e){var t=globalState.allowStateChanges;return globalState.allowStateChanges=e,t}function allowStateChangesEnd(e){globalState.allowStateChanges=e}function allowStateChangesInsideComputed(e){var t,r=globalState.computationDepth;globalState.computationDepth=0;try{t=e()}finally{globalState.computationDepth=r}return t}var ObservableValue=function(e){function t(t,r,n,o,a){void 0===n&&(n="ObservableValue@"+getNextId()),void 0===o&&(o=!0),void 0===a&&(a=comparer.default);var i=e.call(this,n)||this;return i.enhancer=r,i.name=n,i.equals=a,i.hasUnreportedChange=!1,i.value=r(t,void 0,n),o&&isSpyEnabled(),i}return __extends(t,e),t.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},t.prototype.set=function(e){this.value;if((e=this.prepareNewValue(e))!==globalState.UNCHANGED){isSpyEnabled();0,this.setNewValue(e)}},t.prototype.prepareNewValue=function(e){if(checkIfStateModificationsAreAllowed(this),hasInterceptors(this)){var t=interceptChange(this,{object:this,type:"update",newValue:e});if(!t)return globalState.UNCHANGED;e=t.newValue}return e=this.enhancer(e,this.value,this.name),this.equals(this.value,e)?globalState.UNCHANGED:e},t.prototype.setNewValue=function(e){var t=this.value;this.value=e,this.reportChanged(),hasListeners(this)&&notifyListeners(this,{type:"update",object:this,newValue:e,oldValue:t})},t.prototype.get=function(){return this.reportObserved(),this.dehanceValue(this.value)},t.prototype.intercept=function(e){return registerInterceptor(this,e)},t.prototype.observe=function(e,t){return t&&e({object:this,type:"update",newValue:this.value,oldValue:void 0}),registerListener(this,e)},t.prototype.toJSON=function(){return this.get()},t.prototype.toString=function(){return this.name+"["+this.value+"]"},t.prototype.valueOf=function(){return toPrimitive(this.get())},t.prototype[Symbol.toPrimitive]=function(){return this.valueOf()},t}(Atom),isObservableValue=createInstanceofPredicate("ObservableValue",ObservableValue),ComputedValue=function(){function e(e){this.dependenciesState=exports.IDerivationState.NOT_TRACKING,this.observing=[],this.newObserving=null,this.isBeingObserved=!1,this.isPendingUnobservation=!1,this.observers=new Set,this.diffValue=0,this.runId=0,this.lastAccessedBy=0,this.lowestObserverState=exports.IDerivationState.UP_TO_DATE,this.unboundDepsCount=0,this.__mapid="#"+getNextId(),this.value=new CaughtException(null),this.isComputing=!1,this.isRunningSetter=!1,this.isTracing=TraceMode.NONE,invariant(e.get,"missing option for computed: get"),this.derivation=e.get,this.name=e.name||"ComputedValue@"+getNextId(),e.set&&(this.setter=createAction(this.name+"-setter",e.set)),this.equals=e.equals||(e.compareStructural||e.struct?comparer.structural:comparer.default),this.scope=e.context,this.requiresReaction=!!e.requiresReaction,this.keepAlive=!!e.keepAlive}return e.prototype.onBecomeStale=function(){propagateMaybeChanged(this)},e.prototype.onBecomeObserved=function(){this.onBecomeObservedListeners&&this.onBecomeObservedListeners.forEach(function(e){return e()})},e.prototype.onBecomeUnobserved=function(){this.onBecomeUnobservedListeners&&this.onBecomeUnobservedListeners.forEach(function(e){return e()})},e.prototype.get=function(){this.isComputing&&fail("Cycle detected in computation "+this.name+": "+this.derivation),0!==globalState.inBatch||0!==this.observers.size||this.keepAlive?(reportObserved(this),shouldCompute(this)&&this.trackAndCompute()&&propagateChangeConfirmed(this)):shouldCompute(this)&&(this.warnAboutUntrackedRead(),startBatch(),this.value=this.computeValue(!1),endBatch());var e=this.value;if(isCaughtException(e))throw e.cause;return e},e.prototype.peek=function(){var e=this.computeValue(!1);if(isCaughtException(e))throw e.cause;return e},e.prototype.set=function(e){if(this.setter){invariant(!this.isRunningSetter,"The setter of computed value '"+this.name+"' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?"),this.isRunningSetter=!0;try{this.setter.call(this.scope,e)}finally{this.isRunningSetter=!1}}else invariant(!1,!1)},e.prototype.trackAndCompute=function(){var e=this.value,t=this.dependenciesState===exports.IDerivationState.NOT_TRACKING,r=this.computeValue(!0),n=t||isCaughtException(e)||isCaughtException(r)||!this.equals(e,r);return n&&(this.value=r),n},e.prototype.computeValue=function(e){var t;if(this.isComputing=!0,globalState.computationDepth++,e)t=trackDerivedFunction(this,this.derivation,this.scope);else if(!0===globalState.disableErrorBoundaries)t=this.derivation.call(this.scope);else try{t=this.derivation.call(this.scope)}catch(e){t=new CaughtException(e)}return globalState.computationDepth--,this.isComputing=!1,t},e.prototype.suspend=function(){this.keepAlive||(clearObserving(this),this.value=void 0)},e.prototype.observe=function(e,t){var r=this,n=!0,o=void 0;return autorun(function(){var a=r.get();if(!n||t){var i=untrackedStart();e({type:"update",object:r,newValue:a,oldValue:o}),untrackedEnd(i)}n=!1,o=a})},e.prototype.warnAboutUntrackedRead=function(){},e.prototype.toJSON=function(){return this.get()},e.prototype.toString=function(){return this.name+"["+this.derivation.toString()+"]"},e.prototype.valueOf=function(){return toPrimitive(this.get())},e.prototype[Symbol.toPrimitive]=function(){return this.valueOf()},e}(),isComputedValue=createInstanceofPredicate("ComputedValue",ComputedValue),persistentKeys=["mobxGuid","spyListeners","enforceActions","computedRequiresReaction","reactionRequiresObservable","observableRequiresReaction","allowStateReads","disableErrorBoundaries","runId","UNCHANGED"],MobXGlobals=function(){return function(){this.version=5,this.UNCHANGED={},this.trackingDerivation=null,this.computationDepth=0,this.runId=0,this.mobxGuid=0,this.inBatch=0,this.pendingUnobservations=[],this.pendingReactions=[],this.isRunningReactions=!1,this.allowStateChanges=!0,this.allowStateReads=!0,this.enforceActions=!1,this.spyListeners=[],this.globalReactionErrorHandlers=[],this.computedRequiresReaction=!1,this.reactionRequiresObservable=!1,this.observableRequiresReaction=!1,this.computedConfigurable=!1,this.disableErrorBoundaries=!1,this.suppressReactionErrors=!1}}(),mockGlobal={};function getGlobal(){return"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:mockGlobal}var canMergeGlobalState=!0,isolateCalled=!1,globalState=function(){var e=getGlobal();return e.__mobxInstanceCount>0&&!e.__mobxGlobals&&(canMergeGlobalState=!1),e.__mobxGlobals&&e.__mobxGlobals.version!==(new MobXGlobals).version&&(canMergeGlobalState=!1),canMergeGlobalState?e.__mobxGlobals?(e.__mobxInstanceCount+=1,e.__mobxGlobals.UNCHANGED||(e.__mobxGlobals.UNCHANGED={}),e.__mobxGlobals):(e.__mobxInstanceCount=1,e.__mobxGlobals=new MobXGlobals):(setTimeout(function(){isolateCalled||fail("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`")},1),new MobXGlobals)}();function isolateGlobalState(){(globalState.pendingReactions.length||globalState.inBatch||globalState.isRunningReactions)&&fail("isolateGlobalState should be called before MobX is running any reactions"),isolateCalled=!0,canMergeGlobalState&&(0==--getGlobal().__mobxInstanceCount&&(getGlobal().__mobxGlobals=void 0),globalState=new MobXGlobals)}function getGlobalState(){return globalState}function resetGlobalState(){var e=new MobXGlobals;for(var t in e)-1===persistentKeys.indexOf(t)&&(globalState[t]=e[t]);globalState.allowStateChanges=!globalState.enforceActions}function hasObservers(e){return e.observers&&e.observers.size>0}function getObservers(e){return e.observers}function addObserver(e,t){e.observers.add(t),e.lowestObserverState>t.dependenciesState&&(e.lowestObserverState=t.dependenciesState)}function removeObserver(e,t){e.observers.delete(t),0===e.observers.size&&queueForUnobservation(e)}function queueForUnobservation(e){!1===e.isPendingUnobservation&&(e.isPendingUnobservation=!0,globalState.pendingUnobservations.push(e))}function startBatch(){globalState.inBatch++}function endBatch(){if(0==--globalState.inBatch){runReactions();for(var e=globalState.pendingUnobservations,t=0;t<e.length;t++){var r=e[t];r.isPendingUnobservation=!1,0===r.observers.size&&(r.isBeingObserved&&(r.isBeingObserved=!1,r.onBecomeUnobserved()),r instanceof ComputedValue&&r.suspend())}globalState.pendingUnobservations=[]}}function reportObserved(e){var t=globalState.trackingDerivation;return null!==t?(t.runId!==e.lastAccessedBy&&(e.lastAccessedBy=t.runId,t.newObserving[t.unboundDepsCount++]=e,e.isBeingObserved||(e.isBeingObserved=!0,e.onBecomeObserved())),!0):(0===e.observers.size&&globalState.inBatch>0&&queueForUnobservation(e),!1)}function propagateChanged(e){e.lowestObserverState!==exports.IDerivationState.STALE&&(e.lowestObserverState=exports.IDerivationState.STALE,e.observers.forEach(function(t){t.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(t.isTracing!==TraceMode.NONE&&logTraceInfo(t,e),t.onBecomeStale()),t.dependenciesState=exports.IDerivationState.STALE}))}function propagateChangeConfirmed(e){e.lowestObserverState!==exports.IDerivationState.STALE&&(e.lowestObserverState=exports.IDerivationState.STALE,e.observers.forEach(function(t){t.dependenciesState===exports.IDerivationState.POSSIBLY_STALE?t.dependenciesState=exports.IDerivationState.STALE:t.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(e.lowestObserverState=exports.IDerivationState.UP_TO_DATE)}))}function propagateMaybeChanged(e){e.lowestObserverState===exports.IDerivationState.UP_TO_DATE&&(e.lowestObserverState=exports.IDerivationState.POSSIBLY_STALE,e.observers.forEach(function(t){t.dependenciesState===exports.IDerivationState.UP_TO_DATE&&(t.dependenciesState=exports.IDerivationState.POSSIBLY_STALE,t.isTracing!==TraceMode.NONE&&logTraceInfo(t,e),t.onBecomeStale())}))}function logTraceInfo(e,t){if(console.log("[mobx.trace] '"+e.name+"' is invalidated due to a change in: '"+t.name+"'"),e.isTracing===TraceMode.BREAK){var r=[];printDepTree(getDependencyTree(e),r,1),new Function("debugger;\n/*\nTracing '"+e.name+"'\n\nYou are entering this break point because derivation '"+e.name+"' is being traced and '"+t.name+"' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n"+(e instanceof ComputedValue?e.derivation.toString().replace(/[*]\//g,"/"):"")+"\n\nThe dependencies for this derivation are:\n\n"+r.join("\n")+"\n*/\n    ")()}}function printDepTree(e,t,r){t.length>=1e3?t.push("(and many more)"):(t.push(""+new Array(r).join("\t")+e.name),e.dependencies&&e.dependencies.forEach(function(e){return printDepTree(e,t,r+1)}))}var Reaction=function(){function e(e,t,r,n){void 0===e&&(e="Reaction@"+getNextId()),void 0===n&&(n=!1),this.name=e,this.onInvalidate=t,this.errorHandler=r,this.requiresObservable=n,this.observing=[],this.newObserving=[],this.dependenciesState=exports.IDerivationState.NOT_TRACKING,this.diffValue=0,this.runId=0,this.unboundDepsCount=0,this.__mapid="#"+getNextId(),this.isDisposed=!1,this._isScheduled=!1,this._isTrackPending=!1,this._isRunning=!1,this.isTracing=TraceMode.NONE}return e.prototype.onBecomeStale=function(){this.schedule()},e.prototype.schedule=function(){this._isScheduled||(this._isScheduled=!0,globalState.pendingReactions.push(this),runReactions())},e.prototype.isScheduled=function(){return this._isScheduled},e.prototype.runReaction=function(){if(!this.isDisposed){if(startBatch(),this._isScheduled=!1,shouldCompute(this)){this._isTrackPending=!0;try{this.onInvalidate(),this._isTrackPending&&isSpyEnabled()}catch(e){this.reportExceptionInDerivation(e)}}endBatch()}},e.prototype.track=function(e){if(!this.isDisposed){startBatch(),this._isRunning=!0;var t=trackDerivedFunction(this,e,void 0);this._isRunning=!1,this._isTrackPending=!1,this.isDisposed&&clearObserving(this),isCaughtException(t)&&this.reportExceptionInDerivation(t.cause),endBatch()}},e.prototype.reportExceptionInDerivation=function(e){var t=this;if(this.errorHandler)this.errorHandler(e,this);else{if(globalState.disableErrorBoundaries)throw e;var r="[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '"+this+"'";globalState.suppressReactionErrors?console.warn("[mobx] (error in reaction '"+this.name+"' suppressed, fix error of causing action below)"):console.error(r,e),globalState.globalReactionErrorHandlers.forEach(function(r){return r(e,t)})}},e.prototype.dispose=function(){this.isDisposed||(this.isDisposed=!0,this._isRunning||(startBatch(),clearObserving(this),endBatch()))},e.prototype.getDisposer=function(){var e=this.dispose.bind(this);return e[$mobx]=this,e},e.prototype.toString=function(){return"Reaction["+this.name+"]"},e.prototype.trace=function(e){void 0===e&&(e=!1),trace(this,e)},e}();function onReactionError(e){return globalState.globalReactionErrorHandlers.push(e),function(){var t=globalState.globalReactionErrorHandlers.indexOf(e);t>=0&&globalState.globalReactionErrorHandlers.splice(t,1)}}var MAX_REACTION_ITERATIONS=100,reactionScheduler=function(e){return e()};function runReactions(){globalState.inBatch>0||globalState.isRunningReactions||reactionScheduler(runReactionsHelper)}function runReactionsHelper(){globalState.isRunningReactions=!0;for(var e=globalState.pendingReactions,t=0;e.length>0;){++t===MAX_REACTION_ITERATIONS&&(console.error("Reaction doesn't converge to a stable state after "+MAX_REACTION_ITERATIONS+" iterations. Probably there is a cycle in the reactive function: "+e[0]),e.splice(0));for(var r=e.splice(0),n=0,o=r.length;n<o;n++)r[n].runReaction()}globalState.isRunningReactions=!1}var isReaction=createInstanceofPredicate("Reaction",Reaction);function setReactionScheduler(e){var t=reactionScheduler;reactionScheduler=function(r){return e(function(){return t(r)})}}function isSpyEnabled(){return!1}function spyReport(e){}function spyReportStart(e){}var END_EVENT={spyReportEnd:!0};function spyReportEnd(e){}function spy(e){return console.warn("[mobx.spy] Is a no-op in production builds"),function(){}}function dontReassignFields(){fail(!1)}function namedActionDecorator(e){return function(t,r,n){if(n){if(n.value)return{value:createAction(e,n.value),enumerable:!1,configurable:!0,writable:!0};var o=n.initializer;return{enumerable:!1,configurable:!0,writable:!0,initializer:function(){return createAction(e,o.call(this))}}}return actionFieldDecorator(e).apply(this,arguments)}}function actionFieldDecorator(e){return function(t,r,n){Object.defineProperty(t,r,{configurable:!0,enumerable:!1,get:function(){},set:function(t){addHiddenProp(this,r,action(e,t))}})}}function boundActionDecorator(e,t,r,n){return!0===n?(defineBoundAction(e,t,r.value),null):r?{configurable:!0,enumerable:!1,get:function(){return defineBoundAction(this,t,r.value||r.initializer.call(this)),this[t]},set:dontReassignFields}:{enumerable:!1,configurable:!0,set:function(e){defineBoundAction(this,t,e)},get:function(){}}}var action=function(e,t,r,n){return 1===arguments.length&&"function"==typeof e?createAction(e.name||"<unnamed action>",e):2===arguments.length&&"function"==typeof t?createAction(e,t):1===arguments.length&&"string"==typeof e?namedActionDecorator(e):!0!==n?namedActionDecorator(t).apply(null,arguments):void addHiddenProp(e,t,createAction(e.name||t,r.value,this))};function runInAction(e,t){return executeAction("string"==typeof e?e:e.name||"<unnamed action>","function"==typeof e?e:t,this,void 0)}function isAction(e){return"function"==typeof e&&!0===e.isMobxAction}function defineBoundAction(e,t,r){addHiddenProp(e,t,createAction(t,r.bind(e)))}function autorun(e,t){void 0===t&&(t=EMPTY_OBJECT);var r,n=t&&t.name||e.name||"Autorun@"+getNextId();if(!t.scheduler&&!t.delay)r=new Reaction(n,function(){this.track(i)},t.onError,t.requiresObservable);else{var o=createSchedulerFromOptions(t),a=!1;r=new Reaction(n,function(){a||(a=!0,o(function(){a=!1,r.isDisposed||r.track(i)}))},t.onError,t.requiresObservable)}function i(){e(r)}return r.schedule(),r.getDisposer()}action.bound=boundActionDecorator;var run=function(e){return e()};function createSchedulerFromOptions(e){return e.scheduler?e.scheduler:e.delay?function(t){return setTimeout(t,e.delay)}:run}function reaction(e,t,r){void 0===r&&(r=EMPTY_OBJECT);var n,o=r.name||"Reaction@"+getNextId(),a=action(o,r.onError?wrapErrorHandler(r.onError,t):t),i=!r.scheduler&&!r.delay,s=createSchedulerFromOptions(r),c=!0,l=!1,u=r.compareStructural?comparer.structural:r.equals||comparer.default,p=new Reaction(o,function(){c||i?d():l||(l=!0,s(d))},r.onError,r.requiresObservable);function d(){if(l=!1,!p.isDisposed){var t=!1;p.track(function(){var r=e(p);t=c||!u(n,r),n=r}),c&&r.fireImmediately&&a(n,p),c||!0!==t||a(n,p),c&&(c=!1)}}return p.schedule(),p.getDisposer()}function wrapErrorHandler(e,t){return function(){try{return t.apply(this,arguments)}catch(t){e.call(this,t)}}}function onBecomeObserved(e,t,r){return interceptHook("onBecomeObserved",e,t,r)}function onBecomeUnobserved(e,t,r){return interceptHook("onBecomeUnobserved",e,t,r)}function interceptHook(e,t,r,n){var o="function"==typeof n?getAtom(t,r):getAtom(t),a="function"==typeof n?n:r,i=e+"Listeners";return o[i]?o[i].add(a):o[i]=new Set([a]),"function"!=typeof o[e]?fail(!1):function(){var e=o[i];e&&(e.delete(a),0===e.size&&delete o[i])}}function configure(e){var t=e.enforceActions,r=e.computedRequiresReaction,n=e.computedConfigurable,o=e.disableErrorBoundaries,a=e.reactionScheduler,i=e.reactionRequiresObservable,s=e.observableRequiresReaction;if(!0===e.isolateGlobalState&&isolateGlobalState(),void 0!==t){"boolean"!=typeof t&&"strict"!==t||deprecated("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");var c=void 0;switch(t){case!0:case"observed":c=!0;break;case!1:case"never":c=!1;break;case"strict":case"always":c="strict";break;default:fail("Invalid value for 'enforceActions': '"+t+"', expected 'never', 'always' or 'observed'")}globalState.enforceActions=c,globalState.allowStateChanges=!0!==c&&"strict"!==c}void 0!==r&&(globalState.computedRequiresReaction=!!r),void 0!==i&&(globalState.reactionRequiresObservable=!!i),void 0!==s&&(globalState.observableRequiresReaction=!!s,globalState.allowStateReads=!globalState.observableRequiresReaction),void 0!==n&&(globalState.computedConfigurable=!!n),void 0!==o&&(!0===o&&console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled."),globalState.disableErrorBoundaries=!!o),a&&setReactionScheduler(a)}function decorate(e,t){var r="function"==typeof e?e.prototype:e,n=function(e){var n=t[e];Array.isArray(n)||(n=[n]);var o=Object.getOwnPropertyDescriptor(r,e),a=n.reduce(function(t,n){return n(r,e,t)},o);a&&Object.defineProperty(r,e,a)};for(var o in t)n(o);return e}function extendObservable(e,t,r,n){var o=getDefaultDecoratorFromObjectOptions(n=asCreateObservableOptions(n));return initializeInstance(e),asObservableObject(e,n.name,o.enhancer),t&&extendObservableObjectWithProperties(e,t,r,o),e}function getDefaultDecoratorFromObjectOptions(e){return e.defaultDecorator||(!1===e.deep?refDecorator:deepDecorator)}function extendObservableObjectWithProperties(e,t,r,n){var o,a;startBatch();try{var i=getPlainObjectKeys(t);try{for(var s=__values(i),c=s.next();!c.done;c=s.next()){var l=c.value,u=Object.getOwnPropertyDescriptor(t,l),p=(r&&l in r?r[l]:u.get?computedDecorator:n)(e,l,u,!0);p&&Object.defineProperty(e,l,p)}}catch(e){o={error:e}}finally{try{c&&!c.done&&(a=s.return)&&a.call(s)}finally{if(o)throw o.error}}}finally{endBatch()}}function getDependencyTree(e,t){return nodeToDependencyTree(getAtom(e,t))}function nodeToDependencyTree(e){var t={name:e.name};return e.observing&&e.observing.length>0&&(t.dependencies=unique(e.observing).map(nodeToDependencyTree)),t}function getObserverTree(e,t){return nodeToObserverTree(getAtom(e,t))}function nodeToObserverTree(e){var t={name:e.name};return hasObservers(e)&&(t.observers=Array.from(getObservers(e)).map(nodeToObserverTree)),t}var generatorId=0;function FlowCancellationError(){this.message="FLOW_CANCELLED"}function isFlowCancellationError(e){return e instanceof FlowCancellationError}function flow(e){1!==arguments.length&&fail("Flow expects 1 argument and cannot be used as decorator");var t=e.name||"<unnamed flow>";return function(){var r,n=arguments,o=++generatorId,a=action(t+" - runid: "+o+" - init",e).apply(this,n),i=void 0,s=new Promise(function(e,n){var s=0;function c(e){var r;i=void 0;try{r=action(t+" - runid: "+o+" - yield "+s++,a.next).call(a,e)}catch(e){return n(e)}u(r)}function l(e){var r;i=void 0;try{r=action(t+" - runid: "+o+" - yield "+s++,a.throw).call(a,e)}catch(e){return n(e)}u(r)}function u(t){if(!t||"function"!=typeof t.then)return t.done?e(t.value):(i=Promise.resolve(t.value)).then(c,l);t.then(u,n)}r=n,c(void 0)});return s.cancel=action(t+" - runid: "+o+" - cancel",function(){try{i&&cancelPromise(i);var e=a.return(void 0),t=Promise.resolve(e.value);t.then(noop,noop),cancelPromise(t),r(new FlowCancellationError)}catch(e){r(e)}}),s}}function cancelPromise(e){"function"==typeof e.cancel&&e.cancel()}function interceptReads(e,t,r){var n;if(isObservableMap(e)||isObservableArray(e)||isObservableValue(e))n=getAdministration(e);else{if(!isObservableObject(e))return fail(!1);if("string"!=typeof t)return fail(!1);n=getAdministration(e,t)}return void 0!==n.dehancer?fail(!1):(n.dehancer="function"==typeof t?t:r,function(){n.dehancer=void 0})}function intercept(e,t,r){return"function"==typeof r?interceptProperty(e,t,r):interceptInterceptable(e,t)}function interceptInterceptable(e,t){return getAdministration(e).intercept(t)}function interceptProperty(e,t,r){return getAdministration(e,t).intercept(r)}function _isComputed(e,t){if(null==e)return!1;if(void 0!==t){if(!1===isObservableObject(e))return!1;if(!e[$mobx].values.has(t))return!1;var r=getAtom(e,t);return isComputedValue(r)}return isComputedValue(e)}function isComputed(e){return arguments.length>1?fail(!1):_isComputed(e)}function isComputedProp(e,t){return"string"!=typeof t?fail(!1):_isComputed(e,t)}function _isObservable(e,t){return null!=e&&(void 0!==t?!!isObservableObject(e)&&e[$mobx].values.has(t):isObservableObject(e)||!!e[$mobx]||isAtom(e)||isReaction(e)||isComputedValue(e))}function isObservable(e){return 1!==arguments.length&&fail(!1),_isObservable(e)}function isObservableProp(e,t){return"string"!=typeof t?fail(!1):_isObservable(e,t)}function keys(e){return isObservableObject(e)?e[$mobx].getKeys():isObservableMap(e)?Array.from(e.keys()):isObservableSet(e)?Array.from(e.keys()):isObservableArray(e)?e.map(function(e,t){return t}):fail(!1)}function values(e){return isObservableObject(e)?keys(e).map(function(t){return e[t]}):isObservableMap(e)?keys(e).map(function(t){return e.get(t)}):isObservableSet(e)?Array.from(e.values()):isObservableArray(e)?e.slice():fail(!1)}function entries(e){return isObservableObject(e)?keys(e).map(function(t){return[t,e[t]]}):isObservableMap(e)?keys(e).map(function(t){return[t,e.get(t)]}):isObservableSet(e)?Array.from(e.entries()):isObservableArray(e)?e.map(function(e,t){return[t,e]}):fail(!1)}function set(e,t,r){if(2!==arguments.length||isObservableSet(e))if(isObservableObject(e)){var n=e[$mobx];n.values.get(t)?n.write(t,r):n.addObservableProp(t,r,n.defaultEnhancer)}else if(isObservableMap(e))e.set(t,r);else if(isObservableSet(e))e.add(t);else{if(!isObservableArray(e))return fail(!1);"number"!=typeof t&&(t=parseInt(t,10)),invariant(t>=0,"Not a valid index: '"+t+"'"),startBatch(),t>=e.length&&(e.length=t+1),e[t]=r,endBatch()}else{startBatch();var o=t;try{for(var a in o)set(e,a,o[a])}finally{endBatch()}}}function remove(e,t){if(isObservableObject(e))e[$mobx].remove(t);else if(isObservableMap(e))e.delete(t);else if(isObservableSet(e))e.delete(t);else{if(!isObservableArray(e))return fail(!1);"number"!=typeof t&&(t=parseInt(t,10)),invariant(t>=0,"Not a valid index: '"+t+"'"),e.splice(t,1)}}function has(e,t){return isObservableObject(e)?getAdministration(e).has(t):isObservableMap(e)?e.has(t):isObservableSet(e)?e.has(t):isObservableArray(e)?t>=0&&t<e.length:fail(!1)}function get(e,t){if(has(e,t))return isObservableObject(e)?e[t]:isObservableMap(e)?e.get(t):isObservableArray(e)?e[t]:fail(!1)}function observe(e,t,r,n){return"function"==typeof r?observeObservableProperty(e,t,r,n):observeObservable(e,t,r)}function observeObservable(e,t,r){return getAdministration(e).observe(t,r)}function observeObservableProperty(e,t,r,n){return getAdministration(e,t).observe(r,n)}FlowCancellationError.prototype=Object.create(Error.prototype);var defaultOptions={detectCycles:!0,exportMapsAsObjects:!0,recurseEverything:!1};function cache(e,t,r,n){return n.detectCycles&&e.set(t,r),r}function toJSHelper(e,t,r){if(!t.recurseEverything&&!isObservable(e))return e;if("object"!=typeof e)return e;if(null===e)return null;if(e instanceof Date)return e;if(isObservableValue(e))return toJSHelper(e.get(),t,r);if(isObservable(e)&&keys(e),!0===t.detectCycles&&null!==e&&r.has(e))return r.get(e);if(isObservableArray(e)||Array.isArray(e)){var n=cache(r,e,[],t),o=e.map(function(e){return toJSHelper(e,t,r)});n.length=o.length;for(var a=0,i=o.length;a<i;a++)n[a]=o[a];return n}if(isObservableSet(e)||Object.getPrototypeOf(e)===Set.prototype){if(!1===t.exportMapsAsObjects){var s=cache(r,e,new Set,t);return e.forEach(function(e){s.add(toJSHelper(e,t,r))}),s}var c=cache(r,e,[],t);return e.forEach(function(e){c.push(toJSHelper(e,t,r))}),c}if(isObservableMap(e)||Object.getPrototypeOf(e)===Map.prototype){if(!1===t.exportMapsAsObjects){var l=cache(r,e,new Map,t);return e.forEach(function(e,n){l.set(n,toJSHelper(e,t,r))}),l}var u=cache(r,e,{},t);return e.forEach(function(e,n){u[n]=toJSHelper(e,t,r)}),u}var p=cache(r,e,{},t);return getPlainObjectKeys(e).forEach(function(n){p[n]=toJSHelper(e[n],t,r)}),p}function toJS(e,t){var r;return"boolean"==typeof t&&(t={detectCycles:t}),t||(t=defaultOptions),t.detectCycles=void 0===t.detectCycles?!0===t.recurseEverything:!0===t.detectCycles,t.detectCycles&&(r=new Map),toJSHelper(e,t,r)}function trace(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=!1;"boolean"==typeof e[e.length-1]&&(r=e.pop());var n=getAtomFromArgs(e);if(!n)return fail(!1);n.isTracing===TraceMode.NONE&&console.log("[mobx.trace] '"+n.name+"' tracing enabled"),n.isTracing=r?TraceMode.BREAK:TraceMode.LOG}function getAtomFromArgs(e){switch(e.length){case 0:return globalState.trackingDerivation;case 1:return getAtom(e[0]);case 2:return getAtom(e[0],e[1])}}function transaction(e,t){void 0===t&&(t=void 0),startBatch();try{return e.apply(t)}finally{endBatch()}}function when(e,t,r){return 1===arguments.length||t&&"object"==typeof t?whenPromise(e,t):_when(e,t,r||{})}function _when(e,t,r){var n;"number"==typeof r.timeout&&(n=setTimeout(function(){if(!a[$mobx].isDisposed){a();var e=new Error("WHEN_TIMEOUT");if(!r.onError)throw e;r.onError(e)}},r.timeout)),r.name=r.name||"When@"+getNextId();var o=createAction(r.name+"-effect",t),a=autorun(function(t){e()&&(t.dispose(),n&&clearTimeout(n),o())},r);return a}function whenPromise(e,t){var r,n=new Promise(function(n,o){var a=_when(e,n,__assign(__assign({},t),{onError:o}));r=function(){a(),o("WHEN_CANCELLED")}});return n.cancel=r,n}function getAdm(e){return e[$mobx]}function isPropertyKey(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e}var objectProxyTraps={has:function(e,t){if(t===$mobx||"constructor"===t||t===mobxDidRunLazyInitializersSymbol)return!0;var r=getAdm(e);return isPropertyKey(t)?r.has(t):t in e},get:function(e,t){if(t===$mobx||"constructor"===t||t===mobxDidRunLazyInitializersSymbol)return e[t];var r=getAdm(e),n=r.values.get(t);if(n instanceof Atom){var o=n.get();return void 0===o&&r.has(t),o}return isPropertyKey(t)&&r.has(t),e[t]},set:function(e,t,r){return!!isPropertyKey(t)&&(set(e,t,r),!0)},deleteProperty:function(e,t){return!!isPropertyKey(t)&&(getAdm(e).remove(t),!0)},ownKeys:function(e){return getAdm(e).keysAtom.reportObserved(),Reflect.ownKeys(e)},preventExtensions:function(e){return fail("Dynamic observable objects cannot be frozen"),!1}};function createDynamicObservableObject(e){var t=new Proxy(e,objectProxyTraps);return e[$mobx].proxy=t,t}function hasInterceptors(e){return void 0!==e.interceptors&&e.interceptors.length>0}function registerInterceptor(e,t){var r=e.interceptors||(e.interceptors=[]);return r.push(t),once(function(){var e=r.indexOf(t);-1!==e&&r.splice(e,1)})}function interceptChange(e,t){var r=untrackedStart();try{for(var n=__spread(e.interceptors||[]),o=0,a=n.length;o<a&&(invariant(!(t=n[o](t))||t.type,"Intercept handlers should return nothing or a change object"),t);o++);return t}finally{untrackedEnd(r)}}function hasListeners(e){return void 0!==e.changeListeners&&e.changeListeners.length>0}function registerListener(e,t){var r=e.changeListeners||(e.changeListeners=[]);return r.push(t),once(function(){var e=r.indexOf(t);-1!==e&&r.splice(e,1)})}function notifyListeners(e,t){var r=untrackedStart(),n=e.changeListeners;if(n){for(var o=0,a=(n=n.slice()).length;o<a;o++)n[o](t);untrackedEnd(r)}}var MAX_SPLICE_SIZE=1e4,arrayTraps={get:function(e,t){return t===$mobx?e[$mobx]:"length"===t?e[$mobx].getArrayLength():"number"==typeof t?arrayExtensions.get.call(e,t):"string"!=typeof t||isNaN(t)?arrayExtensions.hasOwnProperty(t)?arrayExtensions[t]:e[t]:arrayExtensions.get.call(e,parseInt(t))},set:function(e,t,r){return"length"===t&&e[$mobx].setArrayLength(r),"number"==typeof t&&arrayExtensions.set.call(e,t,r),"symbol"==typeof t||isNaN(t)?e[t]=r:arrayExtensions.set.call(e,parseInt(t),r),!0},preventExtensions:function(e){return fail("Observable arrays cannot be frozen"),!1}};function createObservableArray(e,t,r,n){void 0===r&&(r="ObservableArray@"+getNextId()),void 0===n&&(n=!1);var o=new ObservableArrayAdministration(r,t,n);addHiddenFinalProp(o.values,$mobx,o);var a=new Proxy(o.values,arrayTraps);if(o.proxy=a,e&&e.length){var i=allowStateChangesStart(!0);o.spliceWithArray(0,0,e),allowStateChangesEnd(i)}return a}var ObservableArrayAdministration=function(){function e(e,t,r){this.owned=r,this.values=[],this.proxy=void 0,this.lastKnownLength=0,this.atom=new Atom(e||"ObservableArray@"+getNextId()),this.enhancer=function(r,n){return t(r,n,e+"[..]")}}return e.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},e.prototype.dehanceValues=function(e){return void 0!==this.dehancer&&e.length>0?e.map(this.dehancer):e},e.prototype.intercept=function(e){return registerInterceptor(this,e)},e.prototype.observe=function(e,t){return void 0===t&&(t=!1),t&&e({object:this.proxy,type:"splice",index:0,added:this.values.slice(),addedCount:this.values.length,removed:[],removedCount:0}),registerListener(this,e)},e.prototype.getArrayLength=function(){return this.atom.reportObserved(),this.values.length},e.prototype.setArrayLength=function(e){if("number"!=typeof e||e<0)throw new Error("[mobx.array] Out of range: "+e);var t=this.values.length;if(e!==t)if(e>t){for(var r=new Array(e-t),n=0;n<e-t;n++)r[n]=void 0;this.spliceWithArray(t,0,r)}else this.spliceWithArray(e,t-e)},e.prototype.updateArrayLength=function(e,t){if(e!==this.lastKnownLength)throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");this.lastKnownLength+=t},e.prototype.spliceWithArray=function(e,t,r){var n=this;checkIfStateModificationsAreAllowed(this.atom);var o=this.values.length;if(void 0===e?e=0:e>o?e=o:e<0&&(e=Math.max(0,o+e)),t=1===arguments.length?o-e:null==t?0:Math.max(0,Math.min(t,o-e)),void 0===r&&(r=EMPTY_ARRAY),hasInterceptors(this)){var a=interceptChange(this,{object:this.proxy,type:"splice",index:e,removedCount:t,added:r});if(!a)return EMPTY_ARRAY;t=a.removedCount,r=a.added}r=0===r.length?r:r.map(function(e){return n.enhancer(e,void 0)});var i=this.spliceItemsIntoValues(e,t,r);return 0===t&&0===r.length||this.notifyArraySplice(e,r,i),this.dehanceValues(i)},e.prototype.spliceItemsIntoValues=function(e,t,r){var n;if(r.length<MAX_SPLICE_SIZE)return(n=this.values).splice.apply(n,__spread([e,t],r));var o=this.values.slice(e,e+t);return this.values=this.values.slice(0,e).concat(r,this.values.slice(e+t)),o},e.prototype.notifyArrayChildUpdate=function(e,t,r){var n=!this.owned&&isSpyEnabled(),o=hasListeners(this),a=o||n?{object:this.proxy,type:"update",index:e,newValue:t,oldValue:r}:null;this.atom.reportChanged(),o&&notifyListeners(this,a)},e.prototype.notifyArraySplice=function(e,t,r){var n=!this.owned&&isSpyEnabled(),o=hasListeners(this),a=o||n?{object:this.proxy,type:"splice",index:e,removed:r,added:t,removedCount:r.length,addedCount:t.length}:null;this.atom.reportChanged(),o&&notifyListeners(this,a)},e}(),arrayExtensions={intercept:function(e){return this[$mobx].intercept(e)},observe:function(e,t){return void 0===t&&(t=!1),this[$mobx].observe(e,t)},clear:function(){return this.splice(0)},replace:function(e){var t=this[$mobx];return t.spliceWithArray(0,t.values.length,e)},toJS:function(){return this.slice()},toJSON:function(){return this.toJS()},splice:function(e,t){for(var r=[],n=2;n<arguments.length;n++)r[n-2]=arguments[n];var o=this[$mobx];switch(arguments.length){case 0:return[];case 1:return o.spliceWithArray(e);case 2:return o.spliceWithArray(e,t)}return o.spliceWithArray(e,t,r)},spliceWithArray:function(e,t,r){return this[$mobx].spliceWithArray(e,t,r)},push:function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=this[$mobx];return r.spliceWithArray(r.values.length,0,e),r.values.length},pop:function(){return this.splice(Math.max(this[$mobx].values.length-1,0),1)[0]},shift:function(){return this.splice(0,1)[0]},unshift:function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=this[$mobx];return r.spliceWithArray(0,0,e),r.values.length},reverse:function(){var e=this.slice();return e.reverse.apply(e,arguments)},sort:function(e){var t=this.slice();return t.sort.apply(t,arguments)},remove:function(e){var t=this[$mobx],r=t.dehanceValues(t.values).indexOf(e);return r>-1&&(this.splice(r,1),!0)},get:function(e){var t=this[$mobx];if(t){if(e<t.values.length)return t.atom.reportObserved(),t.dehanceValue(t.values[e]);console.warn("[mobx.array] Attempt to read an array index ("+e+") that is out of bounds ("+t.values.length+"). Please check length first. Out of bound indices will not be tracked by MobX")}},set:function(e,t){var r=this[$mobx],n=r.values;if(e<n.length){checkIfStateModificationsAreAllowed(r.atom);var o=n[e];if(hasInterceptors(r)){var a=interceptChange(r,{type:"update",object:r.proxy,index:e,newValue:t});if(!a)return;t=a.newValue}(t=r.enhancer(t,o))!==o&&(n[e]=t,r.notifyArrayChildUpdate(e,t,o))}else{if(e!==n.length)throw new Error("[mobx.array] Index out of bounds, "+e+" is larger than "+n.length);r.spliceWithArray(e,0,[t])}}};["concat","every","filter","forEach","indexOf","join","lastIndexOf","map","reduce","reduceRight","slice","some","toString","toLocaleString"].forEach(function(e){arrayExtensions[e]=function(){var t=this[$mobx];t.atom.reportObserved();var r=t.dehanceValues(t.values);return r[e].apply(r,arguments)}});var _a,isObservableArrayAdministration=createInstanceofPredicate("ObservableArrayAdministration",ObservableArrayAdministration);function isObservableArray(e){return isObject(e)&&isObservableArrayAdministration(e[$mobx])}var _a$1,ObservableMapMarker={},ObservableMap=function(){function e(e,t,r){if(void 0===t&&(t=deepEnhancer),void 0===r&&(r="ObservableMap@"+getNextId()),this.enhancer=t,this.name=r,this[_a]=ObservableMapMarker,this._keysAtom=createAtom(this.name+".keys()"),this[Symbol.toStringTag]="Map","function"!=typeof Map)throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");this._data=new Map,this._hasMap=new Map,this.merge(e)}return e.prototype._has=function(e){return this._data.has(e)},e.prototype.has=function(e){var t=this;if(!globalState.trackingDerivation)return this._has(e);var r=this._hasMap.get(e);if(!r){var n=r=new ObservableValue(this._has(e),referenceEnhancer,this.name+"."+stringifyKey(e)+"?",!1);this._hasMap.set(e,n),onBecomeUnobserved(n,function(){return t._hasMap.delete(e)})}return r.get()},e.prototype.set=function(e,t){var r=this._has(e);if(hasInterceptors(this)){var n=interceptChange(this,{type:r?"update":"add",object:this,newValue:t,name:e});if(!n)return this;t=n.newValue}return r?this._updateValue(e,t):this._addValue(e,t),this},e.prototype.delete=function(e){var t=this;if(hasInterceptors(this)&&!(o=interceptChange(this,{type:"delete",object:this,name:e})))return!1;if(this._has(e)){var r=isSpyEnabled(),n=hasListeners(this),o=n||r?{type:"delete",object:this,oldValue:this._data.get(e).value,name:e}:null;return transaction(function(){t._keysAtom.reportChanged(),t._updateHasMapEntry(e,!1),t._data.get(e).setNewValue(void 0),t._data.delete(e)}),n&&notifyListeners(this,o),!0}return!1},e.prototype._updateHasMapEntry=function(e,t){var r=this._hasMap.get(e);r&&r.setNewValue(t)},e.prototype._updateValue=function(e,t){var r=this._data.get(e);if((t=r.prepareNewValue(t))!==globalState.UNCHANGED){var n=isSpyEnabled(),o=hasListeners(this),a=o||n?{type:"update",object:this,oldValue:r.value,name:e,newValue:t}:null;0,r.setNewValue(t),o&&notifyListeners(this,a)}},e.prototype._addValue=function(e,t){var r=this;checkIfStateModificationsAreAllowed(this._keysAtom),transaction(function(){var n=new ObservableValue(t,r.enhancer,r.name+"."+stringifyKey(e),!1);r._data.set(e,n),t=n.value,r._updateHasMapEntry(e,!0),r._keysAtom.reportChanged()});var n=isSpyEnabled(),o=hasListeners(this);o&&notifyListeners(this,o||n?{type:"add",object:this,name:e,newValue:t}:null)},e.prototype.get=function(e){return this.has(e)?this.dehanceValue(this._data.get(e).get()):this.dehanceValue(void 0)},e.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},e.prototype.keys=function(){return this._keysAtom.reportObserved(),this._data.keys()},e.prototype.values=function(){var e=this,t=0,r=Array.from(this.keys());return makeIterable({next:function(){return t<r.length?{value:e.get(r[t++]),done:!1}:{done:!0}}})},e.prototype.entries=function(){var e=this,t=0,r=Array.from(this.keys());return makeIterable({next:function(){if(t<r.length){var n=r[t++];return{value:[n,e.get(n)],done:!1}}return{done:!0}}})},e.prototype[(_a=$mobx,Symbol.iterator)]=function(){return this.entries()},e.prototype.forEach=function(e,t){var r,n;try{for(var o=__values(this),a=o.next();!a.done;a=o.next()){var i=__read(a.value,2),s=i[0],c=i[1];e.call(t,c,s,this)}}catch(e){r={error:e}}finally{try{a&&!a.done&&(n=o.return)&&n.call(o)}finally{if(r)throw r.error}}},e.prototype.merge=function(e){var t=this;return isObservableMap(e)&&(e=e.toJS()),transaction(function(){isPlainObject(e)?getPlainObjectKeys(e).forEach(function(r){return t.set(r,e[r])}):Array.isArray(e)?e.forEach(function(e){var r=__read(e,2),n=r[0],o=r[1];return t.set(n,o)}):isES6Map(e)?(e.constructor!==Map&&fail("Cannot initialize from classes that inherit from Map: "+e.constructor.name),e.forEach(function(e,r){return t.set(r,e)})):null!=e&&fail("Cannot initialize map from "+e)}),this},e.prototype.clear=function(){var e=this;transaction(function(){untracked(function(){var t,r;try{for(var n=__values(e.keys()),o=n.next();!o.done;o=n.next()){var a=o.value;e.delete(a)}}catch(e){t={error:e}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(t)throw t.error}}})})},e.prototype.replace=function(e){var t=this;return transaction(function(){var r=getMapLikeKeys(e);Array.from(t.keys()).filter(function(e){return-1===r.indexOf(e)}).forEach(function(e){return t.delete(e)}),t.merge(e)}),this},Object.defineProperty(e.prototype,"size",{get:function(){return this._keysAtom.reportObserved(),this._data.size},enumerable:!0,configurable:!0}),e.prototype.toPOJO=function(){var e,t,r={};try{for(var n=__values(this),o=n.next();!o.done;o=n.next()){var a=__read(o.value,2),i=a[0],s=a[1];r["symbol"==typeof i?i:stringifyKey(i)]=s}}catch(t){e={error:t}}finally{try{o&&!o.done&&(t=n.return)&&t.call(n)}finally{if(e)throw e.error}}return r},e.prototype.toJS=function(){return new Map(this)},e.prototype.toJSON=function(){return this.toPOJO()},e.prototype.toString=function(){var e=this;return this.name+"[{ "+Array.from(this.keys()).map(function(t){return stringifyKey(t)+": "+e.get(t)}).join(", ")+" }]"},e.prototype.observe=function(e,t){return registerListener(this,e)},e.prototype.intercept=function(e){return registerInterceptor(this,e)},e}(),isObservableMap=createInstanceofPredicate("ObservableMap",ObservableMap),ObservableSetMarker={},ObservableSet=function(){function e(e,t,r){if(void 0===t&&(t=deepEnhancer),void 0===r&&(r="ObservableSet@"+getNextId()),this.name=r,this[_a$1]=ObservableSetMarker,this._data=new Set,this._atom=createAtom(this.name),this[Symbol.toStringTag]="Set","function"!=typeof Set)throw new Error("mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js");this.enhancer=function(e,n){return t(e,n,r)},e&&this.replace(e)}return e.prototype.dehanceValue=function(e){return void 0!==this.dehancer?this.dehancer(e):e},e.prototype.clear=function(){var e=this;transaction(function(){untracked(function(){var t,r;try{for(var n=__values(e._data.values()),o=n.next();!o.done;o=n.next()){var a=o.value;e.delete(a)}}catch(e){t={error:e}}finally{try{o&&!o.done&&(r=n.return)&&r.call(n)}finally{if(t)throw t.error}}})})},e.prototype.forEach=function(e,t){var r,n;try{for(var o=__values(this),a=o.next();!a.done;a=o.next()){var i=a.value;e.call(t,i,i,this)}}catch(e){r={error:e}}finally{try{a&&!a.done&&(n=o.return)&&n.call(o)}finally{if(r)throw r.error}}},Object.defineProperty(e.prototype,"size",{get:function(){return this._atom.reportObserved(),this._data.size},enumerable:!0,configurable:!0}),e.prototype.add=function(e){var t=this;if((checkIfStateModificationsAreAllowed(this._atom),hasInterceptors(this))&&!(o=interceptChange(this,{type:"add",object:this,newValue:e})))return this;if(!this.has(e)){transaction(function(){t._data.add(t.enhancer(e,void 0)),t._atom.reportChanged()});var r=isSpyEnabled(),n=hasListeners(this),o=n||r?{type:"add",object:this,newValue:e}:null;0,n&&notifyListeners(this,o)}return this},e.prototype.delete=function(e){var t=this;if(hasInterceptors(this)&&!(o=interceptChange(this,{type:"delete",object:this,oldValue:e})))return!1;if(this.has(e)){var r=isSpyEnabled(),n=hasListeners(this),o=n||r?{type:"delete",object:this,oldValue:e}:null;return transaction(function(){t._atom.reportChanged(),t._data.delete(e)}),n&&notifyListeners(this,o),!0}return!1},e.prototype.has=function(e){return this._atom.reportObserved(),this._data.has(this.dehanceValue(e))},e.prototype.entries=function(){var e=0,t=Array.from(this.keys()),r=Array.from(this.values());return makeIterable({next:function(){var n=e;return e+=1,n<r.length?{value:[t[n],r[n]],done:!1}:{done:!0}}})},e.prototype.keys=function(){return this.values()},e.prototype.values=function(){this._atom.reportObserved();var e=this,t=0,r=Array.from(this._data.values());return makeIterable({next:function(){return t<r.length?{value:e.dehanceValue(r[t++]),done:!1}:{done:!0}}})},e.prototype.replace=function(e){var t=this;return isObservableSet(e)&&(e=e.toJS()),transaction(function(){Array.isArray(e)?(t.clear(),e.forEach(function(e){return t.add(e)})):isES6Set(e)?(t.clear(),e.forEach(function(e){return t.add(e)})):null!=e&&fail("Cannot initialize set from "+e)}),this},e.prototype.observe=function(e,t){return registerListener(this,e)},e.prototype.intercept=function(e){return registerInterceptor(this,e)},e.prototype.toJS=function(){return new Set(this)},e.prototype.toString=function(){return this.name+"[ "+Array.from(this).join(", ")+" ]"},e.prototype[(_a$1=$mobx,Symbol.iterator)]=function(){return this.values()},e}(),isObservableSet=createInstanceofPredicate("ObservableSet",ObservableSet),ObservableObjectAdministration=function(){function e(e,t,r,n){void 0===t&&(t=new Map),this.target=e,this.values=t,this.name=r,this.defaultEnhancer=n,this.keysAtom=new Atom(r+".keys")}return e.prototype.read=function(e){return this.values.get(e).get()},e.prototype.write=function(e,t){var r=this.target,n=this.values.get(e);if(n instanceof ComputedValue)n.set(t);else{if(hasInterceptors(this)){if(!(i=interceptChange(this,{type:"update",object:this.proxy||r,name:e,newValue:t})))return;t=i.newValue}if((t=n.prepareNewValue(t))!==globalState.UNCHANGED){var o=hasListeners(this),a=isSpyEnabled(),i=o||a?{type:"update",object:this.proxy||r,oldValue:n.value,name:e,newValue:t}:null;0,n.setNewValue(t),o&&notifyListeners(this,i)}}},e.prototype.has=function(e){var t=this.pendingKeys||(this.pendingKeys=new Map),r=t.get(e);if(r)return r.get();var n=!!this.values.get(e);return r=new ObservableValue(n,referenceEnhancer,this.name+"."+stringifyKey(e)+"?",!1),t.set(e,r),r.get()},e.prototype.addObservableProp=function(e,t,r){void 0===r&&(r=this.defaultEnhancer);var n=this.target;if(hasInterceptors(this)){var o=interceptChange(this,{object:this.proxy||n,name:e,type:"add",newValue:t});if(!o)return;t=o.newValue}var a=new ObservableValue(t,r,this.name+"."+stringifyKey(e),!1);this.values.set(e,a),t=a.value,Object.defineProperty(n,e,generateObservablePropConfig(e)),this.notifyPropertyAddition(e,t)},e.prototype.addComputedProp=function(e,t,r){var n=this.target;r.name=r.name||this.name+"."+stringifyKey(t),this.values.set(t,new ComputedValue(r)),(e===n||isPropertyConfigurable(e,t))&&Object.defineProperty(e,t,generateComputedPropConfig(t))},e.prototype.remove=function(e){if(this.values.has(e)){var t=this.target;if(hasInterceptors(this))if(!(s=interceptChange(this,{object:this.proxy||t,name:e,type:"remove"})))return;try{startBatch();var r=hasListeners(this),n=isSpyEnabled(),o=this.values.get(e),a=o&&o.get();if(o&&o.set(void 0),this.keysAtom.reportChanged(),this.values.delete(e),this.pendingKeys){var i=this.pendingKeys.get(e);i&&i.set(!1)}delete this.target[e];var s=r||n?{type:"remove",object:this.proxy||t,oldValue:a,name:e}:null;0,r&&notifyListeners(this,s)}finally{endBatch()}}},e.prototype.illegalAccess=function(e,t){console.warn("Property '"+t+"' of '"+e+"' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner")},e.prototype.observe=function(e,t){return registerListener(this,e)},e.prototype.intercept=function(e){return registerInterceptor(this,e)},e.prototype.notifyPropertyAddition=function(e,t){var r=hasListeners(this),n=isSpyEnabled(),o=r||n?{type:"add",object:this.proxy||this.target,name:e,newValue:t}:null;if(r&&notifyListeners(this,o),this.pendingKeys){var a=this.pendingKeys.get(e);a&&a.set(!0)}this.keysAtom.reportChanged()},e.prototype.getKeys=function(){var e,t;this.keysAtom.reportObserved();var r=[];try{for(var n=__values(this.values),o=n.next();!o.done;o=n.next()){var a=__read(o.value,2),i=a[0];a[1]instanceof ObservableValue&&r.push(i)}}catch(t){e={error:t}}finally{try{o&&!o.done&&(t=n.return)&&t.call(n)}finally{if(e)throw e.error}}return r},e}();function asObservableObject(e,t,r){if(void 0===t&&(t=""),void 0===r&&(r=deepEnhancer),Object.prototype.hasOwnProperty.call(e,$mobx))return e[$mobx];isPlainObject(e)||(t=(e.constructor.name||"ObservableObject")+"@"+getNextId()),t||(t="ObservableObject@"+getNextId());var n=new ObservableObjectAdministration(e,new Map,stringifyKey(t),r);return addHiddenProp(e,$mobx,n),n}var observablePropertyConfigs=Object.create(null),computedPropertyConfigs=Object.create(null);function generateObservablePropConfig(e){return observablePropertyConfigs[e]||(observablePropertyConfigs[e]={configurable:!0,enumerable:!0,get:function(){return this[$mobx].read(e)},set:function(t){this[$mobx].write(e,t)}})}function getAdministrationForComputedPropOwner(e){var t=e[$mobx];return t||(initializeInstance(e),e[$mobx])}function generateComputedPropConfig(e){return computedPropertyConfigs[e]||(computedPropertyConfigs[e]={configurable:globalState.computedConfigurable,enumerable:!1,get:function(){return getAdministrationForComputedPropOwner(this).read(e)},set:function(t){getAdministrationForComputedPropOwner(this).write(e,t)}})}var isObservableObjectAdministration=createInstanceofPredicate("ObservableObjectAdministration",ObservableObjectAdministration);function isObservableObject(e){return!!isObject(e)&&(initializeInstance(e),isObservableObjectAdministration(e[$mobx]))}function getAtom(e,t){if("object"==typeof e&&null!==e){if(isObservableArray(e))return void 0!==t&&fail(!1),e[$mobx].atom;if(isObservableSet(e))return e[$mobx];if(isObservableMap(e)){var r=e;return void 0===t?r._keysAtom:((n=r._data.get(t)||r._hasMap.get(t))||fail(!1),n)}var n;if(initializeInstance(e),t&&!e[$mobx]&&e[t],isObservableObject(e))return t?((n=e[$mobx].values.get(t))||fail(!1),n):fail(!1);if(isAtom(e)||isComputedValue(e)||isReaction(e))return e}else if("function"==typeof e&&isReaction(e[$mobx]))return e[$mobx];return fail(!1)}function getAdministration(e,t){return e||fail("Expecting some object"),void 0!==t?getAdministration(getAtom(e,t)):isAtom(e)||isComputedValue(e)||isReaction(e)?e:isObservableMap(e)||isObservableSet(e)?e:(initializeInstance(e),e[$mobx]?e[$mobx]:void fail(!1))}function getDebugName(e,t){return(void 0!==t?getAtom(e,t):isObservableObject(e)||isObservableMap(e)||isObservableSet(e)?getAdministration(e):getAtom(e)).name}var g,toString=Object.prototype.toString;function deepEqual(e,t,r){return void 0===r&&(r=-1),eq(e,t,r)}function eq(e,t,r,n,o){if(e===t)return 0!==e||1/e==1/t;if(null==e||null==t)return!1;if(e!=e)return t!=t;var a=typeof e;if("function"!==a&&"object"!==a&&"object"!=typeof t)return!1;var i=toString.call(e);if(i!==toString.call(t))return!1;switch(i){case"[object RegExp]":case"[object String]":return""+e==""+t;case"[object Number]":return+e!=+e?+t!=+t:0==+e?1/+e==1/t:+e==+t;case"[object Date]":case"[object Boolean]":return+e==+t;case"[object Symbol]":return"undefined"!=typeof Symbol&&Symbol.valueOf.call(e)===Symbol.valueOf.call(t);case"[object Map]":case"[object Set]":r>=0&&r++}e=unwrap(e),t=unwrap(t);var s="[object Array]"===i;if(!s){if("object"!=typeof e||"object"!=typeof t)return!1;var c=e.constructor,l=t.constructor;if(c!==l&&!("function"==typeof c&&c instanceof c&&"function"==typeof l&&l instanceof l)&&"constructor"in e&&"constructor"in t)return!1}if(0===r)return!1;r<0&&(r=-1),o=o||[];for(var u=(n=n||[]).length;u--;)if(n[u]===e)return o[u]===t;if(n.push(e),o.push(t),s){if((u=e.length)!==t.length)return!1;for(;u--;)if(!eq(e[u],t[u],r-1,n,o))return!1}else{var p=Object.keys(e),d=void 0;if(u=p.length,Object.keys(t).length!==u)return!1;for(;u--;)if(!has$1(t,d=p[u])||!eq(e[d],t[d],r-1,n,o))return!1}return n.pop(),o.pop(),!0}function unwrap(e){return isObservableArray(e)?e.slice():isES6Map(e)||isObservableMap(e)?Array.from(e.entries()):isES6Set(e)||isObservableSet(e)?Array.from(e.entries()):e}function has$1(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function makeIterable(e){return e[Symbol.iterator]=getSelf,e}function getSelf(){return this}if("undefined"==typeof Proxy||"undefined"==typeof Symbol)throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Symbol or Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");"object"==typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__&&__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({spy:spy,extras:{getDebugName:getDebugName},$mobx:$mobx}),exports.$mobx=$mobx,exports.FlowCancellationError=FlowCancellationError,exports.ObservableMap=ObservableMap,exports.ObservableSet=ObservableSet,exports.Reaction=Reaction,exports._allowStateChanges=allowStateChanges,exports._allowStateChangesInsideComputed=allowStateChangesInsideComputed,exports._allowStateReadsEnd=allowStateReadsEnd,exports._allowStateReadsStart=allowStateReadsStart,exports._endAction=_endAction,exports._getAdministration=getAdministration,exports._getGlobalState=getGlobalState,exports._interceptReads=interceptReads,exports._isComputingDerivation=isComputingDerivation,exports._resetGlobalState=resetGlobalState,exports._startAction=_startAction,exports.action=action,exports.autorun=autorun,exports.comparer=comparer,exports.computed=computed,exports.configure=configure,exports.createAtom=createAtom,exports.decorate=decorate,exports.entries=entries,exports.extendObservable=extendObservable,exports.flow=flow,exports.get=get,exports.getAtom=getAtom,exports.getDebugName=getDebugName,exports.getDependencyTree=getDependencyTree,exports.getObserverTree=getObserverTree,exports.has=has,exports.intercept=intercept,exports.isAction=isAction,exports.isArrayLike=isArrayLike,exports.isBoxedObservable=isObservableValue,exports.isComputed=isComputed,exports.isComputedProp=isComputedProp,exports.isFlowCancellationError=isFlowCancellationError,exports.isObservable=isObservable,exports.isObservableArray=isObservableArray,exports.isObservableMap=isObservableMap,exports.isObservableObject=isObservableObject,exports.isObservableProp=isObservableProp,exports.isObservableSet=isObservableSet,exports.keys=keys,exports.observable=observable,exports.observe=observe,exports.onBecomeObserved=onBecomeObserved,exports.onBecomeUnobserved=onBecomeUnobserved,exports.onReactionError=onReactionError,exports.reaction=reaction,exports.remove=remove,exports.runInAction=runInAction,exports.set=set,exports.spy=spy,exports.toJS=toJS,exports.trace=trace,exports.transaction=transaction,exports.untracked=untracked,exports.values=values,exports.when=when;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), (function() { return this; }())))

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(7);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(435);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(307);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(417);
	
	var _HelmetConstants = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 194:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(194);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 133:
/***/ (function(module, exports) {

	/** @license React v16.13.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(133);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var ExecutionEnvironment = _interopDefault(__webpack_require__(316));
	var shallowEqual = _interopDefault(__webpack_require__(453));
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;
	
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),

/***/ 453:
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, module) {'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hyphenate = _interopDefault(__webpack_require__(112));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var Stylis = _interopDefault(__webpack_require__(138));
	var _insertRulePlugin = _interopDefault(__webpack_require__(137));
	var PropTypes = _interopDefault(__webpack_require__(7));
	var hoistStatics = _interopDefault(__webpack_require__(74));
	var reactIs = __webpack_require__(81);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	// 
	var isPlainObject = (function (x) {
	  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
	});
	
	// 
	
	
	/**
	 * Parse errors.md and turn it into a simple hash of code: message
	 */
	var ERRORS =  false ? {
	  "1": "Cannot create styled-component for component: %s.\n\n",
	  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
	  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
	  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
	  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
	  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
	  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
	  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
	  "9": "Missing document `<head>`\n\n",
	  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
	  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
	} : {};
	
	/**
	 * super basic version of sprintf
	 */
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var a = args[0];
	  var b = [];
	  var c = void 0;
	
	  for (c = 1; c < args.length; c += 1) {
	    b.push(args[c]);
	  }
	
	  b.forEach(function (d) {
	    a = a.replace(/%[a-z]/, d);
	  });
	
	  return a;
	}
	
	/**
	 * Create an error file out of errors.md for development and a simple web link to the full errors
	 * in production mode.
	 */
	
	var StyledComponentsError = function (_Error) {
	  inherits(StyledComponentsError, _Error);
	
	  function StyledComponentsError(code) {
	    classCallCheck(this, StyledComponentsError);
	
	    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      interpolations[_key2 - 1] = arguments[_key2];
	    }
	
	    if (true) {
	      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
	    } else {
	      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
	    }
	    return possibleConstructorReturn(_this);
	  }
	
	  return StyledComponentsError;
	}(Error);
	
	// 
	
	var objToCss = function objToCss(obj, prevKey) {
	  var css = Object.keys(obj).filter(function (key) {
	    var chunk = obj[key];
	    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
	  }).map(function (key) {
	    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
	    return hyphenate(key) + ': ' + obj[key] + ';';
	  }).join(' ');
	  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
	};
	
	var flatten = function flatten(chunks, executionContext) {
	  return chunks.reduce(function (ruleSet, chunk) {
	    /* Remove falsey values */
	    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
	      return ruleSet;
	    }
	
	    /* Flatten ruleSet */
	    if (Array.isArray(chunk)) {
	      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
	      return ruleSet;
	    }
	
	    /* Handle other components */
	    if (chunk.hasOwnProperty('styledComponentId')) {
	      // $FlowFixMe not sure how to make this pass
	      ruleSet.push('.' + chunk.styledComponentId);
	      return ruleSet;
	    }
	
	    /* Either execute or defer the function */
	    if (typeof chunk === 'function') {
	      if (executionContext) {
	        var nextChunk = chunk(executionContext);
	        /* Throw if a React Element was given styles */
	        if (React__default.isValidElement(nextChunk)) {
	          var elementName = chunk.displayName || chunk.name;
	          throw new StyledComponentsError(11, elementName);
	        }
	        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
	      } else ruleSet.push(chunk);
	
	      return ruleSet;
	    }
	
	    /* Handle objects */
	    ruleSet.push(
	    // $FlowFixMe have to add %checks somehow to isPlainObject
	    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());
	
	    return ruleSet;
	  }, []);
	};
	
	// 
	
	var COMMENT_REGEX = /^\s*\/\/.*$/gm;
	
	// NOTE: This stylis instance is only used to split rules from SSR'd style tags
	var stylisSplitter = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: false,
	  compress: false,
	  semicolon: true
	});
	
	var stylis = new Stylis({
	  global: false,
	  cascade: true,
	  keyframe: false,
	  prefix: true,
	  compress: false,
	  semicolon: false // NOTE: This means "autocomplete missing semicolons"
	});
	
	// Wrap `insertRulePlugin to build a list of rules,
	// and then make our own plugin to return the rules. This
	// makes it easier to hook into the existing SSR architecture
	
	var parsingRules = [];
	// eslint-disable-next-line consistent-return
	var returnRulesPlugin = function returnRulesPlugin(context) {
	  if (context === -2) {
	    var parsedRules = parsingRules;
	    parsingRules = [];
	    return parsedRules;
	  }
	};
	
	var parseRulesPlugin = _insertRulePlugin(function (rule) {
	  parsingRules.push(rule);
	});
	
	stylis.use([parseRulesPlugin, returnRulesPlugin]);
	stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);
	
	var stringifyRules = function stringifyRules(rules, selector, prefix) {
	  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments
	
	  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
	
	  return stylis(prefix || !selector ? '' : selector, cssStr);
	};
	
	var splitByRules = function splitByRules(css) {
	  return stylisSplitter('', css);
	};
	
	// 
	
	function isStyledComponent(target) /* : %checks */{
	  return (
	    // $FlowFixMe TODO: flow for styledComponentId
	    typeof target === 'function' && typeof target.styledComponentId === 'string'
	  );
	}
	
	// 
	
	/* This function is DEPRECATED and will be removed on the next major version release.
	 * It was needed to rehydrate all style blocks prepended to chunks before React
	 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
	 * the use of streamed style tags and will perform the rehydration earlier when needed
	 * this function will not be needed anymore */
	function consolidateStreamedStyles() {
	  if (false) {
	    // eslint-disable-next-line no-console
	    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
	  }
	}
	
	// 
	/* eslint-disable no-bitwise */
	
	/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
	 * counterparts */
	var charsLength = 52;
	
	/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
	var getAlphabeticChar = function getAlphabeticChar(code) {
	  return String.fromCharCode(code + (code > 25 ? 39 : 97));
	};
	
	/* input a number, usually a hash and convert it to base-52 */
	var generateAlphabeticName = function generateAlphabeticName(code) {
	  var name = '';
	  var x = void 0;
	
	  /* get a char and divide by alphabet-length */
	  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
	    name = getAlphabeticChar(x % charsLength) + name;
	  }
	
	  return getAlphabeticChar(x % charsLength) + name;
	};
	
	// 
	
	var interleave = (function (strings, interpolations) {
	  var result = [strings[0]];
	
	  for (var i = 0, len = interpolations.length; i < len; i += 1) {
	    result.push(interpolations[i], strings[i + 1]);
	  }
	
	  return result;
	});
	
	// 
	var EMPTY_ARRAY = Object.freeze([]);
	var EMPTY_OBJECT = Object.freeze({});
	
	// 
	
	var css = (function (styles) {
	  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    interpolations[_key - 1] = arguments[_key];
	  }
	
	  if (typeof styles === 'function' || isPlainObject(styles)) {
	    // $FlowFixMe
	    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
	  }
	
	  // $FlowFixMe
	  return flatten(interleave(styles, interpolations));
	});
	
	// 
	
	
	var SC_ATTR = typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_DIR":"/opt/build/repo/public"}).SC_ATTR || 'data-styled-components';
	var SC_STREAM_ATTR = 'data-styled-streamed';
	var CONTEXT_KEY = '__styled-components-stylesheet__';
	
	var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
	
	var DISABLE_SPEEDY = ("production") !== 'production';
	
	// 
	var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
	
	var extractComps = (function (maybeCSS) {
	  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
	  var existingComponents = [];
	  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
	    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
	    return match;
	  });
	  return existingComponents.map(function (_ref, i) {
	    var componentId = _ref.componentId,
	        matchIndex = _ref.matchIndex;
	
	    var nextComp = existingComponents[i + 1];
	    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
	    return { componentId: componentId, cssFromDOM: cssFromDOM };
	  });
	});
	
	// 
	/* eslint-disable camelcase, no-undef */
	
	var getNonce = (function () {
	  return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
	});
	
	// 
	// Helper to call a given function, only once
	var once = (function (cb) {
	  var called = false;
	
	  return function () {
	    if (!called) {
	      called = true;
	      cb();
	    }
	  };
	});
	
	// 
	/* These are helpers for the StyleTags to keep track of the injected
	 * rule names for each (component) ID that they're keeping track of.
	 * They're crucial for detecting whether a name has already been
	 * injected.
	 * (This excludes rehydrated names) */
	
	/* adds a new ID:name pairing to a names dictionary */
	var addNameForId = function addNameForId(names, id, name) {
	  if (name) {
	    // eslint-disable-next-line no-param-reassign
	    var namesForId = names[id] || (names[id] = Object.create(null));
	    namesForId[name] = true;
	  }
	};
	
	/* resets an ID entirely by overwriting it in the dictionary */
	var resetIdNames = function resetIdNames(names, id) {
	  // eslint-disable-next-line no-param-reassign
	  names[id] = Object.create(null);
	};
	
	/* factory for a names dictionary checking the existance of an ID:name pairing */
	var hasNameForId = function hasNameForId(names) {
	  return function (id, name) {
	    return names[id] !== undefined && names[id][name];
	  };
	};
	
	/* stringifies names for the html/element output */
	var stringifyNames = function stringifyNames(names) {
	  var str = '';
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    str += Object.keys(names[id]).join(' ') + ' ';
	  }
	  return str.trim();
	};
	
	/* clones the nested names dictionary */
	var cloneNames = function cloneNames(names) {
	  var clone = Object.create(null);
	  // eslint-disable-next-line guard-for-in
	  for (var id in names) {
	    clone[id] = _extends({}, names[id]);
	  }
	  return clone;
	};
	
	// 
	
	/* These are helpers that deal with the insertRule (aka speedy) API
	 * They are used in the StyleTags and specifically the speedy tag
	 */
	
	/* retrieve a sheet for a given style tag */
	var sheetForTag = function sheetForTag(tag) {
	  // $FlowFixMe
	  if (tag.sheet) return tag.sheet;
	
	  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
	  var size = document.styleSheets.length;
	  for (var i = 0; i < size; i += 1) {
	    var sheet = document.styleSheets[i];
	    // $FlowFixMe
	    if (sheet.ownerNode === tag) return sheet;
	  }
	
	  /* we should always be able to find a tag */
	  throw new StyledComponentsError(10);
	};
	
	/* insert a rule safely and return whether it was actually injected */
	var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
	  /* abort early if cssRule string is falsy */
	  if (!cssRule) return false;
	
	  var maxIndex = sheet.cssRules.length;
	
	  try {
	    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
	    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
	  } catch (err) {
	    /* any error indicates an invalid rule */
	    return false;
	  }
	
	  return true;
	};
	
	/* deletes `size` rules starting from `removalIndex` */
	var deleteRules = function deleteRules(sheet, removalIndex, size) {
	  var lowerBound = removalIndex - size;
	  for (var i = removalIndex; i > lowerBound; i -= 1) {
	    sheet.deleteRule(i);
	  }
	};
	
	// 
	
	/* this marker separates component styles and is important for rehydration */
	var makeTextMarker = function makeTextMarker(id) {
	  return '\n/* sc-component-id: ' + id + ' */\n';
	};
	
	/* add up all numbers in array up until and including the index */
	var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
	  var totalUpToIndex = 0;
	  for (var i = 0; i <= index; i += 1) {
	    totalUpToIndex += sizes[i];
	  }
	
	  return totalUpToIndex;
	};
	
	/* create a new style tag after lastEl */
	var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
	  var el = document.createElement('style');
	  el.setAttribute(SC_ATTR, '');
	
	  var nonce = getNonce();
	  if (nonce) {
	    el.setAttribute('nonce', nonce);
	  }
	
	  /* Work around insertRule quirk in EdgeHTML */
	  el.appendChild(document.createTextNode(''));
	
	  if (target && !tagEl) {
	    /* Append to target when no previous element was passed */
	    target.appendChild(el);
	  } else {
	    if (!tagEl || !target || !tagEl.parentNode) {
	      throw new StyledComponentsError(6);
	    }
	
	    /* Insert new style tag after the previous one */
	    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
	  }
	
	  return el;
	};
	
	/* takes a css factory function and outputs an html styled tag factory */
	var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
	  return function (additionalAttrs) {
	    var nonce = getNonce();
	    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];
	
	    var htmlAttr = attrs.filter(Boolean).join(' ');
	    return '<style ' + htmlAttr + '>' + css() + '</style>';
	  };
	};
	
	/* takes a css factory function and outputs an element factory */
	var wrapAsElement = function wrapAsElement(css, names) {
	  return function () {
	    var _props;
	
	    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);
	
	    var nonce = getNonce();
	    if (nonce) {
	      // $FlowFixMe
	      props.nonce = nonce;
	    }
	
	    // eslint-disable-next-line react/no-danger
	    return React__default.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
	  };
	};
	
	var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
	  return function () {
	    return Object.keys(markers);
	  };
	};
	
	/* speedy tags utilise insertRule */
	var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	  var sizes = [];
	
	  var extractImport = getImportRuleTag !== undefined;
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = sizes.length;
	    sizes.push(0);
	    resetIdNames(names, id);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var sheet = sheetForTag(el);
	    var insertIndex = addUpUntilIndex(sizes, marker);
	
	    var injectedRules = 0;
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var cssRule = cssRules[i];
	      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
	      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
	        importRules.push(cssRule);
	      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
	        mayHaveImport = false;
	        injectedRules += 1;
	      }
	    }
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	
	    sizes[marker] += injectedRules; /* add up no of injected rules */
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    var size = sizes[marker];
	    var sheet = sheetForTag(el);
	    var removalIndex = addUpUntilIndex(sizes, marker);
	    deleteRules(sheet, removalIndex, size);
	    sizes[marker] = 0;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var _sheetForTag = sheetForTag(el),
	        cssRules = _sheetForTag.cssRules;
	
	    var str = '';
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += makeTextMarker(id);
	      var marker = markers[id];
	      var end = addUpUntilIndex(sizes, marker);
	      var size = sizes[marker];
	      for (var i = end - size; i < end; i += 1) {
	        var rule = cssRules[i];
	        if (rule !== undefined) {
	          str += rule.cssText;
	        }
	      }
	    }
	
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeTextNode = function makeTextNode(id) {
	  return document.createTextNode(makeTextMarker(id));
	};
	
	var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
	  var names = Object.create(null);
	  var markers = Object.create(null);
	
	  var extractImport = getImportRuleTag !== undefined;
	
	  /* indicates whther getImportRuleTag was called */
	  var usedImportRuleTag = false;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    markers[id] = makeTextNode(id);
	    el.appendChild(markers[id]);
	    names[id] = Object.create(null);
	
	    return markers[id];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    var importRules = [];
	    var cssRulesSize = cssRules.length;
	
	    for (var i = 0; i < cssRulesSize; i += 1) {
	      var rule = cssRules[i];
	      var mayHaveImport = extractImport;
	      if (mayHaveImport && rule.indexOf('@import') !== -1) {
	        importRules.push(rule);
	      } else {
	        mayHaveImport = false;
	        var separator = i === cssRulesSize - 1 ? '' : ' ';
	        marker.appendData('' + rule + separator);
	      }
	    }
	
	    addNameForId(names, id, name);
	
	    if (extractImport && importRules.length > 0) {
	      usedImportRuleTag = true;
	      // $FlowFixMe
	      getImportRuleTag().insertRules(id + '-import', importRules);
	    }
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	
	    /* create new empty text node and replace the current one */
	    var newMarker = makeTextNode(id);
	    el.replaceChild(newMarker, marker);
	    markers[id] = newMarker;
	    resetIdNames(names, id);
	
	    if (extractImport && usedImportRuleTag) {
	      // $FlowFixMe
	      getImportRuleTag().removeRules(id + '-import');
	    }
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      str += markers[id].data;
	    }
	    return str;
	  };
	
	  return {
	    clone: function clone() {
	      throw new StyledComponentsError(5);
	    },
	
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: el,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	};
	
	var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
	  var names = namesArg === undefined ? Object.create(null) : namesArg;
	  var markers = markersArg === undefined ? Object.create(null) : markersArg;
	
	  var insertMarker = function insertMarker(id) {
	    var prev = markers[id];
	    if (prev !== undefined) {
	      return prev;
	    }
	
	    return markers[id] = [''];
	  };
	
	  var insertRules = function insertRules(id, cssRules, name) {
	    var marker = insertMarker(id);
	    marker[0] += cssRules.join(' ');
	    addNameForId(names, id, name);
	  };
	
	  var removeRules = function removeRules(id) {
	    var marker = markers[id];
	    if (marker === undefined) return;
	    marker[0] = '';
	    resetIdNames(names, id);
	  };
	
	  var css = function css() {
	    var str = '';
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      var cssForId = markers[id][0];
	      if (cssForId) {
	        str += makeTextMarker(id) + cssForId;
	      }
	    }
	    return str;
	  };
	
	  var clone = function clone() {
	    var namesClone = cloneNames(names);
	    var markersClone = Object.create(null);
	
	    // eslint-disable-next-line guard-for-in
	    for (var id in markers) {
	      markersClone[id] = [markers[id][0]];
	    }
	
	    return makeServerTagInternal(namesClone, markersClone);
	  };
	
	  var tag = {
	    clone: clone,
	    css: css,
	    getIds: getIdsFromMarkersFactory(markers),
	    hasNameForId: hasNameForId(names),
	    insertMarker: insertMarker,
	    insertRules: insertRules,
	    removeRules: removeRules,
	    sealed: false,
	    styleTag: null,
	    toElement: wrapAsElement(css, names),
	    toHTML: wrapAsHtmlTag(css, names)
	  };
	
	  return tag;
	};
	
	var makeServerTag = function makeServerTag() {
	  return makeServerTagInternal();
	};
	
	var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
	  if (IS_BROWSER && !forceServer) {
	    var el = makeStyleTag(target, tagEl, insertBefore);
	
	    if (DISABLE_SPEEDY) {
	      return makeBrowserTag(el, getImportRuleTag);
	    } else {
	      return makeSpeedyTag(el, getImportRuleTag);
	    }
	  }
	
	  return makeServerTag();
	};
	
	/* wraps a given tag so that rehydration is performed once when necessary */
	var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
	  /* rehydration function that adds all rules to the new tag */
	  var rehydrate = once(function () {
	    /* add all extracted components to the new tag */
	    for (var i = 0, len = extracted.length; i < len; i += 1) {
	      var _extracted$i = extracted[i],
	          componentId = _extracted$i.componentId,
	          cssFromDOM = _extracted$i.cssFromDOM;
	
	      var cssRules = splitByRules(cssFromDOM);
	      tag.insertRules(componentId, cssRules);
	    }
	
	    /* remove old HTMLStyleElements, since they have been rehydrated */
	    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
	      var el = els[_i];
	      if (el.parentNode) {
	        el.parentNode.removeChild(el);
	      }
	    }
	  });
	
	  if (immediateRehydration) rehydrate();
	
	  return _extends({}, tag, {
	    /* add rehydration hook to insertion methods */
	    insertMarker: function insertMarker(id) {
	      rehydrate();
	      return tag.insertMarker(id);
	    },
	    insertRules: function insertRules(id, cssRules, name) {
	      rehydrate();
	      return tag.insertRules(id, cssRules, name);
	    }
	  });
	};
	
	// 
	
	var SPLIT_REGEX = /\s+/;
	
	/* determine the maximum number of components before tags are sharded */
	var MAX_SIZE = void 0;
	if (IS_BROWSER) {
	  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
	  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
	} else {
	  /* for servers we do not need to shard at all */
	  MAX_SIZE = -1;
	}
	
	var sheetRunningId = 0;
	var master = void 0;
	
	var StyleSheet = function () {
	  /* a map from ids to tags */
	  /* deferred rules for a given id */
	  /* this is used for not reinjecting rules via hasNameForId() */
	  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
	  /* a list of tags belonging to this StyleSheet */
	  /* a tag for import rules */
	  /* current capacity until a new tag must be created */
	  /* children (aka clones) of this StyleSheet inheriting all and future injections */
	
	  function StyleSheet() {
	    var _this = this;
	
	    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
	    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    classCallCheck(this, StyleSheet);
	
	    this.getImportRuleTag = function () {
	      var importRuleTag = _this.importRuleTag;
	
	      if (importRuleTag !== undefined) {
	        return importRuleTag;
	      }
	
	      var firstTag = _this.tags[0];
	      var insertBefore = true;
	
	      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
	    };
	
	    sheetRunningId += 1;
	    this.id = sheetRunningId;
	    this.forceServer = forceServer;
	    this.target = forceServer ? null : target;
	    this.tagMap = {};
	    this.deferred = {};
	    this.rehydratedNames = {};
	    this.ignoreRehydratedNames = {};
	    this.tags = [];
	    this.capacity = 1;
	    this.clones = [];
	  }
	
	  /* rehydrate all SSR'd style tags */
	
	
	  StyleSheet.prototype.rehydrate = function rehydrate() {
	    if (!IS_BROWSER || this.forceServer) {
	      return this;
	    }
	
	    var els = [];
	    var extracted = [];
	    var isStreamed = false;
	
	    /* retrieve all of our SSR style elements from the DOM */
	    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
	    var nodesSize = nodes.length;
	
	    /* abort rehydration if no previous style tags were found */
	    if (nodesSize === 0) {
	      return this;
	    }
	
	    for (var i = 0; i < nodesSize; i += 1) {
	      // $FlowFixMe: We can trust that all elements in this query are style elements
	      var el = nodes[i];
	
	      /* check if style tag is a streamed tag */
	      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);
	
	      /* retrieve all component names */
	      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
	      var elNamesSize = elNames.length;
	      for (var j = 0; j < elNamesSize; j += 1) {
	        var name = elNames[j];
	        /* add rehydrated name to sheet to avoid readding styles */
	        this.rehydratedNames[name] = true;
	      }
	
	      /* extract all components and their CSS */
	      extracted.push.apply(extracted, extractComps(el.textContent));
	
	      /* store original HTMLStyleElement */
	      els.push(el);
	    }
	
	    /* abort rehydration if nothing was extracted */
	    var extractedSize = extracted.length;
	    if (extractedSize === 0) {
	      return this;
	    }
	
	    /* create a tag to be used for rehydration */
	    var tag = this.makeTag(null);
	    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);
	
	    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
	    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
	    this.tags.push(rehydrationTag);
	
	    /* retrieve all component ids */
	    for (var _j = 0; _j < extractedSize; _j += 1) {
	      this.tagMap[extracted[_j].componentId] = rehydrationTag;
	    }
	
	    return this;
	  };
	
	  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
	   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
	    * StyleSheetManager's context */
	
	
	  /* reset the internal "master" instance */
	  StyleSheet.reset = function reset() {
	    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    master = new StyleSheet(undefined, forceServer).rehydrate();
	  };
	
	  /* adds "children" to the StyleSheet that inherit all of the parents' rules
	   * while their own rules do not affect the parent */
	
	
	  StyleSheet.prototype.clone = function clone() {
	    var sheet = new StyleSheet(this.target, this.forceServer);
	
	    /* add to clone array */
	    this.clones.push(sheet);
	
	    /* clone all tags */
	    sheet.tags = this.tags.map(function (tag) {
	      var ids = tag.getIds();
	      var newTag = tag.clone();
	
	      /* reconstruct tagMap */
	      for (var i = 0; i < ids.length; i += 1) {
	        sheet.tagMap[ids[i]] = newTag;
	      }
	
	      return newTag;
	    });
	
	    /* clone other maps */
	    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
	    sheet.deferred = _extends({}, this.deferred);
	
	    return sheet;
	  };
	
	  /* force StyleSheet to create a new tag on the next injection */
	
	
	  StyleSheet.prototype.sealAllTags = function sealAllTags() {
	    this.capacity = 1;
	
	    this.tags.forEach(function (tag) {
	      // eslint-disable-next-line no-param-reassign
	      tag.sealed = true;
	    });
	  };
	
	  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
	    var lastEl = tag ? tag.styleTag : null;
	    var insertBefore = false;
	
	    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
	  };
	
	  /* get a tag for a given componentId, assign the componentId to one, or shard */
	  StyleSheet.prototype.getTagForId = function getTagForId(id) {
	    /* simply return a tag, when the componentId was already assigned one */
	    var prev = this.tagMap[id];
	    if (prev !== undefined && !prev.sealed) {
	      return prev;
	    }
	
	    var tag = this.tags[this.tags.length - 1];
	
	    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
	    this.capacity -= 1;
	
	    if (this.capacity === 0) {
	      this.capacity = MAX_SIZE;
	      tag = this.makeTag(tag);
	      this.tags.push(tag);
	    }
	
	    return this.tagMap[id] = tag;
	  };
	
	  /* mainly for injectGlobal to check for its id */
	
	
	  StyleSheet.prototype.hasId = function hasId(id) {
	    return this.tagMap[id] !== undefined;
	  };
	
	  /* caching layer checking id+name to already have a corresponding tag and injected rules */
	
	
	  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
	    /* exception for rehydrated names which are checked separately */
	    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
	      return true;
	    }
	
	    var tag = this.tagMap[id];
	    return tag !== undefined && tag.hasNameForId(id, name);
	  };
	
	  /* registers a componentId and registers it on its tag */
	
	
	  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
	    /* don't inject when the id is already registered */
	    if (this.tagMap[id] !== undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].deferredInject(id, cssRules);
	    }
	
	    this.getTagForId(id).insertMarker(id);
	    this.deferred[id] = cssRules;
	  };
	
	  /* injects rules for a given id with a name that will need to be cached */
	
	
	  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
	    var clones = this.clones;
	
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].inject(id, cssRules, name);
	    }
	
	    var tag = this.getTagForId(id);
	
	    /* add deferred rules for component */
	    if (this.deferred[id] !== undefined) {
	      // Combine passed cssRules with previously deferred CSS rules
	      // NOTE: We cannot mutate the deferred array itself as all clones
	      // do the same (see clones[i].inject)
	      var rules = this.deferred[id].concat(cssRules);
	      tag.insertRules(id, rules, name);
	
	      this.deferred[id] = undefined;
	    } else {
	      tag.insertRules(id, cssRules, name);
	    }
	  };
	
	  /* removes all rules for a given id, which doesn't remove its marker but resets it */
	
	
	  StyleSheet.prototype.remove = function remove(id) {
	    var tag = this.tagMap[id];
	    if (tag === undefined) return;
	
	    var clones = this.clones;
	
	    for (var i = 0; i < clones.length; i += 1) {
	      clones[i].remove(id);
	    }
	
	    /* remove all rules from the tag */
	    tag.removeRules(id);
	    /* ignore possible rehydrated names */
	    this.ignoreRehydratedNames[id] = true;
	    /* delete possible deferred rules */
	    this.deferred[id] = undefined;
	  };
	
	  StyleSheet.prototype.toHTML = function toHTML() {
	    return this.tags.map(function (tag) {
	      return tag.toHTML();
	    }).join('');
	  };
	
	  StyleSheet.prototype.toReactElements = function toReactElements() {
	    var id = this.id;
	
	
	    return this.tags.map(function (tag, i) {
	      var key = 'sc-' + id + '-' + i;
	      return React.cloneElement(tag.toElement(), { key: key });
	    });
	  };
	
	  createClass(StyleSheet, null, [{
	    key: 'master',
	    get: function get$$1() {
	      return master || (master = new StyleSheet().rehydrate());
	    }
	
	    /* NOTE: This is just for backwards-compatibility with jest-styled-components */
	
	  }, {
	    key: 'instance',
	    get: function get$$1() {
	      return StyleSheet.master;
	    }
	  }]);
	  return StyleSheet;
	}();
	
	var _StyleSheetManager$ch;
	
	var StyleSheetManager = function (_Component) {
	  inherits(StyleSheetManager, _Component);
	
	  function StyleSheetManager() {
	    classCallCheck(this, StyleSheetManager);
	    return possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  StyleSheetManager.prototype.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
	  };
	
	  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
	    if (this.props.sheet) {
	      this.sheetInstance = this.props.sheet;
	    } else if (this.props.target) {
	      this.sheetInstance = new StyleSheet(this.props.target);
	    } else {
	      throw new StyledComponentsError(4);
	    }
	  };
	
	  StyleSheetManager.prototype.render = function render() {
	    /* eslint-disable react/prop-types */
	    // Flow v0.43.1 will report an error accessing the `children` property,
	    // but v0.47.0 will not. It is necessary to use a type cast instead of
	    // a "fixme" comment to satisfy both Flow versions.
	    return React__default.Children.only(this.props.children);
	  };
	
	  return StyleSheetManager;
	}(React.Component);
	
	StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
	 false ? StyleSheetManager.propTypes = {
	  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
	  target: PropTypes.shape({
	    appendChild: PropTypes.func.isRequired
	  })
	} : void 0;
	
	// 
	
	var ServerStyleSheet = function () {
	  function ServerStyleSheet() {
	    classCallCheck(this, ServerStyleSheet);
	
	    /* The master sheet might be reset, so keep a reference here */
	    this.masterSheet = StyleSheet.master;
	    this.instance = this.masterSheet.clone();
	    this.closed = false;
	  }
	
	  ServerStyleSheet.prototype.complete = function complete() {
	    if (!this.closed) {
	      /* Remove closed StyleSheets from the master sheet */
	      var index = this.masterSheet.clones.indexOf(this.instance);
	      this.masterSheet.clones.splice(index, 1);
	      this.closed = true;
	    }
	  };
	
	  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
	    if (this.closed) {
	      throw new StyledComponentsError(2);
	    }
	
	    return React__default.createElement(
	      StyleSheetManager,
	      { sheet: this.instance },
	      children
	    );
	  };
	
	  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
	    this.complete();
	    return this.instance.toHTML();
	  };
	
	  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
	    this.complete();
	    return this.instance.toReactElements();
	  };
	
	  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
	    var _this = this;
	
	    {
	      throw new StyledComponentsError(3);
	    }
	
	    /* the tag index keeps track of which tags have already been emitted */
	    var instance = this.instance;
	
	    var instanceTagIndex = 0;
	
	    var streamAttr = SC_STREAM_ATTR + '="true"';
	
	    var transformer = new stream.Transform({
	      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
	        var tags = instance.tags;
	
	        var html = '';
	
	        /* retrieve html for each new style tag */
	        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
	          var tag = tags[instanceTagIndex];
	          html += tag.toHTML(streamAttr);
	        }
	
	        /* force our StyleSheets to emit entirely new tags */
	        instance.sealAllTags();
	
	        /* prepend style html to chunk */
	        this.push(html + chunk);
	        callback();
	      }
	    });
	
	    readableStream.on('end', function () {
	      return _this.complete();
	    });
	    readableStream.on('error', function (err) {
	      _this.complete();
	
	      // forward the error to the transform stream
	      transformer.emit('error', err);
	    });
	
	    return readableStream.pipe(transformer);
	  };
	
	  return ServerStyleSheet;
	}();
	
	// 
	
	var LIMIT = 200;
	
	var createWarnTooManyClasses = (function (displayName) {
	  var generatedClasses = {};
	  var warningSeen = false;
	
	  return function (className) {
	    if (!warningSeen) {
	      generatedClasses[className] = true;
	      if (Object.keys(generatedClasses).length >= LIMIT) {
	        // Unable to find latestRule in test environment.
	        /* eslint-disable no-console, prefer-template */
	        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
	        warningSeen = true;
	        generatedClasses = {};
	      }
	    }
	  };
	});
	
	// 
	
	var determineTheme = (function (props, fallbackTheme, defaultProps) {
	  // Props should take precedence over ThemeProvider, which should take precedence over
	  // defaultProps, but React automatically puts defaultProps on props.
	
	  /* eslint-disable react/prop-types */
	  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
	  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
	  /* eslint-enable */
	
	  return theme;
	});
	
	// 
	var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
	var dashesAtEnds = /(^-|-$)/g;
	
	/**
	 * TODO: Explore using CSS.escape when it becomes more available
	 * in evergreen browsers.
	 */
	function escape(str) {
	  return str
	  // Replace all possible CSS selectors
	  .replace(escapeRegex, '-')
	
	  // Remove extraneous hyphens at the start and end
	  .replace(dashesAtEnds, '');
	}
	
	// 
	
	function getComponentName(target) {
	  return target.displayName || target.name || 'Component';
	}
	
	// 
	
	function isTag(target) /* : %checks */{
	  return typeof target === 'string';
	}
	
	// 
	
	function generateDisplayName(target) {
	  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
	}
	
	// 
	/* eslint-disable max-len */
	/**
	 * Trying to avoid the unknown-prop errors on styled components by filtering by
	 * React's attribute whitelist.
	 *
	 * To regenerate this regex:
	 *
	 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
	 * 2. Run `regexgen` with the list of space-separated words below as input
	 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
	 *    and no false positives from partials
	 * */
	/*
	children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
	*/
	/* eslint-enable max-len */
	
	var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
	/* From DOMProperty */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
	var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));
	
	var validAttr = (function (name) {
	  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
	});
	
	// 
	
	function hasInInheritanceChain(child, parent) {
	  var target = child;
	
	  while (target) {
	    target = Object.getPrototypeOf(target);
	
	    if (target && target === parent) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	// 
	/**
	 * Creates a broadcast that can be listened to, i.e. simple event emitter
	 *
	 * @see https://github.com/ReactTraining/react-broadcast
	 */
	
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in listeners) {
	      var listener = listeners[key];
	      if (listener === undefined) {
	        // eslint-disable-next-line no-continue
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
	};
	
	var _contextShape, _ThemeProvider$contex;
	
	// NOTE: DO NOT CHANGE, changing this is a semver major change!
	var CHANNEL = '__styled-components__';
	var CHANNEL_NEXT = CHANNEL + 'next__';
	
	var CONTEXT_CHANNEL_SHAPE = PropTypes.shape({
	  getTheme: PropTypes.func,
	  subscribe: PropTypes.func,
	  unsubscribe: PropTypes.func
	});
	
	var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = PropTypes.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);
	
	var warnChannelDeprecated = void 0;
	if (false) {
	  warnChannelDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
	  });
	}
	
	var isFunction = function isFunction(test) {
	  return typeof test === 'function';
	};
	
	/**
	 * Provide a theme to an entire react component tree via context and event listeners (have to do
	 * both context and event emitter as pure components block context updates)
	 */
	
	var ThemeProvider = function (_Component) {
	  inherits(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    classCallCheck(this, ThemeProvider);
	
	    var _this = possibleConstructorReturn(this, _Component.call(this));
	
	    _this.unsubscribeToOuterId = -1;
	
	    _this.getTheme = _this.getTheme.bind(_this);
	    return _this;
	  }
	
	  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    var outerContext = this.context[CHANNEL_NEXT];
	    if (outerContext !== undefined) {
	      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
	        _this2.outerTheme = theme;
	
	        if (_this2.broadcast !== undefined) {
	          _this2.publish(_this2.props.theme);
	        }
	      });
	    }
	
	    this.broadcast = createBroadcast(this.getTheme());
	  };
	
	  ThemeProvider.prototype.getChildContext = function getChildContext() {
	    var _this3 = this,
	        _babelHelpers$extends;
	
	    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
	      getTheme: this.getTheme,
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
	      if (false) {
	        warnChannelDeprecated();
	      }
	
	      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
	      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
	      return function () {
	        return _this3.broadcast.unsubscribe(unsubscribeId);
	      };
	    }, _babelHelpers$extends));
	  };
	
	  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publish(nextProps.theme);
	    }
	  };
	
	  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.unsubscribeToOuterId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	
	
	  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
	    var theme = passedTheme || this.props.theme;
	
	    if (isFunction(theme)) {
	      var mergedTheme = theme(this.outerTheme);
	
	      if (false) {
	        throw new StyledComponentsError(7);
	      }
	
	      return mergedTheme;
	    }
	
	    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
	      throw new StyledComponentsError(8);
	    }
	
	    return _extends({}, this.outerTheme, theme);
	  };
	
	  ThemeProvider.prototype.publish = function publish(theme) {
	    this.broadcast.publish(this.getTheme(theme));
	  };
	
	  ThemeProvider.prototype.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	
	    return React__default.Children.only(this.props.children);
	  };
	
	  return ThemeProvider;
	}(React.Component);
	
	ThemeProvider.childContextTypes = contextShape;
	ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);
	
	var _babelHelpers$extends;
	
	// HACK for generating all static styles without needing to allocate
	// an empty execution context every single time...
	var STATIC_EXECUTION_CONTEXT = {};
	
	var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));
	
	var identifiers = {};
	
	/* We depend on components having unique IDs */
	var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
	  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);
	
	  /**
	   * This ensures uniqueness if two components happen to share
	   * the same displayName.
	   */
	  var nr = (identifiers[displayName] || 0) + 1;
	  identifiers[displayName] = nr;
	
	  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
	
	  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
	};
	
	var warnExtendDeprecated = function warnExtendDeprecated() {};
	if (false) {
	  warnExtendDeprecated = once(function () {
	    // eslint-disable-next-line no-console
	    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
	  });
	}
	
	// $FlowFixMe
	
	var BaseStyledComponent = function (_Component) {
	  inherits(BaseStyledComponent, _Component);
	
	  function BaseStyledComponent() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, BaseStyledComponent);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
	      theme: null,
	      generatedClassName: ''
	    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
	    if (this.unsubscribeId !== -1) {
	      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	    }
	  };
	
	  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
	    var attrs = this.constructor.attrs;
	
	    var context = _extends({}, props, { theme: theme });
	    if (attrs === undefined) {
	      return context;
	    }
	
	    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
	      var attr = attrs[key];
	
	      // eslint-disable-next-line no-param-reassign
	      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, React.Component) ? attr(context) : attr;
	      return acc;
	    }, {});
	
	    return _extends({}, context, this.attrs);
	  };
	
	  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
	    var _constructor = this.constructor,
	        attrs = _constructor.attrs,
	        componentStyle = _constructor.componentStyle,
	        warnTooManyClasses = _constructor.warnTooManyClasses;
	
	    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;
	
	    // statically styled-components don't need to build an execution context object,
	    // and shouldn't be increasing the number of class names
	    if (componentStyle.isStatic && attrs === undefined) {
	      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
	    } else {
	      var executionContext = this.buildExecutionContext(theme, props);
	      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
	
	      if (false) {
	        warnTooManyClasses(className);
	      }
	
	      return className;
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var componentStyle = this.constructor.componentStyle;
	
	    var styledContext = this.context[CHANNEL_NEXT];
	
	    // If this is a statically-styled component, we don't need to the theme
	    // to generate or build styles.
	    if (componentStyle.isStatic) {
	      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
	      this.setState({ generatedClassName: generatedClassName });
	      // If there is a theme in the context, subscribe to the event emitter. This
	      // is necessary due to pure components blocking context updates, this circumvents
	      // that by updating when an event is emitted
	    } else if (styledContext !== undefined) {
	      var subscribe = styledContext.subscribe;
	
	      this.unsubscribeId = subscribe(function (nextTheme) {
	        // This will be called once immediately
	        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
	
	        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
	
	        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
	      });
	    } else {
	      // eslint-disable-next-line react/prop-types
	      var theme = this.props.theme || EMPTY_OBJECT;
	      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
	      this.setState({ theme: theme, generatedClassName: _generatedClassName });
	    }
	  };
	
	  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this3 = this;
	
	    // If this is a statically-styled component, we don't need to listen to
	    // props changes to update styles
	    var componentStyle = this.constructor.componentStyle;
	
	    if (componentStyle.isStatic) {
	      return;
	    }
	
	    this.setState(function (prevState) {
	      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
	      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
	
	      return { theme: theme, generatedClassName: generatedClassName };
	    });
	  };
	
	  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unsubscribeFromContext();
	  };
	
	  BaseStyledComponent.prototype.render = function render() {
	    // eslint-disable-next-line react/prop-types
	    var innerRef = this.props.innerRef;
	    var generatedClassName = this.state.generatedClassName;
	    var _constructor2 = this.constructor,
	        styledComponentId = _constructor2.styledComponentId,
	        target = _constructor2.target;
	
	
	    var isTargetTag = isTag(target);
	
	    var className = [
	    // eslint-disable-next-line react/prop-types
	    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');
	
	    var baseProps = _extends({}, this.attrs, {
	      className: className
	    });
	
	    if (isStyledComponent(target)) {
	      baseProps.innerRef = innerRef;
	    } else {
	      baseProps.ref = innerRef;
	    }
	
	    var propsForElement = baseProps;
	    var key = void 0;
	
	    for (key in this.props) {
	      // Don't pass through non HTML tags through to HTML elements
	      // always omit innerRef
	      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
	        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
	      }
	    }
	
	    return React.createElement(target, propsForElement);
	  };
	
	  return BaseStyledComponent;
	}(React.Component);
	
	var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
	  var createStyledComponent = function createStyledComponent(target, options, rules) {
	    var _options$isClass = options.isClass,
	        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
	        _options$displayName = options.displayName,
	        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
	        _options$componentId = options.componentId,
	        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
	        _options$ParentCompon = options.ParentComponent,
	        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
	        extendingRules = options.rules,
	        attrs = options.attrs;
	
	
	    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
	
	    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
	
	    var StyledComponent = function (_ParentComponent) {
	      inherits(StyledComponent, _ParentComponent);
	
	      function StyledComponent() {
	        classCallCheck(this, StyledComponent);
	        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
	      }
	
	      StyledComponent.withComponent = function withComponent(tag) {
	        var previousComponentId = options.componentId,
	            optionsToCopy = objectWithoutProperties(options, ['componentId']);
	
	
	        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));
	
	        var newOptions = _extends({}, optionsToCopy, {
	          componentId: newComponentId,
	          ParentComponent: StyledComponent
	        });
	
	        return createStyledComponent(tag, newOptions, rules);
	      };
	
	      createClass(StyledComponent, null, [{
	        key: 'extend',
	        get: function get$$1() {
	          var rulesFromOptions = options.rules,
	              parentComponentId = options.componentId,
	              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);
	
	
	          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
	
	          var newOptions = _extends({}, optionsToCopy, {
	            rules: newRules,
	            parentComponentId: parentComponentId,
	            ParentComponent: StyledComponent
	          });
	
	          warnExtendDeprecated();
	
	          return constructWithOptions(createStyledComponent, target, newOptions);
	        }
	      }]);
	      return StyledComponent;
	    }(ParentComponent);
	
	    StyledComponent.attrs = attrs;
	    StyledComponent.componentStyle = componentStyle;
	    StyledComponent.contextTypes = modifiedContextShape;
	    StyledComponent.displayName = displayName;
	    StyledComponent.styledComponentId = styledComponentId;
	    StyledComponent.target = target;
	
	
	    if (false) {
	      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
	    }
	
	    if (isClass) {
	      hoistStatics(StyledComponent, target, {
	        // all SC-specific things should not be hoisted
	        attrs: true,
	        componentStyle: true,
	        displayName: true,
	        extend: true,
	        styledComponentId: true,
	        target: true,
	        warnTooManyClasses: true,
	        withComponent: true
	      });
	    }
	
	    return StyledComponent;
	  };
	
	  return createStyledComponent;
	});
	
	// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
	function murmurhash(str) {
	  var l = str.length | 0,
	      h = l | 0,
	      i = 0,
	      k;
	
	  while (l >= 4) {
	    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
	
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	    k ^= k >>> 24;
	    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	
	    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
	
	    l -= 4;
	    ++i;
	  }
	
	  switch (l) {
	    case 3:
	      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
	    case 2:
	      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
	    case 1:
	      h ^= str.charCodeAt(i) & 0xff;
	      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  }
	
	  h ^= h >>> 13;
	  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
	  h ^= h >>> 15;
	
	  return h >>> 0;
	}
	
	// 
	
	var areStylesCacheable = IS_BROWSER;
	
	var isStaticRules = function isStaticRules(rules, attrs) {
	  for (var i = 0, len = rules.length; i < len; i += 1) {
	    var rule = rules[i];
	
	    // recursive case
	    if (Array.isArray(rule) && !isStaticRules(rule)) {
	      return false;
	    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
	      // functions are allowed to be static if they're just being
	      // used to get the classname of a nested styled component
	      return false;
	    }
	  }
	
	  if (attrs !== undefined) {
	    // eslint-disable-next-line guard-for-in, no-restricted-syntax
	    for (var key in attrs) {
	      if (typeof attrs[key] === 'function') {
	        return false;
	      }
	    }
	  }
	
	  return true;
	};
	
	var isHMREnabled = typeof module !== 'undefined' && module.hot && ("production") !== 'production';
	
	/*
	 ComponentStyle is all the CSS-specific stuff, not
	 the React-specific stuff.
	 */
	var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
	  /* combines hashStr (murmurhash) and nameGenerator for convenience */
	  var generateRuleHash = function generateRuleHash(str) {
	    return nameGenerator(murmurhash(str));
	  };
	
	  var ComponentStyle = function () {
	    function ComponentStyle(rules, attrs, componentId) {
	      classCallCheck(this, ComponentStyle);
	
	      this.rules = rules;
	      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
	      this.componentId = componentId;
	
	      if (!StyleSheet.master.hasId(componentId)) {
	        var placeholder =  false ? ['.' + componentId + ' {}'] : [];
	
	        StyleSheet.master.deferredInject(componentId, placeholder);
	      }
	    }
	
	    /*
	     * Flattens a rule set into valid CSS
	     * Hashes it, wraps the whole chunk in a .hash1234 {}
	     * Returns the hash to be injected on render()
	     * */
	
	
	    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
	      var isStatic = this.isStatic,
	          componentId = this.componentId,
	          lastClassName = this.lastClassName;
	
	      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
	        return lastClassName;
	      }
	
	      var flatCSS = flatten(this.rules, executionContext);
	      var name = generateRuleHash(this.componentId + flatCSS.join(''));
	
	      if (!styleSheet.hasNameForId(componentId, name)) {
	        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
	      }
	
	      this.lastClassName = name;
	      return name;
	    };
	
	    ComponentStyle.generateName = function generateName(str) {
	      return generateRuleHash(str);
	    };
	
	    return ComponentStyle;
	  }();
	
	  return ComponentStyle;
	});
	
	// 
	// Thanks to ReactDOMFactories for this handy list!
	
	var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',
	
	// SVG
	'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];
	
	// 
	
	var _styled = (function (styledComponent, constructWithOptions) {
	  var styled = function styled(tag) {
	    return constructWithOptions(styledComponent, tag);
	  };
	
	  // Shorthands for all valid HTML Elements
	  domElements.forEach(function (domElement) {
	    styled[domElement] = styled(domElement);
	  });
	
	  return styled;
	});
	
	// 
	
	var replaceWhitespace = function replaceWhitespace(str) {
	  return str.replace(/\s|\\n/g, '');
	};
	
	var _keyframes = (function (nameGenerator, stringifyRules, css) {
	  return function () {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
	    var id = 'sc-keyframes-' + name;
	
	    if (!styleSheet.hasNameForId(id, name)) {
	      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
	    }
	
	    return name;
	  };
	});
	
	// 
	
	var _injectGlobal = (function (stringifyRules, css) {
	  var injectGlobal = function injectGlobal() {
	    var styleSheet = StyleSheet.master;
	    var rules = css.apply(undefined, arguments);
	    var hash = murmurhash(JSON.stringify(rules));
	    var id = 'sc-global-' + hash;
	
	    if (!styleSheet.hasId(id)) {
	      styleSheet.inject(id, stringifyRules(rules));
	    }
	  };
	
	  return injectGlobal;
	});
	
	// 
	
	var _constructWithOptions = (function (css) {
	  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;
	
	    if (!reactIs.isValidElementType(tag)) {
	      throw new StyledComponentsError(1, String(tag));
	    }
	
	    /* This is callable directly as a template function */
	    // $FlowFixMe: Not typed to avoid destructuring arguments
	    var templateFunction = function templateFunction() {
	      return componentConstructor(tag, options, css.apply(undefined, arguments));
	    };
	
	    /* If config methods are called, wrap up a new template function and merge options */
	    templateFunction.withConfig = function (config) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
	    };
	    templateFunction.attrs = function (attrs) {
	      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
	        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
	      }));
	    };
	
	    return templateFunction;
	  };
	
	  return constructWithOptions;
	});
	
	// 
	
	var withTheme = (function (Component) {
	  var isStatelessFunctionalComponent = typeof Component === 'function' &&
	  // $FlowFixMe TODO: flow for prototype
	  !(Component.prototype && 'isReactComponent' in Component.prototype);
	
	  // NOTE: We can't pass a ref to a stateless functional component
	  var shouldSetInnerRef = isStyledComponent(Component) || isStatelessFunctionalComponent;
	
	  var WithTheme = function (_React$Component) {
	    inherits(WithTheme, _React$Component);
	
	    function WithTheme() {
	      var _temp, _this, _ret;
	
	      classCallCheck(this, WithTheme);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
	    }
	
	    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
	
	
	    WithTheme.prototype.componentWillMount = function componentWillMount() {
	      var _this2 = this;
	
	      var defaultProps = this.constructor.defaultProps;
	
	      var styledContext = this.context[CHANNEL_NEXT];
	      var themeProp = determineTheme(this.props, undefined, defaultProps);
	      if (styledContext === undefined && themeProp === undefined && ("production") !== 'production') {
	        // eslint-disable-next-line no-console
	        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
	      } else if (styledContext === undefined && themeProp !== undefined) {
	        this.setState({ theme: themeProp });
	      } else {
	        var subscribe = styledContext.subscribe;
	
	        this.unsubscribeId = subscribe(function (nextTheme) {
	          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
	          _this2.setState({ theme: theme });
	        });
	      }
	    };
	
	    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var defaultProps = this.constructor.defaultProps;
	
	      this.setState(function (oldState) {
	        var theme = determineTheme(nextProps, oldState.theme, defaultProps);
	
	        return { theme: theme };
	      });
	    };
	
	    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    WithTheme.prototype.render = function render() {
	      var props = _extends({
	        theme: this.state.theme
	      }, this.props);
	
	      if (!shouldSetInnerRef) {
	        props.ref = props.innerRef;
	        delete props.innerRef;
	      }
	
	      return React__default.createElement(Component, props);
	    };
	
	    return WithTheme;
	  }(React__default.Component);
	
	  WithTheme.contextTypes = contextShape;
	  WithTheme.displayName = 'WithTheme(' + getComponentName(Component) + ')';
	  WithTheme.styledComponentId = 'withTheme';
	
	
	  return hoistStatics(WithTheme, Component);
	});
	
	// 
	
	/* eslint-disable */
	var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
	  StyleSheet: StyleSheet
	};
	
	// 
	
	/* Warning if you've imported this file on React Native */
	if (false) {
	  // eslint-disable-next-line no-console
	  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
	}
	
	/* Warning if there are several instances of styled-components */
	if (false) {
	  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;
	
	  if (window['__styled-components-init__'] === 1) {
	    // eslint-disable-next-line no-console
	    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
	  }
	
	  window['__styled-components-init__'] += 1;
	}
	
	/* Instantiate singletons */
	var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
	var constructWithOptions = _constructWithOptions(css);
	var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);
	
	/* Instantiate exported singletons */
	var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
	var injectGlobal = _injectGlobal(stringifyRules, css);
	var styled = _styled(StyledComponent, constructWithOptions);
	
	exports.default = styled;
	exports.css = css;
	exports.keyframes = keyframes;
	exports.injectGlobal = injectGlobal;
	exports.isStyledComponent = isStyledComponent;
	exports.consolidateStreamedStyles = consolidateStreamedStyles;
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.ServerStyleSheet = ServerStyleSheet;
	exports.StyleSheetManager = StyleSheetManager;
	exports.__DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS;
	//# sourceMappingURL=styled-components.browser.cjs.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(16), __webpack_require__(27)(module)))

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {(function (factory) {
		 true ? (module['exports'] = factory()) :
			typeof define === 'function' && define['amd'] ? define(factory()) :
				(window['stylisRuleSheet'] = factory())
	}(function () {
	
		'use strict'
	
		return function (insertRule) {
			var delimiter = '/*|*/'
			var needle = delimiter+'}'
	
			function toSheet (block) {
				if (block)
					try {
						insertRule(block + '}')
					} catch (e) {}
			}
	
			return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
				switch (context) {
					// property
					case 1:
						// @import
						if (depth === 0 && content.charCodeAt(0) === 64)
							return insertRule(content+';'), ''
						break
					// selector
					case 2:
						if (ns === 0)
							return content + delimiter
						break
					// at-rule
					case 3:
						switch (ns) {
							// @font-face, @page
							case 102:
							case 112:
								return insertRule(selectors[0]+content), ''
							default:
								return content + (at === 0 ? delimiter : '')
						}
					case -2:
						content.split(needle).forEach(toSheet)
				}
			}
		}
	}))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)(module)))

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	 *          __        ___
	 *    _____/ /___  __/ (_)____
	 *   / ___/ __/ / / / / / ___/
	 *  (__  ) /_/ /_/ / / (__  )
	 * /____/\__/\__, /_/_/____/
	 *          /____/
	 *
	 * light - weight css preprocessor @licence MIT
	 */
	(function (factory) {/* eslint-disable */
		 true ? (module['exports'] = factory(null)) :
			typeof define === 'function' && define['amd'] ? define(factory(null)) :
				(window['stylis'] = factory(null))
	}(/** @param {*=} options */function factory (options) {/* eslint-disable */
	
		'use strict'
	
		/**
		 * Notes
		 *
		 * The ['<method name>'] pattern is used to support closure compiler
		 * the jsdoc signatures are also used to the same effect
		 *
		 * ----
		 *
		 * int + int + int === n4 [faster]
		 *
		 * vs
		 *
		 * int === n1 && int === n2 && int === n3
		 *
		 * ----
		 *
		 * switch (int) { case ints...} [faster]
		 *
		 * vs
		 *
		 * if (int == 1 && int === 2 ...)
		 *
		 * ----
		 *
		 * The (first*n1 + second*n2 + third*n3) format used in the property parser
		 * is a simple way to hash the sequence of characters
		 * taking into account the index they occur in
		 * since any number of 3 character sequences could produce duplicates.
		 *
		 * On the other hand sequences that are directly tied to the index of the character
		 * resolve a far more accurate measure, it's also faster
		 * to evaluate one condition in a switch statement
		 * than three in an if statement regardless of the added math.
		 *
		 * This allows the vendor prefixer to be both small and fast.
		 */
	
		var nullptn = /^\0+/g /* matches leading null characters */
		var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
		var colonptn = /: */g /* splits animation rules */
		var cursorptn = /zoo|gra/ /* assert cursor varient */
		var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
		var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
		var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
		var elementptn = / *[\0] */g /* selector elements */
		var selectorptn = /,\r+?/g /* splits selectors */
		var andptn = /([\t\r\n ])*\f?&/g /* match & */
		var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
		var invalidptn = /\W+/g /* removes invalid characters from keyframes */
		var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
		var plcholdrptn = /::(place)/g /* match ::placeholder varient */
		var readonlyptn = /:(read-only)/g /* match :read-only varient */
		var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
		var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
		var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
		var whiteptn = /\s{2,}/g /* matches repeating whitespace */
		var pseudoptn = /([^\(])(:+) */g /* pseudo element */
		var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
		var gradientptn = /([\w-]+t\()/g /* match *gradient property */
		var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
		var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
		var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
		var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
		var trimptn = /[ \t]+$/ /* match tail whitspace */
		var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
		var imgsrcptn = /([^-])(image-set\()/
	
		/* vendors */
		var webkit = '-webkit-'
		var moz = '-moz-'
		var ms = '-ms-'
	
		/* character codes */
		var SEMICOLON = 59 /* ; */
		var CLOSEBRACES = 125 /* } */
		var OPENBRACES = 123 /* { */
		var OPENPARENTHESES = 40 /* ( */
		var CLOSEPARENTHESES = 41 /* ) */
		var OPENBRACKET = 91 /* [ */
		var CLOSEBRACKET = 93 /* ] */
		var NEWLINE = 10 /* \n */
		var CARRIAGE = 13 /* \r */
		var TAB = 9 /* \t */
		var AT = 64 /* @ */
		var SPACE = 32 /*   */
		var AND = 38 /* & */
		var DASH = 45 /* - */
		var UNDERSCORE = 95 /* _ */
		var STAR = 42 /* * */
		var COMMA = 44 /* , */
		var COLON = 58 /* : */
		var SINGLEQUOTE = 39 /* ' */
		var DOUBLEQUOTE = 34 /* " */
		var FOWARDSLASH = 47 /* / */
		var GREATERTHAN = 62 /* > */
		var PLUS = 43 /* + */
		var TILDE = 126 /* ~ */
		var NULL = 0 /* \0 */
		var FORMFEED = 12 /* \f */
		var VERTICALTAB = 11 /* \v */
	
		/* special identifiers */
		var KEYFRAME = 107 /* k */
		var MEDIA = 109 /* m */
		var SUPPORTS = 115 /* s */
		var PLACEHOLDER = 112 /* p */
		var READONLY = 111 /* o */
		var IMPORT = 105 /* <at>i */
		var CHARSET = 99 /* <at>c */
		var DOCUMENT = 100 /* <at>d */
		var PAGE = 112 /* <at>p */
	
		var column = 1 /* current column */
		var line = 1 /* current line numebr */
		var pattern = 0 /* :pattern */
	
		var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
		var prefix = 1 /* vendor prefix */
		var escape = 1 /* escape :global() pattern */
		var compress = 0 /* compress output */
		var semicolon = 0 /* no/semicolon option */
		var preserve = 0 /* preserve empty selectors */
	
		/* empty reference */
		var array = []
	
		/* plugins */
		var plugins = []
		var plugged = 0
		var should = null
	
		/* plugin context */
		var POSTS = -2
		var PREPS = -1
		var UNKWN = 0
		var PROPS = 1
		var BLCKS = 2
		var ATRUL = 3
	
		/* plugin newline context */
		var unkwn = 0
	
		/* keyframe animation */
		var keyed = 1
		var key = ''
	
		/* selector namespace */
		var nscopealt = ''
		var nscope = ''
	
		/**
		 * Compile
		 *
		 * @param {Array<string>} parent
		 * @param {Array<string>} current
		 * @param {string} body
		 * @param {number} id
		 * @param {number} depth
		 * @return {string}
		 */
		function compile (parent, current, body, id, depth) {
			var bracket = 0 /* brackets [] */
			var comment = 0 /* comments /* // or /* */
			var parentheses = 0 /* functions () */
			var quote = 0 /* quotes '', "" */
	
			var first = 0 /* first character code */
			var second = 0 /* second character code */
			var code = 0 /* current character code */
			var tail = 0 /* previous character code */
			var trail = 0 /* character before previous code */
			var peak = 0 /* previous non-whitespace code */
	
			var counter = 0 /* count sequence termination */
			var context = 0 /* track current context */
			var atrule = 0 /* track @at-rule context */
			var pseudo = 0 /* track pseudo token index */
			var caret = 0 /* current character index */
			var format = 0 /* control character formating context */
			var insert = 0 /* auto semicolon insertion */
			var invert = 0 /* inverted selector pattern */
			var length = 0 /* generic length address */
			var eof = body.length /* end of file(length) */
			var eol = eof - 1 /* end of file(characters) */
	
			var char = '' /* current character */
			var chars = '' /* current buffer of characters */
			var child = '' /* next buffer of characters */
			var out = '' /* compiled body */
			var children = '' /* compiled children */
			var flat = '' /* compiled leafs */
			var selector /* generic selector address */
			var result /* generic address */
	
			// ...build body
			while (caret < eof) {
				code = body.charCodeAt(caret)
	
				// eof varient
				if (caret === eol) {
					// last character + noop context, add synthetic padding for noop context to terminate
					if (comment + quote + parentheses + bracket !== 0) {
						if (comment !== 0) {
							code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
						}
	
						quote = parentheses = bracket = 0
						eof++
						eol++
					}
				}
	
				if (comment + quote + parentheses + bracket === 0) {
					// eof varient
					if (caret === eol) {
						if (format > 0) {
							chars = chars.replace(formatptn, '')
						}
	
						if (chars.trim().length > 0) {
							switch (code) {
								case SPACE:
								case TAB:
								case SEMICOLON:
								case CARRIAGE:
								case NEWLINE: {
									break
								}
								default: {
									chars += body.charAt(caret)
								}
							}
	
							code = SEMICOLON
						}
					}
	
					// auto semicolon insertion
					if (insert === 1) {
						switch (code) {
							// false flags
							case OPENBRACES:
							case CLOSEBRACES:
							case SEMICOLON:
							case DOUBLEQUOTE:
							case SINGLEQUOTE:
							case OPENPARENTHESES:
							case CLOSEPARENTHESES:
							case COMMA: {
								insert = 0
							}
							// ignore
							case TAB:
							case CARRIAGE:
							case NEWLINE:
							case SPACE: {
								break
							}
							// valid
							default: {
								insert = 0
								length = caret
								first = code
								caret--
								code = SEMICOLON
	
								while (length < eof) {
									switch (body.charCodeAt(length++)) {
										case NEWLINE:
										case CARRIAGE:
										case SEMICOLON: {
											++caret
											code = first
											length = eof
											break
										}
										case COLON: {
											if (format > 0) {
												++caret
												code = first
											}
										}
										case OPENBRACES: {
											length = eof
										}
									}
								}
							}
						}
					}
	
					// token varient
					switch (code) {
						case OPENBRACES: {
							chars = chars.trim()
							first = chars.charCodeAt(0)
							counter = 1
							length = ++caret
	
							while (caret < eof) {
								switch (code = body.charCodeAt(caret)) {
									case OPENBRACES: {
										counter++
										break
									}
									case CLOSEBRACES: {
										counter--
										break
									}
									case FOWARDSLASH: {
										switch (second = body.charCodeAt(caret + 1)) {
											// /*, //
											case STAR:
											case FOWARDSLASH: {
												caret = delimited(second, caret, eol, body)
											}
										}
										break
									}
									// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
									case OPENBRACKET: {
										code++
									}
									// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
									case OPENPARENTHESES: {
										code++
									}
									// quote tail delimiter is identical to the head delimiter hence noop,
									// fallthrough clauses have been shifted to the correct tail delimiter
									case DOUBLEQUOTE:
									case SINGLEQUOTE: {
										while (caret++ < eol) {
											if (body.charCodeAt(caret) === code) {
												break
											}
										}
									}
								}
	
								if (counter === 0) {
									break
								}
	
								caret++
							}
	
							child = body.substring(length, caret)
	
							if (first === NULL) {
								first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
							}
	
							switch (first) {
								// @at-rule
								case AT: {
									if (format > 0) {
										chars = chars.replace(formatptn, '')
									}
	
									second = chars.charCodeAt(1)
	
									switch (second) {
										case DOCUMENT:
										case MEDIA:
										case SUPPORTS:
										case DASH: {
											selector = current
											break
										}
										default: {
											selector = array
										}
									}
	
									child = compile(current, selector, child, second, depth+1)
									length = child.length
	
									// preserve empty @at-rule
									if (preserve > 0 && length === 0) {
										length = chars.length
									}
	
									// execute plugins, @at-rule context
									if (plugged > 0) {
										selector = select(array, chars, invert)
										result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
										chars = selector.join('')
	
										if (result !== void 0) {
											if ((length = (child = result.trim()).length) === 0) {
												second = 0
												child = ''
											}
										}
									}
	
									if (length > 0) {
										switch (second) {
											case SUPPORTS: {
												chars = chars.replace(supportsptn, supports)
											}
											case DOCUMENT:
											case MEDIA:
											case DASH: {
												child = chars + '{' + child + '}'
												break
											}
											case KEYFRAME: {
												chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
												child = chars + '{' + child + '}'
	
												if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
													child = '@' + webkit + child + '@' + child
												} else {
													child = '@' + child
												}
												break
											}
											default: {
												child = chars + child
	
												if (id === PAGE) {
													child = (out += child, '')
												}
											}
										}
									} else {
										child = ''
									}
	
									break
								}
								// selector
								default: {
									child = compile(current, select(current, chars, invert), child, id, depth+1)
								}
							}
	
							children += child
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							atrule = 0
							chars = ''
							child = ''
							code = body.charCodeAt(++caret)
							break
						}
						case CLOSEBRACES:
						case SEMICOLON: {
							chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()
	
							if ((length = chars.length) > 1) {
								// monkey-patch missing colon
								if (pseudo === 0) {
									first = chars.charCodeAt(0)
	
									// first character is a letter or dash, buffer has a space character
									if ((first === DASH || first > 96 && first < 123)) {
										length = (chars = chars.replace(' ', ':')).length
									}
								}
	
								// execute plugins, property context
								if (plugged > 0) {
									if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
										if ((length = (chars = result.trim()).length) === 0) {
											chars = '\0\0'
										}
									}
								}
	
								first = chars.charCodeAt(0)
								second = chars.charCodeAt(1)
	
								switch (first) {
									case NULL: {
										break
									}
									case AT: {
										if (second === IMPORT || second === CHARSET) {
											flat += chars + body.charAt(caret)
											break
										}
									}
									default: {
										if (chars.charCodeAt(length-1) === COLON) {
											break
										}
	
										out += property(chars, first, second, chars.charCodeAt(2))
									}
								}
							}
	
							// reset
							context = 0
							insert = 0
							pseudo = 0
							format = 0
							invert = 0
							chars = ''
							code = body.charCodeAt(++caret)
							break
						}
					}
				}
	
				// parse characters
				switch (code) {
					case CARRIAGE:
					case NEWLINE: {
						// auto insert semicolon
						if (comment + quote + parentheses + bracket + semicolon === 0) {
							// valid non-whitespace characters that
							// may precede a newline
							switch (peak) {
								case CLOSEPARENTHESES:
								case SINGLEQUOTE:
								case DOUBLEQUOTE:
								case AT:
								case TILDE:
								case GREATERTHAN:
								case STAR:
								case PLUS:
								case FOWARDSLASH:
								case DASH:
								case COLON:
								case COMMA:
								case SEMICOLON:
								case OPENBRACES:
								case CLOSEBRACES: {
									break
								}
								default: {
									// current buffer has a colon
									if (pseudo > 0) {
										insert = 1
									}
								}
							}
						}
	
						// terminate line comment
						if (comment === FOWARDSLASH) {
							comment = 0
						} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
							format = 1
							chars += '\0'
						}
	
						// execute plugins, newline context
						if (plugged * unkwn > 0) {
							proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
						}
	
						// next line, reset column position
						column = 1
						line++
						break
					}
					case SEMICOLON:
					case CLOSEBRACES: {
						if (comment + quote + parentheses + bracket === 0) {
							column++
							break
						}
					}
					default: {
						// increment column position
						column++
	
						// current character
						char = body.charAt(caret)
	
						// remove comments, escape functions, strings, attributes and prepare selectors
						switch (code) {
							case TAB:
							case SPACE: {
								if (quote + bracket + comment === 0) {
									switch (tail) {
										case COMMA:
										case COLON:
										case TAB:
										case SPACE: {
											char = ''
											break
										}
										default: {
											if (code !== SPACE) {
												char = ' '
											}
										}
									}
								}
								break
							}
							// escape breaking control characters
							case NULL: {
								char = '\\0'
								break
							}
							case FORMFEED: {
								char = '\\f'
								break
							}
							case VERTICALTAB: {
								char = '\\v'
								break
							}
							// &
							case AND: {
								// inverted selector pattern i.e html &
								if (quote + comment + bracket === 0 && cascade > 0) {
									invert = 1
									format = 1
									char = '\f' + char
								}
								break
							}
							// ::p<l>aceholder, l
							// :read-on<l>y, l
							case 108: {
								if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
									switch (caret - pseudo) {
										// ::placeholder
										case 2: {
											if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
												pattern = tail
											}
										}
										// :read-only
										case 8: {
											if (trail === READONLY) {
												pattern = trail
											}
										}
									}
								}
								break
							}
							// :<pattern>
							case COLON: {
								if (quote + comment + bracket === 0) {
									pseudo = caret
								}
								break
							}
							// selectors
							case COMMA: {
								if (comment + parentheses + quote + bracket === 0) {
									format = 1
									char += '\r'
								}
								break
							}
							// quotes
							case DOUBLEQUOTE:
							case SINGLEQUOTE: {
								if (comment === 0) {
									quote = quote === code ? 0 : (quote === 0 ? code : quote)
								}
								break
							}
							// attributes
							case OPENBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket++
								}
								break
							}
							case CLOSEBRACKET: {
								if (quote + comment + parentheses === 0) {
									bracket--
								}
								break
							}
							// functions
							case CLOSEPARENTHESES: {
								if (quote + comment + bracket === 0) {
									parentheses--
								}
								break
							}
							case OPENPARENTHESES: {
								if (quote + comment + bracket === 0) {
									if (context === 0) {
										switch (tail*2 + trail*3) {
											// :matches
											case 533: {
												break
											}
											// :global, :not, :nth-child etc...
											default: {
												counter = 0
												context = 1
											}
										}
									}
	
									parentheses++
								}
								break
							}
							case AT: {
								if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
									atrule = 1
								}
								break
							}
							// block/line comments
							case STAR:
							case FOWARDSLASH: {
								if (quote + bracket + parentheses > 0) {
									break
								}
	
								switch (comment) {
									// initialize line/block comment context
									case 0: {
										switch (code*2 + body.charCodeAt(caret+1)*3) {
											// //
											case 235: {
												comment = FOWARDSLASH
												break
											}
											// /*
											case 220: {
												length = caret
												comment = STAR
												break
											}
										}
										break
									}
									// end block comment context
									case STAR: {
										if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
											// /*<!> ... */, !
											if (body.charCodeAt(length+2) === 33) {
												out += body.substring(length, caret+1)
											}
											char = ''
											comment = 0
										}
									}
								}
							}
						}
	
						// ignore comment blocks
						if (comment === 0) {
							// aggressive isolation mode, divide each individual selector
							// including selectors in :not function but excluding selectors in :global function
							if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
								switch (code) {
									case COMMA:
									case TILDE:
									case GREATERTHAN:
									case PLUS:
									case CLOSEPARENTHESES:
									case OPENPARENTHESES: {
										if (context === 0) {
											// outside of an isolated context i.e nth-child(<...>)
											switch (tail) {
												case TAB:
												case SPACE:
												case NEWLINE:
												case CARRIAGE: {
													char = char + '\0'
													break
												}
												default: {
													char = '\0' + char + (code === COMMA ? '' : '\0')
												}
											}
											format = 1
										} else {
											// within an isolated context, sleep untill it's terminated
											switch (code) {
												case OPENPARENTHESES: {
													// :globa<l>(
													if (pseudo + 7 === caret && tail === 108) {
														pseudo = 0
													}
													context = ++counter
													break
												}
												case CLOSEPARENTHESES: {
													if ((context = --counter) === 0) {
														format = 1
														char += '\0'
													}
													break
												}
											}
										}
										break
									}
									case TAB:
									case SPACE: {
										switch (tail) {
											case NULL:
											case OPENBRACES:
											case CLOSEBRACES:
											case SEMICOLON:
											case COMMA:
											case FORMFEED:
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												break
											}
											default: {
												// ignore in isolated contexts
												if (context === 0) {
													format = 1
													char += '\0'
												}
											}
										}
									}
								}
							}
	
							// concat buffer of characters
							chars += char
	
							// previous non-whitespace character code
							if (code !== SPACE && code !== TAB) {
								peak = code
							}
						}
					}
				}
	
				// tail character codes
				trail = tail
				tail = code
	
				// visit every character
				caret++
			}
	
			length = out.length
	
			// preserve empty selector
	 		if (preserve > 0) {
	 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
	 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
						length = current.join(',').length + 2
	 				}
	 			}
			}
	
			if (length > 0) {
				// cascade isolation mode?
				selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current
	
				// execute plugins, block context
				if (plugged > 0) {
					result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)
	
					if (result !== void 0 && (out = result).length === 0) {
						return flat + out + children
					}
				}
	
				out = selector.join(',') + '{' + out + '}'
	
				if (prefix*pattern !== 0) {
					if (prefix === 2 && !vendor(out, 2))
						pattern = 0
	
					switch (pattern) {
						// ::read-only
						case READONLY: {
							out = out.replace(readonlyptn, ':'+moz+'$1')+out
							break
						}
						// ::placeholder
						case PLACEHOLDER: {
							out = (
								out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
								out.replace(plcholdrptn, '::' + moz + '$1') +
								out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
							)
							break
						}
					}
	
					pattern = 0
				}
			}
	
			return flat + out + children
		}
	
		/**
		 * Select
		 *
		 * @param {Array<string>} parent
		 * @param {string} current
		 * @param {number} invert
		 * @return {Array<string>}
		 */
		function select (parent, current, invert) {
			var selectors = current.trim().split(selectorptn)
			var out = selectors
	
			var length = selectors.length
			var l = parent.length
	
			switch (l) {
				// 0-1 parent selectors
				case 0:
				case 1: {
					for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
						out[i] = scope(selector, out[i], invert, l).trim()
					}
					break
				}
				// >2 parent selectors, nested
				default: {
					for (var i = 0, j = 0, out = []; i < length; ++i) {
						for (var k = 0; k < l; ++k) {
							out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
						}
					}
				}
			}
	
			return out
		}
	
		/**
		 * Scope
		 *
		 * @param {string} parent
		 * @param {string} current
		 * @param {number} invert
		 * @param {number} level
		 * @return {string}
		 */
		function scope (parent, current, invert, level) {
			var selector = current
			var code = selector.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (selector = selector.trim()).charCodeAt(0)
			}
	
			switch (code) {
				// &
				case AND: {
					switch (cascade + level) {
						case 0:
						case 1: {
							if (parent.trim().length === 0) {
								break
							}
						}
						default: {
							return selector.replace(andptn, '$1'+parent.trim())
						}
					}
					break
				}
				// :
				case COLON: {
					switch (selector.charCodeAt(1)) {
						// g in :global
						case 103: {
							if (escape > 0 && cascade > 0) {
								return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
							}
							break
						}
						default: {
							// :hover
							return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
						}
					}
				}
				default: {
					// html &
					if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
						return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
					}
				}
			}
	
			return parent + selector
		}
	
		/**
		 * Property
		 *
		 * @param {string} input
		 * @param {number} first
		 * @param {number} second
		 * @param {number} third
		 * @return {string}
		 */
		function property (input, first, second, third) {
			var index = 0
			var out = input + ';'
			var hash = (first*2) + (second*3) + (third*4)
			var cache
	
			// animation: a, n, i characters
			if (hash === 944) {
				return animation(out)
			} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
				return out
			}
	
			// vendor prefix
			switch (hash) {
				// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
				case 1015: {
					// text-shadow/text-align/text-transform, a
					return out.charCodeAt(10) === 97 ? webkit + out + out : out
				}
				// filter/fill f, i, l
				case 951: {
					// filter, t
					return out.charCodeAt(3) === 116 ? webkit + out + out : out
				}
				// color/column, c, o, l
				case 963: {
					// column, n
					return out.charCodeAt(5) === 110 ? webkit + out + out : out
				}
				// box-decoration-break, b, o, x
				case 1009: {
					if (out.charCodeAt(4) !== 100) {
						break
					}
				}
				// mask, m, a, s
				// clip-path, c, l, i
				case 969:
				case 942: {
					return webkit + out + out
				}
				// appearance: a, p, p
				case 978: {
					return webkit + out + moz + out + out
				}
				// hyphens: h, y, p
				// user-select: u, s, e
				case 1019:
				case 983: {
					return webkit + out + moz + out + ms + out + out
				}
				// background/backface-visibility, b, a, c
				case 883: {
					// backface-visibility, -
					if (out.charCodeAt(8) === DASH) {
						return webkit + out + out
					}
	
					// image-set(...)
					if (out.indexOf('image-set(', 11) > 0) {
						return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
					}
	
					return out
				}
				// flex: f, l, e
				case 932: {
					if (out.charCodeAt(4) === DASH) {
						switch (out.charCodeAt(5)) {
							// flex-grow, g
							case 103: {
								return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
							}
							// flex-shrink, s
							case 115: {
								return webkit + out + ms + out.replace('shrink', 'negative') + out
							}
							// flex-basis, b
							case 98: {
								return webkit + out + ms + out.replace('basis', 'preferred-size') + out
							}
						}
					}
	
					return webkit + out + ms + out + out
				}
				// order: o, r, d
				case 964: {
					return webkit + out + ms + 'flex' + '-' + out + out
				}
				// justify-items/justify-content, j, u, s
				case 1023: {
					// justify-content, c
					if (out.charCodeAt(8) !== 99) {
						break
					}
	
					cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
					return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
				}
				// cursor, c, u, r
				case 1005: {
					return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
				}
				// writing-mode, w, r, i
				case 1000: {
					cache = out.substring(13).trim()
					index = cache.indexOf('-') + 1
	
					switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
						// vertical-lr
						case 226: {
							cache = out.replace(writingptn, 'tb')
							break
						}
						// vertical-rl
						case 232: {
							cache = out.replace(writingptn, 'tb-rl')
							break
						}
						// horizontal-tb
						case 220: {
							cache = out.replace(writingptn, 'lr')
							break
						}
						default: {
							return out
						}
					}
	
					return webkit + out + ms + cache + out
				}
				// position: sticky
				case 1017: {
					if (out.indexOf('sticky', 9) === -1) {
						return out
					}
				}
				// display(flex/inline-flex/inline-box): d, i, s
				case 975: {
					index = (out = input).length - 10
					cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()
	
					switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
						// inline-
						case 203: {
							// inline-box
							if (cache.charCodeAt(8) < 111) {
								break
							}
						}
						// inline-box/sticky
						case 115: {
							out = out.replace(cache, webkit+cache)+';'+out
							break
						}
						// inline-flex
						// flex
						case 207:
						case 102: {
							out = (
								out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
								out.replace(cache, webkit+cache)+';'+
								out.replace(cache, ms+cache+'box')+';'+
								out
							)
						}
					}
	
					return out + ';'
				}
				// align-items, align-center, align-self: a, l, i, -
				case 938: {
					if (out.charCodeAt(5) === DASH) {
						switch (out.charCodeAt(6)) {
							// align-items, i
							case 105: {
								cache = out.replace('-items', '')
								return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
							}
							// align-self, s
							case 115: {
								return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
							}
							// align-content
							default: {
								return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
							}
						}
					}
					break
				}
				// min/max
				case 973:
				case 989: {
					// min-/max- height/width/block-size/inline-size
					if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
						break
					}
				}
				// height/width: min-content / width: max-content
				case 931:
				case 953: {
					if (dimensionptn.test(input) === true) {
						// stretch
						if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
							return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
						else
							return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
					}
					break
				}
				// transform, transition: t, r, a
				case 962: {
					out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out
	
					// transitions
					if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
						return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
					}
	
					break
				}
			}
	
			return out
		}
	
		/**
		 * Vendor
		 *
		 * @param {string} content
		 * @param {number} context
		 * @return {boolean}
		 */
		function vendor (content, context) {
			var index = content.indexOf(context === 1 ? ':' : '{')
			var key = content.substring(0, context !== 3 ? index : 10)
			var value = content.substring(index + 1, content.length - 1)
	
			return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
		}
	
		/**
		 * Supports
		 *
		 * @param {string} match
		 * @param {string} group
		 * @return {string}
		 */
		function supports (match, group) {
			var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))
	
			return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
		}
	
		/**
		 * Animation
		 *
		 * @param {string} input
		 * @return {string}
		 */
		function animation (input) {
			var length = input.length
			var index = input.indexOf(':', 9) + 1
			var declare = input.substring(0, index).trim()
			var out = input.substring(index, length-1).trim()
	
			switch (input.charCodeAt(9)*keyed) {
				case 0: {
					break
				}
				// animation-*, -
				case DASH: {
					// animation-name, n
					if (input.charCodeAt(10) !== 110) {
						break
					}
				}
				// animation/animation-name
				default: {
					// split in case of multiple animations
					var list = out.split((out = '', animationptn))
	
					for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
						var value = list[i]
						var items = value.split(propertiesptn)
	
						while (value = items[index]) {
							var peak = value.charCodeAt(0)
	
							if (keyed === 1 && (
								// letters
								(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
								// dash but not in sequence i.e --
								(peak === DASH && value.charCodeAt(1) !== DASH)
							)) {
								// not a number/function
								switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
									case 1: {
										switch (value) {
											// not a valid reserved keyword
											case 'infinite': case 'alternate': case 'backwards': case 'running':
											case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
											case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
											case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
											case 'initial': case 'unset': case 'step-start': case 'step-end': {
												break
											}
											default: {
												value += key
											}
										}
									}
								}
							}
	
							items[index++] = value
						}
	
						out += (i === 0 ? '' : ',') + items.join(' ')
					}
				}
			}
	
			out = declare + out + ';'
	
			if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
				return webkit + out + out
	
			return out
		}
	
		/**
		 * Isolate
		 *
		 * @param {Array<string>} current
		 */
		function isolate (current) {
			for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
				// split individual elements in a selector i.e h1 h2 === [h1, h2]
				var elements = current[i].split(elementptn)
				var out = ''
	
				for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
					// empty element
					if ((size = (element = elements[j]).length) === 0 && l > 1) {
						continue
					}
	
					tail = out.charCodeAt(out.length-1)
					code = element.charCodeAt(0)
					padding = ''
	
					if (j !== 0) {
						// determine if we need padding
						switch (tail) {
							case STAR:
							case TILDE:
							case GREATERTHAN:
							case PLUS:
							case SPACE:
							case OPENPARENTHESES:  {
								break
							}
							default: {
								padding = ' '
							}
						}
					}
	
					switch (code) {
						case AND: {
							element = padding + nscopealt
						}
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case CLOSEPARENTHESES:
						case OPENPARENTHESES: {
							break
						}
						case OPENBRACKET: {
							element = padding + element + nscopealt
							break
						}
						case COLON: {
							switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
								// :global
								case 530: {
									if (escape > 0) {
										element = padding + element.substring(8, size - 1)
										break
									}
								}
								// :hover, :nth-child(), ...
								default: {
									if (j < 1 || elements[j-1].length < 1) {
										element = padding + nscopealt + element
									}
								}
							}
							break
						}
						case COMMA: {
							padding = ''
						}
						default: {
							if (size > 1 && element.indexOf(':') > 0) {
								element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
							} else {
								element = padding + element + nscopealt
							}
						}
					}
	
					out += element
				}
	
				selector[i] = out.replace(formatptn, '').trim()
			}
	
			return selector
		}
	
		/**
		 * Proxy
		 *
		 * @param {number} context
		 * @param {string} content
		 * @param {Array<string>} selectors
		 * @param {Array<string>} parents
		 * @param {number} line
		 * @param {number} column
		 * @param {number} length
		 * @param {number} id
		 * @param {number} depth
		 * @param {number} at
		 * @return {(string|void|*)}
		 */
		function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
			for (var i = 0, out = content, next; i < plugged; ++i) {
				switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
					case void 0:
					case false:
					case true:
					case null: {
						break
					}
					default: {
						out = next
					}
				}
			}
			if (out !== content) {
			  return out
			}
		}
	
		/**
		 * @param {number} code
		 * @param {number} index
		 * @param {number} length
		 * @param {string} body
		 * @return {number}
		 */
		function delimited (code, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					// /*
					case FOWARDSLASH: {
						if (code === STAR) {
							if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
								return i + 1
							}
						}
						break
					}
					// //
					case NEWLINE: {
						if (code === FOWARDSLASH) {
							return i + 1
						}
					}
				}
			}
	
			return i
		}
	
		/**
		 * @param {number} type
		 * @param {number} index
		 * @param {number} length
		 * @param {number} find
		 * @param {string} body
		 * @return {number}
		 */
		function match (type, index, length, body) {
			for (var i = index + 1; i < length; ++i) {
				switch (body.charCodeAt(i)) {
					case type: {
						return i
					}
				}
			}
	
			return i
		}
	
		/**
		 * Minify
		 *
		 * @param {(string|*)} output
		 * @return {string}
		 */
		function minify (output) {
			return output
				.replace(formatptn, '')
				.replace(beforeptn, '')
				.replace(afterptn, '$1')
				.replace(tailptn, '$1')
				.replace(whiteptn, ' ')
		}
	
		/**
		 * Use
		 *
		 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
		 */
		function use (plugin) {
			switch (plugin) {
				case void 0:
				case null: {
					plugged = plugins.length = 0
					break
				}
				default: {
					if (typeof plugin === 'function') {
						plugins[plugged++] = plugin
					}	else if (typeof plugin === 'object') {
						for (var i = 0, length = plugin.length; i < length; ++i) {
							use(plugin[i])
						}
					} else {
						unkwn = !!plugin|0
					}
				}
	 		}
	
	 		return use
		}
	
		/**
		 * Set
		 *
		 * @param {*} options
		 */
		function set (options) {
			for (var name in options) {
				var value = options[name]
				switch (name) {
					case 'keyframe': keyed = value|0; break
					case 'global': escape = value|0; break
					case 'cascade': cascade = value|0; break
					case 'compress': compress = value|0; break
					case 'semicolon': semicolon = value|0; break
					case 'preserve': preserve = value|0; break
					case 'prefix':
						should = null
	
						if (!value) {
							prefix = 0
						} else if (typeof value !== 'function') {
							prefix = 1
						} else {
							prefix = 2
							should = value
						}
				}
			}
	
			return set
		}
	
		/**
		 * Stylis
		 *
		 * @param {string} selector
		 * @param {string} input
		 * @return {*}
		 */
		function stylis (selector, input) {
			if (this !== void 0 && this.constructor === stylis) {
				return factory(selector)
			}
	
			// setup
			var ns = selector
			var code = ns.charCodeAt(0)
	
			// trim leading whitespace
			if (code < 33) {
				code = (ns = ns.trim()).charCodeAt(0)
			}
	
			// keyframe/animation namespace
			if (keyed > 0) {
				key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
			}
	
			// reset, used to assert if a plugin is moneky-patching the return value
			code = 1
	
			// cascade/isolate
			if (cascade === 1) {
				nscope = ns
			} else {
				nscopealt = ns
			}
	
			var selectors = [nscope]
			var result
	
			// execute plugins, pre-process context
			if (plugged > 0) {
				result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)
	
				if (result !== void 0 && typeof result === 'string') {
					input = result
				}
			}
	
			// build
			var output = compile(array, selectors, input, 0, 0)
	
			// execute plugins, post-process context
			if (plugged > 0) {
				result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)
	
				// bypass minification
				if (result !== void 0 && typeof(output = result) !== 'string') {
					code = 0
				}
			}
	
			// reset
			key = ''
			nscope = ''
			nscopealt = ''
			pattern = 0
			line = 1
			column = 1
	
			return compress*code === 0 ? output : minify(output)
		}
	
		stylis['use'] = use
		stylis['set'] = set
	
		if (options !== void 0) {
			set(options)
		}
	
		return stylis
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)(module)))

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: fixed;\n\n  width: 100%;\n  height: 100%;\n'], ['\n  position: fixed;\n\n  width: 100%;\n  height: 100%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Stars = __webpack_require__(220);
	
	var _Stars2 = _interopRequireDefault(_Stars);
	
	var _Name = __webpack_require__(84);
	
	var _Name2 = _interopRequireDefault(_Name);
	
	var _Canvas = __webpack_require__(215);
	
	var _Canvas2 = _interopRequireDefault(_Canvas);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Background = function Background() {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(_Stars2.default, null),
	    _react2.default.createElement(_Canvas2.default, null)
	  );
	};
	
	exports.default = Background;
	module.exports = exports['default'];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _matter = __webpack_require__(226);
	
	var _matter2 = _interopRequireDefault(_matter);
	
	var _preload = __webpack_require__(227);
	
	var _preload2 = _interopRequireDefault(_preload);
	
	var _shuffle = __webpack_require__(228);
	
	var _shuffle2 = _interopRequireDefault(_shuffle);
	
	var _images = __webpack_require__(225);
	
	var _images2 = _interopRequireDefault(_images);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// const Container = styled.div`
	//   position: fixed;
	//   bottom: 7.6388888889%;
	
	//   display: inline-flex;
	//   justify-content: space-between;
	//   width: 100%;
	//   padding: 0 56px;
	//   padding: 0 4.59% @media (max-width: 760px) {
	//     display: inline-block;
	//   }
	// `
	
	var MAX_IMAGES = 8;
	
	var Canvas = function (_Component) {
	  _inherits(Canvas, _Component);
	
	  function Canvas() {
	    _classCallCheck(this, Canvas);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.componentDidMount = function () {
	      var element = document.querySelector('.canvas');
	
	      _this.matter = new _matter2.default({
	        element: element,
	        width: window.innerWidth,
	        height: window.innerHeight,
	        gravity: { x: 0, y: -0.1 },
	        hasBounds: false,
	        onUpdate: function onUpdate() {
	          return _this.onRenderUpdate();
	        }
	      });
	      _this.preloadImages();
	      _this.addBounds();
	      _this.createImages();
	
	      // // events
	      window.addEventListener('resize', _this.onResize.bind(_this), false);
	    };
	
	    _this.images = (0, _shuffle2.default)(_images2.default);
	    _this.bodies = [];
	    _this.bounds = [];
	    return _this;
	  }
	
	  Canvas.prototype.preloadImages = function preloadImages() {
	    this.images.forEach(function (_ref) {
	      var url = _ref.url;
	
	      (0, _preload2.default)(url).catch(function () {
	        console.log('error loading ' + url);
	      });
	    });
	  };
	
	  Canvas.prototype.addBounds = function addBounds() {
	    var height = window.innerHeight * 3;
	    var mid = height / 2;
	    var options = { isStatic: true };
	    this.bounds.push(this.matter.addRectangle(window.innerWidth + 25, mid, 50, height, options));
	    this.bounds.push(this.matter.addRectangle(-25, mid, 50, height, options));
	  };
	
	  Canvas.prototype.addImage = function addImage() {
	    var isNew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    var _images$ = this.images[0],
	        url = _images$.url,
	        width = _images$.width,
	        height = _images$.height;
	
	    var isSmall = window.innerWidth < 800;
	    var scale = isSmall ? 1 : 1;
	    var x = window.innerWidth * Math.random();
	    var y = window.innerHeight * (isNew ? Math.random() + 1 : 1.5);
	    var body = this.matter.addRectangle(x, y, width * scale, height * scale, {
	      render: {
	        sprite: {
	          texture: url,
	          xScale: scale,
	          yScale: scale
	        }
	      }
	    });
	
	    this.matter.applyForce(body, { x: x + (Math.random() - Math.random()) * 20, y: y + 10 }, {
	      x: (Math.random() - Math.random()) * 0.5,
	      y: -Math.random() * (isSmall ? 0.1 : 0.3)
	    });
	    this.bodies.push(body);
	    this.images.push(this.images.shift());
	  };
	
	  Canvas.prototype.createImages = function createImages() {
	    for (var i = 0; i < MAX_IMAGES; i++) {
	      this.addImage(true);
	    }
	  };
	
	  Canvas.prototype.onRenderUpdate = function onRenderUpdate() {
	    var _this2 = this;
	
	    this.bodies.forEach(function (body, i) {
	      var _body$position = body.position,
	          x = _body$position.x,
	          y = _body$position.y;
	
	      if (y < -200) {
	        var old = _this2.bodies.splice(i, 1)[0];
	        _this2.matter.removeBody(old);
	        _this2.addImage();
	      }
	    });
	  };
	
	  Canvas.prototype.onResize = function onResize() {
	    var _this3 = this;
	
	    this.bounds.forEach(function (bound) {
	      _this3.matter.removeBody(bound);
	    });
	    this.bodies.forEach(function (body) {
	      _this3.matter.removeBody(body);
	    });
	    this.bounds = [];
	    this.bodies = [];
	    this.matter.resize(window.innerWidth, window.innerHeight);
	    this.addBounds();
	    this.createImages();
	  };
	
	  Canvas.prototype.render = function render() {
	    return _react2.default.createElement('div', { className: 'canvas', style: { display: 'flex' } });
	  };
	
	  return Canvas;
	}(_react.Component);
	
	exports.default = Canvas;
	module.exports = exports['default'];

/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  z-index: 5;\n\n  bottom: 7.6388888889%;\n\n  display: none;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 56px;\n  padding: 0 4.59%;\n\n  @media (min-width: 992px) {\n    display: inline-flex;\n  }\n'], ['\n  position: fixed;\n  z-index: 5;\n\n  bottom: 7.6388888889%;\n\n  display: none;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0 56px;\n  padding: 0 4.59%;\n\n  @media (min-width: 992px) {\n    display: inline-flex;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Socials = __webpack_require__(219);
	
	var _Socials2 = _interopRequireDefault(_Socials);
	
	var _MadeBy = __webpack_require__(218);
	
	var _MadeBy2 = _interopRequireDefault(_MadeBy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(_Socials2.default, null),
	    _react2.default.createElement(_MadeBy2.default, null)
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: 12px;\n  line-height: 16px;\n\n  > a {\n    text-decoration: none;\n  }\n'], ['\n  font-size: 12px;\n  line-height: 16px;\n\n  > a {\n    text-decoration: none;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.p(_templateObject);
	
	var MadeBy = function MadeBy() {
	  return _react2.default.createElement(
	    Container,
	    null,
	    'Design made with love by\xA0',
	    _react2.default.createElement(
	      'a',
	      { href: 'http://fabienlaborie.com/', target: '_blank' },
	      'www.fabienlaborie.com'
	    )
	  );
	};
	
	exports.default = MadeBy;
	module.exports = exports['default'];

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  100% { background-position: 0 -384px; }\n'], ['\n  100% { background-position: 0 -384px; }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  100% { background-position: 0 calc(-384px / 2); }\n'], ['\n  100% { background-position: 0 calc(-384px / 2); }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  left: 50%;\n  top: 50%;\n\n  margin: 0;\n  width: 768px;\n  height: 128px;\n\n  background: url(', ') no-repeat;\n  background-size: cover;\n\n  animation: ', ' 0.52s steps(3) infinite;\n  backface-visibility: hidden;\n  perspective: 1000;\n\n  transform: translate(-50%, -50%);\n\n  @media (max-width: 700px) {\n    width: calc(768px / 2);\n    height: calc(128px / 2);\n\n    animation: ', ' 0.52s steps(3) infinite;\n  }\n'], ['\n  position: fixed;\n  left: 50%;\n  top: 50%;\n\n  margin: 0;\n  width: 768px;\n  height: 128px;\n\n  background: url(', ') no-repeat;\n  background-size: cover;\n\n  animation: ', ' 0.52s steps(3) infinite;\n  backface-visibility: hidden;\n  perspective: 1000;\n\n  transform: translate(-50%, -50%);\n\n  @media (max-width: 700px) {\n    width: calc(768px / 2);\n    height: calc(128px / 2);\n\n    animation: ', ' 0.52s steps(3) infinite;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var logo = (0, _gatsbyLink.withPrefix)('/images/p.svg');
	
	var nameAnimation = (0, _styledComponents.keyframes)(_templateObject);
	
	var nameAnimationMobile = (0, _styledComponents.keyframes)(_templateObject2);
	
	var Logo = _styledComponents2.default.div(_templateObject3, logo, nameAnimation, nameAnimationMobile);
	
	var Name = function Name() {
	  return _react2.default.createElement(Logo, { title: 'Maxime Beaudoin', role: 'img', 'aria-label': 'Maxime Beaudoin' });
	};
	
	exports.default = Name;
	module.exports = exports['default'];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: 24px;\n  line-height: 32px;\n\n  > a {\n    margin-left: 20px;\n\n    text-decoration: none;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n\n  @media (max-width: 760px) {\n    font-size: 20px;\n  }\n'], ['\n  font-size: 24px;\n  line-height: 32px;\n\n  > a {\n    margin-left: 20px;\n\n    text-decoration: none;\n\n    &:first-child {\n      margin-left: 0;\n    }\n  }\n\n  @media (max-width: 760px) {\n    font-size: 20px;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.nav(_templateObject);
	
	var Socials = function Socials() {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'mailto:maxim.beaudoin@gmail.com' },
	      'Mail'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://github.com/maxisix', target: '_blank' },
	      'Github'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://medium.com/@maximebeaudoin', target: '_blank' },
	      'Medium'
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'https://www.linkedin.com/in/mabeaudoin/', target: '_blank' },
	      'LinkedIn'
	    )
	  );
	};
	
	exports.default = Socials;
	module.exports = exports['default'];

/***/ }),

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n    0%,100% { opacity: 0 }\n    50% { opacity: 1 }\n'], ['\n    0%,100% { opacity: 0 }\n    50% { opacity: 1 }\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n    45% {\n        opacity: 0;\n    }\n    50% {\n        opacity: 1;\n    }\n    55% {\n        opacity: 0;\n    }\n'], ['\n    45% {\n        opacity: 0;\n    }\n    50% {\n        opacity: 1;\n    }\n    55% {\n        opacity: 0;\n    }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: fixed;\n  top: 0;\n  left: 0;\n\n  width: 100vw;\n  height: 100vh;\n\n  > div {\n    position: absolute;\n\n    opacity: 1;\n    //animation: ', ' 2s infinite;\n  }\n\n  .hide {\n    opacity: 0;\n  }\n\n  .star1 {\n    top: calc(532 / 720 * 100%);\n    left: calc(56 / 1440 * 100%);\n\n\n    //animation: ', ' 0.8s linear infinite;\n  }\n  .star2 {\n    top: calc(41 / 720 * 100%);\n    left: calc(141 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star3 {\n    top: calc(597 / 720 * 100%);\n    left: calc(232 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star4 {\n    top: calc(176 / 720 * 100%);\n    left: calc(237 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star5 {\n    top: calc(314 / 720 * 100%);\n    left: calc(292 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star6 {\n    top: calc(23 / 720 * 100%);\n    left: calc(339 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star7 {\n    top: calc(460 / 720 * 100%);\n    left: calc(436 / 1440 * 100%);\n\n    //animation: ', ' 1.2s linear infinite;\n  }\n  .star8 {\n    top: calc(80 / 720 * 100%);\n    left: calc(638 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star9 {\n    top: calc(113 / 720 * 100%);\n    left: calc(666 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star10 {\n    top: calc(481 / 720 * 100%);\n    left: calc(737 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star11 {\n    top: calc(284 / 720 * 100%);\n    left: calc(761 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star12 {\n    top: calc(160 / 720 * 100%);\n    left: calc(784 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  /* .star13 {\n  top: calc(230 / 720 * 100%);\n  left: calc(9170 / 1440 * 100%);\n} */\n  .star14 {\n    top: calc(279 / 720 * 100%);\n    left: calc(835 / 1440 * 100%);\n\n    //animation: ', ' 0.6s linear infinite;\n  }\n  .star15 {\n    top: calc(230 / 720 * 100%);\n    left: calc(917 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star16 {\n    top: calc(417 / 720 * 100%);\n    left: calc(977 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star17 {\n    top: calc(15 / 720 * 100%);\n    left: calc(1044 / 1440 * 100%);\n\n    //animation: ', ' 0.9s linear infinite;\n  }\n  .star18 {\n    top: calc(137 / 720 * 100%);\n    left: calc(1091 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star19 {\n    top: calc(576 / 720 * 100%);\n    left: calc(1173 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star20 {\n    top: calc(381 / 720 * 100%);\n    left: calc(1252 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star21 {\n    top: calc(702 / 720 * 100%);\n    left: calc(1317 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star22 {\n    top: calc(137 / 720 * 100%);\n    left: calc(1091 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star23 {\n    top: calc(207 / 720 * 100%);\n    left: calc(1346 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star24 {\n    top: calc(177 / 720 * 100%);\n    left: calc(1403 / 1440 * 100%);\n\n\n    //animation: ', ' 1.5s linear infinite;\n  }\n  .star25 {\n    top: calc(530 / 720 * 100%);\n    left: calc(1408 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star26 {\n    top: calc(443 / 720 * 100%);\n    left: calc(303 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star27 {\n    top: calc(612 / 720 * 100%);\n    left: calc(877 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star28 {\n    top: calc(239 / 720 * 100%);\n    left: calc(1111 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n'], ['\n  position: fixed;\n  top: 0;\n  left: 0;\n\n  width: 100vw;\n  height: 100vh;\n\n  > div {\n    position: absolute;\n\n    opacity: 1;\n    //animation: ', ' 2s infinite;\n  }\n\n  .hide {\n    opacity: 0;\n  }\n\n  .star1 {\n    top: calc(532 / 720 * 100%);\n    left: calc(56 / 1440 * 100%);\n\n\n    //animation: ', ' 0.8s linear infinite;\n  }\n  .star2 {\n    top: calc(41 / 720 * 100%);\n    left: calc(141 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star3 {\n    top: calc(597 / 720 * 100%);\n    left: calc(232 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star4 {\n    top: calc(176 / 720 * 100%);\n    left: calc(237 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star5 {\n    top: calc(314 / 720 * 100%);\n    left: calc(292 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star6 {\n    top: calc(23 / 720 * 100%);\n    left: calc(339 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star7 {\n    top: calc(460 / 720 * 100%);\n    left: calc(436 / 1440 * 100%);\n\n    //animation: ', ' 1.2s linear infinite;\n  }\n  .star8 {\n    top: calc(80 / 720 * 100%);\n    left: calc(638 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star9 {\n    top: calc(113 / 720 * 100%);\n    left: calc(666 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star10 {\n    top: calc(481 / 720 * 100%);\n    left: calc(737 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star11 {\n    top: calc(284 / 720 * 100%);\n    left: calc(761 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star12 {\n    top: calc(160 / 720 * 100%);\n    left: calc(784 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  /* .star13 {\n  top: calc(230 / 720 * 100%);\n  left: calc(9170 / 1440 * 100%);\n} */\n  .star14 {\n    top: calc(279 / 720 * 100%);\n    left: calc(835 / 1440 * 100%);\n\n    //animation: ', ' 0.6s linear infinite;\n  }\n  .star15 {\n    top: calc(230 / 720 * 100%);\n    left: calc(917 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star16 {\n    top: calc(417 / 720 * 100%);\n    left: calc(977 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star17 {\n    top: calc(15 / 720 * 100%);\n    left: calc(1044 / 1440 * 100%);\n\n    //animation: ', ' 0.9s linear infinite;\n  }\n  .star18 {\n    top: calc(137 / 720 * 100%);\n    left: calc(1091 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star19 {\n    top: calc(576 / 720 * 100%);\n    left: calc(1173 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star20 {\n    top: calc(381 / 720 * 100%);\n    left: calc(1252 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star21 {\n    top: calc(702 / 720 * 100%);\n    left: calc(1317 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star22 {\n    top: calc(137 / 720 * 100%);\n    left: calc(1091 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star23 {\n    top: calc(207 / 720 * 100%);\n    left: calc(1346 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star24 {\n    top: calc(177 / 720 * 100%);\n    left: calc(1403 / 1440 * 100%);\n\n\n    //animation: ', ' 1.5s linear infinite;\n  }\n  .star25 {\n    top: calc(530 / 720 * 100%);\n    left: calc(1408 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star26 {\n    top: calc(443 / 720 * 100%);\n    left: calc(303 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star27 {\n    top: calc(612 / 720 * 100%);\n    left: calc(877 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n  .star28 {\n    top: calc(239 / 720 * 100%);\n    left: calc(1111 / 1440 * 100%);\n\n    animation-delay: ', 's;\n    animation-duration: ', 's;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Icon = __webpack_require__(224);
	
	var _Icon2 = _interopRequireDefault(_Icon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var fade = (0, _styledComponents.keyframes)(_templateObject);
	
	var lightning = (0, _styledComponents.keyframes)(_templateObject2);
	
	var Container = _styledComponents2.default.div(_templateObject3, fade, lightning, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, lightning, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, lightning, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, lightning, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, lightning, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5, Math.random() * 4 + 0.5, Math.random() * 2 + 0.5);
	
	var Stars = function Stars() {
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'star1' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill60' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star2' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill11' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star3' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill17' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star4' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill13' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star5' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill17' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star6' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill5' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star7' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill60' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star8' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill21' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star9' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill17' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star10' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill9' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star11' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill3' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star12' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill17' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star13' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill3' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star14' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill60' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star15' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill7' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star18' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill19' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star20' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill1' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star22' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill23' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star24' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill60' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star25' },
	      _react2.default.createElement(_Icon2.default, { name: 'fill3' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'star27' },
	      _react2.default.createElement(_Icon2.default, { name: 'fillshape1' })
	    )
	  );
	};
	
	exports.default = Stars;
	module.exports = exports['default'];

/***/ }),

/***/ 221:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.default = undefined;
	
	var _class;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n0%, 100% {\n  background-position: 0 0;\n}\n\n10% {\n  background-position: -5% -10%;\n}\n\n20% {\n  background-position: -15% 5%;\n}\n\n30% {\n  background-position: 7% -25%;\n}\n\n40% {\n  background-position: 20% 25%;\n}\n\n50% {\n  background-position: -25% 10%;\n}\n\n60% {\n  background-position: 15% 5%;\n}\n\n70% {\n  background-position: 0% 15%;\n}\n\n80% {\n  background-position: 25% 35%;\n}\n\n90% {\n  background-position: -10% 10%;\n}\n'], ['\n0%, 100% {\n  background-position: 0 0;\n}\n\n10% {\n  background-position: -5% -10%;\n}\n\n20% {\n  background-position: -15% 5%;\n}\n\n30% {\n  background-position: 7% -25%;\n}\n\n40% {\n  background-position: 20% 25%;\n}\n\n50% {\n  background-position: -25% 10%;\n}\n\n60% {\n  background-position: 15% 5%;\n}\n\n70% {\n  background-position: 0% 15%;\n}\n\n80% {\n  background-position: 25% 35%;\n}\n\n90% {\n  background-position: -10% 10%;\n}\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  body {\n    margin: 0;\n\n    color: #3E0963;\n\n    font-family: "CallingCode-Regular";\n  }\n\n  html {\n    position: relative;\n\n    box-sizing: border-box;\n\n    &:before {\n      content: \'\';\n\n      z-index: 100;\n      position: absolute;\n      top: 0;\n      left: 0;\n\n      width: 100%;\n      height: 100%;\n\n      background-image: url(', ');\n\n      animation: 1s infinite ', ';\n\n      pointer-events: none;\n    }\n  }\n\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n\n\n  a:link{color:inherit}\n  a:active{color:inherit}\n  a:visited{color:inherit}\n  a:hover{color:inherit}\n'], ['\n  body {\n    margin: 0;\n\n    color: #3E0963;\n\n    font-family: "CallingCode-Regular";\n  }\n\n  html {\n    position: relative;\n\n    box-sizing: border-box;\n\n    &:before {\n      content: \'\';\n\n      z-index: 100;\n      position: absolute;\n      top: 0;\n      left: 0;\n\n      width: 100%;\n      height: 100%;\n\n      background-image: url(', ');\n\n      animation: 1s infinite ', ';\n\n      pointer-events: none;\n    }\n  }\n\n  *, *:before, *:after {\n    box-sizing: inherit;\n  }\n\n\n  a:link{color:inherit}\n  a:active{color:inherit}\n  a:visited{color:inherit}\n  a:hover{color:inherit}\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-flow: column;\n\n  background-color: ', ';\n\n  transition: background-color 0.3s ease-in-out;\n'], ['\n  display: flex;\n  flex-flow: column;\n\n  background-color: ', ';\n\n  transition: background-color 0.3s ease-in-out;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(416);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _styledComponents = __webpack_require__(11);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(114);
	
	var _mobxReact = __webpack_require__(52);
	
	var _store = __webpack_require__(44);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _Footer = __webpack_require__(216);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Background = __webpack_require__(214);
	
	var _Background2 = _interopRequireDefault(_Background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	console.log('Design made with ❤️ by www.fabienlaborie.com');
	
	var background = (0, _gatsbyLink.withPrefix)('/images/noise.png');
	var CallingCodeTTF = (0, _gatsbyLink.withPrefix)('../fonts/CallingCode-Regular.ttf');
	
	var noise = (0, _styledComponents.keyframes)(_templateObject);
	
	(0, _styledComponents.injectGlobal)(_templateObject2, background, noise);
	
	var Container = _styledComponents2.default.div(_templateObject3, function (props) {
	  return props.backgroundColor;
	});
	
	var Layout = (0, _mobxReact.observer)(_class = function (_Component) {
	  _inherits(Layout, _Component);
	
	  function Layout() {
	    _classCallCheck(this, Layout);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Layout.prototype.render = function render() {
	    return _react2.default.createElement(
	      _mobxReact.Provider,
	      { store: _store2.default },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	          title: this.props.data.site.siteMetadata.title,
	          meta: [{
	            name: 'description',
	            content: ' I am a Consultant Front-End Developer passionate about new technologies and languages​. I have been able to develop skills focused on efficiency and on communication. Whether for the analysis of a project or design, I consider it imperative to have a final product easy to maintain, easy to use and elegan.'
	          }, {
	            name: 'keywords',
	            content: 'Html, Css, Javascript, React, React Native, Elm, GraphQL + Apollo, TypeScript'
	          }]
	        }),
	        _react2.default.createElement(_Background2.default, null),
	        _react2.default.createElement(
	          Container,
	          { backgroundColor: _store2.default.backgroundColor },
	          this.props.children()
	        ),
	        _react2.default.createElement(_Footer2.default, null)
	      )
	    );
	  };
	
	  return Layout;
	}(_react.Component)) || _class;
	
	exports.default = Layout;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
	
	var _mobx = __webpack_require__(53);
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  Object.defineProperty(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var Store = (_class = function Store() {
	  var _this = this;
	
	  _classCallCheck(this, Store);
	
	  _initDefineProp(this, 'backgroundColor', _descriptor, this);
	
	  _initDefineProp(this, 'updateBackgroundColor', _descriptor2, this);
	
	  _initDefineProp(this, 'visibleSection', _descriptor3, this);
	
	  this.updateVisible = function (section) {
	    _this.visibleSection[section] = !_this.visibleSection[section];
	  };
	
	  _initDefineProp(this, 'updateHero', _descriptor4, this);
	
	  _initDefineProp(this, 'updateAbout', _descriptor5, this);
	}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'backgroundColor', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return '#ffdcc0';
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'updateBackgroundColor', [_mobx.action], {
	  enumerable: true,
	  initializer: function initializer() {
	    var _this2 = this;
	
	    return function (backgroundColor) {
	      _this2.backgroundColor = backgroundColor;
	    };
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'visibleSection', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return {
	      hero: true,
	      about: false
	    };
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'updateHero', [_mobx.action], {
	  enumerable: true,
	  initializer: function initializer() {
	    var _this3 = this;
	
	    return function (bool) {
	      _this3.visibleSection.hero = bool;
	    };
	  }
	}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'updateAbout', [_mobx.action], {
	  enumerable: true,
	  initializer: function initializer() {
	    var _this4 = this;
	
	    return function (bool) {
	      _this4.visibleSection.about = bool;
	    };
	  }
	})), _class);
	exports.default = new Store();
	module.exports = exports['default'];

/***/ }),

/***/ 224:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Icon = function (_Component) {
	  _inherits(Icon, _Component);
	
	  function Icon() {
	    _classCallCheck(this, Icon);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Icon.prototype.render = function render() {
	    switch (this.props.name) {
	      case 'cactus':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '57',
	            height: '87',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'cactus'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h57v87H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M29.517 37.34A61.793 61.793 0 0 0 29.3 32.2a2.164 2.164 0 0 0-.279-.891l.058-10.402a1.78 1.78 0 0 0-.492-1.205c.172-1.135.328-2.273.46-3.414.297-2.58.46-5.175.403-7.772a1.76 1.76 0 0 0-1.522-1.722c-.772-.104-1.803.392-1.926 1.256a101.32 101.32 0 0 0-.764 7.244c-.316.139-.586.365-.728.685a20.418 20.418 0 0 0-1.506 5.135c-.28 1.77-.422 3.553-.54 5.34a398.325 398.325 0 0 0-.725 15.72c-.019.487-.031.974-.036 1.462-.004.401.15.795.405 1.107-.402.321-.678.804-.636 1.334A2488.922 2488.922 0 0 1 24.124 83c.041.628.31 1.186.87 1.514.593.347 1.175.256 1.772 0 1.598-.685 1.675-2.635 1.734-4.168l.019-.438a724.153 724.153 0 0 0 .6-15.45c.192-6.885.287-13.774.282-20.662 0-.606-.003-1.212-.005-1.818v-.205c.08-1.475.124-2.952.121-4.432zm-9.436 18.662c-.043-.951-.772-1.754-1.756-1.754-.189 0-.377-.01-.564-.026a5.985 5.985 0 0 1-1.037-.281c-.028-.01-.057-.022-.085-.034l-.004-.001a2.115 2.115 0 0 0-.105-.04l.083.028-.02-.009a7.412 7.412 0 0 1-1.218-.733l-.025-.018-.006-.005c-.5-.407-.959-.863-1.382-1.349a13.4 13.4 0 0 1-.294-.35l-.061-.075-.026-.033c-.193-.259-.38-.521-.558-.79-.762-1.15-1.394-2.388-1.96-3.643a33.002 33.002 0 0 1-.153-.35l-.054-.123-.026-.063-.041-.1a32.742 32.742 0 0 1-2.11-7.83 32.822 32.822 0 0 1-.067-7.646c.045-.418-.23-.955-.514-1.24-.305-.304-.804-.533-1.242-.513-.454.02-.925.169-1.241.513-.334.364-.46.752-.514 1.24-.473 4.328-.07 8.773 1.115 12.96a34.985 34.985 0 0 0 2.422 6.192c.905 1.796 2 3.533 3.429 4.961 1.674 1.673 3.846 2.864 6.258 2.865.918.001 1.798-.807 1.756-1.753zm30.557-40.176c.093-.047.112-.238.779-2.935l.264 1.69a95.152 95.152 0 0 0 .011 3.416c.035 2.28.07 4.56-.221 6.815-.696 5.389-5.653 10.378-9.371 14.12-.328.33-.646.65-.95.96-1.39 1.413-2.797 2.829-4.381 4.02-.706.532-1.57.831-2.414 1.095a7.84 7.84 0 0 0-.224.074c-.425.147-.927.32-1.212.032-.386-.39-.521-.936-.658-1.486-.096-.387-.192-.776-.376-1.114-.066-.12-.21-.191-.351-.26-.171-.083-.338-.163-.352-.33-.028-.33.314-.61.584-.8.363-.255.804-.398 1.24-.481.66-.128 1.35-.155 2.039-.183 1.15-.046 2.296-.092 3.298-.603 4.35-2.215 6.041-7.745 7.491-12.483.434-1.419.846-2.766 1.302-3.933 3.047-7.803 3.36-7.541 3.502-7.614z',
	            fill: '#FFD65F'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M24.727 3.849a5.502 5.502 0 0 0-.195.132c.115-.198.252-.377.429-.524.536-.449 2.12-1.24 2.026-.55-.425 3.103-1.34 6.106-2.255 9.111-.72 2.366-1.44 4.733-1.923 7.15-.158.79-.086 1.6-.015 2.413.067.756.133 1.512.015 2.253-.041.26-.26.449-.477.637-.226.197-.451.392-.475.665-.401 4.695.884 12.519 1.882 18.59v.002c.448 2.72.837 5.089.99 6.666.286 2.937-.251 5.38-.8 7.876-.436 1.978-.878 3.989-.923 6.303-.093 4.768.711 8.337 1.32 11.037 1.059 4.702 1.524 6.767-4.382 7.934-.41.081-1.113.162-1.229-.237-.608-2.086-.713-4.303-.727-6.475a719.315 719.315 0 0 1 .076-15.773.27.27 0 0 1-.039.018c-3.648 1.29-8.121-2.43-10.133-4.86-2.433-2.939-2.69-4.175-3.156-6.424-.21-1.015-.463-2.235-.978-3.91-.501-1.63-.916-2.872-1.246-3.862-.61-1.827-.936-2.8-.993-3.79-.065-1.13.219-2.279.826-4.74.251-1.016.558-2.256.917-3.81l.453-1.428c.198.004.366.003.509.003.36-.003.558-.004.667.094.134.12.135.387.138.982.001.27.003.605.017 1.024.097 2.869.026 4.98-.035 6.75-.12 3.531-.194 5.707 1.211 9.835.55 1.616 2.705 6.63 3.71 7.945.113.148.053-.013-.048-.278-.179-.473-.483-1.279-.151-1.26.294.018.291.361.29.733-.003.312-.005.645.17.82.59.594 1.873 1.234 3.232 1.912 1.965.98 4.092 2.04 4.525 3.16l.037.093v.002l.002.002c.028.07.059.149.088.229.084-5.03.218-10.059.4-15.085.023-.648.21-1.276.396-1.904.192-.649.384-1.297.397-1.966.573-29.897-.259-15.293-.817-5.485-.492 8.634-.772 13.552.303-18.869.131-3.946 2.505-10.703 5.776-13.01-.15.257-.263.543-.376.829l-.001.003c-.091.231-.182.462-.293.677l.865-1.64zm21.359 10.763c.365-2.197 1.448-7.52 4.497-4.37l-.64 1.264c-.47 1.872-.83 3.353-1.134 4.611-.986 4.068-1.409 5.812-3.226 10.946-.132.372-.26.746-.387 1.12-.455 1.332-.91 2.668-1.552 3.918-.802 1.56-1.857 2.983-2.904 4.393-1.002 1.351-3.333 3.93-5.075 4.377-.97.248-2 .031-2.996-.179-.176-.037-.35-.074-.524-.108l-1.607-.72c-.172-.034-.102-.382 0-.524l.156-.22c.362-.517.746-1.063 1.316-1.305.726-.308 1.515-.412 2.305-.516.633-.083 1.266-.166 1.87-.354 7.86-2.454 8.613-10.204 9.307-17.34.168-1.728.333-3.42.594-4.993z',
	            fill: '#3B9B5B'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M32.424 6.09L35.35 20.6c.195.967-.27 1.85-1.228 2.16-.052.017-.105.03-.159.041.037.673.068 1.347.09 2.02.135 3.961.044 7.925-.05 11.887-.023.985-.787 1.712-1.758 1.756-.94.042-1.771-.837-1.758-1.756a233.245 233.245 0 0 0-.517-19.23l-.01-.072a63.49 63.49 0 0 0-1.213-6.259c-.536-2.212-1.063-4.463-1.056-6.753.003-.985.803-1.713 1.759-1.756.947-.043 1.76.837 1.758 1.756 0 .165.002.33.008.496.575.162 1.086.595 1.208 1.2zm-3.666 44.08c.076-.983.746-1.71 1.759-1.756.899-.04 1.829.838 1.758 1.756a362.73 362.73 0 0 0-.982 19.76 362.69 362.69 0 0 0-.06 12.676c.014.984-.815 1.714-1.757 1.756-.959.043-1.747-.838-1.759-1.756a362.854 362.854 0 0 1 .288-19.781c.177-4.223.429-8.442.753-12.655zm-10.913 1.361a13.89 13.89 0 0 1-1.118-.738l-.015-.01-.003-.004-.002-.001-.064-.047-.028-.02c-.062-.046-.086-.086-.071-.087a4.623 4.623 0 0 0-.15-.114l-.004-.003a3.065 3.065 0 0 1-.2-.155 13.28 13.28 0 0 1-1.156-1.146 9.492 9.492 0 0 1-.202-.236l-.015-.019-.013-.016a7.24 7.24 0 0 1-.546-.886.667.667 0 0 0-.057-.15.867.867 0 0 1-.035-.079 7.772 7.772 0 0 1-.194-.678c-.143-.587-.258-1.182-.373-1.776l-.002-.014-.136-.694-2.06-10.258-1.171-5.83c-.182-.901-1.304-1.503-2.164-1.225-.959.31-1.422 1.193-1.228 2.16L8.97 40.113l1.054 5.245c.053.267.104.536.155.806.283 1.517.573 3.064 1.456 4.356 1.132 1.658 2.717 3.02 4.436 4.044.791.47 1.965.203 2.406-.63.448-.848.214-1.9-.63-2.403zm34.973-41.217c.974-.043 1.724.84 1.758 1.756.137 3.639.272 7.288.01 10.924-.418 5.76-1.85 11.643-5.409 16.315-1.759 2.31-3.913 4.26-6.503 5.606-2.719 1.413-5.686 2.225-8.657 2.91-.962.222-1.86-.29-2.164-1.226-.284-.876.332-1.953 1.229-2.16a63.383 63.383 0 0 0 3.413-.869 34.833 34.833 0 0 0 1.653-.522 27.827 27.827 0 0 0 1.226-.456l.148-.06.036-.014.047-.02.072-.031a21.647 21.647 0 0 0 1.176-.56c.448-.232.887-.48 1.314-.749.392-.245.769-.51 1.14-.785l.048-.038a17.97 17.97 0 0 0 .769-.654 18.247 18.247 0 0 0 2.083-2.233c.125-.167.25-.334.37-.505.267-.377.522-.762.763-1.156a23.406 23.406 0 0 0 1.563-3.017v-.002a25.518 25.518 0 0 0 .605-1.616c.624-1.847 1.039-3.755 1.313-5.684.567-4.443.406-8.933.238-13.398-.037-.983.835-1.715 1.759-1.756z',
	            fill: '#7CC84A'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M54.495 19.713c-.272 1.744-.55 3.49-.924 5.215-.325 1.5-.989 2.892-1.633 4.283-.358.775-.677 1.57-1.046 2.34-.196.41-.424.815-.704 1.17-.76.963-1.272 2.059-1.818 3.142-.293.582-.654 1.133-1.016 1.677a15.271 15.271 0 0 1-1.82 2.201c-.477.476-.952.958-1.465 1.393-.448.38-.914.707-1.509.904-1.034.341-2.022.824-3.022 1.266-1.144.507-2.28 1.032-3.418 1.553-.38.174-.762.343-1.126.545-1.106.615-2.342.707-3.619.966l-.293-.86c.366-.284.726-.249 1.045-.22.685.064 1.293-.157 1.911-.38.823-.296 1.655-.567 2.469-.884.889-.346 1.799-.664 2.634-1.116 1.768-.956 3.412-2.108 4.794-3.58 1.114-1.186 2.245-2.364 3.102-3.769.476-.78 1.041-1.504 1.528-2.278.976-1.555 1.785-3.19 2.236-4.981.365-1.446.815-2.879 1.053-4.346.251-1.545.347-3.12.416-4.687.114-2.54.077-5.086.397-7.614.016-.129.087-.25.157-.446.165.124.297.2.401.304.661.659.999 1.484 1.107 2.387.141 1.183.259 2.372.308 3.561.03.75-.03 1.512-.145 2.254zm-22.28 29.422c-.06.651-.158 1.3-.234 1.95-.243 2.074-.468 4.15-.733 6.222a35.644 35.644 0 0 1-.476 2.7c-.469 2.264-.755 4.542-.733 6.86.007.812-.085 1.625-.124 2.438-.01.197 0 .396.018.593.057.632.157 1.263.175 1.896.038 1.33.019 2.66.052 3.989.027 1.11.105 2.22.142 3.33.022.675 0 1.345-.194 2.008-.098.336-.07.71-.084 1.066-.014.384-.027.767-.036 1.15a23.62 23.62 0 0 1-1.645-.343l-.002.025a28.09 28.09 0 0 1-.078-.797c-.069-.871-.172-1.743-.186-2.616-.018-1.072.01-2.146.073-3.217.126-2.163.277-4.324.444-6.484a6.26 6.26 0 0 1 .291-1.52c.388-1.142.474-2.338.725-3.503.44-2.032.499-4.1.63-6.164.046-.714.135-1.425.19-2.139.04-.515.093-1.033.076-1.547-.047-1.389.025-2.781-.26-4.161a3.67 3.67 0 0 1 .03-1.714c.08-.291.026-.619.034-.97.171.021.283.032.394.049.248.037.496.112.743.11.565-.007.82.22.768.789zm-4.38 11.971c-.129 2.21-.533 4.377-1.033 6.53a32.628 32.628 0 0 0-.84 7.333 29.43 29.43 0 0 1-.088 2.145c-.096 1.275-.007 2.542.1 3.811.05.576.093 1.151.134 1.727-.472.014-.946.072-1.411.144-.007-.892.024-1.785.007-2.677a31.436 31.436 0 0 0-.142-2.376c-.146-1.524-.247-3.045-.184-4.582a18.98 18.98 0 0 0-.136-3.036c-.182-1.51-.137-3.018-.112-4.527.024-1.45.11-2.9.18-4.349a61.84 61.84 0 0 0-.048-6.853c-.062-.99-.008-1.988-.025-2.981-.024-1.49-.073-2.98-.095-4.47-.014-.952-.02-1.906.007-2.858.042-1.49.125-2.977.168-4.467.014-.495-.04-.992-.063-1.489-.105-2.362-.188-4.725-.325-7.085-.061-1.049-.216-2.093-.355-3.136-.128-.955-.088-1.902.035-2.853.14-1.083.28-2.167.38-3.255.108-1.193.345-2.356.643-3.515.311-1.211.554-2.44.816-3.664.241-1.127.473-2.253.568-3.408.05-.603.288-1.192.448-1.785.284-1.055.57-2.11.866-3.162.067-.237.096-.513.404-.646.314.406.342.888.407 1.348a29.14 29.14 0 0 1 .253 4.641c-.031 1.57-.076 3.14-.08 4.71-.003.774.096 1.548.108 2.323a96.376 96.376 0 0 1-.011 3.275c-.024 1.27-.14 2.542-.084 3.808.039.9-.097 1.773-.144 2.659-.014.273.05.55.06.825.02.554.025 1.11.04 1.664.01.436.004.874.043 1.307.156 1.718.327 3.435.492 5.152.013.138.007.279.029.415.134.84.171 1.046-.071 1.809-.36 1.132-.253 2.282-.239 3.432.004.298.005.596.025.893.018.268-.013.482-.234.694-.26.248-.342.602-.363.977-.093 1.67-.024 3.336.063 5.006.155 3 .184 6.001-.113 8.998-.05.513-.05 1.032-.08 1.548zM21.057 27.7c.191 1.737.448 3.466.453 5.22.002.57.157 1.137.173 1.707.058 1.965.115 3.932.115 5.898 0 1.828-.104 3.657-.105 5.486 0 1.588.093 3.175.12 4.764.028 1.669-.048 3.343.057 5.007.128 2.049.083 4.093.037 6.14-.034 1.53-.128 3.058-.176 4.589-.052 1.71-.01 3.412.156 5.12.21 2.176.218 4.371.453 6.543.183 1.69.032 3.37.086 5.052-.408.089-.816.181-1.223.277l-.436.1c-.127-1.967-.25-3.935-.366-5.903-.061-1.031-.075-2.067-.167-3.096-.093-1.048-.245-2.092-.39-3.135-.105-.751-.189-1.485.05-2.24.122-.385.105-.826.096-1.241-.06-2.608.233-5.205.253-7.807.016-2.164-.046-4.338-.246-6.491a83.678 83.678 0 0 1-.32-5.651c-.046-1.826-.023-3.653-.004-5.48.004-.368.136-.732.186-1.102.046-.351.093-.708.086-1.06a175.161 175.161 0 0 0-.12-3.573 488.661 488.661 0 0 0-.223-4.764 32.42 32.42 0 0 1 .114-4.944c.162-1.602.305-3.206.47-4.808.091-.87.235-1.735.314-2.606.1-1.107.143-2.22.24-3.329.188-2.123.464-4.246 1.057-6.287.636-2.186 1.676-4.21 3.185-5.956.108-.125.254-.22.472-.406.002.232.028.345 0 .441-.36 1.198-.727 2.394-1.095 3.589-.193.626-.422 1.242-.58 1.877-.133.536-.174 1.095-.282 1.638-.2 1.013-.427 2.02-.626 3.033-.177.896-.33 1.798-.495 2.697-.043.233-.062.478-.15.694-.558 1.344-.672 2.775-.843 4.193-.155 1.282-.307 2.566-.4 3.853-.047.65.002 1.312.074 1.96zm8.195-24.873c.14-.572.57-.687 1.02-.302.119.101.237.224.305.361.51 1.03 1.095 2.024 1.336 3.176.513 2.45 1.098 4.885 1.59 7.34.174.87.197 1.775.23 2.667.035.973.025 1.948-.007 2.921-.049 1.447-.134 2.893-.204 4.34-.342 1.952-.38 3.912-.25 5.882.043.668-.067 1.347-.117 2.02-.064.85-.169 1.7-.198 2.55-.022.632.06 1.267.076 1.9.018.763-.243.885-.968.677-.682-.196-.86-.639-.916-1.249-.089-.969-.249-1.933-.296-2.903-.048-.97-.017-1.946.022-2.917.076-1.906.23-3.81.263-5.717.03-1.766-.058-3.534-.086-5.3-.025-1.53-.038-3.06-.056-4.588-.027-2.186-.006-4.375-.357-6.542-.211-1.301-.534-2.566-1.248-3.703-.107-.17-.184-.429-.139-.613zm9.738 37.862c-.138.068-.283.126-.415.205a14.49 14.49 0 0 1-3.19 1.435c-.758.234-1.512.486-2.25.776-.687.27-1.394.221-2.09.272-.175-.616-.106-.68.445-.74.588-.065 1.17-.197 1.753-.31 1.35-.259 2.626-.769 3.926-1.198.576-.19 1.152-.385 1.727-.578l.094.138zm-2.92-3.296c.982-.075 1.902-.432 2.785-.845.89-.417 1.574-1.104 2.198-1.863 1.371-1.67 2.286-3.584 2.95-5.609.464-1.412.774-2.877 1.105-4.33.113-.495.061-1.026.119-1.538.073-.649.184-1.294.271-1.942.07-.512.13-1.025.189-1.538.14-1.244.238-2.494.43-3.73.17-1.097.443-2.178.674-3.266.127-.6.178-1.221.515-1.763.276-.445.567-.87 1.105-1.028.104-.03.221-.018.398-.03-.108.572-.202 1.092-.304 1.611-.3 1.521-.54 3.057-.917 4.56-.592 2.355-.898 4.766-1.454 7.126-.3 1.276-.696 2.53-1.06 3.79-.132.457-.312.9-.449 1.355-.142.473-.247.958-.391 1.43a23.122 23.122 0 0 1-2.33 5.21c-.215.358-.421.72-.642 1.075-.616.989-1.475 1.728-2.503 2.238-.78.387-1.621.653-2.428.987-.307.128-.584.325-.893.445a18.814 18.814 0 0 1-3.846 1.061c-.58.093-.721-.037-.612-.595.079-.403.246-.792.397-1.178.1-.257.344-.293.59-.327.21-.029.43-.072.614-.167 1.102-.57 2.225-1.043 3.489-1.139zm13.612-20.195c.131-.744.24-1.491.361-2.237.04-.242.024-.508.35-.75.008.27.032.458.017.643-.193 2.398-.345 4.8-.607 7.191-.122 1.12-.435 2.221-.703 3.321a83.092 83.092 0 0 1-.889 3.282c-.337 1.173-.886 2.256-1.534 3.285-.656 1.041-1.336 2.068-2.009 3.098-.047.073-.122.127-.185.19l-.073-.048c.041-.103.074-.21.125-.308a31.763 31.763 0 0 0 2.338-5.862c.36-1.26.879-2.474 1.255-3.73.255-.853.406-1.74.57-2.617.34-1.817.663-3.638.984-5.458zM18.037 60.955c-.119-.014-.25-.017-.373-.048-1.331-.331-2.664-.657-3.99-1.01a5.224 5.224 0 0 1-1.045-.42c-.935-.485-1.86-.988-2.786-1.492-.858-.467-1.38-1.205-1.75-2.095-.241-.58-.59-1.116-.892-1.671-.226-.419-.445-.842-.681-1.255-.493-.86-1.012-1.706-1.49-2.575-.37-.678-.667-1.396-1.044-2.07-.702-1.252-.755-2.655-.984-4.017-.466-2.773-.576-5.574-.575-8.378 0-.668.106-1.355.28-2.001.474-1.765.988-3.52 1.538-5.264.151-.48.483-.905.737-1.352a.486.486 0 0 1 .263-.235c.06.647-.162 1.187-.362 1.724-.624 1.673-.958 3.392-.935 5.182.016 1.35-.05 2.7 0 4.047.077 2.044.11 4.1.508 6.11.276 1.396.576 2.794 1.143 4.124a173.725 173.725 0 0 1 2.326 5.798c.21.548.608.92.97 1.337a10.324 10.324 0 0 0 3.392 2.587c.675.32 1.413.529 2.142.712 1.135.284 2.287.504 3.482.763.18.422.295.913.126 1.5zM6.752 30.768c.04-.143.093-.282.14-.423l.128.025c.066 1.942.112 3.885.207 5.826.06 1.23.196 2.456.294 3.684.085 1.05.142 2.102.252 3.15.135 1.283.214 2.584.496 3.837.38 1.69 1.025 3.311 2.055 4.724a6.375 6.375 0 0 0 1.574 1.527c1.439.96 2.942 1.819 4.591 2.392.447.155.877.238 1.396.065.105.559.185 1.088.07 1.69-.578-.024-1.096-.142-1.608-.277-.711-.188-1.429-.361-2.123-.598-1.27-.434-2.306-1.183-3.16-2.242-.696-.864-1.027-1.878-1.443-2.86-.58-1.372-1.112-2.765-1.668-4.147-.545-1.355-.88-2.77-1.09-4.203-.407-2.778-.472-5.583-.491-8.386-.01-1.27.043-2.544.38-3.784zm2.545-4.43c.275-.046.335.16.372.363.12.665.251 1.328.348 1.997.207 1.425.092 2.855.059 4.286-.026 1.11.015 2.222.025 3.333.002.215-.002.43-.003.646l-.145.018c-.1-.825-.234-1.647-.292-2.475-.111-1.605-.222-3.213-.25-4.821-.016-.98-.062-1.942-.333-2.887-.059-.206-.06-.413.219-.46zm.972 12.663l.01.37c-.029 0-.057.002-.086.003l-.032-.368.108-.005zm.237 2.32c.036.148.073.295.107.442.37 1.586.738 3.173 1.11 4.758.036.154.117.302.134.457.076.716.467 1.266.955 1.742.768.747 1.534 1.506 2.371 2.17.57.453 1.243.788 1.903 1.11.397.193.59.435.573.868-.009.208.012.417.024.727-.27-.088-.463-.12-.625-.208-.979-.53-1.996-1.005-2.908-1.633-.59-.406-1.098-.988-1.512-1.582-.825-1.184-1.344-2.53-1.725-3.915-.162-.588-.178-1.218-.253-1.83-.124-1.02-.358-2.034-.154-3.105zm46.245-25.854c-.247-1.839-.776-3.56-1.97-5.045-.703-.873-1.502-1.57-2.532-2.019-.335-.146-.63-.275-1.02-.19-.255.055-.558-.008-.818-.09-1.525-.478-2.948-.086-4.353.477a.724.724 0 0 0-.278.217c-.423.53-.77 1.087-.955 1.765-.404 1.473-.474 3.014-.94 4.473-.052.165-.037.353-.049.531-.018.277-.018.557-.053.832-.08.63-.19 1.258-.262 1.89-.059.51-.064 1.026-.123 1.536-.053.453-.142.902-.225 1.351-.308 1.66-.321 3.368-.817 4.998-.358 1.177-.477 2.427-1.023 3.547-.436.893-.874 1.789-1.383 2.64-.542.907-1.214 1.722-2.078 2.357-.718.528-1.505.732-2.405.529-.187-.963-.154-1.934-.018-2.899.283-1.999.17-4.006.187-6.012.008-.932.101-1.865.193-2.794.074-.75.26-1.492.296-2.243a55.85 55.85 0 0 0 .07-4.171c-.033-1.25-.07-2.518-.31-3.738-.472-2.417-1.082-4.806-1.64-7.206a9.616 9.616 0 0 0-1.977-3.964c-.21-.256-.486-.463-.748-.672-.678-.54-1.507-.795-2.262-1.188-.632-.33-1.282-.416-1.958-.366-.851.064-1.587.387-2.264.942-1.897 1.557-3.355 3.433-4.367 5.666a20.965 20.965 0 0 0-1.452 4.471c-.215 1.05-.407 2.104-.63 3.152-.32 1.51-.162 3.076-.56 4.575a.731.731 0 0 0-.013.355c.162.619-.12 1.193-.174 1.788-.116 1.284-.315 2.56-.434 3.842-.086.928-.06 1.867-.15 2.794-.162 1.665-.086 3.329-.037 4.992.02.711.135 1.42.163 2.13.048 1.25.06 2.5.093 3.75.02.755.104 1.512.068 2.264-.141 2.879-.18 5.757-.033 8.636.007.129-.03.26-.055.47-.206-.107-.385-.155-.503-.267a87.963 87.963 0 0 1-1.956-1.918c-.342-.347-.538-.783-.662-1.252-.055-.21-.134-.416-.186-.627-.35-1.407-.751-2.804-1.025-4.225-.224-1.168-.334-2.362-.425-3.55-.108-1.405-.206-2.818-.192-4.227.018-1.97.09-3.932-.303-5.882-.229-1.135-.615-2.134-1.483-2.974-1.094-1.06-2.332-1.283-3.737-.944-.929.223-1.829.537-2.67 1-.187.102-.368.229-.524.375-.996.94-1.574 2.132-1.981 3.388.085.184.133.373.144.563.002.019-.226.05-.418.092-.04.114-.093.243-.13.376-.318 1.15-.652 2.295-.941 3.452-.192.768-.434 1.55-.45 2.33-.054 2.759.048 5.514.4 8.258.107.825.24 1.638.407 2.452.4 1.956 1.33 3.694 2.174 5.469.178.374.446.706.635 1.076.667 1.307 1.285 2.642 1.986 3.93.651 1.198 1.464 2.273 2.752 2.885.304.145.577.352.867.526 1.162.697 2.343 1.345 3.672 1.688 1.056.273 2.1.596 3.15.897.457.131.911.282 1.375.389.53.123.538.117.529.629-.024 1.391-.037 2.783-.07 4.174-.007.335.003.705-.133.994-.41.871-.397 1.774-.325 2.69.05.634.13 1.265.169 1.898.057.933.068 1.869.138 2.8.143 1.923.333 3.842.46 5.766a9.836 9.836 0 0 1-.127 2.264c-.438.06-.892.047-1.308-.118-.426-.17-.78-.47-1.183-.683a.257.257 0 0 1-.148-.252c-.44-.321-.873-.624-1.232-.998-.619-.644-1.317-1.082-2.189-1.209-.706-.103-1.423-.136-2.135-.208-.181-.019-.36-.067-.594-.112.137-.324.246-.555.334-.794.142-.385.351-.676.738-.886.276-.15.463-.467.681-.716.034-.038.051-.123.033-.17-.122-.307-.233-.624-.394-.91-.134-.238-.347-.375-.656-.258-.066.025-.18-.051-.262-.099-.23-.134-.45-.093-.682.006-.551.233-.935.663-1.328 1.085l-.406.435c-.417-.41-.816-.656-1.373-.57-.482.073-1.022-.025-1.213.671.545.908 1.223 1.803 1.394 2.906-1.14.6-2.279 1.206-3.422 1.802-.388.202-.674.477-.782.917.085.099.169.183.237.278.38.528 1.127.774 1.717.536.48-.193.943-.425 1.42-.622 1.875-.774 3.721-1.682 5.854-1.241.096.02.199.012.298.014.504.007.888.215 1.26.572a37.82 37.82 0 0 0 2.508 2.2c.33.264.763.474 1.176.541.719.117 1.465.181 2.187.12.746-.062 1.484-.276 2.214-.466 1.597-.413 3.186-.858 4.781-1.277.183-.048.41-.076.578-.012 1.045.403 2.144.418 3.234.49.935.063 1.861.147 2.754.468.953.343 1.932.418 2.94.275.568-.08 1.149-.061 1.723-.095.177-.01.372-.006.525-.08.769-.366 1.603-.477 2.423-.617.837-.143 1.696-.356 2.543-.11 1.087.317 2.161.683 3.23 1.056.639.223 1.253.515 1.889.743.187.067.425.067.62.02.239-.06.457-.2.639-.285.038-.26.082-.49.102-.72.011-.132.038-.32-.034-.392-.414-.413-.732-.922-1.363-1.103-.82-.235-1.614-.556-2.419-.845a.573.573 0 0 0-.07-.02L42.4 82.87c-.439-.023-.796-.09-1.141-.052l-.345.04c.44-.836.87-1.679 1.678-2.255.062-.045.091-.135.152-.182.319-.246.367-.562.207-.902-.163-.349-.444-.55-.851-.538-.117.004-.242.012-.35-.021-.408-.123-.739.002-1.044.27-.166.145-.35.271-.591.457-.022-.212-.06-.315-.037-.401.222-.824.432-1.652.69-2.464.213-.665.43-1.324.388-2.031-.042-.704-.446-.986-1.16-.862-.093.016-.201-.063-.298-.097-.138.192-.14.477-.451.439-.306-.038-.414.148-.48.41-.28 1.117-.57 2.232-.861 3.347-.042.16-.113.313-.18.495-.196-.082-.331-.12-.446-.19-.876-.531-1.747-.605-2.62.004-.016.01-.038.012-.056.019-.32.112-.335.395-.292.641.041.235.1.498.457.532.778.073 1.283.573 1.707 1.176.102.145.168.335.303.433.362.264.484.653.495 1.042.012.404.008.808.062 1.213-.768.143-1.536.278-2.325.336-.885.065-1.742.025-2.59-.13.022-.82-.066-1.64.087-2.475.316-1.72.26-3.475.154-5.221-.02-.317-.016-.634-.014-.951.003-.672.013-1.344.02-2.016.005-.533.035-1.068.007-1.6-.038-.712-.18-1.422-.175-2.132.01-1.35.122-2.7.133-4.051.01-1.299.059-2.59.424-3.842.334-1.147.628-2.298.712-3.495.015-.218.049-.434.07-.651.202-1.996.42-3.99.596-5.988.08-.908.085-1.823.105-2.735.007-.273.097-.438.352-.553 1.262-.57 2.544-1.09 3.739-1.813.932-.564 1.95-.991 2.944-1.445.577-.263 1.171-.507 1.781-.672.86-.233 1.628-.608 2.3-1.186.573-.493 1.154-.977 1.713-1.485.246-.224.46-.488.666-.75.342-.435.612-.942 1.011-1.312.521-.483.822-1.101 1.173-1.677.556-.913.982-1.904 1.503-2.84.29-.519.71-.966.984-1.491.514-.985.97-2 1.44-3.007.276-.593.541-1.193.794-1.798.253-.603.504-1.209.718-1.826.176-.505.326-1.022.435-1.544.138-.661.22-1.333.33-2 .172-1.058.396-2.111.51-3.176.158-1.47.015-2.94-.181-4.4z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'cloud1':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '69',
	            height: '30',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'cloud1'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h69v30H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M65.11 16.998c-1.006-3.55-4.15-6.059-7.652-6.897-1.864-.446-3.697-.448-5.572-.102-1.92.355-3.78 1.165-5.47 2.131-.428.245-.848.504-1.26.774a6.014 6.014 0 0 0-1.129-1.165c.128-.492.143-1.033-.002-1.481a3.923 3.923 0 0 0-.093-.257c.641-.478 1.274-.97 1.896-1.475.566-.459.806-1.24.81-1.96.555-.36 1.066-1.003 1.213-1.647.352-1.555-.467-3.034-1.989-3.514-2.695-.851-5.606-.487-8.121.735-.58.281-1.095.64-1.603 1.034-.287.223-.566.45-.83.693a26.28 26.28 0 0 0-2.584 1.181c-1.692.876-3.304 1.921-4.887 2.98a90.395 90.395 0 0 0-5.278 3.842c-1.412 1.1-2.754 2.288-4.143 3.415-1.335.09-2.676.213-3.969.532a9.578 9.578 0 0 0-2.508.995c-1.002.585-1.771 1.366-2.422 2.317-1.014 1.482-.008 3.817 1.701 4.197 1.384.308 2.69.3 4.077.027 1.12-.22 2.212-.7 3.213-1.238.687-.37 1.344-.795 1.98-1.253a345.889 345.889 0 0 1 20.604-.755c.532.465 1.213.8 1.935.768l.757-.102a2.837 2.837 0 0 0 1.188-.67 346.928 346.928 0 0 1 17.393.511c1.853.101 3.23-1.906 2.745-3.616z',
	            fill: '#A1CBFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M68.855 21.64a.647.647 0 0 1 .016-.198c.01-.056.02-.111.018-.166a7.754 7.754 0 0 1 0-.281c.003-.254.007-.508-.057-.744-.212-.783-.455-1.558-.698-2.333l-.007-.021c-.054-.174-.11-.349-.163-.523-.287-.921-.621-1.825-1.185-2.617-.136-.19-.27-.383-.405-.576-.474-.678-.95-1.357-1.488-1.98-1.19-1.373-2.596-2.511-4.303-3.165-1.291-.495-2.633-.87-3.969-1.235-1.846-.506-3.726-.684-5.636-.407-.487.07-.645-.054-.85-.504-.303-.67-.608-1.34-.937-1.997-.317-.632-.817-1.11-1.315-1.588a19.618 19.618 0 0 1-.448-.438c-.646-.659-1.337-1.271-2.248-1.546l-.615-.187h-.003C43.636.851 42.71.57 41.775.326c-.522-.136-1.062-.208-1.6-.28h-.002a66.927 66.927 0 0 1-.325-.043.795.795 0 0 0-.314.045c-.058.016-.115.032-.172.04-.022.015-.047.006-.074-.002a.168.168 0 0 0-.067-.013 7.82 7.82 0 0 0-.395.047l-.265.048-.043.008a61.36 61.36 0 0 1-.536.097c-.293.064-.584.136-.876.207h-.001c-.59.145-1.179.29-1.78.37h-.001l-.028.004-.02.003-.294.13h-.002c-.663.293-1.323.584-1.995.788l-.24.123c-.517.267-1.032.532-1.536.82-1.229.699-2.205 1.676-2.951 2.88l-.121.194-.01.016-.001.001c-.216.346-.431.691-.625 1.049-.206.381-.492.521-.908.423-.072-.017-.145-.028-.219-.038h-.002a2.724 2.724 0 0 1-.2-.034c-1.218-.268-2.381-.109-3.505.309-.214.109-.426.22-.636.337l-.133.09-.014.01-.073.048c-.248.168-.503.324-.759.48l-.005.004c-.129.079-.258.158-.386.239-.256.224-.513.446-.78.656l.038.065-.187.16a7.178 7.178 0 0 0-.375.333c-.514.5-1.033 1.008-1.303 1.686a32.519 32.519 0 0 0-.861 2.422c-.109.349-.28.508-.628.549-.565.065-1.128.142-1.69.22l-.062.008-.493.067c-1.112.15-2.22.282-3.35.119-1.884-.272-3.773-.356-5.67-.083-.553.08-1.079.197-1.577.446-.32.16-.352.24-.153.557.067.105.142.206.217.307.12.163.24.326.325.507.186.4.505.51.889.521a5.68 5.68 0 0 0 .794-.032c1.533-.173 3.057-.039 4.577.135.956.11 1.905.156 2.867.05.49-.054.979-.12 1.467-.186h.002c1.208-.164 2.416-.327 3.643-.312.6.007.669-.095.803-.705.034-.155.057-.313.08-.471.039-.27.077-.54.172-.789.262-.69.573-1.36.884-2.03v-.002l.124-.266c.101-.22.232-.44.4-.611.786-.802 1.597-1.58 2.58-2.143 1.004-.574 2.047-.8 3.153-.28l.384.18.02.008c.178.083.358.166.536.251.63.301 1.003.14 1.305-.486.345-.718.717-1.426 1.125-2.11.517-.865 1.14-1.662 1.991-2.218 2.038-1.331 4.2-2.34 6.665-2.597l.276-.03c1.027-.11 2.046-.22 3.065.046.75.195 1.499.397 2.236.634 1.445.466 2.545 1.355 3.217 2.741l.573 1.188.257.535c-.037.03-.065.055-.086.074a.281.281 0 0 1-.075.056l-.02.008c-.126.049-.253.099-.383.135-1.266.352-2.29 1.054-3.03 2.148l-.306.45c-.485.712-.97 1.425-1.394 2.171-.222.39-.36.83-.496 1.267v.002c-.047.15-.094.299-.144.446-.044.128-.064.305-.01.419.15.312.318.615.476.9l.001.002c.058.103.114.204.167.303l.248.022c.144.011.263.021.38.04.469.07.754-.081.87-.54.376-1.483 1.28-2.625 2.324-3.68.214-.215.434-.428.668-.621.763-.63 1.668-.883 2.625-1.08 1.352-.28 2.709-.36 4.075-.298 2.038.092 3.973.662 5.878 1.357.857.313 1.62.794 2.312 1.362 1.763 1.45 2.905 3.349 3.66 5.477.286.81.516 1.64.745 2.47l.002.01c.103.368.205.738.312 1.105.092.317.636.886.875.844.291-.052.589-.155.844-.304.22-.13.185-.366.151-.591v-.005a5.91 5.91 0 0 1-.011-.075zm-18.499 2.493h.015c.65.003 1.301.006 1.952.012 1.101.01 2.202.02 3.302.05.755.02 1.511.044 2.26.127.609.067 1.05-.153 1.436-.591l.007-.008c.273-.31.28-.319-.092-.652l.23-.376-.04-.06v-.002c-.02-.031-.034-.054-.052-.07a.396.396 0 0 0-.061-.044c-.033-.021-.065-.041-.081-.07-.343-.635-.927-.832-1.585-.862l-.627-.028-.106-.005a112.518 112.518 0 0 0-3.79-.131 40.468 40.468 0 0 0-1.868.035c-.641.021-1.282.043-1.922.033a218.97 218.97 0 0 1-3.457-.087c-1.253-.039-2.507-.077-3.76-.092-5.221-.062-10.443-.097-15.665-.131l-2.314-.018h-.003c-3.777-.033-7.552-.065-11.328.09-3.938.163-7.854.505-11.73 1.252-.398.077-.717.259-1.077.618.302.215.43.485.561.764l.04.083c.292.61.89.8 1.544.728 1.175-.13 2.349-.27 3.52-.427 4.156-.559 8.337-.679 12.518-.648 4.527.033 9.054.114 13.581.195h.003l4.222.074c1.89.032 3.781.07 5.672.108h.001c1.862.037 3.723.075 5.585.106 1.036.018 2.073.022 3.11.027zM62.8 27.19c.644-.007 1.151.188 1.444.804.027.057.075.105.134.164.031.031.066.066.102.107l-.28.364c.332.385.332.464.011.742l-.075.065c-.529.459-.564.489-1.335.46a67.063 67.063 0 0 1-3.355-.226c-2.42-.215-4.844-.256-7.27-.262l-3.66-.013c-3.083-.013-6.166-.025-9.248-.011-.995.004-1.988.069-2.982.133-.472.03-.944.06-1.416.085l-.678.035c-1.036.054-2.072.107-3.109.146-.214.008-.434-.05-.648-.108l-.065-.017c-.402-.106-.67-.36-.805-.765a11.092 11.092 0 0 0-.257-.67l-.123-.305c.24-.347.614-.452.997-.5l.33-.043c.901-.115 1.802-.23 2.707-.298 1.728-.13 3.459-.228 5.19-.313.751-.037 1.505-.037 2.258-.037h.37c1.168 0 2.335-.006 3.503-.01 3.033-.013 6.067-.025 9.1.022 1.722.027 3.442.137 5.162.247a223.512 223.512 0 0 0 2.653.16c.448.024.897.05 1.345.044z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'cloud2':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '68',
	            height: '32',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'cloud2'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h68v32H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M45.606 18.486l-.444.046c.008-.12.014-.241.014-.361.145.103.288.208.43.315zm8.431-.168c-1.275-1.239-2.557-2.473-3.927-3.601-1.503-1.237-3.062-2.413-4.804-3.27-.957-.47-1.95-.894-2.971-1.193a10.656 10.656 0 0 0-1.387-.313c-.696-.105-1.398-.215-2.102-.166-1.238.088-2.377.399-3.462 1.031l-.028.017a5.008 5.008 0 0 0-.09-.345c.371-.157.71-.377 1.009-.658.567-.536.77-1.317.833-2.07l.145-1.754c.058-.71-.36-1.582-.834-2.07-.493-.508-1.303-.89-2.012-.857-.278.012-.56.056-.832.137a8.536 8.536 0 0 0-5.76-.772c-1.546.34-3.054 1.305-4.049 2.567-.513.65-.981 1.31-1.337 2.063-.374.789-.691 1.612-.962 2.444-.126.386-.243.775-.358 1.165a11.007 11.007 0 0 0-.613-.264c-.623-.246-1.644-.069-2.193.295a3.145 3.145 0 0 0-1.308 1.75c-.336 1.092-.677 2.183-1.09 3.247a14.341 14.341 0 0 1-1.33 2.434c-.31.38-.648.73-1.014 1.052-.237.17-.482.329-.735.472a95.991 95.991 0 0 0-3.36.408l-.68.295a2.174 2.174 0 0 0-.8.754c-.37.494-.638 1.133-.61 1.774a3.55 3.55 0 0 0 .388 1.478c.308.599 1.054 1.201 1.701 1.345 1.364.304 2.74.295 4.092-.085.27-.077.54-.167.805-.269 1.257-.106 2.515-.185 3.775-.243.657.423 1.479.592 2.233.347a59.651 59.651 0 0 1 1.515-.469c1.608-.032 3.216-.042 4.824-.046 5.445-.01 10.9.06 16.333-.365 3.266-.256 6.532-.683 9.74-1.372.952-.205 1.736-1.109 1.987-2.045.264-.985 0-2.137-.732-2.848z',
	            fill: '#A1CBFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M53.89 18.202c1.023.154 1.807.964 1.965 2.015.038.248.077.497.132.742.12.53.055 1.032-.157 1.527-.113.262-.23.507-.547.512a.842.842 0 0 1-.799-.48l-.01-.02c-.142-.27-.285-.544-.378-.833-.187-.585-.574-.771-1.13-.675-.14.024-.28.045-.421.066h-.003l-.006.001c-.36.054-.722.108-1.068.214-.505.153-.895.089-1.281-.29-.122-.12-.157-.266-.19-.401a.807.807 0 0 0-.086-.242c-.4-.632-.116-1.134.172-1.642l.023-.04c.363-.642.404-1.307.17-1.988-.129-.374-.309-.731-.488-1.084-.083-.164-.191-.362-.34-.435-.38-.19-.64-.504-.898-.818a5.494 5.494 0 0 0-.416-.468c-.82-.79-1.8-1.302-2.844-1.683-1.374-.501-2.806-.713-4.253-.846-1.05-.097-2.025.155-2.956.626-.312.157-.617.33-.922.502l-.002.002-.003.001-.313.176c-.557.311-.79.23-1.08-.326a11.308 11.308 0 0 0-.447-.759l-.002-.003-.004-.005c-.067-.108-.134-.215-.198-.321.124-.764.612-1.124 1.16-1.362a33.04 33.04 0 0 1 1.788-.693l.021-.008c.274-.1.548-.2.82-.304.085-.032.167-.072.264-.12l.005-.002.005-.002a9.39 9.39 0 0 1 .154-.074c-.249-1.096-.552-2.107-1.517-2.77-.269-.184-.494-.446-.713-.7l-.032-.036C35.93 3.84 34.525 3.15 32.81 2.97c-1.65-.174-3.1.314-4.51 1.076-.413.223-.81.476-1.203.735-1.449.959-2.01 2.417-2.155 4.103l-.018.196c-.027.27-.054.544-.02.807.05.39-.131.556-.44.622-.212.045-.458.082-.657.018-1.206-.382-2.37-.197-3.543.167-.659.204-1.295.428-1.691 1.04-.462.716-.914 1.44-1.164 2.274-.135.452-.273.902-.411 1.353l-.01.034-.013.042v.002l-.006.015c-.28.918-.562 1.837-.82 2.762-.158.565-.452.862-1.02.898-.329.021-.658.049-.987.076h-.002c-.36.03-.72.06-1.08.082-.37.022-.742.038-1.114.053h-.015c-.418.018-.836.036-1.254.063-.727.048-1.243-.29-1.667-.859-.154-.206-.121-.337.107-.462l-.39-.254.053-.568c.04-.013.078-.028.116-.043h.002a.913.913 0 0 1 .237-.07c.417-.04.834-.078 1.252-.116.658-.06 1.316-.12 1.973-.192a9.596 9.596 0 0 0 1.438-.26c.348-.094.568-.354.67-.743.285-1.093.591-2.18.908-3.263.41-1.398 1.146-2.595 2.236-3.526.381-.326.866-.56 1.34-.73 1.1-.397 2.249-.588 3.41-.69.519-.047.534-.048.63-.566.18-.956.485-1.87.927-2.723.398-.77 1.048-1.337 1.75-1.807C26.728 1.805 27.85 1.21 29.096.9c.1-.025.195-.065.29-.105.056-.023.113-.047.17-.068C31.395.066 33.273.11 35.088.684c1.526.483 2.738 1.545 3.715 2.858.036.05.07.102.104.154l.001.001.001.001V3.7h.002c.056.087.112.173.18.247.711.77 1.2 1.69 1.637 2.636.169.365.266.768.362 1.167l.051.21c.115.465.357.683.843.741 1.752.21 3.437.678 5.047 1.44 2.277 1.078 3.817 2.862 4.86 5.166.355.786.703 1.558.662 2.453-.01.234.154.316.363.334.325.029.65.059.972.108zm-2.757 6.028c.243.233.38.484.276.833-.015.052-.007.114 0 .171l.002.017v.003c.077.634.077.635-.161 1.3-.475.187-.98.212-1.491.18l-1.44-.086-1.247-.074a8.16 8.16 0 0 0-.15-.007h-.008c-.152-.006-.305-.012-.451-.044-1.936-.423-3.9-.45-5.862-.478l-.656-.01c-.629-.01-1.258-.024-1.887-.039h-.001c-1.49-.034-2.982-.067-4.472-.049-.968.012-1.935.089-2.902.165a82.39 82.39 0 0 1-1.552.114c-.518.03-1.035.063-1.553.096h-.003c-2.676.168-5.353.336-8.036.31-2.087-.02-4.173-.057-6.26-.094-.685-.012-1.37-.025-2.056-.036-.487-.008-.975-.015-1.462-.021H9.748c-1.322-.017-2.645-.034-3.966-.091l-.364-.015H5.41c-1.26-.05-2.526-.1-3.732-.56-.253-.096-.493-.237-.729-.375l-.025-.015c-.221-.13-.314-.32-.102-.59-.51-.135-.551-.495-.593-.863a3.49 3.49 0 0 0-.036-.257c.405-.297.84-.297 1.293-.247l.474.053c.773.087 1.546.174 2.321.227 1.423.097 2.848.176 4.274.223.61.02 1.22.017 1.831.013.47-.003.94-.006 1.409.003.522.009 1.045.03 1.567.05l.008.001c.433.017.865.035 1.297.046.19.004.38-.01.57-.025.135-.01.27-.02.405-.024.881-.022 1.762-.039 2.643-.056 1.892-.037 3.784-.073 5.674-.16 2.268-.105 4.534-.27 6.8-.434l1.745-.125c1.63-.116 3.258-.056 4.885.005.614.022 1.227.045 1.841.058a95.16 95.16 0 0 1 1.818.063h.004c.942.038 1.883.077 2.824.072.838-.005 1.659.013 2.488.16.882.157 1.778.234 2.67.31.404.035.816.005 1.22-.034.359-.035.627.095.88.337zm-4.64 4.863c-.158.022-.322.037-.481.023a7.345 7.345 0 0 1-.424-.05 4.61 4.61 0 0 0-.663-.062c-.52.003-1.04.018-1.561.034h-.008c-.407.013-.814.025-1.221.031a7.088 7.088 0 0 1-.975-.061 9.6 9.6 0 0 1-.547-.09c-.297-.055-.593-.11-.89-.117-.31-.009-.619.018-.929.044-.277.024-.555.048-.832.047-.417-.002-.834-.021-1.25-.04-.5-.024-1-.047-1.5-.04-.448.006-.89-.039-1.332-.084-.46-.047-.919-.094-1.384-.083-.77.017-1.541-.003-2.312-.023-.488-.012-.975-.025-1.462-.028-.284-.002-.568.011-.851.024h-.003c-.41.02-.818.038-1.224.012-.78-.05-1.534.071-2.293.205-.39.07-.672.333-.875.634-.065.097-.016.28.031.456.017.061.033.121.043.176.036.178.089.352.142.526v.002l.005.014c.204.666.714.977 1.368.853.4-.075.802-.15 1.206-.185 2.175-.194 4.347-.083 6.52.028h.003c.494.025.987.05 1.48.072.32.01.64.02.958.028.7.02 1.4.04 2.098.074 1.258.06 2.516.123 3.773.187h.005c1.387.07 2.773.14 4.16.206.57.027 1.14.016 1.71-.007.279-.01.604-.023.742-.334a2.34 2.34 0 0 0 .168-1.482c-.16-.713-.694-1.083-1.394-.99zm20.818-3.89c.09.019.213.092.242.171l.027.074c.233.637.469 1.28.22 1.976-.101.286-.375.313-.611.328l-.41.03c-.514.039-1.031.078-1.54.033a105.977 105.977 0 0 1-3.306-.365c-.454-.055-.907-.11-1.361-.162-.35-.04-.613-.21-.802-.598l.25-.366-.44-.335.1-1.03.116-.015c.722-.086 1.465-.176 2.242-.033 1.485.273 2.989.351 4.498.188.208-.022.426.026.64.074l.135.03z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'cloud3':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '37',
	            height: '24',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'cloud3'
	          },
	          _react2.default.createElement('path', {
	            fill: 'none',
	            d: 'M2.141.226L36.95 3.884l-2.09 19.89L.05 20.117z'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M25.665 12.942c.044-.732-.115-1.513-.614-2.079-.383-.434-.874-.793-1.433-.951a19.923 19.923 0 0 0-1.305-1.774 15.903 15.903 0 0 0-1.715-1.731c-.609-.533-1.273-.925-1.984-1.31a7.06 7.06 0 0 0-1.61-.634c-.764-.196-1.5-.364-2.29-.347-1.042.023-1.887.142-2.876.513-.684.256-1.337.675-1.893 1.146-.977.829-1.708 1.877-2.552 2.826a5.83 5.83 0 0 1-.549.465c-.544.286-.967.668-1.267 1.213-.294.536-.464 1.206-.334 1.82.251 1.193 1.22 2.268 2.494 2.354l12.928.883c.182.09.363.18.543.274l.737.18c.386.055.756.012 1.11-.13.28-.085.562-.211.815-.379.273-.102.53-.245.762-.432.54-.438.99-1.201 1.033-1.907z',
	            fill: '#A1CBFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M32.149 14.465c.706.122 1.413.244 2.112.4.963.213 1.52 1.386 1.15 2.304-.029.073-.054.147-.082.23l-.045.13c-.73.163-1.46.047-2.15-.158-1.694-.502-3.435-.592-5.173-.681l-.362-.02c-1.94-.102-3.886-.138-5.83-.172a63.97 63.97 0 0 0-2.305.016c-.385.007-.77.014-1.155.018-.632.006-.634 0-.865-.556l-.011-.028c-.057-.138-.171-.257-.278-.368l-.01-.01c-.3-.312-.306-.46-.158-.863.193-.525.53-.767 1.094-.758.257.005.515-.011.772-.027.289-.018.577-.036.865-.025.83.032 1.657.076 2.486.12.728.038 1.456.077 2.184.107.245.01.491-.003.737-.016.238-.013.476-.026.713-.017.608.022 1.216.059 1.824.096l.9.053c.086.005.172.003.286.001l.21-.003c-.471-.42-.548-.931-.622-1.425a7.548 7.548 0 0 0-.057-.348 1.437 1.437 0 0 0-.544-.905c-.113-.089-.224-.18-.334-.272-.48-.397-.959-.793-1.572-1.007-.711-.248-1.419-.28-2.152-.166a5.036 5.036 0 0 1-1.024.077c-.363-.018-.488-.206-.574-.578-.03-.133-.095-.259-.17-.402a5.575 5.575 0 0 1-.112-.228l.511-1.536c-.65-.811-1.338-1.639-2.19-2.298-1.128-.874-2.477-1.107-3.85-1.087-1.436.02-2.858.216-4.254.622-2.334.678-3.943 2.167-5 4.309-.14.284-.234.612-.263.928-.059.665-.074 1.335-.08 2.004-.006.623-.227.896-.845 1.017-.098.02-.197.038-.295.057-.458.087-.918.174-1.359.316-.71.23-1.16.754-1.467 1.54.16.008.312.018.46.027.304.02.586.037.868.037 1.16-.003 2.32-.01 3.48-.016.865-.005 1.729-.01 2.593-.013.125 0 .25.013.374.027.077.008.154.016.231.021.394.026.7.185.863.562l-.18.651.524.182c-.018.027-.031.051-.044.074-.023.041-.042.074-.07.095l-.218.169c-.23.178-.459.357-.708.501-.16.093-.383.1-.579.105h-.007c-1.986.054-3.972.102-5.958.149l-.291.007c-.09.002-.178.006-.267.01a4.636 4.636 0 0 1-.763-.009c-.273-.033-.604-.089-.791-.262-.914-.847-1.533-1.848-1.597-3.157-.04-.82.388-1.396.86-1.934.682-.774 1.521-1.345 2.58-1.483.342-.045.504-.229.553-.543.028-.18.044-.363.054-.545a5.197 5.197 0 0 1 .676-2.317C6.7 4.98 8.476 3.406 10.95 2.696c1.091-.313 2.193-.573 3.328-.685 2.356-.233 4.603.081 6.686 1.272l.084.046c.098.054.197.107.275.182l.331.316c.798.759 1.597 1.518 2.206 2.45.036.055.073.108.111.16.08.114.16.226.219.349.157.324.419.49.757.542.865.13 1.61.515 2.307 1.028.182.135.379.25.576.364.136.079.272.158.403.244.123.08.234.18.343.28l.072.066c.048.042.092.09.135.138.081.09.162.178.263.228.505.246.714.694.878 1.185l.156.46c.112.325.223.65.325.978.153.49.243.985.022 1.487-.024.055-.027.12-.03.202a2.302 2.302 0 0 1-.01.147l.254.052c.178.037.349.072.52.103.329.06.658.118.988.175zM20.7 18.329c.513-.005.79.323.93.732.098.282.196.515.468.605-.17.768-.517 1.097-1.181 1.096-.825-.003-1.65-.012-2.473-.02-.957-.01-1.913-.02-2.87-.02-.313 0-.627-.01-.941-.021-.923-.03-1.847-.06-2.75.17-.551.14-1.1.17-1.652.201l-.309.018-.036.003c-.381.024-.757.049-.999-.416-.085-.165-.265-.281-.459-.406a3.778 3.778 0 0 1-.276-.189 3.13 3.13 0 0 1 .052-.182c.035-.118.067-.223.064-.328-.015-.527.31-.68.747-.784 1.349-.32 2.722-.423 4.097-.398 2.209.04 4.414.011 6.62-.105.174-.01.35.006.527.02.147.013.294.025.44.024z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'cloud4':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '72',
	            height: '29',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'cloud4'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h72v29H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M53.178 16.628c-.536-.929-1.43-1.385-2.372-1.767-.982-.398-1.97-.782-2.954-1.173l-11.756-4.67c-1.241-.493-2.482-.992-3.737-1.45a19.516 19.516 0 0 0-1.53-1.097c-2.967-1.92-7.088-3.294-10.349-1.259a7.35 7.35 0 0 0-.777.56 6.804 6.804 0 0 0-2.53 1.367c-.413.352-.763.82-1.044 1.28-.28.458-.499.983-.639 1.502a5.463 5.463 0 0 0-.16 2.044 7.994 7.994 0 0 0-.127.33c-.09.249-.112.496-.147.761-.02.153-.042.297-.053.442h-.086c-3.164.02-6.326.103-9.486.245-1.425.064-2.606 1.047-2.799 2.497-.186 1.405.665 2.769 2.041 3.16 3.402.966 6.802 1.938 10.205 2.899 3.443.971 7.127 1.788 10.66.785a11.163 11.163 0 0 0 4.445-2.451 7.92 7.92 0 0 0 .79-.83c1.352.122 2.7.27 4.045.446 1.878.265 3.748.587 5.603.983.995.213 1.986.446 2.971.703.83.215 1.66.442 2.509.568 1.298.192 2.458.265 3.756-.003.574-.119 1.138-.363 1.655-.631a4.897 4.897 0 0 0 1.821-1.642c.701-1.07.676-2.507.045-3.599z',
	            fill: '#A1CBFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M71.724 24.4c-.013-.066-.032-.134-.051-.201-.066-.233-.134-.47.04-.72.051-.074-.02-.28-.091-.386-.27-.401-.672-.592-1.141-.621-.23-.015-.462-.015-.693-.015-.137 0-.273 0-.41-.003-1.949-.043-3.865-.28-5.698-.998-.695-.272-1.409-.412-2.157-.36-.164.01-.33.002-.494-.006l-.118-.006c-.36-.016-.64-.171-.919-.418-.612-.54-1.242-1.074-1.925-1.514-.326-.21-.719-.32-1.107-.427h-.001l-.003-.001c-.104-.03-.208-.058-.31-.089-.197-.059-.403-.089-.608-.118l-.012-.002c-.089-.013-.178-.026-.266-.041-.01-.053-.02-.1-.03-.142a1.122 1.122 0 0 1-.034-.211c-.03-1.09-.478-2.056-.918-3.005l-.149-.321c-.424-.928-1.174-1.597-2.2-1.93-1.025-.333-2.04-.568-3.124-.433-.574.072-.677-.003-.839-.562-.39-1.35-1.108-2.47-2.215-3.33-.536-.415-1.073-.793-1.797-.845a20.227 20.227 0 0 1-1.625-.205c-.267-.04-.533-.082-.8-.117a1.509 1.509 0 0 0-.365 0l-.401.04c-.616.057-1.233.115-1.803.41-.03.015-.074.006-.118-.004a.59.59 0 0 0-.063-.01c-.044-.057-.089-.112-.134-.168l-.001-.002a4.711 4.711 0 0 1-.28-.366c-1.192-1.797-2.568-3.4-4.413-4.566C32.699 1.599 30.844.776 28.809.416 28.01.275 27.2.202 26.388.129L25.955.09a4.905 4.905 0 0 0-1.1.021c-1.313.178-2.625.364-3.932.584a8.83 8.83 0 0 0-1.12.292c-.137.042-.274.084-.412.124a4.97 4.97 0 0 0-.348.119l-.009.003a7.292 7.292 0 0 1-.215.077c-.874.292-1.707.67-2.493 1.16-1.282.8-2.202 1.954-3.054 3.168-.636.907-.972 1.944-1.145 3.037a2.376 2.376 0 0 0-.017.141c-.02.202-.04.408-.26.503-.61.262-1.225.515-1.847.746-.17.063-.345.109-.52.154-.201.052-.402.104-.593.182-.777.317-1.51.697-2.059 1.386-.977 1.228-1.825 2.526-2.382 4.007-.692 1.841-.649 3.63.333 5.363.037.066.062.137.093.222v.003c.016.043.033.09.053.14a4.094 4.094 0 0 0-.206.058c-.13.039-.246.073-.363.076-.342.007-.683.046-1.025.085-.611.07-1.222.14-1.842.028-.256-.046-.532-.018-.794.016a1.207 1.207 0 0 0-.335.117 3.578 3.578 0 0 1-.175.075c.052.148.1.29.146.43.118.349.226.671.36.983.054.125.24.24.383.269l.27.056c.39.084.785.169 1.173.15 1.248-.062 2.495-.147 3.741-.231.77-.052 1.54-.104 2.309-.15a67.013 67.013 0 0 1 3.117-.134c.657-.01 1.315.005 1.972.019h.026c.396.009.791.017 1.186.02 3.145.025 6.285-.093 9.427-.224 1.982-.083 3.968-.087 5.953-.092h.009c.543 0 1.086-.002 1.63-.005a81.35 81.35 0 0 1 2.575.042l.083.002.824.02c.372.009.693-.034.78-.495.016-.077.082-.144.132-.194a.562.562 0 0 0 .045-.048c-.03-.118-.053-.233-.075-.344-.046-.234-.089-.45-.19-.634-.273-.492-.69-.733-1.304-.707-.748.03-1.499.031-2.249.031-.595 0-1.19 0-1.786.016-1.742.046-3.484.1-5.226.152l-.087.003c-1.677.051-3.354.102-5.031.146-1.761.047-3.523.072-5.284.097l-.778.012c-1.673.024-3.346.04-5.02.052-.53.003-1.06-.003-1.588-.037-.17-.01-.396-.078-.49-.202l-.032-.044c-.307-.408-.622-.827-.828-1.29-.357-.799-.144-1.64.069-2.427.242-.893.675-1.715 1.238-2.465.648-.862 1.308-1.712 2.34-2.115a22.18 22.18 0 0 1 2.387-.769c.22-.058.46-.045.726-.03l.007.001c.126.007.259.015.398.015.511-.337 1.18-.38 1.856-.34.599.036 1.152.243 1.685.523.277.146.582.306.817.137 0-.133-.003-.255-.005-.371-.004-.247-.008-.464.01-.678.025-.276-.08-.477-.256-.662a2.896 2.896 0 0 0-1.403-.844c-.447-.113-.9-.203-1.37-.296l-.011-.002c-.205-.04-.413-.082-.624-.126.005-.036.008-.077.01-.122.007-.111.015-.242.067-.352l.155-.34.005-.012c.219-.483.439-.967.728-1.403.373-.56.838-1.064 1.305-1.551a5.29 5.29 0 0 1 1.085-.888c.469-.279.98-.49 1.485-.7l.066-.028c1.602-.666 3.293-.953 5.003-1.12 1.634-.16 3.275-.137 4.87.27 1.063.272 2.098.677 3.12 1.088a10.783 10.783 0 0 1 4.854 3.825c.22.31.385.669.537 1.022.15.346.288.698.426 1.049l.003.006c.123.312.246.624.376.932.156.369.515.474.859.272.069-.04.128-.095.189-.151.03-.029.062-.057.094-.084.82-.676 1.749-1.064 2.816-1.013.461.022.921.08 1.381.139l.504.062c.765.089 1.294.547 1.757 1.126.38.474.541 1.034.703 1.593.06.208.12.415.192.618.023.068.012.181-.03.234-.167.208-.06.347.062.502l.025.033c.118.154.214.328.309.5l.005.01.006.01c.318.579.322.584.993.447l.202-.041.008-.002c.734-.152 1.474-.306 2.217-.173l.047.008c.958.172 1.947.349 2.427 1.408.067.147.172.283.282.404.295.325.34.71.387 1.136.025.223.004.454-.016.685-.045.512-.09 1.026.354 1.455.007.007.008.02.009.034 0 .009.001.018.004.026.21.66.507.896 1.182.942l.368.022a12.026 12.026 0 0 1 1.064.094l.034.004c.289.037.602.077.809.238.132.103.27.203.406.303.59.429 1.184.862 1.457 1.603.116.317.352.441.657.464.123.01.247 0 .371-.01h.001l.055-.005c1.254-.094 2.483-.05 3.658.497.403.188.847.31 1.285.396 1.688.331 3.396.468 5.114.447.282-.004.568-.062.843-.131.364-.092.388-.196.314-.574zm-25.79 2.858c-.04-.05-.078-.1-.117-.152-.26-.343-.523-.69-1.074-.666-.694.03-1.391.003-2.087-.026h-.003l-.294-.012c-.868-.034-1.736-.072-2.604-.111l-.062-.003c-.843-.038-1.686-.075-2.53-.109a21.03 21.03 0 0 0-.887-.01c-.255 0-.509.001-.762-.006l-2.604-.078a529.49 529.49 0 0 0-5.04-.14c-.466-.01-.933.029-1.412.068h-.002l-.005.001c-.223.019-.447.037-.675.051.006.2.055.376.1.538.072.262.136.49 0 .736.064.062.125.13.186.199l.002.002c.14.157.281.315.456.392.272.121.601.133.91.144l.048.001c.973.035 1.945.065 2.918.095 1.453.046 2.906.09 4.358.151 1.63.068 3.258.154 4.886.24.836.045 1.672.089 2.508.13.594.03 1.188.057 1.781.083l.062.003.134.006 1.078.049c.315.015.601-.046.86-.249.192-.15.238-.325.167-.541-.025-.074-.045-.151-.066-.229-.055-.203-.11-.407-.23-.557zm15.553-1.632c.554.024.841.345 1.017.822a.88.88 0 0 1 .035.144c.014.076.027.152.069.207.025.033.052.065.078.097.14.167.267.318.056.584l-.028.035c-.224.284-.418.528-.856.468a55.414 55.414 0 0 0-2.115-.233l-.745-.073c-.387-.04-.774-.077-1.162-.115-.81-.078-1.62-.157-2.429-.253a16.948 16.948 0 0 1-1.923-.345c-.159-.038-.3-.16-.44-.278-.049-.043-.098-.085-.148-.124-.179-.137-.152-.31-.124-.488.007-.045.014-.09.018-.136a6.36 6.36 0 0 0 .01-.649c-.002-.107-.003-.22-.003-.34l.154-.01c.092-.008.17-.014.246-.007l2.983.26c1.057.092 2.114.185 3.172.276l.205.018c.643.055 1.286.11 1.93.14z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'cloud5':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '44',
	            height: '26',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'cloud5'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h44v26H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M40.272 15.6c-.164-.741-.72-1.345-1.314-1.752-3.172-2.177-6.651-3.891-10.266-5.144-.372-.129-.752-.257-1.137-.381-.696-2.922-2.862-5.543-5.785-6.234-1.645-.39-3.51-.276-4.994.615a2.69 2.69 0 0 0-1.894.116c-.783.339-1.462 1.019-1.656 1.9-.174.79-.407 1.563-.694 2.316a16.684 16.684 0 0 1-1.678 2.947 16.244 16.244 0 0 1-2.296 2.366c-.366.27-.744.519-1.12.778-1.106.764-2.015 1.774-2.2 3.18-.125.957.09 1.842.667 2.609.49.65 1.167 1.154 1.964 1.332 1.014.225 1.993.027 2.995-.126 3.712-.496 7.443-.833 11.18-1.008.03.017.058.035.087.05.664.36 1.468.54 2.204.296.322-.107.633-.258.912-.457l.537-.01c.093.009.184.011.275.007.07-.003.141-.01.212-.016a129.082 129.082 0 0 1 11.244.33c.253-.036.507-.07.76-.105.372-.091.696-.266.973-.526.472-.374.888-.909 1.024-1.523a3.582 3.582 0 0 0 0-1.56z',
	            fill: '#A1CBFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M42.813 13.918c-.435-.53-.942-1.006-1.63-1.183-.918-.236-1.847-.38-2.8-.287-.244.024-.49.04-.735.05-.268.01-.455-.11-.603-.353-.687-1.132-1.497-2.157-2.596-2.899a11.21 11.21 0 0 0-1.278-.725l-.386-.194c-.626-.316-1.253-.631-1.905-.874-.344-.128-.646-.315-.949-.501a14.227 14.227 0 0 0-.337-.204c-.13-.075-.232-.239-.297-.386a10.009 10.009 0 0 0-2.02-2.979C25.56 1.624 23.43.684 21.106.217 19.47-.112 17.799.013 16.15.231l-.19.024h-.004c-.569.068-1.166.139-1.523.735-.008.013-.029.02-.047.025l-.007.002c-.691.22-1.281.624-1.87 1.029h-.002c-.243.168-.487.335-.738.489-.834.512-1.388 1.298-1.603 2.287-.094.434-.155.876-.216 1.317v.005l-.05.354c-.052.367-.209.614-.588.703-1.376.322-2.374 1.24-3.196 2.328-.944 1.25-1.31 2.69-.888 4.268l.004.015c.146.547.146.55-.307.837-.156.1-.316.194-.476.288-1.062.621-1.971 1.431-2.77 2.373-.598.704-1.133 1.442-1.139 2.442 0 .166-.026.343-.088.494-.222.546-.233 1.117-.243 1.689l-.004.236c-.008.315.005.63.026.945.047.71.209 1.362.866 1.764a.92.92 0 0 1 .296.316c.156.268.37.277.636.226.29-.055.424-.233.458-.509.026-.206.047-.416.042-.623-.006-.223-.02-.446-.035-.669a9.987 9.987 0 0 1-.028-1.216c.07-1.19.346-2.32 1.135-3.261.772-.922 1.71-1.64 2.721-2.237.74-.436 1.548-.78 2.43-.829l.069-.003c.447-.025.897-.05 1.343-.02.467.03.933.095 1.398.16l.36.05c.066.008.13.02.195.032.272.05.544.098.814-.076-.013-.536-.099-1.01-.52-1.366-.08-.066-.132-.167-.184-.267l-.001-.002c-.018-.032-.034-.065-.052-.096-.208-.362-.502-.613-.905-.702l-.228-.052-.008-.002c-.302-.071-.606-.143-.909-.147-.427-.005-.854.021-1.282.047h-.007c-.245.016-.49.03-.734.04-.158.005-.317-.006-.484-.018h-.002c-.079-.005-.16-.011-.244-.015a4.456 4.456 0 0 1 1.062-2.762c.797-.958 1.753-1.657 3.1-1.416.151.027.329-.02.478-.077.324-.123.457-.37.433-.735-.013-.2-.031-.398-.05-.597-.042-.45-.084-.898-.06-1.343.054-.968.591-1.741 1.21-2.419.412-.452.89-.893 1.42-1.173 1.327-.696 2.75-1.087 4.258-1.045 1.192.033 2.381.114 3.485.63a13.808 13.808 0 0 1 3.21 2.083c.532.462.884 1.057 1.127 1.777l-.183.025h-.002c-.101.015-.18.027-.258.029-1.24.031-2.457.232-3.587.76-.471.221-.903.534-1.332.846l-.005.003a35.11 35.11 0 0 1-.313.225c-.113.08-.191.268-.214.418-.025.164-.02.333-.014.504.003.073.005.147.005.22.024.017.047.033.07.047l.002.002h.001a.828.828 0 0 1 .134.1c.732.718 1.47.714 2.326.165 1-.643 2.108-1.06 3.317-.963.446.036.889.11 1.332.182h.003c.344.058.688.115 1.033.154 1.03.117 1.915.575 2.767 1.138l.044.029c.191.127.394.26.608.305.403.085.697.31 1 .573.577.502.963 1.122 1.278 1.821.156.348.177.601-.02.928-.297.491-.413 1.034-.274 1.57l1.3.804c.026-.025.055-.048.082-.07.057-.046.11-.09.143-.145.305-.533.798-.756 1.349-.907a7.947 7.947 0 0 1 2.987-.216c.528.057.99.23 1.29.734.125.213.305.398.485.567.358.335.698.301 1.003-.083a7.07 7.07 0 0 0 .25-.341l.102-.145c.03-.775-.385-1.266-.787-1.742l-.003-.003-.15-.18zM31.35 21.513c.32-.046.711-.19.71-.486 0-.068.01-.143.02-.222.036-.272.076-.582-.277-.75a.428.428 0 0 1-.194-.233c-.164-.494-.542-.588-.98-.576a70.363 70.363 0 0 0-2.642.112h-.002c-.714.04-1.43.08-2.145.1-.658.02-1.306.05-1.94.261-.25.083-.523.105-.787.123l-.31.02-.016.002c-1.65.113-3.299.225-4.949.32l-.3.017-.08.005c-.896.053-1.794.106-2.69.082a52.026 52.026 0 0 1-.612-.02l-.013-.001c-.977-.038-1.951-.075-2.921.145-.143.033-.297.02-.45.007h-.006c-.051-.005-.102-.01-.153-.012-.153-.007-.307-.02-.46-.032h-.006a35.193 35.193 0 0 0-.205-.017c-1.06.02-2.072.286-3.075.595-.031.01-.064.02-.098.028h-.002c-.206.056-.427.116-.431.399-.005.278.075.536.394.64.093.03.2.15.224.248.08.328.327.431.591.467.281.038.572.026.856.002.51-.044 1.021-.093 1.532-.142.855-.082 1.711-.165 2.569-.223.745-.05 1.493-.076 2.24-.102.523-.018 1.045-.036 1.567-.063 1.045-.053 2.089-.11 3.133-.168l.041-.002c1.54-.085 3.081-.17 4.622-.241 1.58-.073 3.16-.127 4.742-.181.732-.025 1.465-.05 2.197-.077.102-.004.205-.01.306-.025zm4.912 1.63c.797-.1 1.58-.18 2.226.14.069.091.129.174.184.25.109.151.2.277.305.387.254.264.266.867-.001 1.118-.32.303-.719.38-1.134.403l-.629.032c-.403.019-.807.039-1.21.067-.581.04-1.162.086-1.743.132-1.09.085-2.182.17-3.274.226-1.109.056-2.22.071-3.33.086L26.566 26a1.915 1.915 0 0 1-.546-.077c-.13-.037-.357-.142-.351-.196.027-.26-.145-.415-.318-.573-.208-.19-.419-.381-.285-.757.208-.583.274-.694.904-.709.617-.014 1.235-.027 1.852-.039a191.45 191.45 0 0 0 4.775-.134c1.124-.05 2.245-.192 3.363-.334l.3-.038z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'coffee':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '75',
	            height: '83',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'coffee'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h75v83H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M10.647 32.54a2.053 2.053 0 0 1 1.368-2.572c.83-.255 1.503-.491 3.028-1.048 3.257-1.19 4.754-1.65 6.766-1.932 1.128-.159 3.085-.034 4.994.24.849.122 1.544.256 1.983.394.219.07.406.145.61.266.266.16.5.356.711.682.248.384.364.838.328 1.29.164 1.121-.638 2.301-1.96 2.362-1.722.079-2.945.061-4.672-.028-1.22-.063-1.372-.07-1.818-.07a11.353 11.353 0 0 0-2.54.273c-.123.403-.37.768-.719 1.035l-.025.046c-.177.332-.27.492-.443.717a2.887 2.887 0 0 1-1.234.957c-1.369.55-3.342.08-4.222-1.17-.95.08-1.861-.502-2.155-1.442z',
	            fill: '#C7C7DA'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M15.212 34.128l-.115-.002c.017-.061.014-.087-.106-.001l-.38-.005a717.488 717.488 0 0 1-2.879-.039 2.064 2.064 0 0 0-2.083 2.365 3.672 3.672 0 0 0-.311 1.462c-.013.768.126 1.467.456 2.703l.052.192c.26.962.342 1.318.365 1.598.044.533.255 1.453.537 2.205.567 1.51 1.356 2.553 2.868 2.733.634.076 1.263.146 1.894.212l.076.084c.06.065.121.125.195.19.191.164.387.295.697.403.69.239 1.498.116 2.074-.398 3.405.273 7.183.45 12.36.622.48.016.904.064 1.952.21l.401.055c2.935.396 4.62.29 6.325-.949 2.448-1.779 3.516-5.143 3.365-8.656-.055-1.277-.89-2.138-2-2.487-.54-.17-1.063-.217-1.794-.218-.113 0-.203 0-.388.002a7.978 7.978 0 0 1-.589-.004c-1.656-.12-3.074-.148-5.835-.154h-.236c-3.434-.006-4.942-.045-6.786-.23-1.872-.186-3.49-.357-4.868-.514a33.591 33.591 0 0 0-3.584-.695c-.399-.365-.408-.37-.653-.485a3.587 3.587 0 0 0-.374-.133l-.088-.019-.009-.001a3.405 3.405 0 0 0-.227-.033h-.009a3.44 3.44 0 0 0-.09-.007l-.037-.001a8.206 8.206 0 0 0-.176-.005zm-3.798 32.86c.06-1.509 1.703-2.453 3.06-1.723l.614.33c1.816-.155 4.308-.118 6.772.105 2.879.26 5.493.747 7.423 1.444 1.209.436 2.176.959 2.887 1.624 1.01.944 1.484 2.186 1.171 3.525-.452 1.934-1.148 3.884-2.07 5.87-.11.237-.177.384-.25.53-.607 1.246-1.264 2.047-2.48 2.424-2.233.69-5.704.953-8.686.56-3.387-.447-6.075-1.664-7.552-3.822a2.195 2.195 0 0 1-.61-1.1 7.194 7.194 0 0 1-.116-.282c-.742-1.915-.746-3.418-.372-6.7l.044-.394a2.223 2.223 0 0 1 .165-2.391z',
	            fill: '#EDE7F6'
	          }),
	          _react2.default.createElement('path', {
	            d: 'M10.824 48.536c6.07.42 12.498 3.185 18.633 3.4 3.664.128 7.337-3.242 10.456-1.39 3.876 2.3-2.634 8.575-4.146 12.797-.892 2.491-21.38 1.373-22.94-1.314-1.286-2.216-2.954-9.523-1.3-7.562l.333-5.08c1.887 2.236 2.27 11.308 2.467 8.398l1.136 2.007c.21-3.087-1.093-6.197-.644-9.258.205-1.4.824 2.718 1.415 4.006 1.224 2.664 2.399 10.273 4.02 7.826 2.168-3.272-5.42-11.946-1.484-11.654 4.502.334 1.663 12.84 6.097 11.997 4.267-.812-1.589-8.484-2.03-12.77-.146-1.429.598 2.823 1.144 4.152 1.3 3.166 1.481 7.442 4.38 9.29 2.361 1.505-1.865-14.237-1.04-12.728 2.454 4.49 1.8 10.756 5.486 14.32 1.779 1.72-.456-12.82-.56-13.855-.092-.908.123 1.844.423 2.706.956 2.74.834 9.564 3.326 8.049 2.983-1.813-.403-7.057.542-10.4.307-1.085.71 3.784 1.545 3.017 1.097-1.008.01-2.967.016-4.45',
	            stroke: '#C4AF89',
	            strokeWidth: '4.125',
	            strokeLinecap: 'round',
	            strokeLinejoin: 'round'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M55.963 20.408c-.885 1.582 1.027 3.245 2.493 2.168l.562-.414c1.514-.135 4.225-1.284 9.006-3.682.966-.485 1.165-1.384.971-2.203a2.511 2.511 0 0 0-.624-1.153c-.05-.051-.104-.1-.16-.144l-2.09-1.657v-.056c-.004-.426-.015-.626-.076-.925-.115-.558-.379-1.056-.852-1.438-.87-.7-1.814-.555-2.61-.038-.212.137-.398.29-.608.485-.04.036-.115.108-.18.169l-.01.01-.013.013-.004.003-.019.018-.012.012-.009.008-.04.039c-1.794 1.656-2.808 3.238-4.63 6.733l-.21.401a63.85 63.85 0 0 1-.885 1.651zm-9.144 1.658c-1.52 1.357-3.714-.62-2.5-2.25.438-.587.78-1.07 1.548-2.174 1.597-2.295 2.348-3.303 3.43-4.494.382-.42 1.052-.85 1.69-1.142.398-.182.739-.296 1.115-.32.655-.04 1.312.161 1.72.933.135.254.202.491.218.716l.272.641a1.67 1.67 0 0 1-.097 1.501c-1.023 1.742-2.449 3.031-4.826 4.676-.071.05-.253.173-.478.327l-.044.03-.046.031c-.434.296-.99.675-1.263.865l-.74.66zM24.764 35.983c.37.069.679.124.95.167.304.115.585.177.943.206 2.595.21 5.064.217 7.426-.002 2.082-.192 3.4-.38 5.527-.74 1.386-.235 1.797-.28 2.1-.239.034.005.063.007.089.01h.012c.023.002.045.003.067.006.236.033.447.241 2.94 2.69l.136.134.095.092.813.798c.612.602 1.402.677 2.12.49.33-.086.644-.235.918-.472.504-.439.785-1.118.592-1.86-.24-.921-.544-1.58-1.274-2.94l-.076-.142a19.95 19.95 0 0 1-.59-1.171 76.355 76.355 0 0 0 4.203-1.733c.113-.05.215-.103.328-.18.118-.08.23-.173.342-.302.25-.287.422-.652.416-1.13-.007-.594-.223-.937-.725-1.363-.248-.138-.332-.186-.422-.217a1.904 1.904 0 0 0-.165-.047h-.002a1.855 1.855 0 0 0-.44-.053 4.976 4.976 0 0 0-.816.082c-.596.096-1.394.268-2.157.468-.932.245-1.763.518-2.409.808-.433.195-.793.401-1.091.645a2.616 2.616 0 0 0-.584.651 26.24 26.24 0 0 1-2.358.58c-.148.028-.39-.019-1.083-.244-.987-.32-1.466-.434-2.175-.415a3.822 3.822 0 0 0-.438.037c-.1.014-.197.037-.293.068l-3.447 1.131.083-.15.147-.265.016-.028.002-.004c1.01-1.805 1.341-2.47 1.589-3.404.445-1.679-.013-3.18-1.599-3.98-1.674-.846-3.167-.127-3.941 1.453-.4.814-.604 1.642-.95 3.479l-.046.241-.045.24c-.234 1.227-.42 2.006-.617 2.523l-.761.33c-.312.136-.575.36-.756.645a1.17 1.17 0 0 1-.189.023 3.197 3.197 0 0 1-.504-.018c-.058-.03-.13-.068-.214-.114a7.092 7.092 0 0 0-.718-.355 1.708 1.708 0 0 0-.747-.128l-2.172.115h-.01l-.002.001c-2.256.12-2.077 3.478.18 3.36.36-.019.779.037 1.782.223zm40.14-11.882l-2.5 1.89c-1.8 1.36.256 4.036 2.055 2.676l2.5-1.89c1.8-1.36-.257-4.036-2.055-2.676zm-28.01-3.575l1.819 1.175c1.895 1.224 3.746-1.596 1.851-2.82l-1.82-1.175c-1.894-1.224-3.745 1.595-1.85 2.82zM17.175 17.66c.332-.425.607-.82.852-1.212-.324.337-.695.803-1.225 1.516l-.033.046c-.387.52-.705.934-.997 1.285.452-.47.917-1.01 1.403-1.635zm5.515-1.119c-.109.198-.511.986-.675 1.283a17.51 17.51 0 0 1-1.56 2.352l-.058.074c2.248-1.267 4.073-2.479 5.378-3.597-1.761-.14-2.633-.168-3.085-.112zM6.238 27.607a.467.467 0 0 0-.074.072c.174.166.379.11.991-.175.195-.092.4-.202.624-.335-.583.143-.91.243-1.54.438zm16.528-11.192l.008-.009-.003.004-.005.005zM1.98 24.065c-.677-2.964 2.473-6.407 7.704-10.013 4.549-3.135 9.48-5.434 12.375-5.507a2.07 2.07 0 0 1 2.092 1.685c.631.014 1.257.184 1.824.469.332.167.61.378.866.632.108.107.191.198.294.32a9.215 9.215 0 0 0 .392-.126c.947-.313 1.185-.381 1.7-.422 1.392-.108 2.667.708 2.807 2.286.139 1.564-.494 3.066-1.699 4.524-1.7 2.056-4.582 4.093-8.475 6.24-1.64.903-3.334 1.76-5.319 2.71.053-.026-2.972 1.405-3.367 1.61a7.12 7.12 0 0 0-.73.478c-.123.088-.934.679-1.196.864-.874.62-1.587 1.063-2.325 1.408-2.484 1.162-4.874.854-6.405-1.53-.906-1.411-.674-3.075.201-4.322-.348-.312-.612-.747-.74-1.305z',
	            fill: '#CD8168'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M51.55 29.738c-.57.136-1.151.234-1.717.39-.797.219-1.525.54-2.012 1.281-.316.483-.342.94-.076 1.408.422.742.853 1.483 1.339 2.185.24.346.325.639.176 1.035-.177.467-.278.963-.454 1.43-.287.76-.854 1.09-1.67 1.011-.104-.01-.205-.042-.309-.058-.92-.142-.92-.142-1.562-.884l.007-.026a1.219 1.219 0 0 0-.167-.162c-.459-.345-.928-.67-1.345-1.065-.232-.219-.46-.462-.693-.704-.307-.215-.624-.443-.977-.57a.312.312 0 0 1-.185-.167 1.011 1.011 0 0 1-.07-.042c-.436-.292-.847-.627-1.423-.547-.182.025-.38.02-.541.091-.613.27-1.212.57-1.822.847-.166.076-.35.161-.527.163-1.197.014-2.396.057-3.59-.005-2.117-.11-4.23-.286-6.345-.435-2.114-.148-4.228-.296-6.342-.448-.291-.021-.58-.07-.949-.116.174-.564.549-.893 1.002-1.075.93-.374 1.87-.682 2.915-.68 1.298.001 2.597-.143 3.894-.24.334-.025.667-.095.993-.172.86-.203 1.65-.499 1.961-1.451.057-.174.147-.337.245-.508.123-.515.435-1.003.585-1.506a.32.32 0 0 1 .06-.114.652.652 0 0 1 .122-.187c.343-.807.393-1.172.393-1.192.004-.817.115-1.672.6-2.359.289-.408.921-1.08 1.498-.854.079.03.145.076.199.133h.06l-.024.042c.13.163.172.395.128.603-.071.334-.321.608-.553.846-.233.24-.459.485-.684.733-.084.092-.176.191-.263.297a52.086 52.086 0 0 0-.742 1.907c-.041.392-.028.572-.133 1.056-.016.078-.062.628-.082.714.008.215.015.419.024.622.038.864.46 1.231 1.343 1.265.369.014.734.15 1.099.24.356.09.684.06 1.041-.063.559-.193 1.093-.411 1.564-.771.066-.05.182-.07.21-.132.194-.442.504-.402.844-.314.43-.119.867-.025 1.304.086.6.153 1.249.203 1.867.237.62.034 1.254.034 1.861-.11.406-.097.744-.356 1.131-.495.237-.341.48-.693.745-1.028.099-.124.304-.206.471-.226.246-.031.503-.006.752.024 1.277.152 2.556.18 3.823-.041.593-.104 1.163-.342 1.744-.517.113-.034.228-.058.429-.108-.339.454-.74.622-1.172.726zm-9.107 8.647c-.373 1.238-.75 2.474-1.15 3.704-.438 1.346-.908 2.682-1.352 4.026-.056.171-.037.366-.064.67-.35.067-.693.154-1.04.194-.646.075-1.293.151-1.942.176-.775.029-1.553-.011-2.33.007-.898.021-1.797.056-2.694.115-.98.065-1.958.188-2.939.238-.315.016-.636-.151-.959-.183a48.656 48.656 0 0 0-2.188-.164c-.585-.032-1.172-.01-1.755-.053-1.232-.09-2.464-.185-3.692-.317-1.397-.15-2.788-.352-4.184-.518-1.738-.206-3.426-.602-5.107-1.27-.016-3.508.208-7.026-.455-10.644.372.11.628.13.82.25.92.58 1.975.758 2.99 1.07 1.402.43 2.873.356 4.28.7.835.203 1.673.401 2.518.547.492.084 1.002.053 1.503.085.607.04 1.213.087 1.819.136.982.08 1.964.165 2.946.247 1.568.13 3.136.277 4.706.383 1.57.105 3.143.09 4.717.003.837-.047 1.68.019 2.519-.024.727-.037 1.451-.15 2.176-.24.325-.04.694-.245.96 0 .286.264-.018.58-.103.862zM41.023 50.1c-.321 1.853-.847 3.646-1.527 5.403-.571 1.477-1.073 2.981-1.6 4.475-.223.63-.44 1.261-.644 1.898-.126.396-.231.786-.018 1.211.071.143-.038.393-.102.581-.12.353-.29.69-.399 1.046-.126.413-.354.61-.792.763-2.4.833-4.887.822-7.357.723a30.503 30.503 0 0 1-6.163-.895c-1.425-.356-2.877-.603-4.322-.873-.947-.178-1.905-.294-2.851-.471-.322-.06-.618-.251-.939-.333-.77-.198-1.55-.365-2.324-.547-.345-.081-.687-.17-1.002-.247-.22-1.722-.455-3.392-.64-5.067-.134-1.202-.19-2.413-.305-3.618-.112-1.163-.288-2.32-.374-3.484-.056-.766-.017-1.54.008-2.309.014-.455.085-.91.135-1.409.162.027.304.033.433.076.974.324 1.931.705 2.92.97.95.254 1.925.436 2.9.568 1.954.265 3.913.5 5.875.698 1.44.145 2.893.174 4.333.32 2.495.253 4.992.127 7.49.115.94-.004 1.883.084 2.823.061.753-.017 1.502-.193 2.253-.195.696-.002 1.351-.196 2.163-.316.013.337.07.605.026.856zm-8.186 21.056c-.54 1.318-.762 2.766-1.115 4.159-.22.867-.408 1.743-.63 2.61-.198.773-.835 1.176-1.45 1.573-.158.102-.401.078-.606.105-.333.043-.665.062-.799.469-.034.105-.202.216-.323.235-.558.087-1.123.207-1.683.198-2.35-.04-4.687-.282-7.012-.625-1.36-.2-2.654-.618-3.897-1.2a11.4 11.4 0 0 0-.932-.381c-.767-.279-1.387-.775-1.98-1.31-.248-.224-.344-.505-.313-.844.138-1.535.263-3.071.396-4.606.187-2.161-.242-1.061-.076-3.224.052-.663.004-1.334.008-2.002.002-.246.021-.492.036-.816.413.044.783.055 1.14.127.72.146 1.427.345 2.147.486.759.147 1.528.244 2.29.377.847.148 1.694.299 2.536.473 2.076.428 4.136.937 6.25 1.163 1.085.117 2.168.281 3.257.331.92.043 1.846-.05 2.769-.08.27-.008.541-.001.91-.001-.537 2.053-.128.843-.923 2.782zM9.057 30.038c-.85.197-1.646.61-2.48.884-.693.227-1.403.413-2.115.576-.615.14-.84-.052-1.078-.847.106-.008.205-.03.301-.02a3.265 3.265 0 0 0 1.657-.261c.357-.152.771-.168 1.156-.26.468-.114.95-.2 1.395-.377 1.908-.76 3.793-1.564 5.51-2.721a312.598 312.598 0 0 1 5.991-3.916c2.08-1.334 4.197-2.613 6.262-3.97.96-.63 1.836-1.384 2.748-2.085.613-.472 1.198-.984 1.84-1.414a8.504 8.504 0 0 0 1.717-1.548c.159-.184.27-.408.418-.634.301.073.28.382.46.552-.368.514-.73.994-1.062 1.494-.172.26-.323.509-.659.595-.131.034-.241.162-.355.254-.68.553-1.364 1.1-2.03 1.667-.165.14-.247.371-.405.522-.176.167-.396.288-.594.433-.344.25-.686.504-1.03.756l.007-.009c-.537.395-1.131.735-1.589 1.206-.27.277-.551.513-.855.739-.334.248-.672.49-1.003.743-.193.147-.374.272-.472.546-.076.212-.376.387-.615.495a12.45 12.45 0 0 0-2.995 1.924c-.031.027-.068.07-.101.07-.909-.017-1.416.846-2.245 1.014-.147.03-.269.188-.402.287-.115.087-.216.203-.345.257-.67.278-1.357.515-2.017.814-.928.421-1.902.728-2.78 1.286-.674.429-1.42.758-2.236.948zm-6.468-1.702c-.49-.02-.646-.251-.628-.751.015-.438.192-.799.615-1.107.477.487 1.06.375 1.677.328.625-.049 1.192-.23 1.763-.43 1.148-.404 2.307-.785 3.43-1.249 2.268-.935 4.536-1.876 6.653-3.13a221.79 221.79 0 0 1 2.821-1.65c.378-.216.777-.395 1.166-.59l.073.101c-.422.268-.85.528-1.266.805-1.45.96-2.888 1.938-4.344 2.89-1.174.766-2.345 1.54-3.555 2.248-1.676.98-3.49 1.634-5.388 2.057-.47.105-.924.29-1.398.366a8.263 8.263 0 0 1-1.619.112zm.777-5.848c1.48-.248 2.871-.767 4.242-1.355 2.504-1.072 5.02-2.117 7.516-3.207 2.064-.9 4.005-2.024 5.777-3.413a28.41 28.41 0 0 0 2.403-2.111c.607-.598 1.12-1.29 1.674-1.941l.377-.443c.593.656.859 1.403.914 2.227a.88.88 0 0 1-.389.81c-.24.168-.483.334-.713.514-.427.334-.848.674-1.265 1.019-.644.531-1.273 1.068-2.036 1.448-1.048.522-2.066 1.106-3.083 1.688-.415.237-.793.54-1.19.81-.587.398-1.183.777-1.86 1.016-.15.053-.281.171-.405.278-.205.178-.398.324-.702.355-.228.022-.455.2-.652.35-.345.26-.668.55-1.091.906l-.16-.296c-.033.011-.094.012-.109.038-.157.273-.398.382-.702.45-.28.063-.576.172-.799.345-.86.665-1.831 1.07-2.869 1.364-.602.17-1.18.424-1.78.605a3.64 3.64 0 0 1-.964.17c-.434.012-.88.236-1.284.441-.367.187-.511.225-.675-.109a9.924 9.924 0 0 1-.569-1.386c-.132-.418-.061-.497.394-.573zm2.227-3.432c1.152-.791 2.32-1.558 3.471-2.35 1.086-.746 2.261-1.336 3.408-1.976.128-.072.267-.126.39-.204 1.01-.634 2.008-1.288 3.03-1.904.698-.42 1.423-.798 2.144-1.18a482.642 482.642 0 0 1 4.384-2.307c.193-.1.423-.128.635-.19l.097.116c-.135.187-.243.402-.408.556-1.16 1.086-2.361 2.132-3.493 3.246-1.081 1.064-2.413 1.693-3.733 2.38-2.102 1.096-4.341 1.87-6.488 2.858-.703.323-1.393.674-2.104.975-.63.266-1.28.48-1.923.718l-.101-.138c.23-.202.44-.429.69-.6zm22.79-7.476c.487-.302.997-.276 1.51-.104.337.113.436.307.234.561-.539.68-.904 1.514-1.818 2 .4-.847-.053-1.648.074-2.457zm-1.874 8.567l-.06-.048.25-.372.4-.03-.59.45zm-3.652 8.874c.782-.032 1.546.026 2.319.14.97.142 1.953.217 2.93.32.246.025.492.046.782.074-.08.465-.41.618-.753.683-.575.111-1.16.187-1.745.235-1.338.11-2.69.12-4.016.308-1.644.234-2.999 1.031-3.924 2.452-.08.123-.14.27-.247.36-.117.097-.287.213-.419.196-2.23-.277-4.456-.588-6.523-1.547-.073-.034-.136-.09-.258-.173 1.124-.68 2.102-1.483 3.325-1.826.646-.18 1.297-.331 1.878-.684.053-.032.123-.072.175-.061.55.11 1-.25 1.512-.309.229-.025.457-.06.687-.065 1.426-.035 2.852-.044 4.277-.103zm31.22-1.914c-.535-.195-1.083-.315-1.658-.113-.435.153-.89.252-1.323.408-1.358.486-2.736.757-4.19.545-.515-.075-1.047-.045-1.571-.048-.857-.004-1.525.277-1.965 1.086-.418.77-.908.848-1.749.57-.833-.276-1.687-.592-2.55-.655-.956-.07-1.828-.401-2.745-.578-.397-.076-.774-.255-1.205-.402.427-.607.836-1.135 1.187-1.699.538-.86.888-1.789.356-2.765-.22-.406-.601-.74-.952-1.06-.784-.713-1.952-.753-2.821-.138-.154.109-.333.185-.48.3-.224.179-.454.36-.642.573-.608.69-.865 1.53-.9 2.421-.026.718-.384 1.255-.768 1.83-.872-.07-1.728-.134-2.584-.207-.397-.033-.804-.037-1.189-.13a11.743 11.743 0 0 0-4.371-.215c-.105.014-.216-.016-.376-.03.088-.111.117-.169.164-.204 1.625-1.253 3.348-2.373 4.91-3.714 1.141-.98 2.367-1.863 3.544-2.803.72-.575 1.417-1.18 2.13-1.765.353-.292.76-.533 1.066-.867.464-.509.875-1.068 1.278-1.628.153-.212.33-.494.309-.728-.083-.936-.234-1.864-.95-2.583-.574-.579-1.103-1.205-1.704-1.753-.33-.3-.766-.486-1.158-.715-.144-.084-.308-.133-.452-.217-.978-.573-2.008-.838-3.133-.523-.267.075-.434-.006-.578-.234-.177-.282-.355-.576-.59-.807-.258-.256-.478-.491-.538-.878-.026-.17-.224-.351-.39-.455-.503-.312-1.042-.558-1.654-.535-.395.016-.787.1-1.182.117-.542.025-1.02.221-1.49.465-.89.465-1.787.919-2.675 1.388-.296.157-.578.342-.86.524-.51.328-1.01.672-1.524.994-.426.266-.87.505-1.301.765-.914.552-1.819 1.12-2.739 1.66-.414.244-.898.384-1.277.667a24.519 24.519 0 0 1-2.788 1.78c-.292.163-.562.365-.837.555-.552.381-1.082.797-1.655 1.145-.879.532-1.705 1.108-2.424 1.859-.597.624-1.172 1.233-1.544 2.025-.203.431-.333.912-.76 1.236-.24.18-.234.48-.115.797.278.739.5 1.498.744 2.252-1.503 1.21-1.702 2.32-1.07 4.03.351.947.914 1.823 1.446 2.693.277.453.667.85 1.057 1.222.31.296.683.533 1.051.761.673.417 1.38.536 2.161.27.594-.203 1.219-.32 1.832-.461.133-.031.28-.005.396-.005.577 3.572.535 7.121.34 10.721a965.5 965.5 0 0 0-.4-.143c-.312.23-.43.556-.455.916-.039.571-.077 1.144-.084 1.716-.014 1.147-.007 2.295-.007 3.442 0 .228-.01.457.014.683.091.827.242 1.65.285 2.48.12 2.312.21 4.626.53 6.923.092.66.168 1.323.263 1.983.017.114.093.22.147.327.139.271.403.545.393.81-.017.48.233.787.486 1.106.22.28.332.578.325.924-.025 1.084-.026 2.17-.092 3.253-.054.894.113 2.577-.01 4.156-.046.583-.086 1.167-.178 1.743-.11.684-.094 1.344-.016 2.04.101.91.573 1.49 1.23 2.009 1.218.963 2.473 1.851 3.95 2.413 1.575.6 3.147 1.164 4.842 1.334 1.38.139 2.75.354 4.128.502 1.71.184 3.424.418 5.128-.057.52-.145 1.08-.134 1.546-.478.452-.335.918-.66 1.415-.922.85-.447 1.135-1.25 1.394-2.065.15-.473.192-.978.307-1.463.32-1.36.616-2.726.994-4.07l1.748-5.217c.073-.306.212-.431.495-.45.272-.018.549-.002.816-.046.477-.078.692-.296.636-.764-.083-.695.198-1.273.495-1.845.528-1.014.884-2.06.793-3.223-.015-.183 0-.378.05-.554.192-.661.374-1.328.615-1.972.774-2.072 1.543-4.145 2.143-6.276.414-1.474.78-2.94.566-4.498-.099-.716-.325-1.318-.937-1.813.438-1.21.91-2.414 1.31-3.642.395-1.216.72-2.455 1.094-3.75.284.159.475.28.679.377.357.17.707.402 1.085.469 1.023.18 2.05.183 3.042-.207.72-.283 1.254-.75 1.471-1.514.223-.781.45-1.562.654-2.348.133-.515.004-.98-.309-1.418-.388-.545-.764-1.101-1.094-1.681-.341-.6-.237-.858.423-1.071.558-.18 1.132-.331 1.71-.421 1.147-.179 2.023-.792 2.755-1.629.193-.22.343-.541.37-.83.07-.715-.613-1.737-1.288-1.983zM37.79 18.309c.373-.233.578-.208.869.12.096.11.185.23.258.356.335.578.663 1.16 1.015 1.778-.974-.402-1.86-1.019-2.973-.81.069-.509.498-1.236.83-1.444zm6.718 3.277c.555-1.04 1.06-2.116 1.703-3.098.813-1.242 1.254-2.667 2.014-3.926.5-.83 1.278-1.332 2.156-1.641.531-.187 1.06-.347 1.552-.64.608-.365.996-.262 1.447.294.146.18.263.394.436.538.361.3.4.654.288 1.08-.084.327-.125.665-.177 1-.067.423-.262.765-.64.963-.442.233-.888.468-1.354.648-.969.374-1.776.903-2.197 1.93-.104.253-.33.528-.57.64-.999.465-1.798 1.222-2.709 1.814-.42.273-.864.506-1.289.771-.35.218-.687.455-1.03.683l-.091-.052c.152-.336.288-.68.46-1.004zm-5.704 5.682l.26-.257.065.098-.325.159zM36.74 21.68c.287.205.605.237.934 0a.631.631 0 0 1 .519-.069c.378.15.797.225 1.08.59.186.24.47.322.792.272.245-.037.502.011.749-.022.251-.035.495-.122.788-.199-.048.166-.067.271-.107.367-.307.741-.616 1.482-.93 2.22a1.367 1.367 0 0 1-.223.382c-.548.606-1.02 1.29-1.736 1.728-.172.105-.3.283-.449.427l.078.085c.169-.05.338-.098.508-.147-.13.547.04 1.026.501 1.33.42.275.8.116 1.155-.153.15-.114.276-.261.431-.367.205-.14.414-.318.643-.364.426-.087.696-.344.967-.65a6.36 6.36 0 0 1 .857-.822c.879-.678 1.773-1.335 2.668-1.99.32-.235.658-.44.987-.66.66-.443 1.32-.883 1.977-1.329.568-.385 1.098-.85 1.709-1.14.436-.208.734-.45.9-.89a2.04 2.04 0 0 1 1.024-1.153c.505-.25 1.025-.47 1.534-.713.592-.283 1.237-.594 1.453-1.237.373-1.113.746-2.248.556-3.47-.075-.477-.202-.892-.582-1.22-.363-.314-.72-.646-1.02-1.02-.322-.404-.658-.771-1.154-.93-.477-.154-.962-.28-1.446-.406-.318-.083-.602-.023-.886.175-.29.202-.626.334-.939.502-.701.376-1.407.745-2.098 1.139-.249.141-.477.304-.474.682.002.165-.19.423-.351.483-.528.197-.622.683-.831 1.103a85.704 85.704 0 0 1-.928 1.798c-.155.291-.327.573-.48.841-1.14-.28-1.44-.14-2.114.759-.3.4-.68.75-1.072 1.062-.413.33-.733.22-1.037-.224-.403-.59-.816-1.167-1.358-1.647-.678-.601-1.565-.752-2.386-.38-.664.3-1.097.835-1.458 1.436-.188.313-.448.592-.44 1.021.022 1.28.734 2.118 1.69 2.8zm32.47-4.678c-1.149 1.055-2.496 1.775-3.944 2.302-.384.14-.807.232-1.214.237-1.315.014-2.6.21-3.87.539a4.74 4.74 0 0 1-1.044.146c-.32.01-.52.15-.745.367-1.057 1.014-2.19 1.927-3.588 2.428a.958.958 0 0 1-.606.033c.377-.247.761-.485 1.13-.744.374-.262.753-.521 1.094-.823.515-.455.673-1.097.765-1.746.123-.864.41-1.655.865-2.398a18.44 18.44 0 0 0 .86-1.601c.282-.582.652-1.064 1.215-1.39.251-.146.475-.34.719-.497.779-.504 1.2-1.253 1.455-2.124.197-.675.379-.82 1.082-.897.123-.013.257-.018.364-.07.603-.298 1.123-.087 1.628.247.035.023.074.039.109.062.597.39.713.375 1.254-.113-.113.527-.21 1.058-.343 1.58-.108.427-.057.815.105 1.223.479 1.2 1.293 2.01 2.534 2.368.19.054.364.16.626.28-.184.245-.293.446-.45.59zm2.365.054c-.097-.426-.183-.882-.4-1.248-.447-.751-.924-1.486-1.914-1.65-.344-.057-.661-.325-.972-.527-.251-.163-.288-.405-.091-.646.23-.28.258-.604.25-.948-.005-.186.042-.373.054-.56.044-.647-.072-1.274-.494-1.76-.338-.39-.765-.711-1.185-1.016-.445-.323-.96-.506-1.52-.473-.888.052-1.776.11-2.662.187-.478.042-.934.171-1.346.444-.296.195-.487.41-.498.804-.02.684-.201 1.344-.673 1.851-.337.362-.734.68-1.146.951a4.674 4.674 0 0 0-1.787 2.124 6.594 6.594 0 0 1-.416.844c-.701 1.158-1.22 2.383-1.41 3.738-.055.392-.244.719-.572.938-.587.392-1.189.763-1.78 1.15-.7.46-1.53.73-2.05 1.454-.032.044-.105.062-.163.082-.208.074-.5.085-.603.232-.105.148-.024.43-.024.654l-.003.063-.044.006c.038.287.003.614.129.855.397.763.938 1.36 1.855 1.528.408.074.755.054 1.043-.217.455-.429.991-.554 1.588-.615.891-.092 1.76-.306 2.518-.83.565-.39 1.178-.733 1.666-1.208.657-.64 1.41-.93 2.283-1.126 1.1-.248 2.198-.417 3.322-.447.35-.009.709-.023 1.05-.1 1.376-.307 2.577-1.03 3.786-1.716.429-.244.77-.642 1.194-.898.497-.3.718-.794.97-1.26.097-.178.093-.451.045-.66zM66.4 25.745c-.9.72-1.755 1.514-2.786 2.036-.489.247-.995.298-1.574.088.303-.343.578-.642.837-.954.119-.143.275-.303.297-.473.07-.526.431-.664.82-.824.679-.278 1.34-.604 2.018-.881.546-.223.701-.189 1.27.224-.329.294-.595.554-.882.784zm-.003-2.935c-.14 0-.203-.009-.262 0-1.607.26-3.058.96-4.465 1.775-.298.172-.484.457-.436.85.058.472-.166.778-.534.987-.446.253-.882.542-1.353.725-.895.346-1.669.815-2.24 1.663-.229.34-.247.605-.11.934.23.556.625.846 1.214.898.659.058 1.276-.045 1.905-.26.85-.29 1.738-.464 2.63-.294.67.127 1.293.062 1.899-.23.792-.384 1.524-.862 2.243-1.396.674-.5 1.243-1.08 1.806-1.694.326-.355.5-.786.596-1.241.076-.366.116-.768-.136-1.11-.721-.979-1.654-1.54-2.757-1.607zm3.768-16.012c.247.376.638.718 1.091.676.51-.047 1.07-.172 1.49-.45.681-.455 1.212-1.078 1.431-1.952.163-.649.033-1.27-.307-1.71-.51-.66-1.155-1.244-1.912-1.493-.3.282-.5.633-.733.657-.594.06-.966.35-1.374.768-.6.615-.548 1.338-.424 2.021.094.525.436 1.022.738 1.483zM56.766 4.393c.266-.024.546-.026.805.031 1.052.232 1.837-.352 1.97-1.46-.068-.301-.13-.604-.206-.903-.232-.915-1.02-1.344-1.655-1.9-.178-.156-.422-.12-.654.009-.537.3-.757.81-.959 1.348a9.33 9.33 0 0 1-.401.903c-.204.406-.398.779-.115 1.258.288.488.633.766 1.215.714zm11.694 26.13c-.24-.064-.47-.177-.712-.23-.14-.03-.295.027-.444.026-1.025 0-1.4.327-1.46 1.298-.551.326-1.065.619-1.566.931-.646.402-.674.494-.478 1.25.01.04.032.078.041.119.137.618.576.968 1.13 1.181.496.19 1.136-.24 1.003-.701-.125-.432-.009-.723.256-.999-.074-.137-.138-.242-.188-.355-.058-.13-.103-.265-.15-.387.452-.366.451-.363.935-.27.23.043.462.079.694.101.76.073.88 0 1.229-.707.064-.13.147-.251.22-.374-.064-.122-.153-.227-.174-.344-.041-.23-.038-.461-.336-.54zm6.53-18.747c-.009-.085-.03-.172-.026-.257.034-.694-.444-1.077-1.01-1.334-.57-.26-1.087.102-1.604.294a.286.286 0 0 0-.136.141c-.26.557-.34 1.141-.017 1.678.337.557.853.854 1.597.775.912-.096 1.272-.447 1.196-1.297zM56.216 7.212c-.13-.095-.337-.077-.495-.108-.63.835-.222 1.928.332 2.406.238.205.499.275.776.145.305-.142.504-.505.448-.815-.125-.7-.517-1.23-1.06-1.628zm-3.822 32.809c0 .312.017.577-.003.84-.047.605.307.952.797 1.214.54.288.892.22 1.268-.235.28-.34.262-.747-.106-1.154-.484-.535-1.11-.745-1.956-.665zm9.615-8.616c-.325.469-.251.918.204 1.233.502.347.977.35 1.48.01-.329-.92-.69-1.187-1.684-1.243zm9.871-3.356c-.048-.028-.145.019-.172.088-.053.134-.12.337-.094.457.045.21.156.38.24.568l.094-.114c.014-.25.039-.5.037-.75-.001-.088-.057-.222-.105-.25z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'flag':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '94',
	            height: '71',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'flag'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h94v71H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M3.02 13.201c5.456-1.014 5.796 12.783 5.982 13.641 1.92 8.87 4.164 16.259 7.022 24.632 1.463 4.285 1.51 4.119 2.666 9.775 1.043 5.101.296 1.241.404 5.75.006.237-.262.769-.404.58-2.713-3.604-2.741-6.872-3.833-10.809-.47-1.694-.997-5.338-1.669-6.962-.607-1.468-1.058-2.995-1.551-4.505-.769-2.353-.857-5.029-2.233-7.084l.39-.7c-3.771-5.63.371 3.135-2.536-2.244-.741-1.372-1.18-2.899-1.963-4.248-.565-.975-1.848-1.573-2.055-2.681-.095-.506 1.13-.074 1.467-.462.416-.481.481-1.202.523-1.838.383-5.802-.597-5.952-1.67-10.654l-.54-2.19z',
	            fill: '#C4AF89'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M45.61 29.746c.393-1.272-.907-2.544-2.185-2.165l-1.504.448c-.122.036-.245.075-.367.113l-.01.004-.032.01-.004-.03-.001-.005v-.004l-.002-.005c-.02-.121-.04-.242-.062-.36a95.82 95.82 0 0 0-1.03-4.763 98.011 98.011 0 0 0-1.74-6.262c-.217-.689-.448-1.375-.958-1.912a2.67 2.67 0 0 0-1.251-.727 4.625 4.625 0 0 0-.739-.102l-.011-.012a7.57 7.57 0 0 1-.267-.47c-.198-.38-.393-.758-.589-1.138l-.018-.035-.308-.597a85.483 85.483 0 0 0-.6-1.13l-.005-.011-.006-.01a83.324 83.324 0 0 1-.601-1.135c.896-.336 1.794-.668 2.692-1 .648-.239 1.296-.478 1.944-.719.122-.046.247-.091.373-.137l.041-.016c1.8-.658 3.885-1.42 4.37-3.476.31-1.314-.84-2.499-2.185-2.164-3.788.942-7.317 2.616-10.833 4.283-1.1.522-2.198 1.043-3.302 1.54a162.45 162.45 0 0 1-3.855 1.674c-2.209.92-4.434 1.8-6.666 2.663-.5.193-1 .388-1.5.583-1.785.697-3.573 1.394-5.384 2.017-1.204.415-2.433.765-3.694.958-.3.034-.6.059-.9.073-.927.045-1.821.778-1.777 1.76.042.916.783 1.808 1.777 1.76 1.673-.08 3.29-.444 4.871-.942 0 .147.018.296.055.445a81.145 81.145 0 0 0 6.202 16.762l.011.021c.328.655.655 1.307 1.248 1.767l-.5.275c-1.282.704-2.573 1.397-3.919 1.974-.658.263-1.328.493-2.01.678-.427.102-.854.198-1.283.287-.91.19-1.523 1.3-1.24 2.165.139.426.405.837.816 1.052.444.232.875.264 1.369.177.45-.08.894-.18 1.332-.298a46.007 46.007 0 0 0 12.78-5.203c.791-.472 1.567-.97 2.326-1.49.586-.185 1.174-.365 1.762-.545.88-.269 1.76-.538 2.634-.825.337-.096.672-.205.993-.335a35.84 35.84 0 0 0 2.535-.985c.48-.21.954-.433 1.427-.657.507-.24 1.015-.479 1.53-.701.773-.309 1.564-.562 2.386-.699.452-.044.904-.05 1.356-.01.133.024.265.053.394.086l.261 1.838c.056.389.48.876.817 1.052.359.188.729.263 1.133.21.798-.107 1.631-.857 1.54-1.73a11.032 11.032 0 0 1 .008-2.358c.084-.512.201-1.015.355-1.512zm-11.58.785c-.344-.662-.96-1.157-1.687-1.388-.706-.224-1.664.14-2.006.809-.058.115-.12.228-.19.337a2.496 2.496 0 0 1-.178.23 4.123 4.123 0 0 1-.397.39l-.004.004-.004.004-.055.046-.11.064-.036.02a4.897 4.897 0 0 1-.468.253c-.262.094-.53.167-.805.219-.243.018-.485.02-.728.001a4.356 4.356 0 0 1-.801-.237c-.26-.105-.68-.072-.945 0-.374.102-.688.33-.922.631a1.658 1.658 0 0 0-.35.833c-.035.255-.013.47.048.688-1.633.33-3.273.625-4.92.874.09-.295.1-.617.003-.94l-4.007-13.462-.692-2.327 2.107-.78.215-.08c.849-.316 1.697-.632 2.592-.787a5.01 5.01 0 0 1 .755-.014c.088.019.176.041.263.068.021.011.042.023.062.036l.093.074-.007-.009-.006-.008-.02-.022.033.02c.07.067.132.139.193.213.27.329.847.516 1.256.516.436 0 .957-.192 1.257-.516.31-.335.541-.776.52-1.244-.022-.493-.207-.864-.52-1.245a3.508 3.508 0 0 0-.755-.685c2.314-.951 4.611-1.943 6.88-2.997.107.223.227.442.345.656l.004.008c.081.147.161.292.235.435l1.818 3.514.055.105c.31.6.616 1.195 1.095 1.687.366.377.825.654 1.325.816.2.065.41.097.62.118.085.255.16.515.236.773l.002.009.115.386a97.289 97.289 0 0 1 1.469 5.406 98.1 98.1 0 0 1 .8 3.61c.046.233.086.475.127.72v.003l.004.02c.03.184.061.37.095.555-.996.263-1.965.654-2.898 1.074-.372.168-.741.342-1.11.516zm-13.2-14.473a.736.736 0 0 0-.043-.043L20.749 16l-.007-.003a.926.926 0 0 0 .028.026l.06.035zm8.716 14.883l.034-.028.005-.003.006-.006.003-.002.006-.005c.045-.036.084-.068.084-.066.001.019-.065.065-.138.11zm26.912-1.572c4.74-1.709 9.618-3.012 14.491-4.286l.21-.055h.002c2.043-.535 4.102-1.074 6.198-1.362l.183-2.232.107-1.304c.007-.09.017-.182.026-.274l.001-.006.002-.022.01-.088c-.902-.319-1.83-.579-2.753-.81-.37-.094-.742-.178-1.115-.257a92.415 92.415 0 0 1-7.489.863c-.826.06-1.67-.119-2.279-.715-.54-.529-.723-1.218-.849-1.929l-.632-3.577c-.08-.455-.043-.892.147-1.268a37.704 37.704 0 0 0-1.79-.3 24.973 24.973 0 0 0-6.064.016 35.83 35.83 0 0 0-1.238.2c.107.155.187.326.229.51.325 1.413.65 2.827.954 4.246.888 4.152 1.617 8.395 1.649 12.65zm25.163-8.283c-.17.007-.337.025-.502.052l.036-.44c.156.128.312.258.466.388zm9.662 5.238c.486.32.8.881.828 1.485.043.962-.848 1.743-1.776 1.76-1.83.032-3.465-.694-5.093-1.417-.257-.114-.513-.228-.77-.339a12.464 12.464 0 0 0-2.697-.753c-1.272-.139-2.55-.093-3.82.059-1.807.26-3.578.71-5.343 1.17-5.572 1.455-11.162 2.926-16.548 4.97-.263.42-.688.718-1.243.791a1.783 1.783 0 0 1-.675-.034l-.06.024-.069.028a60.685 60.685 0 0 0-5.979 2.899c-.867.483-1.902.18-2.43-.632-.515-.79-.174-1.956.637-2.408a61.754 61.754 0 0 1 5.958-2.894l-1.908-5.008-.417-1.092-.85-2.232c-.418-1.099-.826-2.204-1.055-3.36-.192-.969.268-1.852 1.24-2.164.866-.277 2.007.324 2.186 1.23a15 15 0 0 0 .513 1.87c-.435-2.301-.958-4.587-1.483-6.869a1.907 1.907 0 0 1-.025-.753c-1.13.277-2.256.581-3.378.886-.96.261-1.889-.32-2.186-1.229-.295-.904.345-1.921 1.241-2.165.45-.122.899-.244 1.349-.364 3.725-.995 7.58-1.89 11.465-1.73 3.457.142 6.934.938 10.202 2.04a45.912 45.912 0 0 1 8.624 3.933 46.028 46.028 0 0 1 7.641 5.65 44.128 44.128 0 0 1 5.921 6.648z',
	            fill: '#E8506D'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M35.11 10.489c.103 1.63 1.148 1.82 2.224 2.015.907.164 1.835.332 2.24 1.369 1.279 3.272 2.338 6.632 3.29 10.014.121.428.116.894.11 1.357v.001c-.008.64-.016 1.273.309 1.795.119.191.367-.002.622-.199s.516-.4.658-.225l.683.18a24.971 24.971 0 0 1 2.542 3.779c.16.294.201.684.241 1.066.06.58.119 1.141.593 1.327.651.254 1.254-.827 1.479-1.489.311-.917.271-1.973.012-2.906l-.1-.367a40.674 40.674 0 0 0-1.544-4.71c-.931-2.387-2.015-5.165-.44-6.342.28-.21.641-.32.998-.43.504-.155 1-.308 1.254-.732.4-.67.449-1.843-.156-2.336-.656-.536-1.606-.463-2.501-.395-.219.017-.434.034-.641.04-1.83.065-2.432.854-2.6 1.424-.103-.794-.503-2.502-1.721-5.749-.148-.392-.646-.636-1.064-.671-1.029-.088-2.117-.052-3.08.318-.916.35-.841.41-.736.492.11.086.252.198-.638.685l-2.033.689zm-18.5 7.905c.183-.113.357-.247.532-.382.348-.269.696-.538 1.114-.64l5.78 2.626c1.484-.36 1.415-1.898 1.342-3.505-.106-2.36-.22-4.872 4.564-4.034 2.545.447 6.488 10.307 7.016 11.789.11.306.858 3.477.282 3.874-1.022.705-2.1-.177-3.076-.974-.88-.72-1.679-1.373-2.278-.73-.541.58-.905 1.303-1.269 2.024-.416.825-.83 1.648-1.507 2.252-.471.421-1.27.197-1.9.02l-.103-.03c-.385-.107-.777-.44-1.157-.763-.584-.496-1.138-.967-1.592-.551-.573.523-.47 1.366-.366 2.227.09.742.183 1.498-.154 2.076-.404.695-1.857 1.247-2.336.601-3.639-4.904-4.513-9.317-4.513-14.8l-.379-1.08zm40.548-5.553c-.602.096-1.204.191-1.782.194l-.051.887c.068 2.81.584 5.095 1.119 7.463.321 1.425.65 2.88.892 4.5.09.594 1.014 1.043 1.63.963A543.81 543.81 0 0 0 75.99 24.36l.283-.322c.79-.128.096-1.612-.266-2.388l-.035-.076c-.972-2.083-5.458-1.432-8.864-.937-1.809.262-3.313.48-3.824.222-.827-.418-.887-1.452-.948-2.5-.034-.587-.069-1.177-.237-1.667-.128-.37-.21-.788-.294-1.21-.2-1.002-.402-2.023-1.223-2.47-1.016-.553-2.22-.362-3.423-.171z',
	            fill: '#fff'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M48.601 22.978c.63 2.463.984 5.012 1 7.554 0 .019 0 .037-.003.055.029.352-.147.586-.557.707-.035.01-.07.022-.104.033-.1.194-.372.284-.602.214l-.399.145c.028-.107.05-.212.072-.318a.522.522 0 0 1-.089-.398c-.346-1.029-.427-2.125-.629-3.187-.24-1.261-.554-2.506-.775-3.772a46.673 46.673 0 0 1-.704-7.706c-.116-.63.16-.97.955-1.31.916-.394 1.828-.862 3.017-.86.003.52.034.975-.006 1.424-.013.148-.182.356-.326.408-.805.288-1.615.561-2.425.832-.04 2.139 1.056 4.145 1.575 6.179zm42.29 6.235c-.452-.264-.827-.48-1.198-.701-.543-.324-1.052-.726-1.63-.966-2.116-.88-4.324-1.316-6.627-1.152-3.89.278-7.722.891-11.491 1.905-1.997.537-4.039.925-6.015 1.528-3.229.985-6.434 2.04-9.568 3.319-2.474 1.01-5.04 1.798-7.571 2.664-.334.114-.71.11-1.182.177.275-.789.6-1.24 1.296-1.457 1.063-.331 2.091-.773 3.141-1.148.277-.098.57-.156.86-.215.38-.22.605-.559.684-1.08.133-.882.078-1.844.048-2.73-.068-2.086-.989-4.045-1.016-6.128-.089-.343-.178-.686-.27-1.028a50.132 50.132 0 0 0-.835-2.728c-.239-.724-.092-1 .668-1.096.316-.04.641-.005.954-.054.758-.117.96-.5.91-1.257-.067-1.008 0-2.023-.048-3.033-.021-.461-.081-.967-.293-1.362-.33-.615-.904-.922-1.653-.946-1.18-.038-2.266.295-3.348.688-.321.117-.648.219-1.037.35-.312-1.102-.279-1.171.555-1.512 2.714-1.108 5.574-1.563 8.465-1.867.855-.09 1.717-.12 2.576-.175 1.73-.11 3.432.04 5.118.467.608.154 1.267.091 1.889.203 2.204.396 4.334 1.06 6.408 1.888 1.922.768 3.823 1.589 5.724 2.408.629.271 1.232.588 1.769.996.619.247 1.263.582 1.808.999a.555.555 0 0 1 .243.063c.135.07.254.162.351.275.238.07.45.208.653.395.586.538 1.22 1.025 1.788 1.58 1.568 1.536 3.114 3.095 4.667 4.648 1.276 1.276 2.195 2.796 3.002 4.39.25.49.298 1.013.205 1.692zM11.798 31.13l.185-.078c.667 2.069 1.336 4.137 1.992 6.208.027.087-.07.212-.347.488-.073-.165-.154-.327-.218-.495-.212-.561-.474-1.111-.616-1.69-.36-1.47-.667-2.955-.996-4.433zm32.239-.834c-.632.216-1.285.382-1.94.52-1.825.384-3.515 1.132-5.204 1.885-.669.298-1.322.632-1.985.943-.452.211-.869.518-1.435.234-.155-.078-.476.103-.69.22-3.216 1.758-6.421 3.535-9.643 5.281a17 17 0 0 1-2.179.967c-2.66.989-5.31 2.004-8.178 2.27-.79.072-1.56.323-2.347.453-.949.156-1.213-.084-1.228-1.046-.003-.158.015-.317.026-.475.032-.467.283-.632.75-.662a57.028 57.028 0 0 0 3.612-.329c.885-.113 1.76-.31 2.474-.92.626-.535.824-1.157.554-1.957-1.07-3.16-2.158-6.315-3.162-9.497-.707-2.242-1.281-4.525-1.929-6.785-.192-.672-.38-1.352-.667-1.986-.203-.45-.537-.852-.865-1.23-.37-.425-.862-.509-1.4-.326-.662.225-1.34.412-1.987.674-.899.364-1.825.55-2.787.622-.422.032-.68-.093-.758-.52-.073-.398-.148-.796-.254-1.361.93-.16 1.708-.294 2.487-.425.346-.058.699-.083 1.037-.17 3.246-.826 6.465-1.72 9.537-3.098 2.237-1.003 4.538-1.862 6.8-2.812 2.676-1.125 5.263-2.434 7.8-3.845 1.221-.68 2.423-1.417 3.705-1.961 2.049-.87 4.147-1.63 6.245-2.377.833-.296 1.169-.068 1.37.806.158.678.218 1.378.33 2.067.077.47-.168.71-.575.85-1.929.666-3.85 1.351-5.79 1.986-.471.154-.999.142-1.436.198-.333.24-.617.48-.933.665-.363.212-.464.49-.358.879.317 1.161.617 2.327.943 3.486.205.726.653 1.226 1.432 1.374.815.155 1.626.348 2.458.08.14-.044.307-.006.516-.006.072.289.154.557.205.83.496 2.653.991 5.306 1.475 7.961.176.969.297 1.947.487 2.912.11.558.266 1.116.476 1.644.248.622.533.78 1.201.6.73-.198 1.43-.51 2.142-.775.2-.074.394-.16.565-.23.095.088.167.122.182.173.452 1.48.532 1.66-1.08 2.213zm-.474 4.342c-.543-1.285-.344-1.613.962-1.45l-.962 1.45zM16.614 56.113c.809 2.675 1.59 5.357 2.38 8.038.295 1.005.582 2.013.862 3.023.082.295.124.602.185.903-.714.14-.87.067-1.025-.386-.856-2.49-1.739-4.971-2.566-7.47-.51-1.538-.932-3.103-1.4-4.654-.616-2.037-1.247-4.07-1.852-6.11-.367-1.24-.7-2.492-1.066-3.805.32-.104.548-.202.786-.25.386-.078.598.112.67.49.078.405.14.816.26 1.21.917 3.005 1.857 6.003 2.766 9.01zm-7.998-21.43a51.868 51.868 0 0 0-1.469-3.089c-.483-.922-1.172-1.618-2.252-1.9-.666-.175-.693-.378-.394-1.243.27.103.466.214.676.252.399.073.818.19 1.206.135.826-.115 1.013-.53.835-1.35-.354-1.642-.673-3.29-.983-4.94-.059-.314-.008-.648-.008-.973l.26-.04c.219.636.485 1.261.65 1.911.634 2.485 1.231 4.979 1.85 7.468a421.22 421.22 0 0 0 1.305 5.162c.166.637.394 1.258.59 1.874-.684.335-.743.35-.988-.194-.453-1.012-.829-2.059-1.278-3.073zm-4.71-22.212c.257-.038.602-.006.796.144.462.356.534.924.523 1.465-.008.37-.364.387-.645.434-.302.05-.599.038-.702-.314-.116-.394-.19-.8-.303-1.289.095-.135.193-.42.33-.44zm38.75-2.222c.328 3.282.624 6.568.984 9.848.152 1.385.435 2.757.658 4.134.016.094.038.187.053.281.178 1.187.078 1.33-1.225 1.691-.373-1.84-.672-3.622-1.107-5.37-.508-2.04-.874-4.093-1.005-6.19-.011-.19-.039-.38-.074-.566-.273-1.459-1.206-1.998-2.652-1.556-.6.183-1.212.324-1.902.506-.133-.653-.251-1.198-.355-1.746-.075-.4.184-.574.506-.691.568-.208 1.132-.428 1.707-.615 1.148-.376 2.3-.74 3.456-1.092.203-.062.432-.036.746-.058.075.499.163.959.21 1.424zm51.06 18.462c-.841-2.068-1.888-4.047-3.337-5.757-2.08-2.454-4.363-4.723-6.784-6.846-2.071-1.816-4.384-3.29-6.922-4.356-2.614-1.097-5.276-2.085-7.94-3.057-1.221-.445-2.486-.793-3.753-1.091-3.582-.842-7.22-.808-10.85-.479-2.732.248-5.46.589-8.063 1.538-.233.085-.486.114-.822.19-.067-.492-.119-.927-.187-1.36-.203-1.286-.389-2.575-.626-3.854-.175-.944-.531-1.807-1.178-2.564-.776-.909-1.478-1.369-3.053-.871a66.692 66.692 0 0 0-4.767 1.704c-2.57 1.032-5.084 2.18-7.525 3.5-2.238 1.211-4.565 2.26-6.863 3.36-.803.385-1.63.727-2.458 1.058a291.96 291.96 0 0 1-5.334 2.087c-1.251.471-2.516.91-3.79 1.317-.467.15-.976.167-1.476.246-.11-.325-.19-.53-.25-.74-.418-1.44-1.318-2.21-2.808-2.277a12.6 12.6 0 0 0-2.376.117c-1.298.19-1.585.677-1.35 1.988.137.77.237 1.546.346 2.268-.09.08-.11.115-.137.12a5.961 5.961 0 0 1-.374.069c-.893.137-1.215.628-.948 1.454.302.935.6 1.87.912 2.801.336 1.003.856 1.85 1.956 2.174.415.122.62.395.676.824.168 1.259.36 2.514.53 3.773.015.109-.057.23-.096.371-.35.016-.666.017-.979.046-.936.085-1.286.46-1.304 1.416-.012.603.008 1.207.004 1.811-.01 1.253.21 1.548 1.44 1.633.686.048 1.143.337 1.45.915.224.42.459.838.646 1.275.536 1.257 1.044 2.526 1.577 3.784.297.7.678 1.378.094 2.121-.088.112-.069.306-.107.46-.43 1.737.042 3.324.772 4.886.313.67.787 1.11 1.49 1.196.604.073.817.393.9.914.33 2.082 1.09 4.044 1.683 6.054 1.546 5.244 3.357 10.401 5.082 15.587.283.85.794 1.434 1.717 1.596.503.088 1.005.183 1.5.303.27.067.578.134.78.305.559.474 1.048.266 1.576-.034.574-.326.522-.839.415-1.339-.287-1.333-.57-2.67-.926-3.985-.555-2.053-1.172-4.089-1.756-6.133-.183-.642-.32-1.297-.519-1.933-.67-2.154-1.386-4.296-2.034-6.457a113.858 113.858 0 0 1-1.405-5.148c-.177-.708-.047-.817.635-1.013.888-.254 1.787-.48 2.655-.79 2.251-.803 4.475-1.643 6.528-2.921 1.997-1.243 4.044-2.45 6.196-3.381 1.602-.693 3.186-1.43 4.784-2.13.584-.256 1.157-.54 1.748-.775.76-.301 1.536-.566 2.343-.861.108.25.215.389.221.53.047 1.222.696 2.156 1.45 3.036.181.212.392.444.64.546 1.131.465 2.28.867 3.499.255.14-.07.304-.093.456-.14 2.523-.789 5.09-1.46 7.554-2.398 2.622-1 5.254-1.95 7.913-2.845 5.125-1.725 10.377-2.88 15.715-3.686 3.544-.535 6.998-.385 10.237 1.363.835.45 1.71.85 2.413 1.728.435.056.872.104 1.308.092.276-.008.527-.06.76-.148l-.037-.014c.938-1.13.999-2.283.533-3.428zm-18.402-5.753c-.05.137-.43.22-.656.219-2.375-.022-4.699.367-7.005.863-3.242.697-6.445 1.536-9.498 2.861-.113.05-.238.07-.552.16-.279-4.471-.336-8.85-1.483-13.152.293-.087.492-.184.697-.2 1.013-.083 2.026-.187 3.04-.202 1.005-.015 1.085.111 1.301 1.122.307 1.43.53 2.865.475 4.339-.04 1.12.38 2.062 1.398 2.629.274.153.706.266.968.16 1.414-.575 2.911-.746 4.394-.831 2.222-.128 4.455-.081 6.683-.097.216-.002.432.077.678.125.198.757-.21 1.372-.44 2.004zm1.828-4.65c-.472.059-.88.182-1.274.146a43.265 43.265 0 0 0-11.347.47c-.213.037-.433.038-.768.065l-.134-1.046a35.928 35.928 0 0 0-1.188-5.585c-.295-1.01-.922-1.36-1.867-1.397-.096-.004-.192-.01-.287-.006-1.43.076-2.859.192-4.29.214-.733.011-1.358.176-1.953.6-.557.397-.677.62-.464 1.262.16.482.363.952.485 1.443.555 2.228.786 4.501.898 6.79.086 1.745.17 3.49.27 5.234.039.666.121 1.33.182 1.994.05.562.312.954.88 1.114.15.043.32.088.434.186.489.427.92.236 1.389-.051.541-.33 1.096-.657 1.68-.897 3.198-1.315 6.53-2.184 9.919-2.827 2.133-.405 4.282-.65 6.456-.253.517.095.754-.136.89-.753.152-.682.265-1.372.43-2.05.264-1.091.366-2.186.28-3.309-.044-.574-.206-1.043-.621-1.344zm-40.949 9.708c-.332.17-.65.369-.993.566-.392-.75-.732-1.42-1.093-2.08-.136-.25-.317-.476-.485-.708-.71-.983-1.32-1.169-2.461-.778-.49.168-.78.486-.965.972-.447 1.173-.647 2.381-.686 3.632-.022.688-.197.837-.794 1.007-.427.122-.759.033-.976-.362-.55-1.003-1.412-1.694-2.305-2.374-.739-.562-1.458-.689-2.311-.279-.41.198-.606.444-.556.877.081.693.133 1.393.277 2.074.174.823.432 1.628.66 2.47l-2.617.984c-.124-.363-.245-.615-.296-.88-.798-4.22-1.873-8.372-3.056-12.497-.184-.64-.314-1.297-.5-1.936-.126-.43-.032-.77.353-.98.584-.316 1.18-.616 1.79-.88.39-.17.708-.013 1.018.295 1.014 1.008 2.068 1.977 3.095 2.974.361.351.755.567 1.275.536.81-.05 1.273-.446 1.243-1.251a40.18 40.18 0 0 0-.286-3.599c-.133-1.05-.078-1.24.926-1.503 1.111-.292 2.222-.571 3.2-1.216.147-.097.354-.104.601-.172.355.622.709 1.216 1.038 1.824.846 1.566 1.69 3.134 2.52 4.709 1.254 2.376 2.051 4.922 2.82 7.48.157.526.04.852-.436 1.095zm2.451-3.26c-.736-1.96-1.436-3.948-2.368-5.816-1.305-2.612-2.806-5.126-4.228-7.68-.4-.718-1.734-1.046-2.43-.514-.42.32-.816.435-1.314.407a1.596 1.596 0 0 0-.644.126c-1.302.51-2.588 1.063-3.904 1.537-.568.205-.843.519-.838 1.106.005.634.005 1.267-.002 1.9-.003.19-.04.38-.072.676-.194-.183-.306-.255-.372-.356-.925-1.4-2.307-1.551-3.8-1.374-1.486.176-2.67.99-3.826 1.849-.81.603-.789.6-.539 1.56a607.68 607.68 0 0 1 1.936 7.564c.777 3.143 1.49 6.302 2.294 9.438.54 2.104 1.045 2.382 3.114 1.363 1.196-.588 2.335-1.29 3.514-1.917.374-.199.57-.465.65-.873.085-.443.226-.877.351-1.347 1.065.793 1.484.91 2.658.587.827-.228 1.632-.54 2.434-.85.898-.346 1.574-.867 1.336-1.987-.01-.05.04-.113.125-.334.158.235.243.36.325.485.66 1.012.725.998 1.852.601a22.05 22.05 0 0 0 4.047-1.911c.651-.392.742-.493.56-1.22-.254-1.015-.492-2.043-.859-3.02z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'glasses':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '80',
	            height: '68',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'glasses'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h80v68H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M64.67 19.344a20.692 20.692 0 0 1-1.183 4.404c-.24.524-.513 1.03-.837 1.507a6.04 6.04 0 0 1-.45.46c-.139.09-.28.171-.426.247a9.035 9.035 0 0 1-1.405.342c-1.043.106-2.091.103-3.133-.006a15.614 15.614 0 0 1-3.096-.843c-1.116-.513-2.145-1.163-3.128-1.898-1.327-1.047-2.607-2.156-3.995-3.125-.425-.297-.871-.58-1.332-.839l8.77-7.05c1.089-.875 2.173-1.756 3.275-2.615 1.391-1.056 2.832-2.056 4.368-2.885.459.76.87 1.549 1.232 2.361a22.605 22.605 0 0 1 1.332 4.89c.191 1.678.197 3.371.008 5.05zm-21.335 7.348l-.024.03a72.867 72.867 0 0 0-.276-1.481c.413.25.813.524 1.204.809-.355.143-.677.35-.904.642zM38.027 39.05a12.82 12.82 0 0 1-.623 2.398c-.249.526-.539 1.03-.873 1.506-.28.327-.58.633-.906.914a7.196 7.196 0 0 1-.828.49 7.617 7.617 0 0 1-1.094.285c-1.08.097-2.179.046-3.257-.076a14.029 14.029 0 0 1-2.764-.722c-.88-.408-1.708-.91-2.491-1.481-2.151-1.738-3.903-3.901-5.593-6.077.335-.292.678-.576 1.03-.853 1.346-1.026 2.716-2.017 4.027-3.085.457.263.972.425 1.507.4.78-.034 1.676-.285 2.196-.909a26.391 26.391 0 0 1 3.837-3.738 26.952 26.952 0 0 1 4.536-2.72c.382 1.743.697 3.5.944 5.267.36 2.766.653 5.622.352 8.4zm32.36-27.832C69.974 9.343 69.3 7.536 68.48 5.8c-.838-1.773-1.937-3.373-3.175-4.89C64.833.33 63.825 0 63.11 0c-.605 0-1.304.214-1.829.589a26.315 26.315 0 0 0-4.5 2.41c-1.72 1.148-3.342 2.443-4.954 3.737-3.23 2.591-6.454 5.188-9.68 7.782l-4.084 3.283c-2.56.203-5.06.908-7.4 1.994-2.875 1.333-5.258 3.495-7.554 5.634-1.13 1.053-2.267 2.094-3.48 3.05-2.154 1.628-4.45 3.144-6.235 5.187-1.934 2.212-3.447 4.782-4.965 7.286-1.39 2.295-2.71 4.642-3.77 7.11-.606 1.411-1.177 2.833-1.609 4.308-.44 1.502-.708 3.025-.904 4.577a17.686 17.686 0 0 0 .014 4.623c.232 1.729.754 3.456 1.767 4.9.474.673 1.039 1.2 1.856 1.426.744.204 1.734.112 2.394-.313.663-.427 1.247-1.064 1.427-1.855.177-.775.162-1.715-.313-2.392a7.542 7.542 0 0 1-.602-1.022 9.798 9.798 0 0 1-.426-1.622c-.112-1.163-.067-2.333.065-3.492.33-2.125.959-4.185 1.77-6.175.954-2.186 2.105-4.282 3.327-6.33.705-1.179 1.41-2.373 2.154-3.54.737.94 1.488 1.87 2.284 2.762a27.606 27.606 0 0 0 3.84 3.544c1.253.96 2.62 1.711 4.085 2.282-.993 2.131-1.52 4.495-1.298 6.852.08.84.293 1.579.91 2.195.538.538 1.422.944 2.196.909.803-.036 1.636-.3 2.196-.91.527-.573.986-1.386.91-2.194a10.72 10.72 0 0 1-.003-1.97c.114-.637.283-1.26.51-1.865l.121-.255c.259-.519.418-1.066.417-1.628.189.008.376.014.563.018 2.14.042 4.353-.343 6.192-1.492 1.598-1 2.921-2.417 3.864-4.045 1.992-3.437 2.155-7.511 1.86-11.373l-.022-.266c.218.05.438.075.649.065.803-.036 1.636-.3 2.196-.909a3.352 3.352 0 0 0 .886-1.95l.023-.088c.184-.225.322-.476.413-.755.108-.206.183-.42.226-.644 1.422.978 2.99 1.726 4.63 2.27 1.791.595 3.735.886 5.621.885 1.075-.001 2.149-.13 3.207-.307 1.073-.18 2.146-.54 3.087-1.087 1.744-1.012 3.006-2.71 3.805-4.53.706-1.61 1.273-3.256 1.598-4.988a26.012 26.012 0 0 0-.157-10.462z',
	            fill: '#A1CBFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M66.827 13.956c-.108-1.388-.23-2.806-.484-4.176C66.059 8.252 64.52 6.974 62.91 7c-.788.013-1.456.251-2.174.518-4.414 1.645-8.442 4.012-11.94 7.109-.39.346-.773.702-1.147 1.066a3.077 3.077 0 0 0-.914 2.14c0 .743.34 1.63.914 2.14.595.53 1.376.924 2.207.887.304-.013.601-.058.886-.138-.405 1.762-.293 3.614.605 5.249.208.38.495.732.819 1.026.5.457 1.189.86 1.867.998 1.045.212 1.893.097 2.937-.068a29.136 29.136 0 0 0 3.435-.758c1.303-.372 2.675-.8 3.88-1.41.964-.489 1.689-1.313 2.106-2.273.337-.774.462-1.54.517-2.387.154-2.375.104-4.772-.082-7.143zM39.024 28.585c.286.337.534.705.735 1.098.65 1.27.973 2.648.924 4.072-.042 1.22-.28 2.453-.614 3.63-.222.786-.48 1.565-.736 2.343l-.273.831-.002.01c-.23.705-.456 1.405-.799 2.07-.526 1.023-1.491 1.732-2.578 2.111-.74.258-1.584.254-2.366.249a17.732 17.732 0 0 1-1.61-.079c-.787-.076-1.583-.173-2.355-.347-.749-.17-1.442-.445-2.149-.738-2.392-.992-4.091-2.983-5.529-5.011a31.736 31.736 0 0 1-.848-1.239c-.51-.798-.887-1.8-.815-2.751.092-1.219.597-2.215 1.444-3.108.3-.316.65-.591.995-.862l.166-.13c1.919-1.517 3.944-2.898 6.118-4.05.977-.517 1.979-.99 3-1.417l.394-.166c.59-.25 1.187-.502 1.796-.697 1.04-.332 2.097-.35 3.16-.14.794.158 1.442.754 1.866 1.392.457.688.496 1.557.314 2.332-.047.202-.13.403-.238.597z',
	            fill: '#9A9AFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M45.32 29.819c.672-.744 1.249-1.1 1.334-1.804.018-.152-.115-.386-.25-.475-.126-.082-.442-.094-.513-.008-.325.395-.636.816-.858 1.272-.078.16.115.448.286 1.015zM27.761 50.98c-1.252.855-1.347 1.765-1.517 2.626-.15.76-.3 1.53.101 2.27.03.056.071.107.107.161.272.41.747.504 1.2.25.46-.258.687-.665.504-1.136-.473-1.22-.587-2.479-.395-4.171zm7.658-8.21c.843-1.247 1.475-2.16 2.081-3.088.177-.271.308-.58.412-.888 1.237-3.66.976-7.209-.832-10.638-.123-.231-.219-.508-.411-.663-.236-.19-.589-.425-.843-.379-1.403.255-2.573.995-3.642 1.895-.14.118-.236.322-.287.505-.39 1.382-.79 2.763-1.122 4.16-.08.334.082.724.134 1.093.576 0 1.033-.011 1.489.003.525.017 1.053.03 1.574.09 1.071.127 1.648.81 1.836 1.791.096.5.07 1.04 0 1.549-.098.71-.302 1.405-.436 2.111-.129.684-.318 1.375.047 2.458zm-6.97-11.247c-1.144.309-2.008 1.043-2.95 1.616a65.734 65.734 0 0 0-2.99 1.95c-.917.629-1.892 1.185-2.761 1.997.301.64.547 1.245.865 1.81.256.455.554.903.912 1.283 2.143 2.272 4.488 4.26 7.567 5.237 1.056.335 2.057.472 3.134-.182.042-.866.045-1.776.142-2.677.098-.91.313-1.806.432-2.715.116-.88.573-1.746.193-2.778-.492.052-.933.105-1.375.143-2.566.226-3.899-1.261-3.37-3.714.132-.613.525-1.214.2-1.97zm4.45 16.88c1.528-.146 3.055-.36 4.394-1.148 1.853-1.092 3.363-2.558 4.476-4.39.552-.91.834-1.907.927-2.976.25-2.89-.174-5.755-.296-8.63-.022-.51-.265-1.01-.39-1.517-.28-1.145-.588-2.285-.812-3.44-.175-.907-.17-1.823.247-2.696.333-.697.832-1.245 1.618-1.305 1.411-.107 2.805-.029 3.858 1.121.355.388.779.733 1.06 1.167 1.054 1.62 2.559 2.834 3.853 4.234 1.184 1.28 2.712 1.818 4.466 1.82 3.67.004 6.543-1.482 8.606-4.454a34.423 34.423 0 0 0 2.064-3.36c.78-1.457 1.313-3.015 1.305-4.69-.011-2.36-.173-4.711-.574-7.042-.417-2.432-1.42-4.63-2.773-6.68-.43-.65-.939-1.266-1.792-1.691-.791.354-1.681.649-2.462 1.12-3.116 1.876-6.228 3.762-9.284 5.731-3.557 2.293-7.043 4.69-10.579 7.016-5.525 3.634-11.082 7.223-16.595 10.876-3.303 2.189-6.364 4.736-9.949 6.509-.875.432-1.385 1.144-1.79 2.016-.663 1.425-1.354 2.852-2.188 4.183-2.807 4.479-4.945 9.264-6.793 14.181-.412 1.097-.637 2.273-.849 3.43-.341 1.863-.067 3.655.913 5.308.505.853 1.097 1.637 1.98 2.163.74.442 1.452.493 2.314-.072-.266-.322-.436-.583-.66-.787-.486-.444-1.034-.826-1.494-1.294-.906-.919-1.508-1.993-1.494-3.323.028-2.572.688-4.915 2.518-6.848.405-.428.808-.873 1.124-1.365 2.236-3.486 4.45-6.984 6.668-10.481.211-.333.373-.696.593-1.022.38-.562.983-.712 1.55-.348.325.208.601.504.86.793.218.243.36.55.569.802.29.353.587.252.999-.331-.39-.748-.725-1.542-1.192-2.253-.696-1.057-.215-2.16-.239-3.24-.004-.204.252-.452.444-.612.251-.208.564-.342.843-.52 4.067-2.603 8.123-5.223 12.206-7.801a28.298 28.298 0 0 1 3.312-1.79c1.57-.718 2.772-.384 3.849.97.867 1.09 1.602 2.274 1.931 3.628.37 1.524.774 3.066.887 4.62.181 2.504-.12 4.975-1.504 7.186a65.412 65.412 0 0 1-1.856 2.792c-1.144 1.633-2.44 3.104-4.354 3.918-.202.086-.32.366-.486.547-.324-.05-.649-.143-.973-.14-1.285.012-2.49-.301-3.664-.785a48.36 48.36 0 0 0-2.034-.789c-.192-.069-.434-.344-.62.03 2.205 2.027 4.204 2.483 7.261 1.659zm-8.588 1.432c-.408-.354-.761-.646-1.098-.956-.675-.622-1.361-1.235-2.006-1.887-.881-.892-1.753-1.777-2.906-2.354-.52-.26-.964-.67-1.55-1.089-.327.288-.691.547-.98.87-2.644 2.97-4.592 6.408-6.7 9.738a34.47 34.47 0 0 0-1.02 1.684c-.286.514-.575 1.035-.778 1.583-.744 2.007-.346 3.72 1.398 5.082.57.446 1.086.96 1.635 1.433.8.691.856 2.071-.05 2.996-.574.587-1.278.913-2.102 1.015-2.248.277-4.074-.64-5.514-2.178C1.034 64.057.094 61.997.01 59.576c-.084-2.407.365-4.673 1.312-6.88C3.107 48.532 5.18 44.51 7.309 40.51c1.325-2.49 2.49-5.06 3.722-7.597.141-.29.259-.591.425-.974 1.678.009 2.983-.936 4.345-1.714 1.09-.622 2.127-1.337 3.178-2.025 6.749-4.418 13.505-8.823 20.236-13.267 3.255-2.149 6.432-4.412 9.694-6.55 3.76-2.463 7.57-4.849 11.368-7.256.5-.317 1.033-.595 1.579-.83 1.294-.556 2.46-.328 3.453.648.234.23.44.49.64.75 2.532 3.296 4.21 6.956 4.758 11.073.206 1.553.318 3.12.42 4.685.16 2.442-.621 4.653-1.87 6.713a68.844 68.844 0 0 1-2.592 3.959c-1.403 1.99-3.236 3.45-5.645 4.108-1.018.278-2.04.627-3.082.722-3.023.276-5.79-.468-8.223-2.306-.204-.154-.449-.255-.703-.396-1.728 1.05-2.055 3.04-3.179 4.312-.037 1.73.006 3.363-.122 4.984-.273 3.452-1.979 6.182-4.61 8.39-1.917 1.607-4.114 2.605-6.631 2.89-.526.06-1.046.18-1.566.284-1.467.293-2.275 1.326-2.124 2.795.053.514.24 1.016.389 1.516.318 1.07-.023 1.89-.862 2.615-1.92 1.658-4.039 1.021-5.375-.254-1.429-1.362-2.13-2.984-1.523-4.974.284-.932.566-1.865.903-2.975zm52.892-39.31c-.652.137-1.315-.141-1.756-.933-.399-.717-.336-1.168.38-1.662.59-.406 1.215-.781 1.867-1.08.747-.344 1.432-.122 1.898.54.536.763.49 1.607.167 2.413-.099.246-.473.47-.76.538-.506.121-1.042.116-1.796.184zm.807 21.042c.013.961-.632 1.376-1.329.972-1.574-.913-2.78-2.162-3.395-3.892-.25-.702.33-1.29 1.081-1.132.128.027.264.05.375.112 1.421.775 2.535 1.837 3.143 3.35.095.236.108.503.125.59zM56.412 45.767c.346-.76.773-.936 1.26-.86.585.093 1.184.251 1.498.83.347.64.555 1.32.479 2.062-.043.416-.398.632-.857.578-.577-.068-.994-.386-1.296-.816-.406-.58-.737-1.212-1.084-1.794zM35.997 6.108c-.332.157-.499.303-.669.306-1.526.027-2.603-.71-3.326-1.988a.679.679 0 0 1 .708-1.022c.438.067.9.205 1.27.436a5.109 5.109 0 0 1 2.017 2.268zm20.945 9.86c.406.066.598.12.79.122.263 0 .527-.057.79-.058 1.77-.004 2.547.792 2.462 2.529a6.419 6.419 0 0 1-.147.967c-.223 1.086-.462 2.17-.684 3.256-.116.566-.322 1.139.08 1.795 1.24-.125 1.91-.841 2.333-1.99 1.101-2.99 1.488-6.083 1.443-9.234-.023-1.555-.118-3.126-.935-4.495-.706-.31-1.387-.31-1.976.015-.975.54-1.903 1.166-2.827 1.79-.203.137-.354.396-.448.63a11.625 11.625 0 0 0-.881 4.674zm1.254 2.662c-.277-.072-.52-.152-.77-.195-.26-.045-.53-.033-.788-.083-1.601-.313-2.096-.945-2.103-2.548-.002-.683.29-1.385.016-2.024-.174-.043-.259-.093-.295-.07-1.822 1.17-3.65 2.33-5.447 3.535-.296.199-.454.598-.662.885.859 2.649 2.748 4.397 4.875 5.834 1.145.772 2.565 1.274 4.055 1.11.235-1.12.48-2.127.65-3.147.178-1.07.681-2.104.47-3.297zm.02 9.397c-.905-.167-1.81-.327-2.714-.503-3.25-.632-5.536-2.68-7.554-5.079-.674-.8-1.242-1.693-1.798-2.58-.274-.437-.45-.945-.603-1.44-.372-1.21.055-2.177 1.02-2.947.153-.123.333-.212.502-.315 3.947-2.41 7.67-5.133 11.385-7.87 1.178-.869 2.64-1.2 4.058-1.53.635-.147 1.13.234 1.57.67 1.269 1.253 1.886 2.8 2.225 4.507.585 2.935.31 5.87-.11 8.77-.24 1.662-.899 3.275-1.468 4.876-.385 1.083-1.194 1.868-2.269 2.355-1.34.607-2.722 1.036-4.244 1.086z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'guitar':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '154',
	            height: '142',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'guitar'
	          },
	          _react2.default.createElement('path', {
	            fill: 'none',
	            d: 'M120.221.304l32.803 37.735L33.78 141.696.977 103.961z'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M49.746 117.906c-.773 3.449-1.544 6.889-3.654 9.828-.35.488-.892.755-1.451.736a9.108 9.108 0 0 1-2.304 1.532c-1.049.488-2.184.812-3.313 1.057-1.017.22-2.052.411-3.089.512-1.235.122-2.42.102-3.63-.194-1.087-.266-2.12-.828-3.037-1.461-1.615-1.112-3.11-2.439-4.58-3.742l-.4-.355c-1.545-1.367-3.034-2.802-4.39-4.357-2.49-2.853-4.536-6.151-5.487-9.824a3.567 3.567 0 0 1-.309-1.497l-.02-.079-.021-.088c-.722-2.951-1.27-6.064-.851-9.099.423-3.073 1.724-6.143 4.212-8.098 1.221-.96 2.616-1.637 4.075-2.152.77-.272 1.55-.514 2.332-.752l.285-.087c.274-.083.548-.166.822-.251l.178-.058c.106-.035.212-.07.319-.099-.274.073-.192.049-.059.01a8.49 8.49 0 0 0 .247-.074c.67-.228 1.333-.48 1.974-.781a15.146 15.146 0 0 0 1.704-.94l.06-.033.046-.026a.463.463 0 0 1 .06-.048c1.357-.951 2.613-2.016 3.841-3.125l.065-.059c.975-.88 1.951-1.76 2.879-2.69-.115-.444-.06-.93.222-1.311 1.09-1.469 2.317-2.824 3.624-4.098.082-.173.163-.347.243-.521l.168-.368c.284-.622.568-1.244.868-1.858.75-1.536 1.612-2.927 2.772-4.188 2.226-2.418 5.322-3.905 8.39-4.953a62.911 62.911 0 0 1 4.927-1.47c1.03-.26 2.133-.047 2.85.786.265.308.448.67.557 1.054.256.039.505.139.724.271.365.22.647.682.726 1.093.069.363.007.951-.25 1.244-.917 1.05-1.954 1.906-3.056 2.754-.429.33-.857.66-1.269 1.01-.214.18-.424.368-.627.563a9.868 9.868 0 0 0-.344.347l-.04.047a4.5 4.5 0 0 0-.407.543 5.45 5.45 0 0 0-.235.387c-.09.222-.164.443-.235.67a1.28 1.28 0 0 0-.004-.056.429.429 0 0 1-.014.112l-.003.008a.293.293 0 0 0-.014.072v.003a4.589 4.589 0 0 0-.044.743l.005.039a5.795 5.795 0 0 0 .2.988.86.86 0 0 1 .037.108l.017.053c.083.219.175.435.274.648.223.479.482.941.76 1.392.08.131.162.262.246.391l.019.029.046.068c.122.18.244.36.367.538.486.702.577 1.537-.011 2.207-.506.576-1.532.822-2.185.297-.59-.474-1.148-.992-1.606-1.596l-.065-.088-.028-.039a1.71 1.71 0 0 1-.617-.233 1.327 1.327 0 0 1-.393.25 26.903 26.903 0 0 0-4.267 2.161l-.11.07-.049.032a47.559 47.559 0 0 1-1.764 2.15l-.454.78c-.623 1.076-1.247 2.155-2.002 3.144-1.92 2.517-4.567 4.563-7.867 4.545-.104 0-.206-.016-.305-.04l-1.744 1.868c-.57.613-1.631.484-2.205-.022a1.622 1.622 0 0 1-.23-.25c-.233.403-.59.74-1.005.95-.128.064-.261.115-.396.153l-2.965 5.681c.31.65.541 1.361.634 2.074.047.369.089.731-.032 1.093-.151.449-.506.821-.931 1.025a2.349 2.349 0 0 1-1.29.228 2.668 2.668 0 0 1-.835-.24c-.627.717-1.367 1.346-2.126 1.89-.611.438-1.244.843-1.877 1.248l-.534.343-.099.065-.164.108-.075.051c-.163.11-.325.223-.485.338-.28.201-.554.411-.82.63.123.291.257.577.402.858 1.145.667 2.129 1.615 2.98 2.624.465.552.901 1.124 1.337 1.695.318.417.636.833.964 1.241l.767.594c.3.232.6.464.9.698l1.913 1.494c.097.076.196.151.295.227l.095.023.034.008.067.01c.213.03.428.044.642.043h.004l.06-.008c.07-.009.137-.017.206-.028a1.675 1.675 0 0 1 1.414.404c.428.377.563.818.581 1.374a16.735 16.735 0 0 1-.832 5.71 1.595 1.595 0 0 1-.06.157c.167.125.335.248.507.366a10.98 10.98 0 0 0 .937.584l.101.053.045.024.005.002a3.557 3.557 0 0 0 .234.104c.125.052.25.1.377.144.199.069.4.121.603.174l.074.011.07.011c.112.016.225.029.338.04.246.022.492.032.739.032.042 0 .089-.004.138-.009a.925.925 0 0 1 .252-.001l.037-.003c.229-.018.458-.043.686-.072.498-.064.994-.148 1.489-.237a29.47 29.47 0 0 0 1.502-.304c.279-.066.556-.137.83-.215l.23-.069a.438.438 0 0 1 .129-.045l.04-.012a9.75 9.75 0 0 0 1.433-.638c.121-.066.24-.137.358-.209l.032-.024c.182-.137.363-.272.535-.421.19-.166.367-.343.544-.523l.013-.013.01-.011.165-.206c.169-.219.326-.447.473-.682a462.193 462.193 0 0 1 1.719-6.124c.062-.595.113-1.19.163-1.786l.02-.224c.34-4.003.976-8.303 4.071-11.163.558-.515 1.412-.505 2.036-.128l.01.007.008.006c.25-.258.51-.505.782-.738 1.192-1.021 2.598-1.763 4.077-2.272 1.266-.436 2.56-.757 3.856-1.078l.682-.17c.375-.094.749-.191 1.12-.295.168-.047.334-.095.5-.145.05-.015.163-.059.248-.092.123-.049.192-.075-.058.035a14.8 14.8 0 0 1 1.014-.39c.267-.095.534-.19.794-.297l.244-.1c.946-.388 1.896-.777 2.873-1.078.746-.263 1.499-.509 2.251-.755l.704-.23c-.512-.07-.991-.272-1.354-.7a2.07 2.07 0 0 1-.48-1.24 6.02 6.02 0 0 1-1.25-.603 8.857 8.857 0 0 1-1.333-.98l-2.654-1.04c-.88-.345-1.322-1.23-1.06-2.139.244-.845 1.31-1.373 2.132-1.05l.215.084.006-.019.008-.028c.253-.788.796-1.36 1.495-1.77.572-.336 1.624-.147 1.999.42a10.892 10.892 0 0 0 1.673 1.974l.06.055.071.06.099.08a11.1 11.1 0 0 0 1.462 1 33.25 33.25 0 0 0 3.26-1.72 39.973 39.973 0 0 0 1.224-.758l.11-.071.06-.041c.512-.34 1.027-.531 1.644-.321.582.198.99.692 1.118 1.286.294 1.356.152 2.808-.325 4.103-.095.258-.2.507-.315.75.234.14.436.325.573.533.478.724.317 1.598-.284 2.187a37.774 37.774 0 0 1-2.931 2.592 37.784 37.784 0 0 1-2.742 1.981l-.063.042c-.887.584-1.782 1.174-2.74 1.637-.826.4-1.743.743-2.663.833-1.15.113-2.178-.069-3.203-.622a1.14 1.14 0 0 1-.226-.162 18.646 18.646 0 0 1-.109.077c-.21.153-.416.314-.618.479-.72.588-1.7.51-2.347-.144l-.697.172c-.71.174-1.421.35-2.123.558l-.275.083a.95.95 0 0 1-.104.024c-.057.019-.115.042-.171.064-.042.016-.083.033-.124.047-.32.115-.638.24-.95.378-.346.153-.686.321-1.016.507-.093.053-.186.109-.278.165l-.089.054-.086.061-.091.065a9.646 9.646 0 0 0-1.235 1.069c-.034.034-.105.118-.164.187-.096.113-.16.186.029-.057l-.154.199c-.39.504-.775 1-1.105 1.552a17.183 17.183 0 0 0-.583 1.067l-.012.027a2.029 2.029 0 0 1-.037.089 19.27 19.27 0 0 0-.217.493c-.911 2.159-1.427 4.459-1.941 6.756zm2.24-46.837c.048-.136.074-.279.08-.423l.993-.787a9.75 9.75 0 0 0-.566 1.28 2.013 2.013 0 0 0-.506-.07zM35.643 86.992c-.093.02-.185.043-.278.066.247-.22.492-.44.736-.664l-.458.598zm-19.208 16.352v-.02a1.794 1.794 0 0 0 1.06.371l-.236.277a43.17 43.17 0 0 1-.247.287l-.047.055c-.08-.187-.162-.374-.249-.559a1.54 1.54 0 0 0-.28-.411zm11.197 19.715c0-.006.002-.012.003-.017-.017.022-.026.032-.029.032-.017.127.053.15.037.007-.033.094-.037.094-.015-.001a.22.22 0 0 0 .004-.021z',
	            fill: '#E8506D'
	          }),
	          _react2.default.createElement('path', {
	            d: 'M64.006 93.403c1.025 1.18 4.952 1.733 5.17 3.48.005.046-4.73 1.645-8.702 3.013-6.039 2.079-13.52 3.154-15.938 9.993-1.603 4.534-.583 18.125-8.852 18.658-.378.024-.733-.253-1.022-.498-3.667-3.107-1.256-9.48-1.663-13.035-.958-8.371-6.346-16.81 3.808-21.525 1.702-.79 3.723-.704 5.44-1.465 4.469-1.981 1.078-2.854 6.188-2.869 1.39-.004-2.762 1.346-2.517.129.349-1.738.713-3.563 1.688-5.041.983-1.49 2.377-2.805 3.991-3.568 5.276-2.492 11.806 11.454 14.438 14.482',
	            fill: '#fff'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M55.815 73.78c-.004.083.05.051.043-.166l-.022.069c-.009.037-.017.072-.021.097z',
	            fill: '#949699'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M139.313 32.486h-.001l-.019.003-.027-.008h.003l-.012-.003-.005-.001a.58.58 0 0 1 .036-.003.618.618 0 0 1 .037-.01c.059.006.091.016.101.024a.637.637 0 0 1-.113-.002zm-.223-.04c.005-.1.039-.13.05-.09l.001.038c0 .015-.004.04-.007.068l-.044-.016zm3.513 2.174c1.423-2.748.057-6.146-2.815-7.292a1.823 1.823 0 0 0-1.139-.051c-1.083-.289-2.236-.405-3.299-.53-1.961-.232-4.036-.306-5.963.161-2.1.51-3.975 1.625-5.209 3.427-1.093 1.597-1.502 3.523-1.757 5.416-.085.63-.151 1.26-.224 1.89-.842.238-1.668.533-2.47.869-2.294.96-4.398 2.299-6.481 3.64a480.158 480.158 0 0 0-11.138 7.39c-1.885.375-3.657 1.218-5.313 2.162a119.753 119.753 0 0 0-5.814 3.566 146.773 146.773 0 0 0-11.469 8.215A142.889 142.889 0 0 0 62.995 78.91a131.053 131.053 0 0 0-11.955 7.717 127.5 127.5 0 0 0-4.103 3.105c-.74.584-.953 1.975-.311 2.736-.007.48.162.973.478 1.43l2.535 3.667c.056.081.122.156.195.224.107.21.23.413.372.61.118.167.251.315.396.446.206.247.505.423.835.523a3 3 0 0 0 2.183.012c.505-.192.916-.553 1.315-.905l1.194-1.052 2.268-1.997 8.953-7.886c5.99-5.276 12.006-10.526 17.932-15.874 5.912-5.337 11.724-10.791 17.248-16.531l.238-.25a223.691 223.691 0 0 1 2.602-1.743l.274-.18.183-.12a221.525 221.525 0 0 1 8.185-5.093c.477-.283.859-.633 1.04-1.177.082-.247.115-.542.092-.83 1.711-1.107 3.442-2.193 5.281-3.073.354-.17.713-.33 1.075-.482.2.598.698 1.093 1.304 1.378 2.052.965 4.612.826 6.609-.162a7.715 7.715 0 0 0 2.753-2.311c.75-.998 1.227-2.19 1.75-3.318l.02-.037c.073-.134.141-.27.215-.403a6.684 6.684 0 0 1 .582-.883c.049-.062.23-.391.074-.096-.145.276.016-.007.091-.08.123-.12.252-.234.388-.34l.049-.038.132-.08c.087-.045.176-.082.265-.121.051-.007.179-.024.245-.039l.019.001c.062.004.294.062.213.034l.042.012c.916.275 1.738.698 2.699.825 1.477.195 2.973-.597 3.653-1.91z',
	            fill: '#C4AF89'
	          }),
	          _react2.default.createElement('path', {
	            d: 'M31.203 117.897c.16-.219.283-.47.416-.707l.982-1.742c.435-.772.457-1.761-.172-2.46l-6.436-7.147c-.714-.793-2.064-.978-2.865-.215a2.204 2.204 0 0 0-.547.834 1.881 1.881 0 0 0-.383.03c-.495.091-1.049.428-1.31.866-.516.861-.428 2.289.582 2.823.279.147.535.32.78.514.714.687 1.323 1.489 1.946 2.255a37.511 37.511 0 0 1 1.924 2.55c.288.451.56.911.808 1.386.134.258.248.526.384.783.378.712 1.074 1.202 1.884 1.247.819.044 1.536-.376 2.006-1.017z',
	            fill: '#E0DDE8'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M135.407 24.515c.009-.028.019-.057.031-.086.128-.314.328-.62.526-.922.058-.089.116-.177.171-.266.235-.371.612-.517.981-.639.488-.16.943.133 1.049.662.027.133.046.269.065.404.017.122.034.243.056.362a.882.882 0 0 1-.12.625c.205.027.409.057.613.088 1.344.205 2.513.875 3.676 1.541h.001l.211.122c.472.269.8.636 1.04 1.143.671 1.421 1.169 2.892 1.398 4.442.054.368-.024.778-.132 1.142-.611 2.061-1.848 3.66-3.707 4.731-1.1.634-2.272.62-3.428.075l-.216-.1-.002-.001c-.324-.15-.648-.3-.948-.489-.552-.345-.969-.153-1.428.198-.636.487-1.013 1.15-1.391 1.816l-.181.316c-.977 1.68-1.986 3.336-3.272 4.807-.844.964-1.908 1.462-3.167 1.574a1.31 1.31 0 0 1-.542-.06c-.311-.111-.628-.208-.944-.305-.666-.203-1.332-.407-1.954-.753-.57-.316-1.21-.515-1.84-.71l-.141-.044c-.406-.126-.789-.037-1.131.293-2.137 2.067-4.487 3.877-6.838 5.688h-.001l-.002.002-.137.106-.627.483c-.977.755-1.935 1.535-2.893 2.315l-.006.004-.005.005-.069.055-.925.752c-.279.226-.561.447-.843.668l-.007.005-.011.009c-.702.55-1.404 1.099-2.047 1.71-2.738 2.6-5.715 4.903-8.698 7.206-.66.51-1.281 1.071-1.902 1.633-.327.296-.654.591-.987.88-.322.28-.654.549-.985.818l-.025.02-.02.016-.287.234c-.796.652-3.284 2.589-5.872 4.604l-.006.006-.01.007c-2.913 2.269-5.95 4.635-6.842 5.374-.23.191-.442.406-.653.621-.157.16-.315.322-.48.472a85.441 85.441 0 0 1-2.147 1.903c-.341.29-.692.57-1.042.848-.326.26-.653.52-.972.789-.663.559-1.32 1.123-1.979 1.687l-.014.012-.003.003a361.574 361.574 0 0 1-5.918 4.977c.13.503.342.98.745 1.393.474.486 1.06.554 1.658.344l.343-.12.06-.021c.991-.346 1.985-.693 2.932-1.136.614-.286 1.156-.762 1.667-1.223 1.022-.923 2.242-1.315 3.57-1.496.467-.064.849.046 1.186.36.956.89 1.641 1.936 1.809 3.258a14.25 14.25 0 0 1-.655 6.432c-.155.457-.406.881-.657 1.305-.115.196-.231.392-.337.59-.58 1.083-1.455 1.9-2.33 2.714-.274.255-.548.509-.812.772-.416.414-.878.812-1.387 1.095l-.312.174c-.963.539-1.925 1.077-3.046 1.305-.668.135-1.322.33-1.977.525l-.001.001h-.003c-.533.159-1.067.318-1.607.445-.773.182-1.564.29-2.353.399a128.546 128.546 0 0 1-3.967.496h-.001c-.537.063-1.076.126-1.614.123-.925-.007-1.749.308-2.578.625l-.006.002-.005.002c-.21.08-.42.16-.631.235-2.128.753-3.267 2.409-4.03 4.375-.205.526-.262 1.113-.319 1.694-.016.163-.032.326-.05.487-.072.601-.131 1.203-.19 1.806a63.642 63.642 0 0 1-.294 2.61c-.448 3.19-1.282 6.27-2.749 9.152-.512 1.007-1.217 1.85-2.057 2.627a12.744 12.744 0 0 1-3.837 2.441c-.25.104-.51.18-.771.256-.105.031-.21.061-.313.093-.612.191-1.225.379-1.838.567-.084.025-.168.057-.252.088-.19.071-.378.142-.57.148-.62.021-1.238.089-1.856.156-1.23.134-2.458.268-3.703.037a30.477 30.477 0 0 0-1.316-.206l-.002-.001h-.003c-.743-.106-1.485-.212-2.205-.405-1.189-.318-2.395-.661-3.331-1.587-.317-.314-.689-.571-1.061-.829a17.094 17.094 0 0 1-.482-.341l-1.06-.788-.008-.005c-.91-.678-1.821-1.356-2.74-2.023-1.146-.831-1.98-1.939-2.781-3.076-.255-.362-.512-.722-.77-1.082l-.004-.005c-.759-1.061-1.518-2.122-2.205-3.228-1.124-1.81-2.22-3.647-3.17-5.551a25.406 25.406 0 0 1-2.45-7.854c-.392-2.813-.326-5.645.309-8.419.41-1.792 1.35-3.35 2.489-4.788 1.098-1.385 2.476-2.432 3.938-3.393l.002-.002c1.615-1.063 3.236-2.128 5.05-2.816 1.425-.54 2.893-.976 4.36-1.398.9-.26 1.808-.497 2.716-.734.848-.222 1.696-.443 2.539-.683.448-.128.88-.369 1.27-.631 1.487-1 2.676-2.279 3.563-3.85.598-1.06 1.207-2.114 1.817-3.168l.002-.004v-.001c1.038-1.795 2.075-3.59 3.059-5.413.879-1.628 1.919-3.133 3.03-4.592.306-.4.71-.729 1.112-1.054l.004-.004.002-.001c.117-.096.235-.19.349-.287 1.157-.979 2.51-1.615 3.865-2.252l.015-.007.035-.017c.183-.086.366-.172.549-.26 1.433-.683 2.917-1.178 4.48-1.425a5.18 5.18 0 0 1 1.567-.02c1.133.173 2.263.386 3.378.655.982.237 1.735.877 2.37 1.643.321.387.63.788.897 1.212.463.734.58 1.548.486 2.404-.017.159-.023.316-.03.474-.014.356-.028.71-.168 1.072-.294.754-.794 1.293-1.416 1.748-.867.634-1.745 1.252-2.624 1.868a3.85 3.85 0 0 0-1.275 1.507c-.289.595-.15 1.813.283 2.301a.702.702 0 0 0 .282.213l.47.152c.524.172 1.05.344 1.586.456.092.018.184.033.277.045l.087-.057.18-.119c.353-.234.715-.458 1.078-.682.721-.446 1.442-.892 2.1-1.418a44.497 44.497 0 0 1 4.23-3.024c.36-.225.726-.442 1.092-.659l.006-.003c.395-.234.79-.468 1.178-.712.52-.327 1.025-.68 1.522-1.042 1.809-1.317 11.28-8.45 13.063-9.802a341.233 341.233 0 0 0 6.375-4.963l.382-.304.069-.055.083-.067c1.32-1.055 2.64-2.11 4.04-3.063.913-.622 1.817-1.258 2.721-1.894 1.15-.809 2.3-1.617 3.469-2.397.991-.661 2.023-1.261 3.055-1.861l.004-.003.07-.04.02-.012c.297-.173.595-.346.891-.521.364-.215.734-.42 1.104-.627h.002l.003-.002.004-.002.003-.002c.484-.269.967-.537 1.438-.827.568-.35 1.122-.721 1.677-1.093l.007-.004h.001c.312-.21.625-.42.94-.625.282-.184.57-.322.915-.413.354-.094.676-.335.988-.568l.002-.002h.001l.168-.125a137.926 137.926 0 0 0 3.292-2.455c.834-.646 1.576-1.378 2.067-2.344.682-1.342 1.365-2.686 2.123-3.985a11.41 11.41 0 0 1 3.256-3.565 14.47 14.47 0 0 1 1.824-1.106.95.95 0 0 1-.205-.436c-.027-.132-.046-.268-.065-.404a8.471 8.471 0 0 0-.056-.362c-.079-.417.166-.752.452-1.029.892-.649 1.493-.808 2.131-.393.342.221.436.602.265 1.023-.098.24-.236.473-.384.704a18.67 18.67 0 0 1 1.833-.514.927.927 0 0 1-.12-.538c.009-.135.025-.271.042-.407v-.001c.015-.122.03-.243.039-.363.033-.424.356-.684.704-.877 1.029-.396 1.651-.395 2.16.171.272.303.265.695-.009 1.057a4.226 4.226 0 0 1-.514.545l.081-.013h.002c.726-.12 1.452-.238 2.181-.284zm1.556 5.695a3.14 3.14 0 0 1-.079-.264c-.099-.426-.029-.813.226-1.064.738-.637 1.588-.587 1.998.155.302.546.234 1.188-.05 1.77-.031.062-.074.119-.117.176l-.005.007-.008.01a.535.535 0 0 0-.023.031c-.245.333-.557.581-.983.438-.411-.138-.797-.344-.858-.868-.015-.133-.058-.261-.101-.39zM40.229 130.25c1.263-.362 2.527-.724 3.645-1.44 1.553-.995 2.973-2.147 3.766-3.907a32.63 32.63 0 0 0 2.723-10.055c.051-.485.11-.969.167-1.453v-.002c.067-.56.133-1.119.19-1.68.083-.823.416-1.555.749-2.289l.123-.273c.026-.059.06-.114.093-.169.041-.068.082-.137.11-.21.586-1.579 1.88-2.41 3.296-3.098a24.534 24.534 0 0 1 1.975-.837c.782-.297 1.604-.363 2.439-.43l.012-.001c3.314-.264 6.604-.735 9.825-1.55.904-.229 1.77-.608 2.636-.986v-.001l.004-.001c.36-.158.72-.315 1.082-.461.097-.039.178-.121.257-.2l.07-.068c.06-.057.117-.119.174-.18v-.001c.105-.113.208-.226.332-.308l.21-.139.056-.037c.606-.403 1.213-.807 1.85-1.155.567-.31 1.016-.72 1.33-1.262l.121-.204c.312-.524.627-1.054.628-1.706 0-.111.06-.232.118-.332.629-1.07.934-2.236 1.03-3.468.01-.129.037-.257.064-.385.032-.154.063-.308.067-.463 0-.057.003-.116.005-.174.01-.327.021-.667-.09-.953-.447-1.145-1.072-1.362-1.93-1.087a4.81 4.81 0 0 0-1.207.59c-.342.232-.66.499-.979.766-.137.115-.275.23-.414.343a.983.983 0 0 0-.03.025c-.027.023-.053.046-.084.062l-.58.287-.047.023c-.597.297-1.193.593-1.797.876-.328.153-.668.282-1.008.41l-.316.12c-.82.318-1.684.448-2.523.191-.426-.13-.848-.463-1.139-.815a9.37 9.37 0 0 1-1.475-2.44l-.101.079c-.096.074-.192.149-.289.222a1.936 1.936 0 0 0-.554.664c-.358.319-.713.64-1.067.964.277.227.565.444.865.647.396.268.79.55 1.137.877.955.897 2.103 1.3 3.375 1.417.081.007.163.016.245.025.302.034.607.067.898.025.498-.073.872.156 1.244.384l.012.007.128.077c.128.076.194.304.232.475.052.23.093.464.134.697.04.231.08.462.132.691.129.577-.245 1.59-.787 1.852-.92.444-1.857.857-2.81 1.224-.416.16-.843.288-1.271.417l-.004.001h-.001c-.37.111-.742.222-1.105.354-1.02.371-2.078.511-3.15.621-.59.06-1.183.156-1.753.315-1.446.404-2.888.824-4.315 1.29a19.519 19.519 0 0 0-5.974 3.162l-.007.006-.002.001c-.71.553-1.425 1.11-2.07 1.735-.366.354-.638.827-.873 1.287a65.633 65.633 0 0 0-1.405 2.973c-.114.253-.163.546-.191.826-.25 2.473-.52 4.946-1.134 7.356-.354 1.385-.73 2.787-1.313 4.082-.564 1.253-1.404 2.38-2.605 3.161l-.321.209-.002.001-.002.001c-.532.345-1.065.689-1.571 1.069a5.528 5.528 0 0 1-2.614 1.081c-1.384.19-2.76.202-4.125-.158-.95-.251-1.693-.649-2.192-1.642-.415-.824-.656-1.586-.477-2.451.11-.532.332-1.048.563-1.544.363-.782.477-1.585.39-2.442-.076-.732-.141-1.465-.201-2.198a21.32 21.32 0 0 1-1.548 1.093c-.504.325-.793.244-1.203-.2l-.432-.464-.009-.01-.016-.017a50.949 50.949 0 0 1-1.487-1.642c-.367-.43-.71-.88-1.053-1.329v-.001l-.002-.002-.006-.007-.002-.003a63.988 63.988 0 0 0-.466-.606c-.141-.181-.279-.366-.417-.55v-.002l-.004-.004c-.313-.42-.626-.84-.982-1.218-.525-.556-1.07-1.094-1.614-1.632v-.001c-.485-.478-.968-.955-1.439-1.446l-.095-.1c-.65-.675-1.32-1.37-.905-2.469.01-.026-.001-.059-.011-.092v-.001a.472.472 0 0 1-.012-.041c-.072-.347.076-.591.384-.716.551-.225.99-.601 1.428-.977.112-.096.223-.191.336-.284a601.12 601.12 0 0 1 1.556-1.275c.666-.544 1.33-1.089 1.994-1.635.481-.397.797-.435 1.283-.044.362.289.705.602 1.048.915l.02.019.262.237a9.443 9.443 0 0 1-.07-1.507c.075-2.013.508-3.942 1.469-5.708.287-.53.673-1.004 1.045-1.461.165-.203.326-.402.476-.6l.743-.45c.51-.313.994-.609 1.493-.875l.063-.034c1.598-.854 3.198-1.708 4.828-2.498.505-.244 1.035-.437 1.565-.63h.002c.413-.15.826-.3 1.227-.474 1.761-.766 3.204-1.96 4.407-3.443 1.164-1.436 2.026-3.064 2.86-4.699.52-1.015 1.258-1.765 2.18-2.4.657-.451 1.32-.832 2.106-1.007.972-.218 1.85-.026 2.654.538.51.358.996.734 1.455 1.141a16.783 16.783 0 0 0 1.527-1.424c.199-.018.379-.094.567-.224.23-.159.46-.316.69-.472l-.128-.056a35.251 35.251 0 0 0-.475-.204c-.447-.186-.701-.578-.895-.992-.43-.918-.742-1.87-.655-2.904.013-.162.023-.325.033-.488.026-.432.052-.865.148-1.28.228-.987.808-1.774 1.613-2.38.35-.265.712-.515 1.073-.765.188-.13.376-.26.562-.393.389-.275.776-.553 1.16-.833 1.343-.976 1.209-2.065.256-3.244-.554-.685-1.285-1.053-2.127-1.235-.053-.012-.108-.02-.162-.03a1.668 1.668 0 0 1-.329-.077c-1.708-.663-3.348-.278-4.953.338l-.334.128h-.001c-1.315.504-2.635 1.01-3.89 1.637-1.456.726-2.785 1.66-3.641 3.124-.135.23-.294.444-.453.66a7.631 7.631 0 0 0-.439.633 239.6 239.6 0 0 0-1.996 3.436l-.157.274c-.546.952-1.09 1.905-1.634 2.858l-.006.01-.002.004a741.933 741.933 0 0 1-3.131 5.45c-1.033 1.774-2.504 3.125-4.291 4.108-.517.284-1.109.445-1.687.603l-.13.035a249.46 249.46 0 0 1-3.057.81l-.029.007-.026.007c-.693.18-1.386.36-2.077.545a25.376 25.376 0 0 0-8.36 3.962c-1.362.98-2.689 1.978-3.727 3.316-.799 1.03-1.431 2.14-1.734 3.422-.774 3.28-.64 6.504.316 9.762 1.02 3.48 2.838 6.533 4.73 9.559 1.22 1.952 2.598 3.801 4.183 5.475.613.647 1.337 1.196 2.052 1.738l.086.066c.552.418 1.114.822 1.677 1.227.819.589 1.637 1.178 2.422 1.809.972.782 2.055 1.198 3.245 1.424.248.047.494.103.74.159.455.104.91.207 1.37.252.875.087 1.762.09 2.644.081.439-.004.878-.048 1.316-.093a32.6 32.6 0 0 1 .66-.059c.128-.008.257-.016.375-.055.453-.149.913-.281 1.373-.413zm21.324-50.997c-.957.565-1.91 1.129-2.537 2.107-.041.064-.12.105-.197.145-.028.014-.056.028-.082.044-.178.105-.36.207-.54.31-.303.17-.605.34-.894.528a10.44 10.44 0 0 1 .575.793c.59-.425 1.178-.854 1.763-1.285.681-.503 1.355-1.016 2.03-1.528 1.742-1.325 3.484-2.649 5.348-3.81.724-.451 1.41-.963 2.097-1.476.484-.361.969-.723 1.467-1.063.484-.331.989-.632 1.493-.933l.003-.002c.356-.212.712-.425 1.06-.647.497-.318.977-.665 1.444-1.027.316-.244.625-.497.934-.75h.001l.001-.001c.484-.397.968-.793 1.477-1.155.622-.443 2.589-1.895 4.777-3.511l.009-.007c3.042-2.247 6.509-4.807 7.384-5.409a316.812 316.812 0 0 0 3.594-2.5l.495-.345h.002c.604-.42 1.21-.84 1.752-1.329 1.221-1.1 2.475-2.149 3.827-3.084a528.148 528.148 0 0 0 3.355-2.346l1.523-1.07c.238-.166.474-.336.711-.506.542-.39 1.084-.779 1.649-1.134 1.03-.648 1.995-1.356 2.67-2.47a4.565 4.565 0 0 1-.222.067h-.002a2.018 2.018 0 0 0-.463.174c-.353.206-.708.408-1.063.61l-.003.002h-.002c-1.012.577-2.024 1.153-2.986 1.803-2.441 1.648-4.87 3.32-7.223 5.088-2.317 1.742-4.564 3.58-6.788 5.44-1.779 1.486-6.9 5.275-11.045 8.341l-.005.004-.005.004c-2.234 1.652-4.183 3.094-5.172 3.852-.756.58-1.566 1.074-2.376 1.567l-.002.002h-.002c-.704.43-1.407.858-2.076 1.344-1.25.909-2.536 1.77-3.821 2.632l-.697.468A70.508 70.508 0 0 1 61.977 79c-.138.084-.276.165-.414.247l-.01.006zm62.893-48.403c-.393.44-.776.904-1.069 1.413-.368.639-.676 1.313-.984 1.985l-.013.027-.022.048-.099.216c-.066.142-.094.302-.125.473-.015.082-.03.166-.05.252.058-.002.105-.001.143 0 .067 0 .11.002.144-.016.12-.061.239-.134.342-.222.973-.834 1.991-1.6 3.139-2.189.156-.08.342-.287.347-.443.021-.604.409-.957.81-1.292.578-.484 1.336-.336 1.653.34.161.345.27.743.282 1.12.03.91-.592 1.49-1.419 1.389a.858.858 0 0 1-.385-.125c-.335-.237-.579-.13-.842.128-.371.367-.767.71-1.164 1.05l-1.749 1.49c-.721.613-1.442 1.226-2.161 1.843a1.32 1.32 0 0 0-.214.263 2.83 2.83 0 0 1-.092.131c.146.029.231.002.296-.049.961-.745 2.013-1.34 3.066-1.937l.001-.001c.635-.36 1.27-.719 1.884-1.111.252-.16.511-.312.769-.464l.003-.001.003-.002c.469-.275.938-.55 1.367-.878a26.7 26.7 0 0 0 1.438-1.215l.003-.002.002-.002h.001c.383-.34.766-.678 1.163-.998.545-.44.7-.92.403-1.552-.176-.377-.074-.725.153-1.03.539-.726 1.584-.844 2.322-.279.528.405.582 1.548.116 2.17-.024.033-.051.065-.078.097l-.003.004c-.139.165-.288.342-.189.647l.151-.078c.09-.047.167-.087.242-.13l.527-.305.014-.008a58.87 58.87 0 0 1 1.121-.639c.134-.074.324-.166.446-.124.326.112.657.254.932.458.24.178.217.562.004.806-.103.117-.24.21-.374.295-.326.207-.653.413-.98.618l-.042.026c-.451.283-.902.566-1.35.854-.309.199-.618.396-.928.592l-.005.003a69.34 69.34 0 0 0-2.736 1.801c-.583.41-1.139.858-1.696 1.306l-.003.003c-.385.31-.769.62-1.163.917-.77.582-1.546 1.155-2.322 1.73l-.03.021-.019.014c-.656.486-1.313.971-1.966 1.462-.118.089-.213.208-.338.365l-.001.001c-.068.085-.144.18-.238.288.38.141.74.283 1.088.42h.003c.757.297 1.456.571 2.175.772.979.272 1.931.046 2.645-.72.575-.615 1.127-1.264 1.594-1.962.672-1.003 1.301-2.033 1.931-3.064l.004-.007.034-.057.429-.7c.761-1.24 1.818-1.961 3.318-1.897.263.01.54.077.78.186.366.167.718.363 1.071.559l.048.026.217.12c.458.252.892.322 1.329-.06.078-.068.189-.098.301-.128.069-.018.139-.037.201-.065l.178-.077.015-.007c.229-.098.458-.196.665-.328 1.248-.795 1.863-2.025 2.285-3.387.161-.52.227-1.02-.059-1.527a.977.977 0 0 1-.088-.32c-.011-.07-.022-.14-.041-.206-.299-1.036-.725-1.976-1.826-2.41-.19-.076-.372-.173-.554-.27l-.063-.033c-1.415-.75-2.946-1.044-4.513-.97-1.849.087-3.663.45-5.46.915-2.413.626-4.485 1.782-6.145 3.643zm-20.802 23.533c-.442.209-.887.425-1.256.732-.349.29-.669.614-.989.938-.138.139-.275.278-.415.414.299-.237.619-.45.941-.663v-.001h.002c.617-.41 1.238-.822 1.717-1.42zM63.381 88.286c-.58.408-1.16.817-1.735 1.233.201.246.408.487.622.722a.45.45 0 0 0 .103-.178c.156-.607.627-.855 1.106-1.108l.079-.041c.056-.03.114-.058.172-.085.129-.061.258-.122.366-.209 1.05-.84 2.096-1.685 3.141-2.53l.116-.094 1.27-1.025c.244-.197.49-.392.735-.586l.013-.011a54.78 54.78 0 0 0 1.474-1.195c.57-.486 1.124-.99 1.678-1.494l.004-.004.002-.001.001-.002h.001l.548-.498c.015-.014.017-.04.023-.106.004-.046.01-.111.024-.205-.15.107-.285.207-.41.301-.25.186-.464.345-.694.48-1.363.793-2.61 1.746-3.786 2.786-.835.739-1.674 1.463-2.577 2.116-.356.258-.702.53-1.048.803-.404.318-.808.636-1.228.93zM24.166 108.63c.57-.276 1.109-.633 1.621-1.01.635-.467.628-.647.085-1.253a4.027 4.027 0 0 0-.187-.201c-.192-.191-.371-.217-.593-.02-.618.546-1.24 1.088-1.862 1.63-.48.419-.959.837-1.436 1.257-.064.056-.112.13-.166.213v.001c-.028.041-.056.085-.089.13.05.063.095.125.14.186l.002.003c.095.13.187.254.293.363.217.219.438.434.66.649.338.328.677.656.997 1 .842.906 1.682 1.816 2.471 2.767.447.538.87 1.095 1.294 1.652v.001l.002.001V116c.367.482.734.964 1.115 1.434.533.656.724.644 1.33.084.045-.042.09-.084.133-.127l.002-.002.003-.003.06-.057.648-.621.006-.006c.507-.486 1.014-.973 1.526-1.454.48-.452.48-.518-.142-1.01l-2.302 1.809a37.117 37.117 0 0 0-.4-.119 11.726 11.726 0 0 1-.685-.216c-.342-.122-.427-.419-.52-.74l-.027-.097c.057-.064.111-.136.165-.207.116-.155.23-.308.383-.374.53-.228.943-.597 1.357-.967l.002-.001c.142-.127.284-.254.43-.375.259-.213.29-.46.05-.708-.154-.159-.314-.311-.468-.458l-.002-.001-.001-.001-.007-.007-.003-.003-.185-.176c-.266.063-.477.229-.681.39-.308.241-.602.472-1.048.332-.21.713-.395.903-1.131.816-.748-.09-.958-.738-1.122-1.32l.516-.662.482.1 1.618-1.407-.196-.25-.013-.017-.007-.009-.361-.459c-.205-.257-.414-.298-.704-.093-.39.276-.808.516-1.227.749-.605.336-1.229.497-1.895.028l-.123.403a2.901 2.901 0 0 0-.277.011h-.002c-.212.014-.422.028-.578-.057-.168-.091-.288-.273-.419-.471a4.132 4.132 0 0 0-.194-.278l.607-.272-.076-.369c.148-.015.29-.019.423-.022.272-.008.512-.015.708-.11zm10.273-12.171l.044-.041c-.4.224-.8.452-1.195.683-1.476.861-2.721 1.945-3.117 3.727a1.5 1.5 0 0 1-.097.27 3.505 3.505 0 0 0-.055.132c-.399 1.055-.544 2.159-.6 3.277l.524-.448c.79-.575 1.518-1.237 2.244-1.897l.002-.002.001-.001c.313-.284.625-.568.941-.844a.338.338 0 0 0 .1-.142l1.667-1.302a2.403 2.403 0 0 1-.066-.14c-.028-.063-.046-.103-.076-.128-.146-.122-.295-.24-.444-.359l-.004-.003a29.106 29.106 0 0 1-.352-.283c-.5-.408-.545-.654-.25-1.256l.006-.01c.028-.057.06-.124.055-.182-.04-.381.192-.6.426-.819l.003-.003.092-.087c.049-.048.1-.095.15-.142zm19.19-13.768c.147-.108.288-.222.431-.344l.244-.166c-1.04-.606-2.47-.542-3.378.095-.886.622-1.65 1.37-2.159 2.349-.127.245-.257.489-.387.733-.218.409-.435.817-.641 1.232-.15.303-.311.599-.479.888l.76-.54c1.185-.842 2.37-1.685 3.554-2.53.08-.056.144-.13.223-.22v-.001c.042-.047.086-.099.138-.154a13.638 13.638 0 0 1-.245-.2 57.958 57.958 0 0 0 1.77-1.09.338.338 0 0 0 .17-.052zm-9.165 18.48l.005-.004c.65-.477 1.277-.939 1.897-1.41a25.318 25.318 0 0 0 1.483-1.211c.345-.306.335-.607.034-.951-.178-.202-.76-.279-.963-.1a608.137 608.137 0 0 0-3.786 3.351.504.504 0 0 0-.108.191c-.016.04-.033.081-.054.124l.647.633.817-.602.001-.001.027-.02zm9.223-12.702c-2.24 1.433-4.361 3.031-6.52 4.684l.577.663 6.033-5.244-.09-.103zm-8.01 6.214l-.005-.004v-.001c-.034-.037-.067-.073-.098-.11-1.523.593-4.687 2.817-5.333 3.767l1.12 1.126c.068-.044.126-.078.175-.107h.001c.086-.052.147-.088.199-.135.997-.891 1.992-1.785 2.986-2.68l.067-.06.037-.033.678-.609.085-.076.002-.002c.09-.08.18-.16.268-.244.176-.165.2-.355.056-.55a3.861 3.861 0 0 0-.239-.282zm-13.08 9.502c-.417.34-.869.732-1.164 1.205-.546.417-1.07.825-1.562 1.282.109.4.22.798.336 1.196l.064.219.067.228a.353.353 0 0 0 .445-.016c.325-.252.65-.504.972-.759.587-.148 1.099-.594 1.522-.999a15.08 15.08 0 0 0 1.132-1.242c.138-.099.275-.2.41-.304l.015.013.045.033 2.984-2.595c-.086-.099-.17-.198-.253-.297l-.004-.004v-.001a10.68 10.68 0 0 0-.603-.675c-.2-.201-.471-.326-.74-.116a91.077 91.077 0 0 0-2.252 1.813 17.5 17.5 0 0 0-1.414 1.019zm11.122-12.612c-1.23.984-2.524 1.835-4.052 2.32-.769.245-1.522.57-2.239.941-.223.116-.446.232-.669.35.465.418.942.823 1.42 1.227l.002.002.006.005.003.002c.116.099.24.186.365.272l.002.002.165.115c.278-.206.55-.41.82-.612.611-.46 1.205-.906 1.817-1.327.406-.279.828-.535 1.25-.79v-.001l.002-.001.004-.003c.356-.216.713-.433 1.06-.663.574-.382.58-.504.198-1.202l.425.262c-.039-.074-.07-.135-.095-.188a1.554 1.554 0 0 0-.12-.22c-.115-.162-.235-.32-.354-.478l-.001-.002-.01-.011zM33.173 110.7c.368-.32.737-.64 1.092-.973.75-.509 1.423-1.132 2.091-1.752l.003-.003.002-.001c.204-.19.409-.379.614-.564l.018-.013v-.001c1.102-.82 2.163-1.61 3.023-2.677-.453-.614-.538-.64-1.019-.289-.53.389-1.058.783-1.569 1.198-.336.273-.66.56-1 .86l-.002.001-.001.001-.128.112c-.242.115-.47.278-.687.434v.001l-.003.001-.12.086a16.17 16.17 0 0 0-1.26.989 8.917 8.917 0 0 0-.82.787l-1.617 1.18.224.234.004.003.001.002c.148.152.276.285.397.423.21.239.434.242.657.048l.1-.087zm16.835-13.882l.447-.388a552.94 552.94 0 0 0 2.298-2.004l.003-.003c1.777-1.554 3.553-3.109 5.374-4.611.295-.244.594-.485.894-.724a17.602 17.602 0 0 1-.742-1.318l-.02.015-.003.002a37.7 37.7 0 0 0-1.169.885c-.658.526-1.31 1.06-1.962 1.595l-.025.02c-.345.284-.691.568-1.038.85-.159.13-.32.256-.482.383l-.007.005-.002.001c-.285.223-.57.446-.841.685a298.858 298.858 0 0 0-3.109 2.792c-.096.087-.183.163-.26.23-.592.515-.61.53.1 1.533a.84.84 0 0 0 .14.14h.001c.04.034.089.077.15.133l.253-.22zm9.67-3.874c.434-.41.846-.846 1.253-1.287a21.44 21.44 0 0 1-.818-.999 40.744 40.744 0 0 0-2.322 1.91 584.613 584.613 0 0 1-4.316 3.8l-.002.002-.003.004c-.6.523-1.198 1.047-1.796 1.572-.223.196-.447.391-.675.58-.25.207-.232.415-.03.645.222.254.55.34.78.101.28-.293.611-.414.97-.544l.024-.01c.171-.062.32-.187.468-.312l.001-.001a4.03 4.03 0 0 1 .195-.158l.14-.107.003-.002.004-.003.003-.003c.073-.057.147-.113.223-.166.108-.076.219-.15.33-.223l.006-.004c.208-.138.415-.275.61-.43.306-.24.578-.515.851-.79v-.001c.328-.33.656-.661 1.046-.94 1.09-.778 2.078-1.71 3.055-2.633zM71.63 77.537l-.007.006-.005.003c-.821.595-1.643 1.19-2.448 1.806-.433.33-.841.693-1.25 1.055l-.002.002h-.002c-.41.365-.821.728-1.256 1.06a740.65 740.65 0 0 1-5.669 4.275l-1.207.904.049.1c.195.408.416.809.658 1.195.617-.474 1.239-.942 1.86-1.41l.004-.003.002-.002c.706-.532 1.412-1.064 2.111-1.603.716-.552 1.426-1.112 2.135-1.672l.002-.001.002-.002.045-.035.03-.024a493.443 493.443 0 0 1 1.191-.94c.227-.182.454-.363.686-.537.48-.358.96-.715 1.442-1.072.893-.663 1.787-1.325 2.671-2 .234-.178.448-.382.662-.586.2-.19.399-.379.614-.548.644-.507 1.294-1.006 1.945-1.505h.001c.632-.484 1.263-.968 1.888-1.46.43-.338 1.35-1.05 2.509-1.947l.004-.003.002-.002c3.425-2.652 8.941-6.923 10.153-7.993 1.229-1.086 2.518-2.106 3.808-3.12.406-.318.832-.61 1.258-.903h.002l.002-.002.002-.001.006-.005c.36-.247.72-.494 1.069-.757.25-.19.507-.369.767-.55l.004-.002.004-.003c.715-.498 1.446-1.006 2.068-1.75-.325.193-.643.376-.955.555l-.022.012c-.7.402-1.366.785-2.007 1.206-.762.5-1.5 1.038-2.239 1.577l-.002.001c-.275.201-.55.401-.827.6-.425.306-.85.614-1.274.922l-.001.001c-.535.388-1.07.776-1.607 1.16-.871.623-1.746 1.24-2.627 1.848-.73.505-7.232 5.356-9.486 7.038l-.702.523c-.715.533-1.42 1.082-2.123 1.631l-.006.004c-.642.501-1.283 1.002-1.934 1.49-.657.493-1.323.975-1.988 1.457l-.008.006-.002.001zm-17.303 8.106c.685-.454 1.364-.918 2.038-1.389a11.69 11.69 0 0 0-.59-.721c-.235.188-.468.379-.702.569l-.238.194a29.07 29.07 0 0 0-.755.642h-.001c-.406.353-.81.706-1.244 1.02-1.296.938-2.605 1.859-3.914 2.78l-.006.004-.01.006c-.647.456-1.294.91-1.94 1.368-.372.264-.744.532-1.09.829-.062.052-.078.158-.094.263a1.286 1.286 0 0 1-.026.14c.043.008.089.022.135.035.1.03.202.06.28.029.178-.07.339-.19.497-.307l.079-.057c.494-.36.988-.722 1.481-1.083 2.01-1.472 4.021-2.944 6.1-4.322zm-9.99 25.208c.343-.57.679-1.161.896-1.787.664-1.915 1.866-3.382 3.444-4.627 1.75-1.382 3.733-2.315 5.725-3.253l.047-.022c1.356-.639 2.79-1.032 4.224-1.425h.002l.018-.006h.003c.399-.11.797-.22 1.193-.334a16.758 16.758 0 0 1 3.012-.587c.754-.076 1.511-.193 2.243-.38a53.393 53.393 0 0 0 2.689-.791l.003-.001.056-.018.542-.169c.174-.054.34-.134.504-.215l.005-.002a7.66 7.66 0 0 1 .224-.106l-.03-.153-.212-.052c-.153-.04-.306-.078-.46-.101-1.332-.204-2.522-.715-3.55-1.601a14.82 14.82 0 0 0-1.019-.797 15.48 15.48 0 0 1-1.651-1.382 191.4 191.4 0 0 0-1.858 1.77c-.123-.007-.257.061-.41.2l-.296.267-.002.001a51.706 51.706 0 0 0-1.905 1.777c-1.542 1.536-3.243 2.859-5.08 4.024-.556.351-1.088.253-1.621.155a7.705 7.705 0 0 0-.424-.07c-.444-.056-.76-.365-1.013-.751-.24-.366-.378-.376-.74-.169-.135.077-.26.174-.385.27l-.001.001-.06.046-.344.263-.018.013c-.786.6-1.572 1.2-2.354 1.806-.16.123-.31.258-.458.391l-.002.001c-.067.06-.133.12-.2.178.098.579.07 1.187-.146 1.481l-.09.122c-.505.692-1.007 1.379-1.794 1.827-.4.228-.683.147-1.007-.021-.1-.052-.186-.135-.29-.235a5.174 5.174 0 0 0-.178-.165l-3.101 2.625a.31.31 0 0 0-.25.074l-2.85 2.476a.33.33 0 0 0-.113.191l-.156.114-.01.007-.011.008c-.377.274-.727.528-.997.854l.382.439.787.906c.352.407.416.791.16 1.251-.155.276-.331.557-.56.769-.33.307-.672.6-1.015.894a37.99 37.99 0 0 0-.887.775l-.05.046-.034.032.006.057c.004.035.008.069.01.104.091.982.159 1.966.226 2.951.036.518.072 1.037.11 1.555.11 1.451.048 2.859-.767 4.146-.282.444-.135.757.374.962.35.141.737.264 1.107.264a23.226 23.226 0 0 0 2.356-.149c.276-.029.569-.133.803-.283l.284-.18c.991-.631 1.984-1.262 2.933-1.952.601-.437 1.022-1.069 1.258-1.79.2-.611.385-1.227.569-1.843l.001-.004.165-.548c.49-1.624.95-3.252 1.096-4.957a54.39 54.39 0 0 1 .266-2.32c.06-.458.118-.916.17-1.374.061-.532.228-1.009.506-1.473zm-7.697 5.831c-.171.602.037 1.193.574 1.59 1.004.742 1.849.614 3.023-.198.366-.363.66-.823.468-1.465-.116-.389-.198-.788-.318-1.176-.252-.816-.968-1.341-1.647-1.19-.514.114-1.034.264-1.307.78-.287.543-.627 1.077-.793 1.659zm-.38 3.764c-.573.619-.531 1.394-.431 2.152.022.171.25.324.399.469.342.332.78.082 1.167.171.179.04.392-.071.47-.087.676-.576.807-1.331.483-2.265-.11-.318-.203-.692-.6-.722-.512-.039-1.075-.162-1.487.282z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'island':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '70',
	            height: '84',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'island'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h70v84H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M43.184 60.41c-1.168-.21-2.288.549-2.502 1.694-.046.25-.046.498-.005.735-.247.3-.457.653-.622 1.065-.7 1.746-.235 3.477 1.06 4.866.94 1.008 2.305 1.834 3.921 2.464 3.136 1.224 6.707 1.585 8.53.479 1.938-1.175 2.401-3.69 1.824-5.908-.699-2.687-3.23-4.06-6.928-4.789a30.856 30.856 0 0 0-3.17-.438 136.062 136.062 0 0 0-2.016-.16l-.07-.006-.022-.002z',
	            fill: '#E8506D'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M19.22 78.777c.65-.565 1.04-.876 1.435-1.123.324-.204.657-.396 1-.579a2.163 2.163 0 0 0 2.546.763c.182.06.43.161.751.31.11.05.226.104.374.175l.316.153.328.156c.264.123.484.22.696.305.716.285 1.29.423 1.958.323.24.531.67.982 1.312 1.259 1.033.444 2.04.296 3.055-.18a8.633 8.633 0 0 0 1.151-.666l.32-.218.33-.224c.308-.202.564-.406.815-.649.194.776.463 1.293 1.15 1.75.899.599 1.868.463 2.601-.025a2.82 2.82 0 0 0 .372-.294c.397.825 1.194 1.414 2.264 1.406 1.316-.01 2.207-.412 3.672-1.352l.145-.094c.793-.51 1.122-.682 1.411-.741.784-.162 1.765-.064 3.142.312.084.052.179.12.418.302.638.485.977.708 1.537.925.398.154.841.26 1.29.278 1.03.038 2.04-.362 2.523-1.532.638-1.547-.023-2.899-1.29-4-.742-.643-1.752-1.246-2.976-1.826-1.931-.914-4.445-1.762-5.632-1.932-.547-.078-1.138-.168-1.902-.288l-1.054-.168-.1-.016h-.004c-.383-.062-.745-.12-.897-.143a117.84 117.84 0 0 0-4.523-.647c-4.026-.482-7.186-.522-9.85.035-4.062.849-6.94 1.84-9.549 3.478-.635.399-1.169.822-1.976 1.527l-.183.16-.178.156c-1.181 1.033-1.782 1.461-2.497 1.724a2.15 2.15 0 0 0-1.28 2.764 2.16 2.16 0 0 0 2.772 1.276c1.363-.5 2.29-1.16 3.852-2.529l.18-.157.175-.154z',
	            fill: '#FFD65F'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M39.515 10.474l.34-.136c.551-.22.687-.274.937-.377 1.041-.43 1.69-.757 2.162-1.149.931-.774 1.078-1.931.081-2.773a1.882 1.882 0 0 0-.998-.425 3.463 3.463 0 0 0-.661-.015 1.976 1.976 0 0 1-.252.002 1.189 1.189 0 0 0-.792.169l-.678.423a2.006 2.006 0 0 0-.106-.395c-.34-.86-1.385-1.146-2.098-.49a1.753 1.753 0 0 0-.277.329c-1.37-.917-3.197-1.763-4.038-1.875-1.219-.162-1.839 1.394-.833 2.09 0 0 3.893 2.704 3.892 2.708-.02.144-.03.27-.025.398.003.07.01.137.023.207l-.215.031a1.4 1.4 0 0 0-.827-.089 2 2 0 0 0-.326.092l-.15.056-.056.021c-.069.025-.138.05-.21.072-.58.06-.987.132-1.415.261a3.263 3.263 0 0 0-.928.302c-1.128.374-2.533.862-3.548 1.24-.82.305-1.395.539-1.718.707a1.871 1.871 0 0 0-.37.242c-.16.137-.287.292-.371.544-.177.53.05 1.089.512 1.367.201.122.377.163.567.178.086.006.168.006.255 0 .12-.008.257-.026.422-.054a11.787 11.787 0 0 0 3.478-1.15c.269-.137.52-.275.826-.451-.055.031.509-.296.637-.368.08-.045.153-.084.218-.117.185-.06.362-.119.525-.171a8.933 8.933 0 0 0 1.367-.252l.11-.01h.01l.028-.003.183.297c.513.815 1.184 1.745 2.137 2.915.114.14.283.431.49.852.093.187.19.395.313.66-.027-.058.344.755.441.963.173.367.31.634.44.85.293.488.525.751 1.043.87a1.268 1.268 0 0 0 1.364-.563c.132-.206.199-.419.24-.67.192-1.165-.148-1.96-1.155-3.54-.204-.32-.366-.586-.49-.809l.048.002c.084.054.163.103.242.15.79.475 1.451.704 2.16.559h1.532c.116 0 .232-.017.343-.051.556-.167.861-.6.998-1.078.065-.228.086-.466.035-.716a1.25 1.25 0 0 0-1.187-1.013l-3.364-.135c-.625-.415-.742-.478-1.082-.608a2.293 2.293 0 0 0-.23-.074zM14.59 34.626c.122.097.215.181.3.284a1.164 1.164 0 0 1-.441 1.85 1.172 1.172 0 0 1-.625.083 1.573 1.573 0 0 1-.227-.043 3.18 3.18 0 0 1-.291-.095 15.34 15.34 0 0 1-.617-.25l-.083-.036-.645-.274a35.75 35.75 0 0 0-.212-.089c-.583-.24-.996-.39-1.2-.43-1.742-.352-2.124-.339-2.445-.09-.07.054-.358.352-.726.733l-.006.006c-.522.54-1.203 1.243-1.655 1.661-.644.595-1.7.304-1.936-.533l-.815-2.889a3.869 3.869 0 0 1-.307-1.137c-.174-1.42 1.91-1.825 2.298-.448l.207.734c.035.013.08.013.137.01.47-.02 1.273-.382 2.235-1.032l.142-.097c.022-.054.052-.115.093-.198.096-.132.13-.18.17-.221.02-.02.04-.04.071-.067l.003-.003.003-.002.003-.003.003-.003c.081-.069.15-.113.232-.16l.127-.066a8.805 8.805 0 0 0 .83-.467c.349-.297.695-.609 1.029-.927.693-.66 1.264-1.29 1.363-1.46a2.324 2.324 0 0 1 .16-.24c.036-.047.085-.083.346-.276.064-.032.105-.053.147-.068.076-.028.158-.04.385-.074.231.024.351.036.46.078.117.046.22.126.436.293.25.455.314.573.32.694a.881.881 0 0 1-.008.143c-.024.18-.03.223-.041.264l-.013.039-.001.002a1.481 1.481 0 0 1-.056.148c-.049.112-.133.28-.227.454-.287.53-.556.942-.851 1.203-.424.374-.82.698-1.191.98.952.459 1.99 1.118 3.12 2.02z',
	            fill: '#7CC84A'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M32.463 16.122c.328-2.227 3.642-1.861 3.477.383l-.107 1.516v.004c-.098 1.405-.225 3.214-.26 3.584-.098.996-.227 1.49-.569 2.222.03-.063-.335.698-.469.992-.23.508-.473 1.09-.755 1.825-.763 1.983-1.71 4.81-2.908 8.78-1.408 4.665-2.312 10.842-2.735 17.44-.076 1.186.132 2.634.853 6.528l.089.48c.845 4.584 1.076 6.764.62 8.591-.061.242-.141.45-.33.696a1.76 1.76 0 0 1-2.457.352c-.037.17-.104.34-.226.536a1.754 1.754 0 0 1-2.415.558 1.644 1.644 0 0 1-.607-.633 2.139 2.139 0 0 1-.246-.713 3.57 3.57 0 0 1-.05-.41l-.996-4.503a1.754 1.754 0 0 1-.04-.301c-.158-3.591-.156-5.53.108-7.734.786-6.564 1.67-12.006 2.86-17.154 1.12-4.848 2.36-8.926 5.013-16.931.286-.864.588-1.48 1.305-2.795.238-.437.375-.691.493-.922l.352-2.392zM9.482 39.302c-.316-2.148 2.787-2.837 3.408-.756l8.945 29.934c.62 2.077-2.342 3.207-3.262 1.244-4.659-9.947-7.462-19.357-9.091-30.422z',
	            fill: '#C28E64'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M55.823 79.83c-1.36.066-2.681-.244-4.018-.407-.964-.118-1.93-.223-2.816-.661-.356-.177-.654-.016-.929.162-.475.306-.923.654-1.393.968-1.502 1.006-3.182 1.535-4.965 1.765-.747.097-1.408-.207-1.984-.628a44.485 44.485 0 0 1-2.831-2.226c-.394-.34-.691-.415-1.194-.24-2.28.796-4.605 1.043-6.98.42-1.022-.27-1.936-.75-2.78-1.369-.605-.444-.582-.422-1.196.026-.415.303-.883.541-1.347.77a15.55 15.55 0 0 1-1.618.704c-.463.167-.968.22-1.432.385a26.8 26.8 0 0 1-7.985 1.542 3.416 3.416 0 0 1-.426-.01c-.116-.01-.23-.04-.425-.075.089-.192.142-.36.235-.503.872-1.33 1.97-2.46 3.24-3.413 1.166-.875 2.383-1.685 3.589-2.509l.188-.124c.144.034.292.04.396.06.262-.12.471-.237.696-.311.404-.134.518-.256.58-.64.615-.261 1.25-.464 1.906-.611.09.029.182.05.28.059.276.023.553-.08.768-.248 2.598-.382 5.164-.906 7.731-1.441 2.418-.504 4.876-.784 7.34-.446 1.731.238 3.452.594 5.15 1.008.766.186 1.444.697 2.197.964 1.8.636 3.603 1.274 5.44 1.793.95.268 1.768.693 2.437 1.358.899.893 1.727 1.857 2.56 2.813.205.233.309.552.544.99-.455.036-.706.064-.958.076zM17.122 65.636l3.142-1.31c.193 1.356.377 2.614.543 3.874.016.123-.038.31-.128.38-.566.44-1.105.943-1.96 1.05l-1.597-3.994zm-.833-1.928c-.53-1.221-.796-2.457-1.044-3.654.907-.143 1.734-.283 2.566-.394.131-.017.303.076.417.167.144.116.283.264.362.427.334.69.645 1.391.994 2.154-1.099.446-2.104.994-3.295 1.3zm-1.607-5.86c-.276-.936-.511-1.883-.78-2.903l1.978-.41a15.272 15.272 0 0 1 1.135 3.216c-.636.35-1.26.432-1.9.368-.157-.016-.396-.146-.433-.271zm-1.034-4.79c-.112-.018-.267-.154-.293-.261-.286-1.2-.74-2.364-.801-3.612-.002-.041.032-.084.07-.18l1.454-.411c.074.161.135.259.165.365.266.945.529 1.89.789 2.836.073.27.187.56-.105.77-.38.276-.767.572-1.279.493zm-1.195-5.906c-.298.09-.466-.032-.527-.295-.177-.763-.335-1.53-.513-2.35l1.573-.41c.258.955.566 1.815.602 2.769-.415.103-.78.179-1.135.286zm-1.718-6.354c-.008-.084.092-.23.176-.265.237-.097.488-.171.74-.214.262-.044.46.06.522.345.084.383.175.765.284 1.24l-1.355.563c-.27-.573-.31-1.125-.367-1.669zm-.35-2.428c-.13-.491-.244-.914-.358-1.338 1.018-.207 1.593.246 1.505 1.254l-1.146.084zm-1.719-3.036c-.645.04-1.075.454-1.44.923-.908 1.164-1.875 2.293-2.398 3.702-.028.074-.103.132-.228.287-.135-.941-.06-1.769.104-2.58.1-.496.315-.972.503-1.448.269-.679.816-.908 1.515-.875.187.009.379.016.56-.016.282-.05.546-.244.492-.51-.122-.606.254-.999.534-1.514.322.048.686.044 1.005.16 1.102.405 1.364.333 1.876-.697.149.11.345.183.408.317.137.293.169.636.315.922.132.257.36.466.595.76-.47.205-.82.41-1.2.507-.306.078-.646.024-.972.029-.556.009-1.114 0-1.669.033zm-5.79-1.327c-.052.011-.12-.045-.183-.07.483-.915 2.554-1.638 3.973-1.335-1.296.585-2.492 1.13-3.79 1.405zm5.677-3.371l-.34-.482c.516-.02.516-.02.34.482zm4.136-1.196c-.104 1.139-.39 1.467-1.163 1.343.176-.64.8-.885 1.163-1.343zm.77 5.297c.619.361 1.249.72 1.692 1.305.037.049.03.128.069.31-.656-.146-1.22-.207-1.569-.788-.157-.261-.46-.437-.717-.67.119-.257.36-.254.525-.157zm1.599-1.893c-.26.486-.262.482-.7.16.23-.288.443-.31.7-.16zm8.145 27.49c1.846.733 3.679.471 5.51-.317.07.217.14.362.161.514.186 1.368.366 2.737.54 4.107.086.674.062.795-.6.984-1.78.508-3.588.852-5.456.607-.177-.023-.345-.12-.499-.177-.094-4.104-.04-5.073.344-5.717zm-.165-2.157c.06-.88.113-1.762.142-2.644.042-1.312.147-2.614.475-3.976.87.053 1.696.185 2.51.129.807-.056 1.6-.301 2.422-.468.005.018.046.082.043.144-.085 1.918-.158 3.835.007 5.753.03.345-.011.652-.408.798-1.376.506-2.749 1.023-4.26.873-.21-.021-.422-.06-.621-.125-.223-.072-.328-.227-.31-.484zM25.276 43.4c.7.119 1.336.275 1.981.324.648.05 1.304-.007 2.06-.018l-.268 2.256c-.06.509-.135 1.017-.168 1.528-.033.514-.102.93-.723 1.114-.648.193-1.245.55-1.883.783-.698.255-1.42.276-2.207.068.256-2.05.738-4.01 1.208-6.055zm3.865 25.91c-.67.171-1.298.346-1.934.486-.343.076-.7.089-1.05.135l2.984-.62zm-5.6 1.053a204.05 204.05 0 0 1-.235-1.69c-.022-.17.023-.35.039-.553 1.128.029 2.195.138 3.248.06 1.05-.077 2.086-.343 3.234-.545.065.44.125.782.165 1.127.016.133.032.25.052.356l-6.503 1.245zm3.807-34.646l2.849.962c-.044.556-.067 1.11-.137 1.66a65.647 65.647 0 0 1-.372 2.496c-.1.606-.16.653-.764.699-.66.05-1.32.107-1.98.117-.367.005-.734-.082-1.216-.142.48-2.043.96-3.932 1.62-5.792zm.641-2.167l1.602-5.145c.013-.04.058-.07.174-.208.502.197 1.012.373 1.495.604.12.058.24.307.216.443-.303 1.698-.632 3.391-.958 5.085-.008.04-.055.073-.124.162a5.706 5.706 0 0 1-2.149-.44c-.219-.09-.335-.247-.256-.501zm2.747-8.376c.306-.859.676-1.696 1.024-2.539.061-.148.16-.28.294-.51l1.267.538c-.106.529-.177 1.034-.313 1.522-.215.766-.473 1.52-.717 2.277-.143.441-.216.494-.666.367-1.643-.464-1.343-.385-.89-1.655zm1.31-12.99c-.644.147-1.296.26-1.868.625-.156.099-.344.156-.524.211-.767.235-1.536.464-2.306.69-.17.05-.348.077-.522.114l-.098-.117c.13-.17.249-.351.395-.507a6.84 6.84 0 0 1 3.428-1.996c1.225-.303 2.453-.399 3.707-.42.602-.009 1.083.066 1.559.464.482.403 1.373.235 1.74-.271.112-.154.15-.389.15-.586-.002-.548-.017-.546.516-.71.178-.056.35-.126.59-.214.316.552.604 1.025.263 1.735-.251.524-.232 1.17-.102 1.772.043.203.08.413.077.619-.018.873.35 1.407 1.2 1.74.14.056.306.167.361.295.449 1.03.946 2.045 1.121 3.17.02.122-.016.253-.04.549-.322-.504-.541-.879-.791-1.232-.65-.918-1.329-1.817-1.96-2.748-.125-.186-.148-.489-.112-.722.132-.863-.209-1.359-1.104-1.463a1.102 1.102 0 0 1-.82-.484c-.408-.573-1.01-.766-1.658-.976-.888-.289-1.661-.083-2.457.242a4.816 4.816 0 0 1-.745.22zm1.97-6.315c-.816-.351-1.764-.4-2.695-.59.088-.258.327-.313.542-.35 1.18-.208 2.342-.216 3.44.365.186.098.383.215.584.237.448.05.609.323.63.705.021.41.077.833-.13 1.213-.822-.564-1.532-1.22-2.371-1.58zm7.808 6.128c.514.055 1.041.114 1.525.281.512.178.905.54 1.005 1.21-.885-.197-1.706-.371-2.521-.568-.125-.03-.251-.143-.33-.251-.1-.142-.155-.317-.229-.478.184-.07.375-.212.55-.194zm.1-5.127c.406-.127.804-.287 1.218-.377.232-.05.488.011.734.022l.051.178-2.344 1.685-.166-.104c-.011-.204-.017-.409-.035-.612-.035-.411.149-.669.543-.792zm-6.148 8.986c-.126.274-.302.403-.613.302-.338-.11-.46-.281-.36-.638.097-.351.245-.688.38-1.057.714.647.814.913.593 1.393zm-1.719 4.583c-.099.27-.502.317-.877.16-.294-.123-.375-.327-.253-.62.32-.771.636-1.545.983-2.387l.956.422c-.277.84-.522 1.64-.809 2.425zm7.045 43.855c.275-.541.572-1.072.845-1.613.288-.572.36-.617 1.021-.573.162.01.325-.005.488-.009-.004.394-1.336 3.841-1.649 4.283l-1.284-.223c-.03-.703.283-1.283.58-1.865zm2.71 3.938c.614-1.715 1.302-3.404 1.965-5.102.136-.348.31-.682.437-1.032.1-.275.279-.37.546-.302.297.074.602.14.881.26 1.278.546 2.553 1.102 3.82 1.672.514.232.55.272.307.795a81.796 81.796 0 0 1-1.736 3.52c-.347.661-.783 1.276-1.155 1.927-.136.238-.2.516-.331.867-.355-.105-.647-.188-.936-.278-1.037-.323-2.083-.622-3.108-.98-.897-.314-1.004-.474-.69-1.347zm6.067-8.914c.331.106.695.111 1.033.202.131.036.343.203.329.275-.075.393-.005.848-.423 1.18-.83-.31-1.691-.567-2.57-1.102.571-.441 1-.758 1.631-.555zm3.468 7.489c.595.328.658.465.404.977-.405.814-.821 1.622-1.248 2.424-.268.503-.45.564-1.148.431l1.992-3.832zM69.978 79.2c-.077-.514-.55-1.075-1.103-1.145-.627-.08-1.286-.143-1.903-.044-1.774.287-3.535.653-5.299.999-.812.16-1.617.355-2.428.513-.552.108-.628.025-.859-.46-.29-.613-.63-1.203-.948-1.803-.23-.432-.506-.848-.67-1.303-.157-.435-.355-.806-.725-1.093-.223-.172-.416-.383-.636-.56-.581-.47-1.17-.932-1.814-1.444.602-.6.908-1.319 1.16-2.067.014-.043.052-.078.072-.12.272-.569.543-1.138.813-1.708.07-.148.123-.303.2-.447.482-.894.84-1.832.906-2.85.053-.827-.346-2.087-1.472-2.26-.192-.03-.366-.2-.541-.314-.43-.28-.846-.584-1.288-.845-.229-.135-.375-.269-.326-.549.08-.459.178-.917.22-1.38.04-.433.185-.974-.01-1.291-.528-.861-1.2-1.602-2.365-1.701-.842-.072-1.693-.197-2.477-.577-.295-.143-.525-.053-.689.273-.143.284-.365.532-.567.784-.278.349-.602.666-.846 1.036-.223.339-.447.504-.87.376-.337-.102-.694-.14-1.044-.2-1.136-.196-2.272-.39-3.448-.59-.033.346-.053.668-.1.986a1.496 1.496 0 0 1-.148.456 75.086 75.086 0 0 1-.82 1.543 18.642 18.642 0 0 0-1.617 4.037c-.242.893-.428 1.778-.043 2.68.047.11.002.258-.001.463-1.958-.317-3.866-.109-5.791.117-.021-.155-.051-.311-.071-.464-.349-2.645-.753-5.284-1.038-7.936-.225-2.093-.409-4.202-.428-6.305-.038-4.128.429-8.229.962-12.318.227-1.74.523-3.472.789-5.208.184-1.202.343-2.408.565-3.603.505-2.722 1.266-5.378 2.136-8.006.686-2.069 1.346-4.146 2.031-6.215.106-.32.29-.615.478-1.005.209.207.35.321.46.46.575.73.99 1.55 1.242 2.432.366 1.284.72 2.575.985 3.881.273 1.35.747 1.23 1.734 1.19a.534.534 0 0 0 .271-.072c.183-.128.4-.247.513-.425.211-.333.365-.702.532-1.061.524-1.12.84-2.278.738-3.533-.112-1.387-.348-2.739-.932-4.018-.107-.235-.13-.507-.197-.787 1.538.07 2.719.901 3.19 2.174.065.176.134.35.191.53.145.45.437.755.864.97.57.284.948.184 1.166-.411.083-.227.073-.503.048-.751-.026-.253-.148-.496-.183-.75-.302-2.16-1.416-3.95-2.657-5.678-.487-.678-1.133-1.188-1.89-1.559-.155-.075-.283-.2-.443-.317.105-.134.15-.222.221-.276 1.132-.85 2.248-1.725 3.599-2.231.195-.073.385-.183.547-.312.1-.08.219-.249.195-.344-.12-.477-.076-1.078-.744-1.219-.29-.06-.596-.111-.886-.081-.332.034-.585-.002-.827-.256-.332-.347-.768-.526-1.238-.648-.949-.244-1.871-.186-2.799.106-.541.171-.59.13-.743-.319-.488-1.437-1.389-2.596-2.488-3.62-.445-.415-.985-.671-1.59-.714-.54-.039-1.087.022-1.63.022-.62 0-.677.24-.672.823.002.171.117.352.212.509.245.4.514.787.762 1.186.118.19.266.383.164.685-1.18-.284-2.345-.315-3.533-.21-2.007.179-3.81.89-5.526 1.876a.666.666 0 0 0-.275.301c-.192.484.284 1.374.8 1.453.745.114 1.499.177 2.248.266 1.198.142 2.4.259 3.59.444.71.111 1.098.639 1.403 1.267-.466.255-.895.158-1.31.15-3.081-.057-5.795.842-7.95 3.081-1.205 1.253-2.2 2.66-2.372 4.456-.067.693-.022 1.398 0 2.097.003.112.123.25.226.326.169.123.369.205.555.305.274.147.526.182.766-.081.442-.485.932-.93 1.341-1.44a5.903 5.903 0 0 1 2.14-1.697c1.207-.56 2.48-.92 3.774-1.211.234-.052.487-.02.853-.03-.21.557-.364.995-.538 1.424-1.283 3.148-2.596 6.284-3.845 9.445-.567 1.438-1.026 2.918-1.508 4.388a139.285 139.285 0 0 0-1.364 4.357c-.42 1.439-.796 2.891-1.176 4.341-.38 1.45-.779 2.898-1.105 4.36-.458 2.058-.853 4.129-1.284 6.192-.408 1.95-.779 3.906-.85 5.903-.029.816.01 1.635-.017 2.452-.01.302-.116.602-.186.943-.132-.093-.183-.11-.204-.146-1.134-1.934-1.93-4.012-2.597-6.137a74.011 74.011 0 0 1-1.182-4.264c-.34-1.361-.594-2.743-.917-4.108-.367-1.548-.771-3.087-1.15-4.632-.045-.187-.026-.389-.037-.587.89-.01 1.411.438 1.803 1.058.287.456.546.932.785 1.414.284.574.741.88 1.357 1.025.769.18 1.076-.164 1.019-.758-.06-.614-.045-1.293-.278-1.871-.446-1.105-.995-2.169-1.52-3.24-.215-.436-.479-.847-.742-1.308.142-.098.26-.212.403-.272.604-.257 1.233-.302 1.88-.2.371.058.746.103 1.12.13.23.017.484.046.62-.223.145-.288.14-.833-.066-1-.492-.399-.971-.835-1.523-1.134-1.1-.596-2.259-1.075-3.503-1.316-.195-.038-.38-.132-.537-.188-.01-.128-.034-.185-.015-.219.525-.965 1.019-1.95 1.6-2.88.237-.378.421-.731.377-1.165-.03-.285-.138-.554-.498-.59-.397-.038-.794-.09-1.192-.109a1.088 1.088 0 0 0-.468.093c-.688.297-1.359.637-2.055.912-1.06.418-2.113.838-2.924 1.67-.27.278-.556.337-.891.153-.63-.345-1.311-.519-2.016-.638-1.287-.218-2.547-.09-3.789.263-.405.116-.488.415-.231.745a.957.957 0 0 0 .32.272c.591.285 1.186.562 1.786.828.316.14.667.228.755.7-.733.186-1.441.345-2.136.548-.656.192-1.321.378-1.94.659-.93.42-1.49 1.193-1.8 2.146-.192.589-.195 1.118.484 1.389.086.448-.195.909.214 1.29.382.354.89.231 1.377.41l-.02.763c-.017.75-.087 1.502-.038 2.247.097 1.478.625 2.823 1.466 4.044.26.378.609.66 1.093.713.591.064 1.183.116 1.856.181.056-.41.185-.762.133-1.085-.241-1.495.223-2.825.901-4.111.11-.207.311-.365.47-.545l.168.048c.076.355.179.707.222 1.067.078.648.07 1.31.187 1.95.332 1.82.698 3.635 1.073 5.446.308 1.491.621 2.983.98 4.462.584 2.414 1.205 4.819 1.814 7.227.5 1.976.994 3.956 1.77 5.85a186.82 186.82 0 0 0 2.163 5.114c.306.689.636 1.368.974 2.042-2.02 1.254-3.922 2.666-5.602 4.362-1.05 1.06-2.027 2.173-2.309 3.712-.06.33-.326.459-.773.42-.776-.068-1.55-.163-2.325-.229a56.133 56.133 0 0 0-2.545-.175c-.607-.024-.84.338-.643.914.105.306.213.612.335.962.417.344.95.475 1.538.448.187-.008.377.018.564.044 2.779.387 5.57.441 8.363.255a25.173 25.173 0 0 0 3.443-.467c2.63-.548 5.13-1.486 7.518-2.705.346-.177.649-.22 1.003-.035.543.285 1.1.543 1.657.802 1.105.516 2.27.813 3.493.825 1.45.014 2.88-.16 4.258-.629.443-.151.777-.11 1.168.194.944.737 1.858 1.514 2.947 2.065.861.435 1.715.817 2.696.68 1.841-.257 3.63-.69 5.217-1.713.416-.268.805-.578 1.232-.826.182-.105.441-.164.647-.131.93.145 1.85.38 2.783.49 1.17.138 2.352.185 3.528.27 1.643.12 3.26-.073 4.862-.415 1.967-.42 3.93-.857 5.901-1.254.762-.153 1.523-.23 2.314.014.904.28 1.45-.272 1.31-1.207z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'book':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '68',
	            height: '32',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'book'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h68v32H0z' }),
	          _react2.default.createElement('path', {
	            d: 'M28.24 22.584c3.313-1.633 17.431-7.792 17.431-7.792L58.02 9.905h3.937v3.63s-13.358 6.926-17.512 8.255c-4.154 1.329-13.619 7.959-13.619 7.959l-4.153.727-1.739-2.128.37-3.701s-.376-.43 2.937-2.063z',
	            fill: '#E0DDE8'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M63.17 5.353c.179.35.278.73.295 1.126.042.967-.707 1.908-1.591 2.152l-1.55.427c-1.503.414-3.007.828-4.51 1.245-3.413.948-6.82 1.92-10.194 3.01-3.284 1.062-6.535 2.236-9.712 3.603a72.392 72.392 0 0 0-7.393 3.742c-.471.275-.984.35-1.465.257-.319.05-.651.034-.933-.046-.46-.13-1.098-.549-1.296-1.026a2.367 2.367 0 0 0-.124-.256 3.18 3.18 0 0 0-.118-.117c-.54-.372-1.146-.653-1.743-.93a37.146 37.146 0 0 1-.54-.252 86.484 86.484 0 0 0-2.729-1.265c-2.236-.952-4.545-1.751-6.944-2.122a17.448 17.448 0 0 0-2.899-.111c-.577.027-1.12-.264-1.532-.654-.426-.402-.61-1-.635-1.578-.024-.555.259-1.19.635-1.577.41-.423.96-.627 1.532-.654.996-.047 1.992.001 2.982.116.135-.074.277-.135.424-.183l6.26-2.04 11.047-3.598 5.548-1.808.252-.082.463-.15c.086-.435.317-.868.6-1.16.354-.364 1.015-.71 1.533-.654a257.919 257.919 0 0 1 23.04 3.56c.49.098 1.066.577 1.296 1.025zM51.15 6.898l.044.095.06-.021.11-.039-.109-.02-.109-.022.004.007z',
	            fill: '#FFD65F'
	          }),
	          _react2.default.createElement('path', {
	            d: 'M22.896 19.92a35.703 35.703 0 0 0-2.752-1.178c-1.706-.655-3.452-1.202-5.188-1.77-1.824-.595-3.645-1.195-5.47-1.785-2.097-.678-4.206-1.261-6.409-1.47-.376-.035-.846.2-1.104.455-.27.269-.474.71-.457 1.096.006.134.026.27.06.403a1.423 1.423 0 0 0-.62.584c-.317.598-.274 1.396.245 1.879 1.745 1.626 3.765 2.864 5.983 3.743 1.733.687 3.542 1.028 5.383 1.192a53.765 53.765 0 0 1 4.286 2.688c.585.406 1.146.844 1.724 1.26a3.138 3.138 0 0 1 .184.13l.01.007-.009-.006a49.285 49.285 0 0 1 .736.58c.32.257.637.518.951.783.39.328.795.495 1.311.426.443-.059.944-.31 1.14-.74l1.185-2.588.604-1.317c.267-.585.626-1.183.622-1.843-.009-1.403-1.33-2.003-2.415-2.528z',
	            fill: '#fff'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M63.413 6.901c-1.715.584-3.433 1.16-5.15 1.74-.91.307-1.821.612-2.729.925-1.344.465-2.678.961-4.03 1.398-1.945.628-3.786 1.526-5.698 2.238a181.869 181.869 0 0 0-6.46 2.535c-1.577.657-3.109 1.426-4.668 2.129-1.33.6-2.678 1.161-4.007 1.767-.76.347-1.498.744-2.24 1.13-.25.131-.487.192-.763.092-.784-.282-1.583-.525-2.357-.833-1.24-.492-2.463-1.028-3.695-1.538-.855-.354-1.718-.688-2.57-1.049-.473-.2-.93-.443-1.398-.658a76.692 76.692 0 0 0-1.608-.719c-.425-.183-.869-.323-1.281-.531-1.487-.75-3.097-1.164-4.624-1.805-.919-.385-1.846-.758-2.845-.881-.097-.012-.19-.067-.39-.141.706-.386 1.322-.725 1.993-.95.96-.322 1.919-.652 2.884-.959.947-.3 1.907-.561 2.853-.865.641-.207 1.27-.459 1.904-.69.969-.351 1.926-.744 2.91-1.046a805.69 805.69 0 0 1 8.631-2.583c2.591-.764 5.186-1.513 7.783-2.257.563-.161 1.142-.263 1.71-.409.515-.131 1.045-.234 1.533-.439 1.005-.42 2.017-.335 3.04-.164 1.068.179 2.128.453 3.202.526 1.263.086 2.454.501 3.694.668.539.072 1.003.382 1.549.437.546.055 1.085.179 1.627.272l1.627.278c.543.093 1.088.17 1.627.279 2.037.408 4.073.817 6.105 1.243.742.155 1.474.36 2.23.645-.13.073-.251.168-.389.215zm-2.157 6.747a4.27 4.27 0 0 1-.8.421c-1.489.593-2.986 1.162-4.471 1.763a90.149 90.149 0 0 0-3.49 1.485c-1.053.48-2.076 1.029-3.123 1.523-2.03.96-4.069 1.897-6.1 2.853-1.45.683-2.908 1.353-4.338 2.08-1.81.919-3.594 1.894-5.395 2.834-.363.189-.757.312-1.127.486-1.548.728-3.091 1.464-4.638 2.193-.209.099-.422.198-.643.26-.606.171-1.146-.232-1.212-.872-.02-.196.03-.325.212-.38 1.037-.315 1.862-1.045 2.823-1.508.626-.301 1.258-.588 1.882-.892.897-.438 1.79-.886 2.684-1.33a17.43 17.43 0 0 1 2.93-1.135c.56-.162 1.088-.433 1.63-.656.286-.119.432-.366.368-.65-.084-.376-.192-.776-.4-1.087-.216-.32-.628-.3-.987-.262-.192.02-.387.068-.568.137-1.13.433-2.263.855-3.379 1.323-.688.288-1.347.648-2.017.98-1.245.617-2.49 1.234-3.732 1.855-.327.164-.645.343-.987.526-.099-.508.448-1.6 1.08-2.245.364.236.651.03.977-.185.67-.44 1.36-.858 2.067-1.233.74-.391 1.506-.73 2.267-1.077 2.3-1.05 4.592-2.12 6.908-3.13 1.452-.633 2.937-1.186 4.416-1.75 1.629-.622 3.272-1.203 4.9-1.824 1.563-.595 3.113-1.223 4.67-1.83.68-.265 1.358-.534 2.048-.764.807-.27 1.628-.498 2.442-.748.831-.256 1.66-.52 2.492-.773.141-.042.294-.042.442-.062l.058.182c-.282.139-.554.307-.848.41-1.325.465-2.654.917-3.986 1.362-.573.192-1.163.333-1.732.536-.366.13-.728.3-1.054.514-.297.195-.478.5-.507.893-.025.348-.005.681.082 1.015.152.587.623.746 1.143.472.58-.305 1.19-.562 1.809-.772 1.075-.366 2.168-.673 3.25-1.02.421-.137.827-.324 1.246-.474.165-.058.352-.126.513-.098.125.022.273.169.321.296.036.093-.038.3-.126.358zM36.024 27.39c.151-.226.151-.226.482-.256-.109.219-.279.25-.482.256zm-1.053.533l-.032-.07.213-.101.031.069-.212.102zm-10.932-2.71c-.088-.04-.17-.069-.242-.113-1.094-.684-2.269-1.19-3.462-1.66-.644-.254-1.276-.542-1.916-.806a2.179 2.179 0 0 0-.505-.147c-.192-.029-.304.075-.415.256-.27.443-.279.96-.27 1.418.007.392.317.78.768.951.898.34 1.8.675 2.675 1.072.906.41 1.783.889 2.668 1.346.147.076.349.146.226.468-.224-.062-.466-.098-.682-.195-.829-.37-1.638-.788-2.474-1.14-1.033-.433-2.086-.815-3.129-1.223-.728-.284-1.457-.566-2.18-.865a693.546 693.546 0 0 1-4.676-1.954c-.786-.331-1.556-.704-2.35-1.016-1.522-.599-3.054-1.171-4.585-1.748-.454-.17-.872-.367-1.192-.775-.266-.34-.452-.694-.507-1.119-.113-.876-.01-1.738.207-2.585.035-.137.171-.271.294-.353.233-.154.489-.274.74-.399a2.666 2.666 0 0 1 1.606-.255c1.225.197 2.452.421 3.65.745.938.254 1.84.652 2.745 1.023 1.926.79 3.846 1.596 5.761 2.414.75.32 1.474.707 2.221 1.036.813.36 1.65.663 2.457 1.035 1.292.596 2.568 1.23 3.85 1.849.028.013.042.056.078.107l-1.361 2.634zm27.48-21.27l-1.386-.216c.42-.11.846-.048 1.386.216zm3.509.385l1.252.269a1.929 1.929 0 0 1-1.275-.151l.023-.118zM68 6.368c-.194-.122-.393-.231-.575-.366-.372-.274-.716-.591-1.104-.839-.703-.448-1.48-.69-2.306-.778-.316-.034-.629-.109-.942-.174-.625-.13-1.25-.27-1.875-.401-.729-.153-1.46-.293-2.188-.452-1.057-.231-2.104-.516-3.168-.702-1.607-.282-3.23-.476-4.838-.75-1.26-.215-2.507-.5-3.762-.746-1.045-.205-2.1-.368-3.138-.606C43.074.317 41.999.39 40.985.05a1.241 1.241 0 0 0-.58-.03c-.524.088-1.05.181-1.562.32-.6.163-1.183.39-1.78.566-1.618.48-3.24.946-4.86 1.42-.308.09-.611.193-.919.282-2.166.631-4.334 1.255-6.499 1.893-.92.27-1.823.616-2.752.845-1.989.489-3.923 1.147-5.845 1.85-1.019.373-2.03.768-3.055 1.118-1.481.504-2.972.978-4.46 1.46-1.542.502-3.047 1.087-4.434 1.96-.36.227-.73.478-1.13.594-.685.197-1.296.47-1.75 1.054-.142.184-.312.347-.478.511-.564.56-.792 1.276-.876 2.042-.034.317.11.658.057.968-.133.77.135 1.435.452 2.085.213.437.502.834.743 1.258.364.643.927 1.06 1.567 1.335 1.21.52 2.447.97 3.665 1.47 1.712.705 3.418 1.424 5.123 2.147.638.27 1.263.576 1.897.856.75.33 1.495.67 2.255.971 1.306.518 2.625 1 3.93 1.517.695.275 1.361.624 2.06.882 1.041.385 2.04.84 2.938 1.51.095.071.24.16.329.133.273-.083.437.087.628.21.255.165.524.31.761.5.354.282.724.272 1.104.107.374-.162.734-.36 1.105-.533 1.337-.626 2.691-1.216 4.01-1.88a318.54 318.54 0 0 0 6.025-3.13c1.543-.817 3.076-1.65 4.699-2.297 2-.797 3.96-1.689 5.88-2.676 2.22-1.144 4.505-2.14 6.805-3.104 2.662-1.116 5.316-2.243 8.116-2.957.493-.126.889-.788.858-1.332-.02-.367-.2-.61-.513-.757-.129-.06-.27-.091-.401-.147-.983-.417-1.286-1.325-.661-2.21.988-1.398 2.123-2.64 3.82-3.15.102-.03.222-.062.287-.136.114-.129.305-.362.265-.427-.197-.327.109-.497.191-.78zM35.922 13.34c.148-.517-.063-.904-.416-1.207-.631-.543-1.312-1.002-2.196-.941-.424.029-.849.054-1.273.08-1.07.064-1.9.61-2.657 1.34-.532.514-.572 1.085-.331 1.736.094.254.208.51.244.774.073.533-.047 1.042-.5 1.352a2.862 2.862 0 0 1-1.924.494 1 1 0 0 1-.352-.11c-.306-.156-.349-.35-.105-.592.226-.225.483-.419.738-.61.209-.156.47-.358.332-.603-.16-.283-.068-.464.09-.695-.218-.162-.37-.286-.532-.394-.584-.387-1.122-.334-1.638.155-.208.197-.43.382-.616.6-.305.357-.593.74-.603 1.242-.007.342.04.687.071 1.03.01.105.022.23.08.308.42.557.79 1.142 1.44 1.494.755.408 1.537.536 2.362.485.76-.048 1.457-.284 2.043-.812.403-.363.65-.782.709-1.349a9.729 9.729 0 0 0-.03-2.222c-.09-.733.04-.934.682-1.274.142-.075.289-.141.439-.197.57-.211 1.477-.22 1.908-.024-.048.34-.048.34-.4.536-.717.398-.778.517-.676 1.32l.027.216c.203.112.405.166.52.299.31.357.534.396.92.124.32-.224.637-.464.986-.626.579-.268.864-.809.71-1.453-.038-.155-.092-.334-.052-.476zm-8.994-.975c.486-.219.992-.576 1.45-.84.453-.26 1.995-.908 2.374-1.202l-.172-.999-.29.028c-.144-.147-.261-.364-.367-.358-.366.02-.712-.153-1.055-.027-.599.222-2.354 1.195-2.922 1.49-1.534.797-3.054 1.623-4.582 2.433a7.499 7.499 0 0 1-2.464.826c-.166.024-.405.064-.455-.161a.883.883 0 0 1 .077-.56c.098-.184.273-.334.437-.47.317-.262.674-.476.97-.76.402-.383.874-.602 1.384-.777.482-.164.952-.366 1.384-.534l.034-.845c-.106-.072-.259-.125-.333-.235-.258-.38-.604-.358-.995-.325-.798.068-1.495.44-2.227.707-.694.252-1.316.642-1.884 1.109-.577.474-.962 1.07-.86 1.882.049.378.085.76.166 1.131.1.458.187.94.54 1.279.562.542 1.214.898 2.018.77.47-.074.954-.148 1.395-.321 1.744-.684 3.348-1.663 4.992-2.558a20.15 20.15 0 0 1 1.385-.683zm16.046 6.895c-.153-.665-.377-.852-1.138-.854-.095.023-.316.036-.502.126-.447.217-.881.465-1.313.713-.103.059-.218.152-.26.258-.24.607-.053 1.123.352 1.59.302.348.65.457 1.155.254.477-.191.942-.42 1.39-.671.414-.233.536-.638.397-1.1a4.903 4.903 0 0 1-.081-.316zm-20.168 2.605c-.307-.266-.642-.53-1.008-.688a37.875 37.875 0 0 0-2.787-1.075c-1.279-.433-2.577-.804-3.86-1.222-1.098-.358-2.186-.745-3.278-1.119-.085-.029-.168-.062-.253-.084-.468-.125-.705.056-.734.559-.009.16.009.325-.023.48-.155.755.095 1.252.794 1.476a68.01 68.01 0 0 0 2.551.772c1.828.51 3.634 1.084 5.385 1.833.8.342 1.613.648 2.422.968.081.032.17.047.19.053.318.01.521-.076.634-.32.067-.145.119-.299.185-.446.231-.513.197-.827-.218-1.187z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'lightningEyes':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '30',
	            height: '41',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'lightningEyes'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h30v41H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M22.7 18.707c.86-.398 1.746-.737 2.648-1.015.608-.187 1.286.08 1.662.57.373.486.448 1.192.139 1.736.196 1.39-.041 2.811-.49 4.14-.362 1.077-.822 2.123-1.28 3.165-.12.27-.238.541-.356.812a470.146 470.146 0 0 1-5.087 11.347c-.152.328-.602.652-.945.73a1.869 1.869 0 0 1-.84 0c-.33-.075-.62-.306-.82-.569-.226-.293-.31-.6-.34-.963l-.052-.629c-.044-.56-.09-1.123-.159-1.7a1.638 1.638 0 0 1-.755-.65c-.243-.378-.222-.805-.16-1.225a137.377 137.377 0 0 1 1.362-7.691 382.33 382.33 0 0 0-9.004.05c-.715.013-1.313-.507-1.525-1.167l-.895-2.786c-.17-.534.022-1.16.407-1.547.414-.417.979-.533 1.538-.41l2.688.597c.26.057.519.119.778.18.172.041.344.082.516.121.088-.084.186-.153.295-.2a8.434 8.434 0 0 0 1.645-.947c.07-.056.137-.114.204-.172.066-.2.13-.402.194-.603.075-.232.148-.464.225-.694l.89-2.68c.119-.355.242-.712.367-1.07.271-.785.545-1.574.769-2.374-.023-.248-.05-.496-.08-.743-.13-.918-.226-.846-.368-.74-.148.112-.346.26-.688-.646-.038-.102-.657-.049-1.261.004-.607.053-1.2.104-1.181-.004-.159-.117-2.424.186-4.18.422-.823.11-1.533.205-1.863.235-.541.05-1.863.028-2.98.01a39.626 39.626 0 0 0-1.672-.01c-.527.026.463-2.243 1.34-4.256.595-1.363 1.138-2.609 1.123-2.943-.04-.887.756-1.55 1.58-1.59.602-.03 1.202-.037 1.8-.027.078-.099.165-.191.264-.276.281-.241.544-.388.907-.437.375-.051.672.039 1.008.188l1.94.862a35.885 35.885 0 0 0 2.03-1.004c.455-.243.933-.282 1.407-.08.405.171.85.559.915 1.03.015.107.038.21.069.312.017.03.035.062.054.092.052.057.107.111.164.163.115.076.234.144.357.206.19.068.384.12.582.16a5.64 5.64 0 0 0 1.031-.028c.322-.051.642-.113.962-.176.354-.069.708-.138 1.065-.191 1.085-.162 2.368-.332 3.173.62.41.485.595 1.04.612 1.675.008.296-.039.594-.085.888-.016.096-.03.192-.044.288l-.283 2.063-.593 4.313-.724 5.264zm-1.422 4.436c-.098.403-.194.807-.288 1.211l-.005.02c.292-.532.587-1.06.884-1.589-.12.078-.24.156-.358.236-.073.05-.152.09-.233.122z',
	            fill: '#FFD65F'
	          }),
	          _react2.default.createElement('path', {
	            d: 'M1.519 13.072c1.457-.504 2.847-1.265 4.37-1.512 1.683-.274 3.417-.17 5.116-.03 10.247.845-5.426 15.299-8.938 6.544-.56-1.399-.33-2.99-.496-4.486l-.052-.516z',
	            fill: '#fff'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M8.199 10.766c.058-.507.362-.823.587-1.174.236-.369.498-.722.758-1.075.36-.488.827-.808 1.441-.907.165-.027.32-.117.478-.184.23-.098.454-.218.69-.3.366-.128.724-.036.946.252.38.494.915.883 1.107 1.508.119.387.249.78.292 1.18.058.536-.062.603-.6.447-.03-.008-.065-.01-.09-.026-.703-.482-1.49-.306-2.238-.228-1.002.104-1.994.306-2.99.464-.106.017-.213.025-.381.043zm1.088 1.804c-.037.27-.062.436-.083.602-.115.883-.018 1.72.52 2.469.154.214.327.336.595.27.472-.119.947-.226 1.412-.364.242-.073.354-.295.453-.517.334-.757.525-1.543.508-2.374a4.762 4.762 0 0 1 0-.283c.007-.19.104-.287.3-.282.47.013.895.165 1.29.412.212.132.216.332.186.541-.14.979-.294 1.955-.422 2.935-.163 1.259-.749 2.323-1.509 3.305-.482.623-1.162.953-1.902 1.164-.275.079-.527-.017-.74-.213-.558-.512-1.051-1.06-1.436-1.732-.502-.875-.809-1.8-1.031-2.768-.168-.732-.16-1.463-.058-2.2.027-.19.102-.32.268-.413.486-.272 1.013-.41 1.649-.552zm18.492 5.606c-.171.316-.37.617-.548.929-.265.463-.52.933-.783 1.398-.78 1.383-1.585 2.753-2.336 4.151-.73 1.357-1.464 2.717-2.084 4.124-.403.916-.984 1.708-1.49 2.549-.82 1.36-1.713 2.676-2.584 4.005-.177.269-.336.567-.733.758-.012-.206-.037-.352-.025-.495.231-2.787.472-5.573.695-8.361.023-.29-.034-.59-.077-.883-.035-.246-.215-.363-.445-.433-.543-.166-1.066-.275-1.66-.177-.993.166-2.012.174-3.01.322-1.324.197-2.638.464-3.956.703-.447.081-.893.16-1.387.129-.075-.462-.162-.89-.214-1.324-.14-1.154-.267-2.31-.398-3.466-.042-.374.237-.771.573-.935.446-.218.795-.122 1.155.188.522.448 1.116.78 1.83.79.309.005.634-.011.926-.102.76-.236 1.41-.682 2.068-1.122 1.02-.683 1.537-1.722 2.09-2.744.907-1.677 1.16-3.503 1.215-5.367.027-.926-.009-1.854-.023-2.78-.008-.495-.11-.969-.361-1.401-.293-.503-.578-1.01-.888-1.503-.461-.733-1.149-1.232-1.93-1.537-.497-.195-1.08-.168-1.65.024l.145.308c-.205.19-.433.222-.695.165-.76-.167-1.469-.048-2.121.387-.334.222-.313.186-.633-.07-.786-.63-1.598-1.234-2.687-1.185-.295.014-.588.076-.878.115-.183-.33-.245-1.118-.118-1.708.221.082.44.15.649.242.444.196.865.429 1.342.569.375.11.585-.031.79-.239.53-.537 1.035-1.098 1.552-1.65.064-.068.129-.138.201-.198.241-.197.338-.204.576.005.343.3.687.604 1.002.932.252.262.523.486.82.692.358.25.352.265.706.066.645-.364 1.29-.728 1.94-1.086.772-.425.778-.426 1.342.211.229.259.417.555.659.8.239.242.505.47.796.643.112.067.359.019.484-.065.827-.552 1.8-.76 2.691-1.155.393-.175.518-.117.574.32.074.572.44.914.84 1.245.216.18.558.108.872-.09.518-.328 1.055-.627 1.59-.93.072-.04.175-.028.287-.043.014.1.044.176.033.247-.085.543-.157 1.089-.272 1.626-.471 2.196-.961 4.39-1.434 6.586-.178.827-.317 1.662-.493 2.49-.187.873-.41 1.74-.59 2.614-.08.392.182.674.444.912.46.416 1.007.468 1.593.31.868-.232 1.735-.472 2.61-.673.454-.105.925-.134 1.443-.205-.012.175.014.292-.03.372zM5.541 19.924a2.354 2.354 0 0 1-1.44-.74c-1.28-1.368-2.02-2.973-2.131-4.85-.02-.343-.001-.688-.008-1.032-.005-.258.093-.407.366-.454.294-.052.58-.149.872-.213.165-.035.335-.043.592-.074-.033.292-.05.491-.078.69-.094.681.074 1.306.427 1.885.218.357.482.656.962.63.285-.015.353.183.416.415.181.665.36 1.331.59 1.98.144.41.375.788.57 1.188-.309.618-.443.674-1.138.575zM4.933 7.33c.395-.232.797-.347 1.26-.26.465.086.771.346.866.808.1.488.107.943-.241 1.377-.262.326-.433.726-.637 1.097-.126.23-.278.29-.566.284-.736-.018-1.474.05-2.21.092-.263.015-.53.109-.792-.115C3.02 9.235 3.67 8.07 4.933 7.33zm24.765 10.127c-.137-.21-.3-.404-.465-.595-.382-.444-.884-.743-1.448-.805-.833-.092-1.669 0-2.476.274a5.094 5.094 0 0 1-.827.197c-.443.072-.615-.162-.454-.573.078-.2.144-.407.185-.617.08-.4.116-.81.208-1.208.262-1.127.544-2.25.815-3.374.342-1.42.681-2.84 1.022-4.26.26-1.084.514-2.17.786-3.253.083-.33.01-.587-.24-.805-.105-.092-.224-.172-.322-.271-.139-.143-.315-.279-.383-.453-.09-.23-.236-.323-.45-.352-.284-.04-.557-.037-.83.099-.565.28-1.142.539-1.72.793-.223.098-.463.16-.73.251-.058-.21-.095-.314-.113-.421-.133-.804-.604-1.174-1.377-1.063a1.34 1.34 0 0 0-.398.138c-.934.469-1.916.813-2.917 1.108-.465.138-.485.14-.8-.25-.226-.28-.461-.557-.653-.86-.557-.884-1.05-.808-1.881-.374-.07.036-.13.091-.2.126-.622.304-1.243.612-1.87.907-.208.097-.418.122-.609-.074-.472-.484-.965-.95-1.428-1.443A.916.916 0 0 0 9.456 0c-.372-.016-.66.157-.921.408-.626.6-1.258 1.192-1.896 1.778-.346.318-.415.297-.811.041a32.614 32.614 0 0 0-1.658-1c-.322-.183-.732-.216-.977.04-.338.35-.64.781-.59 1.325.073.782.166 1.561.244 2.343.045.453.052.912.125 1.36.043.27-.039.445-.216.628-.547.566-1.045 1.161-1.416 1.87a10.804 10.804 0 0 0-1.11 3.23c-.067.4-.08.812-.121 1.218-.036.36-.135.723-.103 1.075.08.857.187 1.714.346 2.559.078.408.287.794.46 1.18.108.243.267.463.388.701.401.788.944 1.451 1.706 1.915.417.253.85.48 1.282.704.158.082.317.144.36.339.05.214.12.425.145.642.174 1.514.327 3.03.514 4.542.098.796.454 1.47 1.092 1.989.306.248.616.337 1.007.238 1.715-.432 3.437-.827 5.197-1.033.878-.103 1.755-.218 2.634-.298.459-.042.515.035.515.503 0 .409.007.819-.027 1.226a712.633 712.633 0 0 1-.515 5.963c-.054.594-.148 1.184-.223 1.776-.061.482-.116.965-.186 1.446-.06.42-.154.834-.203 1.255-.065.565.49 1.106 1.056 1.029.275-.038.54-.183.812-.191a1.498 1.498 0 0 0 1.148-.576c.27-.332.438-.745.644-1.126.018-.034.003-.096-.017-.136-.172-.36.016-.63.214-.906 1.01-1.404 2.032-2.8 3.022-4.22 1.38-1.976 2.502-4.1 3.6-6.241.818-1.593 1.748-3.13 2.632-4.688.489-.86.994-1.713 1.479-2.576.276-.491.534-.993.786-1.497.246-.492.103-.951-.176-1.378z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'luggages':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '83',
	            height: '80',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'luggages'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h83v80H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M39.507 12.102c.03-.001.253-.002.416.005l.109.026c.019.005.092.02.161.037-.057-.039-.088-.066.01.002l.046.012.057.048h.002a.236.236 0 0 1-.034-.014l.056.034c.469.404.916.73 1.506.934.468.162.971.195 1.464.16l-.077.036a3.272 3.272 0 0 0-1.275 1.143c-.172.258-.287.571-.392.862-.026.073-.049.147-.073.22-.014.043-.083.208-.108.28l-.087.157-.001.003c-.03.034-.06.067-.092.1-.039.04-.08.076-.12.115-.074.044-.15.086-.224.128.114-.056.042.022-.089.066l-.054.018-.06.037.054-.036c-.03.01-.06.02-.09.028.026.006-.051.04-.16.046h-.035a.86.86 0 0 0-.107.025l.078-.024h-.11c.026.004-.046.006-.129-.006a4.42 4.42 0 0 0-.02-.003 4.272 4.272 0 0 1-.4-.114c-.017-.005-.09-.028-.159-.052l-.022-.01a80.836 80.836 0 0 0-.568-.258c-.486-.22-.98-.449-1.498-.583a5.868 5.868 0 0 0-1.498-.178c.01-.018.019-.035.027-.053.214-.436.381-.893.606-1.323.089-.171.186-.338.294-.497.017-.025.058-.072.09-.116l.022-.026c.123-.139.254-.27.391-.395.047-.043.095-.083.143-.124l.04-.028c.138-.095.28-.183.426-.265.072-.04.146-.076.219-.114.151-.04.306-.124.455-.167.115-.034.243-.052.37-.074-.002-.012.063-.04.163-.048l.06-.004c.02-.006.039-.012.057-.02l-.05.02c.07-.005.14-.009.21-.01zm14.13 1.173c-.062-.856-.648-1.733-1.53-1.877a1.43 1.43 0 0 0 .131-.348c.19-.832-.13-1.688-.87-2.14-1.439-.875-3.11-1.115-4.761-1.212-1.542-.091-3.094-.157-4.639-.125-1.681.034-3.386.205-5.016.632-1.538.403-3.006 1.028-4.477 1.62l-5.168 2.083c-.886.357-1.493 1.073-1.358 2.078.1.74.636 1.365 1.34 1.571.208.326.51.611.859.786-.144.045-.288.09-.432.133-.907.274-1.484 1.139-1.358 2.078.063.469.294.879.63 1.172-.207.439-.267.963-.136 1.367.242.747.982 1.465 1.827 1.391l10.055-.88c.452-.014.902-.04 1.352-.079.21.206.474.358.787.425 1.117.24 2.306.453 3.429.11.6-.183 1.1-.469 1.577-.87l.024-.021c.946.098 1.964-.094 2.863-.256 1.529-.277 3.536-.64 4.306-2.167.45-.895.506-1.95.575-2.933.059-.846.053-1.693-.01-2.538z',
	            fill: '#CD8168'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M68.517 35.322a.769.769 0 0 0-.106-.01v-.001c.092-.036.136-.012.106.01zm-.135.02a1.45 1.45 0 0 0-.026-.015l.057-.004a.994.994 0 0 0 .099-.006.284.284 0 0 1-.13.025zM59.79 25.147c.043.004.149.029.212.027.217.038.432.08.645.13-.457-.07-.914-.136-1.372-.197l.1.005c.138.01.277.02.415.035zm4.886 3.237c-.258-.03-.517-.05-.776-.065.088-.178.15-.373.178-.579l.004-.041c.188.237.386.465.594.685zm-6.492 7.409v.013a2.72 2.72 0 0 0-.14.024c-.046 0 .073-.036.14-.037zm-15.29-.385a40.77 40.77 0 0 1-1.433-.156h-.001l-.21-.029a62.478 62.478 0 0 1-.356-.053c-.523-.08-.986-.086-1.46.191a2.035 2.035 0 0 0-.714.737c-.175-.055-.35-.114-.522-.178-.117-.044-.233-.1-.353-.138l.065.02c-.003 0-.006-.002-.01-.004-.23-.106-.455-.22-.676-.343a12.28 12.28 0 0 1-1.17-.752l-.058-.048a10.1 10.1 0 0 1-1.235-1.21c-.051-.059-.1-.122-.149-.185l-.007-.012a1.475 1.475 0 0 1-.077-.093l.061.065a41.301 41.301 0 0 0-.387-.64c2.21-.125 4.42-.239 6.63-.335 5.097-.221 10.199-.352 15.3-.322a1.886 1.886 0 0 0-.929 1.89c.116.858.92 1.731 1.861 1.643.313-.03.626-.056.94-.08l-.164.076c-.164.075-.33.148-.494.221-.095.042-.666.285-.17.076a3.652 3.652 0 0 0-.5.246 98.65 98.65 0 0 1-4.166.397 27.23 27.23 0 0 0-3.306-1.409 15.747 15.747 0 0 0-2.498-.74c-.952-.195-2.055.265-2.318 1.272a40.842 40.842 0 0 1-1.495-.107zm26.471-7.585a1.969 1.969 0 0 0-.849-1.117 8.992 8.992 0 0 1-.29-.191 2.863 2.863 0 0 1-.165-.133l.177.154c-.174-.152-.357-.293-.526-.452a8.022 8.022 0 0 1-.695-.74 9.237 9.237 0 0 1-.671-1.084c-.051-.1-.099-.202-.147-.303-.076-.213-.152-.424-.216-.64-.282-.95-1.344-1.643-2.331-1.324-.144.047-.282.11-.41.185-1.665-.732-3.574-.924-5.368-.882-2.526.06-5.059.425-7.567.708-5.337.6-10.669 1.27-16.03 1.619-3.04.197-6.086.288-9.131.208-.992-.026-1.94.89-1.895 1.894.005.117.02.231.043.341-.42.23-.747.603-.837 1.104a5.91 5.91 0 0 1-.18.744c-.033.105-.078.208-.115.312l-.07.145a5.938 5.938 0 0 1-.426.696c-.088.098-.172.2-.264.296a5.82 5.82 0 0 1-.274.268c-.108.1-.502.364-.036.054-.23.152-.447.313-.689.445-.34.186-.659.328-.954.598-.498.454-.685 1.097-.707 1.75-.03.89-.086 1.903.381 2.692.451.763 1.252 1.126 1.97 1.577a19.045 19.045 0 0 1 1.152.785l.158.117c.496.406.982.819 1.443 1.265-.494.602-.665 1.463-.212 2.166.53.821 1.71 1.267 2.593.68l1.103-.735c.359.046.722.043 1.078-.024.112.023.228.037.347.041 6.058.195 12.096.78 18.154.984 2.991.102 5.989.11 8.978-.073a61.591 61.591 0 0 0 4.76-.468c1.276-.177 2.582-.49 3.684-1.184.793-.5 1.42-1.142 1.937-1.921.382-.575.655-1.213.976-1.822a9.593 9.593 0 0 1 .353-.616c.011-.018.064-.089.099-.137a3.793 3.793 0 0 1 .25-.254c.105-.052.222-.137.322-.202l.05-.015-.024-.001a.267.267 0 0 0 .009-.006l.03-.001.006.002h.003l.02.007c.562.216 1.147.231 1.699-.091.58-.34.933-.967.938-1.636l.029-3.898c.006-.915-.746-1.793-1.663-1.887z',
	            fill: '#A1CBFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M58.725 44.545c-.046-1.018-.8-1.781-1.82-1.82l-11.415-.442-1.775-.069-4-.154c-1.838-.07-3.68-.133-5.52-.03a28.5 28.5 0 0 0-3.148.349c-.699.117-1.33.517-1.69 1.137-.32.549-.35 1.169-.359 1.785l-.076 5.608-.079 5.755-.003.194v.03c-.013.784-.026 1.583.18 2.345a3.416 3.416 0 0 0 2.213 2.388c.195.069.395.112.597.156l.074.016.044.01h.004a4.958 4.958 0 0 1 .332.083l.004.002.007.004a.113.113 0 0 1 .008.005l.006.004c.03.032.064.063.096.092l.033.03.023.037c.07.112.139.223.2.341l.07.144.018.04c.119.309.218.623.318.938l.031.096c.089.28.192.56.31.835-.15.18-.261.399-.32.654-.106.465-.083.989.184 1.402.274.425.624.646 1.088.837.584.239 1.22.35 1.856.355l2.47.472.064.012c1.656.317 3.265.626 4.949.327.757-.134 1.469-.42 2.171-.725.583-.252 1.18-.525 1.718-.862.792-.497 1.402-1.186 1.671-2.093.193-.648.16-1.324.085-1.986l-.007-.059c-.026-.232-.053-.464-.062-.698a4.2 4.2 0 0 1 0-.248.846.846 0 0 0 .024-.106l.008-.01.04-.02.01-.005.018-.01.108-.054.048-.017h.002c.062-.023.121-.044.143-.05.114-.033.229-.061.344-.086.08-.017.162-.031.243-.046l.053-.009.027-.003a12.405 12.405 0 0 1 1.753-.075l.056.004.025.002a56.46 56.46 0 0 0-.337 4.115c-.016.372-.032.743-.057 1.113a22.28 22.28 0 0 1-.07.831l-.015.123-.006.056-.002.008-.002.015v.006l-.002.009a6.373 6.373 0 0 1-.055.328c-.034.181-.072.362-.114.542a8.245 8.245 0 0 1-.312 1.01v.004l-.001.001-.024.058-.022.044a7.893 7.893 0 0 1-.146.294c-.124.232-.264.45-.412.666-.02.023-.041.05-.061.075l-.001.001v.001l-.002.001c-.016.021-.031.041-.046.058a5.134 5.134 0 0 1-.378.38l-.002.003-.057.051a5.147 5.147 0 0 0-.096.067l-.007.005-.002.001a2.936 2.936 0 0 1-.507.296l-.004.001c-.048.012-.095.029-.143.045l-.003.002c-.035.012-.07.024-.104.034a5.535 5.535 0 0 1-.501.12c.039-.011-.025 0-.099.013l-.146.023c-.603.055-1.21.06-1.817.065l-.459.005-4.821.065-.527.007h-.002c-1.548.022-3.098.044-4.645-.037a29.488 29.488 0 0 1-1.855-.157 9.756 9.756 0 0 1-.13-.017l-.136-.02a18.264 18.264 0 0 1-2.545-.58c-1.044-.32-2.424.58-2.304 1.755l.147 1.445c.049.473.165.95.534 1.287.346.318.802.556 1.287.534a134.42 134.42 0 0 1 23.654.966c.41.053 1.017-.239 1.287-.533.334-.364.513-.788.533-1.287l.373-9.247c.008-.205.018-.415.029-.629v-.008c.06-1.243.126-2.622-.117-3.864a3.496 3.496 0 0 0-.057-2.107c.15-2.705.235-5.412.254-8.12.094-1.43.105-2.864-.024-4.298a2.3 2.3 0 0 0-.144-.617c.934.003 1.81-.881 1.769-1.82zm-19.092 17.69h-.049a19.114 19.114 0 0 0-.21-.29l-.48-.665c.369.161.752.28 1.144.364a1.885 1.885 0 0 0 .021.455v.001l.004.02-.018.004c-.023.005-.069.018-.125.034l-.005.002c-.083.023-.188.054-.282.075zm.165.23c.028-.039-.04-.085-.128-.125l.065.063.004.003c.035.034.06.058.059.06zm-25.39 13.612l.002.026c.014.151.117.298-.005-.043l.002.017zm5.556-10.379l-.006-.02-.01-.035a.82.82 0 0 1-.009-.064l-.009-.134v-.005c.015 0 .035.068.034.258zm2.013 4.157c.064.603-.319 1.156-.811 1.493l.43 1.997c.036.17.08.345.124.523.141.57.29 1.17.244 1.725-.106 1.265-.96 2.042-2.166 2.29-.682.14-1.367.266-2.053.379-.8.13-1.604.242-2.408.342-.152.02-.306.04-.46.062-.51.07-1.03.141-1.539.143-1.145.004-2.232-.711-2.469-1.874-.112-.552-.15-1.13-.187-1.701-.015-.23-.03-.46-.05-.685L9.13 57.306c-.053-.603.298-1.147.784-1.475l.002-.034v-.005a2.142 2.142 0 0 1-.25-.412 1.737 1.737 0 0 1-.704-.714c-.322-.61-.293-1.263-.1-1.905l.657-2.197.658-2.196.12-.41c.186-.636.372-1.275.659-1.875.379-.791 1.053-1.346 1.77-1.818.664-.437 1.35-.827 2.104-1.087.87-.301 1.879-.315 2.73.044.316.133.61.32.86.55.137-.035.28-.058.425-.064.98-.044 1.824.868 1.82 1.82l-.012 3.076c-.005 1.008-.834 1.792-1.82 1.82-.302.008-.601.024-.9.05a2.88 2.88 0 0 1-.09.018 4.567 4.567 0 0 0-.494.129l-.027.014a1.441 1.441 0 0 0-.113.066l-.017.015.001-.003.004-.005-.015.01-.01.016-.001.001-.043.044-.006.018.032-.033-.04.061-.003.007-.02.061c-.01.04-.018.086-.026.132-.005.03-.01.06-.017.09l-.004.075c-.006.1-.011.2-.01.3.001.324.028.648.058.97l.03.283c.026.22.052.442.05.66-.003.943-.593 1.803-1.507 2.08-.354.108-.764.13-1.151.151l-.27.016c-.237.016-.475.028-.713.039.013.084.02.17.02.255a57.367 57.367 0 0 0 .265 5.883c.04.019.08.038.12.06.152.084.301.172.45.26a2.855 2.855 0 0 0-.088-.021l.005.003c.038.01.077.022.115.035l.02.011.024.015a.25.25 0 0 0 .042.005l.076.03c.07.026.14.053.209.075.509.159 1.024.323 1.495.577.188.101.36.217.515.344.375-.635.98-1.04 1.67-1.285.938-.333 1.982.376 2.24 1.27.624 2.176 1.028 4.399 1.268 6.649z',
	            fill: '#FFD65F'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M41.585.29a9.133 9.133 0 0 0-6.91 1.158c-1.216.763-2.173 1.732-3.027 2.875a1.164 1.164 0 0 0-.123.212l-.03-.002h-.003l-.05-.001c-1.297 0-2.54 1.145-2.48 2.49.06 1.35 1.09 2.49 2.48 2.49 1.105 0 2.17-.83 2.425-1.908.083-.014.166-.033.248-.06.529-.171.884-.472 1.218-.894l.032-.036.102-.118a7.767 7.767 0 0 1 .93-.926c.096-.056.188-.124.28-.19.083-.062.166-.122.252-.175.197-.122.4-.235.607-.338l.018-.009.004-.001.016-.008a2.5 2.5 0 0 1 .126-.059 4.46 4.46 0 0 0 .144-.067l-.096.047.009-.003a7.013 7.013 0 0 1 1.154-.314 6.993 6.993 0 0 1 1.18 0 6.594 6.594 0 0 1 1.094.296l.025.009.12.062h.002v.001h.002v.001h.001l.002.001c.134.07.268.139.398.218.08.049.16.1.238.152h.001a2.582 2.582 0 0 0 .02.014l-.02-.013c.191.193.206.192.155.137a5.642 5.642 0 0 1-.135-.123c.053.038.105.086.135.117.08.067.16.135.234.21.021.021.043.05.066.078l.043.053c.067 1.095 1.059 2.103 2.18 2.052 1.196-.053 2.17-.963 2.185-2.193C46.87 2.79 43.967.846 41.585.29zm.3 13.044a1.709 1.709 0 0 0-.404-.771 1.708 1.708 0 0 0-.633-.584l-.54-.229c-.4-.108-.8-.108-1.2 0l-.54.229c-.34.201-.61.473-.81.813l-.23.346c-.165.26-.254.541-.268.843-.067.301-.053.603.04.904.07.295.205.552.405.771.16.247.37.442.634.584l.54.229c.4.108.8.108 1.2 0l.54-.229c.339-.201.609-.472.81-.813l.229-.346c.165-.26.254-.541.268-.843a1.725 1.725 0 0 0-.04-.904zm29.1 10.09l.003.003c1.057.695 1.407 1.969.81 3.102-.55 1.045-2.1 1.465-3.09.813-1.228-.808-2.174-2.018-2.504-3.474-.281-1.24.37-2.397 1.577-2.79 1.124-.365 2.516.427 2.778 1.584.025.11.055.218.089.325a3.12 3.12 0 0 0 .1.176v.002l.01.016c.052.048.102.104.151.16h.001c.026.03.05.057.076.084zM17.155 50.782a.766.766 0 0 0 .052-.065.674.674 0 0 0-.026.024l-.026.041zM72.858 61.17l.004-.004.075-.057.016-.043.008-.023.002-.003.013-.035c-.038.043-.067.08-.087.11-.02.022-.041.05-.065.08l.034-.025zm-58.471.976c.169.044.193.068.152.067a3.739 3.739 0 0 0-.111-.042l-.023-.013-.018-.012zm8.867-35.886c-.069-.62-.206-1.146-.662-1.603-.391-.394-1.034-.69-1.597-.665-.584.027-1.19.22-1.597.665-.379.414-.726 1.018-.661 1.603.023.208.029.415.02.623l-.007.028v.001c-.01.044-.018.087-.03.13a2.373 2.373 0 0 0 .228 1.747c.274.47.812.919 1.35 1.042 1.176.269 2.464-.354 2.778-1.584.164-.64.251-1.327.178-1.987zm.499 13.104l.08.603c.028.604-.266 1.171-.66 1.603-.382.417-1.044.664-1.598.664a1.697 1.697 0 0 1-.87-.195 1.692 1.692 0 0 1-.727-.469l-.68-.813a2.27 2.27 0 0 1-.58-1l-.081-.603c-.027-.604.266-1.172.661-1.604.381-.417 1.043-.664 1.597-.664.311-.012.601.053.87.195.28.092.523.248.727.47l.68.813c.28.282.474.616.581 1zm48.055-1.623c-.064-.617-.21-1.15-.662-1.604-.392-.393-1.034-.69-1.597-.664-.584.026-1.19.22-1.597.664-.314.344-.601.813-.658 1.297-.93.447-1.5 1.666-1.182 2.653.394 1.223 1.539 1.851 2.778 1.583 1.689-.365 3.098-2.175 2.918-3.93zM37.193 52.406c.253-.942.843-1.54 1.608-2.094 2.175-1.574 5.636-1.089 7.406.865 1.298 1.433 1.343 3.424.032 4.876-1.058 1.17-3.1 1.346-4.4.456-.68.293-1.516.271-2.21.117-.897-.199-1.613-.853-2.093-1.604-.463-.724-.563-1.799-.343-2.616zm.555-47.636c-.28.19-.262.17-.174.108a6.876 6.876 0 0 1 .174-.108zm31.784 50.672c1.294.132 2.422.535 3.4 1.424.874.797.806 2.296 0 3.102-.561.56-1.215.871-1.923 1.186l-1.956.87-.179.08c-.768.342-1.5.67-2.354.743-.68.06-1.381-.147-2.009-.397-.782-.313-1.478-.669-2.01-1.347-.034.421-.074.843-.118 1.264.416-.143.88-.136 1.305-.039.521.12 1.04.553 1.306 1.008.26.446.412 1.189.22 1.69a3.734 3.734 0 0 0-.168.585c-.066.882-.011 1.786.043 2.68v.003c.023.364.045.726.059 1.084l.16 4.218.02.43c.056 1.276.113 2.549-.476 3.73-.8 1.605-2.955 2.39-4.538 1.484-1.359-.777-1.594-2.217-1.821-3.614l-.029-.173a89.507 89.507 0 0 1-.58-4.03 32.84 32.84 0 0 1-.065-7.2c.034-.34.07-.68.107-1.022.221-2.054.442-4.116.195-6.179-.067-.563.275-1.152.64-1.55.327-.358.787-.547 1.258-.615a2.852 2.852 0 0 1-.116-.1c-.373-.345-.678-1.039-.64-1.551.177-2.349.229-4.704.155-7.058a2.54 2.54 0 0 1-.557-1.437c-.024-.546.261-1.17.64-1.55.435-.437.952-.585 1.545-.643a30.657 30.657 0 0 1 3.554-.139c1.225.023 2.13.987 2.185 2.193.026.595-.245 1.158-.667 1.565.231.699.323 1.476.4 2.159.13 1.15.032 2.287-.162 3.426-.027.16-.076.307-.142.444a2.514 2.514 0 0 1 1.708-.247c.52.12 1.04.553 1.305 1.008.313.536.327 1.098.22 1.69a6.04 6.04 0 0 1-.203.805c.096.005.192.01.288.02zm-13.647-21.35c-.053-1.188-.96-2.193-2.184-2.193-1.143 0-2.238 1.009-2.185 2.193.053 1.188.96 2.193 2.184 2.193 1.143 0 2.238-1.009 2.185-2.193zm-17.903-2.193c1.225 0 2.132 1.005 2.184 2.193.053 1.184-1.041 2.193-2.184 2.193-1.224 0-2.131-1.005-2.184-2.193-.053-1.184 1.041-2.193 2.184-2.193zm-2.034 35.37a4.76 4.76 0 0 0-.172-.073 5.267 5.267 0 0 1-.583-.344l-.031-.02-.022-.02c-.065-.057-.131-.114-.194-.174a5.387 5.387 0 0 1-.256-.262 4.946 4.946 0 0 1-.098-.115l-.003-.004-.028-.034a5.168 5.168 0 0 1-.355-.608L34.2 65.6a4.944 4.944 0 0 1-.193-.738c-.095-.514-.57-1.056-1.004-1.311-.468-.275-1.158-.392-1.683-.221-1.206.391-1.75 1.486-1.526 2.698.395 2.14 1.862 3.912 3.738 4.911.289 1.085 1.25 1.87 2.337 2.054.846.144 1.716.151 2.572.152 1.662 0 3.31-.156 4.954-.396a30.089 30.089 0 0 0 4.349-.968c1.52-.459 3.03-1.06 4.193-2.183 1.35-1.303 2.164-3.555 1.419-5.372-.226-.551-.47-.997-1.004-1.31-.468-.276-1.158-.392-1.683-.222-.529.172-1.039.5-1.306 1.008-.255.485-.438 1.158-.22 1.69.043.106.079.212.108.32l-.001.1a2.81 2.81 0 0 1-.055.202 2.484 2.484 0 0 1-.046.093 3.445 3.445 0 0 1-.104.17l-.192.2-.009.01-.128.133-.006.005a5.986 5.986 0 0 1-.644.384c-.088.046-.177.088-.266.13l-.06.029c-.274.13.141-.041.187-.078-.107.086-.292.137-.454.181l-.004.002a3.069 3.069 0 0 0-.168.05c-1.66.567-3.388.952-5.124 1.204-1.132.143-2.299.248-3.46.263a2.237 2.237 0 0 0-1.998-1.362 5.943 5.943 0 0 1-.203-.013 4.73 4.73 0 0 1-.443-.11l-.028-.008-.016-.006a.8.8 0 0 1-.08-.021zm-.172-.073l-.009-.002-.018-.005-.012-.004-.049-.014c.032.01.065.02.097.032l-.01-.007zm-7.94-15.346c-.125 7.98-.001 15.962.366 23.934.043.93-.58 1.68-1.379 2.011-.364.717-1.139 1.193-1.966 1.23-1.236.055-2.107-1.051-2.185-2.193-.36-5.294-.715-10.595-.638-15.904.002-.13.015-.255.038-.377l-5.883.57c-1.218.117-2.135-1.1-2.184-2.194-.024-.546.261-1.17.64-1.55.434-.437.952-.585 1.544-.643l3.383-.327a2.03 2.03 0 0 1-.252-.344 4.213 4.213 0 0 0-.103-.166 3.767 3.767 0 0 0-.22-.22c-.148-.095-.3-.18-.462-.254-.508-.233-.838-.798-1.003-1.31-.182-.565-.048-1.182.22-1.69.25-.475.799-.868 1.305-1.008.603-.167 1.136-.031 1.684.22.596.275 1.137.691 1.59 1.184a2.796 2.796 0 0 1-.08-.532c-.024-.481-.004-.97.017-1.456.01-.216.018-.431.024-.645l.112-4.69c.029-1.209.946-2.107 2.124-2.189.357-.264.8-.424 1.289-.446 1.163-.052 2.207 1.045 2.184 2.193l-.096 4.727-.006.333c-.007.473-.015.944-.058 1.413l-.002.145-.004.178z',
	            fill: '#C4AF89'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M80.684 54.079c-.022.02-.045.048-.07.052-.147.02-.303.075-.441.047-3.032-.62-6.124-.196-9.27-.484.052-.354.077-.644.139-.925.133-.608.056-1.139-.224-1.731-.304-.646-.753-.886-1.372-.997-1.209-.219-1.186-.221-1.265-1.432-.096-1.47-.24-2.938-.352-4.407-.024-.322-.003-.648-.003-1.101l11.47.424c.895 3.507 1.312 6.977 1.53 10.4-.101.11-.12.134-.142.154zm.126 3.51c-.137 2.553-.268 5.106-.44 7.656-.118 1.74-.285 3.475-.457 5.21-.054.536-.194 1.063-.3 1.593-.152.764-.385 1.52-.086 2.306.121.318-.018.556-.306.761-.915.652-1.967 1.074-3.041.983-2.542-.218-5.05.284-7.577.19-.18-.007-.361.015-.542.005-.572-.03-.662-.118-.657-.717.007-.842.053-1.683.05-2.525-.01-2.765-.038-5.53-.052-8.295-.002-.38.037-.759.06-1.2.437-.046.79-.087 1.143-.118 1.02-.089 2.04-.183 3.06-.255.652-.047 1.118-.358 1.513-.863.559-.715.808-1.538.946-2.407.193-1.213.368-2.428.57-3.774 2.011-.165 4.001-.034 6.066.514.018.3.067.62.05.937zM65.038 76.386c-2.02-.027-3.954-.144-5.95-.24-.064-2.086-.193-4.035-.168-5.981.052-4.121-.077-8.246.245-12.361.024-.299.091-.594.143-.89.145-.831.158-.838 1.164-.599 0 .595.057 1.222-.013 1.835-.127 1.125.064 2.208.226 3.312.156 1.063 1.186 1.93 2.253 1.988.658.036 1.315.07 2.047.108.264 4.267.298 8.481.053 12.828zM57.63 43.58c-.334 2.99-.48 5.992-.509 9 0 .06-.003.12-.007.18-.06 1.075-.068 1.115-1.167 1.083-1.986-.058-3.97-.157-5.955-.25-.232-.012-.46-.1-.567-.124-.428-1.076-.781-2.062-1.217-3.01a1.915 1.915 0 0 0-.78-.825c-1.675-.907-3.516-1.282-5.39-1.24-1.125.024-2.283.29-3.352.663-1.147.4-1.759 1.405-2.053 2.572-.08.315-.127.638-.2 1.005l-6.504.266c-.045-.215-.087-.328-.09-.441-.068-2.433-.131-4.866-.195-7.3-.002-.06.003-.12 0-.18-.046-1.2-.047-1.241 1.193-1.283 3.55-.12 7.103-.214 10.655-.303 4.998-.124 9.996-.236 14.993-.351.353-.008.705-.001 1.082-.001.032.253.079.4.063.54zM44.132 50.81c1.093-.32 1.775.289 2.488.686.613.34.742.781.641 1.85l-1.919-.176c-.07-.506-.036-.986-.22-1.36-.172-.354-.573-.596-.99-1zm-1.044 4.245c-.075.898-.304 1.119-1.02 1.085-.576-.027-.751-.267-.75-1.066.567-.257 1.14-.105 1.77-.02zm.398-2.108l-1.952-.09c-.102-.783-.085-1.537-.872-1.93 1.025-.514 2.358-.581 3.21-.178-.164.337-.401.659-.472 1.014-.066.334.043.703.086 1.184zm-5.05-.267c.07-.966.414-1.41 1.241-1.59v1.59h-1.24zm10.507 16.603c1.592-1.434 1.74-3.318 2.05-5.142.062-.371.15-.738.225-1.106l.212-.018c.063.162.196.332.178.484-.185 1.588-.455 3.16-1.142 4.622-.339.72-.562.876-1.523 1.16zm-17.728-4c.041-.61.302-1.077.907-1.435.205.869.359 1.63.567 2.378.339 1.21 1.122 2.038 2.299 2.483 1.707.645 3.484.943 5.3 1.042 1.23.067 2.46.128 3.9.202-.514.436-.93.499-1.356.494-2.257-.028-4.52.066-6.766-.262-.894-.131-1.793-.25-2.693-.3-.765-.042-1.277-.408-1.522-1.074-.416-1.132-.718-2.298-.636-3.528zM56.91 75.888c-.182.043-25.79.096-25.957.059-.269-1.624-.08-3.285-.227-5.143.327.28.461.433.628.532.46.272.909.668 1.408.755 1.837.32 3.687.575 5.541.772 1.404.15 2.821.182 4.233.248.297.014.6-.048.898-.085 1.73-.22 3.463-.424 5.19-.667 2.258-.318 3.532-1.529 4.18-3.908.269-.983.427-1.996.647-3.05.347-.092.726-.163 1.084-.291 1.232-.44 1.928-2.11 1.302-3.26-.43-.79-.995-1.505-1.774-2.012-1.28-.833-2.689-.793-4.096-.537-.672.123-1.31.437-1.962.669-.429.152-.553.528-.64.916-.149.675-.02 1.312.277 1.927.17.35.323.71.486 1.065.192.417.622.748.353 1.314-.36.757-.576 1.624-1.515 1.898-.548.16-1.118.38-1.67.359-2.526-.1-5.053-.224-7.57-.448-.913-.08-1.803-.453-2.698-.711a1.13 1.13 0 0 1-.807-.788c-.1-.33-.106-.65.175-.918.195-.187.374-.392.569-.58.852-.824.745-1.846.382-2.774-.335-.853-1.005-1.525-2.063-1.474-.982.047-1.962.148-3.067.234-.047-.218-.153-.523-.172-.833-.08-1.312-.135-2.626-.204-4.028.192-.037.446-.117.704-.13a296.76 296.76 0 0 1 5.415-.257c.345-.012.694.127 1.044.179.224.033.454.055.68.042.144-.008.28-.11.426-.136 1.333-.235 1.736.032 1.806 1.333.058 1.076.592 1.553 1.826 1.939.622.194 1.412-.063 2.103-.217.227-.05.513-.402.548-.648.154-1.097 1.081-1.128 1.813-1.28.72-.149 1.493.004 2.199-.353.166-.084.414-.018.623-.006 2.315.137 4.63.275 6.945.417.266.017.531.057 1.001.109-.523 6.652.002 13.222-.064 19.767zm9.42-35.95c.187-1.544 2.01-3.402 3.926-3.974-.207.937-.337 1.73-.568 2.495-.15.5-.55.895-1.06 1.032-.74.197-1.506.298-2.297.447zm2.559 13.268c-.059.307-.243.464-.56.462-.329-.002-.658.013-.986 0-.173-.006-.345-.055-.568-.094.186-1.355.771-1.68 2.281-1.276-.054.296-.109.602-.167.908zm-9.147.678c-.054 0-.108-.048-.177-.081-.027-.072-.087-.154-.086-.237.007-3.066.063-6.133.413-9.182.166-1.453.082-1.35 1.525-1.364a143.1 143.1 0 0 1 2.98.006c.326.004.65.048 1.047.08.102 1.13.214 2.2.291 3.274.08 1.11.113 2.222.192 3.332.033.466-.069.862-.277 1.289-.367.751-.646 1.548-.928 2.337-.12.334-.22.627-.647.62-1.444-.026-2.889-.047-4.333-.074zm2.785 3.472c.013-.657.097-.834.744-.903a70.642 70.642 0 0 1 3.688-.268c1.473-.078 2.949-.213 4.416.083.265.053.534.088.796.155.306.077.469.285.392.604-.21.874-.372 1.77-.68 2.61-.248.679-.78 1.094-1.594 1.11-2.317.042-4.634.133-6.95.196-.235.006-.472-.046-.789-.08-.038-.304-.088-.509-.085-.712.013-.932.044-1.863.062-2.795zm-36.85-17.154c-.369-.053-.604-.185-.744-.54-.704-1.79-2.108-2.88-3.769-3.703-.243-.12-.51-.2-.73-.352-.157-.108-.345-.295-.362-.462-.132-1.34-.226-2.683-.33-4.004.72-.49 1.499-.598 2.271-.684 2.753-.304 5.503-.679 8.265-.845 2.792-.168 5.597-.127 8.397-.163 1.505-.02 3.011.018 4.516-.014 5.119-.112 10.237-.252 15.355-.363 3.253-.071 6.505-.112 9.758-.16.572-.008 1.147-.013 1.713.046.186.02.493.242.5.383.068 1.433.022 2.865-.108 4.439-1.93-.42-3.105.607-4.16 1.747-1.064 1.147-2.004 2.408-2.498 3.93-.13.405-.39.548-.806.568-2.015.096-4.027.274-6.042.316-4.366.09-8.733.16-13.099.151-3.278-.006-6.556-.156-9.835-.223-.66-.014-1.323.046-1.984.09-2.108.14-4.21.145-6.308-.157zm2.988 35.822c-1.786.286-3.55.115-5.428.21.035-2.46.123-4.84.086-7.218-.037-2.366-.2-4.73-.31-7.186 1.014-.197 1.368-.852 1.647-1.57.497-1.28.664-2.614.651-3.977-.002-.262 0-.525 0-.89l2.286-.113c.058.647.114 1.203.157 1.761.08 1.047.139 2.096.23 3.143.054.61-.008 1.165-.285 1.74-.692 1.439-.543 2.788.59 3.989.167.177.27.467.295.716.073.746.12 1.498.127 2.248.022 2.224.02 4.447.023 6.67 0 .144-.04.287-.07.477zM22.14 59.24c-.517.108-1.048.148-1.651.224.214-.325.363-.54.5-.763.215-.352.181-.673-.111-.98-.322-.339-.621-.699-.95-1.07.926-.444 2.451-.465 3.338-.08-.006.818-.293 1.57-.665 2.29-.086.166-.286.342-.461.379zm-1.269 17.078c-.165.038-.28.08-.395.088-2.853.196-5.706.429-8.566.162-.617-.058-1.273-.069-1.784-.603.43-1.285.105-2.592.085-3.895-.075-4.778-.164-9.555-.246-14.333-.003-.21.013-.42.029-.63.025-.344.205-.567.55-.612 1.012-.132 2.025-.253 3.038-.371.047-.006.101.055.194.108-.067.838-.161 1.697-.194 2.558-.022.595-.042 1.211.083 1.787.278 1.277 1.022 1.945 2.34 1.962 1.194.014 2.392-.171 3.589-.273.348-.03.695-.072 1.027-.107.403 1.51.59 12.427.25 14.16zm-2.161-22.73c-.556.054-.768-.258-.529-.768.295-.631.862-.77 1.7-.75l.941.195c.37.076.466.333.438.667-.027.314-.263.35-.513.382-.68.088-1.356.207-2.037.273zm-1.14 5.71c.383.135.82.136 1.234.157.26.014.524-.047.879-.085-.904.623-3.027.918-4.372.617-.056-1.06-.065-2.067.577-2.954.305-.422.533-.488.895-.257.371.236.296.511.122.846-.39.754-.155 1.388.665 1.676zm2.886-18.958l-.24-2.842c1.396.509 2.278 1.203 2.713 2.601l-2.473.242zm2.57 9.165c-.011-1.5-.052-3.002-.053-4.503 0-.81.05-.855.871-.916 1.16-.086 2.323-.141 3.512-.211.056.25.112.389.115.529.038 2.52.063 5.04.107 7.56.021 1.188.037 1.198-1.139 1.265-1.101.063-2.204.1-3.338.15-.161-.811-.464-1.473-.151-2.269.186-.472.08-1.066.076-1.605zM10.136 53.2c.178-2.158.39-4.313.553-6.472.052-.683.52-.944 1.027-1.11 1.144-.372 2.298-.732 3.471-.988 1.8-.395 3.643-.26 5.592-.375v5.775c-.326-.066-.628-.085-.895-.19-.803-.313-1.545-.082-2.276.22-.515.21-.82.605-.84 1.177-.02.631-.04 1.263-.033 1.893.005.396-.122.619-.546.663-1.797.188-3.591.393-5.387.586-.175.019-.354.003-.638.003-.012-.426-.058-.807-.028-1.182zm11.44-28.134c.242 1.382-.91 3.157-2.326 3.503-.65-2.012.385-3.368 2.326-3.503zm2.439-.603c.134-.036.384-.132.643-.168.806-.109 1.615-.2 2.424-.288.176-.019.436-.075.521.015.533.56 1.072.124 1.6.044.499-.075.987-.263 1.486-.295 4.21-.267 8.424-.49 12.633-.768 2.225-.147 4.44-.449 6.666-.554 2.918-.138 5.842-.16 8.764-.21.843-.015 1.689.084 2.53.056.96-.032 1.918-.143 2.875-.227.953-.083.99-.079 1.253.853.327 1.16.866 2.173 1.827 2.938.228.182.41.421.708.733-.291.082-.47.176-.647.176-2.501.008-5.002-.015-7.502.008-1.264.012-2.526.13-3.79.15-1.292.02-2.587-.062-3.88-.025-1.713.05-3.424.202-5.139.254-3.038.093-6.074.22-9.12.127a68.25 68.25 0 0 0-9.84.405c-1.55.177-3.104.315-4.652.47l.64-3.694zm3.548-11.508c.027-.46.367-.755.76-.942 1.301-.622 2.6-1.252 3.92-1.83 2.221-.974 4.587-1.474 6.957-1.865 1.771-.291 3.588-.325 5.387-.425.899-.05 1.807-.034 2.705.032 1.077.079 2.163.174 3.213.407.389.086.685.584 1.007.878-.096.54-.487.668-.836.821-1.668.731-3.44 1.086-5.224 1.373-.801.13-1.616.175-2.422.28-.422.056-.765.005-1.012-.392-.108-.174-.306-.29-.437-.452-.773-.964-1.783-1.034-2.863-.73-.606.172-1.208.388-1.774.662-.74.358-1.315.872-1.164 1.822.048.306-.074.513-.36.648-1.602.758-3.182 1.57-4.973 1.817-.957.132-1.905.211-2.894-.037 0-.707-.03-1.39.01-2.067zm13.8-7.007c-1.65.159-2.866.327-2.866.327-.958.194-1.908.428-2.854.68.42-.447.905-.826 1.513-1.052 1.413-.526 2.818-.424 4.206.045zm-9.403.235c.763-1.715 1.936-3.062 3.813-3.584.95-.264 1.94-.382 2.915-.554.975-.171 1.915-.028 2.836.319.392.148.801.25 1.206.36.9.246 1.682.633 2.089 1.554.193.438.422.871.703 1.257.034.048.072.094.11.14-.504.01-1.022.032-1.536.06-.45-.472-1.023-.803-1.558-1.182-1.351-.958-2.898-1.162-4.476-1.059-.823.054-1.688.249-2.43.598-1.59.748-2.566 2.131-3.322 3.666a1.34 1.34 0 0 0-.082.204c-.325.11-.65.22-.977.322.222-.706.41-1.429.709-2.1zm6.175 6.941c.058-.098.119-.36.262-.418.575-.232 1.165-.483 1.771-.57.632-.09.788.52 1.023.96.23.433.17.842-.206 1.122a8.32 8.32 0 0 1-1.382.813c-.14.067-.422-.007-.56-.116-.537-.424-.832-.996-.908-1.791zm14.33-.525c.227 1.646.272 3.297.093 4.95-.1.927-.222 1.012-1.114 1.261-1.1.308-2.184.676-3.275 1.019-1.996.628-4.052.899-6.131 1.044-2.735.192-5.466.44-8.203.59-1.5.083-3.009.01-4.513.024-.395.003-.62-.195-.76-.522-.482-1.14-.7-2.341-.925-3.71 1.682-.017 3.213-.024 4.687-.518 1.45-.486 2.915-.926 4.218-1.338.83.663 1.533 1.253 2.266 1.8.553.411 1.149.463 1.775.098.52-.303 1.065-.561 1.604-.83.943-.47 1.576-1.111 1.308-2.276-.018-.079.034-.173.077-.368 2.915-.343 5.85-.779 8.729-1.804.06.206.138.39.164.58zM70.37 25.93c-.144-.055-.296-.08-.406-.16-.63-.462-1.266-.92-1.872-1.413-.701-.57-.896-1.373-1.01-2.29 2.52-.012 3.685 1.48 3.288 3.862zm11.471 20.33c-.2-1.18-.549-2.345-.935-3.48-.36-1.056-1.063-1.795-2.313-1.745-.15.006-.3-.02-.451-.026-1.957-.077-3.913-.15-5.87-.235-.256-.011-.51-.085-.808-.137.035-.225.046-.37.081-.508.523-2.049.817-4.129.859-6.242.04-1.956.033-3.913.117-5.866.06-1.4-.127-2.764-.393-4.123-.22-1.13-.781-2.1-1.694-2.802-.841-.646-1.761-1.12-2.907-.977-1.014.127-2.04.207-3.061.216-.924.008-1.848-.154-2.772-.156-1.231-.002-2.463.08-3.694.124-1.053.038-2.106.079-3.16.107-.535.015-.642-.116-.559-.639.052-.326.121-.65.168-.976.3-2.105.121-4.205-.07-6.304-.14-1.516-.5-2.946-1.426-4.217-.438-.602-1.057-.96-1.539-1.46-.546-.565-2.618-.98-2.618-.98-.424-.073-.922-.12-1.465-.144a.99.99 0 0 0-.038-.507c-.465-1.42-1.281-2.666-2.51-3.439-1.578-.99-3.344-1.658-5.26-1.718-.81-.025-1.622.035-2.434.057-1.955.234-3.789.719-5.226 2.18-1.502 1.53-2.433 3.342-2.728 5.467-.044.32.162.845.425 1.244-.204.09-.407.182-.609.277-.871.41-1.75.813-2.582 1.297-.365.212-.72.569-.898.945a4.234 4.234 0 0 0-.37 1.57c-.096 2.02.015 4.03.497 6.005.227.927.48 1.847.735 2.82-.146.054-.276.123-.415.15-1.652.321-3.312.608-4.957.962-1.266.273-2.32.963-3.22 1.883-.113.116-.18.31-.203.477a16.554 16.554 0 0 0 .01 4.66c.112.773.227 1.549.284 2.328.191 2.64.357 5.284.534 7.926.035.527.076 1.055.118 1.621-.268.03-.471.06-.676.074-2.354.155-4.685.444-6.864 1.412-.5.222-.909.65-1.353.992-.135.103-.245.327-.375.335-.568.031-.59.445-.623.83-.294 3.536-.67 7.069-.837 10.612-.146 3.122-.113 6.257-.054 9.384.06 3.188.228 6.375.393 9.56.071 1.385.633 2.506 2.066 2.978.599.196 1.197.458 1.813.522 1.284.133 2.58.234 3.87.204 2.529-.059 5.056-.27 7.585-.323 4.458-.094 8.917-.129 13.376-.165 2.44-.02 4.883.088 7.319-.003 4.494-.168 8.983-.057 13.466.195 4.247.24 8.49.368 12.742.282 2.018-.04 4.039-.193 6.054-.142 1.64.042 3.085-.325 4.414-1.277.875-.627 1.33-2.008.94-3.034-.07-.184-.131-.413-.088-.594.511-2.122.58-4.292.72-6.452.212-3.27.442-6.542.567-9.816.145-3.78-.468-7.502-1.098-11.21zm-5.548-9.303c.292.016.589-.093.885-.127.53-.06 1.063-.106 1.657-.164.093.429.128.697.21.95.181.55.859.94 1.438.85.578-.09.89-.47.923-1.128.068-1.318-.284-1.857-1.556-2.271-.394-.129-.821-.162-1.236-.218-.317-.042-.638-.05-1.076-.083.103-.415.173-.725.257-1.032.308-1.13.659-2.25.92-3.39.265-1.156.17-2.325-.057-3.487-.15-.775-.861-1.132-1.398-1.236a.875.875 0 0 0-1.01.574c-.166.457-.277.94.072 1.372.294.363.323.776.234 1.196-.242 1.144-.481 2.29-.77 3.423-.254.99-.551 1.968-.87 2.938-.394 1.2.263 1.769 1.377 1.833zM5.586 70.05c-.032-1.11-.01-2.223-.01-3.335h.11c0-1.111-.034-2.224.011-3.334.033-.796-.421-1.136-1.22-1.276-.555-.098-1.03.438-1.094 1.165-.013.15-.012.3-.015.45-.047 2.162-.105 4.324-.13 6.486-.005.476.109.953.17 1.429.115.874 1.32 1.312 2.062.75.32-.243.471-.485.342-.918a5.54 5.54 0 0 1-.226-1.417zm15.713-54.867c.355.314.799.063 1.185-.068.346-.117.399-.39.333-.731-.22-1.141.068-2.206.528-3.239.257-.576.522-1.15.77-1.729.13-.302.233-.616.307-.816.073-.637-.244-.997-.956-1.22-.594-.185-.975-.082-1.2.45-.54 1.27-1.047 2.555-1.534 3.847-.282.748-.215 1.53-.156 2.317.04.55.381.887.723 1.19zM2.224 67.046c-.036-.417-.002-.84-.055-1.255-.075-.584-.68-1-1.318-.952-.526.038-.832.418-.846 1.071-.01.449-.002.898-.002 1.347l.025.002c.083.894.194 1.787.24 2.683.026.515.275.77.692 1.038.46.295.802.1 1.164-.084.357-.182.459-.485.402-.903-.132-.978-.215-1.963-.302-2.947zm76.882-34.917c-.053.267-.02.64.134.841.455.596.986 1.127 1.802 1.234.629.083 1.046-.24 1.062-.897-.005-.055.018-.17-.03-.23-.499-.64-.396-1.427-.543-2.153-.16-.79-.685-1.278-1.426-1.475-.268-.07-.634.066-.904.207-.313.164-.31.507-.171.8.262.554.19 1.1.076 1.673zm-60.77-18.823c.463.214 1.144-.1 1.25-.574.175-.783.332-1.576.42-2.373.076-.702-.31-1.07-1.23-1.094-.103.062-.448.165-.616.396-.524.72-.753 1.545-.745 2.449.006.66.427.967.921 1.196zm18.808 19.65c.099-.104.354-.15.49-.099.125.046.248.255.263.403.034.352.01.712-.002 1.068-.006.17-.04.338-.063.524-.507.088-.805-.128-.902-.548-.108-.464-.154-.963.214-1.348zm16.733.37c.024-.297.245-.4.509-.333.321.081.435.341.287.612-.157.288-.404.527-.611.788l-.19-.073c0-.332-.022-.665.005-.995zm-15.536 3.927c.658.058.844-.028 1.106-.643.129-.303.281-.518.622-.571 1.337-.21 2.668-.48 4.034-.262.265.042.541.038.81.021 2.014-.121 4.027-.236 6.039-.389.577-.044.956.058 1.195.657.27.676.925.968 1.588 1.036 1.217.123 2.864-1.294 3.041-2.524.274-1.903-1.205-3.755-3.11-3.9a3.466 3.466 0 0 1-.71-.114c-.928-.272-1.077-.168-1.116.817-.004.118-.012.236-.018.341-1.755-.012-3.436-.055-5.116-.027-1.954.031-3.908.23-5.858-.074-.385-.06-.804-.174-1.162-.084-.71.178-1.197-.11-1.733-.502-.87-.637-2.297-.284-2.729.635-1.26 2.682.733 5.372 3.117 5.583zM65.77 59.936c.6.023 1.2.005 1.8.005v.03h1.8c.34 0 .573-.16.68-.482.29-.87-.789-2.259-1.706-2.214a63.15 63.15 0 0 1-2.418.086c-.828.01-1.367.4-1.374 1.096-.008.78.344 1.445 1.218 1.48z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'mac':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '58',
	            height: '82',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'mac'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h58v82H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M46.365 24.173a2.073 2.073 0 0 1 2.284-1.84c.017.002.096.006.262.01.51.015.702.024 1.018.055 1.257.125 2.197.454 2.869 1.428.883 1.28.567 2.693-.477 4.131.86 1.368 1.243 2.383 1.223 3.713-.01.66-.22 1.243-.573 1.758.242.691.262 1.409.163 2.268a17.32 17.32 0 0 1-.065.496c-.035.244-.045.318-.056.42-.115.999-.257 1.769-.608 3.458-.42 2.024-.572 2.944-.624 3.98-.166 3.34-.05 6.195.377 12.013l.027.367c.454 6.165.577 8.93.431 12.446a2.099 2.099 0 0 1-.735 1.523c-.21.182-.419.3-.638.39-.221.09-.433.141-.665.178-.29.046-.624.068-.964.068-.34 0-.675-.022-.965-.068a2.942 2.942 0 0 1-.663-.178 2.216 2.216 0 0 1-.612-.366c-.23.227-.511.407-.927.513a2.05 2.05 0 0 1-1.604-.243 3.966 3.966 0 0 1-.177.3c-.43.656-.981 1.125-1.918 1.167-1.056.047-2.06-.242-3.08-.801a44.928 44.928 0 0 1-4.564.788c-7.95.963-15.193 1.376-19.624.734-.587-.085-1.108-.308-1.536-.937-.594-.874-.438-1.772.018-2.44.065-.094.13-.178.198-.255a2.12 2.12 0 0 1-.03-2.459c-.052-.067-.093-.136-.156-.243a2.082 2.082 0 0 1-.231-.569 3.318 3.318 0 0 1-.077-.421 14.236 14.236 0 0 1-.071-.785 93.098 93.098 0 0 1-.126-2.484c-.08-1.987-.159-4.685-.22-7.47a408.334 408.334 0 0 1-.105-8.075 107.543 107.543 0 0 1-.511-4.379c-.099-.994-.276-1.851-.794-4.01l-.162-.68c-.55-2.332-.795-3.803-.792-5.326.004-1.97.493-3.67 1.6-5.081l1.125-3.505c.09-.278.236-.534.43-.75.873-.977 2.473-1.12 3.395.128.317.43.428.825.499 1.345.068.496.08 1.148.054 1.948-.044 1.337-.203 3.025-.368 3.943a16.345 16.345 0 0 0-.226 3.466c.076 2.176.195 3.925.506 7.874.075.952.13 1.652.174 2.245.192.347.384.744.583 1.197.455 1.04.804 1.985 1.651 4.39l.096.272c.484 1.373.822 2.3 1.111 3.024 4.983-.24 10.042-.403 18.345-.62.358-.081.682-.148 1.022-.212.08-.045.183-.106.309-.182.155-.095.332-.205.592-.368l.34-.214.357-.224.175-.11c.67-.416 1.166-.708 1.596-.929.308-.159.578-.279.842-.363.037-.012-.975-11.4-.975-11.4a2.048 2.048 0 0 1-.01-.18c0-.127 0-.217.006-.329.009-.182.028-.36.067-.543.149-.708.525-1.346 1.274-1.737a2.889 2.889 0 0 1 1.81-.26c.25.043.495.115.723.22a2.133 2.133 0 0 1-.38-.912 2.148 2.148 0 0 1 .053-.945 3.54 3.54 0 0 1 .789-1.424c.218-.248.4-.417.747-.716l.155-.134c-.104-.376-.382-.88-.92-1.675a.857.857 0 0 0-.211-.077l-.013-.003a2.588 2.588 0 0 1-.634-.243 2.18 2.18 0 0 1-.641-3.324c-.396-.484-.64-1.107-.568-1.767z',
	            fill: '#E0DDE8'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M24.29 52.295c5.532-.096 9.016-.723 10.613-1.883.799-.58 1.268-1.417 1.283-2.273 1.747-.676 2.836-1.57 3.814-3.295.273-.481.42-1.02.306-1.577.097-.08.162-.134.219-.195.105-.111.185-.246.404-.615.238-.552.23-1.078.067-1.528 2.563-1.753 4.746-4.092 6.22-6.714a59.602 59.602 0 0 0 2.769-2.686c.29-.3.511-.559.68-.812.144-.216.259-.436.34-.703.184-.605.153-1.285-.31-1.923-.457-.63-1.078-.868-1.697-.886a2.526 2.526 0 0 0-.745.092c-.267.07-.54.18-.85.326l-.068.032a2.741 2.741 0 0 0-.095-.233 2.377 2.377 0 0 0-.906-1.053l-.124-.11c.003-.268.007-.518.012-.75.47-.472.725-.768 1.007-1.207.594-.926.903-1.723.707-2.834.051-1.147-.52-2.02-1.405-2.643-.456-.321-.91-.538-1.688-.855l-.298-.121-.118-.048a16.88 16.88 0 0 1-.492-.208 4.993 4.993 0 0 0-.199-.55 33.154 33.154 0 0 1 .303-.775c.507-1.296.716-2.092.615-3.062-.17-1.617-1.308-2.733-3.053-3.124-1.317-.295-2.31.112-2.901.903a38.52 38.52 0 0 0-.178-4.528c-.07-.744-.106-1.067-.17-1.318a1.999 1.999 0 0 0-.2-.51c-.046-.088-.078-.15-.119-.209-.1-.143-.245-.254-.75-.642h-.001c-.28-.113-.431-.174-.59-.201-.186-.032-.382-.016-.81.018l-.001.001h-.002c-.398.147-.56.206-.701.3a2.725 2.725 0 0 0-.328.275l-.002.002c-.275.366-.357.474-.41.594-.023.05-.041.103-.066.177a3.81 3.81 0 0 0-.06.205c-.007.025-.012.05-.02.09-.018.092-.028.17-.035.252a5.609 5.609 0 0 0-.016.495c0 .291.008.714.027 1.488l-.046-.213-.166-.26-.52-.488-.658-.285-.578-.053-.414.062-.278.093-.226.11-.122.075a3.694 3.694 0 0 0-.314.253l-.05.054-.012.013a3.08 3.08 0 0 0-.1.116l-.024.03a3.9 3.9 0 0 0-.037.05l-.072.103-.005.008-.004.006c-.063.094-.171.263-.32.496l-.274.432-.027.042-.243.362c-.12.019-.24.049-.358.09a2.072 2.072 0 0 0-1.887 1.368c-.502 1.386-.678 2.119-.476 2.956-.537.874-1.129 1.837-1.773 2.89-1.358 1.201-2.525 2.443-3.326 3.605-.53.77-.908 1.533-1.13 2.267a2.098 2.098 0 0 0-2.115.68 2.095 2.095 0 0 0-.473.996c-.145.75.149 2.176 1.162 5.794a5.094 5.094 0 0 0-.202.835c-.127.776-.14 1.726-.07 2.894-.38.913-.4 2.021-.05 3.462l-.444.045-.681.288-.635.655-.278.75-.016.548c.14.533.17.652.227.759.016.03.034.06.058.099l.002.003c.137.205.137.206.196.275l.026.027.085.145.221.385.175.306c-.567 2.134-.563 2.138-.507 2.194l.002.004a4.225 4.225 0 0 0 .158.253l.104.149.171.245.246.353c.224.32.466.669.74 1.063.69.995 1.502 2.17 2.461 3.564l.918 2.507a2.072 2.072 0 0 0 1.98 1.361zM53.543 5.228a2.067 2.067 0 0 0-2.44.138 2.078 2.078 0 0 0-.757 1.665c-.48.416-.79 1.009-.796 1.759-.01 1.399.981 2.29 2.222 2.803 1.259.52 2.633.525 3.669-.477 1.16-1.122 1.125-2.72.34-4.627a2.066 2.066 0 0 0-2.238-1.261zM18.388 8.312a2.067 2.067 0 0 0 3.642-.362c.5-.807.397-1.88-.305-2.576a59.316 59.316 0 0 1-.45-.45l-.325-.33a8.919 8.919 0 0 0-.252-.248 2.405 2.405 0 0 0-.247-.206c-.035-.026-.06-.046-.088-.064-.078-.053-.167-.091-.515-.241-.139-.042-.232-.07-.327-.084-.197-.028-.402.01-1.034.122-.266.132-.4.198-.518.288-.121.092-.224.209-.432.445-.16.28-.228.397-.272.522-.033.09-.053.185-.088.348.015.727.018.884.072 1.022.014.038.033.074.057.12.046.104.062.14.08.175a2.793 2.793 0 0 0 .15.257l.201.299a122.468 122.468 0 0 1 .65.963z',
	            fill: '#E8506D'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M38.123 28.37c.458.125.826.286 1.192.62a2.22 2.22 0 0 1 .29 2.975c-.914 1.25-2.937 2.426-4.955 2.954.496.629.755 1.386.647 2.256-.11.885-.498 1.767-1.11 2.757-.25.404-.534.819-.858 1.262-.194.264-.394.527-.63.832l-.187.239-.07.089-.26.333c-.388.502-1.064 1.055-1.687 1.426-.464.276-.864.45-1.371.496-1.838.163-2.764-1.568-2.225-3.016.936-2.513.971-4.46.478-6.844 0 .002-.246-1.127-.298-1.424-.124-.703-.147-1.236.014-1.822.161-.586.481-1.055.905-1.437.238-.214.425-.34.77-.553l.045-.028.1-.062.031-.07c.064-.15.134-.337.232-.615l.124-.357c.053-.151.093-.264.133-.373.119-.324.221-.572.341-.803.304-.582.627-.99 1.296-1.233.01-.667.043-1.25.117-1.761l-.015-.304a2.079 2.079 0 0 1 .885-1.808c.091-.101.191-.197.3-.287a2.403 2.403 0 0 1 2.428-.4c.51.195.913.521 1.28.957.065-.059.136-.116.211-.172.78-.581 1.87-.657 2.733.019.487.38.731.837.906 1.406.406 1.324-.106 2.468-1.083 3.334-.282.25-.565.455-.927.678a2.19 2.19 0 0 1-.564.577c.312.047.544.095.782.16z',
	            fill: '#FFD65F'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M12.343 73.517c-1.024-1.432-2.004-2.331-4.287-4.156l-.181-.145a2.075 2.075 0 0 0-2.92-2.036 2.065 2.065 0 0 0-1.805.658 2.085 2.085 0 0 0-.334 2.314c-.197 1.108.04 2.32.648 3.52.798 1.574 2.244 3.169 3.89 4.435 1.843 1.418 3.504 2.202 4.931 1.802 1.635-.458 2.098-1.983 1.669-3.451-.238-.812-.77-1.766-1.61-2.941z',
	            fill: '#9D93AC'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M42.587 39.766a2.077 2.077 0 0 0-1.83 2.296c.112 1.002.206 1.888.279 2.666-.187.09-.359.2-.516.327a2.05 2.05 0 0 0-.168.014c-.883.106-1.573.571-2.067 1.246-.265.362-.408.654-.648 1.22-.663.506-1.104.864-1.609 1.306-.086.075-.163.149-.243.238a2.15 2.15 0 0 0-.23.306 1.975 1.975 0 0 0-.318 1.149c.03.287.048.445.096.593.058.18.162.346.391.712.32.29.45.41.602.494.105.059.221.1.418.169.47.07.61.09.748.078.058-.005.116-.015.198-.03.194-.035.335-.083.486-.146.21-.088.447-.218.727-.388.338-.205.666-.423.95-.637.307.184.665.298 1.12.29a2.095 2.095 0 0 0 1.742-.979c.44.139.943.132 1.46-.1.614-.275.919-.693 1.104-1.168.07-.179.108-.339.134-.504a3.88 3.88 0 0 0 .04-.555c.005-.312-.012-.734-.05-1.292-.078-1.17-.25-2.973-.528-5.47a2.073 2.073 0 0 0-2.288-1.835z',
	            fill: '#9A9AFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M12.882 27.339a3.239 3.239 0 0 0-.23-.342 2.413 2.413 0 0 0 .28-1.795c.577-.639.58-.659.714-1.626-.087-.49-.117-.659-.188-.814.992.001 2.036.046 3.165.124.226.015.448.032.702.052l.569.044c.197.015.328.024.439.03.078.004.147.006.215.007.17 0 .3-.006.498-.047h.019c.055-.001.11-.026.663-.274l.003-.002.004-.002c.063-.041.103-.067.14-.096.066-.05.126-.107.287-.261.093-.113.158-.192.21-.268h.034l.016.001h.04c.118.003.178.004.26.004.679-.005 1.24-.117 1.829-.517.637-.433.94-1.067 1.049-1.717a2.373 2.373 0 0 0-.08-1.168c-.309-.936-1.224-1.618-2.328-1.472-.692.09-1.265.162-2.502.312a183.19 183.19 0 0 0-2.514.313 36.697 36.697 0 0 1-1.347-.087c-.178-.09-.358-.186-.54-.288a2.333 2.333 0 0 0-.268-.13l-.003-.001a2.247 2.247 0 0 0-.096-.037 3.543 3.543 0 0 0-.268-.075h-.005v-.001h-.002l-.002-.001h-.002a1.794 1.794 0 0 0-.231-.047c-.192-.02-.391.033-1.119.227-.304.203-.466.31-.592.45-.143.16-.24.359-.449.784l-.411.087c-.517.044-1.01.103-1.478.18-.833.134-1.517.356-2.015.771a2.47 2.47 0 0 0-.944.655 2.073 2.073 0 0 0-1.877 1.412 2.18 2.18 0 0 0 .414 2.096 2.335 2.335 0 0 0-.191.085c-.105.054-.2.127-.48.343-.968.92-.79 2.295.022 3.046.2.186.37.288.556.37-.413.316-.658.767-.773 1.244-.119.496-.077.967.048 1.454.071.28.162.549.278.8a3.121 3.121 0 0 0-.542.313c-1.238.89-1.285 2.446-.403 3.486.03.036.06.07.092.104-.017.14-.023.28-.02.42.004.138.015.276.034.413-.633.666-.852 1.727-.179 2.657.391.54.913 1.025 1.622 1.57.195.15.392.295.63.465-1.485-.144-2.812 1.5-2.07 2.981-.586.284-1.053.838-1.148 1.655-.071.62.082 1.025.351 1.455-.304.259-.54.61-.657 1.03-.11.389-.099.66-.046.97.032.187.08.355.154.572.206.61.438 1.156.73 1.701-.845 1.108-.993 2.376-.594 3.66-.421.376-.625.893-.662 1.405-.019.263.008.465.057.668.085.347.223.623.515 1.143.177.314.395.68.636 1.069l-.964-.147-1.676 2.692.191.425.08.125.01.015.002.002.006.007v.001l.008.01.063.084.02.025.12.134.003.003.248.255.162.166c1.79 1.842 4.363 4.516 8.316 8.662a2.067 2.067 0 0 0 2.704.252c.452.067.907.012 1.399-.229 2.416-1.187 2.38-3.493.702-5.253a10.8 10.8 0 0 0-1.063-.958 2.844 2.844 0 0 0-.16-.805c-.29-.88-.64-1.63-1.121-2.372.114-.07.226-.152.336-.248.513-.451.669-.91.722-1.43.03-.302.009-.58-.046-.947-.305-2.033-1.064-3.493-2.759-5.658.848-.835 1.003-2.05.536-3.307.93-.386 1.39-1.38 1.236-2.313a2.22 2.22 0 0 0-.305-.872c.162-.062.323-.139.485-.233a2.082 2.082 0 0 0 .756-2.836l-1.087-1.892c.19-.765-.009-1.594-.51-2.328.856-.634 1.151-1.896.464-2.874l-.638-.91c.513-.31.923-.815 1.15-1.524.39-1.21.144-2.35-.544-3.346.147-.134.284-.258.374-.337 1.088-.96 1.517-2.31.761-3.6zM13.44 76.052a2.06 2.06 0 0 0-.553 2.819c.047.258.13.507.288.77a2.114 2.114 0 0 0 1.838 1.04c.85-.006 1.255-.31 1.711-.829l.024-.028c1.037.012 2.252.03 4.042.06 6.244.104 9.026.115 12.52-.007 3.735-.13 7.058-.472 10.186-1.099a2.06 2.06 0 0 0 .465-.152l3.306-1.538c1.615-.544 1.879-2.495 1.078-3.649a2.062 2.062 0 0 0-1.383-.863c-.685-.418-1.504-.51-2.336-.33-.61.13-.977.291-1.967.781l-.11.054-.102.05c-.473.23-.737.33-.822.338-2.244.222-4.6.3-7.604.285a61.626 61.626 0 0 1-2.835-.087 186.62 186.62 0 0 1-2.468-.146c-4.113-.26-5.959-.317-8.308-.164-.928.06-1.728.258-2.652.64a2.063 2.063 0 0 0-3.463.563c-.063.152-.157.318-.41.73-.17.276-.318.527-.446.762zm32.022.23a.318.318 0 0 0 .034-.004l-.014.003-.02.002z',
	            fill: '#C7C7DA'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M43.483 43.17c.1-1.712.1-1.712-.223-2.566-.47.306-.76.722-1.001 1.307l1.224 1.258zm-6.215 6.466c.883.217.89.24 1.48.054 1.024-.322 2.049-.575 3.139-.534.371.014.754-.144 1.125-.246.533-.146.824-.51.815-1.069a46.388 46.388 0 0 0-.087-2.343c-.025-.374-.125-.743-.2-1.165-.729.205-1.215.61-1.685 1.027a501.335 501.335 0 0 0-4.02 3.61c-.2.182-.356.415-.567.666zm14.255-27.195c-1.113-.136-1.573-.114-2.131.055-.34.102-.642.262-.796.596-.405.884-.92 1.724-1.153 2.784.379.062.701.159 1.024.159.769 0 1.44.279 2.034.721.506.377.956.83 1.43 1.252.17.152.257.435.634.361.031-2.063-.232-4.065-1.042-5.928zM9.185 19.698c.165.176.217.274.297.31 1.059.487 2.119.972 3.186 1.44.171.075.38.106.567.096 1.401-.08 2.802-.175 4.276-.27l.462-1.764c1.06-.427 1.693.453 2.452.667 1.686-.682 1.686-.682 1.918-1.95-.287-.02-.569-.065-.848-.055-3.745.144-7.447.747-11.17 1.114-.242.023-.486.06-.718.127-.124.036-.227.15-.422.285zm1.887 58.856c0-.367.03-.657-.006-.94-.146-1.169-.275-2.336-.118-3.516.057-.429-.155-.734-.474-1.01a62.19 62.19 0 0 1-2.173-1.96c-.991-.943-1.954-1.915-2.943-2.859-.154-.147-.382-.215-.61-.338-.42.863-.395 1.706-.477 2.53-.062.619.084 1.162.492 1.636.829.961 1.637 1.94 2.48 2.89.842.948 1.721 1.863 2.572 2.804.293.324.55.683 1.257.763zm4.373-3.986c-.468.56-.713 1.027-1.097 1.265-.384.237-.908.244-1.44.368.119 1.178.088 2.333.446 3.497 2.148-.255 4.218-.648 6.302-.16.139.033.291.008.437.014 2.354.09 4.645-.444 6.946-.802.961-.15 1.913-.335 2.886-.353 1.412-.026 2.826 0 4.239-.031.924-.02 1.85-.067 2.77-.16a59.617 59.617 0 0 0 3.19-.42c2.07-.322 4.14-.658 6.207-1.006.328-.056.748-.115.935-.337.303-.36.49-.84.648-1.297.183-.534.429-1.09.153-1.697-.732-.17-1.403-.048-2.075.04a80.674 80.674 0 0 1-6.843.581c-3.212.145-6.419.409-9.63.57-1.945.099-3.899.191-5.842.114-1.258-.05-2.517-.247-3.784-.237-1.508.013-3.017.034-4.448.05zM5.853 21.292c-.022.298-.112.595-.05.856.196.834.117 1.657.018 2.489-.456 3.803-.962 7.6-1.336 11.412-.21 2.146-.21 4.314-.285 6.473-.108 3.093-.199 6.185-.298 9.278-.002.049-.012.098-.02.146-.335 1.842-.511 3.696-.478 5.572.009.486-.099.976-.158 1.463-.106.878-.233 1.754-.317 2.633-.058.604.124 1.103.529 1.613 1.59 2.002 3.394 3.796 5.237 5.548 1.061 1.009 2.23 1.903 3.368 2.828.158.128.415.133.668.207 0-.494.025-.886-.004-1.273-.082-1.078-.19-2.154-.28-3.23-.111-1.323-.214-2.646-.323-3.968-.15-1.811-.365-3.62-.441-5.434-.152-3.633-.225-7.27-.336-10.904-.063-2.064-.212-4.127-.19-6.19.03-2.603.195-5.204.296-7.807.078-2.012.18-4.025.207-6.039.016-1.128-.108-2.257-.147-3.386-.017-.509-.243-.826-.71-.996-1.007-.368-1.997-.798-3.026-1.093-.58-.166-1.198-.407-1.924-.198zM36.993 3.1c-1.018.87-1.849 1.822-2.66 2.794-.943 1.131-1.729 2.369-2.463 3.646-.472.82-1.114.899-1.786.275-.274-.255-.487-.576-.794-.947-.684 1.337-1.261 2.625-1.703 3.973-.446 1.36-1.087 2.617-1.812 3.849-1.167 1.983-2.274 4.003-2.545 6.362-.063.55-.539.86-1.069.715-.315-.087-.622-.269-.882-.473-.306-.239-.538-.572-.837-.82-.206-.172-.473-.269-.826-.46-.146 1.35-.325 2.55-.175 3.767.354 2.875.725 5.747 1.08 8.621.097.78.184 1.562.24 2.345.055.803-.346 1.195-1.138 1.12-.336-.03-.665-.143-.997-.216-.267-.058-.535-.111-.92-.191.078 1.451.35 2.713.972 3.903.316.604.665 1.219.823 1.872.216.893.667 1.623 1.21 2.32.33.424.67.846 1.047 1.227.917.926 1.595 1.975 1.836 3.283.024.135.123.257.221.452.314 0 .647.005.979 0 .876-.018 1.767-.152 2.624-.036 1.823.247 3.592-.148 5.384-.276.517-.037.958-.235 1.26-.645.678-.923 1.628-1.539 2.46-2.288a188.533 188.533 0 0 0 3.44-3.194c.2-.19.332-.456.471-.651-.067-.167-.092-.264-.142-.346-.077-.124-.182-.231-.258-.356-.492-.813-.48-1.25.083-2.012 1.258-1.703 2.697-3.23 4.384-4.51 2.057-1.561 3.661-3.513 4.93-5.762.714-1.268.93-2.176-1.14-2.193-.72-.006-1.455-.138-2.153-.328-1.006-.274-1.317-.929-.97-1.91a15.9 15.9 0 0 1 .795-1.9c.412-.811.623-1.632.415-2.539-.017-.075.071-.176.138-.328 1.055-.317 1.536-1.127 1.697-2.341-.564-.049-1.035-.102-1.508-.127-.584-.032-1.172-.009-1.752-.068-1.162-.117-1.62-.658-1.606-1.847.004-.294.061-.587.069-.88.024-.884.054-1.768.044-2.651-.006-.483.008-.988-.33-1.422-.137.012-.29-.008-.416.043-.407.163-.807.344-1.202.535-.35.169-.68.392-1.04.536-.9.36-1.544.048-1.815-.87-.068-.232-.07-.484-.096-.728-.188-1.807-.337-3.62-.578-5.419-.11-.818-.389-1.615-.618-2.414-.047-.164-.217-.292-.371-.49zM52.656 70.3a26.865 26.865 0 0 0-.187-2.69 78.326 78.326 0 0 1-.452-4.393c-.142-2.057-.1-4.133-.356-6.173-.241-1.919-.247-3.824-.141-5.732.288-5.199.643-10.394.955-15.592.106-1.765.172-3.533.237-5.3.009-.259.1-.608-.388-.728-.217.41-.447.834-.666 1.264-1.265 2.475-2.87 4.672-5.075 6.39-.23.179-.434.393-.66.579-.504.411-.616.922-.565 1.57.23 2.936.428 5.876.602 8.818.042.723.11 1.47-.156 2.145-.113.087-.181.168-.268.202-2.796 1.098-5.732 1.506-8.696 1.73-1.359.102-2.736-.012-4.087.139-1.841.205-3.663.324-5.525.258-1.936-.068-3.886.188-5.824.365-.544.05-.944-.052-1.308-.438-.346-.367-.59-.767-.623-1.292-.043-.686-.127-1.37-.188-2.055a11.244 11.244 0 0 0-1.37-4.448 13.052 13.052 0 0 1-.912-2.156c-.214-.646-.302-1.333-.46-1.998-.328-1.384-.684-2.761-.993-4.15-.31-1.394-.108-1.67 1.332-1.657.08 0 .161-.087.305-.17.077-.497-.064-1.022-.097-1.552-.08-1.322-.163-2.645-.188-3.969-.008-.48.029-1.034.258-1.427.378-.649.381-1.289.332-1.982-.048-.684-.03-1.374-.065-2.06-.014-.277-.09-.552-.154-.927-.786.051-1.506.107-2.228.144-1.196.062-1.514.375-1.493 1.66.006.393.072.784.09 1.176.032.686.072 1.373.065 2.06-.025 2.699.05 5.402-.307 8.089-.013.097-.006.196-.007.294l-.108 7.365c-.004.246-.014.49-.019.736-.015.833-.048 1.666-.038 2.498.017 1.473.064 2.944.092 4.416.014.688.006 1.376.02 2.063.059 2.654.298 5.294.576 7.934.288 2.734.459 5.48.685 8.222.072.87.118 1.745.431 2.657.591.016 1.12.037 1.647.044 1.51.02 3.044-.139 4.523.084 3.506.527 7.004.196 10.504.128 1.605-.03 3.207-.226 4.81-.351.58-.046 1.167-.19 1.738-.141 1.812.158 3.603-.013 5.39-.254 2.414-.326 4.823-.681 7.232-1.038.568-.084 1.128-.224 1.78-.357zm-28.85-54.348c.174-.261.363-.492.495-.752 1.215-2.4 2.515-4.765 3.142-7.421.1-.425.25-.854.468-1.229.365-.63.802-1.22 1.178-1.78 1.326-.172 1.546.879 2.005 1.78 1.003-1.138 1.925-2.206 2.87-3.253C34.91 2.253 35.88 1.23 36.928.1c.584-.019 1.07.334 1.338.973.59 1.4 1.234 2.785 1.482 4.302.23 1.404.415 2.816.636 4.222.035.226.15.439.258.74.477-.158.878-.306 1.287-.421.467-.131.938-.295 1.416-.334 1.013-.085 1.71.465 1.817 1.489.127 1.219.16 2.448.217 3.674.025.532.004 1.066.004 1.516.503.442 1.02.333 1.49.41.72.119 1.447.202 2.16.352.376.08.751.228 1.086.417.756.428.949 1.075.6 1.873-.078.179-.193.341-.279.518-.083.17-.15.35-.21.492.242.474.625.306.932.293 1.12-.048 1.85.475 2.275 1.491a17.02 17.02 0 0 1 1.177 4.395c.164 1.265.274 2.542.315 3.816.035 1.127-.048 2.258-.099 3.386-.03.687-.114 1.371-.148 2.058-.112 2.256-.19 4.514-.325 6.768-.086 1.42-.31 2.834-.369 4.254-.118 2.847-.214 5.696-.221 8.544-.004 1.367.163 2.742.344 4.101.163 1.224.133 2.448.207 3.67.091 1.516.316 3.022.469 4.534.064.635.112 1.273.128 1.91.01.39-.01.792-.093 1.17-.363 1.646-.634 1.9-2.277 2.18-.667.113-1.34.185-1.944.267-.444.444-.48.947-.564 1.422a12.905 12.905 0 0 1-1.573 4.255c-.375.645-.619.823-1.297.613-.592-.182-1.147-.14-1.727-.054-2.747.407-5.49.836-8.242 1.196-1.01.131-2.042.102-3.064.127-.682.016-1.364-.001-2.046-.006a29.462 29.462 0 0 0-5.95.56c-1.809.356-3.67.49-5.515.601-1.008.06-2.032-.19-3.05-.189-1.017.001-2.036.132-3.052.223-.58.052-1.058-.114-1.42-.687-.243.16-.438.279-.62.414-.257.19-.517.222-.823.12-.56-.19-1.092-.41-1.508-.86-.499-.538-1.022-1.053-1.517-1.595a409.721 409.721 0 0 1-3.348-3.698c-.913-1.022-1.808-2.06-2.71-3.092-.306-.352-.415-.766-.372-1.23.095-1.027.183-2.054.274-3.081.038-.44.07-.881.119-1.32.105-.94-.133-1.716-.882-2.358-.748-.64-1.059-1.495-.932-2.507.152-1.218.278-2.44.392-3.662a51.28 51.28 0 0 0 .194-2.788c.041-1.083.13-2.145.412-3.205.199-.746.195-1.55.258-2.33.056-.684.088-1.37.117-2.054.065-1.52.14-3.042.177-4.563.027-1.08.04-2.164-.013-3.243-.074-1.529.058-3.028.298-4.54.346-2.181.5-4.393.842-6.574.239-1.513.316-3.027.36-4.548.016-.539-.012-1.08-.038-1.619a7.614 7.614 0 0 1 .134-1.895c.162-.807.151-1.652.186-2.482.027-.658.241-.906.857-.895.097.002.197.006.29.029 1.508.373 3 .088 4.502-.07 3.585-.375 7.144-.99 10.75-1.186 1.063-.057 2.117-.273 3.306-.435zM51.968 5.212c-.65.884-.917 1.43-1.05 2.55-.081.67-.081 1.38.053 2.036.137.675.519 1.273 1.267 1.479.456-.161.898-.366 1.363-.47.864-.194 1.45-.715 1.908-1.396-.622-1.435-.617-1.435-.365-3.023.048-.306.042-.622.063-.96-.525.094-.518.513-.694.782-.462.705-1.146.77-1.67.138-.275-.33-.526-.68-.875-1.136zm1.367-1.649c.826-.44 1.671-.912 2.535-1.347.58-.291 1.136-.142 1.655.206.311.208.474.497.423.872-.039.29-.114.576-.185.861-.188.762-.362 1.528-.578 2.282-.237.828-.264 1.57.18 2.396.615 1.145.343 1.827-.616 2.717-.935.866-2.089 1.273-3.255 1.565-1.246.312-2.294-.353-3.145-1.191-1.024-1.007-1.452-2.306-1.394-3.75.077-1.928.753-3.63 1.94-5.136.205-.26.47-.405.759-.285.576.238 1.126.538 1.681.81zm-34.711.408c-.255 1.197-.135 1.98.445 3.04.295.54.558 1.136 1.254 1.243 1.103-1.085 1.157-1.5.256-2.583-.523-.628-1.135-1.174-1.955-1.7zm-1.909-2.71c.86-.37 1.495-.212 2.08.376.963.967 1.954 1.907 2.938 2.852.57.548 1.058 1.163 1.344 1.9.173.446.254.937.318 1.415.054.409-.088.762-.474.994-.291.175-.58.368-.827.6-.604.565-1.325.624-2.048.428-.957-.26-1.809-.761-2.318-1.656-.632-1.111-1.129-2.272-1.057-3.61.057-1.068-.19-2.142.044-3.3zm25.017 59.708c-.478.028-1.056.057-1.633.096-.727.05-1.453.154-2.18.155-1.655.002-3.31-.031-4.951.245-.238.04-.486.031-.728.03-.475-.002-.842-.163-1.031-.652-.198-.51-.122-.97.204-1.378.111-.14.308-.242.485-.29.231-.063.481-.07.724-.076 1.7-.044 3.402-.096 5.103-.117 1.362-.016 2.715-.095 4.128-.325.092-.4.153-.775.265-1.135.288-.929.713-1.236 1.7-1.268 1.168-.037 2.335-.084 3.503-.106 1.1-.021 1.562.288 1.668 1.395.103 1.063.021 2.15-.046 3.221-.016.242-.26.589-.48.675-.58.228-1.2.404-1.817.481-.864.108-1.747.06-2.61.168-.86.108-1.537-.064-1.975-.87-.041-.076-.149-.116-.33-.25zm-24.56 6.976c.016-.399.117-.851.573-1.168.662-.46 1.225-.46 1.84.062.377.32.668.7.798 1.195.171.648.064.963-.491 1.378-.27.2-.529.417-.803.611-.55.388-1.12.273-1.5-.302-.332-.506-.463-1.068-.416-1.776zm14.455-28.741c.292-.176.583-.345.868-.525.743-.47 1.497-.922 2.216-1.427.255-.18.419-.491.586-.695-.305-.863-1.128-1.397-.953-2.308.93-.457 1.809-.862 2.662-1.314.773-.41 1.525-.863 2.277-1.31.537-.32 1.091-.635 1.304-1.384-.52-.503-1.19-.69-1.782-.998-.64-.334-1.118-.77-1.277-1.637.322-.56.678-1.197 1.053-1.824.403-.674.84-1.326 1.228-2.007.25-.436.376-.904-.092-1.412l-2.12.397c-.67.124-1.337.278-2.012.361-.576.07-1.064-.136-1.32-.71-.257-.572-.499-1.153-.783-1.815-.21.238-.445.417-.563.656-.304.613-.56 1.252-.827 1.883-.286.678-.493 1.4-.857 2.03-.835 1.441-1.733 2.845-2.633 4.246-.145.226-.419.387-.662.526-.2.114-.443.151-.627.21-.226.674-.068 1.236.041 1.817.464 2.46.903 4.924 1.334 7.39.137.78.086 1.557-.136 2.335l-1.496.751c.264.812.449 1.606 1.266 2.034 1.511-.85 3.089-1.508 4.178-2.947-.362-.724-1.055-1.269-.873-2.323zM35.99 21.08c.667.236 1.241.045 1.817 0 .97-.077 1.94-.168 2.913-.216.333-.016.684.038 1.004.137.43.134.7.564.66 1.031-.035.387-.082.796-.236 1.143-.377.849-.818 1.668-1.235 2.498-.345.686-.941 1.252-1.034 2.144.377.237.753.453 1.106.701.6.42 1.215.824 1.766 1.302.461.4.485.84.138 1.308-.738.994-1.615 1.82-2.75 2.367-1.047.505-2.055 1.092-3.139 1.674.068.382.112.709.186 1.028.066.286.176.561.246.846.118.483-.024.865-.456 1.132-.665.411-1.33.821-1.984 1.25-.744.489-.833.741-.62 1.596.394 1.587.398 1.592-.864 2.534-1.134.846-2.251 1.721-3.432 2.497-.421.276-1.027.25-1.515.447-.76.307-1.326.048-1.832-.497-.166-.178-.34-.36-.456-.571-.751-1.378-1.488-2.765-1.965-4.271-.22-.698-.008-1.025.704-1.123.522-.072 1.048-.114 1.634-.175.043-.36.133-.646.1-.916-.259-2.142-.382-4.296-.919-6.408-.397-1.563-.438-3.198-.381-4.769.524-.703 1.236-.185 1.887-.412a6.173 6.173 0 0 1 1.304-1.455c.711-.58 1.287-1.33 1.609-2.242.932-2.64 2.108-5.17 3.401-7.648.203-.388.355-.803.507-1.215.203-.552.55-.8 1.076-.736.4.049.846.438.89.86.035.335-.003.684-.046 1.022-.12.926-.288 1.846-.38 2.774-.076.775-.178 1.571.296 2.363z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'macOs':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '49',
	            height: '35',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'macOs'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h49v35H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M42.643 8.26l.22.015-.051.308a18.372 18.372 0 0 0-.17-.323zM15.735 24.996l-.742-.4 1.687-.034c-.317.141-.632.286-.945.434zM46.492 5.79c-.237-.367-.626-.763-1.078-.83-2.003-.293-4.008-.435-6.032-.345a2.19 2.19 0 0 0-.244.024 1.652 1.652 0 0 0-1.183-.452c-.977.044-1.804.793-1.804 1.805l.001 10.95v1.503l.001.119c-.657-.18-1.318-.172-1.981-.03-.673.144-1.31.52-1.81.986-.457.427-.58 1.025-.625 1.632a22.52 22.52 0 0 0-.951-4.184c-.036-.11-.074-.218-.112-.327.572.146 1.135.324 1.688.535 1.037.396 2.386-.637 2.283-1.74a66.067 66.067 0 0 1-.222-9.137c.03-.662-.406-1.304-.994-1.613a1.55 1.55 0 0 0-.662-.347c-.495-.113-.933-.037-1.39.182-.22.106-.443.206-.667.304-1.72.696-3.524 1.145-5.36 1.41-3.307.409-6.655.266-9.969-.009-.977-.081-1.953-.174-2.928-.27l-.48.065c-.235.056-.44.164-.613.323-.298.23-.56.56-.647.938a2.152 2.152 0 0 0 0 .96c.09.39.458.905.83 1.078.529.246 1.066.469 1.61.67l-3.536.671c-.375.071-.714.358-.937.647-.235.304-.405.698-.387 1.093.036.821.54 1.487 1.324 1.74.819.265 1.643.508 2.473.73a64.97 64.97 0 0 1-1.559.234c-.626.082-1.253.16-1.88.238-.413.05-.753.124-1.093.387-.298.23-.56.56-.647.938-.173.763.108 1.647.83 2.037.647.35 1.31.668 1.985.953l-3.48.789c-.693.157-1.202.827-1.292 1.5-.093.689.226 1.456.86 1.798l3.378 1.822a37.257 37.257 0 0 1-1.575-.05c-1.102-.06-2.137 1.21-1.739 2.283.302.815.69 1.49 1.262 2.146.44.505.995.93 1.564 1.279 1.09.667 2.363 1.077 3.622 1.276 1.495.237 2.983.267 4.491.154a27.625 27.625 0 0 0 5.221-.883c1.626-.445 3.192-1.144 4.861-1.42.36-.035.721-.044 1.082-.016.219.043.433.1.643.174l.052.026c.529.265 1.054.323 1.605.09.496-.209.918-.626 1.044-1.169.236-1.015.402-2.046.5-3.085.082.825.193 1.648.331 2.468l.182.43c.113.21.268.38.465.507.313.242.687.39 1.093.387.924-.003 1.847.051 2.764.162.97.143 1.926.348 2.869.618.942.269 1.953-.329 2.218-1.26a188.497 188.497 0 0 0 4.926-22.504c.074-.474.094-.964-.181-1.39z',
	            fill: '#A1CBFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M44.254 5.806a14.364 14.364 0 0 0-7.057-1.188c-.427.037-.806.152-1.118.466-.274.276-.48.73-.463 1.126.01.225.07.455.17.668a1.94 1.94 0 0 0-.64 1.212c-.089.667.02 1.373.059 2.044a565.467 565.467 0 0 0 .375 5.84c.064.914.13 1.827.198 2.74a13.302 13.302 0 0 1-1.894-.458c-.477-.154-.994-.014-1.377.285-.416.323-.578.733-.623 1.25l-.734 8.388c-.032.37.197.88.463 1.126.32.296.682.44 1.118.467.357.022.712.055 1.067.098a17.667 17.667 0 0 1 4.037 1.1l.078.032.029.013c.496.22.98.463 1.455.727a1.594 1.594 0 0 0 1.595 0c.525-.31.714-.798.783-1.375.029-.241.06-.483.092-.724a67.868 67.868 0 0 1 2.697-11.777c.622-1.909 1.35-3.803 1.624-5.804.294-2.141.4-5.21-1.934-6.256z',
	            fill: '#9A9AFF'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M4.869 2.294c.686.398 1.357.812 1.925 1.38.23.23.504.135.766.042l.046-.016c.26-.09.28-.324.295-.532.052-.73-.15-1.357-.795-1.78l-.195-.127-.03-.02a22.488 22.488 0 0 1-.453-.298 6.046 6.046 0 0 0-.185-.12C6.073.717 5.904.61 5.777.467c-.248-.28-.554-.38-.93-.467l-.098.154-.005.008a8.493 8.493 0 0 0-.176.285c-.242.417-.115 1.428.222 1.774l.016.017c.02.021.039.042.063.056zm41.483 5.647l.06-.19c.099-.307.046-.497-.16-.725-.748-.828-1.617-1.436-2.734-1.645-.27-.05-.54-.114-.808-.179l-.249-.059c-1.765-.413-3.549-.37-5.334-.198-.644.062-.76.214-.773.873-.004.192.002.383.01.575v.005c.006.205.014.41.007.614a91.108 91.108 0 0 1-.07 1.644c-.066 1.35-.131 2.699-.049 4.05.037.61.055 1.223.074 1.835.039 1.303.078 2.606.297 3.899.092.542-.123 1.058-.899 1.056-.302-.001-.608-.046-.904-.11a17.736 17.736 0 0 1-.79-.196h-.001l-.009-.002-.01-.003c-.22-.058-.44-.116-.662-.168-.51-.119-.632-.042-.687.457-.082.738-.15 1.477-.202 2.218-.01.153.012.308.036.468v.005c.011.073.022.147.03.221.114.013.225.024.334.035h.006l.014.002.023.002.037.004h.006l.006.001.008.001.01.001c.294.03.572.058.847.099.196.029.393.053.59.077.541.067 1.083.133 1.592.3.696.227 1.371.584 1.978.998.848.578 1.5 1.346 1.642 2.43.045.34-.141.753-.4.878-.326.158-.825.095-1.06-.133-.099-.098-.195-.199-.291-.3l-.008-.007a5.42 5.42 0 0 0-.667-.627c-1.325-.987-2.815-1.444-4.473-1.291-.375.034-.443.086-.46.456-.06 1.284-.112 2.568-.163 3.852-.003.069.007.138.02.226.007.047.015.1.021.16l.183.04.014.004c.128.03.245.057.363.075l.05.006c.858.125 1.718.25 2.578.362 1.744.229 3.463.534 5.027 1.411.349.196.497.092.57-.348.05-.303.094-.608.138-.913v-.004l.001-.004v-.003l.001-.004v-.003l.001-.004v-.004c.082-.564.164-1.127.286-1.681.543-2.477 1.117-4.946 1.69-7.415.182-.783.373-1.565.563-2.346l.002-.008.007-.028c.171-.702.342-1.404.507-2.107.148-.633.29-1.268.432-1.902l.001-.003c.241-1.079.483-2.157.755-3.227.3-1.18.673-2.343 1.046-3.503zm1.87-1.459c.213.119.401.298.572.477.243.256.25.532.131.884-.477 1.425-.951 2.853-1.344 4.303a63.814 63.814 0 0 0-.732 3.105l-.005.024-.005.024-.005.023-.006.024-.005.024-.005.024-.005.024-.005.023c-.072.33-.145.661-.22.991-.105.467-.206.936-.308 1.404l-.005.022a106.85 106.85 0 0 1-.563 2.494 99.462 99.462 0 0 1-1.11 4.254c-.33 1.143-.552 2.307-.774 3.471l-.012.06-.074.388c-.144.75-.257 1.507-.37 2.263-.07.478-.142.956-.221 1.433-.037.217-.1.428-.165.64l-.002.006-.001.004-.001.004c-.029.093-.057.186-.083.28l-.83.103-.128 1.035-.233.117a7.348 7.348 0 0 1-.548.261c-.09.037-.215.018-.313-.012a.45.45 0 0 1-.214-.16c-.832-1.138-2.085-1.543-3.356-1.804-1.624-.334-3.273-.566-4.92-.764-1.976-.237-3.929.063-5.865.442-.903.177-1.801.38-2.694.602a85.088 85.088 0 0 0-3.025.818c-.195.056-.38.143-.567.23h-.002l-.004.002a5.834 5.834 0 0 1-.368.162c-.754.291-1.546.414-2.336.537-.207.032-.414.064-.62.1-.838.142-1.69.24-2.533.127a21.546 21.546 0 0 1-2.65-.522 15.522 15.522 0 0 1-2.3-.801c-1.111-.492-2.11-1.171-2.873-2.143l-.077-.096c-.285-.362-.576-.73-.774-1.14a2.1 2.1 0 0 1-.19-1.094c.068-.617.923-.876 1.39-.453.185.168.354.364.494.571.709 1.052 1.61 1.835 2.841 2.23.311.1.614.222.918.343l.002.001h.001c.533.214 1.065.427 1.64.525 1.057.18 2.107.185 3.18.108 1.36-.098 2.636-.499 3.913-.9l.008-.003a37.464 37.464 0 0 1 1.738-.516c.237-.062.468-.147.7-.232h.002v-.001h.003l.001-.001h.001l.001-.001c.241-.09.483-.178.73-.24.593-.148 1.194-.261 1.795-.375h.004l.32-.062c.46-.088.923-.16 1.387-.229.6-.088 1.203-.17 1.805-.253l.018-.002.535-.074c.035-.005.07-.007.106-.009h.004c.036-.002.07-.004.106-.009.6-.085.637-.168.622-.768-.008-.327.016-.654.04-.982v-.002c.014-.195.028-.39.035-.583.024-.598.036-1.195.047-1.793.001-.095-.01-.19-.023-.293v-.002l-.018-.155a1.187 1.187 0 0 1-.101-.017c-.064-.012-.122-.023-.171-.007-.15.049-.3.096-.45.142l-.019.006c-.672.209-1.345.418-1.934.822a6.49 6.49 0 0 0-.943.807c-.68.694-1.234.537-1.6-.244-.328-.7-.293-1.094.22-1.672.666-.751 1.519-1.232 2.414-1.618.81-.349 1.657-.614 2.5-.876.292-.09.438-.214.435-.516l-.004-.329c-.005-.36-.01-.719.005-1.078.01-.28.035-.56.058-.84v-.003l.001-.005c.019-.222.038-.444.05-.667a6.27 6.27 0 0 1 .01-.141c.023-.276.045-.554-.152-.8-.035-.045-.026-.136-.016-.203.09-.631.615-1.017 1.252-.914.148.023.295.052.442.08l.008.002.008.001a12.012 12.012 0 0 0 .582.102c.188.029.38.059.559.027.224-.04.41-.03.624.055.312.123.438.03.46-.3a3.418 3.418 0 0 0-.005-.411v-.002a7.573 7.573 0 0 1-.009-.184c-.016-.517-.035-1.033-.054-1.55v-.002a101.742 101.742 0 0 1-.09-3.608c-.002-.883.05-1.767.1-2.651.024-.419.049-.837.067-1.256.024-.541.043-1.083-.13-1.67a5.447 5.447 0 0 1-.123.005h-.001l-.016.001h-.015l-.003.001H33.766c-.1.005-.197.009-.292.025-2.524.434-5.003 1.061-7.483 1.688l-.335.085c-.645.163-1.305.283-1.965.378-1.787.258-3.578.514-5.389.504-1.61-.01-3.22-.072-4.766-.591-1.365-.459-2.64-1.095-3.651-2.158-.441-.462-.808-.976-.842-1.655-.013-.28-.021-.545.273-.708.304-.169.612-.205.924-.047.11.055.221.136.295.233.703.922 1.72 1.365 2.74 1.78 1.721.702 3.54.898 5.373.798 1.382-.076 2.76-.244 4.136-.412l.007-.001.01-.002.015-.001.146-.018.016-.002.516-.063c.341-.04.675-.131 1.01-.221h.001c.173-.047.345-.094.519-.134.666-.153 1.33-.312 1.996-.472 1.548-.37 3.097-.742 4.66-1.035 2.553-.479 5.117-.94 7.737-.91 1.276.014 2.51.271 3.746.541l.13.031.01.003c.112.028.224.056.337.065 1.32.11 2.308.888 3.261 1.69.305.257.53.613.752.962l.128.2c.122.188.239.335.44.447zm-27.857 5.136c.283.601.062 1.067-.553 1.308-.472.185-.939.212-1.43.16-.173-.02-.347-.024-.521-.029H17.82l-.004-.001h-.024c-.182-.005-.364-.01-.544-.03a24.404 24.404 0 0 1-1.924-.272 46.732 46.732 0 0 1-2.062-.468l-.363-.088c-1.182-.285-2.316-.71-3.326-1.385-.562-.376-1.073-.832-1.58-1.285l-.216-.191c-.294-.26-.405-.632-.398-1.03.001-.108 0-.217-.017-.322-.064-.394.066-.785.308-.9.234-.113.77.01 1.011.214l.267.226.034.03c.435.37.87.74 1.32 1.092.861.671 1.89.962 2.92 1.242 1.553.421 3.126.72 4.741.751l.051.003h.005a.436.436 0 0 0 .106 0c.62-.098 1.235-.146 1.887.27l.094.185.005.01.003.007.005.008v.001c.077.151.164.322.245.494zm-2.118 4.667c-.04.508-.322.79-.841.76a38.049 38.049 0 0 1-1.996-.16c-1.256-.141-2.505-.326-3.725-.664-1.276-.353-2.494-.85-3.59-1.6-.636-.435-1.154-1.012-1.353-1.772-.097-.37-.076-.777-.056-1.17l.006-.118c.005-.108.08-.214.15-.31.028-.04.056-.08.077-.116.483-.017.773.191 1.003.524.411.595.983.99 1.613 1.33 1.829.986 3.796 1.448 5.848 1.606.2.015.4.021.6.027.251.007.502.015.75.04.215.023.427.079.639.135h.003c.083.023.166.044.25.064.033.008.077.03.089.056.059.13.132.254.206.378.179.301.357.602.327.99zm-3.911 5.883c.2-.008.532-.183.56-.327a3.09 3.09 0 0 0-.026-1.147c-.032-.166-.132-.32-.25-.5l-.001-.002a5.269 5.269 0 0 1-.18-.288l-.449-.04-.006-.002c-.358-.033-.74-.07-1.124-.082-1.039-.035-2.042-.212-2.98-.675-.996-.493-1.825-1.198-2.523-2.062a2.462 2.462 0 0 0-.18-.203c-.201-.198-.601-.296-.79-.196-.238.125-.356.407-.316.743.006.046.014.093.023.14.022.118.043.236.018.341-.099.404.073.691.308.989.636.804 1.43 1.43 2.254 2.015.348.246.745.454 1.151.578.471.146.951.26 1.432.375l.004.001c.308.074.616.148.922.23.645.171 1.299.145 1.95.12h.004l.199-.008zm-2.655 2.815l.033.012.628.22.027.009.005.001.004.002c.06.02.125.04.155.082.356.504.696 1.02.617 1.682-.046.383-.168.506-.533.579a1.72 1.72 0 0 1-.25.028c-.084 0-.153.004-.211.007h-.005a.602.602 0 0 1-.233-.012c-.634-.23-1.265-.469-1.897-.708l-.228-.086c-.042-.016-.083-.037-.124-.059a.875.875 0 0 0-.17-.073c-.906-.243-1.682-.748-2.452-1.252-.584-.382-.983-.951-1.302-1.566-.204-.394-.162-.826-.122-1.243l.018-.199c.016-.187.29-.445.494-.503.293-.084.59.053.803.328.253.327.526.64.806.944.529.573 1.214.876 1.938 1.118.668.223 1.333.456 1.999.69zM3.04 11.904c.529.286.996-.003 1.021-.602.002-.04.002-.08.001-.108v-.028c.031-.69-.079-1.01-.623-1.351-.738-.461-1.5-.881-2.263-1.301l-.22-.12c-.252-.14-.49-.064-.674.15-.24.277-.342.599-.247.953.127.476.33.904.796 1.16.343.188.682.383 1.021.579.394.226.788.453 1.188.668zm1.141 14.72c.027.068.054.138.032.18-.124.234-.026.42.07.601v.002c.025.048.05.096.07.144-.345.596-.799.738-1.345.369-.568-.383-1.143-.774-1.634-1.247-.57-.549-.813-1.275-.71-2.08.03-.246.12-.503.39-.61.19-.076.641.08.763.285.366.61.918 1.016 1.469 1.42.103.076.206.152.307.229l.05.037c.216.162.428.321.512.598l.026.072zM1.31 16.708l.036.021c.379.218.762.438 1.169.587.296.108.612.162.927.216h.004c.09.015.182.03.272.047.305.057.494-.117.55-.391.028-.142.024-.29.02-.438v-.003a3.553 3.553 0 0 1-.002-.249c.022-.518-.228-.817-.697-1.026-.405-.18-.797-.387-1.189-.594h-.001l-.001-.001-.001-.001a33.27 33.27 0 0 0-.685-.356 5.475 5.475 0 0 0-.472-.2l-.017-.007c-.076-.03-.155-.06-.236-.093l-.084.143a3.77 3.77 0 0 1-.099.164c-.501.773-.288 1.726.506 2.181zm4.017-11.39c.576.253.813.672.783 1.213.017.802-.485 1.18-1.166.9l-.199-.082c-.6-.245-1.209-.493-1.751-.838-.787-.5-.876-1.243-.505-2.03.098-.206.273-.285.49-.24.158.034.318.076.461.146.236.114.47.234.702.353.392.2.783.401 1.185.578zm-3.37 16.371c-.164-.117-.33-.236-.507-.331-.64-.345-.757-.965-.854-1.598-.048-.31.12-.522.29-.733.04-.052.082-.104.12-.157.42-.066.695.081.974.323.394.34.829.639 1.268.922.62.402.765 1.026.795 1.683.023.512-.763.81-1.266.493a6.447 6.447 0 0 1-.488-.353c-.098-.075-.196-.151-.297-.223l-.035-.026zm26.664-6.441c.39-.035.428-.002.472-.394.114-1.004.205-2.01.292-2.879 0-.535.004-.932-.002-1.33-.004-.297-.144-.502-.415-.642a2.714 2.714 0 0 0-1.25-.29c-.416-.003-.687.3-.709.723-.043.829-.116 1.657-.133 2.486-.01.446-.028.935.134 1.332.275.675.813 1.064 1.61.994zm12.076-4.345c-.396-.222-.832-.227-1.26-.235-.322-.006-.577.286-.636.618-.123.693-.252 1.386-.377 2.078-.105.586-.206 1.172-.315 1.794.04.115.045.296.137.368.39.303.663.75 1.177.908.529.164.846.043.972-.496a33.66 33.66 0 0 0 .361-1.859c.138-.782.27-1.566.383-2.352.065-.446-.047-.602-.442-.824z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'pizza':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '59',
	            height: '100',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'pizza'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h59v100H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M55.315 89.91a8.34 8.34 0 0 1 .504 1.77c.234 1.392.203 2.787.173 4.186a50.598 50.598 0 0 0-.018 1.845c.008.54-.417.99-.936 1.059-.561.075-.997-.264-1.185-.772l-.987-2.666-1.716-4.635-.44-1.19-.044-.115c-.046-.126-.092-.252-.14-.378l-.032-.078a2.345 2.345 0 0 1-.041-.102l-.016-.035a4.624 4.624 0 0 0-.219-.424 3.54 3.54 0 0 0-.117-.186l-.015-.023c-.041-.046-.082-.093-.127-.136a.483.483 0 0 0-.022-.02l-.005-.005c-.053-.024-.104-.058-.156-.091a1.192 1.192 0 0 0-.175-.1c-.238-.101-.392-.314-.468-.556a1.593 1.593 0 0 1-.495-.141c.174.074.132.057.058.026l-.13-.052a9.213 9.213 0 0 0-1.864-.498l-.058-.01-.015-.002-.015-.002a9.729 9.729 0 0 0-2.284.002 10.4 10.4 0 0 0-1.913.487 9.677 9.677 0 0 0-.266.102l-.022.01-.014.006a9.534 9.534 0 0 0-1.283.698c-.345.223-.702.434-1.101.547-.343.097-.693.1-1.044.105-.103 0-.206.002-.31.005-.046.002-.092.006-.138.01l-.04.002-.008.002-.015.002a3.332 3.332 0 0 0-.538.152l-.035.013-.006.003a3.332 3.332 0 0 0-.416.237.617.617 0 0 0-.065.053l.036-.038c-.024.025-.05.047-.078.069-.02.016-.04.032-.058.05-.044.04-.085.089-.126.138a1.44 1.44 0 0 1-.135.145l-.03.047a2.464 2.464 0 0 0-.107.188 1.701 1.701 0 0 0-.052.145c-.01.032-.016.066-.022.1-.006.032-.012.064-.02.094l-.001.01-.002.021c-.006.148.002.296.01.444l.004.08a4.02 4.02 0 0 1-.146 1.326 18.71 18.71 0 0 1-.384 1.134c.035 1.439-.245 2.887-.557 4.283l-.025.11c-.09.416-.188.862-.52 1.158-.605.54-1.587.466-2.016-.264-.419-.713-.199-1.572 0-2.346.03-.118.06-.234.087-.348a31.675 31.675 0 0 1 .856-2.95 8.015 8.015 0 0 0-.027-.34l-.002-.015a.452.452 0 0 0-.005-.05l-.006-.04a.556.556 0 0 1-.003-.032l.001.022a6.492 6.492 0 0 0-.135-.642 5.813 5.813 0 0 0-.159-.504c-.017-.047-.073-.16-.072-.16l.063.122a1.728 1.728 0 0 1-.051-.112 5.517 5.517 0 0 0-.523-.898l-.017-.02-.03-.037a5.164 5.164 0 0 0-.657-.653l-.013-.01a.82.82 0 0 1-.082-.063 5.954 5.954 0 0 0-1.012-.587l-.02-.01-.06-.023a6.212 6.212 0 0 0-.732-.23 6.944 6.944 0 0 0-.478-.096l-.017-.002a8.098 8.098 0 0 0-1.364-.011c-.203.014-.406.035-.608.06l-.091.01-.11.017-.12.017c-.208.031-.416.065-.625.098l-.549.087c-.82.125-1.648.237-2.48.216a1.1 1.1 0 0 1-1.08-1.079 6.664 6.664 0 0 0-.034-.558l-.005-.047v-.004a7.946 7.946 0 0 0-.178-.8 8.488 8.488 0 0 0-.263-.779 12.688 12.688 0 0 1-.031-.08c.037.1.019.054-.003 0l-.032-.08a13.885 13.885 0 0 0-.537-1.064c-.328-.412-.63-.845-.9-1.296a33.938 33.938 0 0 0-5.147-5.003c-.415-.326-.382-1.007-.1-1.394l-.013-.008a6.748 6.748 0 0 0-.247-.118h-.001l-.033-.014-.056-.022a6.576 6.576 0 0 0-1.152-.325c-.55-.103-.833-.666-.775-1.179l-.051-.01a7.943 7.943 0 0 1-.088-.018c-.361-.08-.658-.406-.754-.754a.984.984 0 0 1 .004-.557 7.307 7.307 0 0 0-.798-1.356.798.798 0 0 0-.002-.002l-.003-.005a.524.524 0 0 0-.03-.037l-.022-.027a7.665 7.665 0 0 0-1.103-1.106l-.02-.015c.034.025.04.024-.042-.037l-.017-.013-.004-.002a7.586 7.586 0 0 0-1.212-.728c-.725-.35-.684-1.501 0-1.862l.099-.05.053-.027c.108-.08.23-.14.358-.176a12.062 12.062 0 0 1 4.77-1.141.972.972 0 0 1 .792.356c.244-.283.559-.37.931-.38.261-.006.522-.01.782-.01 1.329 0 2.773.19 3.927.878.09-.082.183-.16.28-.232.492-.368 1.088-.52 1.69-.578.546-.053 1.098.027 1.639.105l.153.022c.168.023.335.05.501.078a.91.91 0 0 1 .45-.094c.371.023.74.064 1.108.113 1.4.188 2.757.576 4.063 1.113 1.336.549 2.68 1.161 3.75 2.156.364.34.68.726.994 1.111.105.13.21.258.318.385.2.24.409.473.635.689a6.2 6.2 0 0 0 .342.3l.009.008c.025.017.05.036.074.054l.06.045a6.509 6.509 0 0 0 1.07.612l.015.007a2.615 2.615 0 0 1 .147.059 6.935 6.935 0 0 0 1.222.337l.095.016.078.013a6.935 6.935 0 0 0 1.484.007l.084-.015c.218-.04.434-.079.65-.137a6.248 6.248 0 0 0 .617-.203l.035-.015.013-.005.067-.031c.31-.142.625-.285.952-.38a2.95 2.95 0 0 1 1.337-.062c.737.124 1.38.612 1.914 1.106 2.007 1.858 3.59 4.161 5.13 6.403l.02.031c.775 1.127 1.513 2.265 1.988 3.555.16.434.277.889.34 1.35a.852.852 0 0 1 .167.227c.615 1.234.97 2.59.995 3.964zm-34.96-14.832c.713-.37 1.305-.949 1.755-1.608a4.294 4.294 0 0 0 .736-2.379 8.22 8.22 0 0 0 .754-1.369c.08-.19.135-.376.139-.563l.032.003.063.007.064.008.013.001.013.002.013.001.012.002.006.001c.195.046.393.076.591.106h.003c.205.031.41.062.61.11a7.284 7.284 0 0 1 .843.253h.002l.002.001c.016.005.033.01.05.017.014.01.029.018.043.025a4.399 4.399 0 0 1 .658.38l-.028-.026.045.037.023.016c.024.017.05.041.057.051a4.174 4.174 0 0 1 .465.472l.049.064a.329.329 0 0 0-.016-.024l.007.01c.183.254.33.526.465.808l.004.01.017.042a5.02 5.02 0 0 1 .265 1.02 5.093 5.093 0 0 1 .013.905l-.007.072v.007l-.002.008v.008l-.006.054-.005.025v.006l-.001.002-.02.119a6.052 6.052 0 0 1-.298.98 6.059 6.059 0 0 1-.375.689c-.074.116-.153.228-.233.34l-.04.056a6.895 6.895 0 0 1-.972.985l-.076.063-.004.003a3.341 3.341 0 0 0-.1.08c.131-.111.123-.105.079-.069h-.001c-.036.03-.095.078-.124.099a7.396 7.396 0 0 1-.734.46c-.368.048-.743.069-1.112.085a14.917 14.917 0 0 1-2.298-.08 8.945 8.945 0 0 1-.472-.922l-.025-.056-.022-.048c-.028-.063-.03-.066-.021-.045-.05-.114-.094-.231-.138-.347v-.004l-.046-.118c-.154-.4-.453-.698-.851-.766l.136-.069zm3.638-5.89l-.037-.004c.07.014.17.02.037.004zm-3.588 10.046a1.02 1.02 0 0 1-.06.015c.157.158.31.318.464.48a6.667 6.667 0 0 1-.404-.495zm5.662 7.146l.05-.008.767-.12-.205.022-.051.006-.017.003a5.46 5.46 0 0 1-.07.011l-.01.002-.01.001-.067.01c-.13.022-.258.048-.387.073zm8.47 2.054l-.175-.088c.104.12.203.243.297.369.03-.067.064-.133.098-.197a1.248 1.248 0 0 1-.22-.084zm-9.734-1.982v-.005l-.009-.042a1.876 1.876 0 0 0 .631.072l-.128.015a11.992 11.992 0 0 1-.477.048 4.16 4.16 0 0 0-.017-.088zm-4.38-16.155a.893.893 0 0 1-.15.543l-.046.065c.114-.115.224-.234.331-.356a3.873 3.873 0 0 1-.055-.105c-.026-.05-.052-.099-.08-.147zm27.11 8.243l.148.187.04.052c.093.117.183.237.273.357l.051.069c.383.51.755 1.028 1.121 1.55l.324.46.323.457c-.315.112-.562.371-.691.725a4.73 4.73 0 0 0-.273 1.304l-.006.022a.667.667 0 0 1-.025.071v.002l-.002.004a3.176 3.176 0 0 0-.055.108c-.03.06-.059.12-.095.178-.014.023-.03.045-.046.067v.001l-.004.005a2 2 0 0 0-.024.026l-.001.001-.001.001-.001.001a1.113 1.113 0 0 1-.036.039c-.01.01-.036.032-.06.052l-.03.027a1.292 1.292 0 0 1-.04.026c-.013.008-.04.022-.069.035l-.003.002-.002.001-.038.02a2.707 2.707 0 0 1-.093.03c-.026.007-.054.01-.082.015h-.003l-.067.013h-.006l-.018.002a2.577 2.577 0 0 1-.205 0c-.016 0-.058-.004-.098-.008l-.054-.004-.022-.004-.005-.001a4.096 4.096 0 0 1-.294-.067 4.753 4.753 0 0 1-.474-.158l-.002-.001h-.001l-.045-.02a11.054 11.054 0 0 1-.544-.274 64.549 64.549 0 0 1-.215-.116c-.206-.111-.41-.222-.62-.326-.755-.377-1.555-.674-2.412-.65a1.11 1.11 0 0 0-.687.256 3.794 3.794 0 0 1-.076-.152l-.001-.003-.005-.011a8.728 8.728 0 0 1-.155-.448l-.028-.091-.001-.006-.024-.079.017-.043.037-.097.088-.223a1.11 1.11 0 0 1 .025-.051c.034-.07.089-.18.081-.205l.017-.037a14.812 14.812 0 0 1 .34-.72c.287-.568.618-1.11.997-1.623l.028-.034a8.5 8.5 0 0 1 .457-.522 7.72 7.72 0 0 1 .655-.614l.043-.036.018-.014.072-.054.004-.003h.001l.08-.06a6.402 6.402 0 0 1 .852-.507c.035-.017.07-.033.106-.048h.001l.001-.001h.001v-.001h.002c.031-.014.063-.028.093-.043l.033-.012.075-.029c.074-.027.145-.061.213-.101a27.161 27.161 0 0 1 1.122 1.331zm3.466 5.577c.19.04.368.133.5.286l-.01-.017-.023-.048a13.18 13.18 0 0 0-.374-.7 6.834 6.834 0 0 1-.093.4v.079zm-25.348.153h-.001l-.017.004-.003-.014a8.06 8.06 0 0 1-.024-.109l-.004-.018.047.018.052.02c.054.022.109.042.164.06l-.024.005a7.82 7.82 0 0 0-.179.032l-.01.002zm-.26.082h.002l.027-.01c.068-.035.06-.096-.077.019H25.352l.011-.002h.007l.021-.007zm8.219.67c-.174-.134-.508-.173-.742-.13l-.034-.026a9.572 9.572 0 0 1-.096-.071l-.074-.056-.067-.053a18.348 18.348 0 0 1-.57-.47 18.361 18.361 0 0 1-2.044-2.06c.186-.528.398-1.047.61-1.565l.032-.079c.487-1.193.944-2.398 1.116-3.671.353.045.748-.16.954-.417.56-.019 1.118-.06 1.675-.128.248-.03.451-.074.654-.231.169-.13.317-.313.377-.523l.038.013.048.015c.044.286.215.543.462.744 0 .005.06.051.1.082l.002.002.002.002h.001l.028.022a6.548 6.548 0 0 1 .847.847l.035.043.01.011v-.004.005l.043.051c.094.114-.03-.012-.042-.049.01.043.153.234.254.369v.001c.047.062.085.113.096.13a7.088 7.088 0 0 1 .46.856c.042.15.093.297.143.444v.001l.001.002v.001l.001.002v.001l.001.002v.001c.077.22.154.442.205.673a6.822 6.822 0 0 1 .066.347l.002.016.001-.002v.004l.012.073c.007.045.003.065-.004.064l.006.034a.983.983 0 0 1 .014.091 6.513 6.513 0 0 1-.012 1.164c0 .007-.003.019-.005.032a.467.467 0 0 0-.01.096 6.958 6.958 0 0 1-.387 1.41.657.657 0 0 1-.048.087l.038-.056c.058-.086.043-.06.017-.018l-.001.002a1.215 1.215 0 0 0-.044.076 7.117 7.117 0 0 1-.623 1.103l-.031.042-.005.006c-.031.04-.074.095-.105.138.033-.038.065-.066.003.008l-.038.046-.002.004c-.002.003-.003.005-.002.006v-.004l-.005.005-.084.102a6.848 6.848 0 0 1-.698.705l-.103.085-.002.002-.012.01h-.002l-.002.003-.003.002c-.092.075-.172.14-.004.011-.233.18-.414.35-.496.645a1.012 1.012 0 0 0-.03.176 3.483 3.483 0 0 1-.254-.075l-.004-.002h-.002l-.003-.002-.003-.002h-.003a3.773 3.773 0 0 1-.214-.11l-1.444-1.111zm7.145-6.723l-.007.01c.109-.085.114-.132.086-.118l-.008.01-.01.012c-.008.008-.015.02-.024.033l-.001.002c-.011.016-.023.035-.036.05zm1.81 5.058a1.088 1.088 0 0 0-.093-.103l-.002-.002c.018.007.056.039.1.108l-.005-.003zm.117.119l.01.007c.078.057.125-.033-.033-.038l.003.003.018.026.002.002zM22.44 77.91l-.004-.002a1.041 1.041 0 0 0-.1-.083c-.022-.028 0-.024.104.085zm-1.423 2.038c.169.18.335.364.5.548a.341.341 0 0 1 .019.007h.002l.014.006c.025-.01.05-.018.076-.026a5.768 5.768 0 0 1-.61-.535zm-2.051-3.955l-.017-.02-.044-.053-.01-.013a5.543 5.543 0 0 1-.203-.302l-.003-.003-.009-.014.252-.045h.004c.094-.016.189-.032.283-.05-.127.14-.218.311-.253.5z',
	            fill: '#FFD65F'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M12.931 89.332l-.013.02a.505.505 0 0 0-.02.024c-.038.033-.047.045-.027.037-.052.055-.072.028.06-.081zm7.605-2.383a7.762 7.762 0 0 0-.792-2.872c-.402-.828-.95-1.577-1.53-2.285-1.143-1.397-2.481-2.65-3.886-3.771a46.76 46.76 0 0 0-1.262-.97l-.5-.373c-.094-.07-.188-.14-.28-.212l-.097-.074a12.777 12.777 0 0 1-1.004-.88 8.52 8.52 0 0 1-.615-.679c-.02-.023-.039-.048-.058-.072-.938-1.303-1.555-2.783-2.175-4.26-.352-.838-.71-1.674-1.137-2.475-.247-.462-.514-.908-.849-1.311-.465-.56-1.089-.863-1.802-.923a.94.94 0 0 0-.35.042 1.316 1.316 0 0 0-.794.159c-1.156.632-1.738 1.887-1.88 3.161-.14 1.24.223 2.536.551 3.722.281 1.012.674 1.983 1.186 2.894.313 1.785.865 3.522 1.758 5.104 1.267 2.242 3.142 4 5.146 5.554.125.097.252.194.379.29a11.826 11.826 0 0 1 .347.702c.008.067.063.156.085.215.19.515.313 1.052.464 1.58.164.576.353 1.21.696 1.704.415.598 1.088.957 1.819.752.54-.152.89-.567 1.186-1.021.304-.468.552-.97.797-1.47.255-.521.507-1.046.818-1.537.077-.122.16-.24.242-.357l.012-.017c.034-.039.07-.076.102-.112l.015-.016c.098.095.194.191.292.285.488.47 1.125.895 1.833.825.332-.033.67-.119.907-.381.22-.244.4-.578.376-.92z',
	            fill: '#C4AF89'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M42.611 70.888c-.252-.181-.542-.3-.83-.42l-.218-.09-2.561-1.103c-.275-.118-.527-.198-.81-.169-.12-.21-.315-.4-.496-.506-.28-.164-.692-.233-1.006-.131-.316.102-.621.298-.781.6-.173.327-.196.644-.132 1.007.113.638.484 1.237.932 1.696.492.503 1.093.82 1.737 1.082.446.182.91.309 1.375.435l.045.013.161.044 1.87.516c.404.111.813.018 1.139-.234.353-.273.459-.599.515-1.026.093-.712-.403-1.328-.94-1.714zm-15.1 2.495a1.561 1.561 0 0 0-.468-.468.935.935 0 0 0-.158-.08c.16-.476.281-.965.357-1.461.054-.36.06-.68-.132-1.008-.159-.27-.47-.53-.78-.6-.335-.076-.71-.06-1.007.132-.267.172-.55.453-.6.78a8.18 8.18 0 0 1-.454 1.717l-.025.061-.001.004-.031.068-.002.003a8.142 8.142 0 0 1-.821 1.406 5.12 5.12 0 0 1-.424.003c-.686-.023-1.333.618-1.306 1.307.018.447.164.86.485 1.183.326.328.727.461 1.18.495.266.02.527-.073.746-.233.154-.023.305-.078.442-.169.102-.068.205-.134.309-.2a6.6 6.6 0 0 0 2.486-1.356c.419-.361.5-1.125.204-1.584zm10.992 4.268c-.312-.618-.998-1.042-1.692-1.026a1.99 1.99 0 0 0-.132.007c-.206-.45-.64-.77-1.177-.772l-1.481-.007-.185-.002c-.148-.003-.295-.005-.442.002-.576.026-1.069.27-1.397.752-.298.437-.31 1.001-.323 1.525v.003a20.7 20.7 0 0 1-.006.216 25.755 25.755 0 0 0 .2 4.213c.092.7.248 1.315.708 1.872.314.38.767.637 1.233.781 1.059.328 2.144-.03 2.97-.71.743-.611 1.185-1.52 1.521-2.4a8.192 8.192 0 0 0 .516-2.87c0-.55-.064-1.089-.313-1.584zm9.323 2.431c.237.465.346.976.345 1.498 0 .182-.015.363-.03.545-.016.211-.032.423-.027.636.019.732-.613 1.276-1.306 1.307-.718.032-1.29-.624-1.307-1.307-.002-.075 0-.15.002-.226a1.586 1.586 0 0 1-.642-.236c-.798-.514-1.06-1.563-.696-2.36-.292-.404-.351-.912-.086-1.413.15-.283.477-.517.78-.6.298-.082.746-.056 1.007.131.433.31.846.704 1.146 1.163.338.201.626.494.814.862z',
	            fill: '#E8506D'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M51.319 88.882c.574.137.933.7.959 1.263.012.287-.11.572-.28.793-.158.204-.41.427-.68.47-.665.104-1.332.114-1.945-.216a1.787 1.787 0 0 1-.21-.135l-1.901-.455-1.66-.397-.302-.073a17.977 17.977 0 0 0-1.08-.241c-.11.008-.221.017-.331.027a1.013 1.013 0 0 1-.43-.055l-.01.001c-.447.084-.881.227-1.313.37l-.355.116-1.934.617c-.697.223-1.396-.261-1.607-.914-.223-.692.262-1.404.912-1.611l.875-.28 1.733-.552c.793-.253 1.607-.442 2.444-.347l.032.003.023.003a19.787 19.787 0 0 1 3.31.039c.683.066 1.383.136 2.052.289.478.109.911.395 1.174.813.073.117.129.25.169.387l.355.085zm-22.772 2.706c-.263.198-.093.051-.002.002l.002-.002zm-1.395.845c-.023.02-.047.039-.072.058-.07.061-.127.122.079-.063l-.007.005zm-.936-2.532c1.574-1.056 3.768-1.692 5.334-.27.746.677.33 1.927-.576 2.189a11.108 11.108 0 0 0-1.046.36 5.248 5.248 0 0 0-.193.086 10.673 10.673 0 0 0-1.78 1.046 5.715 5.715 0 0 0-.07.05l-.028.022-.039.03-.045.037a10.725 10.725 0 0 0-1.179 1.113l-.099.11c-.26.29-.513.571-.857.777a1.949 1.949 0 0 1-1.72.147c-.327.318-.665.625-1.022.91-.369.294-.707.519-1.155.682-.308.112-.644.153-.97.17-.417.023-.841-.009-1.261-.041a25.17 25.17 0 0 0-.48-.034l-3.535-.204c-.468-.027-.885-.233-1.128-.648a1.321 1.321 0 0 1 0-1.322l1.336-2.261c-.043-.634.015-1.266.27-1.87.474-1.128 1.495-2.004 2.762-2.003.181 0 .35.037.504.104.983-.604 2.237-.772 3.247-.11.315.207.52.503.6.83.631.08 1.255.229 1.85.452.171.065.325.152.456.257.265-.213.54-.418.825-.61z',
	            fill: '#CD8168'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M51.651 9.239c.673.908 1.154 1.997 1.43 3.094 1.003 3.98-.412 8.444-3.666 10.922.024.102.04.209.055.322.113.91-.35 1.793-.868 2.502l-.198.266-.001.002c-.158.21-.316.421-.458.642-.079.123-.148.25-.214.38l-.015.047a1.87 1.87 0 0 0-.025.092v.098a.443.443 0 0 0 .02.04l.005.008.005.009a1.724 1.724 0 0 1 .002.002l.01.018.007.012c-.01-.009.026.054.066.103l.013.02.001.001.002.002c.017.023.033.046.048.07a5.355 5.355 0 0 0-.043-.068c.063.072.13.141.197.209.113.112.23.22.347.329.218.2.435.4.623.63a4.537 4.537 0 0 1 1.06 3.005c-.01.5-.089 1.005-.229 1.493.163.693-.073 1.345-.495 1.876-.98 2.078-3.223 3.543-5.51 3.518a1.31 1.31 0 0 1-1.092-.614l-.053.014-.023.006-.12.032a19.87 19.87 0 0 1-3.102.552c-.464.045-.93.067-1.397.062-.144-.002-.288-.009-.433-.016a9.997 9.997 0 0 0-.447-.017c-.033.511-.028 1.032-.023 1.542l.002.207c.006.687.04 1.373.122 2.055.078.52.186 1.035.344 1.537.038.124.08.246.124.368l.016.04.005.014c.011.032.028.077.042.108l.003.007.006.015c.008.019.015.037.021.056l-.018-.053c.11.243.235.48.375.708.07.113.144.222.22.33l-.05-.058.06.074.005.007.013.019c.028.04.073.09.064.074.144.17.3.329.46.483l.135.13v.001h.001l.001.001c.346.332.693.664.995 1.038.481.598.837 1.213.92 1.992.079.74-.27 1.535-.83 2.012-.286.244-.604.414-.924.585-.196.104-.393.21-.584.333a4.948 4.948 0 0 0-.19.129l.041-.038a2.453 2.453 0 0 1-.049.043l-.01.007c-.032.023-.075.06-.097.082a5.289 5.289 0 0 0-.6.612l-.029.037-.01.013a5.523 5.523 0 0 0-.308.485 6.06 6.06 0 0 1-.653 3.566c-.129.246-.348.425-.599.53L35.92 59.2c-.125.643-.831 1.022-1.43.94a1.311 1.311 0 0 1-1.13-1.289c0-.047-.001-.094-.004-.14a2.383 2.383 0 0 0-.053-.21l-.03-.084-.002-.005a2.675 2.675 0 0 0-.165-.28l-.01-.012a2.657 2.657 0 0 0-.21-.215l.038.022a.9.9 0 0 1-.03-.018l-.003-.002-.012-.007-.009-.009a.326.326 0 0 0-.13-.082 1.461 1.461 0 0 0-.122-.075l.088.028a1.263 1.263 0 0 1-.138-.05 2.54 2.54 0 0 0-.392-.095l.201.027c-.27-.04-.48-.095-.706-.27a1.326 1.326 0 0 1-.132-1.96l.063-.065a2.227 2.227 0 0 1-.081-.522c-.038-1.138.395-2.234.956-3.2l.076-.13a7.619 7.619 0 0 0-.033-.855 8.386 8.386 0 0 0-.416-1.518 9.637 9.637 0 0 0-.953-1.609 14.502 14.502 0 0 0-2.19-2.15 32.689 32.689 0 0 0-1.514-1.047c-.634-.421-1.268-.843-1.864-1.319-1.197-.953-2.052-2.345-2.057-3.918-.005-1.534.817-2.929 1.9-3.953.912-.864 1.98-1.52 3.045-2.175l.116-.071a2.24 2.24 0 0 1 1.2-.74l.837-.517.37-.225c.361-.218.724-.438 1.067-.682.09-.078.175-.161.257-.248.016-.027.033-.054.048-.082.024-.08.044-.159.061-.24.05-.726-.03-1.47-.124-2.196-.379-2.75-1.15-5.428-2.2-7.993A42.11 42.11 0 0 0 28.156 16c-.25-.447-.517-.886-.784-1.326-.44-.725-.881-1.451-1.247-2.215-.35-.732-.677-1.505-.825-2.31a7.316 7.316 0 0 1-.031-2.552c.22-1.47 1.095-2.848 2.348-3.637.788-.496 1.706-.667 2.618-.728.267-.018.534-.022.802-.026.289-.004.577-.008.865-.03.119-.025.236-.054.352-.09.125-.068.245-.143.362-.224.285-.244.551-.51.818-.775.157-.156.313-.312.474-.465.643-.607 1.317-1.092 2.14-1.41.989-.381 2.067-.213 3.002.221.871.405 1.516 1.221 2.033 2.005.132.201.26.404.386.607.202.324.404.646.626.958a11.858 11.858 0 0 0 1.703 1.708c.65.479 1.344.888 2.077 1.223.353.14.712.268 1.07.396.726.26 1.452.518 2.136.883.06.031.117.064.174.097.38-.115.817-.12 1.17-.022.555.154.895.503 1.227.95zM37.748 50.026l.177-.09.005-.002c.07-.035.141-.07.21-.106a3.898 3.898 0 0 0 .225-.127c-.05-.091-.1-.181-.16-.268l-.09-.11-.001-.002-.003-.003-.03-.036a8.22 8.22 0 0 0-.313-.339c.031.364.028.722-.02 1.083zm7.417-21.792a2.383 2.383 0 0 1-.048-.23l-.024.207-.002.022h.074z',
	            fill: '#fff'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M56.731 89.965c-.17.915-.374 1.824-.528 2.741-.18 1.062-.356 2.126-.342 3.212.005.394-.067.793-.142 1.183-.035.18-.14.36-.251.51-.175.234-.394.185-.483-.089-.023-.07-.014-.156-.052-.214-.371-.576-.33-1.2-.248-1.841.043-.336.017-.68.036-1.019.047-.81-.237-1.507-.725-2.13a.967.967 0 0 1-.215-.609c-.008-.417-.084-.817-.317-1.179-.357-.553-.858-.95-1.389-1.315-.084-.058-.203-.083-.26-.158-.297-.397-.722-.54-1.176-.62-.328-.058-.574-.178-.68-.53-.07-.234-.25-.399-.48-.491-.761-.306-1.493-.708-2.33-.778-.305-.025-.519-.186-.6-.447-.14-.455-.519-.616-.874-.808-.564-.305-1.179-.445-1.815-.486-.767-.05-1.403.25-1.94.78-.23.227-.462.455-.66.708-.114.144-.169.337-.238.512-.145.369-.247.76-.431 1.106-.227.427-.535.551-.998.44-.713-.174-1.327.11-1.952.37a.17.17 0 0 0-.073.048c-.343.475-.784.9-.893 1.507-.11.61-.168 1.223-.074 1.85.173 1.148.073 2.298-.036 3.445-.028.294-.073.587-.11.88-.088.71-.552 1.162-1.091 1.537-.322.224-.867.051-1.13-.33a3.974 3.974 0 0 1-.696-1.846 9.867 9.867 0 0 1 .137-2.822c.323-1.745.045-3.408-.794-4.977-.155-.29-.385-.465-.646-.637-.684-.45-1.422-.635-2.223-.47-.72.149-1.444.294-2.14.521-.466.153-.903.42-1.323.683-.436.274-.831.613-1.347.734-.417.099-.79.1-1.136-.247-.448-.447-.966-.816-1.568-1.043-.208-.079-.318-.234-.397-.442-.34-.895-.693-1.786-1.049-2.675-.055-.14-.06-.249.046-.364.179-.196.346-.402.524-.599.214-.237.464-.311.793-.254.377.066.685.212.964.473.178.167.396.297.61.42.171.1.333.25.566.186.314-.086.619-.183.86-.42.111-.108.239-.2.344-.287.198.144.36.252.51.373.277.222.556.156.86.057.53-.173.763-.758.5-1.264-.265-.512-.73-.702-1.238-.834a6.16 6.16 0 0 0-.688-.145 1.184 1.184 0 0 0-.387.03c-.215.043-.424.125-.64.15-.153.016-.316-.024-.467-.064-.183-.048-.356-.162-.54-.178-.397-.036-.792-.046-1.131-.3-.04-.03-.14-.043-.166-.017-.257.246-.572.126-.864.158a.575.575 0 0 0-.273.098c-.312.235-.613.483-.963.762-.129-.178-.249-.319-.341-.476a17.159 17.159 0 0 0-2.598-3.401c-.983-.992-2.037-1.915-3.01-2.917-.583-.599-1.11-1.263-1.585-1.952-.251-.365-.348-.84-.493-1.273-.283-.841-.606-1.663-1.102-2.404-.431-.644-.868-1.285-1.325-1.961 1.472-.483 2.965-.906 4.58-1.077 0 .314-.003.544.002.773.005.23.017.461.032.691.027.412-.094.783-.296 1.134-.192.332-.227.703-.27 1.074-.021.193-.074.383-.123.624.363 0 .655.015.943-.009.103-.008.21-.1.295-.174.546-.476.888-1.09 1.178-1.743.18-.405.23-.798.134-1.244-.062-.288.02-.612.063-.917.025-.18.168-.281.348-.278.234.003.48-.01.7.057.644.197 1.283.415 1.912.657.27.104.507.292.765.43.45.243.903.483 1.363.708.082.04.216.038.299-.002a3.84 3.84 0 0 0 .64-.374c.377-.283.378-.636.023-.952-.085-.076-.177-.145-.314-.257.144-.057.241-.116.345-.134.374-.064.75-.122 1.127-.168.831-.1 1.661-.218 2.496-.279.388-.028.79.03 1.176.101.75.137 1.5.286 2.238.478.435.114.866.284 1.264.494.689.363 1.355.77 2.022 1.173a7.63 7.63 0 0 0 2.026.85c.137.036.271.084.361.112-.023.442-.049.827-.06 1.213-.013.377.169.683.39.964a8.744 8.744 0 0 0 2.55 2.215c.98.56 2.047.887 3.155.868 1.304-.021 2.557-.35 3.593-1.236.234-.2.288-.208.538-.029.64.458 1.19.994 1.616 1.671.423.673.89 1.324 1.472 1.873.212.202.467.357.688.55.242.211.515.41.692.67.557.821 1.211 1.558 1.86 2.302.389.447.689.94.82 1.54.104.473.285.929.44 1.39.171.511.622.83 1.182.806.216-.01.355.063.407.25.114.41.211.825.297 1.242.093.448.109.92.26 1.344.254.706.557 1.392 1.329 1.728.42.183.44.281.355.73zm-5.164 1.566c-.343.026-.597-.138-.845-.283a3.642 3.642 0 0 0-1.11-.41c-1.22-.258-2.434-.561-3.66-.787-.734-.136-1.488-.167-2.234-.227-.202-.016-.41.02-.612.053-.297.05-.576.006-.857-.066.013-.067.008-.109.025-.122.325-.244.465-.584.554-.97.107-.467.204-.536.678-.492.379.034.751.13 1.129.182.334.045.672.059 1.006.103.232.03.47.06.687.142.272.102.504.079.756-.056a.777.777 0 0 1 .452-.086c.488.075.958.203 1.173.731.497.328.786.967 1.491.986.188.005.374.072.561.111.59.122.857.504.806 1.191zm-12.665-.983c.29-.229.311-.232.636-.097-.22.057-.396.21-.636.097zm-7.397 1.063c-.008.003-.066.049-.11.038-.545-.133-1.05.03-1.548.212-1.057.385-2.03.921-2.93 1.604-.704.533-1.414 1.065-2.167 1.522-.759.46-1.537.9-2.384 1.195a.549.549 0 0 0-.299.276.657.657 0 0 1-.522.424c-.33.066-.665.16-.997.155-.925-.015-1.85-.064-2.756-.288-.495-.122-.932-.356-1.344-.643-.26-.18-.358-.462-.43-.751-.162-.658-.146-1.323-.005-1.978.225-1.052.695-2.004 1.277-2.897.494-.757 1.196-1.18 2.111-1.271 1.472-.146 2.601.405 3.438 1.61.057.084.122.177.206.223.354.195.485.56.705.864.219.303.491.584.791.804.207.153.459.016.629-.17a4.546 4.546 0 0 1 1.915-1.228c1.333-.451 2.65-.974 4.071-1.103.1-.009.2-.001.349-.001v1.403zM14.84 90.606c-.08.135-.153.274-.245.439-.106-.083-.184-.125-.237-.188a531.492 531.492 0 0 1-2.278-2.758c-1.045-1.276-2.058-2.579-3.135-3.826-1.062-1.23-2-2.547-2.874-3.911-.627-.978-1.246-1.964-1.807-2.98-.405-.733-.707-1.523-1.058-2.286-.123-.267-.26-.529-.383-.797-.421-.913-.681-1.883-.928-2.853-.096-.378-.075-.791-.073-1.189.003-.457.066-.914.062-1.37-.006-.746.35-1.356.648-2 .17-.369.451-.52.8-.619.055-.015.12-.038.172-.024.54.15 1.08-.007 1.619-.008.388-.002.697.116.995.379.638.562 1.1 1.263 1.595 1.939.356.486.705.978 1.071 1.456.51.67.983 1.357 1.28 2.156.26.703.535 1.402.833 2.09.152.348.346.685.563.997.352.508.738.993 1.112 1.486.665.876 1.547 1.53 2.315 2.3 1.124 1.127 2.262 2.243 3.179 3.552.344.49.622 1.038.863 1.588.374.85.692 1.725 1.03 2.591.035.093.043.196.062.287-.655.146-1.265.242-1.85.42-.917.28-1.729.78-2.34 1.516-.4.48-.667 1.07-.99 1.613zm22.033-19.804c.043-.213.088-.426.133-.642.458-.091.827-.013 1.129.2.594.42 1.122.936 1.845 1.178-.468.533-.468.533-.106 1.239.398.087.767.063 1.049-.29l-.258-.58c.2-.007.325-.027.447-.015.464.044.929.094 1.392.151.281.035.53.145.75.37-.14.26-.378.378-.618.467-.343.127-.696.228-1.05.324-1.127.305-2.15.015-3.098-.598-.502-.325-.991-.672-1.398-1.129-.187-.21-.271-.409-.217-.675zm22.04 18.102c-.34-.393-.594-.888-1.115-1.087a1.26 1.26 0 0 1-.8-.876 3.113 3.113 0 0 1-.137-.909c.027-.944-.324-1.766-.8-2.535-.205-.33-.485-.659-.81-.855a1.431 1.431 0 0 1-.608-.72c-.31-.752-.796-1.37-1.353-1.947-.367-.381-.735-.771-1.037-1.204-.57-.817-1.201-1.561-2.043-2.108a1.234 1.234 0 0 1-.321-.294c-.357-.487-.699-.985-1.049-1.477-.385-.542-.806-1.05-1.34-1.457-.96-.733-1.897-1.495-2.868-2.211-.705-.52-1.491-.876-2.378-.977a19.503 19.503 0 0 1-1.477-.23 1.107 1.107 0 0 1-.727-.461c-.217-.313-.54-.48-.874-.646-.748-.373-1.538-.572-2.361-.668-.554-.064-1.113-.112-1.658-.224-.917-.188-1.743-.62-2.534-1.104-1.691-1.036-3.593-1.443-5.487-1.84-1.147-.24-2.31-.068-3.451.186-.3.067-.607.1-.91.146-.61.092-1.22.177-1.828.275-.173.028-.34.094-.51.133-.239.054-.439.003-.562-.232-.089-.17-.24-.235-.42-.285-.733-.202-1.482-.227-2.23-.19-.804.038-1.61.061-2.398.29-.389.113-.817.078-1.222.145-1.464.244-2.92.519-4.28 1.162-.372.176-.45.13-.705-.198-.207-.268-.42-.531-.63-.798-.31-.397-.779-.57-1.172-.85-.454-.323-.959-.442-1.495-.427-.616.018-1.23.103-1.846.104-.836 0-1.533.35-2.08.917-.629.653-1.066 1.478-1.2 2.378-.206 1.373-.315 2.766-.004 4.141.155.684.341 1.371.611 2.015a61.045 61.045 0 0 0 1.761 3.867c.524 1.038 1.135 2.033 1.738 3.029.481.794.964 1.593 1.524 2.33 1.088 1.431 2.223 2.826 3.355 4.223.751.927 1.537 1.827 2.295 2.749.458.557.952 1.097 1.324 1.71.481.79 1.08 1.555 1.048 2.568-.003.085.034.173.06.257.08.252.16.504.248.754.122.347.215.711.383 1.036.418.811.939 1.565 1.825 1.9.696.265 1.424.463 2.154.606.543.107 1.112.098 1.67.107 1.58.024 2.954-.528 4.175-1.523.454-.37.943-.7 1.43-1.027 1-.672 2.02-1.316 3.012-2 .463-.32.932-.621 1.45-.828.373-.15.775-.225 1.177-.337.036.11.068.164.069.218.014.837.021 1.675.04 2.513.002.144.027.296.08.428.217.544.393 1.11.786 1.564a.514.514 0 0 1 .088.153c.125.334.368.563.654.754.22.147.458.275.653.45.458.412.978.575 1.584.492.262-.036.534-.021.787-.088.278-.074.586-.159.795-.34.353-.304.648-.68.948-1.044.098-.118.21-.303.184-.43-.048-.238.066-.4.142-.587.072-.177.2-.343.226-.526.123-.831.24-1.664.316-2.501.055-.599.042-1.204.06-1.84l1.593-.398c1.513-.38 3.048-.497 4.59-.291 1.047.14 2.076.403 3.12.57a5.659 5.659 0 0 1 1.827.611c.076.041.165.101.241.094.453-.047.815.168 1.194.366.227.118.49.18.745.224.312.054.352.06.35.382-.004.488-.047.975-.036 1.462.008.32.062.642.128.957.064.302.17.595.258.892.155.532.404 1.019.803 1.4.63.6 1.423.54 2.205.482.081-.006.161-.065.237-.108.166-.094.331-.19.49-.294.16-.105.356-.191.455-.34.25-.377.507-.765.665-1.184a4.169 4.169 0 0 0 .246-1.743c-.029-.454-.058-.902.088-1.353.099-.305.147-.636.163-.958.025-.489.15-.953.253-1.425.193-.88.365-1.764.53-2.65.024-.132.004-.322-.077-.415zm-32.42-13.706c-.256.258-.552.475-.835.706-.075.062-.165.106-.293.187-.015-.125-.01-.207-.037-.278-.099-.263-.205-.46-.554-.525-.433-.079-.774.012-1.129.262.141.353.029.916.748.786l-.072.113c-.386-.074-.771-.15-1.157-.222-.488-.09-.696-.433-.814-.878.56-.374 1.11-.734 1.652-1.107.154-.106.289-.244.425-.375.346-.333.4-.77.423-1.218.016-.305.043-.609-.07-.907-.062-.169 0-.312.15-.424.402-.298.83-.483 1.35-.423.238.027.391.129.46.343.116.361.213.73.322 1.11-.41.023-.782.012-1.144.071-.374.062-.552.403-.771.672.072.091.164.173.213.276.162.336.462.443.79.479a.74.74 0 0 0 .4-.098c.167-.09.308-.235.518-.142.197.8-.082 1.098-.574 1.592zm-.41-6.12c-.127-.018-.256-.024-.417-.038.085-.623.042-.704-.48-.99-.064-.035-.13-.068-.191-.108-.145-.097-.285-.103-.457-.049-.434.139-.737.467-1.08.733-.179.14-.377.336-.429.542-.142.57-.24 1.155-.3 1.74-.037.348.028.706.046 1.06.028.541-.063 1.025-.569 1.346-.642.406-1.317.71-2.08.787-.454.045-.906.097-1.358.148-.185.02-.332.096-.421.276-.158.316-.352.616-.483.943-.089.224-.136.483-.128.724.009.286.309.592.655.46.137-.052.283-.086.427-.107.267-.04.47-.163.587-.411.2-.42.597-.297.93-.33.272-.028.322.216.403.398.365.825 1.012 1.32 1.839 1.605.775.266 1.58.316 2.391.325.378.004.716-.026 1.086-.206.534-.259 1.047-.512 1.453-.954.427-.466.86-.925 1.284-1.394a.57.57 0 0 0 .14-.268c.06-.364.128-.729.146-1.095.03-.589.006-1.18.036-1.767.046-.924-.3-1.706-.878-2.377-.555-.644-1.334-.882-2.151-.994zm12.373 10.318c-.089.523-.19 1.044-.256 1.57-.03.241.01.491.02.737.003.059.028.122.012.174-.154.503-.234 1.04-.66 1.418-.229.203-.42.454-.665.631-.864.625-1.762.632-2.68.1a20.062 20.062 0 0 0-1.28-.683c-.267-.13-.435-.324-.571-.583a6.706 6.706 0 0 1-.657-1.919c-.157-.845.048-1.61.583-2.28.416-.522.42-.519.904-.72-.026-.376.033-.457.378-.545.695-.179 1.418-.216 2.096-.054.918.219 1.85.481 2.515 1.258.232.27.319.554.26.896zm1.46-1.607c-.525-.647-1.056-1.312-1.863-1.646a1.107 1.107 0 0 1-.157-.08c-.928-.57-1.937-.843-3.021-.782-.644.037-1.284.132-1.927.193-.62.06-1.106.353-1.494.83-.102.125-.187.269-.304.377-.675.622-1.048 1.404-1.229 2.294-.112.551-.199 1.095-.102 1.666.186 1.102.548 2.139 1.046 3.134.185.37.453.643.81.844 1.078.607 2.171 1.187 3.37 1.509.401.108.847.131 1.261.086.706-.076 1.355-.38 1.974-.716.634-.345 1.008-.952 1.296-1.576.565-1.221.743-2.539.819-4.02-.023-.283-.022-.716-.105-1.132-.068-.341-.164-.721-.374-.98zm7.724 4.18c-.077.28-.223.543-.35.808-.109.226-.282.325-.537.233-.029-.267-.058-.483-.075-.7-.025-.307-.239-.43-.49-.487-.242-.055-.497-.117-.738-.094-.54.053-.873-.263-1.197-.607-.166-.177-.218-.406-.088-.613.24-.38.421-.789.784-1.098.577-.49 1.178-.47 1.81-.208.705.293.964.943 1.072 1.615.06.365-.089.775-.191 1.151zm1.652-2.976c-.374-.662-.956-1.141-1.582-1.504-1.073-.621-2.2-.425-3.314-.017-.471.173-.805.524-1.195.805-.252.182-.425.392-.506.69-.042.157-.09.316-.165.458-.248.472-.3.974-.24 1.492.018.157-.042.255-.17.325-.078.041-.163.073-.234.123-.317.226-.355.5-.136.816.072.103.11.231.16.349.05.115.096.232.153.37.259-.113.476-.164.583.146.1-.033.143-.044.184-.06.57-.219.689-.174.976.37.035.065.052.142.096.2.131.174.25.369.412.51.92.792 2.014.981 3.174.848.277-.032.537-.213.804-.328.053-.023.097-.072.151-.085.573-.136.807-.585.988-1.078.254-.693.457-1.398.558-2.135.063-.453.065-.874-.158-1.281-.184-.336-.35-.681-.539-1.014zm3.363 7.168c-.32-.572-.62-.754-1.32-.699-.413.033-.512.227-.322.59.246.467.46.954.742 1.398.342.537.768.997 1.518 1.022-.087-.341.23-.439.4-.743-.064-.141-.12-.324-.222-.472-.257-.372-.576-.705-.796-1.097zm-37.11.683c-.37-.377-.756-.74-1.128-1.116-.735-.743-1.45-1.507-2.203-2.232a26.534 26.534 0 0 1-2.024-2.156c-.254-.306-.535-.592-.768-.912-.623-.858-1.253-1.713-1.833-2.6a76.388 76.388 0 0 1-1.893-3.087c-.343-.584-.64-1.197-.94-1.804a4.69 4.69 0 0 1-.345-.86c-.122-.456-.333-.843-.679-1.16-.15-.139-.628-.2-.821-.077-.215.138-.164.347-.128.556.061.363.146.73.145 1.094 0 .474.112.904.325 1.316.548 1.058.995 2.167 1.668 3.164.65.962 1.196 1.994 1.846 2.956.642.95 1.295 1.889 2.065 2.753.802.902 1.602 1.8 2.45 2.66.835.845 1.63 1.732 2.482 2.56.238.231.44.64.92.558.31-.107.622-.212.931-.321.43-.152.54-.529.263-.88-.11-.139-.209-.287-.332-.412zM38.86 71.682l-.243-.195.259-.32c-.366-.074-.643-.167-.921-.172-.145-.002-.313.13-.431.243-.12.114-.079.275.03.395.387.43.826.448 1.306.05zm-4.455 7.94c.164.122.339.232.52.322.082.04.213.059.286.02.249-.133.55-.21.666-.543l-.19-.204c.09-.127.169-.24.246-.352-.318-.267-.622-.461-1.02-.477-.33-.014-.553.08-.65.327-.098.246-.024.786.142.908zm1.783 3.168c-.282-.158-.627-.204-.95-.285-.042-.011-.121.032-.149.073-.104.157-.241.232-.423.281-.177.048-.178.176-.035.332.098.107.215.203.288.325.227.383.575.451.931.438l.568-.641c-.061-.152-.087-.443-.23-.523zm1.357-2.625c-.323-.051-.656-.185-.988-.04-.21.091-.415.198-.65.312.093.145.178.261.245.387.174.331.499.446.816.538.301.086.403-.231.585-.38a.6.6 0 0 0 .094-.094c.16-.203.108-.689-.102-.723zm-3.044.297c-.232-.298-.57-.285-.887-.264-.259.017-.386.264-.483.466-.092.193-.048.434.151.551.272.16.535.376.869.316.134-.201.234-.358.342-.51.086-.122.098-.444.008-.559zm12.468-.82c-.458-.12-.944-.334-1.341.233.138.372.511.52.795.756.053.044.182.056.241.021.175-.102.356-.212.49-.36.18-.195.07-.584-.185-.65zM21.48 10.808c.223.247.365.568.591.811a10.008 10.008 0 0 0 1.936 1.598c.731.469 1.552.7 2.383.893.324.076.602.204.861.416.48.39.78.916 1.125 1.412.958 1.381 1.415 2.907 1.297 4.594a3.2 3.2 0 0 0 .446 1.908c.309.52.623 1.039.886 1.582.437.903.841 1.822 1.248 2.739.443.997.179 1.89-.779 2.523-.49.325-.976.656-1.467.98-.468.31-.95.604-1.502.726-1.486.326-2.874.94-4.302 1.439-.592.206-.954.594-1.225 1.13-.286.565-.597 1.119-.901 1.675-.329.6-.617 1.218-.628 1.917-.018 1.06-.06 2.125.005 3.181.037.6.215 1.207.72 1.64.13.112.215.278.32.42.749 1.006 1.774 1.464 2.997 1.51.307.012.617-.021.924-.049.503-.046 1.01-.04 1.48.14.376.143.77.33 1.057.602.649.616 1.062 1.404 1.356 2.248.222.641.445 1.283.634 1.934.083.29.14.612.106.907-.04.346-.19.679-.295 1.017-.261.844-.728 1.6-1.001 2.444-.224.69-.226 1.356-.096 2.044.046.245.096.49.135.688-.07.503.171.874.352 1.246.068.14.344.173.523.26.41.198 1.016-.085 1.058-.536.062-.661.035-1.324-.174-1.966-.176-.541-.244-1.081.006-1.621.043-.094.07-.194.11-.29.204-.505.428-1.004.608-1.518a1.53 1.53 0 0 1 .413-.656c.32-.296.507-.646.381-1.134-.255-.985-.42-1.995-.705-2.97-.184-.627-.365-1.283-.843-1.784-.047-.05-.067-.13-.088-.199a2.863 2.863 0 0 0-.729-1.195c-.98-.992-2.162-1.495-3.574-1.4-.482.033-.968.034-1.452.04-.566.008-1.016-.268-1.402-.645-.24-.235-.43-.523-.651-.78a1.06 1.06 0 0 1-.282-.722c.004-.768-.024-1.538.016-2.303.021-.392.095-.809.263-1.157.356-.743.773-1.458 1.2-2.163.13-.215.348-.404.569-.531a4.71 4.71 0 0 1 .936-.384c1.231-.39 2.468-.762 3.7-1.148.168-.052.336-.12.482-.213.556-.358 1.09-.752 1.658-1.09.52-.31 1.004-.654 1.436-1.086.85-.852 1.165-2.332.687-3.444-.274-.636-.54-1.277-.844-1.9a79.975 79.975 0 0 0-1.451-2.832c-.168-.31-.274-.607-.24-.963.086-.94-.109-1.853-.324-2.757-.271-1.136-.838-2.14-1.494-3.09a13.948 13.948 0 0 0-.934-1.176c-.619-.718-1.465-1.025-2.35-1.21-.827-.175-1.547-.536-2.208-1.051-.775-.604-1.482-1.262-1.895-2.179-.158-.35-.32-.706-.195-1.106.323-1.028.788-1.957 1.622-2.687a7.78 7.78 0 0 0 1.268-1.406c.238-.343.494-.65.78-.944.422-.432.843-.866 1.243-1.318.269-.304.162-.699-.201-.863-.079-.036-.17-.06-.23-.116-.207-.193-.417-.16-.645-.047-.128.063-.27.096-.402.154-.199.086-.432.14-.583.28-.538.502-1.08 1.007-1.56 1.563a18.555 18.555 0 0 1-1.783 1.774c-.163.144-.341.305-.427.497-.38.845-.783 1.688-1.07 2.567a1.967 1.967 0 0 0 .138 1.514c.294.556.543 1.139.976 1.616zm15.43 33.329c.133.136.223.311.35.454.142.161.295.315.457.456.311.267.68.482.938.793.451.542.833 1.141 1.248 1.714.329.453.672.896.994 1.354.286.406.264.523-.052.887-.202.233-.404.471-.57.731a10.565 10.565 0 0 1-1.941 2.271c-.295.261-.581.549-.803.871-.585.852-.817 1.82-.823 2.848-.001.116.026.264-.033.343-.293.397-.423.83-.37 1.322.003.027-.008.058-.018.086-.25.673.039 1.2.44 1.707.123.156.196.35.306.519.068.103.143.224.246.278.252.133.546.14.812.268.164.079.428-.017.635-.075.187-.052.288-.217.256-.415-.095-.582-.164-1.183-.71-1.556-.132-.09-.177-.21-.127-.343.188-.508.174-1.075.472-1.554.084-.135.133-.358.082-.498-.166-.454-.055-.877.068-1.302.149-.516.387-.965.796-1.349a22.654 22.654 0 0 0 1.854-1.95c.595-.71 1.117-1.48 1.67-2.224.044-.059.09-.121.111-.19a.49.49 0 0 0 .027-.254c-.164-.585-.374-1.144-.76-1.632-.565-.716-1.132-1.434-1.644-2.188-.472-.693-1.016-1.293-1.706-1.766a2.135 2.135 0 0 1-.79-1.042c-.234-.648-.237-1.334-.1-2.013.044-.217.17-.347.394-.427.466-.168.94-.24 1.429-.196.306.027.613.12.917.107.762-.035 1.515-.034 2.276.076.622.09 1.26.08 1.89.114 1.065.046 2.112-.12 3.154-.296a3.866 3.866 0 0 0 1.793-.8 1.52 1.52 0 0 0 .399-.464c.375-.727.63-1.478.598-2.328a5.587 5.587 0 0 1 .586-2.738c.322-.65.649-1.313.686-2.085.026-.547-.104-.983-.476-1.363-.258-.263-.518-.524-.77-.792-.874-.925-1.322-2.054-1.476-3.295-.131-1.057.046-2.093.425-3.086.36-.94.932-1.659 1.955-1.944a9.708 9.708 0 0 0 1.44-.55c.894-.41 1.808-.796 2.52-1.514.28-.282.565-.56.822-.863.497-.585.952-1.204 1.144-1.968.25-.994.38-1.982.15-3.018-.199-.902-.593-1.685-1.092-2.435a20.418 20.418 0 0 0-.506-.722.9.9 0 0 0-.21-.219c-.18-.122-.371-.227-.557-.34-.232-.14-.638-.124-.788.034-.17.177-.186.458-.022.731.159.266.338.519.504.78.41.653.818 1.33.903 2.098.133 1.198.08 2.39-.695 3.42-.402.535-.39 1.05-.98 1.362-.736.39-1.9.828-2.697 1.107-.58.202-1.14.471-1.694.742a3.1 3.1 0 0 0-1.362 1.349c-.606 1.137-1.049 2.348-1.122 3.653-.04.719-.056 1.45.03 2.162.11.902.505 1.711 1.023 2.465.334.485.658.97 1.118 1.347.459.377.556.835.315 1.383a14.156 14.156 0 0 0-1.072 3.823c-.06.438-.07.883-.13 1.32-.102.725-.34.994-1.047 1.107-.883.141-1.768.305-2.67.15-.187-.032-.382-.017-.572-.031a35.337 35.337 0 0 1-.92-.08c-.744-.075-1.484-.184-2.24-.118-.345.03-.7-.03-1.049-.07-.497-.059-.991-.12-1.487.007-.341.088-.687.157-1.026.253a10.76 10.76 0 0 0-.958.32.558.558 0 0 0-.258.23 4.337 4.337 0 0 0-.554 1.573 6.766 6.766 0 0 0 .015 2.148c.09.513.266.957.63 1.33z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'record':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '75',
	            height: '60',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'record'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h75v60H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M68.957 14.797c-.04.914-.081 1.828.131 2.654.48 1.865.744 3.834.593 5.756-.163 2.086-.744 4.067-1.793 5.895-.172.298-.32.6-.468.902-.255.522-.508 1.039-.872 1.512-.337.44-.804.71-1.276.98-.386.223-.775.448-1.098.769-1.443 1.432-1.958 1.783-3.952 2.307-1.553.408-3.18.372-4.793.335-.397-.009-.794-.017-1.188-.02-.307-.001-.512.151-.693.286-.23.171-.422.314-.734.078-.85-.644-1.085-1.602-.884-2.607.051-.255.124-.507.197-.76.06-.206.12-.413.168-.622.093-.403.168-.81.23-1.219.09-.756.135-1.52.062-2.278a5.243 5.243 0 0 0-.226-.851 3.745 3.745 0 0 0-.223-.378 3.298 3.298 0 0 0-.23-.226 3.642 3.642 0 0 0-.336-.19 5.471 5.471 0 0 0-.847-.208c-.479-.048-.96-.063-1.442-.077l-.272-.009c-.921-.03-1.798-.12-2.643-.5-1.037-.466-1.617-1.433-1.732-2.511a2.464 2.464 0 0 1 .132-1.07l-5.012-10.718c-.216-.462-.326-.85-.257-1.35.052-.382.186-.698.426-1.003l.016-.02.006-.007c-.774-.63-.987-1.849-.465-2.693 1.022-1.652 2.368-3.025 3.965-4.147C44.89 1.79 46.757.966 48.574 1.15a6.518 6.518 0 0 1 2.952 1.03c.166-.115.345-.2.517-.226.612-.092 1.22-.165 1.84-.151 2.26.05 4.377.838 6.403 1.751 1.796.81 3.539 1.795 4.964 3.155 1.405 1.341 2.448 3.019 3.313 4.73.5.99.447 2.173.394 3.357zM54.082 7.733a3.27 3.27 0 0 0 .457-1.698 3.015 3.015 0 0 0-.085-.64l.018.002.144.013c1.096.176 2.154.518 3.18.93 1.428.603 2.833 1.295 4.088 2.2a11.355 11.355 0 0 1 1.72 1.689c.313.414.605.845.878 1.288a1.52 1.52 0 0 0-.412-.04c-.837.037-1.48.535-1.751 1.306l-.006.014-.004.012a3.842 3.842 0 0 1-.24.402c-.111.123-.229.238-.354.347a3.977 3.977 0 0 1-.41.236 4.41 4.41 0 0 1-.155.05 1.937 1.937 0 0 0-.894.58 3.717 3.717 0 0 0-.261-.408 5.766 5.766 0 0 0-1.852-1.618c-.558-.312-1.158-.55-1.754-.785l-.203-.08a64.854 64.854 0 0 0-2.07-.78c.012-.15.009-.3-.011-.445a2.118 2.118 0 0 0-.978-1.505c.388-.3.72-.667.955-1.07zM49.69 23.291c.656.022 1.305.08 1.954.182a5.807 5.807 0 0 1 2.034.72A45.81 45.81 0 0 0 56.54 18.7c.248-.59.474-1.19.594-1.817.013-.165.015-.328.007-.492a2.952 2.952 0 0 0-.066-.24 2.91 2.91 0 0 0-.107-.179 3.565 3.565 0 0 0-.273-.263 7.587 7.587 0 0 0-1.234-.65 61.444 61.444 0 0 0-4.263-1.543c-.316.207-.627.422-.932.645-.475.37-.934.757-1.376 1.163-.358.33-.762.52-1.242.583-.462.06-.976.003-1.38-.251a7.418 7.418 0 0 1-.075-.049l-.04-.026 2.904 6.21c.196.33.294.687.295 1.07l-.057.418.394.012zm17.216 2.418c.328-.818.558-1.667.696-2.535a14.64 14.64 0 0 0-.027-3.404 21.075 21.075 0 0 0-1.109-4.172c.156.822.283 1.65.38 2.483.379 3.267.054 6.783-1.229 9.868.488-.714.93-1.456 1.29-2.24zm-8.004 3.48c.017.044.033.09.047.136.027-.131.056-.261.086-.392l-.132.256zm-2.999-2.102l.054-.028.03-.015-.063.1-.01-.025-.01-.032z',
	            fill: '#9D93AC'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M45.795 27.023l5.603 8.938c.255.407.283.904.178 1.36-.106.466-.448.786-.815 1.055a2534.778 2534.778 0 0 1-29.08 21.008c-.45.32-1.098.291-1.58.089-.535-.225-.827-.611-1.026-1.144a248.949 248.949 0 0 0-3.832-9.609A247.293 247.293 0 0 0 6.5 30.315a1.92 1.92 0 0 1-.223-.788A9.931 9.931 0 0 1 4.27 28.52c-.53-.349-.879-.875-.879-1.524 0-.672.359-1.146.879-1.524A182.808 182.808 0 0 1 34.318 7.728c.452-.212.878-.288 1.367-.178.37.085.694.341.921.633.246.317.363.67.38 1.07.022.477-.223.899-.519 1.247v.002c.254.217.446.505.529.845.19.777.444 1.534.746 2.275.69 1.567 1.568 3.041 2.472 4.494 1.252 2.012 2.513 4.02 3.773 6.026l1.808 2.88zm-11.193-11.76c-.439-.121-.918-.082-1.323.178a1.93 1.93 0 0 0-.39.332 2.013 2.013 0 0 0-.22-.228c.54-.344 1.081-.686 1.623-1.026.099.25.202.498.31.744zm-16.006 4.903a64.67 64.67 0 0 0-1.318 1.012c-.623.492-1.234.999-1.83 1.522a278.684 278.684 0 0 0-4.583 2.441 182.535 182.535 0 0 1 7.731-4.975zm28.485 15.577l.416.664-.55.403c.114-.343.162-.709.134-1.067zm-26.35 12.002a152.913 152.913 0 0 1 1.928 6.61l.002.006 1.09-.78a174.316 174.316 0 0 0-3.02-5.836zm-8.72-19.12a2.02 2.02 0 0 0-.192.02l.193-.106v.086zm3.6-1.912a1.73 1.73 0 0 1-.178-.017l-.113.06a226.4 226.4 0 0 0-.634.337c.11.062.21.134.288.213.21-.2.421-.398.636-.593zm26.971 1.964a2.242 2.242 0 0 0-.093-.26l.308.49a27.352 27.352 0 0 0-.215-.23zm-32.21.776l-.105.06.043.062.14.195c.073-.21.198-.4.35-.563l-.085.047c-.114.063-.228.13-.344.198zm12.375-1.85a10.64 10.64 0 0 0-1.115 1.954c-.58 1.438-.981 2.979-1.222 4.511a177.374 177.374 0 0 1 4.117 5.614l.066-.09c.125-.192.29-.343.497-.454l.424-.178 5.803-.83c.418-.229.82-.485 1.206-.767a10.77 10.77 0 0 0 1.568-1.556c.516-.697.953-1.445 1.313-2.232l-.002-.025c-.032-.504.042-1.016.124-1.515a1.823 1.823 0 0 1-.577-.584 16.36 16.36 0 0 1-1.866-4.557c-.077-.034-.155-.068-.232-.1l-.028-.013-.014-.006c-1.338-.544-2.726-.977-4.156-1.197a10.75 10.75 0 0 0-2.296-.024 7.884 7.884 0 0 0-1.491.397 7.149 7.149 0 0 0-1.128.655c-.362.3-.691.635-.991.996zm5.813-5.578l.027.015a14.67 14.67 0 0 0-.29-.025c.008-.053.014-.105.018-.158.075.062.156.119.245.168z',
	            fill: '#E8506D'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M57.6 5.09a42.955 42.955 0 0 1 4.125 3.12c.672.576.554 1.624 0 2.215a1.304 1.304 0 0 1-.314.24c-.012.099-.03.196-.056.29-.11.4-.31.685-.575 1-.443.527-1.378.569-1.938.245l-1.14-.658c-.76-.438-1.52-.877-2.277-1.32-.64-.374-1.052-.917-1.105-1.658-.026-.368.082-.757.2-1.106a7.192 7.192 0 0 1 .891-1.807c.245-.352.544-.59.956-.72.359-.113.917-.052 1.232.158zm-6.273 22.367l.347 2.073c.068.409.08.839-.161 1.206-.15.226-.343.416-.574.562-.298.188-.679.23-1.02.186-.316-.042-.708-.172-.918-.431l-1.798-2.22c-.278-.343-.448-.666-.468-1.107-.02-.417.189-.809.468-1.107.27-.288.739-.459 1.131-.459.267 0 .623.09.887.253.046-.018.093-.035.139-.05.384-.121.89-.038 1.232.159.312.178.675.572.735.935z',
	            fill: '#C7C7DA'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M56.53 16.497l.001.114c.016 1.034-.078 2.118-.343 3.12-.293 1.103-.997 2.083-2.083 2.562-1.035.456-2.182.685-3.316.537-1.223-.16-2.368-.824-2.762-1.959-.34-.193-.6-.507-.714-.891-.41-1.384-.176-2.865.504-4.128.678-1.26 1.855-2.208 3.232-2.66.553-.18 1.113.021 1.497.398.304.005.597.062.885.15a1.734 1.734 0 0 1 1.063-.329c.93.04 1.612.694 1.872 1.53.149.478.157 1.047.163 1.556zm-4.39.484c-.02.044-.042.088-.065.13l-.004.01c.136-.222.112-.21.068-.14z',
	            fill: '#fff'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M65.785 24.1c-.421 1.446-1.058 2.79-1.695 4.138-.168.355-.471.656-.746.95-.433.463-.875.92-1.348 1.342a15.97 15.97 0 0 1-1.446 1.139c-.78.546-1.591 1.045-2.37 1.59a4.827 4.827 0 0 1-1.069.564c-.946.36-1.902.639-2.926.661-.385.009-.702-.034-.842-.448a.251.251 0 0 0-.052-.091c-.617-.646-.39-1.32-.05-1.985.206-.406.428-.809.684-1.185.265-.387.284-.78.15-1.201-.095-.298-.221-.572-.096-.913.108-.291-.107-.536-.313-.737-.112-.11-.257-.186-.377-.289-.233-.198-.231-.268-.04-.525.145-.196.293-.393.42-.602.195-.324.127-.631-.211-.8-.604-.299-1.229-.594-1.926-.382-.595.18-1.191.065-1.786.096-.702.036-1.22-.252-1.719-.731-.416-.4-.76-.824-1.022-1.325a.805.805 0 0 0-.348-.36 2.091 2.091 0 0 1-.72-.667c-.808-1.202-1.467-2.477-2.05-3.799-.46-1.045-.975-2.066-1.476-3.093a50.248 50.248 0 0 1-1.75-4.007c-.308-.8-.695-1.576-1.107-2.331-.222-.407-.277-.81-.147-1.21.33-1.02.692-2.036 1.306-2.926.535-.774 1.31-1.277 2.19-1.595.728-.264 1.48-.464 2.223-.693 2.496-.615 5.016-.819 7.576-.56 1.784.18 3.536.49 5.192 1.197 1.284.549 2.523 1.183 3.64 2.032.336.256.687.493 1.027.745 1.096.812 1.864 1.85 2.231 3.17.179.64.382 1.275.547 1.918.092.356.16.723.18 1.088.04.673.264 1.284.55 1.88.044.095.106.186.128.286.237 1.098.466 2.193.501 3.328.067 2.168-.31 4.255-.913 6.33zM51.18 28.596c-.138.379-.094.705.23.994.094.084.108.326.07.473-.05.193-.186.365-.287.549-.346-.23-2.17-2.918-2.406-3.536.465-.169.926-.043 1.445-.023-.046.758.469 1.129.948 1.543zm1.253 8.937c-.238.203-.467.423-.73.59-.712.457-1.431.906-2.166 1.325-.535.305-1.086.59-1.654.827-.636.265-1.269.516-1.86.885-.548.343-1.16.584-1.736.885-.435.227-.865.465-1.283.721-.629.387-1.246.793-1.866 1.194-.532.344-1.061.692-1.591 1.04-.044.029-.08.074-.128.093-.797.327-1.407.924-2.097 1.408-.575.403-1.213.715-1.816 1.078-.618.373-1.24.74-1.837 1.144-.845.572-1.654 1.197-2.505 1.76a173.432 173.432 0 0 1-4.484 2.895c-1.123.696-2.303 1.3-3.428 1.992-.854.525-1.663 1.123-2.492 1.689l-.471.323c-.354-.633-.685-1.208-.998-1.792-.69-1.288-1.444-2.534-2.346-3.689-.803-1.029-1.517-2.108-2.049-3.31-.454-1.026-1.017-2.003-1.5-3.017-.43-.903-.813-1.828-1.224-2.74-.93-2.07-2.014-4.062-3.136-6.034a27.599 27.599 0 0 1-.995-1.978c-.859-1.839-1.883-3.583-3.114-5.193a11.85 11.85 0 0 1-1.166-1.86c-.237-.468-.569-.887-.846-1.335-.274-.444-.257-.507.142-.818 1.216-.95 2.58-1.644 3.972-2.294.894-.418 1.774-.868 2.655-1.315 1.21-.613 2.42-1.226 3.618-1.86a18.11 18.11 0 0 0 1.494-.9c1.649-1.087 3.248-2.255 4.943-3.264 2.06-1.227 4.173-2.37 6.31-3.461 1.476-.755 2.985-1.447 4.409-2.301 1.527-.917 3.058-1.828 4.584-2.748.49-.296.602-.302.903.16 1.1 1.678 2.123 3.387 2.767 5.313.377 1.126.969 2.182 1.47 3.267.642 1.387 1.267 2.782 1.943 4.152.403.817.89 1.593 1.34 2.386.895 1.576 1.755 3.172 2.697 4.72.896 1.47 1.887 2.885 2.824 4.332 1.032 1.594 2.05 3.199 3.08 4.795.102.159.24.297.37.437.161.171.184.338-.003.498zM68.08 26.277c.158-.446.3-.9.405-1.361.26-1.146.524-2.291.735-3.446a12.5 12.5 0 0 0 .067-4.194c-.44-2.796-1.124-5.537-1.921-8.251-.42-1.429-1.125-2.698-2.228-3.711-.62-.57-1.28-1.106-1.97-1.588-1.23-.858-2.487-1.678-3.877-2.27C58.133.963 56.923.631 55.695.373 55.112.25 54.51.204 53.914.157a38.274 38.274 0 0 0-2.062-.1c-.936-.023-1.88-.107-2.806-.014-1.297.13-2.585.375-3.87.615-1.585.296-3.12.745-4.513 1.602-.944.58-1.82 1.215-2.34 2.228-.229.448-.446.902-.714 1.445-.051-.063-.088-.129-.142-.174-.416-.34-.74-.81-1.32-.923-.055-.011-.096-.096-.143-.147-.361-.393-.373-.403-.858-.214-.227.09-.45.202-.657.33-.3.185-.58.403-.877.59-1.12.703-2.239 1.41-3.37 2.096-1.085.658-2.172 1.317-3.283 1.931-1.481.819-2.992 1.586-4.48 2.392-.776.42-1.534.874-2.297 1.316-1.206.698-2.438 1.356-3.606 2.111-1.23.794-2.355 1.75-3.603 2.51-1.58.962-3.227 1.82-4.867 2.683-1.966 1.036-4.03 1.89-5.901 3.104-.62.402-1.264.77-1.872 1.189-.38.262-.42.584-.193.995.101.184.243.345.358.523.824 1.278 1.809 2.47 2.163 4.001.022.097.101.183.16.27.504.763 1.043 1.506 1.507 2.292.598 1.014 1.147 2.057 1.698 3.097.616 1.164 1.21 2.34 1.814 3.51.549 1.061 1.131 2.106 1.64 3.185.492 1.042.875 2.136 1.369 3.177.82 1.73 1.687 3.438 2.541 5.151.108.216.267.406.392.614.17.285.307.592.499.861.65.918 1.336 1.81 1.97 2.737.354.52.629 1.094.944 1.64.26.454.397.965.79 1.359.291.29.498.675.696 1.042.43.796 1.089 1.034 1.892.616a6.527 6.527 0 0 0 1.023-.653c1.643-1.291 3.494-2.255 5.272-3.333 1.418-.859 2.848-1.7 4.248-2.587 1.192-.754 2.34-1.577 3.526-2.34 1.5-.962 3.026-1.882 4.527-2.842 1.649-1.055 3.255-2.177 4.929-3.19 1.599-.969 3.287-1.78 5.021-2.493.815-.335 1.62-.7 2.401-1.105.813-.423 1.593-.908 2.383-1.373a1.41 1.41 0 0 0 .32-.267c.133-.145.572-1.8.546-1.997-.002-.018-.01-.034-.013-.051-.092-.69-.041-.754.646-.834.035-.005.071-.015.105-.01.567.07 1.078-.11 1.58-.337.079-.037.17-.047.254-.074.703-.23 1.406-.447 2.025-.887.861-.611 1.76-1.17 2.632-1.768.625-.428 1.28-.828 1.837-1.333a29.685 29.685 0 0 0 2.25-2.3c.368-.415.636-.923.92-1.406.214-.362.391-.747.567-1.13.182-.398.362-.798.508-1.21zm3.95-2.01c-.06-.427-.34-.876-1.042-.965-.483-.062-.907.326-.837.796.037.242.092.491.068.73-.165 1.66-.692 3.185-1.772 4.491-.225.271-.45.543-.67.817-.272.338-.288.536-.006.834.465.495 1.403.703 2.008.025.998-1.12 1.77-2.354 2.14-3.825.226-.897.364-1.788.111-2.904zM6.477 40.95c-.492-1.065-1.19-1.978-2.048-2.778-.204-.19-.395-.4-.563-.621-.363-.48-.886-.614-1.437-.659-.286-.023-.558.067-.684.384-.12.302-.12.577.105.833.208.238.401.49.614.723.713.782 1.388 1.587 1.739 2.61.042.123.154.23.254.325.19.181.391.351.595.518.346.283.611.317.915.13.42-.26.724-.826.622-1.204-.03-.068-.068-.166-.112-.261zm68.436-14.04c-.133-.198-.33-.36-.52-.51-.285-.229-.603-.368-.996-.24-.405.184-.758.41-.838.909-.041.258-.096.52-.188.764-.197.524-.419 1.038-.637 1.554-.084.197-.19.398-.05.597.328.463.782.749 1.34.862a.39.39 0 0 0 .256-.033c.345-.207.712-.393.846-.821.067-.217.168-.424.238-.64.213-.65.43-1.297.616-1.954a.657.657 0 0 0-.067-.488zM3.45 41.267c-.233-.329-.564-.524-.931-.668-.13-.05-.26-.11-.394-.146-.228-.062-.46-.11-.69-.164-.47.166-.61.378-.468.822.056.178.17.34.273.5.315.483.64.961.959 1.443.038.057.055.144.107.175.406.239.806.492 1.233.684.143.064.397.02.537-.072.368-.239.492-.948.248-1.324-.276-.426-.58-.835-.874-1.25zm29.348-7.097a3.834 3.834 0 0 1-.267.626c-.247.446-.533.871-.768 1.323-.402.769-1.064 1.254-1.792 1.663-.413.233-.864.4-1.29.613-.393.199-.798.23-1.233.194-1.08-.091-2.052-.503-3.01-.953a1.306 1.306 0 0 1-.497-.46c-.474-.723-.89-1.477-1.099-2.328-.112-.602-.24-1.203-.043-1.815a.629.629 0 0 0 .019-.259c-.133-1.126.276-2.105.849-3.032.23-.373.5-.724.777-1.065.089-.11.253-.164.39-.228.219-.103.451-.178.666-.289.675-.35 1.344-.698 2.147-.64.157.012.366-.045.476-.149a.74.74 0 0 1 .736-.182c1.166.317 2.283.748 3.196 1.572.153.138.287.317.374.503.202.427.411.859.537 1.31.081.291.02.62.022.933.009.893.106 1.793-.19 2.663zm-.955-7.649c-.868-.454-1.842-.705-2.752-1.085-.825-.344-1.627-.255-2.428.033-.763.274-1.512.59-2.276.863-.885.317-1.621.79-2.173 1.585-.851 1.227-1.61 2.469-1.71 4.012-.065 1.001-.145 1.996.113 3.077.242.92.676 1.86 1.267 2.722.491.716 1.095 1.292 1.945 1.63 1.199.478 2.385.947 3.693 1.042.79.057 1.55.02 2.271-.337.583-.287 1.18-.55 1.744-.872.578-.33 1.123-.718 1.68-1.084.613-.403.743-1.13 1.14-1.68.06-.085.092-.193.157-.274.398-.5.563-1.096.656-1.703.12-.778.232-1.564.246-2.349.017-.964-.105-1.915-.489-2.83-.593-1.413-1.84-2.1-3.084-2.75zM56.4 18.928c-.107.257-.241.502-.34.761-.2.522-.37 1.056-.58 1.574-.155.38-.418.686-.77.911-.791.503-1.649.782-2.594.784-.352.001-.704.03-1.056.037-.83.017-1.4-.446-1.839-1.07-.32-.458-.587-.96-.652-1.537-.042-.17-.086-.34-.126-.51-.273-1.157.065-2.233.515-3.266.374-.861 1.102-1.392 1.982-1.715.272-.1.533-.143.816-.001.151.076.34.084.514.109.188.027.347-.018.447-.203.23-.427.58-.565 1.058-.449.34.083.693.115 1.038.182.448.088.745.374.963.758.563.991.738 2.075.758 3.192.002.147-.075.3-.134.443zm1.619-4.55c-.317-.573-.76-.961-1.316-1.238-.779-.386-1.61-.569-2.481-.68a8.593 8.593 0 0 0-2.793.085c-.334.111-.686.186-.997.341-.662.33-1.313.684-1.95 1.06-.807.478-1.37 1.187-1.832 1.991-.377.656-.461 1.397-.657 2.104-.087.314-.111.66-.09.986.034.506.105 1.014.206 1.512.22 1.091.688 2.056 1.53 2.82.208.189.405.397.571.622a1 1 0 0 0 .643.412c.62.13 1.23.31 1.85.44 1.192.252 2.382.254 3.555-.107.302-.093.597-.212.892-.326.937-.361 1.77-.874 2.397-1.672.865-1.1 1.276-2.41 1.447-3.745.115-.899-.06-1.853-.223-2.762-.115-.646-.425-1.25-.752-1.843zm3.315-2.82l-1.614.393c-.877-1.299-2.428-1.57-3.924-1.974.165-.555-.055-.954-.327-1.342.29-.271.597-.414.962-.441.638-.047.932-.5.778-1.144-.151-.629-.163-.626-.823-1.335.46-.25 1.175-.16 1.457.232.313.438.705.75 1.169 1.023.353.21.669.521.924.847.341.437.72.813 1.19 1.102.23.142.426.307.453.699-.575.106-.75.547-.918 1.052l.673.888zm1.671-3.996c-.31-.335-.638-.651-.951-.981-.547-.576-1.091-1.142-1.937-1.285-.17-.028-.314-.203-.472-.31-.418-.28-.803-.655-1.264-.822-.844-.305-1.733-.49-2.652-.338-.382.063-.769.106-1.154.15-.639.074-1.252.192-1.736.675-.29.29-.35.502-.094.816.22.269.479.505.725.75.241.241.488.476.751.732-.148.095-.25.162-.355.227-.358.224-.722.438-1.073.673-.439.292-.458.393-.2.861.058.107.132.207.202.307.284.404.273.393-.06.733-.215.22-.391.48-.575.709.312.582.7.97 1.297 1.097.395.084.794.158 1.195.203.724.082 1.434.178 2.039.648.154.12.387.135.58.21.14.054.32.091.404.198.38.48.742.976 1.087 1.482.094.138.087.34.16.498.101.219.184.505.365.616.336.205.649.552 1.128.407.078-.024.177.005.261.026.272.068.455-.05.554-.284.241-.565.517-1.122.681-1.71.12-.428.286-.681.752-.72.376-.03.622-.27.846-.567.285-.376.195-.804.255-1.211.018-.117-.01-.292.057-.342.39-.289.31-.726.36-1.105.06-.455.007-.928-.278-1.312-.27-.364-.588-.696-.898-1.031zm-9.622 10.804c-.314-.104-.628-.208-.946-.298-.077-.022-.17-.002-.253.016-.565.119-1.058.345-1.326.94.114.214.193.437.334.608.154.185.355.337.555.477.332.233.708.478 1.11.264.38-.203.704-.511 1.043-.785.074-.06.139-.17.149-.262.046-.424-.235-.818-.666-.96z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'taco':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '55',
	            height: '51',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'taco'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h55v51H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M22.365 9.538c1.012.52 1.48.822 2.02 1.467 1.051 1.256 1.32 3.409-.277 4.564-1.773 1.282-2.965 1.81-4.258 1.489-.876-.218-1.487-.796-1.856-1.55-.192-.392-.292-.738-.42-1.31-.17-.764-.15-.677-.21-.876a2.188 2.188 0 0 0-.142-.368l.018.124c.304 2.106.275 3.317-.654 4.4-1.51 1.76-2.532 2.712-3.98 3.42-1.99.974-3.786 1.344-5.523.67-2.181-.846-4.091-2.12-4.652-3.886-.332-1.047-.156-2.088.322-3.215.191-.45.426-.898.717-1.391.096-.164.195-.326.313-.516l.26-.418.037-.06c.022-.316.116-.633.288-.925 1.4-2.376 2.18-3.627 2.827-4.498.916-1.236 1.72-1.909 2.85-2.085.641-.101 1.196-.007 1.828.217.19.068.893.354 1.07.418.503.183.985.302 1.577.368 1.717.192 3.042.293 3.968.32.615-.296 1.317-.369 1.972-.27.324.048.63.14.942.326.987.59 1.564 1.946.618 3.175a3.508 3.508 0 0 1-.127.156c.108.062.26.144.472.254zM6.385 16.29a1.433 1.433 0 0 1 .004.007l-.004-.007zm5.367-3.996a.787.787 0 0 0 .007.003l-.007-.003zm1.71 3.303a.152.152 0 0 0 .01-.003l-.004.001-.007.002zm-4.663-.482l-.004.001.01-.002-.006.001zm8.102-4.283v-.01.01z',
	            fill: '#C28E64'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M22.703 5.393c-2.811 0-2.811-4.26 0-4.26h4.733c2.81 0 2.81 4.26 0 4.26h-4.733zM11.706 26.89c-.416.037-.85.054-1.31.054-2.753 0-2.838-4.142-.088-4.258l.088-.002.95-.042c1.688-.16 2.956-.807 5.13-2.331l.36-.253c.988-.692 1.6-1.09 2.32-1.48 4.834-2.625 10.047-2.827 16.533-.09.185.078.383.15.597.215.442.136.76.206 1.735.398 1.944.384 2.896.694 3.978 1.531 3.87 2.997 6.141 7.7 7.914 14.804l-.148-3.16c-.127-2.701 3.803-3.085 4.19-.41.126.86.311 1.946.452 2.77.105.616.185 1.084.195 1.2.041.452.022.83-.053 1.393l-.095.66c-.063.43-.14.96-.183 1.264-.356 2.562-4.072 2.389-4.193-.195l-.02-.424a35.67 35.67 0 0 1-.323 1.605 20.88 20.88 0 0 0-.214 1.078c-.352 2.118-.728 3.52-1.43 4.795-.867 1.57-2.151 2.646-3.876 3.047-1.82.424-5.48-1.773-14.975-8.104l-.97-.648c-2.694-1.805-8.872-6.025-10.899-7.41l-.013-.008-.263-.18-.38-.259a6.64 6.64 0 0 0-.38-.227l-.128-.072-.051-.029-.087-.048-.359-.202c-.343-.194-.609-.354-.858-.52-.58-.385-.995-.747-1.306-1.262a2.536 2.536 0 0 1-.37-1.541l-.412-.86a2.14 2.14 0 0 1-.21-.834l-.848.035z',
	            fill: '#FFD65F'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M31.387 15.342a2.325 2.325 0 0 0 1.222-.969l.286.204c.398.38.847.702 1.313.935l6.05 4.312c.081.059.168.112.258.158.585.302 1.166.57 1.847.862.147.063.483.203.809.34l.01.004.033.014.682.286c.309.133.583.258.828.38l.199.196c.106.106.217.318.49 1.003.352.88.564 1.323.966 1.863.392.528.962.863 1.546 1.052.388.125.766.185 1.22.114a2.197 2.197 0 0 0 1.79-2.774c-.662-2.408-1.756-3.794-3.687-4.91-.49-.457-.959-.86-1.406-1.215.18-.237.288-.49.376-.778.057-.187.096-.379.126-.586a7.92 7.92 0 0 0 .072-1.028 7.127 7.127 0 0 0-.062-1.053 3.336 3.336 0 0 0-.16-.672c-.217-.597-.554-1.087-1.32-1.38a2.903 2.903 0 0 0-.222-.074c.225-.703.088-1.518-.65-2.175l-1.41-1.254c-.887-.79-1.898-.688-2.616-.164-.364-.348-.855-.696-1.53-1.103-.872-.528-3.084-1.456-5.075-2.12-3.04-1.014-5.037-1.379-6.46-.648a2.92 2.92 0 0 0-.864.667c-1.392-.126-2.701 1.215-2.21 2.768.15.473.26.868.505 1.775.537 1.996.821 2.894 1.348 4.018.516 1.099 1.486 1.49 3.143 1.88a7.616 7.616 0 0 0 1.47.219c.378.011.716-.02 1.083-.147zm8.728-3.67a2.49 2.49 0 0 1-1.214.63c1.038.134 1.742.24 2.344.375a2.501 2.501 0 0 1-.056-.05l-1.074-.954zm13.206 16.765l-.443-1.13c-1.035-2.635-4.98-1.078-3.944 1.557l.444 1.13c1.035 2.635 4.979 1.079 3.944-1.557z',
	            fill: '#7CC84A'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M17.365 3.482c-.828-.023-.945.046-.915.508l.915-.508zm24.027 6.853c-.189.175-.276.413-.06.583.295.233.652.388 1.003.588.12-.715.01-.842-.943-1.17zm9.676 18.076c-.201.445-.05.809.069 1.159.126.367-.007.809.286 1.139.885-.611.771-1.38-.355-2.297zm1.007 4.501c-.38.442-.329.803-.323 1.157.024 1.337.042 2.675.066 4.012.002.11.039.218.06.326l.126.007c.034-.217.071-.434.102-.652.036-.249.04-.506.105-.747.295-1.103.437-2.21.137-3.334-.058-.215-.148-.422-.273-.769zM13.952 16.51c-.273.247-.513.456-.743.676-.377.359-.793.468-1.282.25-.163-.072-.34-.11-.551-.177-.18.606.045 1.128.026 1.648-.02.543-.1 1.083-.155 1.65.647.08 1.143-.154 1.58-.492a91.85 91.85 0 0 0 2.529-2.04c.301-.25.192-.944-.17-1.09-.407-.165-.83-.288-1.234-.425zm6.557-13.78c.256.073.42.11.578.167 1.018.362 2.057.676 3.046 1.107 1.398.609 2.7.28 3.532-.99.067-.104.146-.199.224-.303-.153-.262-.27-.516-.604-.535-.423-.024-.853-.12-1.267-.072-1.088.125-2.155-.08-3.231-.13-.81-.037-1.61.013-2.278.756zm-5.278 3.539c-.213.19-.324.286-.432.386-.106.1-.221.193-.31.306-.341.434-.51.487-.965.284-.444-.198-.624-.507-.543-.957.022-.124.094-.242.105-.366.023-.274-.064-.523-.334-.626-.397-.15-1.178.25-1.36.672-.274.639-.777.922-1.456.803a3.174 3.174 0 0 1-.67-.186c-.494-.207-.914-.059-1.301.245-.487.381-.709.875-.65 1.511.035.378.018.766-.02 1.145-.067.652-.252.808-.895.797-.317-.006-.634-.045-.951-.059-.529-.023-.607.03-.797.53-.084.218-.142.449-.24.66-.08.169-.17.398-.314.458-.422.175-.395.509-.382.85.053 1.34.184 2.678-.282 3.988-.167.467-.145.976.204 1.398.406.49.792 1.001 1.235 1.456.346.356.739.68 1.217.873 0-.414.029-.79-.01-1.16-.03-.303.086-.494.317-.639.196-.123.394-.25.606-.338.365-.152.716.061.695.452-.018.33-.091.675-.223.977-.147.339-.388.636-.635 1.025 1.132.265 2.203.432 3.367.115-.19-.339-.37-.58-.47-.852-.158-.438-.357-.79-.827-.977-.337-.134-.487-.514-.359-.79.123-.265.261-.6.49-.724.468-.256.605-.65.756-1.108.127-.387.223-.877.677-1.032 1.246-.425 2.479-.495 3.659.32.063-.076.116-.17.194-.233.389-.318.743-.671 1.271-.792.678-.155 1.25.088 1.827.363.235.112.352.296.334.563-.02.317.154.51.39.656.76-.284 1.485-.585 2.229-.826.733-.237 1.485-.415 2.303-.638-.143-.185-.197-.315-.293-.37-.537-.306-1.036-.646-1.447-1.125-.264-.308-.716-.299-1.034-.028-.192.163-.339.379-.511.565-.259.28-.5.585-.79.828-.361.303-.85.159-1.051-.267-.317-.667-.616-.802-1.274-.512-.303.133-.534.077-.75-.135a.684.684 0 0 1-.111-.824c.31-.557.758-.91 1.415-.919.465-.006.93.019 1.395.027.183.004.366.001.635.001l-.17-.851c.116-.18.22-.367.35-.533.41-.523 1.259-.662 1.69-.2.498.533 1.128.8 1.754 1.1.38.183.795.314.955.78.03.083.146.175.236.193.412.082.457.413.49.729.026.25-.026.509-.02.763.004.145.054.29.083.434.173-.085.248-.168.252-.254.02-.467.054-.938.02-1.402a12.674 12.674 0 0 0-.226-1.512c-.082-.417-.374-.67-.774-.764-.494-.117-.998-.185-1.395-.558-.08-.075-.239-.087-.361-.087-.458 0-.692-.253-.802-.626l.802-1.04c-.107-.444-.38-.647-.747-.77-.259-.087-.527-.18-.752-.328-.355-.236-.723-.201-1.104-.152-.218.029-.334.164-.368.379-.023.147-.025.304-.078.44-.182.466-.28 1.006-1.038 1.188-.062-.095-.147-.273-.276-.41-.128-.134-.29-.301-.455-.324-.746-.105-1.044-.654-1.32-1.246-.104-.221-.228-.433-.38-.72zm20.001 9.137c.086-.246.153-.382.18-.525.107-.577.515-.86 1.01-1.04.267-.098.519-.087.755.152.411.417.695.9.642 1.478-.071.78.265 1.194.977 1.378.122.032.243.08.356.137.545.278 1.105.533 1.627.85.506.308.964.693 1.457 1.023 1.058.71 2.122 1.41 3.194 2.1.168.109.383.173.584.199.52.066.866.352.894.861.015.284.13.478.312.669.19.2.363.417.54.63.495.597.988 1.197 1.49 1.804.38-.59.358-1.23.37-1.871.01-.501-.112-.915-.531-1.232-.33-.248-.583-.582-.623-1.007-.052-.552-.319-.912-.828-1.093a10.867 10.867 0 0 0-.781-.246c-.306-.084-.643-.099-.92-.237-.97-.483-2-.656-3.089-.69l-.179-.606c-.024-.082-.056-.162-.073-.245-.118-.565.053-.883.601-.992.545-.108 1.082-.37 1.664-.088.193.093.448.058.664.081.534-.733.472-1.473.11-2.156-.335-.635-.79-1.208-1.221-1.788-.116-.156-.333-.236-.524-.364-.647.794-1.36 1.306-2.426.856-.107.284-.197.518-.283.753-.074.199-.127.409-.221.597-.163.324-.4.538-.806.498-.396-.039-.612-.282-.73-.62-.085-.239-.083-.509-.17-.747-.106-.294-.214-.613-.41-.845-.579-.682-1.199-1.313-2.13-1.527-.535-.123-.96-.435-1.066-1.022.15-.395.46-.569.807-.697.607-.226 1.204-.193 1.796.062.287.124.58.235.924.374.08-.205.172-.352.191-.507.06-.486.1-.975.133-1.464.031-.447-.17-.74-.553-.993-1.386-.916-2.944-1.296-4.548-1.522-.679-.095-1.352-.003-1.947.41-.26.181-.543.328-.816.489-.48.282-.944.11-1.072-.425a2.378 2.378 0 0 1-.035-.75c.075-.837-.299-1.168-1.089-.951-.413.113-.785.276-1.12.568-.402.35-.88.587-1.42.68-.927.16-1.855.131-2.784.033-.522-.055-.669.1-.565.595.073.353.151.709.181 1.067.04.481.212.81.735.865.387.04.664.264.858.59.681 1.144 1.119 2.347.878 3.711-.07.4-.153.796-.217 1.197-.021.138-.003.282-.003.467.474 0 .913.008 1.351-.001 1.342-.029 2.664.154 3.988.339.28.039.57.006.867.006 0-.164.012-.27-.002-.371-.084-.655-.41-1.2-.763-1.739-.659-1.004-1.485-1.818-2.63-2.211-.445-.153-.638-.456-.81-.827-.136-.293-.047-.54.172-.752.635-.618 1.345-.726 2.145-.292.385.209.744.466 1.133.712.868-.942 1.979-1.385 3.148-1.728.319-.093.48.022.599.294.277.637-.062 1.42-.72 1.69-.35.145-.701.296-1.027.488-.498.293-.625.783-.375 1.319.144.309.29.617.454.916.367.667.361 1.34.082 2.033-.084.21-.135.433-.223.722l1.861.478zM7.91 23.811c.645.517 1.235 1.122 1.94 1.527 1.35.778 2.62 1.647 3.764 2.711.34.317.727.588 1.11.852.926.64 1.928 1.185 2.777 1.913 1.043.892 2.16 1.643 3.33 2.34.983.586 1.92 1.251 2.88 1.878.23.15.471.283.701.435.404.264.817.517 1.198.812.47.362.9.775 1.365 1.143 1.818 1.435 3.636 2.87 5.468 4.287a549.01 549.01 0 0 0 6.663 5.096c.885.663 1.904 1.1 2.947 1.464 1.053.369 2.085.304 3.078-.197.255-.129.438-.437.697-.514.466-.137.76-.466 1.049-.792a7.307 7.307 0 0 0 1.326-2.17c.831-2.105 1.243-4.305 1.347-6.553a30.708 30.708 0 0 0-.275-5.748c-.217-1.522-.601-2.995-1.263-4.408-.48-1.023-1.188-1.858-1.808-2.768-.657-.963-1.506-1.737-2.415-2.426-1.047-.793-2.172-1.483-3.272-2.204-.6-.394-1.212-.773-1.835-1.13-.254-.145-.566-.186-.827-.321-1.23-.637-2.506-1.144-3.854-1.463-.103-.025-.204-.06-.305-.093-1.562-.521-3.177-.76-4.813-.8-1.035-.026-2.073.11-3.11.129a9.494 9.494 0 0 0-2.63.394c-.467.143-.932.295-1.404.412-2.477.616-4.621 1.892-6.623 3.423-.668.511-1.24 1.151-2.066 1.42-.338.11-.683.2-1.027.284-.204.05-.418.058-.622.108-.884.22-1.76.472-2.685.459-.297-.005-.6.04-.806.5zM.05 17.922c-.15-.571.053-1.03.433-1.455.126-.141.191-.378.2-.575.021-.51.011-1.023-.016-1.533-.02-.4.021-.74.341-1.04.424-.398.482-.981.622-1.514.075-.287.126-.583.174-.877.098-.606.423-1.058.908-1.41.171-.125.364-.236.497-.396.532-.64 1.25-1.008 1.966-1.369.31-.156.413-.397.483-.697.324-1.37 1.34-2.12 2.467-2.762.435-.248.902-.218 1.355-.068.254.083.439.065.626-.136.527-.57 1.289-.7 1.952-1.01.164-.076.416-.016.61.04.557.163 1.048.133 1.421-.375.405-.55 1.082-.636 1.624-.951.602-.351 1.231-.674 1.884-.914.55-.201 1.146-.28 1.726-.387C20.261.321 21.2.14 22.145.026c.52-.063 1.055.01 1.584.008.737-.002 1.474-.024 2.211-.022.655.002 1.313-.005 1.964.05.568.047 1.133.159 1.693.271.434.087.867.197 1.288.336 1.228.406 2.456.814 3.67 1.256.737.268 1.446.61 2.175.9.631.251.894.833 1.187 1.36.254.457.6.728 1.047.967.784.418 1.536.9 2.285 1.38.284.182.412.482.359.834-.052.35.116.524.416.692.573.319 1.139.664 1.648 1.073.262.21.498.559.567.883.115.54.441.819.889.987.82.309 1.403.847 1.745 1.657.348.823.698 1.645 1.057 2.463.084.19.191.38.323.54.583.708.985 1.49 1.02 2.428.011.3.117.53.37.698.177.117.35.247.499.397.174.177.406.36.463.58.142.55.413.947.903 1.242.34.203.412.645.361.974-.102.661.196 1.16.516 1.644.528.801.773 1.658.639 2.606-.063.445.094.764.356 1.106.293.382.513.824.732 1.257.274.543.291 1.093.014 1.66-.24.49-.183.985.08 1.47.801 1.487.958 3.041.64 4.71-.541 2.837-1.697 5.403-3.213 7.82-.53.844-1.086 1.712-1.797 2.39-.863.824-1.512 1.896-2.66 2.42-.313.142-.56.453-.807.714a2.991 2.991 0 0 1-1.767.93c-.105.017-.214.019-.314.05-2.097.66-3.891-.123-5.63-1.185-.271-.166-.552-.317-.83-.47-1.738-.964-3.21-2.296-4.767-3.506-1.995-1.551-3.945-3.162-5.936-4.72a276.34 276.34 0 0 0-5.57-4.25c-.918-.683-1.898-1.282-2.852-1.916-1.059-.705-2.136-1.369-3.078-2.254-.672-.633-1.503-1.107-2.3-1.59a9.633 9.633 0 0 1-1.808-1.401c-.746-.738-1.606-1.313-2.513-1.837-.73-.421-1.5-.793-2.071-1.46-.217-.252-.526-.427-.799-.63-.8-.594-1.597-1.197-2.41-1.776-1.048-.746-1.72-1.813-2.436-2.844a30.876 30.876 0 0 1-.741-1.116c-.361-.57-.605-1.178-.498-1.88zm32.128 4.522c.457-.557 1.056-.922 1.717-1.178.153-.06.361.026.525.043.222.825-.145 1.829-.779 2.224-.468.292-.876.13-1.08-.4-.087-.226-.235-.428-.383-.689zm10.495 12.643c-.092.532-.338.943-.67 1.305-.266.289-.612.35-.976.187-.339-.152-.58-.518-.476-.873.064-.22.258-.424.44-.58.523-.444 1.106-.453 1.682-.039zM28.381 29.59c.793-1.045 1.311-1.233 2.099-.764.035.657-.407 1.098-.777 1.539-.338.403-.912.25-1.134-.248-.078-.173-.129-.358-.188-.527zm-7.044-4.258c-.07.586-.194 1.113-.642 1.507-.308.27-.692.353-.924.183-.269-.198-.4-.79-.245-1.1.327-.653 1.102-.928 1.811-.59zM44.67 42.39c.085.03.296.07.473.172.182.105.267.311.12.49-.267.323-.525.685-.866.91-.558.366-1.183-.018-1.178-.684a.723.723 0 0 1 .18-.44c.29-.316.689-.455 1.271-.448zm-2.841-16.076c.464-.252.903-.543 1.381-.735.49-.198.747.05.601.566-.09.316-.271.612-.443.897-.142.236-.338.484-.643.425-.331-.065-.637-.228-.746-.602-.047-.16-.088-.32-.15-.55zm-6.339 12.01c.247.152.516.238.639.422.075.114-.029.406-.13.568a3.668 3.668 0 0 1-.61.726c-.275.254-.571.156-.881 0-.303-.151-.372-.399-.369-.68.002-.138.056-.337.154-.398.373-.23.773-.417 1.197-.638zM27.884 20.07c.05.77-.285 1.262-.66 1.722-.245.299-.673.239-1.007-.095-.344-.344-.38-.645-.045-.925.305-.255.646-.48 1.003-.652.185-.09.439-.036.709-.05zm18.613 11.033l.486.247c-.027.81-.408 1.417-1 1.624-.35.123-.654-.013-.824-.367-.19-.398-.111-.717.238-.907.184-.1.38-.18.565-.279.162-.086.316-.187.535-.318zm-10.89-2.103c.04.614-.364 1.016-.733 1.412-.203.218-.746.106-.924-.129-.274-.364-.232-.817.098-1.06.701-.518.93-.552 1.559-.223zM7.968 13.592c.105-.423.075-.773.478-.949.239-.104.45-.32.615-.532a.913.913 0 0 0 .183-.562c-.012-.248-.135-.489-.192-.737-.182-.8-.208-1.586.17-2.35.172-.346.451-.489.798-.552.187-.033.374-.07.563-.084.385-.03.643.237.6.63-.018.167-.098.33-.107.497-.01.207-.053.473.052.614.393.53.195 1.012-.15 1.388-.408.444-.492.881-.386 1.45.11.586-.138 1.15-.4 1.643-.4.752-1.337.772-1.865.098-.149-.191-.265-.408-.359-.554zm5.997-4.121c.037-.002.164-.002.288-.017.583-.071 1.162.529 1.03 1.095-.03.126-.151.26-.266.333-.705.45-1.02 1.115-1.065 1.924-.037.676-.515 1.056-.95 1.45-.252.229-.559.107-.8-.235a27.865 27.865 0 0 0-.478-.667c-.255-.342-.26-.752.107-1.17.4-.457.535-.99.671-1.555.2-.83.591-1.284 1.463-1.158zm-7.382 5.117c-.451.319-.784.294-1.13.042-.127-.093-.323-.086-.48-.145-.494-.188-.654-.714-.39-1.176a1.03 1.03 0 0 0 .146-.527c-.024-.508.233-.79.665-.97.13-.054.262-.119.37-.207.305-.25.504-.23.687.107.07.129.111.278.136.423.076.44.188.88.189 1.322 0 .392-.129.785-.193 1.131zm.571 1.259c.007.738-.333 1.301-.874 1.763-.254.217-.576.287-.817.09-.248-.203-.433-.508-.571-.804-.039-.082.155-.344.298-.426.315-.182.5-.422.612-.769.06-.188.222-.356.37-.5.195-.191.433-.234.7-.126.281.113.275.345.282.58.002.064 0 .128 0 .192z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'vans':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '94',
	            height: '50',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg',
	            className: 'vans'
	          },
	          _react2.default.createElement('path', { fill: 'none', d: 'M0 0h94v50H0z' }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M10.5 41.208c.227.034.463.002 1.081-.082.392-.204.63-.327.802-.446 0 0 7.591-.231 7.675-.243 1.9-.261 3.194-.4 9.494-1.042 2.686-.274 4.359-.45 5.944-.635a104.03 104.03 0 0 0 3.77-.493c1.258-.194 4.306-.648 6.279-.942l1.743-.26c2.775-.421 4.862-.768 6.902-1.16 4.731-.907 9.044-2.04 14.016-3.738 1.73-.59 11.59-7.756 13.25-9.386 1.47-1.442 1.987-2.422 2.201-3.917.088-.152.319-.43.755-.849.276-.264.802-.726 1.31-1.172l.007-.005.01-.009c.54-.474 1.055-.927 1.223-1.102 1.34-1.399 1.64-2.694 1.736-6.19l.015-.354c.011-.226.016-.344.02-.49.031-1.294-.152-2.28-.89-3.237-1.72-2.225-4.069-3.455-6.927-3.85-2.167-.3-4.492-.134-7.511.4-.765.136-1.484.276-2.633.51-3.533.718-4.66.91-6.034.954-6.927.226-12.215.224-17.326-.078-.84-.05-1.57-.204-3.265-.648l-.436-.114c-2.11-.548-3.405-.765-4.926-.688-4.462.225-6.89.656-8.126 1.572a3.41 3.41 0 0 0-.14.11 285.379 285.379 0 0 0-4.672-1.205L23.456 1.07c-1.267-.713-2.864-.138-3.402 1.225a30.464 30.464 0 0 0-.755 2.15l-.003.01c-.11.345-.272.855-.325 1.012-.395 1.171-.54 1.314-2.201 1.851-.424.137-.966.278-1.718.45-.413.093-2.004.439-2.06.45l-.002.001c-.91.2-1.622.368-2.323.552-3.28.858-5.661 1.92-7.41 3.62-2.377 2.315-3.11 5.503-1.993 9.33.395 1.353.86 2.576 1.494 4.006.186.42.38.842.65 1.423l.333.714.339.73c1.173 2.544 1.873 4.23 2.205 5.246.177.54.186.594.181.69l-.005.158c-.025 1.165.319 1.885 2.332 5.328l.019.033a4.534 4.534 0 0 0 .124.189c.035.048.075.094.229.27l.005.005.002.003.002.002.002.001c.045.048.08.085.116.118.106.095.233.165.707.426l.004.003c.22.074.357.12.497.141z',
	            fill: '#E8506D'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M10.577 12.16c-.376.215-.747.433-1.285.755-1.804 1.08-2.745 1.616-3.479 1.92a1.392 1.392 0 0 0-.212-.034c-.406-.033-.817.124-1.064.504a.997.997 0 0 0-.376 1.018c-.187 1.274.749 2.357 2.376 3.075 1.52.67 3.731 1.088 6.083 1.189 2.356.102 4.63-.125 6.269-.663 2.136-.701 3.322-1.998 2.794-3.763-.243-.814-.679-1.245-1.681-1.96l-.068-.049c-.508-.362-.717-.54-.862-.743-.043-.06-.086-.214-.143-.567l-.013-.084c-.172-1.088-.365-1.585-1.133-1.974-1.953-.988-4.073-.406-7.206 1.377zm4.586.234a7.053 7.053 0 0 0-1.435.44c.558-.195 1.057-.35 1.435-.44z',
	            fill: '#CD8168'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M39.278 1.957a.376.376 0 0 0-.14.51l2.36 4.216c.1.18.326.243.503.142a.376.376 0 0 0 .14-.51l-2.36-4.217a.368.368 0 0 0-.503-.141zM45.474 4c.727.964 1.16 2.137 1.063 2.796.1 0 .2.041.272.122a.377.377 0 0 1-.024.528c-.188.174-.506.458-.858.773-.761.681-1.685 1.509-1.823 1.683-.16.203-.909 1.636-1.365 2.51l-.002.004c-.147.28-.263.503-.32.608a.368.368 0 0 1-.502.15.376.376 0 0 1-.147-.508l.198-.377.024-.047.006-.012c.437-.837 1.318-2.527 1.53-2.795.18-.228 1.257-1.192 2.043-1.896l.024-.021.286-.256c-.61-.283-1.126-2.01-1.526-4.85a.373.373 0 0 1 .314-.422.37.37 0 0 1 .418.317c.082.58.17 1.11.26 1.585a.37.37 0 0 1 .13.108zm6.038-1.072a.375.375 0 0 0-.227.477l.096.291.001.004V3.7l.002.004v.004c.17.515.48 1.465.583 1.637.098.163.733.834 1.119 1.242l.003.004.003.003.015.016.245.26a.367.367 0 0 0 .523.022c.15-.14.16-.377.021-.529-.09-.099-.248-.266-.424-.451l-.002-.002c-.37-.392-.818-.865-.87-.953-.055-.09-.275-.76-.444-1.276l-.006-.02v-.001c-.07-.214-.131-.4-.167-.503a.369.369 0 0 0-.471-.23zm7.66 9.604a.371.371 0 0 0 .39-.352l.007-.107v-.001c.088-1.552.11-1.925.259-2.237a2.83 2.83 0 0 1 .186-.313l.02-.03.397-.588.006-.01.017-.024.01-.015c.228-.338.44-.663.677-1.048.65-1.05 1.391-2.376 2.289-4.127a.376.376 0 0 0-.159-.504.368.368 0 0 0-.498.16c-.889 1.733-1.62 3.042-2.26 4.075-.231.376-.437.692-.66 1.023l-.006.009-.015.021c-.078.115-.35.516-.416.617-.456.703-.459.717-.592 3.056a.373.373 0 0 0 .348.395zm-23.267.66a.367.367 0 0 1-.513.103.376.376 0 0 1-.101-.519l3.517-5.301a.367.367 0 0 1 .513-.102c.17.115.215.347.1.519l-3.516 5.3zm12.306-1.354a.367.367 0 0 0 .518-.071l2.092-2.786a.377.377 0 0 0-.071-.524.367.367 0 0 0-.519.072l-2.091 2.786a.377.377 0 0 0 .07.523zm6.88-.198a.368.368 0 0 1-.51.12.376.376 0 0 1-.12-.514l1.874-3.056a.368.368 0 0 1 .51-.121c.173.108.227.34.119.515L55.09 11.64zm3.085-7.856a.375.375 0 0 1 .242-.468.37.37 0 0 1 .464.244l.608 1.96a.375.375 0 0 1-.242.469.37.37 0 0 1-.464-.245l-.608-1.96zM11.43 42.914c-.556-1.46.501-3.034 2.05-3.05 6.936-.069 11.668-.077 14.704-.046.274-.19.576-.323.947-.45 1.405-.485 4.789-1.072 10.864-1.848 1.81-.231 3.27-.31 6.412-.4 3.284-.094 4.695-.173 6.406-.41 2.37-.33 4.297-.784 8.556-1.932.597-.162.843-.228 1.143-.308.103-.351.287-.673.532-.94.253-.275.506-.439.797-.578 2.048-.977 2.946-1.279 4.56-1.664.096-.023.168-.04.234-.058 1.207-.31 2.862-1.313 8.573-5.476 1.383-1.009 4.663-3.144 4.57-3.08.724-.501 1.233-.924 1.724-1.448.529-.563 1.061-1.272 1.669-2.242.164-.262.35-.718.64-1.575l.068-.2.024-.07.185-.548c.85-2.485 1.553-3.788 3.068-4.655 1.692-.968 3.393-.193 4.174 1.405.4.82.598 1.872.654 3.095.104 2.28-.29 4.809-1.12 6.19-1.622 2.7-3.48 4.293-7.577 7.056l-.575.388c-1.43.966-2.254 1.552-3.077 2.214-.74.596-3.686 3.066-3.438 2.86-3.813 3.166-6.425 4.933-9.342 5.97-.512.183-1.028.357-1.55.524-4.872 1.562-8.868 2.265-17.367 3.334-3.22.405-4.293.544-5.922.78-1.777.256-3.467.343-5.985.363-.298.003-.536.004-1.07.006-2.767.012-3.986.048-5.493.204-1.908.197-3.52.43-4.92.697-.906.173-2.32.535-3.535.846h-.004l-.006.002c-1.04.267-1.933.495-2.236.536-1.707.227-3.244-.097-6.584-1.288-.879-.314-1.565-.74-2.071-1.544a2.481 2.481 0 0 1-.345-1.776l-.337-.884zM52.832 25.42a1.473 1.473 0 0 0 1.967.722l3.573-1.69c.74-.35 1.06-1.24.714-1.988a1.473 1.473 0 0 0-1.967-.721l-3.574 1.689c-.74.35-1.06 1.24-.713 1.988z',
	            fill: '#fff'
	          }),
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M90.898 20.462c-.396.883-.889 1.706-1.425 2.506-.326.487-.616.998-.935 1.488-.178.273-.382.528-.577.789-.507.678-.98 1.386-1.531 2.026-1.401 1.628-2.648 3.387-4.183 4.903-1.143 1.128-2.396 2.094-3.725 2.97a208.557 208.557 0 0 1-3.882 2.502c-.366.23-.78.382-1.176.562-.384.173-.787.309-1.156.509-.802.434-1.663.703-2.516 1.004-.853.3-1.683.668-2.528.995-.935.362-1.872.72-2.813 1.066a44.92 44.92 0 0 1-2.155.742c-.616.191-1.243.352-1.872.495-1.132.257-2.264.519-3.405.726-.985.178-1.984.277-2.975.424-.653.096-1.302.219-1.953.321-.366.057-.735.099-1.103.144-1.38.167-2.756.37-4.14.487-1.157.099-2.322.11-3.483.132-.79.016-1.584-.066-2.37-.008-.864.065-1.729.201-2.58.377-1.151.239-2.28.548-3.477.56-1.142.012-2.282.185-3.423.287-.096.009-.193.027-.289.024-1.006-.038-1.99.128-2.984.26-1.102.147-2.221.152-3.333.217-1.016.06-2.032.105-3.047.182-.448.033-.892.138-1.34.193-.384.046-.772.059-1.158.1-.8.088-1.601.179-2.4.283-.208.027-.372.01-.525-.154-.885-.953-1.778-1.897-2.663-2.849-.14-.15-.255-.327-.44-.57.37-.063.661-.145.955-.157.514-.023 1.031-.006 1.547 0 1.567.015 3.134.033 4.696-.148.256-.03.516-.02.774-.038.497-.034.994-.082 1.491-.113.483-.03.979-.124 1.45-.054 1.193.179 2.355.012 3.486-.308 1.337-.378 2.695-.514 4.067-.615 1.257-.092 2.51-.23 3.768-.32a86.974 86.974 0 0 1 5.14-.24l-.317.103c.433.089.848.003 1.265-.059 1.358-.2 2.716-.4 4.076-.59.222-.032.452-.008.678-.01a.866.866 0 0 0 .561-.19c.227-.17.572-.176.885-.19l-.694.25c.343.158.603.027.858-.01.4-.057.79-.169 1.189-.227 1.372-.201 2.749-.375 4.12-.59.62-.096 1.232-.261 1.846-.403 1.024-.235 2.048-.471 3.07-.716 1.178-.283 2.388-.43 3.534-.853a3.5 3.5 0 0 1 .66-.162c1.02-.163 1.93-.649 2.87-1.037 1.226-.506 2.391-1.145 3.549-1.8.843-.478 1.752-.839 2.642-1.226 1.164-.506 2.23-1.18 3.293-1.866.476-.308.967-.596 1.428-.925 1.24-.885 2.557-1.646 3.749-2.613.766-.622 1.408-1.347 2.098-2.031 1.154-1.145 2.266-2.334 3.387-3.511.898-.943 1.802-1.88 2.67-2.851.945-1.058 1.791-2.193 2.374-3.51.13-.294.302-.57.455-.854a.88.88 0 0 1 .273.556c.06.603.098 1.208.153 1.811.024.261.06.521.106.779.046.252-.003.43-.236.581a1.062 1.062 0 0 0-.354.444zM48.98 41.05l-.031-.13 1.246-.153.014.103-1.229.18zm-37.238.566c.193-.02.38-.055.566-.057.986-.008 1.971 0 2.957-.015a8.114 8.114 0 0 0 1.157-.095c1.5-.241 3.005-.422 4.521-.535 1.143-.084 2.275-.301 3.416-.424a151.1 151.1 0 0 1 4.053-.376c2.867-.232 5.736-.452 8.604-.67.935-.072 1.87-.138 2.806-.185 1.17-.059 2.295-.375 3.442-.57 1.4-.237 2.806-.455 4.208-.687.7-.115 1.394-.26 2.095-.36.43-.061.871-.048 1.304-.094.577-.06 1.153-.137 1.727-.22.383-.056.762-.143 1.145-.2.862-.125 1.722-.278 2.59-.351.985-.084 1.908-.492 2.893-.539.73-.035 1.378-.305 2.035-.585.43-.184.896-.278 1.335-.442.788-.296 1.567-.613 2.35-.922.542-.214 1.078-.446 1.626-.642.938-.334 1.788-.827 2.623-1.364.46-.295.968-.528 1.478-.724.661-.255 1.226-.655 1.802-1.05.602-.412 1.225-.791 1.832-1.195.823-.549 1.658-1.082 2.456-1.668 1.085-.795 2.139-1.635 3.208-2.453.206-.158.431-.291.63-.457.424-.352.848-.705 1.25-1.08 1.002-.938 1.743-2.105 2.657-3.121.426-.474.848-.943 1.433-1.229.118-.057.215-.192.284-.313.344-.61.674-1.228 1.014-1.84.062-.114.13-.233.224-.318.445-.406.721-.919.934-1.474.268-.702.55-1.4.802-2.107.266-.746.504-1.502.772-2.308.216.26.339.526.187.777-.41.677-.436 1.464-.667 2.19-.099.312-.186.63-.324.924-.346.738-.704 1.47-1.086 2.19a5.315 5.315 0 0 1-.634.925c-.902 1.07-1.81 2.136-2.74 3.18-.594.668-1.235 1.292-1.85 1.94-.324.343-.625.71-.957 1.044-.56.565-1.169 1.085-1.7 1.677-.68.758-1.495 1.342-2.264 1.99-.645.542-1.362.924-2.085 1.32-.253.138-.468.345-.709.51-.723.494-1.43 1.017-2.182 1.461-.709.42-1.46.769-2.207 1.12-.468.22-.972.36-1.439.582-.627.298-1.264.594-1.845.972-1.109.722-2.312 1.228-3.517 1.747-1.467.631-3.008.986-4.55 1.336-1.007.227-2.017.462-3.037.59-.67.083-1.272.366-1.92.477-.906.155-1.804.359-2.73.396-.394.016-.782.152-1.176.214-.764.122-1.532.22-2.295.348-.425.07-.841.22-1.268.26-.625.06-1.26.028-1.885.086-.803.075-1.616.136-2.398.32-1.474.345-2.968.448-4.467.516-1.083.048-2.155.18-3.228.322-.656.087-1.32.118-1.98.167-.885.065-1.772.103-2.655.191a8.393 8.393 0 0 0-1.371.27 15.11 15.11 0 0 1-2.512.465c-.876.27-1.597.302-2.298.28-1.074-.035-2.13.117-3.19.193a61.768 61.768 0 0 1-5.125.175c-.83-.01-1.632.164-2.452.181-.37.008-.74.026-1.11.02-.264-.004-.467-.252-.563-.686zm-1.867-2.282c-.765-1.03-1.52-2.067-2.271-3.107-.084-.116-.122-.266-.195-.392-.285-.493-.566-.988-.866-1.47-.575-.93-.978-1.939-1.475-3.001 1.007-.352 1.927-.655 2.834-.996.611-.23 1.229-.41 1.882-.384.4.016.798.094 1.195.158.857.138 1.723.241 2.567.438.968.226 1.841.69 2.66 1.265.716.503 1.471.951 2.177 1.468a13.86 13.86 0 0 1 3.268 3.387c.387.567.613 1.22.746 1.916-.25.167-.527.144-.794.174-1.342.152-2.7.158-4.022.49-.996.252-2.017.194-3.033.193-.774 0-1.547.054-2.32.062a42.996 42.996 0 0 1-2.031-.037.471.471 0 0 1-.322-.164zM3.743 27.588c-.241-.693-.544-1.366-.768-2.065-.327-1.026-.615-2.066-.904-3.104-.087-.313-.126-.64-.176-.963-.016-.105.005-.215.013-.41.294.203.547.342.76.527.813.707 1.76 1.145 2.766 1.481.69.231 1.368.501 2.057.736.84.286 1.677.595 2.534.819.745.194 1.516.285 2.277.417.845.146 1.701.156 2.554.13 1.835-.053 3.62-.386 5.335-1.066.681-.27 1.29-.676 1.871-1.122.57-.437.888-1.071 1.242-1.678.657-1.127 1.301-2.262 1.996-3.364.52-.826 1.118-1.6 1.797-2.303.19-.197.42-.355.627-.536.548-.478 1.092-.961 1.642-1.437.085-.073.199-.11.286-.18.303-.24.632-.459.895-.739 1.166-1.238 2.496-2.218 4.104-2.782.073-.026.153-.034.308-.067-.083.182-.135.308-.196.429-.334.672-.672 1.342-1.006 2.014a1.513 1.513 0 0 0-.111.273c-.171.626-.38 1.24-.573 1.86-.44 1.413.722 2.815 2.2 2.693a6.227 6.227 0 0 0 1.644-.353c.245-.09.452-.42.572-.688.143-.32.253-.695.234-1.037-.027-.48.175-.857.375-1.236.472-.894.97-1.773 1.468-2.653.31-.548.663-1.043 1.35-1.16.259-.045.403-.271.463-.522.069-.282.256-.395.612-.467-.208.312-.365.566-.54.807-.402.552-.829 1.086-1.215 1.65-.363.53-.53 1.152-.705 1.767-.065.232-.187.447-.261.677a3.931 3.931 0 0 0-.18.71c-.124.98.139 1.855.784 2.59.456.52 1.064.68 1.724.534.342-.076.67-.23.994-.372 1.003-.443 1.291-1.31 1.295-2.322.001-.227.037-.397.186-.573.095-.113.139-.294.151-.449.09-1.11.435-2.098 1.263-2.873.474-.444.955-.881 1.41-1.345.189-.193.377-.211.665-.153-.063.13-.098.25-.169.34-.476.607-.83 1.285-1.162 1.98a2.193 2.193 0 0 0-.202 1.193c.023.227.002.384-.154.574-.428.524-.45 1.564-.084 2.136.123.192.24.389.378.57.407.542.946.853 1.625.8 1.154-.09 2.1-.608 2.801-1.543.438-.584.537-1.213.13-1.872-.084-.136-.14-.291-.214-.448.146-.241.309-.479.21-.806-.028-.097.046-.26.122-.348.401-.47.822-.922 1.228-1.387.114-.13.23-.271.3-.428.223-.49.433-.987.629-1.49.083-.214.188-.306.43-.285.349.03.7.013 1.141.016-.099.204-.169.357-.245.507-.236.466-.486.924-.707 1.397-.147.314-.234.638-.059.99.076.153.06.305-.123.461-.198.169-.316.463-.145.738.1.158.045.265-.013.405-.082.194-.16.397-.192.603-.064.408.059.743.344 1.069.642.732 1.432.852 2.299.642 1.187-.286 1.159-.472 1.081-1.614a.665.665 0 0 0-.063-.286c-.228-.384-.17-.77-.045-1.167.273-.878.771-1.632 1.205-2.422-.022.49-.147.94-.255 1.395-.114.477-.22.957-.31 1.44-.048.258-.081.527.241.667.16.069.17.214.13.377a3.52 3.52 0 0 0-.073.485c-.013.13-.03.264-.011.39.181 1.173 1.314 2.234 2.46 2.409.886.134 2.073-.674 2.019-1.932-.022-.503-.18-.935-.527-1.28-.24-.239-.273-.501-.208-.805.443-2.004.913-3.892 2.125-5.487.482-.635.933-1.295 1.389-1.95.232-.335.447-.681.66-1.028.189-.306.45-.447.808-.444.317.002.635-.03 1.025-.05-.092.165-.133.288-.213.374-.415.44-.634.989-.818 1.548-.074.223-.078.484-.056.721.027.278-.048.481-.265.638-.48.349-.729.861-.972 1.383a7.12 7.12 0 0 0-.69 3.274c.012.374-.08.75-.09 1.126-.014.554.023 1.11-.002 1.664-.022.49-.06.984-.16 1.461a31.196 31.196 0 0 1-.544 2.13c-.141.5-.477.887-.803 1.275-.125.149-.271.283-.376.446-.426.663-1.095.99-1.733 1.354-.224-.296-.415-.572-.63-.828-.318-.376-.831-.496-1.327-.288-.522.22-1.045.446-1.54.72-.955.527-1.965.916-2.978 1.306-.664.257-1.318.542-1.973.823-.382.163-.562.53-.772.852-.123.188-.013.428.171.59.132.117.276.239.356.39.22.416.409.848.632 1.32-.445.302-.785.593-1.173.783-.957.467-1.6 1.239-2.195 2.095-.468.674-.725 1.45-1.132 2.152-.34.585-.264 1.265-.383 1.9-.101.54-.233 1.072-.333 1.612-.047.25-.05.51-.078.831-.086.027-.217.083-.352.107-1.784.314-3.57.614-5.352.939-1.196.218-2.402.313-3.612.396-2.048.14-4.094.306-6.14.47-2.29.185-4.577.38-6.866.57-.112.009-.226.012-.339.005-.231-.015-.38-.113-.445-.367-.101-.396-.238-.783-.373-1.169a4.232 4.232 0 0 0-1.125-1.694c-.295-.278-.593-.556-.858-.863-.578-.67-1.27-1.2-1.942-1.765-1.128-.948-2.424-1.62-3.643-2.417-.931-.608-1.988-.942-3.08-1.138-.7-.126-1.401-.244-2.103-.356-1.618-.257-3.144.113-4.644.688a23.05 23.05 0 0 1-1.561.526c-.393.12-.406.1-.537-.318-.196-.624-.374-1.255-.589-1.873zM1.75 16.37c.145.597.263 1.121.401 1.64.133.495.465.863.851 1.164.51.398 1.045.766 1.58 1.132.225.153.47.281.717.396.47.218.954.405 1.421.628.55.263 1.134.37 1.73.435.176.019.352.052.523.1.73.2 1.452.446 2.191.605a17.89 17.89 0 0 0 2.296.35c.637.054 1.284.008 1.925-.019.984-.04 1.974-.069 2.897-.487.47-.213.94-.434 1.401-.667.142-.07.265-.186.387-.292.475-.413.947-.829 1.417-1.248.081-.072.144-.164.268-.224-.023.078-.033.164-.072.233-.21.367-.397.754-.65 1.09-.74.984-1.728 1.597-2.906 1.92-1.211.332-2.445.451-3.693.447-.252-.001-.503-.079-.757-.102-.35-.032-.704-.035-1.054-.07a53.199 53.199 0 0 1-1.684-.2 2.625 2.625 0 0 1-.515-.13c-1.054-.37-2.106-.744-3.159-1.117-.747-.265-1.5-.518-2.24-.8-.298-.115-.604-.255-.85-.454-.526-.425-1.137-.734-1.552-1.316-.184-.258-.513-.411-.672-.737-.302-.614-.487-1.24-.371-1.93.017-.104.095-.199.17-.347zm3.75-4.336c.482-.228.98-.418 1.467-.63.65-.284 1.356-.205 2.022-.381l.03.133c-.165.052-.33.105-.495.154-.513.153-1.02.334-1.44.676-.746.608-1.612.955-2.516 1.214-.91.261-1.614.78-2.104 1.6-.13.216-.282.418-.427.631-.042-.046-.084-.078-.08-.09.42-1.016 1.047-1.879 1.956-2.485.494-.33 1.05-.568 1.588-.822zm6.15.177c.693.004 1.388.021 2.077-.03.343-.025.677-.185 1.014-.29.337-.107.672-.219 1.008-.33.49-.162.978-.327 1.469-.488.149-.05.301-.089.512-.15.166 1.08.795 1.851 1.266 2.701.173.313.339.631.52.94.115.195.253.376.377.566.051.078.125.161.13.246.024.384.266.622.53.844.16.135.348.24.505.38.151.135.28.298.429.46-.64.889-1.301 1.681-2.133 2.32-.204.156-.367.366-.555.545-.745.714-1.64 1.086-2.655 1.158-.87.06-1.742.119-2.614.138-.43.01-.865-.059-1.294-.117-.384-.052-.763-.138-1.144-.21-.426-.08-.847-.149-1.253-.337-.3-.14-.657-.183-.992-.207-.616-.045-1.141-.329-1.684-.576-.103-.047-.199-.117-.306-.145-.69-.184-1.235-.631-1.806-1.026-.28-.194-.543-.413-.818-.615-.337-.247-.504-.582-.54-.998-.04-.446.004-.853.28-1.24.431-.605.933-1.097 1.671-1.25 1.003-.21 1.876-.678 2.717-1.25.328-.222.721-.353 1.097-.493.408-.152.839-.244 1.244-.403.312-.123.622-.145.948-.143zm5.542-2.95c-.096.086-.206.161-.32.216-.628.299-1.263.572-1.956.686-.284.047-.58.116-.83.251-.468.252-.946.389-1.478.357-.544-.033-1.09-.044-1.727-.068 2.197-.734 4.367-1.193 6.416-2.04.156.27.063.45-.105.599zm2.216-2.703c-.073-.11.015-.344.054-.515.253-1.133.66-2.198 1.482-3.04.241-.247.569-.417.877-.583.128-.07.312-.058.467-.042.352.036.702.099 1.054.148 1.552.217 3.103.442 4.657.646 1.137.15 2.278.282 3.38.612 1.07.32 2.175.426 3.265.624.19.035.387.052.571.109.443.134.891.04 1.335.044.294.003.436-.232.5-.516.077-.345.036-.62-.205-.741-.264-.133-.522-.26-.843-.305-1.017-.142-2.036-.31-3.07-.729.444-.148.829-.213 1.225-.157.336.048.668.127 1.003.18.526.084 1.051.192 1.58.223.37.021.604.129.833.447.567.789.924 1.682 1.353 2.54.02.04.014.095.027.197-.136.078-.279.18-.436.247a2.466 2.466 0 0 0-1.347 1.341c-.11.26-.246.45-.585.362-.278-.071-.543.018-.772.195-.434.334-.93.495-1.458.623-.934.228-1.771.698-2.609 1.166-.976.546-1.755 1.323-2.518 2.124-.204.215-.42.384-.721.46-1.03.263-1.902.76-2.567 1.645-.594.79-1.274 1.514-1.935 2.29-.718-.163-1.354-.538-1.954-.987-.076-.056-.17-.139-.183-.221-.105-.616-.604-.988-.884-1.494-.3-.541-.671-1.042-.977-1.58-.41-.722-.542-1.536-.682-2.342a13.427 13.427 0 0 1-.138-1.02c-.032-.341-.013-.655.16-.99.134-.26.295-.607.06-.962zm15.937 9.123c-.125-.002-.344.047-.384-.018a.937.937 0 0 1-.132-.54c.008-.104.165-.215.278-.285.073-.045.19-.009.284-.03.168-.04.366-.057.42.117.038.126-.04.315-.116.443-.072.119-.212.194-.35.313zm4.045-8.44c-.152.403-.026.654.35.717.028.483-.239.774-.517 1.003-.876.72-1.418 1.688-1.987 2.637-.308.515-.565 1.062-.869 1.64l-.848-.097c-.027-.085-.053-.123-.044-.143.352-.752.681-1.517 1.068-2.25.385-.73 1-1.276 1.605-1.817.276-.248.478-.521.567-.887.039-.156.094-.32.186-.45.104-.145.258-.255.39-.38l.099.027zm.158-4.681c.308.031.321.057.424.897l-.424-.897zm2.498 4.613c.018.04-.009.103-.016.155l-.196-.056.061-.21c.07.048.132.07.151.111zm1.612-2.567c.363.659.863 1.24 1.332 1.895l-.929.202c-.329-.473-.672-.98-1.03-1.478a6.551 6.551 0 0 1-1.104-2.573c-.03-.15-.04-.306-.065-.516l.93.391c.275.678.502 1.417.866 2.08zm-2.54 11.505c-.25-.338-.258-.406-.124-.937.295-.06.588-.21.943-.093-.053.545-.346.858-.818 1.03zm.653-3.744c.207-.368.463-.706.692-1.06a12.018 12.018 0 0 1 2.45-2.751c.167-.138.365-.235.605-.387.09.47-.094.706-.32.932-.469.47-.958.922-1.391 1.424-.591.684-.994 1.484-1.257 2.354-.037.125-.073.25-.114.374-.01.03-.037.053-.09.124l-.814-.097c-.075-.381.093-.654.239-.913zm4.07-8.105c.346.57.72 1.123 1.075 1.689.18.287.344.585.516.879-.797-.746-2.635-3.741-2.73-4.327.223.026.274.213.353.35.268.467.51.949.787 1.409zm2.583 10.04c.147-.103.32-.165.425.001.058.092.045.312-.026.392-.334.37-.654.776-1.218.888-.2-.486-.15-.65.226-.883.202-.126.398-.261.593-.398zm-.545-6.163c-.233-.057-.215-.188-.142-.378.119.116.183.215.142.378zm2.424 1.92c-.426.47-.838.95-1.25 1.432a.882.882 0 0 0-.17.294c-.108.336-.337.448-.665.414.06-.63 2.02-3.217 2.778-3.615-.186.56-.32 1.066-.693 1.476zM49.242 4.36c.266.045.539.046.77.063.246.4.436.781.693 1.11.252.324.494.639.594 1.037l-1.573.656c-.31-.598-.596-1.216-.94-1.8-.343-.579-.822-1.075-1.046-1.752.396.097.806.108 1.08.492.08.112.272.17.422.194zm3.326.044c.268.798.696 1.506 1.147 2.203.053.08.095.17.134.258.01.022-.012.058-.033.147-.093-.08-.191-.127-.236-.207-.473-.832-.942-1.668-1.403-2.507-.177-.322-.325-.657-.374-1.021.217-.092.287.014.343.14.144.328.309.649.422.987zm3.929 4.455c-.333.724-.663 1.45-1.014 2.165a2.486 2.486 0 0 1-.417.59c-.094.1-.256.134-.387.198l-.07-.08c.406-1.023.974-1.958 1.571-2.877.082-.126.196-.23.295-.344l.09.054c-.021.098-.027.204-.068.294zm-.215-4.411c.463.022.596.398.759.728.237.483.457.976.675 1.468.05.115.066.246.114.435l-1.47-.042c-.73-.952-1.542-1.895-1.966-3.124.678-.143 1.193.187 1.73.427.058.026.104.105.158.108zm2.722-.813c.063.556.26 1.047.146 1.649-.132-.108-.236-.156-.285-.238a8.465 8.465 0 0 1-.382-.734c-.179-.385-.118-.514.284-.643.06-.02.124-.019.237-.034zm1.177 11.603c-.064.136-.176.352-.266.351-.14 0-.28-.154-.413-.237-.032-.297-.085-.539-.077-.779.008-.26.199-.36.44-.27.265.1.392.272.384.553a.992.992 0 0 1-.068.382zm-.161-5.966c.332-.814.624-1.648 1.01-2.435.328-.67.764-1.286 1.154-1.926.152-.249.318-.49.46-.744.22-.392.555-.542.955-.4 0 .044.017.104-.005.137-.289.433-.501.9-.707 1.381-.24.562-.612 1.072-.968 1.575-.637.9-1.066 1.9-1.519 2.9-.403.89-.605 1.82-.85 2.749-.09.345-.105.34-.58.331.093-.39.166-.77.277-1.14.236-.781.492-1.557.74-2.336.01-.031.02-.062.033-.092zM54.89 24.136c.994-.265 1.898-.742 2.836-1.138.294-.124.6-.218.904-.317.032-.01.082.038.163.078-.608.52-4.484 2.803-4.903 2.884l-.36-.763c.455-.276.864-.611 1.36-.744zM68.094 6.24c.445-.578.893-1.153 1.345-1.726.07-.089.177-.151.233-.246.113-.192.282-.25.485-.272 1.913-.201 3.827-.385 5.736-.618.913-.111 1.82-.293 2.72-.484 1.622-.343 3.248-.284 4.877-.116.61.063 1.13.369 1.632.71.921.625 1.606 1.483 2.18 2.411.525.848.86 1.797.85 2.831-.002.147-.003.298.023.441.188 1.03-.079 1.977-.483 2.907-.247.568-.433 1.166-.697 1.726-.29.618-.638 1.209-.965 1.81-.038.07-.09.152-.156.182-.44.2-.654.61-.936.968-.817 1.034-1.663 2.044-2.493 3.067-.255.315-.493.645-.746.963-.773.971-1.627 1.855-2.633 2.59-1.05.764-2.047 1.603-3.111 2.346-1.41.986-2.866 1.902-4.293 2.863-.661.444-1.315.888-2.063 1.182-.555.219-1.091.49-1.62.769-.428.227-.819.527-1.25.749-.46.237-.938.443-1.423.622-1.503.554-2.958 1.245-4.51 1.667-.389.106-.776.239-1.143.407-.435.2-.883.294-1.354.348-.447.052-.887.17-1.333.24-1.23.194-2.46.376-3.69.563-.704.107-1.409.206-2.11.327a8.095 8.095 0 0 1-1.887.086c-.26-.487-.137-.953-.106-1.399.03-.433.157-.86.256-1.286.143-.612.5-1.132.734-1.7.256-.621.613-1.147 1.031-1.645a2.58 2.58 0 0 1 .573-.523c1.273-.808 2.512-1.669 3.87-2.344.938-.466 1.8-1.092 2.698-1.645.22-.136.448-.261.667-.4 1.152-.725 2.299-1.459 3.455-2.178 1.34-.833 2.204-2.061 2.776-3.5.317-.801.529-1.648.742-2.486.095-.374.13-.784.095-1.168-.058-.629.032-1.238.102-1.855.053-.47.087-.945.1-1.418.014-.495.071-.971.22-1.449.125-.4.136-.834.232-1.245.054-.234.176-.452.27-.677.045-.105.135-.205.139-.31.017-.486.315-.826.554-1.203.137-.217.226-.466.334-.701.028-.06.035-.132.073-.181zm25.464 13.097c-.053-.636-.092-1.274-.172-1.907-.065-.518-.19-1.028-.272-1.544-.065-.404-.083-.817-.162-1.217-.205-1.027-.459-2.044-.64-3.075-.118-.671-.36-1.29-.612-1.91-.173-.424-.373-.838-.523-1.27-.574-1.653-1.445-3.144-2.415-4.58-.235-.349-.488-.71-.81-.968-.617-.495-1.279-.936-1.942-1.367-.462-.3-.948-.56-1.5-.667a16.433 16.433 0 0 0-6.221-.029c-1.08.203-2.16.423-3.249.57-1.938.263-3.883.471-5.823.714-.962.12-1.916.289-2.891.29-.529.002-1.057.087-1.664.14-.339-.205-.778-.465-1.271-.42a8.685 8.685 0 0 0-1.705.33c-.352.107-.613.118-.875-.16-.13-.14-.296-.32-.46-.337a5.653 5.653 0 0 0-1.248.02c-.414.05-.816.193-1.229.266-.182.032-.377-.01-.566-.017-.252-.01-.532-.094-.75-.01-.226.086-.394.334-.57.495l-2.043-.287c.016-.346-.211-.526-.564-.673-.817-.341-1.644-.329-2.472-.134-.402.094-.813.207-1.14.511a.655.655 0 0 1-.637.15c-.405-.112-.818-.2-1.214-.34-.4-.143-.789-.277-1.215-.085-.053-.11-.118-.192-.128-.279-.067-.609-.386-.86-.996-.809-.303.026-.627.06-.912-.018a1.927 1.927 0 0 0-1.138.015c-.334.105-.693.122-1.03.218-.504.145-.992.288-1.393-.215-.07-.088-.152-.167-.229-.249-.264-.28-.558-.457-.967-.482-.718-.045-1.332.17-1.909.58-.162.115-.38.222-.569.217-.514-.015-1.027-.089-1.54-.144-.594-.065-1.184-.17-1.779-.191-.53-.02-1.064.039-1.595.088-.4.037-.798.106-1.196.173-.651.109-1.211.45-1.784.75-.349.183-.683.24-1.072.145-.39-.095-.797-.122-1.198-.165-1.236-.131-2.483-.2-3.707-.405a6.683 6.683 0 0 0-1.97-.042c-1.02.13-1.812.657-2.376 1.523-.727 1.117-1.275 2.316-1.507 3.642-.072.416-.292.665-.666.826-.773.334-1.54.674-2.363.876-.737.181-1.456.432-2.187.637-.886.248-1.772.504-2.667.712-.63.146-1.277.207-1.912.324-.964.178-1.838.619-2.737.987-1.219.499-2.243 1.273-3.113 2.263-.493.56-1.015 1.101-1.256 1.84-.177.542-.39 1.074-.538 1.623-.164.607-.333 1.222-.245 1.865.064.468.147.933.196 1.402.083.78.131 1.564.224 2.343.053.437.152.87.254 1.299.171.724.339 1.45.552 2.162.195.653.404 1.31.689 1.926.265.574.347 1.189.53 1.779.219.7.41 1.41.667 2.097.25.666.581 1.301.76 1.997.036.14.12.268.178.403.102.24.198.482.302.72.045.1.105.194.156.291.177.338.554.553.583.984.004.057.066.11.1.164.119.191.25.376.352.576.23.447.44.905.67 1.352.45.875.994 1.687 1.637 2.427.168.193.26.37.276.642.025.397.207.755.594.941.568.275 1.091.61 1.495 1.11.174.215.333.444.524.643a.758.758 0 0 1 .226.518c.017.285.105.538.453.604.1.02.213.146.261.251.378.818.997 1.443 1.598 2.083.467.498.937.99 1.394 1.497.413.459.804.939 1.218 1.396.161.179.35.35.628.213.835-.41 1.763-.37 2.647-.52 1.029-.175 2.081-.202 3.123-.297.852-.078 1.704-.165 2.557-.239.836-.072 1.673-.133 2.51-.2l4.204-.333c.386-.03.773-.064 1.16-.09.998-.066 1.997-.12 2.994-.197.675-.051 1.353-.103 2.02-.21.508-.081.996-.281 1.503-.37.619-.11 1.249-.23 1.872-.22 2.344.033 4.682.072 7.012-.285 1.213-.186 2.44-.273 3.661-.41.434-.048.868-.102 1.299-.168 1.053-.16 2.105-.33 3.158-.496.987-.156 1.982-.27 2.958-.478 1.548-.33 3.084-.721 4.624-1.091.123-.03.241-.088.36-.138.402-.17.796-.364 1.206-.512.836-.302 1.684-.57 2.52-.872.44-.16.858-.382 1.299-.54.607-.218 1.227-.402 1.84-.602.277-.09.562-.161.827-.277a71.3 71.3 0 0 0 2.215-1.002c.831-.395 1.7-.716 2.452-1.274.39-.29.79-.567 1.195-.836.714-.473 1.436-.935 2.154-1.403.081-.053.153-.12.233-.177.368-.264.737-.527 1.108-.788.332-.233.704-.422.992-.702.906-.88 1.785-1.79 2.665-2.698.453-.467.9-.94 1.323-1.434.381-.443.728-.917 1.089-1.379.792-1.015 1.601-2.016 2.37-3.05a44.378 44.378 0 0 0 1.69-2.458c.492-.767.939-1.564 1.4-2.352.056-.094.134-.23.105-.311-.14-.403.112-.58.384-.743.243-.147.39-.323.346-.635-.038-.273-.035-.552-.058-.827zm-62.993-.96c-.659-.377-.828-.685-.722-1.275.585.051.93.636.722 1.274zm.338 1.363c.801-.102 1.519-.824 1.54-1.547.016-.528-.04-1.057-.341-1.601-.063-.354-.416-.559-.713-.81-.45-.384-.928-.653-1.546-.39-.17.073-.354.119-.516.206a9.71 9.71 0 0 0-.972.573c-.14.097-.3.272-.31.421-.038.525-.022 1.054-.01 1.581.002.101.06.211.119.3.632.956 1.61 1.412 2.749 1.267z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill3':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '17',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M4.679 5.093c-.079.168-.153.27-.174.38-.173.903-.332 1.808-.505 2.71-.044.229.072.322.256.426.34.193.69.388.982.642.485.42.546.43.856-.117l.058-.109c.189-.36.334-.734.813-.869.264-.074.258-.344.038-.54-.061-.054-.137-.093-.21-.134a3.072 3.072 0 0 1-1.206-1.213c-.224-.4-.391-.864-.908-1.176zM0 10.266c.146-.21.284-.468.479-.675.494-.525.86-1.118 1.047-1.802.435-1.584.882-3.17.949-4.821.037-.934.006-1.871.006-2.86.638-.327 1.337.212 2.063.05.292.36.847.432 1.042.913.053.13.159.251.175.384.21 1.702 1.054 3.09 2.256 4.289.544.543 1.298.742 2.008.979.318.106.557.262.755.507.344.425.284.85-.172 1.158a1.51 1.51 0 0 1-.39.2c-.87.268-1.28.963-1.625 1.697-.701 1.495-1.064 3.058-.932 4.716a3.076 3.076 0 0 1-.374 1.709c-.118.223-.267.333-.489.274-.564-.148-1.138-.284-1.67-.51-.399-.169-.483-.598-.514-.993-.064-.797-.108-1.596-.165-2.393-.027-.389-.053-.777-.099-1.164a1.311 1.311 0 0 0-.135-.468c-.476-.871-.87-.918-1.556-.332-.598.51-.835.527-1.518.17-.037-.018-.073-.045-.113-.052-.51-.098-.823-.41-1.028-.976z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill7':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '15',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M4.26 8.74c.175.12.318.228.47.324.39.248.503.231.826-.099.436-.446.876-.889 1.31-1.338.05-.053.07-.137.11-.222l-1.48-1.27L4.26 8.739zM11 8.015c-.105.281-.368.499-.75.584-1.128.25-1.837 1.043-2.439 1.98-.491.766-.813 1.607-1.12 2.463-.205.575-.264 1.214-.662 1.71-.073.092-.16.246-.241.246a8.558 8.558 0 0 1-1.311-.067 1.476 1.476 0 0 1-.655-.298c-.388-.302-.452-.746-.398-1.214.063-.532.159-1.063.188-1.597.047-.865-.243-1.184-1.098-1.283-.6-.07-1.204-.126-1.754-.405a1.697 1.697 0 0 1-.484-.357c-.416-.459-.359-.866.148-1.23.016-.011.035-.02.053-.029 1.08-.547 1.645-1.532 2.096-2.604.457-1.084.62-2.198.406-3.384-.11-.614-.317-1.242-.13-1.892.13-.455.248-.605.69-.633.339-.021.681.018 1.023.023.306.005.468.206.69.396.545.463.707 1.081.878 1.712.144.533.415.977.801 1.359.13.128.259.268.345.428.481.892 1.179 1.563 2.012 2.1.12.077.228.171.346.252.596.41 1.297.724 1.366 1.74z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill11':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '15',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M4.8 8.303c.352.166.688.352 1.045.475.115.04.353-.043.42-.147.345-.538.661-1.097.967-1.66.046-.085.017-.317-.03-.334a11.224 11.224 0 0 0-1.259-.388c-.073-.018-.224.114-.272.212-.293.59-.566 1.19-.871 1.842zM0 9.54c.073-.37.32-.6.594-.833C2.04 7.474 3.104 5.989 3.52 4.074c.187-.866.18-1.736.099-2.61-.043-.462-.039-.447.375-.63.175-.078.33-.22.471-.356.256-.247.49-.514.9-.365.072.026.18.037.238 0 .397-.251.71-.04.994.202.317.27.443.693.393 1.065-.12.898.26 1.72.282 2.59.008.295.17.5.476.567.178.04.347.124.525.167.97.235 1.707.868 2.437 1.502.401.348.391.932-.061 1.187-.832.471-1.283 1.195-1.703 2.036-.46.922-.77 1.875-1.014 2.862-.14.564-.224 1.142-.375 1.703a2.726 2.726 0 0 1-.375.775c-.125.189-.296.29-.577.194-.396-.137-.823-.185-1.237-.267-.469-.093-.497-.09-.533-.596-.055-.788-.069-1.579-.096-2.369-.008-.228.02-.46-.006-.686-.051-.431-.279-.676-.7-.752-.491-.088-.982-.096-1.412.22-.485.355-.972.354-1.47.04-.035-.022-.064-.058-.1-.07-.248-.072-.546-.077-.73-.228-.164-.137-.203-.433-.321-.716z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill13':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '16',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M4.757 10.373c.347.204.484.023.62-.182.164-.247.287-.557.515-.72.686-.49 1.026-1.23 1.513-1.853-.377-.525-.94-.901-1.46-.94-.134 1.3-.618 2.508-1.188 3.695zm-2.729 2.865C1.05 13.012.577 12.406 0 11.959c.092-.24.145-.47.264-.66.095-.151.253-.284.412-.373.399-.225.776-.437.907-.933.05-.19.253-.34.392-.504.551-.651.911-1.404 1.121-2.216.317-1.224.598-2.456.422-3.738-.094-.685-.285-1.333-.667-1.921-.204-.314-.149-.462.174-.668.27-.173.54-.349.786-.551.39-.322.907-.191 1.331-.39.052-.024.168.04.232.09.558.446 1.035.916 1.072 1.712a3.91 3.91 0 0 0 .956 2.405c.403.466.883.868 1.344 1.282.351.316.712.625 1.095.902.59.426.804 1.094 1.14 1.68.052.09-.01.31-.095.393-.18.175-.393.379-.624.43-.975.216-1.47.945-1.883 1.718-.65 1.213-1.104 2.498-1.235 3.886-.05.524-.147 1.062-.7 1.365-.225.124-.412.187-.663.07-.408-.188-.84-.325-1.245-.52-.134-.063-.28-.222-.308-.36-.072-.35-.13-.716-.1-1.069.038-.481-.11-.887-.365-1.266-.23-.34-.39-.369-.755-.142-.38.236-.743.497-.98.657z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill60':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '20',
	            height: '33',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M16.858 17.935c-.575 1.212-1.326 2.398-1.896 3.613-.581 1.237-.969 2.511-1.561 3.743-.548 1.138-.626 1.634-1.217 2.75-.03.055-.114.08-.242.164-.026-.22-.058-.385-.064-.55-.083-2.045-.216-4.821-.01-6.865.149-1.464-1.109-1.039-2.186-.804-.916.199-1.807.521-2.706.8-.632.197-1.254.426-1.888.613-.233.068-.488.058-.789.089-.568-5.493-1.128-10.181-1.704-15.753 3.734-.89 6.98-1.718 10.826-2.636-.02.427-.007.729-.05 1.022-.242 1.613-.543 3.218-.737 4.836-.23 1.927-.375 3.865-.556 5.797a4.409 4.409 0 0 0-.018.233c-.038.94.291 1.743 1.2 1.7.81-.039 1.615-.157 2.422-.249.474-.053.948-.199 1.473.03-.029.763.022.796-.297 1.467zm3.125-3.12c-.06-.58-.582-.95-1.154-.874-1.236.162-2.471.325-3.707.48-.19.023-.386.002-.701.002.035-.529.056-1.009.101-1.487.118-1.236.245-2.472.372-3.707.062-.604.112-1.21.205-1.81.26-1.655.54-3.308.81-4.963.215-1.323.077-1.592-1.052-2.238-.372-.213-.726-.283-1.138-.152-.269.086-.558.104-.834.169-1.517.359-3.036.706-4.547 1.089-1.84.466-3.662 1.014-5.515 1.423-.772.17-1.537.295-2.281.597-.485.197-.588.479-.525.927.028.2.06.4.086.6.21 1.662.447 3.321.623 4.986.19 1.782.304 3.572.484 5.355.237 2.358.503 4.713.765 7.068.044.401.129.798.195 1.197.09.536.425.817.939.831.537.015 1.101.072 1.609-.064 1.397-.374 2.77-.84 4.153-1.266.259-.08.524-.141.834-.224.041.301.085.497.092.694.04 1.27.064 2.543.11 3.814.065 1.727.132 3.454.2 5.182.175.24.44.423.724.544l.028.012a4.718 4.718 0 0 0 1.303-.255c.12-.13.228-.27.339-.408.136-.347.293-.689.472-1.026a190.58 190.58 0 0 0 2.542-5.006c.855-1.729 1.64-3.494 2.533-5.2.873-1.67 1.671-3.353 1.903-5.255.041-.342.068-.695.032-1.036z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill25':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '10',
	            height: '14',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M6.226 7.422c-.39-.282-.727-.537-1.076-.772-.283-.191-.446-.171-.599.111a5.878 5.878 0 0 0-.39.946c-.085.256.13.376.315.44.283.098.468.506.856.28.034-.02.061-.052.088-.082l.806-.923zM0 8.952c.07-.547.297-.893.83-1.036.185-.05.346-.275.468-.454.604-.885.937-1.884 1.148-2.918.116-.57.152-1.161.174-1.745.019-.507-.169-.942-.606-1.26-.246-.18-.358-.888-.219-1.156.018-.035.045-.079.077-.09.3-.106.596-.258.904-.29.242-.024.508.08.75.165.34.12.658.31 1.003.408.83.236 1.125.634 1.06 1.49-.056.738.233 1.387.579 2.01.186.336.408.654.64.961.3.4.691.666 1.191.797.35.091.772.179.995.42.319.345.79.548.963 1.053.112.33-.006.496-.225.668a.505.505 0 0 1-.213.113c-1.103.177-1.494 1.14-2.014 1.896-.53.771-.787 1.677-.664 2.653.052.412.129.867-.288 1.171-.123.09-.28.154-.43.178-.178.028-.365.008-.547-.006-.864-.063-1.252-.453-1.423-1.296a27.92 27.92 0 0 0-.585-2.287c-.167-.57-.404-.702-1.005-.617-.524.074-1.035.183-1.569.006-.453-.15-.798-.39-.994-.835z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill21':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '15',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M7.399 7.442c-.803-.142-1.45-.273-2.1-.358-.127-.017-.32.108-.402.226-.166.24-.287.513-.406.782-.092.208-.014.366.197.454.363.153.718.326 1.09.453.13.045.366.04.44-.045.377-.438.718-.91 1.18-1.512zM7.432 15c-.428-.071-.813-.086-1.16-.212-.209-.076-.444-.293-.517-.501a6.717 6.717 0 0 1-.362-1.526c-.107-1.05-.913-2.04-1.932-2.282-.347-.082-.667-.049-.933.207-.418.4-.897.392-1.402.242-.14-.041-.275-.102-.418-.13-.393-.074-.633-.293-.692-.705-.064-.443.056-.8.468-1.008 1.09-.55 1.641-1.5 1.946-2.646.075-.285.182-.563.278-.842.238-.69.32-1.393.214-2.124-.133-.919-.228-1.843-.353-2.763-.031-.233.07-.367.246-.463.53-.292 1.292-.376 1.823.03.419.32.64.635.676 1.178.048.735.171 1.472.34 2.19.093.398.32.772.53 1.132.188.323.542.344.877.4.818.139 1.639.277 2.448.465.543.125.957.491 1.278.95.334.479.272.835-.165 1.2-1.097.918-1.952 1.998-2.318 3.44a4.086 4.086 0 0 0 .078 2.37c.169.491-.084.835-.259 1.178-.083.163-.479.16-.69.22z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill17':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '14',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M6.012 5.475l-.65 1.273.746.455.876-1.057-.972-.671zM.052 7.231c.552-.339 1.103-.768 1.768-.883.707-.124 1.114-.57 1.438-1.134.422-.735.693-1.522.68-2.399-.01-.641.049-1.283.067-1.925.009-.304.072-.572.39-.669.402-.12.803-.4 1.226-.052.352.29.71.572 1.052.873.352.31.622.658.528 1.194-.052.292-.06.607-.012.9.044.265.189.514.289.77.124.32.415.232.653.287.84.195 1.693.342 2.456.797.483.288.565.997.125 1.348-.107.086-.229.16-.354.214C9.39 6.98 8.75 7.688 8.35 8.697c-.49 1.238-.723 2.494-.644 3.823.038.655-.155 1.079-.606 1.48-.396-.262-.861-.088-1.299-.187-.401-.09-.664-.252-.754-.643a14.151 14.151 0 0 1-.256-1.418c-.07-.558-.067-1.125-.152-1.68a5.008 5.008 0 0 0-.334-1.148c-.235-.564-.473-.627-1.03-.394-.38.159-.769.299-1.162.421-.397.124-.775.03-1.14-.159-.152-.079-.326-.113-.49-.171-.395-.14-.536-.402-.466-.83.028-.17.023-.344.035-.56z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill19':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '15',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M4.84 7.594l.02-.13-.268-.026-.012.065.26.09zm.309.234c.398.312.672.566.985.764.373.236.557.114.626-.392-.484-.101-.91-.418-1.611-.372zM11 8.427c-.103.425-.394.647-.839.756a1.18 1.18 0 0 0-.588.358c-.43.515-.845 1.045-1.216 1.6-.46.688-.612 1.473-.43 2.26.142.616-.23 1.01-.488 1.465-.041.074-.185.14-.276.133-.44-.033-.877-.09-1.315-.143-.04-.005-.076-.06-.112-.058-.851.046-.888-.603-.963-1.117-.1-.691-.077-1.399-.114-2.099-.03-.573-.244-1.077-.605-1.54-.23-.293-.498-.376-.848-.275-.144.041-.304.068-.423.148-.484.325-.972.248-1.48.068-.343-.122-.7-.21-1.112-.331-.005-.068.03-.207-.028-.286-.372-.513-.04-.811.32-1.146.222-.207.383-.483.539-.746.192-.322.33-.674.527-.994.625-1.022.871-2.143.987-3.3.031-.309.068-.617.088-.926.01-.142.048-.35-.031-.418C2.034 1.36 2.415.74 2.225.156c.205-.042.363-.092.524-.102.17-.011.345.014.517.027.264.02.512-.208.8.024.477.387 1.004.717 1.206 1.333.06.183.244.338.272.52.043.289.06.602-.013.882-.141.547-.22 1.084-.137 1.648.17 1.16.94 1.615 2.032 1.577 1.047-.037 1.775.44 2.498.974.46.34.93.73 1.076 1.388z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill23':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '14',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M4.366 6.995c.298.353.598.686 1.035.927l1.3-1.393c-.356-.33-.643-.634-.969-.889-.284-.222-.418-.171-.603.128-.24.388-.482.775-.763 1.227zM0 7.879c.059-.497.421-.762.75-1.053.661-.585 1.263-1.232 1.715-1.984.478-.797.585-1.687.437-2.612-.048-.3-.007-.615-.007-.796.387-.357.672-.657.995-.906.262-.202.57-.343.858-.51.018-.01.043-.022.06-.017.358.114.772.154 1.057.366.306.227.548.6.41 1.048-.327 1.057.071 1.834.954 2.404.49.317 1.015.582 1.513.887.481.293.956.597 1.419.918.22.152.43.332.6.537.423.516.276 1.134-.37 1.262-1.167.23-1.874 1.004-2.453 1.913-.322.505-.541 1.092-.707 1.67-.19.659-.287 1.346-.388 2.026-.098.666-.29.817-.992.934a1.9 1.9 0 0 1-1.26-.186c-.483-.247-.695-.61-.775-1.127a68.53 68.53 0 0 0-.505-2.778 2.059 2.059 0 0 0-.242-.643c-.177-.299-.405-.494-.825-.428a3.026 3.026 0 0 1-1.123-.038C.648 8.656.232 8.404 0 7.879z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill1':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '17',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M7.164 9.444c-.52-.438-1.006-.858-1.653-1.144l-.862 1.962c.313.21.569.385.83.554.218.142.41.144.595-.086.328-.407.675-.798 1.09-1.286zM0 11.614c.132-.495.383-.888.801-1.229 1.917-1.562 2.606-3.583 1.995-6.037-.247-.993-.526-1.977-.79-2.966-.091-.344-.177-.68.289-.83.072-.024.111-.162.162-.25.197-.343.378-.389.694-.163.12.085.224.192.345.274.278.188.548.227.874.06a1.338 1.338 0 0 1 1.912.873c.058.24-.059.541-.144.797-.253.766-.355 1.533-.162 2.331.103.426.265.822.591 1.106.697.606 1.4 1.205 2.124 1.775.56.442 1.143.853 1.738 1.243.335.22.435.574.544.9.11.33-.134.533-.408.703-1.061.655-1.897 1.542-2.32 2.75-.304.866-.387 1.787-.403 2.714-.006.328-.133.655-.207.982-.064.286-.278.389-.518.342-.45-.088-.972.164-1.349-.294-.03-.037-.119-.04-.179-.036-.378.03-.492-.228-.582-.536a91.422 91.422 0 0 0-.74-2.448c-.098-.3-.246-.586-.389-.868-.134-.266-.359-.34-.634-.246-.158.054-.314.111-.471.165-.702.24-1.35.242-1.997-.242-.328-.245-.62-.467-.776-.87z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill5':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '17',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M4.198 8.96l2.419 1.09c.15-.295.252-.632.462-.87.23-.261.551-.438.597-.842-.419-.33-.827-.65-1.233-.973-.4-.317-.69-.77-1.18-1.013L4.198 8.96zM0 10c.067-.41.401-.6.688-.78.67-.418 1.046-1.016 1.377-1.733.504-1.09.731-2.242.942-3.399.117-.637.091-1.3.132-1.997.494-.049.552-.372.558-.8.01-.799.842-1.453 1.609-1.256.302.078.562.328.839.503.315.199.282.517.316.838.116 1.103.368 2.187.81 3.196.302.694.834 1.238 1.51 1.634.61.357 1.193.77 1.756 1.199.585.445.609 1.034.11 1.572-.128.138-.297.24-.41.389-.212.278-.487.553-.576.874-.415 1.502-.767 3.022-1.16 4.531a16.775 16.775 0 0 1-.537 1.745c-.162.425-.453.548-.9.455-.442-.093-.883-.2-1.314-.333-.117-.035-.219-.171-.294-.284-.293-.439-.306-.952-.361-1.456-.1-.902-.214-1.802-.332-2.701-.019-.144-.078-.285-.13-.423-.211-.555-.457-.738-1.03-.743-.374-.003-.753-.01-1.123.035C1.445 11.192.615 10.862 0 10z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fill9':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '11',
	            height: '14',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M6.42 7.672c.374-.271.478-.698.673-1.058.028-.05-.004-.17-.048-.222-.409-.487-.824-.969-1.246-1.444-.042-.048-.14-.042-.224-.064l-.88 1.504c.338.19.664.332.944.54.28.209.512.483.781.744zm4.469-2.37c.031.266.033.445.075.613.094.373.01.719-.333.855-.675.268-.999.869-1.292 1.447-.63 1.243-1.238 2.502-1.593 3.868-.061.235-.09.48-.164.71-.091.287-.212.563-.323.842-.117.292-.319.4-.618.292-.054-.02-.133-.054-.17-.03-.396.257-.686-.045-1.035-.152-.617-.191-.775-.639-.803-1.196-.023-.447.02-.898-.013-1.343-.04-.546-.09-1.098-.208-1.63-.228-1.03-.765-1.344-1.784-1.136-.345.07-.702.075-1.045.15-.26.056-.454.015-.64-.184-.09-.098-.234-.143-.35-.218-.745-.484-.83-.954-.014-1.65.379-.324.764-.641 1.158-.945C3.131 4.523 3.43 2.97 3.522 1.324a1.25 1.25 0 0 0-.004-.244c-.039-.276.035-.467.312-.573.422-.162.825-.464 1.253-.502.674-.06 1.29.4 1.49 1.05.155.503.25 1.04.49 1.496.439.83 1.045 1.517 1.934 1.888.653.273 1.29.587 1.892.863z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fillshape':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '16',
	            height: '22',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M7.247.373l.09-.04.007-.003.006-.003c.05-.022.095-.042.14-.064.347-.174.543-.115.683.223.044.106.065.222.085.336l.004.02c.106.576.208 1.152.31 1.728.256 1.438.51 2.875.813 4.303.127.601-.182.884-.559 1.165-.321.238-.71.234-1.08.035-.109-.06-.23-.106-.35-.139-.651-.174-.91-.49-1.026-1.122-.197-1.07-.407-2.14-.617-3.208l-.003-.016c-.109-.55-.217-1.102-.323-1.653-.05-.256-.094-.513-.14-.785A82.02 82.02 0 0 0 5.22.752C5.39.7 5.465.56 5.544.415c.105-.192.214-.392.545-.41.464-.027.829.06 1.158.368zm.186 14.754c-.03-.313.412-.918.767-1.03.61-.19 1.222-.1 1.799.11.341.124.461.467.51.801l.016.106c.128.854.255 1.71.364 2.566.091.72.174 1.44.256 2.16l.002.014.001.014.002.01.118 1.028c.069.59-.54 1.15-1.166 1.08a2.019 2.019 0 0 0-.507-.006c-.814.118-1.441-.302-1.53-1.063-.093-.796-.177-1.593-.262-2.39a449.63 449.63 0 0 0-.296-2.728l-.074-.672zm6.008-5.987c-.936.249-1.747.708-2.492 1.329l.077.265c.055.184.106.356.143.53.054.261.217.394.474.422.74.08 1.479.159 2.204-.105l.082-.03c.29-.107.585-.215.888-.268.578-.101.856-.491 1.076-.944.24-.492.076-.816-.477-.97-.097-.027-.198-.045-.298-.063-.15-.027-.3-.055-.437-.111-.414-.17-.814-.168-1.24-.055zM0 11.79c.4-.689 1.046-.868 1.786-.814a64.9 64.9 0 0 1 2.787.254c.175.02.343.104.509.188.064.032.128.064.192.092l.035.016c.203.088.416.181.362.459l-.01.055c-.054.283-.11.577-.475.66l-.18.042c-.386.091-.767.18-1.19.147-.507-.04-1.017-.034-1.528-.029-.274.003-.548.006-.821.002a2.012 2.012 0 0 1-.332-.042l-.004-.001c-.076-.014-.153-.028-.23-.036-.33-.033-.542-.161-.607-.509-.02-.111-.097-.213-.179-.322l-.003-.004A2.387 2.387 0 0 1 0 11.79zm8.217.906c.147.021.303.044.469.072.06-.022.133-.04.213-.06.194-.049.422-.105.565-.243.47-.448.792-1.008.766-1.677-.006-.164-.097-.4-.227-.47-.082-.045-.164-.094-.246-.143-.437-.262-.883-.529-1.454-.215a.452.452 0 0 1-.198.035c-.018 0-.035 0-.053.002-.758.047-1.193.476-1.431 1.126-.253.689.023 1.223.764 1.42.26.07.53.109.832.153z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fillshape1':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '17',
	            height: '21',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M7.742.942c.088-.077.173-.154.256-.229L8 .712c.181-.164.354-.32.539-.462.316-.244.66-.35 1.046-.131.077.043.164.069.25.094.067.02.133.039.196.067.354.157.577.418.605.833.037.564.077 1.127.116 1.69l.001.012v.01c.082 1.162.164 2.324.228 3.486.068 1.239-1.276 2.11-2.335 1.5-.41-.236-.563-.722-.584-1.212-.034-.766-.066-1.533-.097-2.3v-.01l-.001-.009c-.037-.9-.074-1.798-.115-2.697-.006-.135-.033-.268-.063-.414-.015-.072-.03-.147-.044-.227zM10.62 21c-.711-.171-1.041-.78-1.248-1.537a30.506 30.506 0 0 1-.898-4.687 1.75 1.75 0 0 1-.008-.115v-.007c-.038-.846.145-1.172.777-1.39.798-.274 1.623-.075 1.978.506.1.163.142.378.165.575.205 1.77.552 3.509 1.102 5.202.188.575.16.641-.327.932-.087.053-.169.114-.25.177-.077.058-.154.116-.235.166a.836.836 0 0 1-.313.112 7.17 7.17 0 0 1-.482.046h-.005l-.256.02zM.154 9.77a9.602 9.602 0 0 1-.154.248l.036.166c.032.146.069.315.103.484.093.457.168.538.63.554.285.01.57.01.856.012a34.99 34.99 0 0 1 2.947.13c.083.007.167.02.25.034.342.055.674.108.973-.217.05-.055.142-.067.236-.08a.886.886 0 0 0 .16-.033l.063-.02.006-.002.006-.002c.126-.042.254-.083.359-.158.315-.225.308-.413.022-.669-.054-.048-.1-.109-.144-.17a1.005 1.005 0 0 0-.158-.18 6.616 6.616 0 0 1-.145-.125l-.004-.004-.003-.002c-.177-.155-.357-.313-.563-.385-1.562-.544-3.164-.528-4.77-.254-.156.027-.317.15-.43.274-.1.11-.18.241-.276.4zm13.543 1.547a212.9 212.9 0 0 0-.287-.028l-.008-.001a75.084 75.084 0 0 1-.674-.068c-.474-.051-.729-.3-.81-.81-.092-.575.131-1.103.685-1.298.297-.104.618-.148.931-.188a25.038 25.038 0 0 1 1.6-.16c.567-.035 1.105.09 1.551.476.403.35.359.492.201 1.003l-.01.034c-.173.562-.56.719-1.012.79-.491.078-.987.128-1.496.18h-.005c-.219.023-.44.045-.666.07zm-5.225.108c.214.402.435.683.932.633l.202-.05c.155-.036.31-.073.462-.121.088-.028.172-.066.257-.104.076-.035.152-.07.23-.096.403-.137.74-.67.574-1.062-.22-.518-.446-1.054-.897-1.423-.353-.288-1.063-.348-1.33-.125-.853.709-.954 1.364-.43 2.348z',
	            fill: '#3F0A65'
	          })
	        );
	
	      case 'fillshape2':
	        return _react2.default.createElement(
	          'svg',
	          {
	            width: '20',
	            height: '23',
	            fill: 'none',
	            xmlns: 'http://www.w3.org/2000/svg'
	          },
	          _react2.default.createElement('path', {
	            fillRule: 'evenodd',
	            clipRule: 'evenodd',
	            d: 'M11.615.08A.878.878 0 0 0 11.47 0l-.32.143-.007.003-.003.002c-.212.095-.41.184-.608.269-.557.238-.684.512-.61 1.133.119 1.003.23 2.007.298 3.014.063.944.096 1.89.13 2.836.008.246.016.49.026.736.014.388.199.694.44.976.158.187.36.245.61.185l.097-.023c.222-.055.449-.111.673-.11.825.003 1.173-.485 1.153-1.254-.047-1.72-.139-3.44-.23-5.16l-.035-.648a8.944 8.944 0 0 0-.175-1.26c-.08-.4-.481-.809-.725-.691-.26.125-.425.02-.57-.071zm1.443 14.645l-.008-.001-.253-.048-.246.042-.008.002h-.006c-.224.038-.443.075-.657.127a.402.402 0 0 0-.224.19l-.09.164c-.252.458-.504.916-.26 1.48.03.07.03.15.032.23v.002c0 .043 0 .087.006.128.053.446.108.891.163 1.336v.002c.133 1.077.266 2.154.38 3.234.054.503.317.857.65 1.196.2.204.422.27.65.072.182-.158.352-.166.564-.08.241.097.537.127.688-.083.045-.063.096-.125.147-.188l.001-.001.002-.002c.187-.229.38-.467.35-.777-.16-1.648-.341-3.295-.53-4.942a14.98 14.98 0 0 0-.234-1.37c-.056-.268-.214-.496-.494-.577a6.375 6.375 0 0 0-.623-.136zm.817-3.25c.049-.02.087-.033.117-.043.045-.016.07-.025.078-.041.34-.615.92-.839 1.576-.916l.388-.047c.872-.11 1.747-.22 2.62.01.351.093.71.218 1.016.407.54.332.393 1.175-.262 1.486-.5.237-1.027.416-1.597.423-.68.009-1.36.02-2.04.04-.634.018-1.187-.114-1.518-.715a.673.673 0 0 0-.164-.174l-.001-.002c-.017-.014-.043-.018-.081-.025a1.167 1.167 0 0 1-.08-.015l-.03.12c-.02.088-.041.178-.08.26-.173.372-.354.741-.87.733a.763.763 0 0 0-.259.06l-.04.014c-1.14.396-2.01.03-2.654-.68-.194-.213-.267-.467-.127-.73.457-.856 1.086-1.522 2.113-1.678.16-.024.332.025.5.073h.003c.045.014.09.026.134.037.055.014.107.044.159.072.057.032.114.064.175.075.392.073.606.293.69.675.028.129.085.251.146.383v.002c.03.063.06.128.088.197zm-7.844 1.29c.602-.183.635-.226.668-.92a1.985 1.985 0 0 0-.169-.072c-.131-.052-.267-.105-.35-.202-.428-.502-1.008-.578-1.594-.654l-.196-.026c-.274-.039-.548-.08-.822-.122-.539-.082-1.078-.163-1.62-.22-.38-.04-.776 0-1.157.052-.296.041-.533.195-.58.54a.568.568 0 0 1-.085.2.635.635 0 0 0-.083.184c-.034.168-.069.362-.015.515.15.424.419.701.938.734.768.05 1.535.123 2.302.196.34.033.679.066 1.019.096.085.008.172.018.258.028.483.058.966.117 1.369-.298.015-.016.042-.019.07-.022.016-.002.033-.004.047-.009z',
	            fill: '#3F0A65'
	          })
	        );
	    }
	  };
	
	  return Icon;
	}(_react.Component);
	
	exports.default = Icon;
	module.exports = exports['default'];

/***/ }),

/***/ 225:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{ url: '/images/cactus.svg', width: 57, height: 87 }, { url: '/images/coffee.svg', width: 75, height: 83 }, { url: '/images/flag.svg', width: 94, height: 71 }, { url: '/images/glasses.svg', width: 80, height: 68 }, { url: '/images/guitar.svg', width: 50, height: 158 }, { url: '/images/island.svg', width: 70, height: 84 },
	// { url: '/images/JS_Book.svg', width: 68, height: 32 },
	{ url: '/images/lightingBart.svg', width: 30, height: 41 }, { url: '/images/luggages.svg', width: 83, height: 80 }, { url: '/images/macintosh.svg', width: 58, height: 82 }, { url: '/images/macSad.svg', width: 49, height: 35 }, { url: '/images/pizza.svg', width: 59, height: 100 }, { url: '/images/record.svg', width: 75, height: 60 }, { url: '/images/taco.svg', width: 55, height: 51 }, { url: '/images/vans.svg', width: 94, height: 50 }];
	module.exports = exports['default'];

/***/ }),

/***/ 226:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _matterJs = __webpack_require__(348);
	
	var _matterJs2 = _interopRequireDefault(_matterJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Bodies = _matterJs2.default.Bodies,
	    Body = _matterJs2.default.Body,
	    Composite = _matterJs2.default.Composite,
	    Composites = _matterJs2.default.Composites,
	    Constraint = _matterJs2.default.Constraint,
	    Engine = _matterJs2.default.Engine,
	    Events = _matterJs2.default.Events,
	    Mouse = _matterJs2.default.Mouse,
	    MouseConstraint = _matterJs2.default.MouseConstraint,
	    Render = _matterJs2.default.Render,
	    Runner = _matterJs2.default.Runner,
	    Vertices = _matterJs2.default.Vertices,
	    World = _matterJs2.default.World;
	
	var MatterWrapper = function () {
	  function MatterWrapper(_ref) {
	    var element = _ref.element,
	        width = _ref.width,
	        height = _ref.height,
	        gravity = _ref.gravity,
	        canvas = _ref.canvas,
	        _ref$options = _ref.options,
	        options = _ref$options === undefined ? {} : _ref$options,
	        _ref$autoRender = _ref.autoRender,
	        autoRender = _ref$autoRender === undefined ? true : _ref$autoRender,
	        _ref$autoStart = _ref.autoStart,
	        autoStart = _ref$autoStart === undefined ? true : _ref$autoStart,
	        _ref$hasBounds = _ref.hasBounds,
	        hasBounds = _ref$hasBounds === undefined ? true : _ref$hasBounds,
	        _ref$isInteractive = _ref.isInteractive,
	        isInteractive = _ref$isInteractive === undefined ? true : _ref$isInteractive,
	        _ref$onUpdate = _ref.onUpdate,
	        onUpdate = _ref$onUpdate === undefined ? null : _ref$onUpdate;
	
	    _classCallCheck(this, MatterWrapper);
	
	    this.dimensions = { width: width, height: height };
	    this.runner = Runner.create();
	    this.engine = Engine.create();
	    this.world = this.engine.world;
	    this.mouse = null;
	    this.mouseConstraint = null;
	    this.render = autoRender ? Render.create({
	      element: element,
	      engine: this.engine,
	      options: _extends({
	        width: width,
	        height: height,
	        background: 'transparent',
	        wireframeBackground: '#333',
	        showAngleIndicator: false,
	        wireframes: false
	      }, options)
	    }) : null;
	    this.canvas = this.render ? this.render.canvas : element;
	    this.itemDefaults = {
	      restitution: 0.7
	    };
	
	    this.world.gravity = gravity || { x: 0, y: 2 };
	    hasBounds && this.addBounds();
	    isInteractive && this.bindMouse();
	    autoStart && this.start();
	    onUpdate && Events.on(this.runner, 'afterUpdate', onUpdate);
	
	    if (autoRender) {
	      Render.run(this.render);
	      Render.lookAt(this.render, {
	        min: { x: 0, y: 0 },
	        max: { x: width, y: height }
	      });
	    }
	  }
	
	  MatterWrapper.prototype.destroy = function destroy() {
	    this.stop();
	    World.clear(this.world);
	    Engine.clear(this.engine);
	
	    if (this.render) {
	      Render.stop(this.render);
	      this.render.canvas.remove();
	      this.render.canvas = null;
	      this.render.context = null;
	      this.render.textures = {};
	    }
	  };
	
	  MatterWrapper.prototype.resize = function resize(width, height) {
	    this.canvas.width = width;
	    this.canvas.height = height;
	  };
	
	  MatterWrapper.prototype.bindMouse = function bindMouse() {
	    this.mouse = Mouse.create(this.canvas);
	    this.mouseConstraint = MouseConstraint.create(this.engine, {
	      mouse: this.mouse,
	      constraint: {
	        stiffness: 0.2,
	        render: { visible: false }
	      }
	    });
	
	    World.add(this.world, this.mouseConstraint);
	
	    if (this.render) {
	      this.render.mouse = this.mouse;
	    }
	  };
	
	  MatterWrapper.prototype.start = function start() {
	    Runner.run(this.runner, this.engine);
	  };
	
	  MatterWrapper.prototype.stop = function stop() {
	    Runner.stop(this.runner);
	  };
	
	  MatterWrapper.prototype.getBodies = function getBodies() {
	    return Composite.allBodies(this.world);
	  };
	
	  MatterWrapper.prototype.applyForce = function applyForce(body, position, force) {
	    Body.applyForce(body, position, force);
	  };
	
	  MatterWrapper.prototype.addBounds = function addBounds() {
	    var _dimensions = this.dimensions,
	        width = _dimensions.width,
	        height = _dimensions.height;
	
	    var options = { isStatic: true };
	    var size = 50;
	    var offset = size / 2;
	
	    World.add(this.world, [Bodies.rectangle(width / 2, -offset, width + offset, size, options), Bodies.rectangle(width / 2, height + offset, width + offset, size, options), Bodies.rectangle(width + offset, height / 2, size, height + offset * 2, options), Bodies.rectangle(-offset, height / 2, size, height + offset * 2, options)]);
	  };
	
	  MatterWrapper.prototype.addBody = function addBody(body) {
	    World.add(this.world, body);
	  };
	
	  MatterWrapper.prototype.removeBody = function removeBody(body) {
	    World.remove(this.world, body);
	  };
	
	  MatterWrapper.prototype.rotateBody = function rotateBody(body, rotation) {
	    Body.rotate(body, rotation);
	  };
	
	  MatterWrapper.prototype.positionBody = function positionBody(body, position) {
	    Body.setPosition(body, position);
	  };
	
	  MatterWrapper.prototype.addEvent = function addEvent(event, handler) {
	    Events.on(this.engine, event, handler);
	  };
	
	  MatterWrapper.prototype.removeEvent = function removeEvent(event, handler) {
	    Events.off(this.engine, event, handler);
	  };
	
	  MatterWrapper.prototype.addShape = function addShape(x, y, points) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var vertices = Vertices.fromPath(points.join(' '));
	    var shape = Bodies.fromVertices(x, y, vertices, _extends({}, this.itemDefaults, options));
	    World.add(this.world, shape);
	
	    return shape;
	  };
	
	  MatterWrapper.prototype.addRectangle = function addRectangle(x, y, width, height) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	    var rect = Bodies.rectangle(x, y, width, height, _extends({}, this.itemDefaults, options));
	    World.add(this.world, rect);
	
	    return rect;
	  };
	
	  MatterWrapper.prototype.addCircle = function addCircle(x, y, radius) {
	    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	    var circ = Bodies.circle(x, y, radius, _extends({}, this.itemDefaults, options));
	    World.add(this.world, circ);
	
	    return circ;
	  };
	
	  MatterWrapper.prototype.addPolygon = function addPolygon(x, y, sides, size) {
	    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	    var poly = Bodies.polygon(x, y, sides, size, _extends({}, this.itemDefaults, options));
	    World.add(this.world, poly);
	
	    return poly;
	  };
	
	  MatterWrapper.prototype.addItemToString = function addItemToString(_ref2) {
	    var item = _ref2.item,
	        x = _ref2.x,
	        y = _ref2.y,
	        length = _ref2.length,
	        parent = _ref2.parent,
	        _ref2$offset = _ref2.offset,
	        offset = _ref2$offset === undefined ? 0 : _ref2$offset;
	
	    var group = Body.nextGroup(true);
	    var segments = Math.round(length / 100);
	    var segmentLength = Math.round(length / segments * 2);
	    var string = Composites.stack(x, y, 1, segments, 2, 2, function (x, y) {
	      return Bodies.rectangle(x, y, 2, segmentLength / 2, {
	        collisionFilter: { group: group },
	        frictionAir: 0.1,
	        render: { fillStyle: '#333' }
	      });
	    });
	    var lastBody = string.bodies[string.bodies.length - 1];
	    var position = string.bodies[0].position;
	    var lastPosition = lastBody.position;
	
	    var constraint = Constraint.create({
	      bodyA: item,
	      bodyB: lastBody,
	      pointA: { x: 0, y: offset },
	      pointB: { x: 0, y: segmentLength / 4 },
	      stiffness: 0.9,
	      render: { visible: false }
	    });
	
	    Body.set(item, {
	      density: 0.00005,
	      friction: 1,
	      position: {
	        x: lastPosition.x,
	        y: lastPosition.y + offset
	      },
	      collisionFilter: lastBody.collisionFilter
	    });
	
	    Composites.chain(string, 0, 0.49, 0, -0.49, {
	      stiffness: 0.9,
	      length: 0,
	      render: { type: 'line', visible: false }
	    });
	
	    Composite.add(string, Constraint.create({
	      bodyA: parent,
	      bodyB: string.bodies[0],
	      pointA: {
	        x: position.x - (parent ? parent.position.x : 0),
	        y: position.y - (parent ? parent.position.y : 0)
	      },
	      pointB: { x: 0, y: 0 },
	      stiffness: 0.9
	    }));
	
	    World.add(this.world, [string, constraint]);
	
	    return string;
	  };
	
	  return MatterWrapper;
	}();
	
	exports.default = MatterWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 227:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (url) {
	  return new Promise(function (resolve, reject) {
	    var img = document.createElement('img');
	    img.onload = function () {
	      return resolve(img);
	    };
	    img.onerror = function () {
	      return reject(new Error('Error loading image'));
	    };
	    img.src = url;
	  });
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shuffle;
	function shuffle(a) {
	  for (var i = a.length - 1; i > 0; i--) {
	    var j = Math.floor(Math.random() * (i + 1));var _ref = [a[j], a[i]];
	    a[i] = _ref[0];
	    a[j] = _ref[1];
	  }
	  return a;
	}
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-d48bb1f903a2e8ae0bd2.js